import * as n from "three";
import { REVISION as Ua, Camera as lo, Color as Zt, Vector2 as me, UnsignedByteType as ft, DepthTexture as fo, DepthStencilFormat as co, UnsignedInt248Type as uo, UnsignedIntType as mo, WebGLRenderTarget as Ye, Vector3 as pe, Matrix4 as Ba, Scene as Jt, Mesh as ka, BasicDepthPacking as ct, LinearFilter as dt, Uniform as K, LoadingManager as Bi, Texture as $t, NearestFilter as ki, LinearEncoding as Ri, sRGBEncoding as Li, ShaderMaterial as Re, NoBlending as qe, PerspectiveCamera as zi, BufferGeometry as vo, BufferAttribute as yt, Material as Fi, EventDispatcher as Ni, GLSL3 as Oi, MathUtils as ea, WebGLCubeRenderTarget as go, CubeCamera as po, TextureLoader as Ra, CubeTextureLoader as Gi, RepeatWrapping as ho, SRGBColorSpace as _o, Plane as xo, Vector4 as La, HalfFloatType as yo, WebGLTransformFeedback as Hi, Box3 as bo, AnimationMixer as wo, LoopOnce as Ao, LoopPingPong as Co, RedFormat as So, RGFormat as Po, RGBAFormat as Mo, MetaMesh as Do, OrthographicCamera as Vi, UniformsUtils as Wi, PlaneGeometry as ji, Triangle as Eo, Object3D as To, InstancedBufferAttribute as Io } from "three";
import { jsx as y, Fragment as te, jsxs as H } from "react/jsx-runtime";
import { extend as N, useThree as U, useFrame as q, addEffect as za, addAfterEffect as Uo, useLoader as Ee, useInstanceHandle as Bo } from "@react-three/fiber";
import * as A from "react";
import ce, { createRef as Xe, useRef as I, useLayoutEffect as ie, useState as ve, Suspense as de, useMemo as V, useEffect as G, forwardRef as Z, useImperativeHandle as ge, createElement as bt, createContext as Fa, useContext as Ke, useCallback as wt } from "react";
import { useEvent as re, emitEvent as ae, onEvent as Qi, offEvent as Yi } from "@utsubo/events";
import { shallow as Le } from "zustand/shallow";
import { create as De } from "zustand";
import ko from "stats-gl";
import { suspend as Se } from "suspend-react";
import { MeshoptDecoder as Ze } from "three/addons/libs/meshopt_decoder.module.js";
import { DRACOLoader as Na } from "three/addons/loaders/DRACOLoader.js";
import { GLTFLoader as Je } from "three/addons/loaders/GLTFLoader.js";
import * as ta from "react-device-detect";
import { isIOS as At } from "react-device-detect";
import { KTX2Loader as Ro } from "three/addons/loaders/KTX2Loader";
import { subscribeWithSelector as Lo, persist as zo, createJSONStorage as Fo } from "zustand/middleware";
import No from "react-dom/client";
import { MeshBVHUniformStruct as Oo, shaderStructs as Go, shaderIntersectFunction as Ho, shaderDistanceFunction as Vo, MeshBVH as Wo, StaticGeometryGenerator as jo } from "three-mesh-bvh";
import { Pose as Qo, Face as Yo } from "kalidokit";
import * as qo from "three/addons/utils/SkeletonUtils.js";
import { FBXLoader as Xo } from "three/addons/loaders/FBXLoader.js";
import { OrbitControls as Ko } from "three/addons/controls/OrbitControls.js";
import { TransformControls as Zo } from "three/addons/controls/TransformControls.js";
const v = new Proxy({}, { get(e, t) {
  return "https://cdn.utsubo.io/renderer/0-1-385" + (t.startsWith("/") ? t : "/" + t);
} });
/**
* postprocessing v6.31.0 build Sun May 07 2023
* https://github.com/pmndrs/postprocessing
* Copyright 2015-2023 Raoul van Rüschen
* @license Zlib
*/
var Jo = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}", qi = "", ye = "srgb", aa = "srgb-linear", $o = Number(Ua.replace(/\D+/g, "")), Xi = $o >= 152, es = /* @__PURE__ */ new Map([[Ri, aa], [Li, ye]]), ts = /* @__PURE__ */ new Map([[aa, Ri], [ye, Li]]);
function ia(e) {
  return e === null ? null : Xi ? e.outputColorSpace : es.get(e.outputEncoding);
}
function Ct(e, t) {
  e !== null && (Xi ? e.colorSpace = t : e.encoding = ts.get(t));
}
var Q = { SKIP: 9, SET: 30, ADD: 0, ALPHA: 1, AVERAGE: 2, COLOR: 3, COLOR_BURN: 4, COLOR_DODGE: 5, DARKEN: 6, DIFFERENCE: 7, DIVIDE: 8, DST: 9, EXCLUSION: 10, HARD_LIGHT: 11, HARD_MIX: 12, HUE: 13, INVERT: 14, INVERT_RGB: 15, LIGHTEN: 16, LINEAR_BURN: 17, LINEAR_DODGE: 18, LINEAR_LIGHT: 19, LUMINOSITY: 20, MULTIPLY: 21, NEGATION: 22, NORMAL: 23, OVERLAY: 24, PIN_LIGHT: 25, REFLECT: 26, SATURATION: 27, SCREEN: 28, SOFT_LIGHT: 29, SRC: 30, SUBTRACT: 31, VIVID_LIGHT: 32 }, Ki = { DEPTH: 0, LUMA: 1, COLOR: 2 }, ze = { NONE: 0, DEPTH: 1, CONVOLUTION: 2 }, X = { FRAGMENT_HEAD: "FRAGMENT_HEAD", FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV", FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE", VERTEX_HEAD: "VERTEX_HEAD", VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT" }, as = { DISABLED: 0, DEPTH: 1, CUSTOM: 2 }, Fe = { LOW: 0, MEDIUM: 1, HIGH: 2, ULTRA: 3 }, is = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <encodings_fragment>
#include <dithering_fragment>
}`, ns = class extends Re {
  constructor() {
    super({ name: "CopyMaterial", uniforms: { inputBuffer: new K(null), opacity: new K(1) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, fragmentShader: is, vertexShader: Jo });
  }
  set inputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  setInputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  getOpacity(e) {
    return this.uniforms.opacity.value;
  }
  setOpacity(e) {
    this.uniforms.opacity.value = e;
  }
}, rs = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#define WEIGHT_INNER 0.125
#define WEIGHT_OUTER 0.0555555
varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;float clampToBorder(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void main(){vec4 c=vec4(0.0);vec4 w=WEIGHT_INNER*vec4(clampToBorder(vUv00),clampToBorder(vUv01),clampToBorder(vUv02),clampToBorder(vUv03));c+=w.x*texture2D(inputBuffer,vUv00);c+=w.y*texture2D(inputBuffer,vUv01);c+=w.z*texture2D(inputBuffer,vUv02);c+=w.w*texture2D(inputBuffer,vUv03);w=WEIGHT_OUTER*vec4(clampToBorder(vUv04),clampToBorder(vUv05),clampToBorder(vUv06),clampToBorder(vUv07));c+=w.x*texture2D(inputBuffer,vUv04);c+=w.y*texture2D(inputBuffer,vUv05);c+=w.z*texture2D(inputBuffer,vUv06);c+=w.w*texture2D(inputBuffer,vUv07);w=WEIGHT_OUTER*vec4(clampToBorder(vUv08),clampToBorder(vUv09),clampToBorder(vUv10),clampToBorder(vUv11));c+=w.x*texture2D(inputBuffer,vUv08);c+=w.y*texture2D(inputBuffer,vUv09);c+=w.z*texture2D(inputBuffer,vUv10);c+=w.w*texture2D(inputBuffer,vUv11);c+=WEIGHT_OUTER*texture2D(inputBuffer,vUv);gl_FragColor=c;
#include <encodings_fragment>
}`, os = "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;void main(){vUv=position.xy*0.5+0.5;vUv00=vUv+texelSize*vec2(-1.0,1.0);vUv01=vUv+texelSize*vec2(1.0,1.0);vUv02=vUv+texelSize*vec2(-1.0,-1.0);vUv03=vUv+texelSize*vec2(1.0,-1.0);vUv04=vUv+texelSize*vec2(-2.0,2.0);vUv05=vUv+texelSize*vec2(0.0,2.0);vUv06=vUv+texelSize*vec2(2.0,2.0);vUv07=vUv+texelSize*vec2(-2.0,0.0);vUv08=vUv+texelSize*vec2(2.0,0.0);vUv09=vUv+texelSize*vec2(-2.0,-2.0);vUv10=vUv+texelSize*vec2(0.0,-2.0);vUv11=vUv+texelSize*vec2(2.0,-2.0);gl_Position=vec4(position.xy,1.0,1.0);}", ss = class extends Re {
  constructor() {
    super({ name: "DownsamplingMaterial", uniforms: { inputBuffer: new K(null), texelSize: new K(new me()) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, fragmentShader: rs, vertexShader: os });
  }
  set inputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  setSize(e, t) {
    this.uniforms.texelSize.value.set(1 / e, 1 / t);
  }
}, ls = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`, fs = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`, cs = class extends Re {
  constructor(e = new me(), t = Ki.COLOR) {
    super({ name: "EdgeDetectionMaterial", defines: { THREE_REVISION: Ua.replace(/\D+/g, ""), LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0", EDGE_THRESHOLD: "0.1", DEPTH_THRESHOLD: "0.01", PREDICATION_MODE: "0", PREDICATION_THRESHOLD: "0.01", PREDICATION_SCALE: "2.0", PREDICATION_STRENGTH: "1.0", DEPTH_PACKING: "0" }, uniforms: { inputBuffer: new K(null), depthBuffer: new K(null), predicationBuffer: new K(null), texelSize: new K(e) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, fragmentShader: ls, vertexShader: fs }), this.edgeDetectionMode = t;
  }
  set depthBuffer(e) {
    this.uniforms.depthBuffer.value = e;
  }
  set depthPacking(e) {
    this.defines.DEPTH_PACKING = e.toFixed(0), this.needsUpdate = true;
  }
  setDepthBuffer(e, t = ct) {
    this.depthBuffer = e, this.depthPacking = t;
  }
  get edgeDetectionMode() {
    return Number(this.defines.EDGE_DETECTION_MODE);
  }
  set edgeDetectionMode(e) {
    this.defines.EDGE_DETECTION_MODE = e.toFixed(0), this.needsUpdate = true;
  }
  getEdgeDetectionMode() {
    return this.edgeDetectionMode;
  }
  setEdgeDetectionMode(e) {
    this.edgeDetectionMode = e;
  }
  get localContrastAdaptationFactor() {
    return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
  }
  set localContrastAdaptationFactor(e) {
    this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = e.toFixed("6"), this.needsUpdate = true;
  }
  getLocalContrastAdaptationFactor() {
    return this.localContrastAdaptationFactor;
  }
  setLocalContrastAdaptationFactor(e) {
    this.localContrastAdaptationFactor = e;
  }
  get edgeDetectionThreshold() {
    return Number(this.defines.EDGE_THRESHOLD);
  }
  set edgeDetectionThreshold(e) {
    this.defines.EDGE_THRESHOLD = e.toFixed("6"), this.defines.DEPTH_THRESHOLD = (e * 0.1).toFixed("6"), this.needsUpdate = true;
  }
  getEdgeDetectionThreshold() {
    return this.edgeDetectionThreshold;
  }
  setEdgeDetectionThreshold(e) {
    this.edgeDetectionThreshold = e;
  }
  get predicationMode() {
    return Number(this.defines.PREDICATION_MODE);
  }
  set predicationMode(e) {
    this.defines.PREDICATION_MODE = e.toFixed(0), this.needsUpdate = true;
  }
  getPredicationMode() {
    return this.predicationMode;
  }
  setPredicationMode(e) {
    this.predicationMode = e;
  }
  set predicationBuffer(e) {
    this.uniforms.predicationBuffer.value = e;
  }
  setPredicationBuffer(e) {
    this.uniforms.predicationBuffer.value = e;
  }
  get predicationThreshold() {
    return Number(this.defines.PREDICATION_THRESHOLD);
  }
  set predicationThreshold(e) {
    this.defines.PREDICATION_THRESHOLD = e.toFixed("6"), this.needsUpdate = true;
  }
  getPredicationThreshold() {
    return this.predicationThreshold;
  }
  setPredicationThreshold(e) {
    this.predicationThreshold = e;
  }
  get predicationScale() {
    return Number(this.defines.PREDICATION_SCALE);
  }
  set predicationScale(e) {
    this.defines.PREDICATION_SCALE = e.toFixed("6"), this.needsUpdate = true;
  }
  getPredicationScale() {
    return this.predicationScale;
  }
  setPredicationScale(e) {
    this.predicationScale = e;
  }
  get predicationStrength() {
    return Number(this.defines.PREDICATION_STRENGTH);
  }
  set predicationStrength(e) {
    this.defines.PREDICATION_STRENGTH = e.toFixed("6"), this.needsUpdate = true;
  }
  getPredicationStrength() {
    return this.predicationStrength;
  }
  setPredicationStrength(e) {
    this.predicationStrength = e;
  }
  setSize(e, t) {
    this.uniforms.texelSize.value.set(1 / e, 1 / t);
  }
}, ds = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if THREE_REVISION >= 137
vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}vec3 RGBToHCV(const in vec3 RGB){vec4 P=mix(vec4(RGB.bg,-1.0,2.0/3.0),vec4(RGB.gb,0.0,-1.0/3.0),step(RGB.b,RGB.g));vec4 Q=mix(vec4(P.xyw,RGB.r),vec4(RGB.r,P.yzx),step(P.x,RGB.r));float C=Q.x-min(Q.w,Q.y);float H=abs((Q.w-Q.y)/(6.0*C+EPSILON)+Q.z);return vec3(H,C,Q.x);}vec3 RGBToHSL(const in vec3 RGB){vec3 HCV=RGBToHCV(RGB);float L=HCV.z-HCV.y*0.5;float S=HCV.y/(1.0-abs(L*2.0-1.0)+EPSILON);return vec3(HCV.x,S,L);}vec3 HueToRGB(const in float H){float R=abs(H*6.0-3.0)-1.0;float G=2.0-abs(H*6.0-2.0);float B=2.0-abs(H*6.0-4.0);return clamp(vec3(R,G,B),0.0,1.0);}vec3 HSLToRGB(const in vec3 HSL){vec3 RGB=HueToRGB(HSL.x);float C=(1.0-abs(2.0*HSL.z-1.0))*HSL.y;return(RGB-0.5)*C+HSL.z;}FRAGMENT_HEAD void main(){FRAGMENT_MAIN_UV vec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGE gl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <encodings_fragment>
#endif
#include <dithering_fragment>
}`, us = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEAD void main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORT gl_Position=vec4(position.xy,1.0,1.0);}", ms = class extends Re {
  constructor(e, t, a, i, r = false) {
    super({ name: "EffectMaterial", defines: { THREE_REVISION: Ua.replace(/\D+/g, ""), DEPTH_PACKING: "0", ENCODE_OUTPUT: "1" }, uniforms: { inputBuffer: new K(null), depthBuffer: new K(null), resolution: new K(new me()), texelSize: new K(new me()), cameraNear: new K(0.3), cameraFar: new K(1e3), aspect: new K(1), time: new K(0) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, dithering: r }), e && this.setShaderParts(e), t && this.setDefines(t), a && this.setUniforms(a), this.copyCameraSettings(i);
  }
  set inputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  setInputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  get depthBuffer() {
    return this.uniforms.depthBuffer.value;
  }
  set depthBuffer(e) {
    this.uniforms.depthBuffer.value = e;
  }
  get depthPacking() {
    return Number(this.defines.DEPTH_PACKING);
  }
  set depthPacking(e) {
    this.defines.DEPTH_PACKING = e.toFixed(0), this.needsUpdate = true;
  }
  setDepthBuffer(e, t = ct) {
    this.depthBuffer = e, this.depthPacking = t;
  }
  setShaderData(e) {
    this.setShaderParts(e.shaderParts), this.setDefines(e.defines), this.setUniforms(e.uniforms), this.setExtensions(e.extensions);
  }
  setShaderParts(e) {
    return this.fragmentShader = ds.replace(X.FRAGMENT_HEAD, e.get(X.FRAGMENT_HEAD) || "").replace(X.FRAGMENT_MAIN_UV, e.get(X.FRAGMENT_MAIN_UV) || "").replace(X.FRAGMENT_MAIN_IMAGE, e.get(X.FRAGMENT_MAIN_IMAGE) || ""), this.vertexShader = us.replace(X.VERTEX_HEAD, e.get(X.VERTEX_HEAD) || "").replace(X.VERTEX_MAIN_SUPPORT, e.get(X.VERTEX_MAIN_SUPPORT) || ""), this.needsUpdate = true, this;
  }
  setDefines(e) {
    for (const t of e.entries())
      this.defines[t[0]] = t[1];
    return this.needsUpdate = true, this;
  }
  setUniforms(e) {
    for (const t of e.entries())
      this.uniforms[t[0]] = t[1];
    return this;
  }
  setExtensions(e) {
    this.extensions = {};
    for (const t of e)
      this.extensions[t] = true;
    return this;
  }
  get encodeOutput() {
    return this.defines.ENCODE_OUTPUT !== void 0;
  }
  set encodeOutput(e) {
    this.encodeOutput !== e && (e ? this.defines.ENCODE_OUTPUT = "1" : delete this.defines.ENCODE_OUTPUT, this.needsUpdate = true);
  }
  isOutputEncodingEnabled(e) {
    return this.encodeOutput;
  }
  setOutputEncodingEnabled(e) {
    this.encodeOutput = e;
  }
  get time() {
    return this.uniforms.time.value;
  }
  set time(e) {
    this.uniforms.time.value = e;
  }
  setDeltaTime(e) {
    this.uniforms.time.value += e;
  }
  adoptCameraSettings(e) {
    this.copyCameraSettings(e);
  }
  copyCameraSettings(e) {
    e && (this.uniforms.cameraNear.value = e.near, this.uniforms.cameraFar.value = e.far, e instanceof zi ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = true);
  }
  setSize(e, t) {
    const a = this.uniforms;
    a.resolution.value.set(e, t), a.texelSize.value.set(1 / e, 1 / t), a.aspect.value = e / t;
  }
  static get Section() {
    return X;
  }
}, vs = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`, gs = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}", ps = class extends Re {
  constructor(e = new me(), t = new me()) {
    super({ name: "SMAAWeightsMaterial", defines: { MAX_SEARCH_STEPS_INT: "16", MAX_SEARCH_STEPS_FLOAT: "16.0", MAX_SEARCH_STEPS_DIAG_INT: "8", MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0", CORNER_ROUNDING: "25", CORNER_ROUNDING_NORM: "0.25", AREATEX_MAX_DISTANCE: "16.0", AREATEX_MAX_DISTANCE_DIAG: "20.0", AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))", AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)", SEARCHTEX_SIZE: "vec2(66.0, 33.0)", SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)" }, uniforms: { inputBuffer: new K(null), searchTexture: new K(null), areaTexture: new K(null), resolution: new K(t), texelSize: new K(e) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, fragmentShader: vs, vertexShader: gs });
  }
  set inputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  setInputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  get searchTexture() {
    return this.uniforms.searchTexture.value;
  }
  set searchTexture(e) {
    this.uniforms.searchTexture.value = e;
  }
  get areaTexture() {
    return this.uniforms.areaTexture.value;
  }
  set areaTexture(e) {
    this.uniforms.areaTexture.value = e;
  }
  setLookupTextures(e, t) {
    this.searchTexture = e, this.areaTexture = t;
  }
  get orthogonalSearchSteps() {
    return Number(this.defines.MAX_SEARCH_STEPS_INT);
  }
  set orthogonalSearchSteps(e) {
    const t = /* @__PURE__ */ Math.min(Math.max(e, 0), 112);
    this.defines.MAX_SEARCH_STEPS_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_FLOAT = t.toFixed("1"), this.needsUpdate = true;
  }
  setOrthogonalSearchSteps(e) {
    this.orthogonalSearchSteps = e;
  }
  get diagonalSearchSteps() {
    return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
  }
  set diagonalSearchSteps(e) {
    const t = /* @__PURE__ */ Math.min(Math.max(e, 0), 20);
    this.defines.MAX_SEARCH_STEPS_DIAG_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = t.toFixed("1"), this.needsUpdate = true;
  }
  setDiagonalSearchSteps(e) {
    this.diagonalSearchSteps = e;
  }
  get diagonalDetection() {
    return this.defines.DISABLE_DIAG_DETECTION === void 0;
  }
  set diagonalDetection(e) {
    e ? delete this.defines.DISABLE_DIAG_DETECTION : this.defines.DISABLE_DIAG_DETECTION = "1", this.needsUpdate = true;
  }
  isDiagonalDetectionEnabled() {
    return this.diagonalDetection;
  }
  setDiagonalDetectionEnabled(e) {
    this.diagonalDetection = e;
  }
  get cornerRounding() {
    return Number(this.defines.CORNER_ROUNDING);
  }
  set cornerRounding(e) {
    const t = /* @__PURE__ */ Math.min(Math.max(e, 0), 100);
    this.defines.CORNER_ROUNDING = t.toFixed("4"), this.defines.CORNER_ROUNDING_NORM = (t / 100).toFixed("4"), this.needsUpdate = true;
  }
  setCornerRounding(e) {
    this.cornerRounding = e;
  }
  get cornerDetection() {
    return this.defines.DISABLE_CORNER_DETECTION === void 0;
  }
  set cornerDetection(e) {
    e ? delete this.defines.DISABLE_CORNER_DETECTION : this.defines.DISABLE_CORNER_DETECTION = "1", this.needsUpdate = true;
  }
  isCornerRoundingEnabled() {
    return this.cornerDetection;
  }
  setCornerRoundingEnabled(e) {
    this.cornerDetection = e;
  }
  setSize(e, t) {
    const a = this.uniforms;
    a.texelSize.value.set(1 / e, 1 / t), a.resolution.value.set(e, t);
  }
}, hs = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;uniform mediump sampler2D supportBuffer;
#else
uniform lowp sampler2D inputBuffer;uniform lowp sampler2D supportBuffer;
#endif
uniform float radius;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vec4 c=vec4(0.0);c+=texture2D(inputBuffer,vUv0)*0.0625;c+=texture2D(inputBuffer,vUv1)*0.125;c+=texture2D(inputBuffer,vUv2)*0.0625;c+=texture2D(inputBuffer,vUv3)*0.125;c+=texture2D(inputBuffer,vUv)*0.25;c+=texture2D(inputBuffer,vUv4)*0.125;c+=texture2D(inputBuffer,vUv5)*0.0625;c+=texture2D(inputBuffer,vUv6)*0.125;c+=texture2D(inputBuffer,vUv7)*0.0625;vec4 baseColor=texture2D(supportBuffer,vUv);gl_FragColor=mix(baseColor,c,radius);
#include <encodings_fragment>
}`, _s = "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,1.0);vUv1=vUv+texelSize*vec2(0.0,1.0);vUv2=vUv+texelSize*vec2(1.0,1.0);vUv3=vUv+texelSize*vec2(-1.0,0.0);vUv4=vUv+texelSize*vec2(1.0,0.0);vUv5=vUv+texelSize*vec2(-1.0,-1.0);vUv6=vUv+texelSize*vec2(0.0,-1.0);vUv7=vUv+texelSize*vec2(1.0,-1.0);gl_Position=vec4(position.xy,1.0,1.0);}", xs = class extends Re {
  constructor() {
    super({ name: "UpsamplingMaterial", uniforms: { inputBuffer: new K(null), supportBuffer: new K(null), texelSize: new K(new me()), radius: new K(0.85) }, blending: qe, toneMapped: false, depthWrite: false, depthTest: false, fragmentShader: hs, vertexShader: _s });
  }
  set inputBuffer(e) {
    this.uniforms.inputBuffer.value = e;
  }
  set supportBuffer(e) {
    this.uniforms.supportBuffer.value = e;
  }
  get radius() {
    return this.uniforms.radius.value;
  }
  set radius(e) {
    this.uniforms.radius.value = e;
  }
  setSize(e, t) {
    this.uniforms.texelSize.value.set(1 / e, 1 / t);
  }
}, ys = new lo(), He = null;
function bs() {
  if (He === null) {
    const e = new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), t = new Float32Array([0, 0, 2, 0, 0, 2]);
    He = new vo(), He.setAttribute !== void 0 ? (He.setAttribute("position", new yt(e, 3)), He.setAttribute("uv", new yt(t, 2))) : (He.addAttribute("position", new yt(e, 3)), He.addAttribute("uv", new yt(t, 2)));
  }
  return He;
}
var he = class {
  constructor(e = "Pass", t = new Jt(), a = ys) {
    this.name = e, this.renderer = null, this.scene = t, this.camera = a, this.screen = null, this.rtt = true, this.needsSwap = true, this.needsDepthTexture = false, this.enabled = true;
  }
  get renderToScreen() {
    return !this.rtt;
  }
  set renderToScreen(e) {
    if (this.rtt === e) {
      const t = this.fullscreenMaterial;
      t !== null && (t.needsUpdate = true), this.rtt = !e;
    }
  }
  set mainScene(e) {
  }
  set mainCamera(e) {
  }
  setRenderer(e) {
    this.renderer = e;
  }
  isEnabled() {
    return this.enabled;
  }
  setEnabled(e) {
    this.enabled = e;
  }
  get fullscreenMaterial() {
    return this.screen !== null ? this.screen.material : null;
  }
  set fullscreenMaterial(e) {
    let t = this.screen;
    t !== null ? t.material = e : (t = new ka(bs(), e), t.frustumCulled = false, this.scene === null && (this.scene = new Jt()), this.scene.add(t), this.screen = t);
  }
  getFullscreenMaterial() {
    return this.fullscreenMaterial;
  }
  setFullscreenMaterial(e) {
    this.fullscreenMaterial = e;
  }
  getDepthTexture() {
    return null;
  }
  setDepthTexture(e, t = ct) {
  }
  render(e, t, a, i, r) {
    throw new Error("Render method not implemented!");
  }
  setSize(e, t) {
  }
  initialize(e, t, a) {
  }
  dispose() {
    for (const e of Object.keys(this)) {
      const t = this[e];
      (t instanceof Ye || t instanceof Fi || t instanceof $t || t instanceof he) && this[e].dispose();
    }
  }
}, ws = class extends he {
  constructor(e, t = true) {
    super("CopyPass"), this.fullscreenMaterial = new ns(), this.needsSwap = false, this.renderTarget = e, e === void 0 && (this.renderTarget = new Ye(1, 1, { minFilter: dt, magFilter: dt, stencilBuffer: false, depthBuffer: false }), this.renderTarget.texture.name = "CopyPass.Target"), this.autoResize = t;
  }
  get resize() {
    return this.autoResize;
  }
  set resize(e) {
    this.autoResize = e;
  }
  get texture() {
    return this.renderTarget.texture;
  }
  getTexture() {
    return this.renderTarget.texture;
  }
  setAutoResizeEnabled(e) {
    this.autoResize = e;
  }
  render(e, t, a, i, r) {
    this.fullscreenMaterial.inputBuffer = t.texture, e.setRenderTarget(this.renderToScreen ? null : this.renderTarget), e.render(this.scene, this.camera);
  }
  setSize(e, t) {
    this.autoResize && this.renderTarget.setSize(e, t);
  }
  initialize(e, t, a) {
    a !== void 0 && (this.renderTarget.texture.type = a, a !== ft ? this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1" : ia(e) === ye && Ct(this.renderTarget.texture, ye));
  }
}, As = class extends he {
  constructor() {
    super("ClearMaskPass", null, null), this.needsSwap = false;
  }
  render(e, t, a, i, r) {
    const l = e.state.buffers.stencil;
    l.setLocked(false), l.setTest(false);
  }
}, Zi = new Zt(), Ji = class extends he {
  constructor(e = true, t = true, a = false) {
    super("ClearPass", null, null), this.needsSwap = false, this.color = e, this.depth = t, this.stencil = a, this.overrideClearColor = null, this.overrideClearAlpha = -1;
  }
  setClearFlags(e, t, a) {
    this.color = e, this.depth = t, this.stencil = a;
  }
  getOverrideClearColor() {
    return this.overrideClearColor;
  }
  setOverrideClearColor(e) {
    this.overrideClearColor = e;
  }
  getOverrideClearAlpha() {
    return this.overrideClearAlpha;
  }
  setOverrideClearAlpha(e) {
    this.overrideClearAlpha = e;
  }
  render(e, t, a, i, r) {
    const l = this.overrideClearColor, s = this.overrideClearAlpha, o = /* @__PURE__ */ e.getClearAlpha(), f = l !== null, d = s >= 0;
    f ? (e.getClearColor(Zi), e.setClearColor(l, d ? s : o)) : d && e.setClearAlpha(s), e.setRenderTarget(this.renderToScreen ? null : t), e.clear(this.color, this.depth, this.stencil), f ? e.setClearColor(Zi, o) : d && e.setClearAlpha(o);
  }
};
function $i(e, t, a) {
  for (const i of t) {
    const r = "$1" + e + i.charAt(0).toUpperCase() + i.slice(1), l = new RegExp("([^\\.])(\\b" + i + "\\b)", "g");
    for (const s of a.entries())
      s[1] !== null && a.set(s[0], s[1].replace(l, r));
  }
}
function Cs(e, t, a) {
  let i = t.getFragmentShader(), r = t.getVertexShader();
  const l = i !== void 0 && /mainImage/.test(i), s = i !== void 0 && /mainUv/.test(i);
  if (a.attributes |= t.getAttributes(), i === void 0)
    throw new Error(`Missing fragment shader (${t.name})`);
  if (s && a.attributes & ze.CONVOLUTION)
    throw new Error(`Effects that transform UVs are incompatible with convolution effects (${t.name})`);
  if (!l && !s)
    throw new Error(`Could not find mainImage or mainUv function (${t.name})`);
  {
    const o = /\w+\s+(\w+)\([\w\s,]*\)\s*{/g, f = a.shaderParts;
    let d = f.get(X.FRAGMENT_HEAD) || "", c = f.get(X.FRAGMENT_MAIN_UV) || "", u = f.get(X.FRAGMENT_MAIN_IMAGE) || "", m = f.get(X.VERTEX_HEAD) || "", p = f.get(X.VERTEX_MAIN_SUPPORT) || "";
    const g = /* @__PURE__ */ new Set(), h = /* @__PURE__ */ new Set();
    if (s && (c += `	${e}MainUv(UV);
`, a.uvTransformation = true), r !== null && /mainSupport/.test(r)) {
      const x = /* @__PURE__ */ /mainSupport *\([\w\s]*?uv\s*?\)/.test(r);
      p += `	${e}MainSupport(`, p += x ? `vUv);
` : `);
`;
      for (const b of r.matchAll(/(?:varying\s+\w+\s+([\S\s]*?);)/g))
        for (const w of b[1].split(/\s*,\s*/))
          a.varyings.add(w), g.add(w), h.add(w);
      for (const b of r.matchAll(o))
        h.add(b[1]);
    }
    for (const x of i.matchAll(o))
      h.add(x[1]);
    for (const x of t.defines.keys())
      h.add(x.replace(/\([\w\s,]*\)/g, ""));
    for (const x of t.uniforms.keys())
      h.add(x);
    h.delete("while"), h.delete("for"), h.delete("if"), t.uniforms.forEach((x, b) => a.uniforms.set(e + b.charAt(0).toUpperCase() + b.slice(1), x)), t.defines.forEach((x, b) => a.defines.set(e + b.charAt(0).toUpperCase() + b.slice(1), x));
    const C = /* @__PURE__ */ new Map([["fragment", i], ["vertex", r]]);
    $i(e, h, a.defines), $i(e, h, C), i = C.get("fragment"), r = C.get("vertex");
    const _ = t.blendMode;
    if (a.blendModes.set(_.blendFunction, _), l) {
      t.inputColorSpace !== null && t.inputColorSpace !== a.colorSpace && (u += t.inputColorSpace === ye ? `color0 = LinearTosRGB(color0);
	` : `color0 = sRGBToLinear(color0);
	`), t.outputColorSpace !== qi ? a.colorSpace = t.outputColorSpace : t.inputColorSpace !== null && (a.colorSpace = t.inputColorSpace);
      const x = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/;
      u += `${e}MainImage(color0, UV, `, a.attributes & ze.DEPTH && x.test(i) && (u += "depth, ", a.readDepth = true), u += `color1);
	`;
      const b = e + "BlendOpacity";
      a.uniforms.set(b, _.opacity), u += `color0 = blend${_.blendFunction}(color0, color1, ${b});

	`, d += `uniform float ${b};

`;
    }
    if (d += i + `
`, r !== null && (m += r + `
`), f.set(X.FRAGMENT_HEAD, d), f.set(X.FRAGMENT_MAIN_UV, c), f.set(X.FRAGMENT_MAIN_IMAGE, u), f.set(X.VERTEX_HEAD, m), f.set(X.VERTEX_MAIN_SUPPORT, p), t.extensions !== null)
      for (const x of t.extensions)
        a.extensions.add(x);
  }
}
var Ss = class extends he {
  constructor(e, ...t) {
    super("EffectPass"), this.fullscreenMaterial = new ms(null, null, null, e), this.listener = (a) => this.handleEvent(a), this.effects = [], this.setEffects(t), this.skipRendering = false, this.minTime = 1, this.maxTime = Number.POSITIVE_INFINITY, this.timeScale = 1;
  }
  set mainScene(e) {
    for (const t of this.effects)
      t.mainScene = e;
  }
  set mainCamera(e) {
    this.fullscreenMaterial.copyCameraSettings(e);
    for (const t of this.effects)
      t.mainCamera = e;
  }
  get encodeOutput() {
    return this.fullscreenMaterial.encodeOutput;
  }
  set encodeOutput(e) {
    this.fullscreenMaterial.encodeOutput = e;
  }
  get dithering() {
    return this.fullscreenMaterial.dithering;
  }
  set dithering(e) {
    const t = this.fullscreenMaterial;
    t.dithering = e, t.needsUpdate = true;
  }
  setEffects(e) {
    for (const t of this.effects)
      t.removeEventListener("change", this.listener);
    this.effects = e.sort((t, a) => a.attributes - t.attributes);
    for (const t of this.effects)
      t.addEventListener("change", this.listener);
  }
  updateMaterial() {
    const e = new Is();
    let t = 0;
    for (const s of this.effects)
      if (s.blendMode.blendFunction === Q.DST)
        e.attributes |= s.getAttributes() & ze.DEPTH;
      else {
        if (e.attributes & s.getAttributes() & ze.CONVOLUTION)
          throw new Error(`Convolution effects cannot be merged (${s.name})`);
        Cs("e" + t++, s, e);
      }
    let a = e.shaderParts.get(X.FRAGMENT_HEAD), i = e.shaderParts.get(X.FRAGMENT_MAIN_IMAGE), r = e.shaderParts.get(X.FRAGMENT_MAIN_UV);
    const l = /\bblend\b/g;
    for (const s of e.blendModes.values())
      a += s.getShaderCode().replace(l, `blend${s.blendFunction}`) + `
`;
    e.attributes & ze.DEPTH ? (e.readDepth && (i = `float depth = readDepth(UV);

	` + i), this.needsDepthTexture = this.getDepthTexture() === null) : this.needsDepthTexture = false, e.colorSpace === ye && (i += `color0 = sRGBToLinear(color0);
	`), e.uvTransformation ? (r = `vec2 transformedUv = vUv;
` + r, e.defines.set("UV", "transformedUv")) : e.defines.set("UV", "vUv"), e.shaderParts.set(X.FRAGMENT_HEAD, a), e.shaderParts.set(X.FRAGMENT_MAIN_IMAGE, i), e.shaderParts.set(X.FRAGMENT_MAIN_UV, r);
    for (const [s, o] of e.shaderParts)
      o !== null && e.shaderParts.set(s, o.trim().replace(/^#/, `
#`));
    this.skipRendering = t === 0, this.needsSwap = !this.skipRendering, this.fullscreenMaterial.setShaderData(e);
  }
  recompile() {
    this.updateMaterial();
  }
  getDepthTexture() {
    return this.fullscreenMaterial.depthBuffer;
  }
  setDepthTexture(e, t = ct) {
    this.fullscreenMaterial.depthBuffer = e, this.fullscreenMaterial.depthPacking = t;
    for (const a of this.effects)
      a.setDepthTexture(e, t);
  }
  render(e, t, a, i, r) {
    for (const l of this.effects)
      l.update(e, t, i);
    if (!this.skipRendering || this.renderToScreen) {
      const l = this.fullscreenMaterial;
      l.inputBuffer = t.texture, l.time += i * this.timeScale, e.setRenderTarget(this.renderToScreen ? null : a), e.render(this.scene, this.camera);
    }
  }
  setSize(e, t) {
    this.fullscreenMaterial.setSize(e, t);
    for (const a of this.effects)
      a.setSize(e, t);
  }
  initialize(e, t, a) {
    this.renderer = e;
    for (const i of this.effects)
      i.initialize(e, t, a);
    this.updateMaterial(), a !== void 0 && a !== ft && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
  }
  dispose() {
    super.dispose();
    for (const e of this.effects)
      e.removeEventListener("change", this.listener), e.dispose();
  }
  handleEvent(e) {
    switch (e.type) {
      case "change":
        this.recompile();
        break;
    }
  }
}, Ps = class extends he {
  constructor(e, t) {
    super("MaskPass", e, t), this.needsSwap = false, this.clearPass = new Ji(false, false, true), this.inverse = false;
  }
  set mainScene(e) {
    this.scene = e;
  }
  set mainCamera(e) {
    this.camera = e;
  }
  get inverted() {
    return this.inverse;
  }
  set inverted(e) {
    this.inverse = e;
  }
  get clear() {
    return this.clearPass.enabled;
  }
  set clear(e) {
    this.clearPass.enabled = e;
  }
  getClearPass() {
    return this.clearPass;
  }
  isInverted() {
    return this.inverted;
  }
  setInverted(e) {
    this.inverted = e;
  }
  render(e, t, a, i, r) {
    const l = /* @__PURE__ */ e.getContext(), s = e.state.buffers, o = this.scene, f = this.camera, d = this.clearPass, c = this.inverted ? 0 : 1, u = 1 - c;
    s.color.setMask(false), s.depth.setMask(false), s.color.setLocked(true), s.depth.setLocked(true), s.stencil.setTest(true), s.stencil.setOp(l.REPLACE, l.REPLACE, l.REPLACE), s.stencil.setFunc(l.ALWAYS, c, 4294967295), s.stencil.setClear(u), s.stencil.setLocked(true), this.clearPass.enabled && (this.renderToScreen ? d.render(e, null) : (d.render(e, t), d.render(e, a))), this.renderToScreen ? (e.setRenderTarget(null), e.render(o, f)) : (e.setRenderTarget(t), e.render(o, f), e.setRenderTarget(a), e.render(o, f)), s.color.setLocked(false), s.depth.setLocked(false), s.stencil.setLocked(false), s.stencil.setFunc(l.EQUAL, 1, 4294967295), s.stencil.setOp(l.KEEP, l.KEEP, l.KEEP), s.stencil.setLocked(true);
  }
}, Ms = class extends he {
  constructor() {
    super("MipmapBlurPass"), this.needsSwap = false, this.renderTarget = new Ye(1, 1, { depthBuffer: false }), this.renderTarget.texture.name = "Upsampling.Mipmap0", this.downsamplingMipmaps = [], this.upsamplingMipmaps = [], this.downsamplingMaterial = new ss(), this.upsamplingMaterial = new xs(), this.resolution = new me();
  }
  get texture() {
    return this.renderTarget.texture;
  }
  get levels() {
    return this.downsamplingMipmaps.length;
  }
  set levels(e) {
    if (this.levels !== e) {
      const t = this.renderTarget;
      this.dispose(), this.downsamplingMipmaps = [], this.upsamplingMipmaps = [];
      for (let a = 0; a < e; ++a) {
        const i = /* @__PURE__ */ t.clone();
        i.texture.name = "Downsampling.Mipmap" + a, this.downsamplingMipmaps.push(i);
      }
      this.upsamplingMipmaps.push(t);
      for (let a = 1, i = e - 1; a < i; ++a) {
        const r = /* @__PURE__ */ t.clone();
        r.texture.name = "Upsampling.Mipmap" + a, this.upsamplingMipmaps.push(r);
      }
      this.setSize(this.resolution.x, this.resolution.y);
    }
  }
  get radius() {
    return this.upsamplingMaterial.radius;
  }
  set radius(e) {
    this.upsamplingMaterial.radius = e;
  }
  render(e, t, a, i, r) {
    const { scene: l, camera: s } = this, { downsamplingMaterial: o, upsamplingMaterial: f } = this, { downsamplingMipmaps: d, upsamplingMipmaps: c } = this;
    let u = t;
    this.fullscreenMaterial = o;
    for (let m = 0, p = d.length; m < p; ++m) {
      const g = d[m];
      o.setSize(u.width, u.height), o.inputBuffer = u.texture, e.setRenderTarget(g), e.render(l, s), u = g;
    }
    this.fullscreenMaterial = f;
    for (let m = c.length - 1; m >= 0; --m) {
      const p = c[m];
      f.setSize(u.width, u.height), f.inputBuffer = u.texture, f.supportBuffer = d[m].texture, e.setRenderTarget(p), e.render(l, s), u = p;
    }
  }
  setSize(e, t) {
    const a = this.resolution;
    a.set(e, t);
    let i = a.width, r = a.height;
    for (let l = 0, s = this.downsamplingMipmaps.length; l < s; ++l)
      i = Math.round(i * 0.5), r = Math.round(r * 0.5), this.downsamplingMipmaps[l].setSize(i, r), l < this.upsamplingMipmaps.length && this.upsamplingMipmaps[l].setSize(i, r);
  }
  initialize(e, t, a) {
    if (a !== void 0) {
      const i = /* @__PURE__ */ this.downsamplingMipmaps.concat(this.upsamplingMipmaps);
      for (const r of i)
        r.texture.type = a;
      if (a !== ft)
        this.downsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1", this.upsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
      else if (ia(e) === ye)
        for (const r of i)
          Ct(r.texture, ye);
    }
  }
  dispose() {
    super.dispose();
    for (const e of this.downsamplingMipmaps.concat(this.upsamplingMipmaps))
      e.dispose();
  }
}, en = class extends he {
  constructor(e, t = "inputBuffer") {
    super("ShaderPass"), this.fullscreenMaterial = e, this.input = t;
  }
  setInput(e) {
    this.input = e;
  }
  render(e, t, a, i, r) {
    const l = this.fullscreenMaterial.uniforms;
    t !== null && l !== void 0 && l[this.input] !== void 0 && (l[this.input].value = t.texture), e.setRenderTarget(this.renderToScreen ? null : a), e.render(this.scene, this.camera);
  }
  initialize(e, t, a) {
    a !== void 0 && a !== ft && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
  }
}, Oa = 1 / 1e3, Ds = 1e3, Es = class {
  constructor() {
    this.startTime = performance.now(), this.previousTime = 0, this.currentTime = 0, this._delta = 0, this._elapsed = 0, this._fixedDelta = 1e3 / 60, this.timescale = 1, this.useFixedDelta = false, this._autoReset = false;
  }
  get autoReset() {
    return this._autoReset;
  }
  set autoReset(e) {
    typeof document < "u" && document.hidden !== void 0 && (e ? document.addEventListener("visibilitychange", this) : document.removeEventListener("visibilitychange", this), this._autoReset = e);
  }
  get delta() {
    return this._delta * Oa;
  }
  get fixedDelta() {
    return this._fixedDelta * Oa;
  }
  set fixedDelta(e) {
    this._fixedDelta = e * Ds;
  }
  get elapsed() {
    return this._elapsed * Oa;
  }
  update(e) {
    this.useFixedDelta ? this._delta = this.fixedDelta : (this.previousTime = this.currentTime, this.currentTime = (e !== void 0 ? e : performance.now()) - this.startTime, this._delta = this.currentTime - this.previousTime), this._delta *= this.timescale, this._elapsed += this._delta;
  }
  reset() {
    this._delta = 0, this._elapsed = 0, this.currentTime = performance.now() - this.startTime;
  }
  handleEvent(e) {
    document.hidden || (this.currentTime = performance.now() - this.startTime);
  }
  dispose() {
    this.autoReset = false;
  }
}, Ts = class {
  constructor(t = null, { depthBuffer: a = true, stencilBuffer: i = false, multisampling: r = 0, frameBufferType: l } = {}) {
    this.renderer = null, this.inputBuffer = this.createBuffer(a, i, l, r), this.outputBuffer = this.inputBuffer.clone(), this.copyPass = new ws(), this.depthTexture = null, this.passes = [], this.timer = new Es(), this.autoRenderToScreen = true, this.setRenderer(t);
  }
  get multisampling() {
    return this.inputBuffer.samples || 0;
  }
  set multisampling(t) {
    const a = this.inputBuffer, i = this.multisampling;
    i > 0 && t > 0 ? (this.inputBuffer.samples = t, this.outputBuffer.samples = t, this.inputBuffer.dispose(), this.outputBuffer.dispose()) : i !== t && (this.inputBuffer.dispose(), this.outputBuffer.dispose(), this.inputBuffer = this.createBuffer(a.depthBuffer, a.stencilBuffer, a.texture.type, t), this.inputBuffer.depthTexture = this.depthTexture, this.outputBuffer = this.inputBuffer.clone());
  }
  getTimer() {
    return this.timer;
  }
  getRenderer() {
    return this.renderer;
  }
  setRenderer(t) {
    if (this.renderer = t, t !== null) {
      const a = /* @__PURE__ */ t.getSize(new me()), i = t.getContext().getContextAttributes().alpha, r = this.inputBuffer.texture.type;
      r === ft && ia(t) === ye && (Ct(this.inputBuffer.texture, ye), Ct(this.outputBuffer.texture, ye), this.inputBuffer.dispose(), this.outputBuffer.dispose()), t.autoClear = false, this.setSize(a.width, a.height);
      for (const l of this.passes)
        l.initialize(t, i, r);
    }
  }
  replaceRenderer(t, a = true) {
    const i = this.renderer, r = i.domElement.parentNode;
    return this.setRenderer(t), a && r !== null && (r.removeChild(i.domElement), r.appendChild(t.domElement)), i;
  }
  createDepthTexture() {
    const t = this.depthTexture = new fo();
    return this.inputBuffer.depthTexture = t, this.inputBuffer.dispose(), this.inputBuffer.stencilBuffer ? (t.format = co, t.type = uo) : t.type = mo, t;
  }
  deleteDepthTexture() {
    if (this.depthTexture !== null) {
      this.depthTexture.dispose(), this.depthTexture = null, this.inputBuffer.depthTexture = null, this.inputBuffer.dispose();
      for (const t of this.passes)
        t.setDepthTexture(null);
    }
  }
  createBuffer(t, a, i, r) {
    const l = this.renderer, s = l === null ? new me() : l.getDrawingBufferSize(new me()), o = { minFilter: dt, magFilter: dt, stencilBuffer: a, depthBuffer: t, type: i }, f = new Ye(s.width, s.height, o);
    return r > 0 && (f.ignoreDepthForMultisampleCopy = false, f.samples = r), i === ft && ia(l) === ye && Ct(f.texture, ye), f.texture.name = "EffectComposer.Buffer", f.texture.generateMipmaps = false, f;
  }
  setMainScene(t) {
    for (const a of this.passes)
      a.mainScene = t;
  }
  setMainCamera(t) {
    for (const a of this.passes)
      a.mainCamera = t;
  }
  addPass(t, a) {
    const i = this.passes, r = this.renderer, l = /* @__PURE__ */ r.getDrawingBufferSize(new me()), s = r.getContext().getContextAttributes().alpha, o = this.inputBuffer.texture.type;
    if (t.setRenderer(r), t.setSize(l.width, l.height), t.initialize(r, s, o), this.autoRenderToScreen && (i.length > 0 && (i[i.length - 1].renderToScreen = false), t.renderToScreen && (this.autoRenderToScreen = false)), a !== void 0 ? i.splice(a, 0, t) : i.push(t), this.autoRenderToScreen && (i[i.length - 1].renderToScreen = true), t.needsDepthTexture || this.depthTexture !== null)
      if (this.depthTexture === null) {
        const f = /* @__PURE__ */ this.createDepthTexture();
        for (t of i)
          t.setDepthTexture(f);
      } else
        t.setDepthTexture(this.depthTexture);
  }
  removePass(t) {
    const a = this.passes, i = /* @__PURE__ */ a.indexOf(t);
    if (i !== -1 && a.splice(i, 1).length > 0) {
      if (this.depthTexture !== null) {
        const s = (f, d) => f || d.needsDepthTexture;
        a.reduce(s, false) || (t.getDepthTexture() === this.depthTexture && t.setDepthTexture(null), this.deleteDepthTexture());
      }
      this.autoRenderToScreen && i === a.length && (t.renderToScreen = false, a.length > 0 && (a[a.length - 1].renderToScreen = true));
    }
  }
  removeAllPasses() {
    const t = this.passes;
    this.deleteDepthTexture(), t.length > 0 && (this.autoRenderToScreen && (t[t.length - 1].renderToScreen = false), this.passes = []);
  }
  render(t) {
    const a = this.renderer, i = this.copyPass;
    let r = this.inputBuffer, l = this.outputBuffer, s = false, o, f, d;
    t === void 0 && (this.timer.update(), t = this.timer.delta);
    for (const c of this.passes)
      c.enabled && (c.render(a, r, l, t, s), c.needsSwap && (s && (i.renderToScreen = c.renderToScreen, o = a.getContext(), f = a.state.buffers.stencil, f.setFunc(o.NOTEQUAL, 1, 4294967295), i.render(a, r, l, t, s), f.setFunc(o.EQUAL, 1, 4294967295)), d = r, r = l, l = d), c instanceof Ps ? s = true : c instanceof As && (s = false));
  }
  setSize(t, a, i) {
    const r = this.renderer, l = /* @__PURE__ */ r.getSize(new me());
    (t === void 0 || a === void 0) && (t = l.width, a = l.height), (l.width !== t || l.height !== a) && r.setSize(t, a, i);
    const s = /* @__PURE__ */ r.getDrawingBufferSize(new me());
    this.inputBuffer.setSize(s.width, s.height), this.outputBuffer.setSize(s.width, s.height);
    for (const o of this.passes)
      o.setSize(s.width, s.height);
  }
  reset() {
    const t = this.timer.autoReset;
    this.dispose(), this.autoRenderToScreen = true, this.timer.autoReset = t;
  }
  dispose() {
    for (const t of this.passes)
      t.dispose();
    this.passes = [], this.inputBuffer !== null && this.inputBuffer.dispose(), this.outputBuffer !== null && this.outputBuffer.dispose(), this.deleteDepthTexture(), this.copyPass.dispose(), this.timer.dispose();
  }
}, Is = class {
  constructor() {
    this.shaderParts = /* @__PURE__ */ new Map([[X.FRAGMENT_HEAD, null], [X.FRAGMENT_MAIN_UV, null], [X.FRAGMENT_MAIN_IMAGE, null], [X.VERTEX_HEAD, null], [X.VERTEX_MAIN_SUPPORT, null]]), this.defines = /* @__PURE__ */ new Map(), this.uniforms = /* @__PURE__ */ new Map(), this.blendModes = /* @__PURE__ */ new Map(), this.extensions = /* @__PURE__ */ new Set(), this.attributes = ze.NONE, this.varyings = /* @__PURE__ */ new Set(), this.uvTransformation = false, this.readDepth = false, this.colorSpace = aa;
  }
}, Us = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y,opacity);}", Bs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,min(y.a,opacity));}", ks = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y)*0.5,opacity);}", Rs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.rg,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}", Ls = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(step(0.0,y)*(1.0-min(vec4(1.0),(1.0-x)/y)),vec4(1.0),step(1.0,x));return mix(x,z,opacity);}", zs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=step(0.0,x)*mix(min(vec4(1.0),x/max(1.0-y,1e-9)),vec4(1.0),step(1.0,y));return mix(x,z,opacity);}", Fs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x,y),opacity);}", Ns = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,abs(x-y),opacity);}", Os = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x/max(y,1e-12),opacity);}", Gs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y-2.0*x*y),opacity);}", Hs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 a=min(x,1.0),b=min(y,1.0);vec4 z=mix(2.0*a*b,1.0-2.0*(1.0-a)*(1.0-b),step(0.5,y));return mix(x,z,opacity);}", Vs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,step(1.0,x+y),opacity);}", Ws = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.r,xHSL.gb));return vec4(mix(x.rgb,z,opacity),y.a);}", js = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-y,opacity);}", Qs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y*(1.0-x),opacity);}", Ys = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x,y),opacity);}", qs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(y+x-1.0,0.0,1.0),opacity);}", Xs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x+y,1.0),opacity);}", Ks = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(2.0*y+x-1.0,0.0,1.0),opacity);}", Zs = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.rg,yHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}", Js = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x*y,opacity);}", $s = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-abs(1.0-x-y),opacity);}", el = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,opacity);}", tl = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(2.0*y*x,1.0-2.0*(1.0-y)*(1.0-x),step(0.5,x));return mix(x,z,opacity);}", al = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 z=mix(mix(y2,x,step(0.5*x,y)),max(vec4(0.0),y2-1.0),step(x,(y2-1.0)));return mix(x,z,opacity);}", il = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(min(x*x/max(1.0-y,1e-12),1.0),y,step(1.0,y));return mix(x,z,opacity);}", nl = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.r,yHSL.g,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}", rl = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y-min(x*y,1.0),opacity);}", ol = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 w=step(0.5,y);vec4 z=mix(x-(1.0-y2)*x*(1.0-x),mix(x+(y2-1.0)*(sqrt(x)-x),x+(y2-1.0)*x*((16.0*x-12.0)*x+3.0),w*(1.0-step(0.25,x))),w);return mix(x,z,opacity);}", sl = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y;}", ll = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x+y-1.0,0.0),opacity);}", fl = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(max(1.0-min((1.0-x)/(2.0*y),1.0),0.0),min(x/(2.0*(1.0-y)),1.0),step(0.5,y));return mix(x,z,opacity);}", cl = /* @__PURE__ */ new Map([[Q.ADD, Us], [Q.ALPHA, Bs], [Q.AVERAGE, ks], [Q.COLOR, Rs], [Q.COLOR_BURN, Ls], [Q.COLOR_DODGE, zs], [Q.DARKEN, Fs], [Q.DIFFERENCE, Ns], [Q.DIVIDE, Os], [Q.DST, null], [Q.EXCLUSION, Gs], [Q.HARD_LIGHT, Hs], [Q.HARD_MIX, Vs], [Q.HUE, Ws], [Q.INVERT, js], [Q.INVERT_RGB, Qs], [Q.LIGHTEN, Ys], [Q.LINEAR_BURN, qs], [Q.LINEAR_DODGE, Xs], [Q.LINEAR_LIGHT, Ks], [Q.LUMINOSITY, Zs], [Q.MULTIPLY, Js], [Q.NEGATION, $s], [Q.NORMAL, el], [Q.OVERLAY, tl], [Q.PIN_LIGHT, al], [Q.REFLECT, il], [Q.SATURATION, nl], [Q.SCREEN, rl], [Q.SOFT_LIGHT, ol], [Q.SRC, sl], [Q.SUBTRACT, ll], [Q.VIVID_LIGHT, fl]]), dl = class extends Ni {
  constructor(e, t = 1) {
    super(), this._blendFunction = e, this.opacity = new K(t);
  }
  getOpacity() {
    return this.opacity.value;
  }
  setOpacity(e) {
    this.opacity.value = e;
  }
  get blendFunction() {
    return this._blendFunction;
  }
  set blendFunction(e) {
    this._blendFunction = e, this.dispatchEvent({ type: "change" });
  }
  getBlendFunction() {
    return this.blendFunction;
  }
  setBlendFunction(e) {
    this.blendFunction = e;
  }
  getShaderCode() {
    return cl.get(this.blendFunction);
  }
}, ul = class extends Ni {
  constructor(e, t, { attributes: a = ze.NONE, blendFunction: i = Q.NORMAL, defines: r = /* @__PURE__ */ new Map(), uniforms: l = /* @__PURE__ */ new Map(), extensions: s = null, vertexShader: o = null } = {}) {
    super(), this.name = e, this.renderer = null, this.attributes = a, this.fragmentShader = t, this.vertexShader = o, this.defines = r, this.uniforms = l, this.extensions = s, this.blendMode = new dl(i), this.blendMode.addEventListener("change", (f) => this.setChanged()), this._inputColorSpace = aa, this._outputColorSpace = qi;
  }
  get inputColorSpace() {
    return this._inputColorSpace;
  }
  set inputColorSpace(e) {
    this._inputColorSpace = e, this.setChanged();
  }
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e, this.setChanged();
  }
  set mainScene(e) {
  }
  set mainCamera(e) {
  }
  getName() {
    return this.name;
  }
  setRenderer(e) {
    this.renderer = e;
  }
  getDefines() {
    return this.defines;
  }
  getUniforms() {
    return this.uniforms;
  }
  getExtensions() {
    return this.extensions;
  }
  getBlendMode() {
    return this.blendMode;
  }
  getAttributes() {
    return this.attributes;
  }
  setAttributes(e) {
    this.attributes = e, this.setChanged();
  }
  getFragmentShader() {
    return this.fragmentShader;
  }
  setFragmentShader(e) {
    this.fragmentShader = e, this.setChanged();
  }
  getVertexShader() {
    return this.vertexShader;
  }
  setVertexShader(e) {
    this.vertexShader = e, this.setChanged();
  }
  setChanged() {
    this.dispatchEvent({ type: "change" });
  }
  setDepthTexture(e, t = ct) {
  }
  update(e, t, a) {
  }
  setSize(e, t) {
  }
  initialize(e, t, a) {
  }
  dispose() {
    for (const e of Object.keys(this)) {
      const t = this[e];
      (t instanceof Ye || t instanceof Fi || t instanceof $t || t instanceof he) && this[e].dispose();
    }
  }
};
new pe(), new Ba(), new Zt(), new pe(), new pe();
var tn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC", an = "data:image/png;base64,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", ml = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}", vl = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}", gl = class extends ul {
  constructor({ blendFunction: e = Q.SRC, preset: t = Fe.MEDIUM, edgeDetectionMode: a = Ki.COLOR, predicationMode: i = as.DISABLED } = {}) {
    super("SMAAEffect", ml, { vertexShader: vl, blendFunction: e, attributes: ze.CONVOLUTION | ze.DEPTH, uniforms: /* @__PURE__ */ new Map([["weightMap", new K(null)]]) });
    let r, l;
    arguments.length > 1 && (r = arguments[0], l = arguments[1], arguments.length > 2 && (t = arguments[2]), arguments.length > 3 && (a = arguments[3])), this.renderTargetEdges = new Ye(1, 1, { depthBuffer: false }), this.renderTargetEdges.texture.name = "SMAA.Edges", this.renderTargetWeights = this.renderTargetEdges.clone(), this.renderTargetWeights.texture.name = "SMAA.Weights", this.uniforms.get("weightMap").value = this.renderTargetWeights.texture, this.clearPass = new Ji(true, false, false), this.clearPass.overrideClearColor = new Zt(0), this.clearPass.overrideClearAlpha = 1, this.edgeDetectionPass = new en(new cs()), this.edgeDetectionMaterial.edgeDetectionMode = a, this.edgeDetectionMaterial.predicationMode = i, this.weightsPass = new en(new ps());
    const s = new Bi();
    s.onLoad = () => {
      const o = new $t(r);
      o.name = "SMAA.Search", o.magFilter = ki, o.minFilter = ki, o.generateMipmaps = false, o.needsUpdate = true, o.flipY = true, this.weightsMaterial.searchTexture = o;
      const f = new $t(l);
      f.name = "SMAA.Area", f.magFilter = dt, f.minFilter = dt, f.generateMipmaps = false, f.needsUpdate = true, f.flipY = false, this.weightsMaterial.areaTexture = f, this.dispatchEvent({ type: "load" });
    }, s.itemStart("search"), s.itemStart("area"), r !== void 0 && l !== void 0 ? (s.itemEnd("search"), s.itemEnd("area")) : typeof Image < "u" && (r = new Image(), l = new Image(), r.addEventListener("load", () => s.itemEnd("search")), l.addEventListener("load", () => s.itemEnd("area")), r.src = tn, l.src = an), this.applyPreset(t);
  }
  get edgesTexture() {
    return this.renderTargetEdges.texture;
  }
  getEdgesTexture() {
    return this.edgesTexture;
  }
  get weightsTexture() {
    return this.renderTargetWeights.texture;
  }
  getWeightsTexture() {
    return this.weightsTexture;
  }
  get edgeDetectionMaterial() {
    return this.edgeDetectionPass.fullscreenMaterial;
  }
  get colorEdgesMaterial() {
    return this.edgeDetectionMaterial;
  }
  getEdgeDetectionMaterial() {
    return this.edgeDetectionMaterial;
  }
  get weightsMaterial() {
    return this.weightsPass.fullscreenMaterial;
  }
  getWeightsMaterial() {
    return this.weightsMaterial;
  }
  setEdgeDetectionThreshold(e) {
    this.edgeDetectionMaterial.edgeDetectionThreshold = e;
  }
  setOrthogonalSearchSteps(e) {
    this.weightsMaterial.orthogonalSearchSteps = e;
  }
  applyPreset(e) {
    const t = this.edgeDetectionMaterial, a = this.weightsMaterial;
    switch (e) {
      case Fe.LOW:
        t.edgeDetectionThreshold = 0.15, a.orthogonalSearchSteps = 4, a.diagonalDetection = false, a.cornerDetection = false;
        break;
      case Fe.MEDIUM:
        t.edgeDetectionThreshold = 0.1, a.orthogonalSearchSteps = 8, a.diagonalDetection = false, a.cornerDetection = false;
        break;
      case Fe.HIGH:
        t.edgeDetectionThreshold = 0.1, a.orthogonalSearchSteps = 16, a.diagonalSearchSteps = 8, a.cornerRounding = 25, a.diagonalDetection = true, a.cornerDetection = true;
        break;
      case Fe.ULTRA:
        t.edgeDetectionThreshold = 0.05, a.orthogonalSearchSteps = 32, a.diagonalSearchSteps = 16, a.cornerRounding = 25, a.diagonalDetection = true, a.cornerDetection = true;
        break;
    }
  }
  setDepthTexture(e, t = ct) {
    this.edgeDetectionMaterial.depthBuffer = e, this.edgeDetectionMaterial.depthPacking = t;
  }
  update(e, t, a) {
    this.clearPass.render(e, this.renderTargetEdges), this.edgeDetectionPass.render(e, t, this.renderTargetEdges), this.weightsPass.render(e, this.renderTargetEdges, this.renderTargetWeights);
  }
  setSize(e, t) {
    this.edgeDetectionMaterial.setSize(e, t), this.weightsMaterial.setSize(e, t), this.renderTargetEdges.setSize(e, t), this.renderTargetWeights.setSize(e, t);
  }
  dispose() {
    const { searchTexture: e, areaTexture: t } = this.weightsMaterial;
    e !== null && t !== null && (e.dispose(), t.dispose()), super.dispose();
  }
  static get searchImageDataURL() {
    return tn;
  }
  static get areaImageDataURL() {
    return an;
  }
};
const pl = 1, hl = "/", _l = "/", xl = "/", yl = "https://storage.googleapis.com/sougen/", bl = [0, 0, 0, 0], wl = { clothing: { mesh: "default" }, collection: "default" }, Al = () => true, Cl = { 0: { aa: Fe.LOW, samples: 2, fur: false, dpr: 1, shadows: false, ssao: false, quality: 0, bloom: 0 }, 1: { aa: Fe.HIGH, samples: 4, fur: true, dpr: 1, quality: 1, shadows: true, ssao: true, bloom: 5 }, 2: { aa: Fe.ULTRA, samples: 4, fur: true, dpr: 1, quality: 2, shadows: true, ssao: true, bloom: 5 } }, z = { qualityPresets: Cl, assetsRoot: hl, coreAssetsRoot: _l, collectionAssetsRoot: xl, externalEndpoint: yl, isAdmin: Al, defaultHeight: pl, defaultSkinColor: bl, defaultPerks: wl, renderPriority: { default: 4, updateAllPositions: 5, beforeUpdtCharacterInstance: 6, frustum: 6, characterInstanceFrustumCheck: 6.5, characterInstanceAnim: 8, characterInstanceBones: 9, updtCharacterInstance: 11, postGravity: 20, cinematic: 99.5, mirror: 900, prerender: 1e3, render: 1001, postrender: 1010, postprocess: 1100 } };
function W(e, t, a, i) {
  const r = class extends n.ShaderMaterial {
    constructor(l = {}) {
      const s = /* @__PURE__ */ Object.entries(e);
      super({ uniforms: s.reduce((o, [f, d]) => {
        const c = /* @__PURE__ */ n.UniformsUtils.clone({ [f]: { value: d } });
        return { ...o, ...c };
      }, {}), vertexShader: t, fragmentShader: a }), s.forEach(([o]) => Object.defineProperty(this, o, { get: () => this.uniforms[o].value, set: (f) => this.uniforms[o].value = f })), Object.assign(this, l), i && i(this);
    }
  };
  return r.key = n.MathUtils.generateUUID(), r;
}
const oe = new n.UniformsGroup();
oe.setName("Common"), oe.add(new n.Uniform(0)), oe.add(new n.Uniform(0)), oe.add(new n.Uniform(new n.Vector4(-9999, -9999, -9999, 0)));
var Sl = `precision highp float;
precision highp int;

out highp vec4 gColor;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>
#include <packing>

float readDepthFrag( float fragCoordZ, float cameraNear, float cameraFar) {
  float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );
  return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );
}

const float weight[5] = float[] (0.227027, 0.1945946, 0.1216216, 0.054054, 0.016216);
vec4 blur(sampler2D image,vec2 uv, vec2 direction){
  vec2 tex_offset = 1.0 / vec2( textureSize(image, 0) );		// gets size of single texel
    vec3 result = texture(image, uv).rgb * weight[0];	// current fragment's contribution

    vec2 tex;
    for(int i = 1; i < 5; ++i){
      tex = direction * tex_offset * float(i);
      result += texture(image, uv + tex).rgb * weight[i];
      result += texture(image, uv - tex).rgb * weight[i];
    }

    return vec4(result, 1.0);
}

uniform sampler2D tDiffuse;
uniform sampler2D tBright;

// anim loading
uniform float revealProgress;
uniform sampler2D tNormal;
uniform sampler2D tPosition;
uniform sampler2D tDepth;
uniform sampler2D tCloud;
uniform sampler2D tCloudDepth;

uniform float cameraNear;
uniform float cameraFar;

vec3 introAnimationScreen(float progress, float dist, float scale, vec3 color, vec4 normal, vec3 position) {
  float gray = 0.21 * normal.r + 0.71 * normal.g + 0.3 * normal.b;
  // float animProgress = sin(time * 1.) * 0.5 + 0.5;
  float fw = fwidth(dist) * 0.5;

  float part1 = smoothstep(0.2, .5, progress) * scale;
  float part2 = smoothstep(0.2, .53, progress) * scale;
  float part3 = smoothstep(0.25, 1., progress) * scale;


  float smoothed = smoothstep( part1 - fw, part1 + fw, dist );
  float smoothedStep2 = smoothstep( part2 - fw, part2 + fw, dist );
  float smoothedStep3 = smoothstep( part3 - fw, part3 + fw, dist );


  // loading animation block

  // prevent emissive from being black
  if (length(normal.rgb) == 0.) gray = .9;

  color.rgb = mix(color.rgb, vec3(gray), smoothedStep3);
  color.rgb = mix(color.rgb, vec3(0.086,0.922,0.922) , smoothedStep2);

  color.rgb = mix(color.rgb, vec3(0.125,0.141,0.153), smoothed);

  float prepart = smoothstep(0., .1, progress);
  float outpart = smoothstep(.6, .8, progress);
  float distEffectFactor = 1. - smoothstep(.0, 20., distance(position, playerPos.xyz));
  if (normal.a > 0.5 && progress < .99) {
    color.rgb = mix(color.rgb, vec3(gray), (prepart - outpart) * distEffectFactor);
  }

  return color;
}


uniform float brightness;
uniform float contrast;
uniform float saturation;
uniform float vibrance;
uniform float hue;
uniform float cinematic;
uniform float debugMRT;
uniform vec3 lightPos;



vec3 czm_hue(vec3 color, float hue) {
    const vec3 k = vec3(0.57735, 0.57735, 0.57735);
    float cosAngle = cos(hue);
    return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
}


vec3 czm_saturation(vec3 rgb, float adjustment)
{
    // Algorithm from Chapter 16 of OpenGL Shading Language
    const vec3 W = vec3(0.2125, 0.7154, 0.0721);
    vec3 intensity = vec3(dot(rgb, W));
    return mix(intensity, rgb, adjustment);
}

vec3 czm_vibrance(vec3 rgb, float adjustement)
{
    const float AverageLuminance = 0.5;
    float currentLuminance = dot(rgb, vec3(0.2125, 0.7154, 0.0721));
    float mx = max(rgb.r, max(rgb.g, rgb.b));
    float amt = (mx - currentLuminance) * (-3.0 * adjustement * AverageLuminance);
    return mix(rgb.rgb, vec3(mx), amt);
}

vec3 brightnessContrast(vec3 value, float brightness, float contrast)
{
    return (value - 0.5) * contrast + 0.5 + brightness;
}

 vec3 A( vec3 color ) { 
  
 	color *= 1.7; 
 	return saturate(( color * ( 2.51 * color + 0.03 ) ) / ( color * ( 2.43 * color + 0.59 ) + 0.14 )); 
  
 } 


vec3 blendAdd(vec3 base, vec3 blend) {
	return min(base+blend,vec3(1.0));
}

vec4 blendAdd(vec4 base, vec4 blend) {
	return min(base+blend, 1.);
}


vec3 blendOverlay(vec3 base, vec3 blend) {
    return mix(1.0 - 2.0 * (1.0 - base) * (1.0 - blend), 2.0 * base * blend, step(base, vec3(0.5)));
}
#define RADIUS 1.45
#define EDGE 0.55
#define NOISEBIGNESS 0.02
#define NIGHTSPEEDBONUS 2.25 		


float radial(vec2 pos, float radius)
{
    float result = length(pos)-radius;
    result = fract(result*1.0);
    float result2 = 1.0 - result;
    float fresult = result * result2;
    fresult = pow((fresult*3.),7.);
    return fresult;
}


in vec2 vUv;


void main() {


  uvec2 fragCoord = uvec2(gl_FragCoord.xy);
  ivec2 fCoord = ivec2(gl_FragCoord.xy);

  vec2 uv = vUv;


  vec4 color = vec4(1.);
  vec4 diffuse = texture(tDiffuse, vUv);


  color.rgb = diffuse.rgb;

  #ifdef USE_BLOOM
    vec3 bright = texture(tBright, uv).rgb;
    color.rgb = blendAdd(color.rgb, bright);
  #endif

  gColor.rgb = color.rgb;

  if (vUv.y < cinematic) {
    gColor.rgb = vec3(0.);
  }
  if (vUv.y > 1. - cinematic) {
    gColor.rgb = vec3(0.);
  }

  gColor.rgb = brightnessContrast(gColor.rgb, brightness, contrast);
  gColor.rgb = czm_hue(gColor.rgb, hue);
  gColor.rgb = czm_saturation(gColor.rgb, saturation);
  gColor.rgb = czm_vibrance(gColor.rgb, vibrance);
  gColor.a = 1.;


  vec2 c_uv = vUv;
  vec2 o_uv = vUv * .1 * revealProgress;

  float gradient = radial(c_uv, revealProgress);
  vec2 fuv = mix(vUv,o_uv,gradient);
  // vec2 fuv = vUv;
  // fuv += realPixel;

  vec4 o_position = texture(tPosition, vUv);
  vec4 o_normal = texture(tNormal, vUv);
  
  float depthCloud = 0.0;

  #ifdef USE_SDFCLOUDS
    float d = readDepthFrag(texture(tDepth, uv).x, cameraNear, cameraFar);
    float cloudD = readDepthFrag(texture(tCloudDepth, uv).x, cameraNear, cameraFar);
    depthCloud = (cloudD < d ) ? 1.0 : 0.0;

  // cloudD > 0.001 to prevent aterfact
    if (depthCloud > 0.) {
      vec4 clouds = texture(tCloud, uv);
      gColor.rgb = clouds.rgb;
    }
  #endif

  float screenAnimDist = length(fuv * vec2( 1. * (cos(revealProgress * 2.), 1.)) - 0.5);
  // gColor.rgb = introAnimation(revealProgress, playerAnimDist, 30., gColor.rgb, normal);
  gColor.rgb = introAnimationScreen(revealProgress, screenAnimDist, 1., gColor.rgb, o_normal, o_position.xyz);

  // gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b), 1.);

  #ifdef USE_DEFERRED
    #ifdef USE_COMMON_UBO
      float playerAnimDist = distance(playerPos.xyz, o_position.xyz);
      gColor.rgb = introAnimation(1. - animProgress, playerAnimDist, 1000., gColor.rgb, o_normal, o_position.xyz, playerPos.xyz);
    #endif
  #endif

}
`, Pl = `
out vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = vec4(position, 1.0);
}
`;
const Ml = /* @__PURE__ */ W({ revealProgress: 1, cinematic: 0, brightness: 0, contrast: 1, hue: 0, saturation: 1, vibrance: 0, tDiffuse: null, tDepth: null, tNormal: null, tCloud: null, tCloudDepth: null, tPosition: null, tBright: null, debugMRT: 0, cameraNear: 0.1, cameraFar: 3500 }, Pl, Sl, (e) => {
  e.glslVersion = n.GLSL3, e.uniformsGroups = [oe];
});
class St extends n.BufferGeometry {
  constructor() {
    super(), this.setAttribute("position", new n.BufferAttribute(new Float32Array([-1, -1, 3, -1, -1, 3]), 2)), this.setAttribute("uv", new n.BufferAttribute(new Float32Array([0, 0, 2, 0, 0, 2]), 2));
  }
}
const Ga = /* @__PURE__ */ De((e, t) => {
  const a = new n.Scene(), i = new n.OrthographicCamera(-1, 1, 1, -1, 0, 1), r = new n.Mesh(new St());
  r.frustumCulled = false, a.add(r);
  const l = /* @__PURE__ */ Xe(), s = /* @__PURE__ */ Xe(), o = /* @__PURE__ */ Xe(), f = /* @__PURE__ */ Xe(), d = /* @__PURE__ */ Xe();
  return { key: null, screen: r, screenScene: a, screenCamera: i, inputDiffuse: l, inputBloom: d, inputVColor: f, inputDepth: o, inputDepthPrePass: s, composer: null, passPostprocess: null };
}), $e = (e) => Ga(e, Le);
Object.assign($e, Ga);
const { getState: na, setState: be } = Ga, Ha = /* @__PURE__ */ De(() => ({ gl: null, aa: Fe.LOW, samples: 0, dpr: 1, shadows: false, quality: 0, bloom: 0, paused: false, screenshot: false, fur: false, useComposer: true, useSSAO: true, useFog: true, useShadows: true, useDeferred: false, useBloom: false, useGlobalBloom: false, bloomThreshold: 0.9, bloomSmoothing: 0.025, aoIntensity: 0.5, aoRadius: 5, aoNoiseRadius: 12, fogColor: "#ffffff", fogOpacity: 0.8, fogNear: 1, fogFar: 1e3, colorSettings: { brightness: 0, hue: 0, saturation: 1, contrast: 1, vibrance: 0 } })), Y = (e, t) => Ha(e, t || Le);
Object.assign(Y, Ha);
const { getState: Va, setState: Pt } = Ha, { damp: Dl, smoothstep: El } = n.MathUtils;
class Tl extends he {
  constructor(t, a, i, r) {
    super("PostProcessEffectPass"), this.fullscreenMaterial = this.material = new Ml(), this.inputDiffuse = t, this.inputBloom = a, this.inputDepth = i, this.revealProgress = r;
  }
  render(t, a, i, r) {
    this.material.uniforms.tDiffuse.value = this.inputDiffuse.current, this.material.uniforms.tBright.value = this.inputBloom.current, this.material.uniforms.tDepth.value = this.inputDepth.current, this.material.uniforms.revealProgress.value = this.revealProgress.current, this.material.uniforms.revealProgress.value > 0.01 ? (this.camera.fov = 50 - (1 - El(this.revealProgress.current, 0, 0.5)) * 10, this.camera.updateProjectionMatrix()) : this.camera.fov !== 50 && (this.camera.fov = 50, this.camera.updateProjectionMatrix()), this.material.uniforms.cameraNear.value = this.camera.near, this.material.uniforms.cameraFar.value = this.camera.far;
    const { tPosition: l, tNormal: s, tCloud: o, tCloudDepth: f } = /* @__PURE__ */ na();
    l && (this.material.uniforms.tPosition.value = l), s && (this.material.uniforms.tNormal.value = s), o && (this.material.uniforms.tCloud.value = o), f && (this.material.uniforms.tCloudDepth.value = f), this.material.uniforms.cinematic.value = Dl(this.material.uniforms.cinematic.value, this.cinematic.current, 2, r), t.setRenderTarget(null), t.render(this.scene, this.camera);
  }
  dispose() {
    this.fullscreenMaterial.dispose();
  }
}
N({ PostProcessEffectPass: Tl }), be({ key: n.MathUtils.generateUUID() });
function Il() {
  const e = /* @__PURE__ */ I(), t = /* @__PURE__ */ U((h) => h.camera), [a, i, r] = /* @__PURE__ */ $e((h) => [h.inputDiffuse, h.inputBloom, h.inputDepth]), l = /* @__PURE__ */ Y((h) => h.debug), s = /* @__PURE__ */ Y((h) => h.useClouds), o = /* @__PURE__ */ I(0), f = /* @__PURE__ */ I(0), [d, c, u, m, p] = /* @__PURE__ */ Y((h) => [parseFloat(h.colorSettings.brightness), parseFloat(h.colorSettings.hue), parseFloat(h.colorSettings.saturation), parseFloat(h.colorSettings.contrast), parseFloat(h.colorSettings.vibrance)]);
  re("cinematic", (h) => {
    f.current = h ? 0.15 : 0;
  }), re("challenge", (h) => {
    o.current = h ? 1 : 0;
  }), re("fadeBlack", (h) => {
    f.current = h ? 1 : 0;
  });
  const g = /* @__PURE__ */ I(1);
  return re("postAnimFinishLoad", (h) => {
  }), y("postProcessEffectPass", { ref: e, args: [a, i, r, g], attach: (h, C) => (be({ passPostprocess: C }), h.addPass(C), () => h.removePass(C)), camera: t, cinematic: f, "material-brightness": typeof d == "number" ? d : 0, "material-contrast": typeof m == "number" ? m : 1, "material-saturation": typeof u == "number" ? u : 1, "material-hue": typeof c == "number" ? c : 0, "material-vibrance": typeof p == "number" ? p : 0, "material-debugMRT": l ? 1 : 0, "material-defines-USE_SDFCLOUDS": !!s });
}
const Wa = /* @__PURE__ */ De(() => ({ gl: null, loader: null, loaderInfos: {}, active: true, startLoadTimestamp: 0, noLoader: false, forceLoader: true, totalEssentials: 9999, startPositionSet: false, startCanvasLoop: false, canvasLoopReady: false, loadingStep: 0, waitForAllLoad: false, step0Complete: false, loadingManagerActive: false, allLoadedItem: [], startCountGltf: 0, isAnalysingLoader: false, startRecordPaths: false, ignoreProgress: false, forceFinishLoader: false, pathLoaded: [] })), ra = (e, t) => Wa(e, t || Le);
Object.assign(ra, Wa);
const { getState: et, setState: Ve } = Wa, tt = new n.UniformsGroup();
tt.setName("NearbyPlayers"), tt.add(new n.Uniform(new n.Vector4(1, -9999, -9999, 1))), tt.add(new n.Uniform(new n.Vector4(1, -9999, -9999, 1))), tt.add(new n.Uniform(new n.Vector4(1, -9999, -9999, 1))), tt.add(new n.Uniform(new n.Vector4(1, -9999, -9999, 1))), tt.add(new n.Uniform(new n.Vector4(1, -9999, -9999, 1)));
const at = new n.UniformsGroup();
at.setName("ShadowMapData"), at.add(new n.Uniform(new n.Matrix4())), at.add(new n.Uniform(new n.Matrix4())), at.add(new n.Uniform(new n.Color("#00172d"))), at.add(new n.Uniform(0.2)), at.add(new n.Uniform(15e-4));
const Mt = new n.UniformsGroup(100), Ul = /* @__PURE__ */ new Array(100).fill(0).map((e, t) => new n.Vector4(-9999, -9999, -9999, 0)), Bl = /* @__PURE__ */ new Array(100).fill(0).map((e, t) => new n.Vector4(255, 0, 0, 0)), kl = /* @__PURE__ */ new Array(100).fill(0).map((e, t) => new n.Vector4(0, 0, 0, 0));
Mt.setName("BrushDataBlock"), Mt.add(new n.Uniform(Ul)), Mt.add(new n.Uniform(Bl)), Mt.add(new n.Uniform(kl));
const Te = new n.UniformsGroup();
Te.setName("FogData"), Te.add(new n.Uniform(new n.Color("#ffffff"))), Te.add(new n.Uniform(0.8)), Te.add(new n.Uniform(1)), Te.add(new n.Uniform(1e3));
const Rl = 1, we = { ambientColor: { r: 1, g: 1, b: 1 }, ambientIntensity: 0.75, diffuseColor: { r: 1, g: 1, b: 1 }, diffuseIntensity: 1.1, specularColor: { r: 1, g: 1, b: 1 }, specularShininess: 1 }, it = new n.UniformsGroup();
it.setName("LightingData"), it.add(new n.Uniform(new n.Vector4(we.ambientColor.r, we.ambientColor.g, we.ambientColor.b, we.ambientIntensity))), it.add(new n.Uniform(new n.Vector4(we.diffuseColor.r, we.diffuseColor.g, we.diffuseColor.b, we.diffuseIntensity))), it.add(new n.Uniform(new n.Vector4(we.specularColor.r, we.specularColor.g, we.specularColor.b, we.specularShininess))), it.add(new n.Uniform(new n.Vector4(-2500, 2e4, -1e4, 0)));
const oa = new n.UniformsGroup(Rl);
oa.setName("PointLightData"), oa.add(new n.Uniform([new n.Vector4(), new n.Vector4()]));
const nn = /* @__PURE__ */ Xe();
nn.current = {};
const ja = /* @__PURE__ */ De((e, t) => ({ lightData: it, paintData: Mt, pointsLightData: oa, shadowMapData: at, fogData: Te, commonUbo: oe, nearbyPlayersUbo: tt, pointsLightsCnt: 0, shadowMap: null, playerBrushReferences: nn })), Ie = (e) => ja(e, Le);
Object.assign(Ie, ja);
const { getState: Dt, setState: Qa } = ja;
var Ll = `precision highp float;

layout(location = 0) out vec4 gColor;

#include <common>
#include <common_ubo_pars>
#include <packing>

float depthSampleToWorld(float depth, float cameraNear, float cameraFar) {
	// return cameraNear * cameraFar / (cameraFar - depth * (cameraFar - cameraNear));
  float viewZ = perspectiveDepthToViewZ( depth, cameraNear, cameraFar );
  return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );
}

float sobelDepth(sampler2D tex, ivec2 xy, float camNear, float camFar) {
  float x00 = depthSampleToWorld(texelFetch(tex, xy + ivec2(-1, -1), 0).x, camNear, camFar);
  float x10 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 0, -1), 0).x, camNear, camFar);
  float x11 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 0,  0), 0).x, camNear, camFar);
  float x01 = depthSampleToWorld(texelFetch(tex, xy + ivec2(-1,  0), 0).x, camNear, camFar);
  float x02 = depthSampleToWorld(texelFetch(tex, xy + ivec2(-1,  1), 0).x, camNear, camFar);
  float x12 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 0,  1), 0).x, camNear, camFar);
  float x20 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 1, -1), 0).x, camNear, camFar);
  float x21 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 1,  0), 0).x, camNear, camFar);
  float x22 = depthSampleToWorld(texelFetch(tex, xy + ivec2( 1,  1), 0).x, camNear, camFar);
  float x = x00 + 2.0f * x10 + x20 - (x02 + 2.0f * x12 + x22);
  float y = x00 + 2.0f * x01 + x02 - (x20 + 2.0f * x21 + x22);
  return sqrt(x * x + y * y);
}

vec3 sobelNorm(sampler2D tex, ivec2 xy) {
  vec3 x00 = texelFetch(tex, xy + ivec2(-1, -1), 0).xyz;
  vec3 x01 = texelFetch(tex, xy + ivec2(-1,  0), 0).xyz;
  vec3 x02 = texelFetch(tex, xy + ivec2(-1,  1), 0).xyz;
  vec3 x10 = texelFetch(tex, xy + ivec2( 0, -1), 0).xyz;
  vec3 x11 = texelFetch(tex, xy + ivec2( 0,  0), 0).xyz;
  vec3 x12 = texelFetch(tex, xy + ivec2( 0,  1), 0).xyz;
  vec3 x20 = texelFetch(tex, xy + ivec2( 1, -1), 0).xyz;
  vec3 x21 = texelFetch(tex, xy + ivec2( 1,  0), 0).xyz;
  vec3 x22 = texelFetch(tex, xy + ivec2( 1,  1), 0).xyz;
  vec3 x = x00 + 2.0f * x10 + x20 - (x02 + 2.0f * x12 + x22);
  vec3 y = x00 + 2.0f * x01 + x02 - (x20 + 2.0f * x21 + x22);
  return sqrt(x * x + y * y);
}

uniform sampler2D tDepth;
uniform sampler2D tDiffuse;
uniform sampler2D tNormal;
uniform sampler2D tPosition;
uniform sampler2D tVColor;

uniform float cameraFar;
uniform float cameraNear;

uniform float debugMRT;

uniform vec2 uRes;

uniform mat4 projectionInverse;

float readDepthFrag( float fragCoordZ, float cameraNear, float cameraFar) {
  float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );
  return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );
}

#include <deferred_lights_pars>

vec3 toonShading(
  vec3 colorIn, uint steps,
  ivec2 fCoord, sampler2D normalTex, sampler2D depthTex,
  float camNear, float camFar,
  float normalWeight, float depthWeight,
  float edgeThresholdMin, float edgeThresholdMax, vec3 color, float scale
) {
  colorIn = floor(colorIn * (float(steps) - 0.01f)) / float(steps);
  vec3 normal = normalWeight * sobelNorm(normalTex, fCoord);
  float depth = depthWeight * sobelDepth(depthTex, fCoord, camNear, camFar);
  float diff = length(normal) + depth;

  colorIn = mix(colorIn, color, smoothstep(edgeThresholdMin, edgeThresholdMax, diff * scale));
  return colorIn;
}


in vec2 vUv;
void main() {
  ivec2 fCoord = ivec2(gl_FragCoord.xy);
  vec2 uv = vUv;


  #ifdef DEBUG_DIFFUSE
    uv *= vec2(3., 3.);
    uv -= vec2(1., 1.);
    fCoord *= ivec2(3., 3.);
    fCoord -= ivec2(1., 1.);
  #endif

  // mrt layers
  vec4 albedo = texture(tDiffuse, uv);
  vec4 normal = texture(tNormal, uv);
  vec4 vcolor = texture(tVColor, uv);
  vec4 position = texture(tPosition, uv);

  vec4 o_diffuse = vec4(vec3(0.), 1.);


  // shadow factor of 0.4
  float shadow = 0.;
  if (position.a > 0.) {
    position.a * .4;
  }

  float shininess = 0.;
  float toon = 1.;
  float unlit = 0.;

  // ID 0.0 = unlit
  // ID 0.5 = lit
  // ID 1. = lit + toon
  if (normal.a > 0.2) {
    unlit = 0.;
    if (normal.a > 0.5) {
      toon = 1.;
    }
  } else {
    if (normal.a > 0.0) {
      toon = 1.;
    }
  }


  float gray = 0.21 * normal.r + 0.71 * normal.g + 0.3 * normal.b;

  // shadow player position
  albedo.rgb = mix(albedo.rgb, vec3(gray) * .1 * (1. - shadow), smoothstep(0.5, .8, 1. - distance(playerPos.xyz - vec3(0., .2, 0.), position.xyz)) * .2);

  normal.xyz = unpackRGBToNormal(normal.xyz);

  // TODO Shiny re-enable
  // if (length(vcolor.rg) < .1) {
  //   shininess = vcolor.b;
  //   vcolor.rgb = vec3(0.);
  // }


  // Unlit
  // then no lights
  #ifndef DEBUG_DIFFUSE
  if (unlit == 1.) {
    // albedo -= shadow;
    gColor = albedo;
    return;
  };
  #endif

  // ambient
  vec3 ambient = Light.ambient.xyz * max(Light.ambient.w + min(1., vcolor.r / 8.), 0.0);
  vec3 diffuse = getDirectLighting(position.xyz, normal.rgb, toon, shininess, vcolor.r);


  // diffuse -= shadow;
  o_diffuse.rgb = (ambient + diffuse) * albedo.rgb;

  #ifdef USE_LIGHTS_POINT
    // Point "scene" lighting
    for (int j = 0; j < LIGHTS_POINT_MAX; j++) {
      vec3 pointDiffuse = getPointLighting(pointLight[j], position.xyz, normal.rgb, toon, shininess);
      // threshold minimum light otherwise black texture never gets lit
      o_diffuse.rgb += max(vec3(.1 * normal.b), albedo.rgb) * pointDiffuse * albedo.a;
    }
  #endif


  if (toon > 0.) {
    o_diffuse.rgb = toonShading(
      o_diffuse.rgb, 12u, fCoord,
      tNormal,
      tDepth,
      cameraNear, cameraFar,
      0.15f, 0.0001f,
      .3f, 1.8f,
      vec3(0., 0., 0.),
      6.0f * toon
    );
  }

  gColor.rgb = o_diffuse.rgb;

  #ifdef DEBUG_DIFFUSE
    if (vUv.y < .333) {
      if (vUv.x < .333) {
        vec2 uvd =  vUv * vec2(3., 3.) - vec2(0., 0.);
        float d = readDepthFrag(texture(tDepth, uvd).x, cameraNear, cameraFar);
        gColor.rgb = vec3(d);
      } else if (vUv.x < .666) {
        gColor.rgb = vec3(texture(tNormal, vUv * vec2(3., 3.) - vec2(1., 0.)).a);
      } else {
        gColor.rgb = vec3(texture(tPosition, vUv * vec2(3., 3.) - vec2(2., 0.)).a);
      }
    } else if (vUv.y < .666) {
      if (vUv.x < .333) {
        gColor.rgb = vec3(texture(tVColor, vUv * vec2(3., 3.) - vec2(0., 1.)).r, 0., 0.);
      } else if (vUv.x < .666) {
        gColor.rgb = o_diffuse.rgb;
      } else {
        gColor.rgb = vec3(0., texture(tVColor, vUv * vec2(3., 3.) - vec2(2., 1.)).g, 0.);
      }
    } else {
      if (vUv.x < .333) {
        vec2 uvd = vUv * vec2(3., 3.) - vec2(0., 2.);
        gColor.rgb = texture(tDiffuse, uvd).rgb;
      } else if (vUv.x < .666) {
        vec2 uvd = vUv * vec2(3., 3.) - vec2(1., 2.);
        gColor.rgb = texture(tNormal, uvd).rgb;
      } else {
        vec2 uvd = vUv * vec2(3., 3.) - vec2(2., 2.);
        gColor.rgb = texture(tPosition, uvd).rgb;
      }
    }
  #endif

  // gColor.rgb = deferred.rrr;
  // gColor.rgb = vcolor.rgb;
  gColor.a = 1.;
}
`, zl = `
out vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = vec4(position, 1.0);
}
`;
const Fl = /* @__PURE__ */ W({ uRes: new n.Vector2(), cameraNear: 0.1, debugMRT: 0, cameraFar: 3e3, tDepth: null, tDiffuse: null, tBright: null, tPosition: null, tVColor: null, tNormal: null, tDeferredData: null }, zl, Ll, (e) => {
  Object.defineProperty(e, "pointsLightsCnt", { get() {
    return e.defines.LIGHTS_POINT_MAX;
  }, set(t) {
    const { commonUbo: a, lightData: i, pointsLightData: r } = /* @__PURE__ */ Dt();
    e.defines.USE_LIGHTS_POINT = t > 0, e.defines.LIGHTS_POINT_MAX = t;
    const l = [a, i];
    t > 0 && l.push(r), e.uniformsGroups = l;
  } }), e.pointsLightsCnt = 0, e.glslVersion = n.GLSL3;
});
class Nl extends he {
  constructor(t, a, i, r) {
    super("DeferredEffectPass"), this.inputScene = t, this.camera = a, this.useBloom = i, this.useSSAO = r, this.fboMRT = new n.WebGLMultipleRenderTargets(512, 512, this.useBloom || r ? 4 : 3, { type: n.HalfFloatType }), this.fboMRT.depthTexture = new n.DepthTexture(512, 512), this.fboMRT.depthTexture.type = n.FloatType, this.fboMRT.texture[0].generateMipmaps = false, this.fboMRT.texture[0].type = n.HalfFloatType, this.fboMRT.texture[0].name = "texture_diffuse", this.fboMRT.texture[1].generateMipmaps = false, this.fboMRT.texture[1].type = n.FloatType, this.fboMRT.texture[1].name = "texture_position", this.fboMRT.texture[2].generateMipmaps = false, this.fboMRT.texture[2].type = n.FloatType, this.fboMRT.texture[2].name = "texture_normal", (this.useBloom || this.useSSAO) && (this.fboMRT.texture[3].generateMipmaps = false, this.fboMRT.texture[3].type = n.HalfFloatType, this.fboMRT.texture[3].name = "texture_vcolor"), this.fboDeferred = new n.WebGLRenderTarget(512, 512, { samples: 0, type: n.HalfFloatType, depthBuffer: false, stencilBuffer: false }), this.fullscreenMaterial = new Fl(), this.fullscreenMaterial.tDepth = this.fboMRT.depthTexture, this.fullscreenMaterial.tDiffuse = this.fboMRT.texture[0], this.fullscreenMaterial.tPosition = this.fboMRT.texture[1], this.fullscreenMaterial.tNormal = this.fboMRT.texture[2], this.fullscreenMaterial.tVColor = this.fboMRT.texture[3];
  }
  get debug() {
    return !!this.fullscreenMaterial.debugMRT;
  }
  set debug(t) {
    this.fullscreenMaterial.debugMRT = t ? 1 : 0;
  }
  get pointsLightsCnt() {
    return this.fullscreenMaterial.pointsLightsCnt;
  }
  set pointsLightsCnt(t) {
    this.fullscreenMaterial.pointsLightsCnt = t;
  }
  setSize(t, a) {
    this.fboMRT.setSize(t, a), this.fboDeferred.setSize(t, a), this.fullscreenMaterial.uRes.set(t, a);
  }
  render(t, a, i, r) {
    t.clear(), t.setRenderTarget(this.fboMRT), t.render(this.inputScene, this.camera), this.fullscreenMaterial.cameraNear = this.camera.near, this.fullscreenMaterial.cameraFar = this.camera.far, this.fullscreenMaterial.tDiffuse = this.fboMRT.texture[0], t.setRenderTarget(this.fboDeferred), t.render(this.scene, this.camera), this.inputDiffuse.current = this.fboDeferred.texture, this.inputDepth.current = this.fboMRT.depthTexture, this.inputBloom.current = this.useBloom || this.useSSAO ? this.fboMRT.texture[3] : null, this.inputVColor.current = this.useBloom || this.useSSAO ? this.fboMRT.texture[3] : null;
  }
  dispose() {
    this.fboMRT.dispose(), this.fboDeferred.dispose(), this.fullscreenMaterial.dispose();
  }
}
N({ DeferredEffectPass: Nl }), be({ key: n.MathUtils.generateUUID() });
function Ol() {
  const e = /* @__PURE__ */ I(), [t, a, i, r, l] = /* @__PURE__ */ $e((p) => [p.composer, p.inputDepth, p.inputDiffuse, p.inputBloom, p.inputVColor]), s = /* @__PURE__ */ Ie((p) => p.pointsLightsCnt), [o, f, d, c] = /* @__PURE__ */ Y((p) => [p.useBloom, p.useSSAO, p.bloom, p.debug]), u = /* @__PURE__ */ U((p) => p.scene), m = /* @__PURE__ */ U((p) => p.camera);
  return q(({ gl: p }, g) => {
    e.current.render(p, t.outputBuffer, t.inputBuffer, g);
  }, z.renderPriority.render), y("deferredEffectPass", { ref: e, enabled: false, args: [u, m, o && d > 0, f], attach: (p, g) => (p.addPass(g), be({ tPosition: g.fboMRT.texture[1], tNormal: g.fboMRT.texture[2] }), () => p.removePass(g)), pointsLightsCnt: s, debug: c, inputDiffuse: i, inputDepth: a, inputBloom: r, inputVColor: l });
}
class Gl extends he {
  constructor(t, a, i, r, l, s, o, f, d) {
    super("ForwardEffectPass"), this.inputScene = t, this.camera = a, this.inputDiffuse = i, this.inputDepth = r, this.inputBloom = l, this.inputVColor = s, this.useBloom = o, this.useSSAO = f, this.samples = d, o || f ? this.fbo = new n.WebGLMultipleRenderTargets(512, 512, 2, { samples: this.samples, generateMipmaps: true, type: n.HalfFloatType }) : this.fbo = new n.WebGLRenderTarget(512, 512, { samples: this.samples, generateMipmaps: true, type: n.HalfFloatType }), this.fbo.depthTexture = new n.DepthTexture(512, 512, n.FloatType), this.inputDepth.current = this.fbo.depthTexture;
  }
  setSize(t, a) {
    this.fbo.setSize(t, a);
  }
  render(t, a, i, r) {
    t.clear(), t.setRenderTarget(this.fbo), t.render(this.inputScene, this.camera), this.inputDiffuse.current = this.useBloom || this.useSSAO ? this.fbo.texture[0] : this.fbo.texture, this.inputBloom.current = this.useBloom || this.useSSAO ? this.fbo.texture[1] : null, this.inputVColor.current = this.useBloom || this.useSSAO ? this.fbo.texture[1] : null;
  }
  dispose() {
    this.fbo.dispose();
  }
}
N({ ForwardEffectPass: Gl }), be({ key: n.MathUtils.generateUUID() });
function Hl() {
  const e = /* @__PURE__ */ I(), t = /* @__PURE__ */ U((m) => m.scene), a = /* @__PURE__ */ U((m) => m.camera), [i, r, l, s, o] = /* @__PURE__ */ $e((m) => [m.composer, m.inputDepth, m.inputDiffuse, m.inputBloom, m.inputVColor]), [f, d, c, u] = /* @__PURE__ */ Y((m) => [m.useBloom, m.useSSAO, m.bloom, m.samples]);
  return q(({ gl: m }, p) => {
    e.current.render(m, i.outputBuffer, i.inputBuffer, p);
  }, z.renderPriority.render), y("forwardEffectPass", { ref: e, enabled: false, args: [t, a, l, r, s, o, f && c > 0, d, u], attach: (m, p) => (m.addPass(p), () => m.removePass(p)) });
}
var Vl = `layout(location = 0) out vec4 gVColor;

uniform sampler2D tDiffuse;
uniform sampler2D tSelective;

#ifdef USE_GLOBALBLOOM
  uniform float uThreshold;
  uniform float uSmoothing;
#endif

in vec2 vUv;

#include <common>

void main() {
  // Filter from gBuffer input, fallback to luminance
  vec4 texel = texture(tDiffuse, vUv);
  float intensity = texture(tSelective, vUv).r;

  #ifdef USE_GLOBALBLOOM
    if (intensity <= 0.0) {
      intensity = smoothstep(uThreshold, uThreshold + uSmoothing, luminance(texel.rgb));
    }
  #endif

  gVColor = vec4(texel.rgb * intensity, 1.0);
}
`, Wl = `out vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = vec4(position, 1);
}
`;
class jl extends Re {
  constructor(t) {
    super({ glslVersion: Oi, defines: { USE_GLOBALBLOOM: t }, uniforms: { tDiffuse: new K(null), tSelective: new K(null), uThreshold: new K(0.9), uSmoothing: new K(0.025) }, vertexShader: Wl, fragmentShader: Vl, blending: qe });
  }
}
class Ql extends he {
  constructor(t = 2, a) {
    super("BloomEffectPass"), this.mipmapBlurPass = new Ms(), this.mipmapBlurPass.levels = t, this.fullscreenMaterial = this.luminanceMaterial = new jl(a);
  }
  set strength(t) {
    this.mipmapBlurPass.strength = t;
  }
  set radius(t) {
    this.mipmapBlurPass.radius = t;
  }
  set threshold(t) {
    this.luminanceMaterial.uniforms.uThreshold.value = t;
  }
  set smoothing(t) {
    this.luminanceMaterial.uniforms.uSmoothing.value = t;
  }
  initialize(t, a, i) {
    this.mipmapBlurPass.initialize(t, a, i);
  }
  setSize(t, a) {
    this.mipmapBlurPass.setSize(t, a);
  }
  render(t, a, i) {
    const { inputDiffuse: r, inputBloom: l } = /* @__PURE__ */ na();
    this.luminanceMaterial.uniforms.tDiffuse.value = r.current, this.luminanceMaterial.uniforms.tSelective.value = l.current, t.setRenderTarget(i), t.render(this.scene, this.camera), this.mipmapBlurPass.render(t, i, a), l.current = this.mipmapBlurPass.texture;
  }
  dispose() {
    this.mipmapBlurPass.dispose();
  }
}
N({ BloomEffectPass: Ql }), be({ key: n.MathUtils.generateUUID() });
function Yl({ strength: e = 0.5, radius: t = 0.7 }) {
  const [a, i, r, l] = /* @__PURE__ */ Y((s) => [s.bloom, s.bloomThreshold, s.bloomSmoothing, s.useGlobalBloom]);
  return a > 0 && y("bloomEffectPass", { args: [a, l], attach: (s, o) => (s.addPass(o), () => s.removePass(o)), strength: e, radius: t, threshold: i, smoothing: r });
}
const ql = new n.Vector2();
class Xl extends Ss {
  constructor(t) {
    super(t, new gl()), this.blitMaterial = new n.ShaderMaterial({ uniforms: { tDiffuse: { value: null } }, vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1.0);
        }
      `, fragmentShader: `
        uniform sampler2D tDiffuse;
        varying vec2 vUv;

        void main() {
          gl_FragColor = texture(tDiffuse, vUv);
        }
      ` });
  }
  get preset() {
    return this._preset;
  }
  set preset(t) {
    this._preset = t, this.effects[0].applyPreset(t);
  }
  blit(t, a) {
    const i = this.fullscreenMaterial;
    t.setRenderTarget(a), this.fullscreenMaterial = this.blitMaterial, this.fullscreenMaterial.uniforms.tDiffuse.value = this.inputDiffuse.current, t.render(this.scene, this.camera), this.fullscreenMaterial = i;
  }
  render(t, ...a) {
    this.blit(t, ...a), super.render(t, ...a), t.copyFramebufferToTexture(ql, this.inputDiffuse.current, 0);
  }
  dispose() {
    super.dispose(), this.blitMaterial.dispose();
  }
}
N({ SMAAEffectPass: Xl }), be({ key: n.MathUtils.generateUUID() });
function Kl() {
  const e = /* @__PURE__ */ U((i) => i.camera), t = /* @__PURE__ */ Y((i) => i.aa), a = /* @__PURE__ */ $e((i) => i.inputDiffuse);
  return y("sMAAEffectPass", { args: [e], attach: (i, r) => (i.addPass(r), () => i.removePass(r)), preset: t, inputDiffuse: a });
}
class Zl extends he {
  constructor(t = 16) {
    super("SSAOEffectPass"), this.skipShadowMapUpdate = true, this.ignoreBackground = true, this.effectMaterial = new $l(t), this.compositeMaterial = new ef(t / 4);
  }
  get debug() {
    return this.compositeMaterial.defines.DEBUG;
  }
  set debug(t) {
    this.compositeMaterial.defines.DEBUG = t, this.compositeMaterial.dispose();
  }
  set intensity(t) {
    this.compositeMaterial.uniforms.intensity.value = t;
  }
  set radius(t) {
    this.effectMaterial.uniforms.radius.value = t;
  }
  set noiseRadius(t) {
    this.compositeMaterial.uniforms.radius.value = t;
  }
  setSize(t, a) {
    this.effectMaterial.uniforms.resolution.value.set(t, a), this.compositeMaterial.uniforms.resolution.value.set(t, a);
  }
  render(t, a, i, r) {
    const { inputDiffuse: l, inputVColor: s, inputDepth: o } = /* @__PURE__ */ na();
    this.effectMaterial.uniforms.sceneDepth.value = o.current, this.effectMaterial.uniforms.sceneVColor.value = s.current, this.effectMaterial.uniforms.projViewMat.value.copy(this.camera.projectionMatrix).multiply(this.camera.matrixWorldInverse), this.effectMaterial.uniforms.projectionMatrixInv.value = this.camera.projectionMatrixInverse, this.effectMaterial.uniforms.viewMatrixInv.value = this.camera.matrixWorld, this.effectMaterial.uniforms.time.value += r, this.effectMaterial.uniforms.frame.value++, this.effectMaterial.uniforms.cameraNear.value = this.camera.near, this.effectMaterial.uniforms.cameraFar.value = this.camera.far, this.fullscreenMaterial = this.effectMaterial, t.setRenderTarget(i), t.clear(), t.render(this.scene, this.camera), this.compositeMaterial.uniforms.sceneDepth.value = o.current, this.compositeMaterial.uniforms.cameraNear.value = this.camera.near, this.compositeMaterial.uniforms.cameraFar.value = this.camera.far, this.compositeMaterial.uniforms.tDiffuse.value = i.texture, this.compositeMaterial.uniforms.sceneDiffuse.value = l.current, this.fullscreenMaterial = this.compositeMaterial, t.setRenderTarget(a), t.clear(), t.render(this.scene, this.camera), l.current = a.texture, this.needsSwap = false;
  }
  dispose() {
    super.dispose(), this.effectMaterial.dispose(), this.compositeMaterial.dispose();
  }
}
N({ SSAOEffectPass: Zl }), be({ key: n.MathUtils.generateUUID() });
function Jl({ samples: e }) {
  const t = /* @__PURE__ */ U((s) => s.camera), a = /* @__PURE__ */ Y((s) => s.debug), i = /* @__PURE__ */ Y((s) => s.aoIntensity), r = /* @__PURE__ */ Y((s) => s.aoRadius), l = /* @__PURE__ */ Y((s) => s.aoNoiseRadius);
  return y("sSAOEffectPass", { args: [e], intensity: i || 0.5, radius: r || 5, noiseRadius: l || 12, attach: (s, o) => (s.addPass(o), () => s.removePass(o)), camera: t, debug: a });
}
class $l extends n.ShaderMaterial {
  constructor(t = 16) {
    super({ defines: { SAMPLES: `${t}.0` }, uniforms: { sceneDepth: { value: null }, sceneVColor: { value: null }, projViewMat: { value: new n.Matrix4() }, projectionMatrixInv: { value: new n.Matrix4() }, viewMatrixInv: { value: new n.Matrix4() }, resolution: { value: new n.Vector2() }, time: { value: 0 }, frame: { value: -1 }, radius: { value: 5 }, cameraNear: { value: 0.1 }, cameraFar: { value: 1e3 } }, vertexShader: `
        out vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1);
        }
      `, fragmentShader: `
        uniform sampler2D sceneDepth;
        uniform sampler2D sceneVColor;
        uniform mat4 projectionMatrixInv;
        uniform mat4 viewMatrixInv;
        uniform mat4 projViewMat;
        uniform vec2 resolution;
        uniform float time;
        uniform float frame;
        uniform float radius;
        uniform float cameraNear;
        uniform float cameraFar;
        in vec2 vUv;

        #include <common>
        #include <packing>

        const int HAMMERSLEY_SAMPLES = 16;
        const vec3 HAMMERSLEY_KERNEL[HAMMERSLEY_SAMPLES] = vec3[HAMMERSLEY_SAMPLES]( 
          vec3(0.1767766952966369, 0, 0.9842509842514764),
          vec3(-0.22577214042372534, 0.2068258702592343, 0.9519716382329886),
          vec3(0.034557871103510586, -0.3937711944070988, 0.9185586535436918),
          vec3(0.284571475629725, 0.37117256802991355, 0.8838834764831844),
          vec3(-0.5222232721278168, -0.09237344882657603, 0.8477912478906586),
          vec3(0.4946950300670119, -0.31468528282555297, 0.8100925873009825),
          vec3(-0.16546507864064025, 0.6155252291746023, 0.7705517503711221),
          vec3(-0.31556244500763, -0.607593896694829, 0.7288689868556626),
          vec3(0.6846426210953952, 0.25002896108176564, 0.6846531968814576),
          vec3(-0.7122554783476936, 0.2940104310457334, 0.6373774391990983),
          vec3(0.34335281315973815, -0.7337294090434797, 0.5863019699779286),
          vec3(0.25373228509386936, 0.8089313490655702, 0.5303300858899106),
          vec3(-0.7647471137159311, -0.44318376782453683, 0.46770717334674244),
          vec3(0.8971333945395349, -0.19723506889488845, 0.39528470752104716),
          vec3(-0.5475044001631867, 0.7787739927616671, 0.30618621784789724),
          vec3(-0.12649013645731044, -0.9760892609690012, 0.1767766952966372)
        );

        // Interleaved gradient noise
        // https://blog.demofox.org/2022/01/01/interleaved-gradient-noise-a-different-kind-of-low-discrepancy-sequence/
        float IGN(vec2 uv) {
          vec3 magic = vec3(0.06711056, 0.00583715, 52.9829189);
          return fract(fract(dot(uv, magic.xy)) * magic.z);
        }
        vec4 IGN4(vec2 uv) {
          return vec4(
            IGN(uv + vec2(0, 0)),
            IGN(uv + vec2(1, 0)),
            IGN(uv + vec2(0, 1)),
            IGN(uv + vec2(1, 1))
          );
        }

        // Calculates the view-space position
        vec3 getPosition(const float depth, const vec2 uv) {
          vec4 position = viewMatrixInv * projectionMatrixInv * vec4(vec3(uv, depth) * 2.0 - 1.0, 1.0);
          return position.xyz / position.w;
        }

        // Calculates the view-space normal
        vec3 getNormal(const vec3 position, const vec2 uv) {
          vec2 uvx = uv + vec2(1.0 / resolution.x, 0.0);
          vec2 uvy = uv + vec2(0.0, 1.0 / resolution.y);

          vec3 vertical = getPosition(textureLod(sceneDepth, uvx, 0.0).r, uvx);
          vec3 horizontal = getPosition(textureLod(sceneDepth, uvy, 0.0).r, uvy);

          return -normalize(cross(horizontal - position, vertical - position));
        }

        void main() {
          float depth = texture(sceneDepth, vUv).r;

          // Filter out high-pass background, selective SSAO
          float receiveSSAO = texture(sceneVColor, vUv).g;
          if (depth == 1.0) discard;

          // Precompute fragment data
          vec3 position = getPosition(depth, vUv);
          vec3 normal = getNormal(position, vUv);
          vec4 noise = IGN4(vUv * resolution + frame * 5.588238);

          // Gram Schmidt orthonormalization
          vec3 random = normalize(noise.rgb * 2.0 - 1.0);
          vec3 tangent = normalize(random - normal * dot(random, normal));
          vec3 bitangent = cross(normal, tangent);
          mat3 tbn = mat3(tangent, bitangent, normal);

          // Calculate occlusion factor
          float occlusion = 0.0;
          float totalWeight = 0.0;
          for (float i = 0.0; i < SAMPLES; i++) {
            // Tangent-space sample point
            vec3 sampleDirection = tbn * HAMMERSLEY_KERNEL[int(i) % HAMMERSLEY_SAMPLES];

            // Offset sample point
            float jitter = (mod(i + noise.a * SAMPLES, SAMPLES) + 1.0) / SAMPLES;
            vec3 samplePosition = position + radius * jitter * sampleDirection;

            // Convert from view-space to clip-space in [0-1]
            vec4 offset = projViewMat * vec4(samplePosition, 1.0);
            offset.xyz /= offset.w;
            offset.xyz = offset.xyz * 0.5 + 0.5;

            // Linear sample & world distance
            float sampleDepth = textureLod(sceneDepth, offset.xy, 0.0).r;
            float distSample = -perspectiveDepthToViewZ(sampleDepth, cameraNear, cameraFar);
            float distWorld = -perspectiveDepthToViewZ(offset.z, cameraNear, cameraFar);

            // Range check & accumulate
            float rangeCheck = smoothstep(0.0, 1.0, radius / (radius * abs(distSample - distWorld)));
            float weight = dot(sampleDirection, normal);
            occlusion += rangeCheck * weight * (distSample < distWorld ? 1.0 : 0.0);
            totalWeight += weight;
          }
          occlusion /= totalWeight;

          gl_FragColor = vec4(0.5 + 0.5 * normal, 1.0 - occlusion);
        }
      ` });
  }
}
class ef extends n.ShaderMaterial {
  constructor(t = 4) {
    super({ defines: { SAMPLES: String(t), DEBUG: false }, uniforms: { sceneDiffuse: { value: null }, sceneDepth: { value: null }, tDiffuse: { value: null }, resolution: { value: new n.Vector2() }, radius: { value: 12 }, intensity: { value: 0.5 }, cameraNear: { value: 0.1 }, cameraFar: { value: 1e3 } }, vertexShader: `
        out vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1);
        }
      `, fragmentShader: `
        uniform sampler2D sceneDiffuse;
        uniform sampler2D sceneDepth;
        uniform sampler2D tDiffuse;
        uniform vec2 resolution;
        uniform float radius;
        uniform float intensity;
        uniform float cameraNear;
        uniform float cameraFar;
        in vec2 vUv;

        const int POISSON_SAMPLES = 16;
        const vec2 POISSON_KERNEL[POISSON_SAMPLES] = vec2[]( 
          vec2(-0.94201624, -0.39906216), 
          vec2(0.94558609, -0.76890725), 
          vec2(-0.094184101, -0.92938870), 
          vec2(0.34495938, 0.29387760), 
          vec2(-0.91588581, 0.45771432), 
          vec2(-0.81544232, -0.87912464), 
          vec2(-0.38277543, 0.27676845), 
          vec2(0.97484398, 0.75648379), 
          vec2(0.44323325, -0.97511554), 
          vec2(0.53742981, -0.47373420), 
          vec2(-0.26496911, -0.41893023), 
          vec2(0.79197514, 0.19090188), 
          vec2(-0.24188840, 0.99706507), 
          vec2(-0.81409955, 0.91437590), 
          vec2(0.19984126, 0.78641367), 
          vec2(0.14383161, -0.14100790) 
        );

        #include <common>
        #include <packing>

        void main() {
          vec4 data = texture(tDiffuse, vUv);
          vec3 normal = data.rgb * 2.0 - 1.0;
          float occlusion = data.a;
          float baseOcc = occlusion;

          float d = texture(sceneDepth, vUv).x;
          float depth = perspectiveDepthToViewZ(d, cameraNear, cameraFar);

          float count = 1.0;
          for (int i = 0; i < SAMPLES; i++) {
            vec2 offset = POISSON_KERNEL[i % POISSON_SAMPLES] * radius / resolution;
            vec4 dataSample = texture(tDiffuse, vUv + offset);
            float occSample = dataSample.a;
            vec3 normalSample = dataSample.rgb * 2.0 - 1.0;
            float dSample = texture(sceneDepth, vUv + offset).x;
            float depthSample = perspectiveDepthToViewZ(dSample, cameraNear, cameraFar);

            float rangeCheck = exp(-1.0 * 1.0 * abs(depthSample - depth)) * (0.5 + 0.5 * dot(normal, normalSample)) * (1.0 - abs(occSample - baseOcc));
            occlusion += occSample * rangeCheck;
            count += rangeCheck;
          }
          occlusion = pow(occlusion / count, intensity);

          #if defined(DEBUG_DIFFUSE) && defined(USE_DEFERRED)
            gl_FragColor = vec4(texture(sceneDiffuse, vUv).rgb, 1.0);
          #elif defined(DEBUG)
              gl_FragColor = vec4(vec3(occlusion), 1.0);
          #else
            gl_FragColor = vec4(texture(sceneDiffuse, vUv).rgb * occlusion, 1.0);
          #endif
        }
      ` });
  }
}
new n.Frustum(), new n.Matrix4(), N({ EffectComposer: Ts });
const tf = () => {
  const [e, t, a, i, r, l, s, o, f] = /* @__PURE__ */ Y((_) => [_.paused, _.useSSAO, _.useComposer, _.useDeferred, _.useBloom, _.useGlobalBloom, _.bloom, _.ssao, _.samples]), d = /* @__PURE__ */ ra((_) => _.startCanvasLoop), [c, u] = /* @__PURE__ */ $e((_) => [_.key, _.composer]), m = /* @__PURE__ */ U((_) => _.gl), { width: p, height: g } = /* @__PURE__ */ U((_) => _.size);
  ie(() => void u?.setSize(p, g), [u, p, g]);
  const [h, C] = /* @__PURE__ */ ve(false);
  return q(function({ gl: x }) {
    C(x.xr.isPresenting);
  }, z.renderPriority.frustum), ie(() => Ve({ canvasLoopReady: true }), []), q(function({ gl: x, scene: b, camera: w }, P) {
    if (d && !e)
      if (u && !x.xr.isPresenting) {
        const S = x.xr.enabled;
        x.xr.enabled = false, u.render(P), x.xr.enabled = S;
      } else
        x.xr.isPresenting || x.setRenderTarget(null), x.render(b, w);
  }, z.renderPriority.postprocess), y(te, { children: a ? y("effectComposer", { args: [m], multisampling: f, attach: (_, x) => (be({ composer: x }), () => be({ composer: null })), children: u && !h ? H(de, { fallback: null, children: [i ? y(Ol, {}) : y(Hl, {}), i && f > 0 ? y(Kl, {}) : null, t && o ? y(Jl, {}) : null, r && s > 0 ? y(Yl, {}) : null, y(Il, {})] }, [c, i, t, o, r, l, s, f].join("-")) : null }) : null });
};
function af() {
  n.ShaderChunk.uv_pars_vertex = `

#ifdef USE_PAINT
out vec2 vUvPaint;
	#ifndef USE_UV1
	in vec2 uv1;
	#endif
#endif

	#ifdef USE_UV

	varying vec2 vUv;

#endif
#ifdef USE_MAP

	uniform mat3 mapTransform;
	varying vec2 vMapUv;

#endif
#ifdef USE_ALPHAMAP

	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;

#endif
#ifdef USE_LIGHTMAP

	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;

#endif
#ifdef USE_AOMAP

	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;

#endif
#ifdef USE_BUMPMAP

	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;

#endif
#ifdef USE_NORMALMAP

	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;

#endif
#ifdef USE_DISPLACEMENTMAP

	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;

#endif
#ifdef USE_EMISSIVEMAP

	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;

#endif
#ifdef USE_METALNESSMAP

	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;

#endif
#ifdef USE_ROUGHNESSMAP

	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;

#endif
#ifdef USE_ANISOTROPYMAP

	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;

#endif
#ifdef USE_CLEARCOATMAP

	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;

#endif
#ifdef USE_CLEARCOAT_NORMALMAP

	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;

#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP

	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;

#endif
#ifdef USE_SHEEN_COLORMAP

	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;

#endif
#ifdef USE_SHEEN_ROUGHNESSMAP

	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;

#endif
#ifdef USE_IRIDESCENCEMAP

	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;

#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP

	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;

#endif
#ifdef USE_SPECULARMAP

	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;

#endif
#ifdef USE_SPECULAR_COLORMAP

	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;

#endif
#ifdef USE_SPECULAR_INTENSITYMAP

	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;

#endif
// #ifdef USE_TRANSMISSIONMAP

// 	uniform mat3 transmissionMapTransform;
// 	varying vec2 vTransmissionMapUv;

// #endif
#ifdef USE_THICKNESSMAP

	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;

#endif
	`, n.ShaderChunk.common = `
#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6

#ifndef saturate
// <tonemapping_pars_fragment> may have defined saturate() already
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )

float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }

// expects values in the range of [0,1]x[0,1], returns values in the [0,1] range.
// do not collapse into a single function per: http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/
highp float rand( const in vec2 uv ) {

	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );

	return fract( sin( sn ) * c );

}

#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif

struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};

struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};

struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};

vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

}

vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {

	// dir can be either a direction vector or a normal vector
	// upper-left 3x3 of matrix is assumed to be orthogonal

	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );

}

mat3 transposeMat3( const in mat3 m ) {

	mat3 tmp;

	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );

	return tmp;

}

float luminance( const in vec3 rgb ) {

	// assumes rgb is in linear color space with sRGB primaries and D65 white point

	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );

	return dot( weights, rgb );

}

bool isPerspectiveMatrix( mat4 m ) {

	return m[ 2 ][ 3 ] == - 1.0;

}

vec2 equirectUv( in vec3 dir ) {

	// dir is assumed to be unit length

	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;

	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;

	return vec2( u, v );

}

vec3 BRDF_Lambert( const in vec3 diffuseColor ) {

	return RECIPROCAL_PI * diffuseColor;

} // validated

vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {

	// Original approximation by Christophe Schlick '94
	// float fresnel = pow( 1.0 - dotVH, 5.0 );

	// Optimized variant (presented by Epic at SIGGRAPH '13)
	// https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );

	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );

} // validated

float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {

	// Original approximation by Christophe Schlick '94
	// float fresnel = pow( 1.0 - dotVH, 5.0 );

	// Optimized variant (presented by Epic at SIGGRAPH '13)
	// https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );

	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );

} // validated

  #ifdef USE_PARTICLE_INSTANCE
    in vec3 a_offset;
    in vec3 a_rotation;
    in vec3 a_scale;
    in float a_life;
    in float a_age;


    mat4 rotation3d(vec3 axis, float angle) {
      axis = normalize(axis);
      float s = sin(angle);
      float c = cos(angle);
      float oc = 1.0 - c;

      return mat4(
        oc * axis.x * axis.x + c,           oc * axis.x * axis.y - axis.z * s,  oc * axis.z * axis.x + axis.y * s,  0.0,
        oc * axis.x * axis.y + axis.z * s,  oc * axis.y * axis.y + c,           oc * axis.y * axis.z - axis.x * s,  0.0,
        oc * axis.z * axis.x - axis.y * s,  oc * axis.y * axis.z + axis.x * s,  oc * axis.z * axis.z + c,           0.0,
        0.0,                                0.0,                                0.0,                                1.0
      );
    }
  
    float degToRad(float deg) {
      return deg * PI / 180.0;
    }
  #endif

`, n.ShaderChunk.begin_vertex = `
vec3 transformed = vec3( position );


#ifdef USE_PAINT
	vUvPaint = uv1;
	#ifdef FLIP_UV
	vUvPaint.y = 1.0 - vUvPaint.y; // To flip the UVs along the V axis
	#endif
#endif 

#ifdef USE_PARTICLE_INSTANCE
vec4 transformedParticle = vec4( position, 1.0 );

float ratio = 1.;
// over time
// float ratio = 1. - (a_age / a_life);
// Translate
mat4 tPos = mat4(vec4(1.0,0.0,0.0,0.0),
                vec4(0.0,1.0,0.0,0.0),
                vec4(0.0,0.0,1.0,0.0),
                vec4(a_offset,1.0));

// Rotate
mat4 rXPos = mat4(vec4(1.0,0.0,0.0,0.0),
                  vec4(0.0,cos(degToRad(a_rotation.x)),-sin(degToRad(a_rotation.x)),0.0),
                  vec4(0.0,sin(degToRad(a_rotation.x)),cos(degToRad(a_rotation.x)),0.0),
                  vec4(0.0,0.0,0.0,1.0));

mat4 rYPos = mat4(vec4(cos(degToRad(a_rotation.y)),0.0,sin(degToRad(a_rotation.y)),0.0),
                  vec4(0.0,1.0,0.0,0.0),
                  vec4(-sin(degToRad(a_rotation.y)),0.0,cos(degToRad(a_rotation.y)),0.0),
                  vec4(0.0,0.0,0.0,1.0));

mat4 rZPos = mat4(vec4(cos(degToRad(a_rotation.z)),-sin(degToRad(a_rotation.z)),0.0,0.0),
                  vec4(sin(degToRad(a_rotation.z)),cos(degToRad(a_rotation.z)),0.0,0.0),
                  vec4(0.0,0.0,1.0,0.0),
                  vec4(0.0,0.0,0.0,1.0));

// Scale
mat4 sPos = mat4(vec4(a_scale.x * ratio,0.0,0.0,0.0),
                  vec4(0.0,a_scale.y * ratio,0.0,0.0),
                  vec4(0.0,0.0,a_scale.z * ratio,0.0),
                  vec4(0.0,0.0,0.0,1.0));

mat4 vPosition = tPos * rXPos * rZPos * rYPos * sPos;
  

transformed = (transformedParticle * rXPos * rZPos * rYPos * sPos).xyz;

transformed += a_offset;

#endif
`;
}
function nf() {
  n.MeshStandardMaterial.prototype.glslVersion = n.GLSL3, n.MeshBasicMaterial.prototype.glslVersion = n.GLSL3, n.MeshNormalMaterial.prototype.glslVersion = n.GLSL3, n.MeshPhongMaterial.prototype.glslVersion = n.GLSL3, n.MeshPhysicalMaterial.prototype.glslVersion = n.GLSL3, n.LineBasicMaterial.prototype.glslVersion = n.GLSL3, n.PointsMaterial.prototype.glslVersion = n.GLSL3, n.MeshStandardMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `), e.vertexShader = `
    out vec3 vWorldPositionPatch;
    ${e.vertexShader}
  `, e.fragmentShader = `
    #include <layout_pars_fragment>
    in vec3 vWorldPositionPatch;
    ${e.fragmentShader}
  `, e.vertexShader = e.vertexShader.replace("#include <fog_vertex>", `
    #include <fog_vertex>
    vWorldPositionPatch = (modelMatrix * vec4( transformed, 1.0 )).xyz;
    `), e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(vWorldPositionPatch, 1.);
      vec4 o_normal = vec4(normal, 0.);
      #include <layout_output_fragment>
      `), e.fragmentShader = e.fragmentShader.replace("#include <lights_pars_begin>", ""), e.fragmentShader = e.fragmentShader.replace("#include <lights_physical_pars_fragment>", ""), e.fragmentShader = e.fragmentShader.replace("#include <lights_physical_fragment>", "");
  }, n.MeshBasicMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `), e.fragmentShader = `
      #include <layout_pars_fragment>
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(0.);
      vec4 o_normal = vec4(0.);
      #include <layout_output_fragment>
      `);
  }, n.MeshNormalMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `), e.fragmentShader = `
      #include <layout_pars_fragment>
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("gl_FragColor = vec4( packNormalToRGB( normal ), opacity );", `
      #include <fog_fragment>
      vec4 o_diffuse = vec4( packNormalToRGB( normal ), 1. );
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(0.);
      vec4 o_normal = vec4(  normal, 0.);
      #include <layout_output_fragment>
      `);
  }, n.MeshPhongMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = e.vertexShader.replace("#include <skinning_pars_vertex>", `
          #include <batching_pars_vertex>
          #include <batching_skinning_pars_vertex>

          #include <batching_pars_uniforms>
          `), e.vertexShader = e.vertexShader.replace("#include <skinnormal_vertex>", `
        #include <skinnormal_vertex>
        #include <batchingbase_vertex>

      `), e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `), e.fragmentShader = `
      #include <layout_pars_fragment>
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(0.);
      vec4 o_normal = vec4(normal, 1.);
      #include <layout_output_fragment>
      `), e.fragmentShader = e.fragmentShader.replace("#include <lights_pars_begin>", ""), e.fragmentShader = e.fragmentShader.replace("#include <lights_phong_pars_fragment>", "varying vec3 vViewPosition;"), e.fragmentShader = e.fragmentShader.replace("#include <lights_phong_fragment>", "");
  }, n.MeshDepthMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = e.vertexShader.replace("#include <skinning_pars_vertex>", `
      #include <skinning_pars_vertex>
      #include <batching_pars_vertex>
      #include <batching_skinning_pars_vertex>
      `), e.vertexShader = e.vertexShader.replace("#include <begin_vertex>", `
      #include <begin_vertex>
      #include <batchingbase_vertex>
      `), e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `);
  }, n.MeshPhysicalMaterial.prototype.onBeforeCompile = function(e) {
    e.vertexShader = `
      out vec3 vWorldPosition2;
      ${e.vertexShader}
    `, e.vertexShader = e.vertexShader.replace("#include <vertex_project>", `
      vec4 mvPosition = vec4( transformed, 1.0 );

      #ifdef USE_BATCHING
        mvPosition = batchingMatrix * mvPosition;
      #endif
      #ifdef USE_INSTANCING
      
        mvPosition = instanceMatrix * mvPosition;
      
      #endif
      
      mvPosition = modelViewMatrix * mvPosition;
      gl_Position = projectionMatrix * mvPosition;
      `), e.fragmentShader = `
      #include <layout_pars_fragment>
      in vec3 vWorldPosition2;
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(vWorldPosition2, 1.);
      vec4 o_normal = vec4(normal, 0.5);
      #include <layout_output_fragment>
      `), e.fragmentShader = e.fragmentShader.replace("#include <lights_pars_begin>", ""), e.fragmentShader = e.fragmentShader.replace("#include <lights_physical_pars_fragment>", ""), e.fragmentShader = e.fragmentShader.replace("#include <lights_physical_fragment>", "");
  }, n.LineBasicMaterial.prototype.onBeforeCompile = function(e) {
    e.fragmentShader = `
      #include <layout_pars_fragment>
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(0.);
      vec4 o_normal = vec4(0.);
      #include <layout_output_fragment>
      `);
  }, n.PointsMaterial.prototype.onBeforeCompile = function(e) {
    e.fragmentShader = `
      #include <layout_pars_fragment>
      ${e.fragmentShader}
    `, e.fragmentShader = e.fragmentShader.replace("#include <fog_fragment>", `
      #include <fog_fragment>
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_position = vec4(0.);
      vec4 o_normal = vec4(0.);
      #include <layout_output_fragment>
      `);
  };
}
var rf = `

in float vDitherDepth;
uniform mat4 modelViewMatrix;


float Bayer2(vec2 a) {
  a = floor(a);
  return fract(a.x / 2. + a.y * a.y * .75);
}

#define Bayer4(a)   (Bayer2 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer8(a)   (Bayer4 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer16(a)  (Bayer8 (.5 *(a)) * .25 + Bayer2(a))

bool shouldDiscard(vec3 worldPosition, vec3 playerPosition) {
    float radius = 1.;
    float objectRadius = 1.;
    vec3 objectPosition = playerPosition + vec3(0., .7, 0.);
    // Calculate the normalized view direction from the camera to the pixel's world position
    vec3 viewDirection = normalize(worldPosition - cameraPosition);

    // Calculate the point on the view direction line closest to the object position
    float t = dot(objectPosition - cameraPosition, viewDirection);
    vec3 pointOnViewDirection = cameraPosition + t * viewDirection;

    // Check if the pixel is within the specified radius of the object
    bool withinRadius = distance(pointOnViewDirection, objectPosition) <= radius;


    // float dither = smoothstep( 0., .1, distance(pointOnViewDirection, objectPosition) );

    // float dithered = Bayer4(gl_FragCoord.xy) * (1. + dither * 1.) - (1. - dither * 1.);


    // Check if the pixel is between the object position and the camera
    bool betweenCameraAndObject = t > 0.0 && t <  distance((modelViewMatrix * vec4(cameraPosition, 1.)).xyz, (modelViewMatrix * vec4(objectPosition, 1.)).xyz);

    // Check if the pixel is strictly inside the sphere
    bool insideObjectSphere = distance(worldPosition, objectPosition) <= objectRadius;

    float distWorldToCamera = distance(worldPosition, cameraPosition);
    float distObjectToCamera = distance(objectPosition, cameraPosition) + objectRadius;

    return !(distWorldToCamera > distObjectToCamera) && (withinRadius && betweenCameraAndObject) && !insideObjectSphere && worldPosition.y > 0.4;
}


`, of = `

#ifdef USE_ALPHATEST

  // #ifndef USE_DEFERRED
  // diffuseColor.a = (diffuseColor.a - alphaTest) / max(fwidth(diffuseColor.a), 0.0001) + 0.5;
  // #endif
  if (diffuseColor.a < alphaTest) discard;

#endif
`, sf = `out float vDitherDepth;
`, lf = `if (shouldDiscard(vWorldPosition, playerPos.xyz)) {
  discard;
}
`, ff = `vDitherDepth = - mvPosition.z;
`, cf = `

#ifdef USE_COMMON_UBO
vec3 introAnimation(float progress, float dist, float scale, vec3 color, vec4 normal, vec3 position, vec3 playerPos) {
  // vec3 tempN = normal.rgb;
  vec3 tempN = (normal.rgb * .5) + .4;
  float gray = 0.21 * tempN.r + 0.71 * tempN.g + 0.31 * tempN.b;
  // float animProgress = sin(time * 1.) * 0.5 + 0.5;
  float fw = fwidth(dist) * 0.5;

  float part1 = smoothstep(0.2, .5, progress) * scale;
  float part2 = smoothstep(0.25, .56, progress) * scale;
  float part3 = smoothstep(0.33, 1., progress) * scale;


  float smoothed = smoothstep( part1 - fw, part1 + fw, dist );
  float smoothedStep2 = smoothstep( part2 - fw, part2 + fw, dist );
  float smoothedStep3 = smoothstep( part3 - fw, part3 + fw, dist );


  // loading animation block

  // prevent emissive from being black
  if (length(normal.rgb) == 0.) gray = .9;

  color.rgb = mix(color.rgb, vec3(gray) * .4, smoothedStep3);
  color.rgb = mix(color.rgb, mix(vec3(gray), vec3(0.086,0.922,0.922), .5), smoothedStep2);

  color.rgb = mix(color.rgb, vec3(gray), smoothed);

  float prepart = smoothstep(0., .1, progress);
  float outpart = smoothstep(.6, .8, progress);
  float distEffectFactor = 1. - smoothstep(.0, 20., distance(position, playerPos.xyz));
  if (normal.a > 0.5 && progress < .99) {
    color.rgb = mix(color.rgb, vec3(gray), (prepart - outpart) * distEffectFactor);
  }

  return color;
}
#endif
`, df = `

float getShadowMask() {
  float shadow = 1.0;

  #ifdef USE_SHADOWMAP
  // #if NUM_DIR_LIGHT_SHADOWS > 0
  DirectionalLightShadow directionalLight;

  // #pragma unroll_loop_start
  // for (int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++) {
  directionalLight = directionalLightShadows[0];
  if (receiveShadow) {

    // float lightDotNormal = dot(vNormal, vDirectionalShadowCoord[ i ].xyz);

		// If the face is facing away from the light, return 0.0 (full shadow)
		// if (lightDotNormal <= 0.2) {
		// 	return 1.0;
		// }

    shadow *=
      getShadow(
        directionalShadowMap[0],
        directionalLight.shadowMapSize,
        directionalLight.shadowBias,
        directionalLight.shadowRadius,
        vDirectionalShadowCoord[0]
      ) *
      0.7;

    shadow +=
      getShadow(
        directionalShadowMap[1],
        directionalLight.shadowMapSize,
        directionalLight.shadowBias,
        directionalLight.shadowRadius,
        vDirectionalShadowCoord[1]
      ) *
      0.3;
  }
  // }
  // #pragma unroll_loop_end
  // #endif
  #endif

  return shadow;
}
`, uf = `

#if !defined(USE_DEFERRED) && !defined(DEBUG_DIFFUSE)

  float shininess = o_color.b;
  // TODO Shiny re-enable
  // if (length(o_color.rg) < .1) {
  //   shininess = o_color.b;
  //   o_color.rgb = vec3(0.);
  // }

  // override in forward
  vec4 vcolor = o_color;
  vec4 albedo = o_diffuse;
  float toon = toonShading;
  vec3 position = o_position.xyz;

  float unlit = 1.;
  // ID 0.0 = unlit
  // ID 0.5 = lit
  // ID 1. = lit + toon
  if (toonShading >= 0.5) {
    unlit = 0.;
    if (toonShading > 0.5) {
      toon = 1.;
    }
  } else {
    if (toonShading > 0.0) {
      toon = 1.;
    }
  }

  // if cellshading then do nothing
  #ifdef USE_CELLSHADING
    if ( isBackSide ) {
      gColor.rgb = vec3(0.);
      #if defined(USE_BLOOM) || defined(USE_SSAO)
      gVColor = vec4(vec3(0.), 0.);
      #endif
      return;
    }
  #endif


  // if (vcolor.r == 0.) {
  // lights system

  // ambient
  vec3 ambient = Light.ambient.xyz * max(Light.ambient.w + min(1., vcolor.r / 8.), 0.0);
  vec3 diffuse = getDirectLighting(position.xyz, o_normal.rgb, toon, shininess, vcolor.r);

  // bloom elements over 1.0 are brighter than ambient light so cast tends towards pure albedo
    o_diffuse.rgb = saturate((ambient + diffuse) * albedo.rgb);

  #ifdef USE_SHADOWS
    // o_diffuse.rgb = vec3(1. - shadow);
    o_diffuse.rgb = mix(o_diffuse.rgb, mix(o_diffuse.rgb, ShadowMap.shadowColor.rgb, ShadowMap.shadowIntensity), shadow);
  #endif

    #ifdef USE_LIGHTS_POINT
      // Point "scene" lighting
      for (int j = 0; j < LIGHTS_POINT_MAX; j++) {
        vec3 pointDiffuse = getPointLighting(pointLight[j], position.xyz, o_normal.rgb, toon, shininess);
        // threshold minimum light otherwise black texture never gets lit
        o_diffuse.rgb += max(vec3(.1 * o_normal.b), albedo.rgb) * pointDiffuse * albedo.a;
      }
    #endif

  // }
// tricks the glsl optimizer to not optimize away the above code
#else
#endif`, mf = `

#ifdef USE_DEFERRED 
  #ifdef USE_SHADOWS
    o_diffuse.rgb = mix(o_diffuse.rgb, mix(o_diffuse.rgb, ShadowMap.shadowColor.rgb, ShadowMap.shadowIntensity), shadow);
  #endif
#endif

#ifdef DEBUG_FRONTFACING
  gColor = gl_FrontFacing ? vec4(0., 0., 1., 1.) : vec4(1., 0., 0., 1.);
  gColor.rgb = mix(gColor.rgb + .2, gColor.rgb - .1, vNormal.r);
  gVColor = vec4(0.);
  return;
#endif

#ifndef USE_DEFERRED

#ifdef DEBUG_DIFFUSE
  gColor = o_diffuse;
  gVColor = vec4(0.);
  return;
#endif

#ifdef DEBUG_VIEWPOSITION
  gColor = vec4(vViewPosition.rgb, 1.);
  gVColor = vec4(0.);
  return;
#endif

#ifdef DEBUG_NORMAL
  gColor = vec4(packNormalToRGB(o_normal.rgb), 1.);
  gVColor = vec4(0.);
  return;
#endif

#ifdef DEBUG_POSITION
  gColor = o_position;
  gVColor = vec4(0.);
  return;
#endif

#ifdef DEBUG_VERTEXCOLOR
  gColor = vec4(o_color.rgb, 1.);
  gVColor = vec4(0.);
  return;
#endif

#endif

gColor = o_diffuse;

#ifndef USE_DEFERRED
  #ifdef USE_COMMON_UBO
    float playerAnimDist = distance(playerPos.xyz, o_position.xyz);
    // gColor.rgb = introAnimation(1. - animProgress, playerAnimDist, 1000., gColor.rgb, o_normal, o_position.xyz, playerPos.xyz);
  #endif
#endif

#if defined(USE_DEFERRED)
  gPosition = o_position;

  if (length(o_normal.rgb) > 0.) {
    o_normal.rgb = normalize( o_normal.rgb ) * 0.5 + 0.5;
  }
  gNormal = o_normal;
#endif


#ifndef USE_BLOOM
  if (o_color.r > 0.) {
    gColor.rgb += 0.15 * o_color.r;
  }
#endif

#ifdef USE_BLOOM
  gVColor = o_color;
#else
  #ifdef USE_SSAO
    gVColor = o_color;
  #endif
#endif



#ifdef USE_UBO_FOG

  float fogFactor = smoothstep( Fog.near, Fog.far, vViewPosition.z );

	gColor.rgb = mix( gColor.rgb, Fog.color, fogFactor * Fog.opacity );

#endif


#ifdef USE_PAINT

vec4 normalNoise = texture(uNoise, vWorldPosition.xz / 5.);
      
normalNoise.xy = normalNoise.ga;              // Load in [0,1]
normalNoise.xy = normalNoise.xy * 2.0 - 1.0;           // Unpack to [-1,1]
normalNoise.z = sqrt(1. - dot(normalNoise.xy, normalNoise.xy)); // Compute Z

vec3 bumpedNormal = normalize(vNormal * normalNoise.rgb);

      
vec4 paint = texture(uPaintMap, vUvPaint);

if (paint.a > 0.1 && paint.r == 0.) {
  discard;
}

// gColor.rgb = mix(gColor.rgb, paint.rgb, paint.a);
float noiseValue = noise(vUvPaint * 100.); // Implement or import a GLSL noise function
vec3 noisyNormal = normalize(normalize(bumpedNormal) + noiseValue * 100.);

bumpedNormal = bumpedNormal + paint.a * .1 * noisyNormal;


float distanceToCamera = length(vWorldPosition - cameraPosition);
float attenuation = 1.0 / (1.0 + 0.1 * distanceToCamera + 0.02 * distanceToCamera * distanceToCamera);
vec3 specular = (envColor.rgb * .1 * normalNoise.b) * pow(max(dot(vViewPosition, noisyNormal), 0.0), 2.) * attenuation;

gColor.rgb = mix(gColor.rgb, paint.rgb + specular, paint.a);
#ifdef USE_SHADOWS
  gColor.rgb = mix(gColor.rgb, gColor.rgb * (1. - shadow *  .5), shadow);
#endif

float fresnel = pow(dot(vViewPosition, bumpedNormal), 1.3);
vec3 fresnelColor = fresnel * vec3(.01);
fresnelColor = min(fresnelColor, vec3(1.));
gColor.rgb = mix(gColor.rgb, min(gColor.rgb + fresnelColor, vec3(1.)), paint.a * attenuation);

#endif`, vf = `

uniform mat4 modelViewMatrix;
struct PointLight {
  vec4 position; // position.w is the distance
  vec4 color; // color w is the intensity
};

uniform LightingData {
  // ambient
  vec4 ambient;
  // rgb = ambient color
  // w = ambient intensity;

  // diffuse
  vec4 diffuse;
  // rgb = diffuse color
  // w = diffuse intensity;

  // specular
  vec4 specular;
  // rgb = specular color
  // w = float shininess;

  vec4 position;
} Light;

float fresnelSchlick(float cosTheta, float f0) {
  return f0 + (1.0 - f0) * pow(1.0 - cosTheta, 5.0);
}

#ifdef USE_LIGHTS_POINT
uniform PointLightData {
  PointLight pointLight[LIGHTS_POINT_MAX];
};
#endif

vec3 getGradientIrradiance(float dotNL) {
  vec2 coord = vec2(dotNL * 0.5 + 0.5, 0.0);

  vec2 fw = fwidth(coord) * 0.5;
  vec3 backColor = mix(vec3(0.65), vec3(0.7), smoothstep(0.65, 0.7, coord.x));

  vec3 res = coord.x < 0.7 ? backColor : vec3(1.0);

  return res;
}

float getDistanceAttenuation(
  float lightDistance,
  float cutoffDistance,
  float decayExponent
) {
  float distanceFalloff = 1.0 / max(pow(lightDistance, decayExponent), 0.01);

  if (cutoffDistance > 0.0) {
    distanceFalloff *= pow2(
      saturate(1.0 - pow4(lightDistance / cutoffDistance))
    );
  }

  return distanceFalloff;
}
vec3 getPointLighting(
  PointLight pointLight,
  vec3 position,
  vec3 normal,
  float toonShadingFactor,
  float shininess
) {
  vec3 offset = pointLight.position.xyz - position.xyz;
  vec3 lightDir = normalize(offset);
  float distance = length(offset);

  // energy-conserving-wrapped diffuse implemenatation
  float w = 0.45;
  float dotNL = saturate((dot(normal, lightDir) + w) / ((1.0 + w) * (1.0 + w)));
  // float dotNL = max(0.0, dot(normal, lightDir));
  float attenuation = 1.0 / (distance * distance);
  float distanceFalloff = getDistanceAttenuation(
    distance,
    pointLight.position.w,
    0.0
  );

  vec3 irradiance = pointLight.color.xyz;

  // if (toonShadingFactor == 1.0) {
  //   irradiance *= getGradientIrradiance(dotNL);
  // }

  vec3 viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( cameraPosition - position );

  vec3 reflectDir = reflect(-lightDir, normal);

  float spec = pow(max(dot(viewDir, reflectDir), 0.0), 13.0);

  float cosTheta = max(dot(viewDir, reflectDir), 0.0);
  float fresnel = 1.; // 0.04 is the default value for F0 (dielectric materials)
  // float fresnel = fresnelSchlick(cosTheta, 0.14); // 0.04 is the default value for F0 (dielectric materials)

  float fresnelRim = fresnelSchlick(cosTheta, 0.04);

  float specularStrength = shininess;
  vec3 specular = specularStrength * spec * pointLight.color.xyz;

  vec3 lightWeighting =
    (irradiance + specular) * pointLight.color.w * distanceFalloff;



  float rim = max(dot(viewDir, normal), 0.0);
  float rimPower = 2.0; // You can adjust this value to control the rim lighting tightness
  rim = pow(rim, rimPower);
  float rimIntensity = 0.1; // Adjust this value to control the intensity of the rim lighting
  rim *= rimIntensity;

  vec3 lighting = lightWeighting * (1.0 + dotNL * 2.0) + rim;

  return saturate(lighting);
}

vec3 getDirectLighting(
  vec3 position,
  vec3 normal,
  float toonShadingFactor,
  float shininess,
  float bloom
) {
  vec3 mvpDirLight = (modelViewMatrix * vec4(Light.position.xyz, .1)).xyz;
  // diffuse
  vec3 lightDir = normalize(mvpDirLight - position.xyz);

  // energy-conserving-wrapped diffuse implemenatation
  float w = 0.45;
  float dotNL = saturate((dot(normal, lightDir) + w) / ((1.0 + w) * (1.0 + w)));
  // float dotNL = max(dot(normal.rgb, lightDir), 0.0);

  vec3 irradiance = Light.diffuse.rgb;
  // toon shading if normal.a = 1
  // if (toonShadingFactor == 1.0) {
  //   irradiance *= getGradientIrradiance(dotNL);
  // }

  // no ortho camera condition needed
  vec3 viewDir = normalize(cameraPosition - mvpDirLight);
  vec3 reflectDir = reflect(-lightDir, normal.xyz);

  float cosTheta = max(dot(viewDir, reflectDir), 0.0);
  float fresnel = 1.; // 0.04 is the default value for F0 (dielectric materials)
  // float fresnel = fresnelSchlick(cosTheta, 0.14); // 0.04 is the default value for F0 (dielectric materials)

  float spec = pow(max(dot(viewDir, reflectDir), 0.0), 32.0);
  float specularStrength = shininess;
  vec3 specular = specularStrength * spec * Light.diffuse.rgb * fresnel;

  float fresnelRim = fresnelSchlick(cosTheta, 0.04);

  float rim = max(dot(viewDir, normal), 0.0);
  float rimPower = 2.0; // You can adjust this value to control the rim lighting tightness
  rim = pow(rim, rimPower);
  float rimIntensity = 0.1; // Adjust this value to control the intensity of the rim lighting
  rim *= rimIntensity;

  vec3 diffuse = dotNL * (irradiance + specular) * max(0.0, Light.diffuse.w + min(1., bloom / 8.)) + rim;

  return diffuse;
}

`, gf = `

#define ALBEDO_LOCATION 0



layout(location = ALBEDO_LOCATION) out vec4 gColor;

#if defined(USE_DEFERRED)
  #define POSITION_LOCATION 1
  #define NORMAL_LOCATION 2
  #define EFFECT_LOCATION 3

  layout(location = POSITION_LOCATION) out vec4 gPosition;
  layout(location = NORMAL_LOCATION) out vec4 gNormal;
  #if defined(USE_BLOOM) || defined(USE_SSAO)
    layout(location = EFFECT_LOCATION) out vec4 gVColor;
  #endif
#elif defined(USE_BLOOM) || defined(USE_SSAO)
  #define EFFECT_LOCATION 1
  layout(location = EFFECT_LOCATION) out vec4 gVColor;
#endif

#if defined(USE_UBO_FOG)

  uniform FogData {
    vec3 color;
    float opacity;
    float near;
    float far;
  } Fog;

#endif

#define gl_FragColor gColor


#ifdef USE_PAINT

uniform sampler2D uPaintMap;
uniform sampler2D uNoise;
float hash(float n) { return fract(sin(n) * 43758.5453123); }

float noise(vec2 x) {
    vec2 p = floor(x);
    vec2 f = fract(x);

    f = f * f * (3.0 - 2.0 * f);

    float n = p.x + p.y * 57.0;

    float res = mix(mix(hash(n +  0.0), hash(n +  1.0), f.x),
                    mix(hash(n + 57.0), hash(n + 58.0), f.x), f.y);

    return res;
}

in vec2 vUvPaint;
#endif`, pf = `

#ifdef USE_CELLSHADING
if ( isBackSide ) {
	float thickness = 0.005;
	// if (!isPerspectiveMatrix( projectionMatrix )) {
	// 	thickness = 2.;
	// }
	#ifdef CELLSHADING_THICKNESS
		thickness += CELLSHADING_THICKNESS;
	#endif
	const float ratio = 1.0;
	vec3 outlineNormal = - objectNormal;
	vec3 transformed2 = transformed;
	transformed2.xyz += outlineNormal;
	vec3 norm = normalize( transformed - transformed2 );
	transformed += norm * thickness;
}

#endif
`, hf = `

uniform Common {
  float time;
  float animProgress;
  vec4 playerPos;
};

#define USE_COMMON_UBO
`, _f = `


#ifdef USE_NEARBYPLAYERS
float circleRadius = 1.5;

float callFactor = smoothstep(0.5, .75, playerPos.w);
float focusFactor = smoothstep(0.75, 1., playerPos.w);


float sdf = circleSDF(playerPos.xyz, circleRadius, .4);

sdf = smoothUnion(sdf, circleSDF(nearbyPlayer1.xyz, circleRadius, .4), 1.);
sdf = smoothUnion(sdf, circleSDF(nearbyPlayer2.xyz, circleRadius, .4), 1.);
sdf = smoothUnion(sdf, circleSDF(nearbyPlayer3.xyz, circleRadius, .4), 1.);
sdf = smoothUnion(sdf, circleSDF(nearbyPlayer4.xyz, circleRadius, .4), 1.);
sdf = smoothUnion(sdf, circleSDF(nearbyPlayer5.xyz, circleRadius, .4), 1.);

float isAvailable = 1.0;
if (playerPos.w == 0.25) {
  isAvailable = 0.0;
}


vec3 circleColorUnavailable = vec3(0.953, 0.192, 0.51);
vec3 circleColorAvailable = vec3(1.);

if (focusFactor > 0.) {
  // gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b), focusFactor * .5);
  float currentPlayerCirclePrivate = circleSDFSimple(playerPos.xyz, circleRadius + focusFactor * 200.);
  gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b), focusFactor);

  if (smoothstep(0.0, 0.02, currentPlayerCirclePrivate) < 1.0) {
    gColor.rgb = mix(gColor.rgb, mix(vec3(0.035,0.235,0.745), vec3(0.953,0.192,0.51), o_normal.g * .8), .6 * focusFactor);
  }
}

if (smoothstep(0.0, 0.02, sdf) < 1.0) {
  gColor.rgb = mix(gColor.rgb, circleColorAvailable, (1. - smoothstep(0.0, 0.02, sdf)) * .3);
}


if (isAvailable == 0.0) {
  float currentPlayerCircle = circleSDF(playerPos.xyz, circleRadius, .4);
  if (smoothstep(0.0, 0.02, currentPlayerCircle) < 1.0) {
    gColor.rgb = mix(gColor.rgb, circleColorUnavailable, (1. - smoothstep(0.0, 0.02, currentPlayerCircle)) * .3);
  }
}




// Nearest intensity
vec4 playerPositions[5];
playerPositions[0] = nearbyPlayer1;
playerPositions[1] = nearbyPlayer2;
playerPositions[2] = nearbyPlayer3;
playerPositions[3] = nearbyPlayer4;
playerPositions[4] = nearbyPlayer5;

for (int i = 0; i < 5; i++) {
    float dist = distance(playerPos.xyz, playerPositions[i].xyz);

    if (playerPositions[i].w == 0.25) {
      float innerBusy = circleSDF(playerPositions[i].xyz, circleRadius, .4);
      if (smoothstep(0.0, 0.02, innerBusy) < 1.0) {
        gColor.rgb = mix(gColor.rgb, circleColorUnavailable, (1. - smoothstep(0.0, 0.02, circleSDF(playerPositions[i].xyz, circleRadius, .4))) * .3);
      }
      continue;
    }
    
    if (dist <= 4.) {
      
        float pulseDistance = smoothstep(4.0, 3., dist);


        if (playerPositions[i].w == 0.25 || playerPos.w == 0.25) {
          focusFactor = 0.0;
          circleRadius = 0.;
        }

        float a = 1. - (.1 * (((sin(time * 3.5)) + 1.) / 2.)) * (1. - callFactor);
        a -= callFactor * .3;

        float sdfInner = circleSDF(playerPos.xyz, circleRadius * a * pulseDistance, .4);
        float sdfInnerOut = circleSDF(playerPositions[i].xyz, circleRadius * a * pulseDistance, .4);

        sdfInner = smoothUnion(sdfInner, sdfInnerOut, pulseDistance + callFactor);

        float contactFactor = 1. - smoothstep(0. + 0.98 * (1. - pulseDistance), 0.02 + 0.98 * (1. - pulseDistance), sdfInner);

        if (playerPositions[i].w == 0.25 || playerPos.w == 0.25) {
          contactFactor = 0.;
        }

        gColor.rgb = mix(gColor.rgb, mix(vec3(0.035,0.235,0.745), vec3(0.953,0.192,0.51), focusFactor), contactFactor * (.5 * pulseDistance) );
    }
}

// gColor.rgb += circleColor;
#endif`, xf = `

#ifdef USE_NEARBYPLAYERS

uniform NearbyPlayers {
  vec4 nearbyPlayer1;
  vec4 nearbyPlayer2;
  vec4 nearbyPlayer3;
  vec4 nearbyPlayer4;
  vec4 nearbyPlayer5;
};

const vec3 floorNormal = vec3(0.0, 1.0, 0.0);
const float maxAngleDifference = 70.0;

float circleSDF(vec3 playerPos, float radius, float heightDistance) {
    float angleDifference = degrees(acos(dot(normalize(vNormal), floorNormal)));
    if (angleDifference > maxAngleDifference) {
      return 1.;
    }
    if (distance(playerPos.y, vWorldPosition.y) > heightDistance) {
      return 1.;
    }
    if (!gl_FrontFacing) {
      return 1.;
    }
    return length(vWorldPosition.xz - playerPos.xz) - radius;
}

float smoothUnion(float d1, float d2, float k) {
    float h = clamp(0.5 + 0.5 * (d2 - d1) / k, 0.0, 1.0);
    return mix(d2, d1, h) - k * h * (1.0 - h);
}
float circleSDFSimple(vec3 playerPos, float radius) {
    float angleDifference = degrees(acos(dot(normalize(vNormal), floorNormal)));
    return length(vWorldPosition.xz - playerPos.xz) - radius;
}

#endif`, yf = `

#ifdef USE_SHADOWS
  uniform ShadowMapData {
    mat4 projection;
    mat4 matrixInv;
    vec3 shadowColor;
    float shadowIntensity;
    float bias;
  } ShadowMap;

  uniform mediump sampler2DShadow shadowMap;
  in vec4 vShadowCoord;
  in float vShadowBias;

  uniform bool receiveShadow;

  const vec2 poissonDisk[16] = vec2[]( 
    vec2( -0.94201624, -0.39906216 ), 
    vec2( 0.94558609, -0.76890725 ), 
    vec2( -0.094184101, -0.92938870 ), 
    vec2( 0.34495938, 0.29387760 ), 
    vec2( -0.91588581, 0.45771432 ), 
    vec2( -0.81544232, -0.87912464 ), 
    vec2( -0.38277543, 0.27676845 ), 
    vec2( 0.97484398, 0.75648379 ), 
    vec2( 0.44323325, -0.97511554 ), 
    vec2( 0.53742981, -0.47373420 ), 
    vec2( -0.26496911, -0.41893023 ), 
    vec2( 0.79197514, 0.19090188 ), 
    vec2( -0.24188840, 0.99706507 ), 
    vec2( -0.81409955, 0.91437590 ), 
    vec2( 0.19984126, 0.78641367 ), 
    vec2( 0.14383161, -0.14100790 ) 
  );

  float noiseRandom(vec4 seed4) {
     float dot_product = dot(seed4, vec4(12.9898,78.233,45.164,94.673));
    return fract(sin(dot_product) * 43758.5453);
  }

float blurNoise(vec3 position, vec2 resolution, int blurSize, int index) {
    vec2 pixelSize = 1.0 / resolution;
    float blurSum = 0.0;
    float weightSum = 0.0;

    for (int x = -blurSize; x <= blurSize; x++) {
        for (int y = -blurSize; y <= blurSize; y++) {
            vec2 offset = vec2(float(x), float(y)) * pixelSize;
            vec4 seed4 = vec4(floor((position.xyz + offset.xxy) * 600.0), float(index));
            float noise = noiseRandom(seed4);
            float weight = 1.0 / (1.0 + length(offset));
            blurSum += noise * weight;
            weightSum += weight;
        }
    }

    return blurSum / weightSum;
}

#endif`, bf = `

#ifdef USE_SHADOWS

  uniform ShadowMapData {
    mat4 projection;
    mat4 matrixInv;
    vec3 shadowColor;
    float shadowIntensity;
    float bias;
  } ShadowMap;

  out float vShadowBias;
  out vec4 vShadowCoord;

  const mat4 biasMatrix = mat4(
    0.5, 0.0, 0.0, 0.0, 
    0.0, 0.5, 0.0, 0.0,
    0.0, 0.0, 0.5, 0.0,
    0.5, 0.5, 0.5, 1.0
    );
#endif
`, wf = `  #ifdef USE_SHADOWS

    float cosTheta = dot(normalize((modelViewMatrix * vec4(Light.position.xyz, 1.)).xyz), vNormal);

    vec2 shadowMapSize = vec2(textureSize(shadowMap, 0).xy);

    float bias = max(vShadowBias * (1.0 - cosTheta), vShadowBias);

    float shadowFactor = 0.;
    vec2 texelSize = 1.0 / shadowMapSize;

    // Calculate the shadow factor using the Poisson disk
    for (int i = 0; i < 2; i++) {
      // int index = 0;
      int index = int(16.0 * noiseRandom(vec4(floor(vWorldPosition.xyz * 600.0), i))) % 16;
      float poissonShadow = 1.0 - texture(shadowMap, vec3(vShadowCoord.xy + poissonDisk[index] / shadowMapSize.x, (vShadowCoord.z - bias) / vShadowCoord.w));
      shadowFactor += 1. / 2.0 * poissonShadow;
    }


    bvec4 inFrustumVec = bvec4 ( vShadowCoord.x >= 0.0, vShadowCoord.x <= 1.0, vShadowCoord.y >= 0.0, vShadowCoord.y <= 1.0 );
    bool inFrustum = all( inFrustumVec );

    bvec2 frustumTestVec = bvec2( inFrustum, vShadowCoord.z <= 1.0 );
    bool frustumTest = all( frustumTestVec );

    if(frustumTest == false){
        shadowFactor = 0.0;
    }

    float difLight = max(0., cosTheta);

    float shadow = saturate(shadowFactor * difLight);

  #endif
  `, Af = `#ifdef USE_SHADOWS

  vShadowCoord = biasMatrix * ShadowMap.projection * ShadowMap.matrixInv * worldPosition;
  vShadowBias = ShadowMap.bias;

#endif
`;
function Cf() {
  n.ShaderChunk2.common_ubo_pars = hf, n.ShaderChunk2.encodings_fragment = "", n.ShaderChunk2.shadowmask_pars_fragment = df, n.ShaderChunk2.deferred_lights_pars = vf, n.ShaderChunk2.forward_lights_fragment = uf, n.ShaderChunk2.cellshading_vertex = pf, n.ShaderChunk2.alphatest_fragment = of, n.ShaderChunk2.layout_pars_fragment = gf, n.ShaderChunk2.layout_output_fragment = mf, n.ShaderChunk2.introanimation_pars_fragment = cf, n.ShaderChunk2.dither_fragment = lf, n.ShaderChunk2.dither_pars_fragment = rf, n.ShaderChunk2.dither_vertex = ff, n.ShaderChunk2.dither_pars_vertex = sf, n.ShaderChunk2.nearbyplayers_ubo_pars = xf, n.ShaderChunk2.nearbyplayers_fragment = _f, n.ShaderChunk2.shadows_fragment = wf, n.ShaderChunk2.shadows_vertex = Af, n.ShaderChunk2.shadows_pars_fragment = yf, n.ShaderChunk2.shadows_pars_vertex = bf;
}
Cf(), nf(), af();
const Sf = () => {
  const [e, t, a, i] = /* @__PURE__ */ Y((r) => [r.fogColor, r.fogOpacity, r.fogNear, r.fogFar]);
  return V(() => {
    Te.uniforms[0].value.set(e || "#ffffff"), Te.uniforms[1].value = t, Te.uniforms[2].value = a, Te.uniforms[3].value = i;
  }, [e, t, a, i]), null;
}, Pf = () => {
  const [e, t, a, i] = /* @__PURE__ */ Y((o) => [o.useDeferred, o.useBloom, o.useSSAO, o.bloom]), r = /* @__PURE__ */ Ie((o) => o.commonUbo), l = /* @__PURE__ */ U((o) => o.scene), s = /* @__PURE__ */ U((o) => o.gl);
  return V(() => {
    Ve({ gl: s }), Pt({ gl: s });
  }, [s]), ie(() => za((o) => r.uniforms[0].value = o / 1e3), [r]), V(() => {
    l.traverse((o) => {
      o.material && s.properties.remove(o.material);
    }), s.globalDefines.USE_DEFERRED = e, s.globalDefines.USE_BLOOM = i > 0 ? t : false, s.globalDefines.USE_SSAO = a;
  }, [s, l, e, t, a, i]), null;
}, Mf = ({ children: e }) => H(te, { children: [y(Pf, {}), y(Sf, {}), e] });
function rn({ className: e, parent: t, ...a }) {
  const i = /* @__PURE__ */ U((l) => l.gl), r = /* @__PURE__ */ V(() => {
    const l = new ko({ ...a });
    return l.init(i.domElement), l;
  }, [i]);
  return G(() => {
    if (r) {
      const l = t && t.current || document.body;
      l?.appendChild(r.container), e && r.container.classList.add(...e.split(" ").filter((f) => f));
      const s = /* @__PURE__ */ za(() => r.begin()), o = /* @__PURE__ */ Uo(() => r.end());
      return () => {
        l?.removeChild(r.container), s(), o();
      };
    }
  }, [t, r, e]), null;
}
const Df = ({ children: e }) => {
  const t = /* @__PURE__ */ U((a) => a.gl);
  return G(() => {
    const a = /* @__PURE__ */ t.getContext();
    a.enable(a.SAMPLE_ALPHA_TO_COVERAGE), Ve({ gl: t });
  }, [t]), H(Mf, { children: [process.env.NODE_ENV === "development" && y(rn, {}), y(tf, {}), e] });
}, on = new n.Matrix4(), sn = new n.Matrix4(), sa = [], Et = new n.Mesh();
class ln extends n.Group {
  constructor() {
    super(), this.instance = { current: void 0 }, this.instanceKey = { current: void 0 };
  }
  get geometry() {
    return this.instance.current?.geometry;
  }
  raycast(t, a) {
    const i = this.instance.current;
    if (!i || !this.useRaycast || !i.geometry || !i.material)
      return;
    Et.geometry = i.geometry;
    const r = i.matrixWorld, l = /* @__PURE__ */ i.userData.instances.indexOf(this.instanceKey);
    if (!(l === -1 || l > i.count)) {
      i.getMatrixAt(l, on), sn.multiplyMatrices(r, on), Et.matrixWorld = sn, i.material instanceof n.Material ? Et.material.side = i.material.side : Et.material.side = i.material[0].side, Et.raycast(t, sa);
      for (let s = 0, o = sa.length; s < o; s++) {
        const f = sa[s];
        f.instanceId = l, f.object = this, a.push(f);
      }
      sa.length = 0;
    }
  }
}
let la;
const fn = /* @__PURE__ */ A.createContext(null), Ef = new n.Matrix4();
N({ SougenPosition: ln });
const cn = /* @__PURE__ */ A.forwardRef(function({ context: t, children: a, ...i }, r) {
  const l = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(r, () => l.current);
  const s = /* @__PURE__ */ A.useContext(t || fn);
  return A.useLayoutEffect(() => s.subscribe(l), []), y("sougenPosition", { instance: s?.getParent(), instanceKey: l, ref: l, ...i, children: a });
}), Tf = /* @__PURE__ */ A.forwardRef(function({ children: t, range: a, limit: i = 1e3, ...r }, l) {
  const [{ context: s, instance: o }] = /* @__PURE__ */ A.useState(() => {
    const p = /* @__PURE__ */ A.createContext(null);
    return { context: p, instance: y(cn, { context: p, ...r, ref: l }) };
  }), f = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(l, () => f.current);
  const [d, c] = /* @__PURE__ */ A.useState([]), [[u]] = /* @__PURE__ */ A.useState(() => {
    const p = new Float32Array(i * 16);
    for (la = 0; la < i; la++)
      Ef.identity().toArray(p, la * 16);
    return [p, new Float32Array([...new Array(i * 3)].map(() => 1))];
  });
  A.useEffect(() => {
    const p = /* @__PURE__ */ Math.min(i, a !== void 0 ? a : i, d.length);
    f.current.count = p, f.current.instanceMatrix.updateRange.count = p * 16, f.current.instanceMatrix.needsUpdate = true;
  }, [a, d.length]);
  const m = /* @__PURE__ */ A.useMemo(() => ({ getParent: () => f, subscribe: (p) => (c((g) => [...g, p]), () => c((g) => g.filter((h) => h.current !== p.current))) }), []);
  return H("instancedMesh", { userData: { instances: d }, matrixAutoUpdate: false, ref: f, args: [null, null, 0], raycast: () => null, ...r, children: [y("instancedBufferAttribute", { attach: "instanceMatrix", count: u.length / 16, array: u, itemSize: 16, usage: n.DynamicDrawUsage }), typeof t == "function" ? y(s.Provider, { value: m, children: t(o) }) : y(fn.Provider, { value: m, children: t })] });
}), If = ({ collectionId: e = "konpi", animationsList: t, ...a }) => {
  const i = /* @__PURE__ */ I(), [r, l, s] = /* @__PURE__ */ Se(async () => {
    let o = e;
    e !== "konpi" && (o = "ancient");
    const d = await (await fetch(z.ignoreProxy ? `/animations/${o}/animations.json` : v[`/animations/${o}/animations.json`])).json(), c = [];
    for (let g = 0; g < d.animations.length; g++) {
      const h = d.animations[g], C = z.ignoreProxy ? `/animations/${o}/gpu/${h}.bin` : v[`/animations/${o}/gpu/${h}.bin`];
      c.push(C);
    }
    const u = new Array(c.length), m = /* @__PURE__ */ c.map((g) => fetch(g).then((h) => h.arrayBuffer()).then((h) => {
      const C = new Float32Array(h);
      for (let _ = 0; _ < C.length; _++)
        C[_] = parseFloat(C[_]);
      u[c.indexOf(g)] = C;
    }));
    await Promise.all(m);
    const p = new Float32Array(u[0].length * u.length);
    return u.map((g) => p.set(g, g.length * u.indexOf(g))), [p, u[0].length / 4, d];
  }, [`animations_${e.toString()}`, e]);
  return V(() => {
    t && (t.current = s.animations);
  }, []), y("dataArrayTexture", { ref: i, ...a, args: [r, l, 1, s.animations.length, n.RGBAFormat], type: n.FloatType, needsUpdate: true });
}, Uf = (e) => y(de, { fallback: null, children: y(If, { ...e }) }), Bf = ["position", "normal"];
function kf(e, t = false, a) {
  let i = 0, r = 0, l = 0, s = 0;
  const o = e[0].geometry, f = new n.BufferGeometry();
  let d = {};
  for (let m = 0; m < e.length; m++) {
    const p = e[m].geometry;
    l += p.attributes.position.count, s += p.index.count;
  }
  for (const m in o.attributes) {
    const p = /* @__PURE__ */ o.getAttribute(m), { array: g, itemSize: h, normalized: C } = p, _ = new g.constructor(l * h), x = new p.constructor(_, h, C);
    x.setUsage(p.usage), d[m] = 0, f.setAttribute(m, x);
  }
  if (o.getIndex() !== null) {
    const m = s > 65534 ? new Uint32Array(s) : new Uint16Array(s);
    if (f.setIndex(new n.BufferAttribute(m, 1)), t) {
      const p = s > 65534 ? new Uint32Array(s) : new Uint16Array(s);
      f.setAttribute("faceGeoId", new n.BufferAttribute(p, 1));
    }
  }
  const c = /* @__PURE__ */ f.getIndex(), u = /* @__PURE__ */ f.getAttribute("faceGeoId");
  for (let m = 0; m < e.length; m++) {
    const p = /* @__PURE__ */ e[m].geometry.clone();
    e[m].matrix && p.applyMatrix4(e[m].matrix);
    const g = /* @__PURE__ */ p.getAttribute("position"), h = p.getIndex() !== null, C = /* @__PURE__ */ p.getIndex();
    for (const _ in p.attributes) {
      if (!Bf.includes(_) && (!a || !a.includes(_)))
        continue;
      const x = /* @__PURE__ */ p.getAttribute(_), b = /* @__PURE__ */ f.getAttribute(_);
      b && (b.array.set(x.array, d[_]), d[_] += x.array.length, b.needsUpdate = true);
    }
    if (h) {
      for (let _ = 0; _ < C.count; ++_)
        c.setX(r + _, i + C.getX(_)), t && u.setX(i + C.getX(_), t[m]);
      c.needsUpdate = true, r += C.count;
    }
    i += g.count;
  }
  return f;
}
function Rf(e) {
  n.Material.DefaultBlending = e ? n.NormalBlending : n.NoBlending;
}
const Lf = /[^#-.*|\":<>[\]{}`\\()^/'~=%,;@&$œ_ !?+a-zA-ZÀ-ÿæ0-9À-ÖØ-ö\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B]+/gi, zf = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
function Ff(e) {
  return Math.max(Math.min(e, 1), 0);
}
function Nf(e, t, a) {
  return e <= t ? 0 : e >= a ? 1 : (e - t) / (a - t);
}
const dn = new n.Vector3(), Of = new n.Vector3(), Gf = new n.Quaternion();
function Hf(e, t) {
  return e.matrixWorld.decompose(dn, Gf, t), t;
}
function Vf(e, t) {
  return e.matrixWorld.decompose(dn, t, Of), t;
}
const fa = new n.Matrix4(), ut = new n.Matrix4(), Ae = new n.Matrix4(), ca = new n.Matrix4(), Pe = new n.Vector3(), da = new n.Vector3(), mt = new n.Quaternion(), nt = new n.Euler(), Wf = (e) => {
  for (let t = 0; t < e.length; t++)
    e[t] = n.MathUtils.radToDeg(e[t]);
  return e;
}, jf = (e) => {
  for (let t = 0; t < e.length; t++)
    e[t] = n.MathUtils.degToRad(e[t]);
  return e;
}, Qf = (e, t) => (t && (fa.makeRotationFromEuler(nt.fromArray(e)), ca.fromArray(t.matrixWorld).invert(), Ae.multiplyMatrices(ca, fa), nt.setFromRotationMatrix(Ae), e = nt.toArray(), e.pop()), e), Yf = (e, t) => t ? (fa.makeRotationFromQuaternion(mt.fromArray(e)), ca.fromArray(t.matrixWorld).invert(), Ae.multiplyMatrices(ca, fa), mt.setFromRotationMatrix(Ae).toArray()) : e, qf = (e, t) => t ? (ut.copy(Ya(t)), Pe.fromArray(e), Pe.applyMatrix4(ut.invert()), Pe.toArray()) : e, Xf = (e, t) => t && t.position ? (ut.copy(Ya(t)), Pe.fromArray(e), Pe.applyMatrix4(ut), Pe.toArray()) : e, un = (e, t) => {
  t(e), e.parent && un(e.parent, t);
}, Kf = (e, t) => (t && t.position && un(t, (a) => {
  e = Xf(e, a);
}), e), Zf = (e, t) => t && t.matrixWorld ? (Pe.fromArray(e).applyMatrix4(Ae.fromArray(t.matrixWorld).invert()), Pe.toArray()) : e, Jf = (e) => {
  Ae.fromArray(e.matrixWorld).extractRotation(Ae), nt.setFromRotationMatrix(Ae);
  const t = /* @__PURE__ */ nt.toArray();
  return t.pop(), t;
}, Ya = (e) => (da.set(1, 1, 1), Pe.fromArray(e.position), mt.setFromEuler(nt.fromArray(e.rotation)), Ae.compose(Pe, mt, da)), $f = (e) => (da.set(1, 1, 1), Pe.fromArray(e.position), mt.setFromEuler(nt.fromArray(e.rotation)), Ae.compose(Pe, mt, da), e.parent && e.parent.matrixWorld && (ut.fromArray(e.parent.matrixWorld), Ae.multiplyMatrices(ut, Ae)), Ae), ec = new Headers(), tc = { method: "GET", headers: ec, mode: "cors", cache: "default" }, mn = async (e, t = z.ignoreProxy ? "/img/webp/coming-soon/0.webp" : v["/img/webp/coming-soon/0.webp"]) => {
  const a = await fetch(`${decodeURIComponent(e)}?nocache=${n.MathUtils.generateUUID()}`, tc);
  if (a.status === 404 || a.status === 403)
    return t;
  const i = await a.blob();
  return URL.createObjectURL(i);
}, { clamp: ac } = n.MathUtils, ic = (e, t, a) => t - e === 0 ? 1 : ac((a - e) / (t - e), 0, 1);
function nc(e, t, a) {
  return e * (1 - a) + t * a;
}
const rc = (e) => e.normalize("NFKD").toLowerCase().trim().replace(/\s+/g, "-"), oc = (e) => {
  const t = { Hood: "hood", Helmet: "head", Shoulder: "shoulder", "Energy Ring": "energy", Chest: "chest", "Head Augmentation": "ear", Necklace: "necklace", "Bottom Helmet": "mouth", Headwear: "headwear", "Back Accessory": "back-accessory", Background: "background" };
  return t[e] ? t[e] : e;
};
function vn(e, t, a) {
  let i = t, r = null;
  return typeof t == "object" && (i = t.mesh, t.variant && (r = t.variant)), !a[e].includes(i) && i !== "none" && (i = a[e][0]), { perkKey: rc(`${oc(e)}_-_${i}`), mesh: i, variant: r };
}
const sc = (e) => {
  const t = [], a = /* @__PURE__ */ new Set();
  for (const i of e) {
    let r = i, l = 0;
    for (; a.has(r); )
      r = `${i}.${++l}`;
    a.add(r), t.push(r);
  }
  return t;
}, lc = (e, t) => {
  const a = {};
  for (const i of e.mappings)
    for (const r of i.variants)
      a[t[r]] = { material: null, gltfMaterialIndex: i.material };
  return a;
}, ua = (e) => e.material !== void 0 && e.userData && e.userData.variantMaterials, gn = (e, t, a) => {
  a(e, t);
  for (let i = 0; i < e.children.length; i++)
    gn(e.children[i], t.children[i], a);
}, pn = (e, t) => {
  t.userData.variantMaterials !== void 0 && (e.userData.variantMaterials = { ...t.userData.variantMaterials }), t.userData.originalMaterial !== void 0 && (e.userData.originalMaterial = t.userData.originalMaterial);
};
class fc {
  constructor(t) {
    this.parser = t, this.name = "KHR_materials_variants";
  }
  afterRoot(t) {
    const a = this.parser, i = a.json;
    if (!i.extensions || !i.extensions[this.name])
      return null;
    const l = i.extensions[this.name].variants || [], s = /* @__PURE__ */ sc(l.map((d) => d.name));
    for (const d of t.scenes)
      d.traverse((c) => {
        const u = /* @__PURE__ */ a.associations.get(c);
        if (!u || u.meshes === void 0 || u.primitives === void 0)
          return;
        const g = i.meshes[u.meshes].primitives[u.primitives].extensions;
        !g || !g[this.name] || (c.userData.variantMaterials = lc(g[this.name], s));
      });
    t.userData.variants = s, t.functions = t.functions || {};
    const o = async (d, c, u) => {
      d.userData.originalMaterial || (d.userData.originalMaterial = d.material);
      const m = d.material;
      let p = null;
      if (c === null || !d.userData.variantMaterials[c])
        d.material = d.userData.originalMaterial, a.associations.has(d.material) && (p = a.associations.get(d.material).index);
      else {
        const g = d.userData.variantMaterials[c];
        g.material ? (d.material = g.material, g.gltfMaterialIndex !== void 0 && (p = g.gltfMaterialIndex)) : (p = g.gltfMaterialIndex, d.material = await a.getDependency("material", p), a.assignFinalMaterial(d), g.material = d.material);
      }
      u !== null && u(d, m, p);
    }, f = (d) => {
      const c = d.material, u = d.userData.variantMaterials, m = [];
      for (const p in u) {
        const g = u[p];
        if (g.material)
          continue;
        const h = g.gltfMaterialIndex;
        m.push(a.getDependency("material", h).then((C) => {
          d.material = C, a.assignFinalMaterial(d), u[p].material = d.material;
        }));
      }
      return Promise.all(m).then(() => {
        d.material = c;
      });
    };
    t.functions.selectVariant = (d, c, u = true, m = null) => {
      const p = [];
      return u ? d.traverse((g) => ua(g) && p.push(o(g, c, m))) : ua(d) && p.push(o(d, c, m)), Promise.all(p);
    }, t.functions.ensureLoadVariants = (d, c = true) => {
      const u = [];
      return c ? d.traverse((m) => ua(m) && u.push(f(m))) : ua(d) && u.push(f(d)), Promise.all(u);
    }, t.functions.copyVariantMaterials = (d, c, u = true) => {
      u ? gn(d, c, (m, p) => pn(m, p)) : pn(d, c);
    };
  }
}
const qa = [];
let Tt = 0;
const It = [], hn = ["/images/collections/coming-soon/webp/0.webp"], Ut = new Bi();
function vt(e) {
  e.manager = Ut, e.dontPropagateManager = true;
}
const _n = /* @__PURE__ */ De((e, t) => {
  let a;
  function i(r) {
    if (a = et(), a.ignoreProgress)
      return 0;
    let { cntLoaded: l, graphLoaded: s, pathDetailsRemainning: o } = t();
    if (s || a.allLoadedItem.push(r), o?.[a.loadingStep]?.includes(r)) {
      if (r.endsWith(".glb") && !qa.includes(r))
        qa.unshift(r);
      else {
        const f = /* @__PURE__ */ o[a.loadingStep].findIndex((d) => d === r);
        o[a.loadingStep].splice(f, 1), It.push(r), l += 1, o[0].length === 0 && Ve({ step0Complete: true }), a.loadingStep === 2 && o[a.loadingStep] && o[a.loadingStep].length === 0 && Ve({ loadingStep: a.loadingStep + 1 });
      }
    } else
      r.startsWith("blob") || (!It.includes(r) && hn.includes(r), It.includes(r) || It.push(r));
    return l;
  }
  return Ut.onStart = (r, l, s) => {
    a = et(), e({ active: true, item: r, loaded: l, total: s, progress: (l - Tt) / (s - Tt) * 100 });
  }, Ut.onLoad = () => {
    e({ active: false });
  }, Ut.onError = (r) => {
    const l = /* @__PURE__ */ i(r);
    e((s) => ({ errors: [...s.errors, r], cntLoaded: l }));
  }, Ut.onProgress = (r, l, s) => {
    l === s && (Tt = s);
    const o = /* @__PURE__ */ i(r);
    e({ active: true, item: r, loaded: l, total: s, progress: (l - Tt) / (s - Tt) * 100 || 100, cntLoaded: o });
  }, { graphLoaded: false, pathDetailsRemainning: false, errors: [], active: false, progress: 0, item: "", loaded: 0, total: 0, cntLoaded: 0, registerLoadedItem: (r) => {
    const l = /* @__PURE__ */ i(r);
    e({ cntLoaded: l });
  } };
}), { getState: cc, setState: dc } = _n;
function uc(e) {
  return e.replace(/-v.*v-\./, "");
}
const Xa = /* @__PURE__ */ De(() => ({})), Ka = (e, t) => Xa(e, t || Le);
Object.assign(Ka, Xa);
const { getState: xn, setState: mc } = Xa, yn = (e) => {
  if (process.env.NODE_ENV === "development") {
    const t = /* @__PURE__ */ Ka((a) => a[e]);
    return t !== void 0 ? t : ta[e];
  }
  return ta[e];
}, bn = (e) => {
  if (process.env.NODE_ENV === "development") {
    const a = xn()[e];
    return a !== void 0 ? a : ta[e];
  }
  return ta[e];
}, gt = [{ key: "isMob", check: "isMobile" }, { key: "saf", check: "isSafari" }, { key: "ios", check: "isIOS" }], vc = [{ isDesktop: true, isSafari: false, isMobile: false, isIOS: false }, { isDesktop: true, isSafari: true, isMobile: false, isIOS: false }, { isDesktop: false, isSafari: false, isMobile: true, isIOS: false }, { isDesktop: false, isSafari: false, isMobile: true, isIOS: true }, { isDesktop: false, isSafari: true, isMobile: true, isIOS: true }], Za = () => {
  let e = "";
  for (let t = 0; t < gt.length; t++)
    e += gt[t].key + (bn(gt[t].check) ? "1" : "0");
  return e;
}, gc = (e) => {
  let t = "";
  for (let a = 0; a < gt.length; a++)
    t += gt[a].key + (e[gt[a].check] ? "1" : "0");
  return t;
}, Bt = (e) => e === Object(e) && !Array.isArray(e) && typeof e != "function";
function ma(e, t) {
  const { startRecordPaths: a, pathLoaded: i, loaderInfos: r, loadingStep: l } = /* @__PURE__ */ et();
  if (a && !i.includes(e)) {
    i.push(e);
    const s = r[Za()].pathDetailsToLoad, o = Bt(t) ? Object.values(t) : Array.isArray(t) ? t : [t];
    for (let f = 0; f < o.length; f++) {
      let d = true;
      const c = /* @__PURE__ */ uc(o[f]);
      for (let u = 0; u < s.length; u++)
        s[u].includes(c) && (d = false);
      d && !c.startsWith("blob") && Ve((u) => (u.loaderInfos[Za()].pathDetailsToLoad[l].push(c), {}));
    }
  }
}
const pc = (e, t, a, i, r) => (e - t) * (r - i) / (a - t) + i;
function We() {
  const e = /* @__PURE__ */ Y((a) => a.quality), t = /* @__PURE__ */ U((a) => a.gl);
  return Math.floor(pc(e + 1, 0, 4, n.Texture.DEFAULT_ANISOTROPY ?? 4, t.capabilities.getMaxAnisotropy())), e === 2 && t.capabilities.getMaxAnisotropy(), 0;
}
const hc = z.ignoreProxy ? "" : "https://cdn.utsubo.io", kt = new Ro();
function Ce(e, t) {
  const a = Array.isArray(e) ? e.map((o) => o) : e, i = /* @__PURE__ */ U((o) => o.gl), r = /* @__PURE__ */ _c(kt, Bt(a) ? Object.values(a) : a, (o) => {
    vt(o), o.detectSupport(i), o.setTranscoderPath(`${hc}/basis/`);
  }), l = /* @__PURE__ */ I(ea.generateUUID());
  ma(l.current, a), ie(() => {
    t?.(r);
  }, [t]), ie(() => {
    (Array.isArray(r) ? r : [r]).forEach(i.initTexture);
  }, [i, r]);
  const s = /* @__PURE__ */ We();
  if (ie(() => {
    const o = Array.isArray(r) ? r : [r];
    for (const f of o)
      f.anisotropy = s, f.needsUpdate = true;
  }, [r, s]), Bt(a)) {
    const o = /* @__PURE__ */ Object.keys(a), f = {};
    return o.forEach((d) => Object.assign(f, { [d]: r[o.indexOf(d)] })), f;
  }
  return r;
}
function _c(e, t, a, i) {
  const r = Array.isArray(t) ? t : [t], l = /* @__PURE__ */ Se(xc(a, i), [e, ...r], { equal: rt.equ });
  return Array.isArray(t) ? l : l[0];
}
function xc(e, t) {
  return (a, ...i) => (e && e(a), Promise.all(i.map((r) => new Promise((l, s) => {
    a.load(r, (o) => {
      l(o);
    }, t, (o) => console.error(`Could not load ${r}: ${o.message})`));
  }))));
}
const rt = { obj: (e) => e === Object(e) && !rt.arr(e) && typeof e != "function", fun: (e) => typeof e == "function", str: (e) => typeof e == "string", num: (e) => typeof e == "number", boo: (e) => typeof e == "boolean", und: (e) => e === void 0, arr: (e) => Array.isArray(e), equ(e, t, { arrays: a = "shallow", objects: i = "reference", strict: r = true } = {}) {
  if (typeof e != typeof t || !!e != !!t)
    return false;
  if (rt.str(e) || rt.num(e))
    return e === t;
  const l = /* @__PURE__ */ rt.obj(e);
  if (l && i === "reference")
    return e === t;
  const s = /* @__PURE__ */ rt.arr(e);
  if (s && a === "reference")
    return e === t;
  if ((s || l) && e === t)
    return true;
  let o;
  for (o in e)
    if (!(o in t))
      return false;
  for (o in r ? t : e)
    if (e[o] !== t[o])
      return false;
  if (rt.und(o)) {
    if (s && e.length === 0 && t.length === 0 || l && Object.keys(e).length === 0 && Object.keys(t).length === 0)
      return true;
    if (e !== t)
      return false;
  }
  return true;
} }, yc = z.ignoreProxy ? "" : "https://cdn.utsubo.io", wn = () => {
  const { loader: e, gl: t } = /* @__PURE__ */ et();
  if (e)
    return e;
  kt.detectSupport(t), kt.setTranscoderPath(z.ignoreProxy ? "/basis/" : `${yc}/basis/`);
  const a = new Na();
  a.setDecoderPath(z.ignoreProxy ? "/draco/" : "https://www.gstatic.com/draco/versioned/decoders/1.5.6/");
  const i = new Je();
  return i.setKTX2Loader(kt), i.setDRACOLoader(a), i.setMeshoptDecoder(Ze), i.register((r) => new fc(r)), i.manager = et().loadingManager, vt(i), Ve({ loader: i }), i;
};
function bc(e, t, a, i) {
  return class extends n.RawShaderMaterial {
    constructor() {
      const r = /* @__PURE__ */ Object.entries(e);
      super({ uniforms: r.reduce((l, [s, o]) => {
        const f = /* @__PURE__ */ n.UniformsUtils.clone({ [s]: { value: o } });
        return { ...l, ...f };
      }, {}), vertexShader: t, fragmentShader: a }), r.forEach(([l]) => Object.defineProperty(this, l, { get: () => this.uniforms[l].value, set: (s) => this.uniforms[l].value = s })), i && i(this);
    }
  };
}
let va = null;
function An(e, t, a) {
  return (i) => {
    vt(i), a && a(i), e && (va || (va = new Na()), va.setDecoderPath(typeof e == "string" ? e : "/draco/"), i.setDRACOLoader(va)), t && i.setMeshoptDecoder(typeof Ze == "function" ? Ze() : Ze);
  };
}
function ot(e, t = true, a = true, i) {
  U((o) => o.gl), U((o) => o.scene);
  const r = /* @__PURE__ */ Ee(Je, e, An(t, a, i)), l = /* @__PURE__ */ I(ea.generateUUID());
  ma(l.current, e);
  const s = /* @__PURE__ */ We();
  return ie(() => {
    let o = true;
    return r.parser.getDependencies("texture").then((f) => {
      if (o)
        for (const d of f)
          d.anisotropy = s, d.needsUpdate = true;
    }), () => void (o = false);
  }, [r.parser, s]), r;
}
ot.preload = (e, t = true, a = true, i) => Ee.preload(Je, z.ignoreProxy ? e : v[e], An(t, a, i)), ot.clear = (e) => Ee.clear(Je, Array.isArray(e) ? e.map((t) => z.ignoreProxy ? t : v[t]) : z.ignoreProxy ? e : v[e]);
function wc({ all: e, scene: t, camera: a }) {
  const i = /* @__PURE__ */ U(({ gl: l }) => l);
  U(({ camera: l }) => l);
  const r = /* @__PURE__ */ U(({ scene: l }) => l);
  return ie(() => {
    const l = [];
    e && (t || r).traverse((d) => {
      d.visible === false && (l.push(d), d.visible = true);
    }), i.compileAsync(t || r);
    const s = new go(128);
    new po(0.01, 1e5, s).update(i, t || r), s.dispose(), l.forEach((f) => f.visible = false);
  }, []), null;
}
let Rt = null;
const Ac = (e, t, a, i) => {
  const [r, l] = /* @__PURE__ */ ve(null), s = /* @__PURE__ */ I(ea.generateUUID());
  ma(s.current, t);
  const o = /* @__PURE__ */ V(() => {
    const d = new n.Scene();
    return d.add(new n.Mesh(new n.BoxGeometry(1, 1, 1), new n.MeshBasicMaterial({ color: 16711680, wireframe: true }))), { scene: d, animations: [] };
  }, []), f = /* @__PURE__ */ Se(async () => {
    const d = new e();
    Cn(d, a, i), d.setDRACOLoader(Rt);
    let c = null;
    try {
      c = await new Promise(function(m, p) {
        d.load(t, m, () => {
        }, (g) => {
          console.error(g), console.error("Failed to fetch", t), l(g), p(g);
        });
      });
    } catch (u) {
      c = o, l(u);
    }
    return c || o;
  }, [t + "_glb"]);
  return r && console.warn("GLTFLoader Error:", r), f;
};
function Cn(e, t, a) {
  t && (Rt || (Rt = new Na()), Rt.setDecoderPath(typeof t == "string" ? t : "https://www.gstatic.com/draco/versioned/decoders/1.5.6/"), e.setDRACOLoader(Rt)), a && e.setMeshoptDecoder(typeof Ze == "function" ? Ze() : Ze);
}
function Cc(e, t, a) {
  return (i) => {
    vt(i), Cn(i, e, t), a && a(i);
  };
}
function ga(e, t = true, a = true, i) {
  U((s) => s.gl), U((s) => s.scene);
  const r = /* @__PURE__ */ Ac(Je, e, t, a), l = /* @__PURE__ */ We();
  return ie(() => {
    let s = true;
    return r.parser && r.parser.getDependencies("texture").then((o) => {
      if (s)
        for (const f of o)
          f.anisotropy = l, f.needsUpdate = true;
    }), () => void (s = false);
  }, [r.parser, l]), r;
}
ga.preload = (e, t = true, a = true, i) => Ee.preload(Je, z.ignoreProxy ? e : v[e], Cc(t, a, i), (r) => {
}, (r) => {
  console.warn(r);
}), ga.clear = (e) => Ee.clear(Je, Array.isArray(e) ? e.map((t) => z.ignoreProxy ? t : v[t]) : z.ignoreProxy ? e : v[e]);
function Sc(e, t) {
  const a = /* @__PURE__ */ I(), [i] = /* @__PURE__ */ ce.useState(() => t ? t instanceof n.Object3D ? { current: t } : t : a), [r] = /* @__PURE__ */ ce.useState(() => new n.AnimationMixer(t)), l = /* @__PURE__ */ ce.useRef({}), [s] = /* @__PURE__ */ ce.useState(() => {
    const o = {}, f = [];
    return e.forEach((d) => {
      o[d.name] || d.name.includes(".") || (f.push(d.name), Object.defineProperty(o, d.name, { enumerable: true, get() {
        if (i.current)
          return l.current[d.name] || (l.current[d.name] = r.clipAction(d, i.current));
      } }));
    }), { ref: i, clips: e, actions: o, names: e.map((d) => d.name), mixer: r };
  });
  return ce.useEffect(() => {
    const o = i.current;
    return () => {
      l.current = {}, Object.values(s.actions).forEach((f) => {
        o && r.uncacheAction(f, o);
      });
    };
  }, [e]), ce.useEffect(() => () => {
    r.stopAllAction();
  }, [r]), s;
}
const Sn = (e, t, a, i) => {
  const r = [];
  for (let l = 0; l < e.length; l++)
    for (let s = e[l].tracks.length - 1; s >= 0; s--)
      e[l].tracks[s].name.includes("scale") && e[l].tracks.splice(s, 1);
  for (let l = 0; l < e.length; l++)
    if (t.includes(e[l].name)) {
      const s = /* @__PURE__ */ e[l].clone();
      s.name += "_mirror", r.push(s);
    }
  return r.forEach((l) => {
    l.tracks.forEach((s, o) => {
      s.name.includes(a) ? l.tracks[o].name = s.name.replace(a, i) : s.name.includes(i) && (l.tracks[o].name = s.name.replace(i, a)), s.name.includes("quaternion") && (l.tracks[o].values = s.values.map((f, d) => (d - 1) % 4 === 0 || (d - 2) % 4 === 0 ? f * -1 : f)), s.name.includes("position") && (l.tracks[o].values = s.values.map((f, d) => d % 3 === 0 ? f * -1 : f));
    });
  }), r;
}, Lt = (e, t = z.ignoreProxy ? "/img/webp/coming-soon/0.webp" : v["/img/webp/coming-soon/0.webp"]) => Se(async () => {
  let i = t;
  if (e)
    try {
      i = await mn(e, t);
    } catch (r) {
      console.warn(r);
    }
  return i;
}, [e, t]);
function Ne(e, t) {
  const a = Array.isArray(e) ? e.map((s) => s) : e, i = /* @__PURE__ */ U((s) => s.gl), r = /* @__PURE__ */ Ee(Ra, Bt(a) ? Object.values(a) : a, vt), l = /* @__PURE__ */ I(ea.generateUUID());
  if (ma(l.current, a), ie(() => {
    t?.(r);
  }, [t]), G(() => {
    (Array.isArray(r) ? r : [r]).forEach(i.initTexture);
  }, [i, r]), Bt(a)) {
    const s = /* @__PURE__ */ Object.keys(a), o = {};
    return s.forEach((f) => Object.assign(o, { [f]: r[s.indexOf(f)] })), o;
  }
  return r;
}
Ne.preload = (e) => Ee.preload(Ra, v[e]), Ne.clear = (e) => Ee.clear(Ra, Array.isArray(e) ? e.map((t) => v[t]) : v[e]);
const Pc = (e = "konpi") => Se(async () => await (await fetch(v[`/animations/${e}/animations.json`])).json(), [`animations_list_${e}`]);
function zt(e, { path: t }) {
  const [a] = /* @__PURE__ */ Ee(Gi, [e], (i) => i.setPath(t));
  return a;
}
zt.preload = (e, { path: t }) => Ee.preload(Gi, [e], (a) => a.setPath(t));
function Mc(e, t, ...a) {
  const i = /* @__PURE__ */ useRef(), r = /* @__PURE__ */ useThree((l) => l.scene);
  return useEffect(() => (t && e && (i.current = new t(e, ...a), i.current && r.add(i.current)), () => {
    i.current && r.remove(i.current);
  }), [r, t, e, a]), i;
}
const pa = /* @__PURE__ */ De(Lo(zo(() => ({ videoQuality: 0, isVideoUserChoice: false, gpuTier: null, fps: 0, maxMemory: 0 }), { name: "sougen-video", storage: Fo(() => localStorage) })));
pa.subscribe((e) => e.videoQuality, (e, t) => {
  Pt(z.qualityPresets[Math.min(2, typeof e < "u" ? e : 0)]);
}, { fireImmediately: true });
const Ja = (e, t) => pa(e, t || Le);
Object.assign(Ja, pa);
const { getState: Dc, setState: Ec } = pa, se = (e, t = {}) => {
  e === void 0 && (e = { useLights: true, useFog: true }), e.useLights === void 0 && (e.useLights = true), e.useFog === void 0 && (e.useFog = true);
  const a = /* @__PURE__ */ Y((h) => h.useDeferred), i = /* @__PURE__ */ Y((h) => h.useFog), r = /* @__PURE__ */ Ja((h) => h.videoQuality), [l, s, o, f, d, c, u, m] = /* @__PURE__ */ Ie((h) => [h.commonUbo, h.fogData, h.lightData, h.pointsLightData, h.pointsLightsCnt, h.nearbyPlayersUbo, h.shadowMapData, h.shadowMap]), p = /* @__PURE__ */ I({ defines: {} });
  return p.current.defines.USE_LIGHTS_POINT = !!(e.useLights && !a && d > 0), p.current.defines.LIGHTS_POINT_MAX = d, p.current.defines.USE_SHADOWS = !!(e.useShadows && !At), p.current.defines.USE_NEARBYPLAYERS = !!e.useNearbyPlayers, p.current.defines.USE_UBO_FOG = !!(i && e.useFog), p.current.shadowMap = e.useShadows && !At ? m : null, Object.assign(p.current.defines, t), { uniformsGroups: V(() => {
    const h = [l];
    return i && e.useFog && h.push(s), e.useLights && (h.push(o), d > 0 && h.push(f)), e.useNearbyPlayers && c && h.push(c), e.useShadows && !At && h.push(u), h;
  }, [At, r, a, i, e.useLights, e.useNearbyPlayers, e.useShadows, e.useFog, l, s, o, d, c, f, u]), ...p.current };
}, _e = (e) => {
  const t = /* @__PURE__ */ U((s) => s.gl), a = /* @__PURE__ */ I(Va().useDeferred), i = /* @__PURE__ */ I(Va().useBloom), [r, l] = /* @__PURE__ */ Y((s) => [s.useDeferred, s.useBloom]);
  V(() => {
    const s = e.current;
    a.current !== r && s && s.__r3f && (t.properties.remove(s), t.compileAsync(s.__r3f?.parent), a.current = l);
  }, [r]), V(() => {
    const s = e.current;
    i.current !== l && s && s.__r3f && (t.properties.remove(s), t.compileAsync(s.__r3f?.parent), i.current = l);
  }, [l]);
}, $a = /* @__PURE__ */ W({ map: null, mapTransform: new n.Matrix3() }, `
  
  out vec2 vUv;
  out float vInstanceId;
  #include <common>

  void main() {
      vUv = uv;
      // vUv.y = 1.0 - vUv.y;
      vInstanceId = float(gl_InstanceID);
      #include <begin_vertex>
      vec4 mvPosition = vec4(transformed, 1.0);
      #ifdef USE_INSTANCING
        mvPosition = instanceMatrix * mvPosition;
      #endif
      gl_Position = projectionMatrix * modelViewMatrix * mvPosition;
  }`, `
  #include <layout_pars_fragment>
  #include <packing>
  
  in vec2 vUv;
  in float vInstanceId;
  
  precision mediump sampler2DArray;
  uniform sampler2DArray map;
  
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>
  
  void main() {
    vec4 diffuseColor = texture(map, vec3(vUv, vInstanceId));
  
    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(0.);
  
    #include <layout_output_fragment>
  }
  `);
$a.key = n.MathUtils.generateUUID(), N({ TextureInstanceShaderImpl: $a });
const Pn = /* @__PURE__ */ ce.forwardRef(({ ...e }, t) => {
  const a = /* @__PURE__ */ ce.useRef();
  ce.useImperativeHandle(t, () => a.current);
  const i = /* @__PURE__ */ se({ useLights: false });
  return y("textureInstanceShaderImpl", { ref: a, attach: "material", side: n.DoubleSide, ...i, ...e }, $a);
});
Pn.displayName = "TextureInstanceShader";
const ei = /* @__PURE__ */ De((e, t) => ({ focusableElements: [], focusedUuid: null, activedUuid: null, addFocusableElement: (o) => {
  const f = t().focusableElements;
  f.push(o), e({ focusableElements: f });
}, removeFocusableElement: (o) => {
  const d = /* @__PURE__ */ t().focusableElements.filter((c) => c !== o);
  e({ focusableElements: d });
}, focusNext: () => {
  const o = t().focusableElements, f = t().focusedUuid;
  let d = null;
  if (f === null && o.length > 0)
    d = o[0];
  else
    for (let c = 0; c < o.length; c++)
      o[c] === f && (o[c + 1] ? d = o[c + 1] : d = o[0]);
  e({ focusedUuid: d });
}, focusPrev: () => {
  const o = t().focusableElements, f = t().focusedUuid;
  let d = null;
  if (f === null && o.length > 0)
    d = o[o.length - 1];
  else
    for (let c = 0; c < o.length; c++)
      o[c] === f && (o[c - 1] ? d = o[c - 1] : d = o[o.length - 1]);
  e({ focusedUuid: d });
}, actionFocused: () => {
  const o = t().focusedUuid;
  e({ activedUuid: o });
} })), Mn = (e, t) => ei(e, t || Le);
Object.assign(Mn, ei);
const { getState: Tc, setState: Ic } = ei, ti = /* @__PURE__ */ De((e, t) => ({ currentPlayer: null, currenModel: null, geometriesCached: {}, font: "Noto Sans", zone: 0, zonesCnt: 1, fontLoaded: false, prevZone: null, updateFont(a) {
  if (t().font === "Noto Sans") {
    const i = `Noto Sans ${a}`;
    "fonts" in document ? document.fonts.load(`1em ${i}`).then(() => {
      e({ font: i, fontLoaded: true }), ae("updateFont", { font: i });
    }).catch((r) => {
      console.error(`Failed to load font ${i}`, r);
    }) : (e({ font: i, fontLoaded: true }), ae("updateFont", { font: i }));
  }
} })), Ft = (e, t) => ti(e, t || Le);
Object.assign(Ft, ti);
const { getState: Dn, setState: En } = ti, Uc = new n.BufferGeometry(), Bc = new n.ShaderMaterial({ vertexShader: `
    uniform sampler2D uFontAtlas;
    uniform sampler2D uEmojiAtlas;

    in float instanceEmojiIndex;
    in float instanceLineHeight;
    in vec4 instanceLayout;
    in vec4 instancePosition;
    in vec4 instanceSize;
    in vec4 instanceColor;
    flat out int vEmojiIndex;
    out vec2 vUv;
    out vec2 vBoxUV;
    out vec4 vColor;

    const vec2 quad[6] = vec2[](vec2(0), vec2(0, 1), vec2(1, 0), vec2(1, 0), vec2(0, 1), vec2(1));

    void main() {
      vec2 position = quad[gl_VertexID];
      vec2 uv = vec2(position.x, 1.0 - position.y);

      vec2 instanceUV = instanceLayout.xy;
      vec2 instanceLayoutSize = instanceLayout.zw;
      vec2 instanceBoxPosition = instancePosition.xy;
      vec2 instanceGlyphPosition = instancePosition.zw;
      vec2 instanceBoxSize = instanceSize.xy;
      vec2 instanceGlyphSize = instanceSize.zw;

      vEmojiIndex = int(instanceEmojiIndex);
      vBoxUV = (uv * instanceBoxSize - (instanceGlyphPosition - instanceBoxPosition)) / instanceGlyphSize;
      vUv = (instanceUV + vBoxUV * instanceGlyphSize) / vec2(textureSize(uFontAtlas, 0));
      vColor = instanceColor;

      vec2 vertex = (instanceBoxPosition + position.xy * instanceBoxSize - 0.5 * instanceLayoutSize) * instanceLineHeight;
      gl_Position = projectionMatrix * modelViewMatrix * instanceMatrix * vec4(vertex, 0, 1);
    }
  `, fragmentShader: `
    #include <layout_pars_fragment>

    uniform float uEmojiSize;
    uniform sampler2D uFontAtlas;
    uniform sampler2D uEmojiAtlas;
    flat in int vEmojiIndex;
    in vec2 vUv;
    in vec2 vBoxUV;
    in vec4 vColor;

    // https://github.com/Jam3/three-bmfont-text
    float aastep(float value) {
      // clamp to prevent the anti-aliasing step function from over-smoothing 
      // generating unwanted thin border around the glyphs on some GPUs
      float afwidth = min(0.05, length(vec2(dFdx(value), dFdy(value))) * 0.70710678118654757);
      return smoothstep(0.5 - afwidth, 0.5 + afwidth, value);
    }

    void main() {
      vec4 o_diffuse, o_color, o_position, o_normal;

      if (vBoxUV.x >= 0.0 && vBoxUV.x <= 1.0 && vBoxUV.y >= 0.0 && vBoxUV.y <= 1.0) {
        if (vEmojiIndex > -1) {
          float numEmojis = float(textureSize(uEmojiAtlas, 0).x) / uEmojiSize;
          float emojiWidth = 1.0 / numEmojis;
          vec2 uv = vec2(vBoxUV.x * emojiWidth + float(vEmojiIndex) * emojiWidth, 1.0 - vBoxUV.y);
          o_diffuse = texture(uEmojiAtlas, uv);
        } else {
          float dist = texture(uFontAtlas, vUv).a;
          o_diffuse = vec4(vColor.rgb, aastep(dist));
        }
      }

      o_diffuse.a *= vColor.a;

      #include <layout_output_fragment>
      // #include <tonemapping_fragment>
      #include <colorspace_fragment>
    }
  `, uniforms: { uFontAtlas: { value: new n.DataTexture() }, uEmojiAtlas: { value: new n.DataTexture() }, uEmojiSize: { value: 64 } }, side: n.DoubleSide, transparent: true, depthWrite: false, glslVersion: n.GLSL3 }), ai = /* @__PURE__ */ De((e) => ({ fontManager: null, emojiManager: null, geometry: Uc, material: Bc })), ha = (e, t) => ai(e, t || Le);
Object.assign(ha, ai);
const { getState: Me, setState: ii } = ai, Tn = 1;
function In(e, t) {
  let a = 3;
  const { player: i } = e.userData;
  return i && (a = t || 3, a *= parseFloat(i.height) * e.scale.y), a;
}
function kc(e) {
  return e.activAnimations.glide || e.activAnimations.glide_mirror ? Tn : 0;
}
function Un(e) {
  return e.modelHeight * 0.78;
}
const Rc = [], ue = { water: { water_windwalker: v["/img/ktx/water_windwalker.ktx2"] }, grid: { pattern: v["/img/patterns/pattern.png"] }, particle: { disc: v["/img/png/disc.png"] }, moss: { fractal4: v["/img/ktx/fractal4.ktx2"], dirt: v["/img/ktx/dirt.ktx2"], grass01: v["/img/ktx/grass01.ktx2"] }, gradient: { blue_noise: v["/img/ktx/blue_noise.ktx2"] }, rock: { rock_albedo: v["/img/webp/rock_albedo.webp"], rock_normal: v["/img/webp/rock_normal.webp"] }, mirror: { surface_imperfection: v["/img/ktx/surface_imperfection.ktx2"] }, rainbow: { rainbow: v["/img/ktx/rainbow.ktx2"] }, basic: { matcapRevised: v["/img/ktx/matcap-revised.ktx2"] }, noise: { noise_xs: v["/img/ktx/noise_xs.ktx2"] }, canopy: { pattern3: v["/img/ktx/pattern3.ktx2"], foliage_alpha: v["/img/ktx/foliage_alpha.ktx2"] } }, Lc = (e) => {
  const t = [];
  if (ue[e])
    for (const a in ue[e])
      t.push(ue[e][a]);
  return t;
}, ni = { abstract_1: { uastc: v["/img/patterns/uastc/abstract_1.ktx2"], png: v["/img/patterns/png/abstract_1.png"] }, abstract_1_normal: { uastc: v["/img/patterns/uastc/abstract_1_normal.ktx2"], png: v["/img/patterns/png/abstract_1_normal.png"] }, brickfloor_1: { uastc: v["/img/patterns/uastc/brickfloor_1.ktx2"], png: v["/img/patterns/png/brickfloor_1.png"] }, brickfloor_1_normal: { uastc: v["/img/patterns/uastc/brickfloor_1_normal.ktx2"], png: v["/img/patterns/png/brickfloor_1_normal.png"] }, brickfloor_2: { uastc: v["/img/patterns/uastc/brickfloor_2.ktx2"], png: v["/img/patterns/png/brickfloor_2.png"] }, brickfloor_2_normal: { uastc: v["/img/patterns/uastc/brickfloor_2_normal.ktx2"], png: v["/img/patterns/png/brickfloor_2_normal.png"] }, brickfloor_3: { uastc: v["/img/patterns/uastc/brickfloor_3.ktx2"], png: v["/img/patterns/png/brickfloor_3.png"] }, brickfloor_3_normal: { uastc: v["/img/patterns/uastc/brickfloor_3_normal.ktx2"], png: v["/img/patterns/png/brickfloor_3_normal.png"] }, brickpaver_1: { uastc: v["/img/patterns/uastc/brickpaver_1.ktx2"], png: v["/img/patterns/png/brickpaver_1.png"] }, brickpaver_1_normal: { uastc: v["/img/patterns/uastc/brickpaver_1_normal.ktx2"], png: v["/img/patterns/png/brickpaver_1_normal.png"] }, brickwall_1: { uastc: v["/img/patterns/uastc/brickwall_1.ktx2"], png: v["/img/patterns/png/brickwall_1.png"] }, brickwall_1_normal: { uastc: v["/img/patterns/uastc/brickwall_1_normal.ktx2"], png: v["/img/patterns/png/brickwall_1_normal.png"] }, brickwall_2: { uastc: v["/img/patterns/uastc/brickwall_2.ktx2"], png: v["/img/patterns/png/brickwall_2.png"] }, brickwall_2_normal: { uastc: v["/img/patterns/uastc/brickwall_2_normal.ktx2"], png: v["/img/patterns/png/brickwall_2_normal.png"] }, brickwall_3: { uastc: v["/img/patterns/uastc/brickwall_3.ktx2"], png: v["/img/patterns/png/brickwall_3.png"] }, brickwall_3_normal: { uastc: v["/img/patterns/uastc/brickwall_3_normal.ktx2"], png: v["/img/patterns/png/brickwall_3_normal.png"] }, brickwall_4: { uastc: v["/img/patterns/uastc/brickwall_4.ktx2"], png: v["/img/patterns/png/brickwall_4.png"] }, brickwall_4_normal: { uastc: v["/img/patterns/uastc/brickwall_4_normal.ktx2"], png: v["/img/patterns/png/brickwall_4_normal.png"] }, brickwall_5: { uastc: v["/img/patterns/uastc/brickwall_5.ktx2"], png: v["/img/patterns/png/brickwall_5.png"] }, brickwall_5_normal: { uastc: v["/img/patterns/uastc/brickwall_5_normal.ktx2"], png: v["/img/patterns/png/brickwall_5_normal.png"] }, concrete_1: { uastc: v["/img/patterns/uastc/concrete_1.ktx2"], png: v["/img/patterns/png/concrete_1.png"] }, concrete_1_normal: { uastc: v["/img/patterns/uastc/concrete_1_normal.ktx2"], png: v["/img/patterns/png/concrete_1_normal.png"] }, concrete_2: { uastc: v["/img/patterns/uastc/concrete_2.ktx2"], png: v["/img/patterns/png/concrete_2.png"] }, concrete_2_normal: { uastc: v["/img/patterns/uastc/concrete_2_normal.ktx2"], png: v["/img/patterns/png/concrete_2_normal.png"] }, concrete_3: { uastc: v["/img/patterns/uastc/concrete_3.ktx2"], png: v["/img/patterns/png/concrete_3.png"] }, concrete_3_normal: { uastc: v["/img/patterns/uastc/concrete_3_normal.ktx2"], png: v["/img/patterns/png/concrete_3_normal.png"] }, dotsfloor_1: { uastc: v["/img/patterns/uastc/dotsfloor_1.ktx2"], png: v["/img/patterns/png/dotsfloor_1.png"] }, dotsfloor_1_normal: { uastc: v["/img/patterns/uastc/dotsfloor_1_normal.ktx2"], png: v["/img/patterns/png/dotsfloor_1_normal.png"] }, eroded_1: { uastc: v["/img/patterns/uastc/eroded_1.ktx2"], png: v["/img/patterns/png/eroded_1.png"] }, eroded_1_normal: { uastc: v["/img/patterns/uastc/eroded_1_normal.ktx2"], png: v["/img/patterns/png/eroded_1_normal.png"] }, fence_1: { uastc: v["/img/patterns/uastc/fence_1.ktx2"], png: v["/img/patterns/png/fence_1.png"] }, fence_1_normal: { uastc: v["/img/patterns/uastc/fence_1_normal.ktx2"], png: v["/img/patterns/png/fence_1_normal.png"] }, finesand_1: { uastc: v["/img/patterns/uastc/finesand_1.ktx2"], png: v["/img/patterns/png/finesand_1.png"] }, finesand_1_normal: { uastc: v["/img/patterns/uastc/finesand_1_normal.ktx2"], png: v["/img/patterns/png/finesand_1_normal.png"] }, fishscale_1: { uastc: v["/img/patterns/uastc/fishscale_1.ktx2"], png: v["/img/patterns/png/fishscale_1.png"] }, fishscale_1_normal: { uastc: v["/img/patterns/uastc/fishscale_1_normal.ktx2"], png: v["/img/patterns/png/fishscale_1_normal.png"] }, floorpattern_1: { uastc: v["/img/patterns/uastc/floorpattern_1.ktx2"], png: v["/img/patterns/png/floorpattern_1.png"] }, floorpattern_1_normal: { uastc: v["/img/patterns/uastc/floorpattern_1_normal.ktx2"], png: v["/img/patterns/png/floorpattern_1_normal.png"] }, floortile_1: { uastc: v["/img/patterns/uastc/floortile_1.ktx2"], png: v["/img/patterns/png/floortile_1.png"] }, floortile_1_normal: { uastc: v["/img/patterns/uastc/floortile_1_normal.ktx2"], png: v["/img/patterns/png/floortile_1_normal.png"] }, floorwoodtile_1: { uastc: v["/img/patterns/uastc/floorwoodtile_1.ktx2"], png: v["/img/patterns/png/floorwoodtile_1.png"] }, floorwoodtile_1_normal: { uastc: v["/img/patterns/uastc/floorwoodtile_1_normal.ktx2"], png: v["/img/patterns/png/floorwoodtile_1_normal.png"] }, grass_1: { uastc: v["/img/patterns/uastc/grass_1.ktx2"], png: v["/img/patterns/png/grass_1.png"] }, grass_1_normal: { uastc: v["/img/patterns/uastc/grass_1_normal.ktx2"], png: v["/img/patterns/png/grass_1_normal.png"] }, grass_2: { uastc: v["/img/patterns/uastc/grass_2.ktx2"], png: v["/img/patterns/png/grass_2.png"] }, grass_2_normal: { uastc: v["/img/patterns/uastc/grass_2_normal.ktx2"], png: v["/img/patterns/png/grass_2_normal.png"] }, grass_3: { uastc: v["/img/patterns/uastc/grass_3.ktx2"], png: v["/img/patterns/png/grass_3.png"] }, grass_3_normal: { uastc: v["/img/patterns/uastc/grass_3_normal.ktx2"], png: v["/img/patterns/png/grass_3_normal.png"] }, grass_4: { uastc: v["/img/patterns/uastc/grass_4.ktx2"], png: v["/img/patterns/png/grass_4.png"] }, grass_4_normal: { uastc: v["/img/patterns/uastc/grass_4_normal.ktx2"], png: v["/img/patterns/png/grass_4_normal.png"] }, marble_1: { uastc: v["/img/patterns/uastc/marble_1.ktx2"], png: v["/img/patterns/png/marble_1.png"] }, marble_1_normal: { uastc: v["/img/patterns/uastc/marble_1_normal.ktx2"], png: v["/img/patterns/png/marble_1_normal.png"] }, mountain_1: { uastc: v["/img/patterns/uastc/mountain_1.ktx2"], png: v["/img/patterns/png/mountain_1.png"] }, mountain_1_normal: { uastc: v["/img/patterns/uastc/mountain_1_normal.ktx2"], png: v["/img/patterns/png/mountain_1_normal.png"] }, pattern_1: { uastc: v["/img/patterns/uastc/pattern_1.ktx2"], png: v["/img/patterns/png/pattern_1.png"] }, pattern_1_normal: { uastc: v["/img/patterns/uastc/pattern_1_normal.ktx2"], png: v["/img/patterns/png/pattern_1_normal.png"] }, pattern_2: { uastc: v["/img/patterns/uastc/pattern_2.ktx2"], png: v["/img/patterns/png/pattern_2.png"] }, pattern_2_normal: { uastc: v["/img/patterns/uastc/pattern_2_normal.ktx2"], png: v["/img/patterns/png/pattern_2_normal.png"] }, pattern_3: { uastc: v["/img/patterns/uastc/pattern_3.ktx2"], png: v["/img/patterns/png/pattern_3.png"] }, pattern_3_normal: { uastc: v["/img/patterns/uastc/pattern_3_normal.ktx2"], png: v["/img/patterns/png/pattern_3_normal.png"] }, pattern_4: { uastc: v["/img/patterns/uastc/pattern_4.ktx2"], png: v["/img/patterns/png/pattern_4.png"] }, pattern_4_normal: { uastc: v["/img/patterns/uastc/pattern_4_normal.ktx2"], png: v["/img/patterns/png/pattern_4_normal.png"] }, pattern_5: { uastc: v["/img/patterns/uastc/pattern_5.ktx2"], png: v["/img/patterns/png/pattern_5.png"] }, pattern_5_normal: { uastc: v["/img/patterns/uastc/pattern_5_normal.ktx2"], png: v["/img/patterns/png/pattern_5_normal.png"] }, pattern_6: { uastc: v["/img/patterns/uastc/pattern_6.ktx2"], png: v["/img/patterns/png/pattern_6.png"] }, pattern_6_normal: { uastc: v["/img/patterns/uastc/pattern_6_normal.ktx2"], png: v["/img/patterns/png/pattern_6_normal.png"] }, pebble_1: { uastc: v["/img/patterns/uastc/pebble_1.ktx2"], png: v["/img/patterns/png/pebble_1.png"] }, pebble_1_normal: { uastc: v["/img/patterns/uastc/pebble_1_normal.ktx2"], png: v["/img/patterns/png/pebble_1_normal.png"] }, rectangle_1: { uastc: v["/img/patterns/uastc/rectangle_1.ktx2"], png: v["/img/patterns/png/rectangle_1.png"] }, rectangle_1_normal: { uastc: v["/img/patterns/uastc/rectangle_1_normal.ktx2"], png: v["/img/patterns/png/rectangle_1_normal.png"] }, rectangle_2: { uastc: v["/img/patterns/uastc/rectangle_2.ktx2"], png: v["/img/patterns/png/rectangle_2.png"] }, road_1: { uastc: v["/img/patterns/uastc/road_1.ktx2"], png: v["/img/patterns/png/road_1.png"] }, road_1_normal: { uastc: v["/img/patterns/uastc/road_1_normal.ktx2"], png: v["/img/patterns/png/road_1_normal.png"] }, road_2: { uastc: v["/img/patterns/uastc/road_2.ktx2"], png: v["/img/patterns/png/road_2.png"] }, road_2_normal: { uastc: v["/img/patterns/uastc/road_2_normal.ktx2"], png: v["/img/patterns/png/road_2_normal.png"] }, rock_1: { uastc: v["/img/patterns/uastc/rock_1.ktx2"], png: v["/img/patterns/png/rock_1.png"] }, rock_1_normal: { uastc: v["/img/patterns/uastc/rock_1_normal.ktx2"], png: v["/img/patterns/png/rock_1_normal.png"] }, roof_1: { uastc: v["/img/patterns/uastc/roof_1.ktx2"], png: v["/img/patterns/png/roof_1.png"] }, roof_1_normal: { uastc: v["/img/patterns/uastc/roof_1_normal.ktx2"], png: v["/img/patterns/png/roof_1_normal.png"] }, roof_2: { uastc: v["/img/patterns/uastc/roof_2.ktx2"], png: v["/img/patterns/png/roof_2.png"] }, roof_2_normal: { uastc: v["/img/patterns/uastc/roof_2_normal.ktx2"], png: v["/img/patterns/png/roof_2_normal.png"] }, roof_3: { uastc: v["/img/patterns/uastc/roof_3.ktx2"], png: v["/img/patterns/png/roof_3.png"] }, roof_3_normal: { uastc: v["/img/patterns/uastc/roof_3_normal.ktx2"], png: v["/img/patterns/png/roof_3_normal.png"] }, soil_1: { uastc: v["/img/patterns/uastc/soil_1.ktx2"], png: v["/img/patterns/png/soil_1.png"] }, soil_1_normal: { uastc: v["/img/patterns/uastc/soil_1_normal.ktx2"], png: v["/img/patterns/png/soil_1_normal.png"] }, stonecliff_1: { uastc: v["/img/patterns/uastc/stonecliff_1.ktx2"], png: v["/img/patterns/png/stonecliff_1.png"] }, stonecliff_1_normal: { uastc: v["/img/patterns/uastc/stonecliff_1_normal.ktx2"], png: v["/img/patterns/png/stonecliff_1_normal.png"] }, straightlines_1: { uastc: v["/img/patterns/uastc/straightlines_1.ktx2"], png: v["/img/patterns/png/straightlines_1.png"] }, straightlines_1_normal: { uastc: v["/img/patterns/uastc/straightlines_1_normal.ktx2"], png: v["/img/patterns/png/straightlines_1_normal.png"] }, terrain_1: { uastc: v["/img/patterns/uastc/terrain_1.ktx2"], png: v["/img/patterns/png/terrain_1.png"] }, terrain_1_normal: { uastc: v["/img/patterns/uastc/terrain_1_normal.ktx2"], png: v["/img/patterns/png/terrain_1_normal.png"] }, treetrunk_1: { uastc: v["/img/patterns/uastc/treetrunk_1.ktx2"], png: v["/img/patterns/png/treetrunk_1.png"] }, treetrunk_1_normal: { uastc: v["/img/patterns/uastc/treetrunk_1_normal.ktx2"], png: v["/img/patterns/png/treetrunk_1_normal.png"] }, treetrunk_2: { uastc: v["/img/patterns/uastc/treetrunk_2.ktx2"], png: v["/img/patterns/png/treetrunk_2.png"] }, treetrunk_2_normal: { uastc: v["/img/patterns/uastc/treetrunk_2_normal.ktx2"], png: v["/img/patterns/png/treetrunk_2_normal.png"] }, triangles_1: { uastc: v["/img/patterns/uastc/triangles_1.ktx2"], png: v["/img/patterns/png/triangles_1.png"] }, triangles_1_normal: { uastc: v["/img/patterns/uastc/triangles_1_normal.ktx2"], png: v["/img/patterns/png/triangles_1_normal.png"] }, water_1: { uastc: v["/img/patterns/uastc/water_1.ktx2"], png: v["/img/patterns/png/water_1.png"] }, water_1_normal: { uastc: v["/img/patterns/uastc/water_1_normal.ktx2"], png: v["/img/patterns/png/water_1_normal.png"] }, wood_1: { uastc: v["/img/patterns/uastc/wood_1.ktx2"], png: v["/img/patterns/png/wood_1.png"] }, wood_1_normal: { uastc: v["/img/patterns/uastc/wood_1_normal.ktx2"], png: v["/img/patterns/png/wood_1_normal.png"] }, wood_2: { uastc: v["/img/patterns/uastc/wood_2.ktx2"], png: v["/img/patterns/png/wood_2.png"] }, wood_2_normal: { uastc: v["/img/patterns/uastc/wood_2_normal.ktx2"], png: v["/img/patterns/png/wood_2_normal.png"] }, woodtile_chevron: { uastc: v["/img/patterns/uastc/woodtile_chevron.ktx2"], png: v["/img/patterns/png/woodtile_chevron.png"] }, woodtile_chevron_normal: { uastc: v["/img/patterns/uastc/woodtile_chevron_normal.ktx2"], png: v["/img/patterns/png/woodtile_chevron_normal.png"] }, japan_bamboowall: { png: v["/img/patterns/png/japan_bamboowall.png"], uastc: v["/img/patterns/uastc/japan_bamboowall.png"] }, japan_bamboowall_normal: { png: v["/img/patterns/png/japan_bamboowall_normal.png"], uastc: v["/img/patterns/uastc/japan_bamboowall_normal.png"] }, japan_castlewall: { png: v["/img/patterns/png/japan_castlewall.png"], uastc: v["/img/patterns/uastc/japan_castlewall.png"] }, japan_castlewall_normal: { png: v["/img/patterns/png/japan_castlewall_normal.png"], uastc: v["/img/patterns/uastc/japan_castlewall_normal.png"] }, japan_concreteblocks: { png: v["/img/patterns/png/japan_concreteblocks.png"], uastc: v["/img/patterns/uastc/japan_concreteblocks.png"] }, japan_concreteblocks_normal: { png: v["/img/patterns/png/japan_concreteblocks_normal.png"], uastc: v["/img/patterns/uastc/japan_concreteblocks_normal.png"] }, japan_concretebricks: { png: v["/img/patterns/png/japan_concretebricks.png"], uastc: v["/img/patterns/uastc/japan_concretebricks.png"] }, japan_concretebricks_normal: { png: v["/img/patterns/png/japan_concretebricks_normal.png"], uastc: v["/img/patterns/uastc/japan_concretebricks_normal.png"] }, japan_concreterough: { png: v["/img/patterns/png/japan_concreterough.png"], uastc: v["/img/patterns/uastc/japan_concreterough.png"] }, japan_concreterough_normal: { png: v["/img/patterns/png/japan_concreterough_normal.png"], uastc: v["/img/patterns/uastc/japan_concreterough_normal.png"] }, japan_lampion_normal: { png: v["/img/patterns/png/japan_lampion_normal.png"], uastc: v["/img/patterns/uastc/japan_lampion_normal.png"] }, japan_panels: { png: v["/img/patterns/png/japan_panels.png"], uastc: v["/img/patterns/uastc/japan_panels.png"] }, japan_panels_normal: { png: v["/img/patterns/png/japan_panels_normal.png"], uastc: v["/img/patterns/uastc/japan_panels_normal.png"] }, japan_pebbleground: { png: v["/img/patterns/png/japan_pebbleground.png"], uastc: v["/img/patterns/uastc/japan_pebbleground.png"] }, japan_pebbleground_normal: { png: v["/img/patterns/png/japan_pebbleground_normal.png"], uastc: v["/img/patterns/uastc/japan_pebbleground_normal.png"] }, japan_planks_bleached: { png: v["/img/patterns/png/japan_planks_bleached.png"], uastc: v["/img/patterns/uastc/japan_planks_bleached.png"] }, japan_planks_normal: { png: v["/img/patterns/png/japan_planks_normal.png"], uastc: v["/img/patterns/uastc/japan_planks_normal.png"] }, japan_plasterwallfine_normal: { png: v["/img/patterns/png/japan_plasterwallfine_normal.png"], uastc: v["/img/patterns/uastc/japan_plasterwallfine_normal.png"] }, japan_plasterwallold_normal: { png: v["/img/patterns/png/japan_plasterwallold_normal.png"], uastc: v["/img/patterns/uastc/japan_plasterwallold_normal.png"] }, japan_plasterwallrough_normal: { png: v["/img/patterns/png/japan_plasterwallrough_normal.png"], uastc: v["/img/patterns/uastc/japan_plasterwallrough_normal.png"] }, japan_plasterwallstandard_normal: { png: v["/img/patterns/png/japan_plasterwallstandard_normal.png"], uastc: v["/img/patterns/uastc/japan_plasterwallstandard_normal.png"] }, japan_roughasphalt_normal: { png: v["/img/patterns/png/japan_roughasphalt_normal.png"], uastc: v["/img/patterns/uastc/japan_roughasphalt_normal.png"] }, japan_sand: { png: v["/img/patterns/png/japan_sand.png"], uastc: v["/img/patterns/uastc/japan_sand.png"] }, japan_sand_normal: { png: v["/img/patterns/png/japan_sand_normal.png"], uastc: v["/img/patterns/uastc/japan_sand_normal.png"] }, japan_tatami_normal: { png: v["/img/patterns/png/japan_tatami_normal.png"], uastc: v["/img/patterns/uastc/japan_tatami_normal.png"] }, japan_tatamiblack: { png: v["/img/patterns/png/japan_tatamiblack.png"], uastc: v["/img/patterns/uastc/japan_tatamiblack.png"] }, japan_tatamitraditional: { png: v["/img/patterns/png/japan_tatamitraditional.png"], uastc: v["/img/patterns/uastc/japan_tatamitraditional.png"] }, japan_terrace: { png: v["/img/patterns/png/japan_terrace.png"], uastc: v["/img/patterns/uastc/japan_terrace.png"] }, japan_terrace_normal: { png: v["/img/patterns/png/japan_terrace_normal.png"], uastc: v["/img/patterns/uastc/japan_terrace_normal.png"] }, japan_weatheredasphalt: { png: v["/img/patterns/png/japan_weatheredasphalt.png"], uastc: v["/img/patterns/uastc/japan_weatheredasphalt.png"] }, japan_weatheredasphalt_normal: { png: v["/img/patterns/png/japan_weatheredasphalt_normal.png"], uastc: v["/img/patterns/uastc/japan_weatheredasphalt_normal.png"] }, japan_weatheredasphalt_wide_det: { png: v["/img/patterns/png/japan_weatheredasphalt_wide_det.png"], uastc: v["/img/patterns/uastc/japan_weatheredasphalt_wide_det.png"] }, japan_weatheredasphalt_wide_det_normal: { png: v["/img/patterns/png/japan_weatheredasphalt_wide_det_normal.png"], uastc: v["/img/patterns/uastc/japan_weatheredasphalt_wide_det_normal.png"] }, japan_wood: { png: v["/img/patterns/png/japan_wood.png"], uastc: v["/img/patterns/uastc/japan_wood.png"] }, japan_wood_normal: { png: v["/img/patterns/png/japan_wood_normal.png"], uastc: v["/img/patterns/uastc/japan_wood_normal.png"] } }, Bn = ({ step: e, children: t }) => {
  const [a, i] = /* @__PURE__ */ ra((r) => [r.loadingStep, r.forceFinishLoader], (r, l) => {
    const [s] = r, [o, f] = l;
    return !(s !== o && (o === e || f));
  });
  return (a >= e || i) && t;
};
function zc() {
  const e = /* @__PURE__ */ document.createElement("canvas");
  e.width = 256, e.height = 256;
  const t = /* @__PURE__ */ e.getContext("2d");
  for (let a = 0; a < 2e4; ++a)
    t.fillStyle = `rgba(255,${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},1)`, t.fillRect(Math.random() * e.width, Math.random() * e.height, 2, 2);
  return e;
}
var Fc = `#include <layout_pars_fragment>

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>


uniform float opacity;
uniform sampler2D map;
uniform sampler2D t_dirt;
uniform sampler2D t_moss;
uniform sampler2D parallaxMap;

in float vOffset;


uniform vec3 u_dirt;
uniform vec3 u_grass;
uniform vec3 u_grass2;

uniform float parallaxLayers;

in vec2 vUv;
in vec3 vViewPosition;
in vec3 vWorldPosition;

#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <lightmap_pars_fragment>
#include <normal_pars_fragment>


#include <shadows_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>


float drawDirection (vec2 p1, vec2 p2, vec2 uv, float offset, float a, float start, float end)
{
    float r = 0.;
    float d = distance(p1, p2);
    
    float duv = distance(p1, uv);
    float duv2 = distance(p2, uv);

    float aa = a * (1. - smoothstep(offset / 1.5 + 0., offset + 1., duv));

    r = 1. - floor(1.-(aa) + distance(mix(p1, p2, clamp(duv/d, start, end)), uv));

    return r;
}


void main() {
  vec2 worldUv = vWorldPosition.xz / 1000.;

  vec2 uv = vUv;
  vec3 color = vColor;
  float playerFoldingArea = 1. - smoothstep(0., .5, distance(vWorldPosition.xz, playerPos.xz));
  float dirtFactor = 1. - smoothstep(0.0, 1., color.b);
  vec4 diffuseColor =  vec4(mix(u_grass, u_dirt, dirtFactor), 1.);

  
  #ifdef USE_COLOR
    diffuseColor.rgb = mix(diffuseColor.rgb, u_grass2, color.g);
  #endif

  if (vOffset > 0.0 && parallaxLayers > 0.) {
    #ifdef USE_PARALLAX

      float windNoise = sin(time * 2.) * 0.05 * vOffset * texture(t_moss, worldUv * 1280. ).r;
      // fold grass reflected from playerposition
      windNoise *= smoothstep(0., 1., distance(vWorldPosition.xz, playerPos.xz));

      float parallaxAlpha = mix(texture(parallaxMap, vWorldPosition.xz / 2.5 - windNoise).g, 1., dirtFactor - playerFoldingArea);
      diffuseColor.a *= color.r + dirtFactor;
      diffuseColor.a -= (1. - color.r - dirtFactor) * .2;
      diffuseColor.a = saturate(diffuseColor.a);

      // // discard no hairs + above the max length
      if ((diffuseColor.a < 0.0 || parallaxAlpha < vOffset)) {
        discard;
      }
    #endif
  }

 
  vec2 dirtUv = vWorldPosition.xz / 10.;
  
  // diffuseColor.rgb = mix(diffuseColor.rgb, diffuseColor.rgb - .3, saturate((1. - pow(texture( t_dirt, dirtUv).r, 10.))) * dirtFactor);
  
  diffuseColor.rgb -= playerFoldingArea * .2;
  diffuseColor.a = 1.;
  

  if (vOffset == 0.0 && parallaxLayers > 0.) {
    diffuseColor.rgb *= .8;
  } else {
    diffuseColor.rgb *= min(1., (vOffset + .8));
  }

  #include <alphamap_fragment>
  #include <normal_fragment_begin>

  vec4 o_color = vec4(color, 1.);

  normal -= vOffset * (1. - dirtFactor);

  vec4 o_diffuse = diffuseColor;

  #include <shadows_fragment>

  float toonShading = .5;

  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  #include <layout_output_fragment>
}
`, Nc = `#include <common>

#include <common_ubo_pars>

out vec3 vViewPosition;
out vec2 vUv;
out vec3 vWorldPosition;
out float vOffset;
uniform float repeat;
uniform float parallaxLayers;
uniform mat3 uvTransform;
uniform mat4 viewMatrixCamera;

#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>

#ifdef USE_PARALLAX
  // snoise
  vec3 mod289(vec3 x) {return x - floor(x * (1.0 / 289.0)) * 289.0;} vec2 mod289(vec2 x) {return x - floor(x * (1.0 / 289.0)) * 289.0;} vec3 permute(vec3 x) {return mod289(((x*34.0)+1.0)*x);} float snoise(vec2 v){const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439); vec2 i  = floor(v + dot(v, C.yy) ); vec2 x0 = v -   i + dot(i, C.xx); vec2 i1; i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0); vec4 x12 = x0.xyxy + C.xxzz; x12.xy -= i1; i = mod289(i); vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 )) + i.x + vec3(0.0, i1.x, 1.0 )); vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0); m = m*m ; m = m*m ; vec3 x = 2.0 * fract(p * C.www) - 1.0; vec3 h = abs(x) - 0.5; vec3 ox = floor(x + 0.5); vec3 a0 = x - ox; m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h ); vec3 g; g.x  = a0.x  * x0.x  + h.x  * x0.y; g.yz = a0.yz * x12.xz + h.yz * x12.yw; return 130.0 * dot(m, g);}
#endif
#ifdef USE_TRIPLANAR
  out vec3 vWorldNorm;
#endif

#include <shadows_pars_vertex>

void main() {
  vUv = (uvTransform * vec3(uv, 1.)).xy;
  #include <color_vertex>
  #include <beginnormal_vertex>
  #include <morphnormal_vertex>
  #include <skinbase_vertex>
  #include <skinnormal_vertex>
  #include <defaultnormal_vertex>
  #include <normal_vertex>
  #include <begin_vertex>
  #include <batchingbase_vertex>

  #include <morphtarget_vertex>
  #include <skinning_vertex>
  #include <displacementmap_vertex>
  
  vec4 mvPosition = vec4(transformed, 1.0);

  vec4 mPosition = mvPosition;

  mPosition = modelMatrix * mPosition;


  #ifdef USE_BATCHING
    mPosition = batchingMatrix * mPosition;
  #endif


  #ifdef USE_INSTANCING
    mPosition = instanceMatrix * mPosition;
  #endif

  #ifdef USE_PARALLAX
    float factorFur = smoothstep(0.2, .6, color.b);
    vOffset = ((float(gl_InstanceID)) / parallaxLayers);
    
    if (parallaxLayers > 0.) {
      float spacing = 0.01 / pow(repeat, .4);
      float noise = 1.0-(snoise(vec2((time/3.5-uv.x*60.), (time/5.5-uv.y*60.)))); 

      vec3 displacement = vec3(0.0,0.0,0.0);
      vec3 forceDirection = vec3(0.0,0.0,0.0);
      vec3 pos = position;
      float factor = .01 * (1. - vColor.g);
      // "wind"
      forceDirection.x = sin(noise * 5.+position.x*0.24) * factor;
      forceDirection.y = cos(noise * 5.*0.7+position.y*0.04) * factor;
      forceDirection.z = sin(noise * 5.*0.7+position.y*0.24) * factor;


      // "gravity"
      displacement = forceDirection;
      displacement *= noise;
      float displacementFactor = pow(vOffset, 3.0) * factorFur;

      // float tempzPos = -(viewMatrix * modelMatrix * mvPosition).z;

      float dist = distance(mPosition.xz, playerPos.xz);

      mPosition.y += vOffset * .2 * (smoothstep(0., 1., dist) * smoothstep(0.0, 1., vColor.b) + .2);
      // prevent flick from far depth issue
      // spacing *= 1. + smoothstep(0., 1500., tempzPos) * 10.;

      vec3 aNormal = normal;
      aNormal.xyz += displacement*displacementFactor;

   
    }
  #endif
  

  if (parallaxLayers > 0.) {
      float depth = -(viewMatrix * mPosition).z;
      // mvPosition.y += smoothstep(50., 1000., depth);
  }
  gl_Position = projectionMatrix * (viewMatrix * mPosition);

  vViewPosition = -(viewMatrix * mPosition).xyz;
  #include <worldpos_vertex>
  #include <shadowmap_vertex>
  #include <fog_vertex>

  
  vWorldPosition = (mPosition).xyz;

  vec4 worldPosition = mPosition;

  #include <shadows_vertex>

}
`;
const Oc = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), parallaxMap: null, tFractal: null, t_dirt: null, t_moss: null, u_dirt: new n.Color(14474415), u_grass: new n.Color(9747526), u_grass2: new n.Color(9747526), vertexColors: 2, map: null, mapTransform: new n.Matrix3(), repeat: 1, parallaxLayers: 0, instanceAmount: 0 }, Nc, Fc, null), Gc = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ MossShaderImpl: Oc });
const kn = /* @__PURE__ */ Z(function(t, a) {
  const [i, r] = /* @__PURE__ */ Ce([ue.moss.dirt, ue.moss.grass01], (o) => {
    o[0].wrapS = o[0].wrapT = n.RepeatWrapping, o[0].colorSpace = n.LinearSRGBColorSpace, o[0].needsUpdate = true, o[1].wrapS = o[1].wrapT = n.RepeatWrapping, o[1].colorSpace = n.LinearSRGBColorSpace, o[1].needsUpdate = true;
  }), l = /* @__PURE__ */ I(null);
  ge(a, () => l.current), _e(l);
  const s = /* @__PURE__ */ se({ useShadows: true, useFog: true }, t.defines);
  return y("mossShaderImpl", { attach: "material", ref: l, glslVersion: n.GLSL3, side: n.FrontSide, normalScale: new n.Vector2(1, 1), vertexColors: 2, u_dirt: "#fcfcbd", u_grass: "#94bc46", u_grass2: "#94bc46", t_moss: r, t_dirt: i, ...t, ...s, transparent: false }, Gc);
}), Hc = ({ children: e, mesh: t, color: a, color2: i, dirt: r, frustumCulled: l = true, frames: s = 1, repeat: o = 1, useTriplanar: f, useFractalColorMap: d, withFallback: c, hideFirstLayer: u, ...m }) => {
  const p = /* @__PURE__ */ Y((S) => S.quality), g = p === 0 ? u ? 0 : 1 : 10, h = /* @__PURE__ */ U(({ get: S }) => S), [C, _] = /* @__PURE__ */ V(() => {
    const S = new n.Texture(zc());
    S.wrapS = S.wrapT = n.RepeatWrapping, S.anisotropy = h().gl.capabilities.getMaxAnisotropy(), S.needsUpdate = true;
    const M = [];
    for (let D = 0; D < g; D++)
      M.push(D / g);
    return [M, S];
  }, [g]), x = /* @__PURE__ */ I();
  let b = 0;
  const w = /* @__PURE__ */ V(() => new n.Object3D(), []), P = (S) => {
    for (let M = 0; M < g; M++)
      w.rotation.copy(S.rotation), w.position.copy(S.position), w.scale.copy(S.scale), w.updateMatrix(), w.updateMatrixWorld(false, false), S.setMatrixAt(M, w.matrixWorld);
    S.instanceMatrix.needsUpdate = true;
  };
  return q(() => {
    const S = x.current;
    !S || !S || (s === 1 / 0 || b < s) && (P(S), b++);
  }, z.renderPriority.default / 2), y("instancedMesh", { args: [t.geometry, null, g, p], ...m, ref: x, limit: g, range: g, receiveShadow: true, castShadow: false, geometry: t.geometry, frustumCulled: false, onUpdate: (S) => {
    setTimeout(() => {
      S.geometry && S.computeBoundingSphere();
    }, 0), P(S);
  }, children: y(de, { fallback: y("meshBasicMaterial", { visible: c, color: a || 9747526, wireframe: true }), children: y(kn, { defines: { USE_PARALLAX: true, USE_TRIPLANAR: !!f, USE_FRACTAL_COLORMAP: !!d }, repeat: o, vertexColors: 2, u_grass: a || 9747526, u_grass2: i || 9747526, u_dirt: r || 14474415, parallaxMap: _, normalScale: new n.Vector2(1, 1), parallaxLayers: g, reflectivity: 0.8 }) }) });
};
var Vc = `#include <layout_pars_fragment>
in vec3 vWorldPosition;
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
uniform float metalness;
uniform sampler2D alphaMap;


uniform sampler2D tDiffuse;
uniform sampler2D distortionMap;
uniform float distortion;
uniform float cameraNear;
uniform float cameraFar;
uniform float mirror;
uniform float roughness;
uniform float mixStrength;
uniform float mixContrast;
in vec4 my_vUv;
in vec2 vUv;

in vec3 vViewPosition;


#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

// sougen deferred light system

#include <deferred_lights_pars>

#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>

#include <shadows_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );

	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>


  // albedo

  float distortionFactor = 0.0;
  // #ifdef USE_DISTORTION
    distortionFactor = texture2D(distortionMap, vUv).g * 4.;
  // #endif

  vec4 new_vUv = my_vUv;
  new_vUv.x += distortionFactor;
  new_vUv.y += distortionFactor;

  vec4 base = texture2DProj(tDiffuse, new_vUv);

  vec4 merge = base;

  #ifdef USE_NORMALMAP
    vec2 normal_uv = vec2(0.0);
    vec4 normalColor = texture2D(normalMap, vUv * normalScale);
    vec3 my_normal = normalize( vec3( normalColor.r * 2.0 - 1.0, normalColor.b,  normalColor.g * 2.0 - 1.0 ) );
    vec3 coord = new_vUv.xyz / new_vUv.w;
    normal_uv = coord.xy + coord.z * my_normal.xz * 0.05;
    vec4 base_normal = texture2D(tDiffuse, normal_uv);
    merge = base_normal;
  #endif

  // Sougen deferred lighting  
  vec3 ambient = Light.ambient.xyz * max(Light.ambient.w, 0.0);
  vec3 irradiance = ambient + getDirectLighting(vWorldPosition, normal, 0., 0., 0.);
  diffuseColor.rgb = irradiance * diffuseColor.rgb;

  // Point "scene" lighting
  #ifdef USE_LIGHTS_POINT
    // Point "scene" lighting
    for (int j = 0; j < LIGHTS_POINT_MAX; j++) {
      vec3 pointDiffuse = getPointLighting(pointLight[j], vWorldPosition, normal, 0., 0.);
      diffuseColor.rgb += diffuseColor.rgb * pointDiffuse;
    }
  #endif



  float reflectorRoughnessFactor = 1.;
  // #ifdef USE_ROUGHNESSMAP
    vec4 reflectorTexelRoughness = texture2D( distortionMap, vUv * 6. ) * 5.;
    vec4 reflectorTexelRoughness2 = texture2D( distortionMap, vUv * .35 * 6. ) * 5.;
    reflectorRoughnessFactor *= reflectorTexelRoughness.g + reflectorTexelRoughness2.g;
  // #endif


  vec4 newMerge = vec4(0.0, 0.0, 0.0, 1.0);
  newMerge.r = (merge.r - 0.5) * mixContrast + 0.5;
  newMerge.g = (merge.g - 0.5) * mixContrast + 0.5;
  newMerge.b = (merge.b - 0.5) * mixContrast + 0.5;
  
  diffuseColor.rgb = diffuseColor.rgb * ((1.0 - min(1.0, 1.)) + newMerge.rgb);

  // specular shiny reflection

  float toonShading = 0.;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif



  #include <shadows_fragment>

  #ifndef USE_SHADOWS
    float shadow = 0.0;
  #endif

  diffuseColor.rgb -= shadow * .3;

  vec4 o_diffuse = diffuseColor;
  vec4 o_color = vec4(vec3(0.), 1.);
  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, shadow);

  // #include <forward_lights_fragment>
  #include <layout_output_fragment>
}
`, Wc = `#define MIRROR

out vec3 vWorldPosition;

#include <common>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadows_pars_vertex>

out vec3 vViewPosition;


uniform mat4 textureMatrix;
out vec4 my_vUv;
out vec2 vUv;

void main() {

  vUv = uv;

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>


  vec3 transformedNormal = objectNormal;

  #ifdef USE_INSTANCING

    // this is in lieu of a per-instance normal-matrix
    // shear transforms in the instance matrix are not supported

    mat3 m = mat3( instanceMatrix );

    transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );

    transformedNormal = m * transformedNormal;

  #endif

  transformedNormal = normalMatrix * transformedNormal;

  #ifdef FLIP_SIDED

    transformedNormal = - transformedNormal;

  #endif

  #ifdef USE_TANGENT

    vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;

    #ifdef FLIP_SIDED

      transformedTangent = - transformedTangent;

    #endif

  #endif

	// #include <defaultnormal_vertex>

  // normal
	#include <normal_vertex>

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>

  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif




  vViewPosition = - mvPosition.xyz;

	worldPosition = modelMatrix * worldPosition;

  // position
  vWorldPosition = (worldPosition).xyz;

  #include <shadows_vertex>
  my_vUv = textureMatrix * vec4( transformed, 1.0 );
}
`;
const jc = /* @__PURE__ */ W({ shadowMap: null, diffuse: new n.Color(16777215), mixStrength: 1, resolution: 256, mirror: 1, distortion: 1, opacity: 1, debug: 0, mixContrast: 1, distortionMap: null, roughness: 0.5, my_vUv: new n.Vector4(), textureMatrix: new n.Matrix4(), tDiffuse: null }, Wc, Vc), Qc = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ MirrorShaderImpl: jc });
const Rn = /* @__PURE__ */ Z(function(t, a) {
  const i = /* @__PURE__ */ I(null);
  ge(a, () => i.current);
  const r = /* @__PURE__ */ se({ useShadow: true });
  return bt("mirrorShaderImpl", { glslVersion: n.GLSL3, ...t, ref: i, attach: "material", key: Qc, ...r });
}), Ln = /* @__PURE__ */ A.forwardRef(function({ mixStrength: t = 1, resolution: a = 1024, color: i = "#ffffff", mirror: r = 0, opacity: l = 1, distortion: s = 1, roughness: o = 0.2, mixContrast: f = 1, reflectorOffset: d = 0, ...c }, u) {
  const m = /* @__PURE__ */ Y((j) => j.samples), p = /* @__PURE__ */ Ce(ue.mirror.surface_imperfection);
  p.wrapS = p.wrapT = ho, p.repeat = new me(15, 15), p.colorSpace = _o, p.needsUpdate = true;
  const g = /* @__PURE__ */ U(({ gl: j }) => j), h = /* @__PURE__ */ U(({ camera: j }) => j), C = /* @__PURE__ */ U(({ scene: j }) => j), _ = /* @__PURE__ */ A.useRef(null), [x] = /* @__PURE__ */ A.useState(() => new xo()), [b] = /* @__PURE__ */ A.useState(() => new pe()), [w] = /* @__PURE__ */ A.useState(() => new pe()), [P] = /* @__PURE__ */ A.useState(() => new pe()), [S] = /* @__PURE__ */ A.useState(() => new Ba()), [M] = /* @__PURE__ */ A.useState(() => new pe(0, 0, -1)), [D] = /* @__PURE__ */ A.useState(() => new La()), [T] = /* @__PURE__ */ A.useState(() => new pe()), [R] = /* @__PURE__ */ A.useState(() => new pe()), [L] = /* @__PURE__ */ A.useState(() => new La()), [k] = /* @__PURE__ */ A.useState(() => new Ba()), [E] = /* @__PURE__ */ A.useState(() => new zi()), O = /* @__PURE__ */ Bo(_);
  A.useImperativeHandle(u, () => _.current);
  const J = /* @__PURE__ */ A.useCallback(() => {
    const j = O.current?.parent;
    if (!j || (w.setFromMatrixPosition(j.matrixWorld), P.setFromMatrixPosition(h.matrixWorld), S.extractRotation(j.matrixWorld), b.set(0, 0, 1), b.applyMatrix4(S), w.addScaledVector(b, d), T.subVectors(w, P), T.dot(b) > 0))
      return;
    T.reflect(b).negate(), T.add(w), S.extractRotation(h.matrixWorld), M.set(0, 0, -1), M.applyMatrix4(S), M.add(P), R.subVectors(w, M), R.reflect(b).negate(), R.add(w), E.position.copy(T), E.up.set(0, 1, 0), E.up.applyMatrix4(S), E.up.reflect(b), E.updateMatrix(), E.lookAt(R), E.far = h.far, E.updateMatrix(), E.updateMatrixWorld(), E.projectionMatrix.copy(h.projectionMatrix), k.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1), k.multiply(E.projectionMatrix), k.multiply(E.matrixWorldInverse), k.multiply(j.matrixWorld), x.setFromNormalAndCoplanarPoint(b, w), x.applyMatrix4(E.matrixWorldInverse), D.set(x.normal.x, x.normal.y, x.normal.z, x.constant);
    const F = E.projectionMatrix;
    L.x = (Math.sign(D.x) + F.elements[8]) / F.elements[0], L.y = (Math.sign(D.y) + F.elements[9]) / F.elements[5], L.z = -1, L.w = (1 + F.elements[10]) / F.elements[14], D.multiplyScalar(2 / D.dot(L)), F.elements[2] = D.x, F.elements[6] = D.y, F.elements[10] = D.z + 1, F.elements[14] = D.w;
  }, [h, d]), [$, ne] = /* @__PURE__ */ A.useMemo(() => {
    const j = { type: yo, samples: m }, F = new Ye(a, a, j), le = { mirror: r, textureMatrix: k, tDiffuse: F.texture, mixStrength: t, distortion: s, roughness: o, distortionMap: p, mixContrast: f, "defines-USE_DISTORTION": p ? "" : void 0 };
    return [F, le];
  }, [k, a, m, r, t, s, o, p, f]), Ue = /* @__PURE__ */ Y((j) => j.paused);
  return q(function() {
    const F = O.current?.parent;
    if (!F || Ue)
      return;
    F.visible = false;
    const le = g.xr.enabled;
    J(), g.xr.enabled = false, g.shadowMap.autoUpdate = false, g.setRenderTarget($), g.state.buffers.depth.setMask(true), g.autoClear || g.clear(), g.render(C, E), g.xr.enabled = le, F.visible = true, g.setRenderTarget(null);
  }, z.renderPriority.mirror), y(Rn, { ref: _, ...ne, ...c, distortionMap: p, onUpdate: (j) => j.textureMatrix = k });
});
Ln.displayName = "Mirror";
const Yc = ({ mapName: e, url: t, depth: a }) => {
  const { args: i, getParent: r } = /* @__PURE__ */ A.useContext(Oe), l = t.split(".")[0], s = `${l}.ktx2`, o = /* @__PURE__ */ Ce(t.includes("https://storage") ? t : v[`${z.assetsRoot}img/patterns/uastc/${s}`], (d) => d.name = l);
  A.useMemo(() => new n.Box3(), []), A.useMemo(() => new n.Vector3(), []), U(({ get: d }) => d);
  const f = /* @__PURE__ */ We();
  return A.useEffect(() => {
    const d = r().current;
    if (d.material && (!d.material[e] || d.material[`${e}CountCached`] !== i[`${e}s`].size) && o && o.mipmaps) {
      d.material[e] && (d.material[e].dispose(), d.material[e] = null, d.batchUniforms[e]?.texture.dispose(), delete d.batchUniforms[e]);
      const c = i[`${e}s`].size, u = [];
      for (let p = 0; p < o.mipmaps.length; p++) {
        const g = o.mipmaps[p];
        u.push({ data: new Uint8Array(g.data.byteLength * c).fill(0), width: g.width, height: g.height });
      }
      const m = new n.CompressedArrayTexture(u, o.mipmaps[0].width, o.mipmaps[0].height, c, o.format, o.type);
      m.wrapS = m.wrapT = n.RepeatWrapping, m.generateMipmaps = false, d.material[`${e}CountCached`] = c, d.material.defines[`USE_BATCH_${e.toUpperCase()}S`] = true, d.material[e] = m, d.material[e].anisotropy = f, d.material[e].needsUpdate = true;
    }
  }, [i[`${e}s`]?.size]), A.useEffect(() => {
    const d = r().current;
    if (!(!d || !d.material?.[e])) {
      if (!d.material[e].mipmaps[0]) {
        d.material[e].source.data && o?.source.data && (a * o.source.data.length + o.source.data.length > d.material[e].source.data.data.length ? console.warn("Texture array is full", a, e, o, d.material[e].source.data) : (d.material[e].source.data.data.set(o.source.data, a * o.source.data.length), d.material[e].needsUpdate = true));
        return;
      }
      if (o?.mipmaps)
        if (a * o.mipmaps[0].data.length + o.mipmaps[0].data.length > d.material[e].mipmaps[0].data.length)
          console.warn("Texture array is full", a, e, o, d.material[e].mipmaps[0]);
        else {
          for (let c = 0; c < o.mipmaps.length; c++) {
            const u = o.mipmaps[c];
            d.material[e].mipmaps[c].data.set(u.data, a * u.data.length);
          }
          d.material[e].needsUpdate = true;
        }
    }
  }, [a]), A.useEffect(() => {
    const d = r().current;
    d && d.material?.[e] && (d.material[e].anisotropy = f, d.material[e].needsUpdate = true);
  }, [parent, e, f]), null;
}, qc = ({ mapName: e, map: t, depth: a }) => {
  const { args: i, getParent: r } = /* @__PURE__ */ A.useContext(Oe), l = /* @__PURE__ */ We();
  return A.useEffect(() => {
    const s = r().current;
    if (t?.mipmaps && (!s.material[e] || s.material?.[`${e}CountCached`] !== i[`${e}s`].size)) {
      s.material[e] && (s.material[e].dispose(), s.material[e] = null, s.batchUniforms[e]?.texture.dispose(), delete s.batchUniforms[e]);
      const o = i[`${e}s`].size, f = [];
      for (let c = 0; c < t.mipmaps.length; c++) {
        const u = t.mipmaps[c];
        f.push({ data: new Uint8Array(u.data.byteLength * o).fill(0), width: u.width, height: u.height });
      }
      const d = new n.CompressedArrayTexture(f, t.mipmaps[0].width, t.mipmaps[0].height, o, t.format, t.type);
      d.wrapS = d.wrapT = n.RepeatWrapping, d.generateMipmaps = false, s.material[`${e}CountCached`] = o, s.material.defines[`USE_BATCH_${e.toUpperCase()}S`] = true, s.material[e] = d, s.material[e].anisotropy = l, s.material[e].needsUpdate = true;
    }
  }, [i[`${e}s`].size]), A.useEffect(() => {
    const s = r().current;
    if (s) {
      if (!s.material[e].mipmaps[0]) {
        s.material[e].source.data && t?.source.data && (a * t.source.data.length + t.source.data.length > s.material[e].source.data.data.length ? console.warn("Texture array is full", a, e, t, s.material[e].source.data) : (s.material[e].source.data.data.set(t.source.data, a * t.source.data.length), s.material[e].needsUpdate = true));
        return;
      }
      if (t?.mipmaps)
        if (a * t.mipmaps[0].data.length + t.mipmaps[0].data.length > s.material[e].mipmaps[0].data.length)
          console.warn("Texture array is full", a, e, t, s.material[e].mipmaps[0]);
        else {
          for (let f = 0; f < t.mipmaps.length; f++) {
            const d = t.mipmaps[f];
            o.material[e].mipmaps[f].data.set(d.data, a * d.data.length);
          }
          const o = r().current;
          o.material[e].needsUpdate = true;
        }
    }
  }, [a]), A.useEffect(() => {
    const s = r().current;
    s && s.material[e] && (s.material[e].anisotropy = l, s.material[e].needsUpdate = true);
  }, [parent, e, l]), null;
}, zn = ({ mapName: e = "map" }) => {
  const { args: t, uuid: a, getParent: i } = /* @__PURE__ */ A.useContext(Oe), [r, l] = /* @__PURE__ */ A.useState(false);
  return re(`batch-${e}-${a}`, ({ id: s, map: o, remove: f, justRemount: d }) => {
    if (!d)
      if (f || o === "none" || typeof o == "string" && !Object.keys(ni).includes(o.split(".")[0])) {
        if (t[`${e}s`].has(o)) {
          const c = /* @__PURE__ */ t[`${e}s`].get(o).filter((u) => u !== s);
          c.length === 0 ? t[`${e}s`].delete(o) : t[`${e}s`].set(o, c);
        }
      } else
        o !== "none" && (t[`${e}s`].has(o) || t[`${e}s`].set(o, [s]), t[`${e}s`].get(o).includes(s) || t[`${e}s`].set(o, [...t[`${e}s`].get(o), s]));
    l(!r);
  }), A.useEffect(() => {
    const s = i().current;
    return s && s.material && s.material[`${e}CountCached`] !== t[`${e}s`].size && (s.material[e] = null), () => {
      s && s.material && (s.material[e] = null);
    };
  }, [r]), [...t[`${e}s`]].map(([s, o], f) => s ? y(A.Fragment, { children: H(A.Suspense, { fallback: null, children: [o.map((d) => y(Xc, { depth: f, id: d, mapName: e }, `${d}-${r}`)), y(te, { children: s.isTexture ? y(te, { children: s.isCompressedTexture ? y(qc, { map: s, url: s, depth: f, mapName: e }, `${f}-${r}`) : y(Zc, { map: s, depth: f, mapName: e }, `${f}-${r}`) }) : y(te, { children: typeof s == "string" && (Object.keys(ni).includes(s.split(".")[0]) || s.includes("ktx")) ? y(Yc, { url: s, depth: f, mapName: e }, `${f}-${r}`) : typeof s == "string" && s?.includes(".") ? y(Kc, { url: s, depth: f, mapName: e }, `${f}-${r}`) : null }) })] }) }, s) : null);
}, Xc = ({ id: e, depth: t, mapName: a }) => {
  const { getParent: i } = /* @__PURE__ */ A.useContext(Oe);
  return A.useEffect(() => {
    i().current.setUniformAt(e, a, t + 1, 1, Float32Array, n.RedFormat);
  }, [e, t]), null;
}, Kc = ({ mapName: e, url: t, depth: a }) => {
  const { args: i, getParent: r } = /* @__PURE__ */ A.useContext(Oe), l = /* @__PURE__ */ Lt(t), s = /* @__PURE__ */ Ne(l, (c) => {
    c.name = l;
  }), o = /* @__PURE__ */ We(), f = s.image.width, d = s.image.height;
  return A.useEffect(() => {
    const c = r().current;
    if (!c.material[e] || c.material[`${e}CountCached`] !== i[`${e}s`].size) {
      c.material[e] && (c.material[e].dispose(), c.material[e] = null, c.batchUniforms[e]?.texture.dispose(), delete c.batchUniforms[e]);
      const u = i[`${e}s`].size, m = new n.DataArrayTexture(new Uint8Array(f * d * 10 * 4).fill(0), f, d, u, s.format, s.type);
      m.wrapS = m.wrapT = n.RepeatWrapping, m.generateMipmaps = false, c.material[`${e}CountCached`] = u, c.material.defines[`USE_BATCH_${e.toUpperCase()}S`] = true, c.material[e] = m, c.material[e].anisotropy = o, c.material[e].needsUpdate = true;
    }
  }, [i[`${e}s`].size]), A.useEffect(() => {
    const c = r().current, u = f * d * 4, m = new Uint8Array(u);
    let p = null;
    typeof OffscreenCanvas < "u" ? p = new OffscreenCanvas(f, d) : typeof document < "u" ? p = document.createElement("canvas") : p = null;
    const g = /* @__PURE__ */ p.getContext("2d");
    g.drawImage(s.image, 0, 0);
    const h = /* @__PURE__ */ g.getImageData(0, 0, f, d);
    m.set(h.data), c.material[e].image.data && c.material[e].image.data.set(m, a * h.data.length), c && c.material[e] && (c.material[e].needsUpdate = true);
  }, [a]), null;
}, Zc = ({ mapName: e, map: t, depth: a }) => {
  const { args: i, getParent: r } = /* @__PURE__ */ A.useContext(Oe), l = /* @__PURE__ */ We(), s = t.image.width, o = t.image.height;
  return A.useEffect(() => {
    const f = r().current;
    if (!f.material[e] || f.material[`${e}CountCached`] !== i[`${e}s`].size) {
      f.material[e] && (f.material[e].dispose(), f.material[e] = null, f.batchUniforms[e]?.texture.dispose(), delete f.batchUniforms[e]);
      const d = i[`${e}s`].size, c = new n.DataArrayTexture(new Uint8Array(s * o * 10 * 4).fill(0), s, o, d, t.format, t.type);
      c.wrapS = c.wrapT = n.RepeatWrapping, c.generateMipmaps = false, f.material[`${e}CountCached`] = d, f.material.defines[`USE_BATCH_${e.toUpperCase()}S`] = true, f.material[e] = c, f.material[e].anisotropy = l, f.material[e].needsUpdate = true;
    }
  }, [i[`${e}s`].size]), A.useEffect(() => {
    const f = r().current, d = s * o * 4, c = new Uint8Array(d), m = /* @__PURE__ */ new OffscreenCanvas(s, o).getContext("2d");
    m.drawImage(t.image, 0, 0);
    const p = /* @__PURE__ */ m.getImageData(0, 0, s, o);
    c.set(p.data), f.material[e].image.data.set(c, a * p.data.length), f.material[e].needsUpdate = true;
  }, [a]), null;
};
new n.Matrix4(), new n.Matrix4(), new n.Mesh();
const Oe = /* @__PURE__ */ A.createContext({ subscribe: () => {
}, getParent: () => A.createRef(), uuid: "" }), Jc = new n.Color(), $c = new n.Vector4(), ed = new n.Vector2(), td = /* @__PURE__ */ A.forwardRef(function({ children: t, range: a, ...i }, r) {
  const [{ context: l, instance: s }] = /* @__PURE__ */ A.useState(() => {
    const _ = /* @__PURE__ */ A.createContext({ subscribe: () => {
    }, getParent: () => {
    }, uuid: "" });
    return { context: _, instance: y(ya, { context: _ }) };
  }), o = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(r, () => o.current);
  const [f, d] = /* @__PURE__ */ A.useState([]), c = /* @__PURE__ */ A.useMemo(() => ({ verticesCount: 0, indicesCount: 0, geometries: {}, maps: /* @__PURE__ */ new Map(), normalMaps: /* @__PURE__ */ new Map(), count: 0, currentIndex: 0 }), []), u = /* @__PURE__ */ A.useMemo(() => n.MathUtils.generateUUID(), []), m = /* @__PURE__ */ A.useMemo(() => ({ getParent: () => o, uuid: u, args: c, instances: f, subscribe: (_) => {
    const x = _.current;
    return x.geometryInfos = { offset: c.verticesCount, count: x.geometry.attributes.position.count, indicesCount: x.geometry.index.count }, c.geometries[x.geometry.uuid] ? c.geometries[x.geometry.uuid].push(x.uuid) : (c.geometries[x.geometry.uuid] = [x.uuid], x && (c.verticesCount += x.geometry.attributes.position.count, c.indicesCount += x.geometry.index.count)), c.count++, d((b) => [...b, _]), () => {
      c.geometries[x.geometry.uuid] = c.geometries[x.geometry.uuid].filter((b) => b !== x.uuid), c.geometries[x.geometry.uuid].length === 0 && (x && (c.verticesCount -= x.geometry.attributes.position.count, c.indicesCount -= x.geometry.index.count), delete c.geometries[x.geometry.uuid]), c.count--, d((b) => b.filter((w) => w.current && w.current !== x));
    };
  } }), []);
  c.currentIndex = 0;
  const p = /* @__PURE__ */ A.useCallback((_, x) => {
    x.updateMatrix(), x.parent && (x.parent.updateMatrix(), x.parent.matrixWorld.copy(x.parent.matrix)), x.updateMatrixWorld(true);
    for (let b = 0; b < _.length; b++) {
      const w = _[b].current;
      w && w.updateMatrix();
    }
  }, []), g = /* @__PURE__ */ A.useCallback((_, x) => {
    const b = c.count, w = /* @__PURE__ */ Math.min(b, a !== void 0 ? a : b, c.count);
    x.count = w, x.setInstanceCount(w);
    for (let P = 0; P < _.length; P++) {
      const S = _[P].current;
      if (S) {
        const M = S.userData.id;
        S.geometry.attributes._tint || (S.geometry.attributes._tint = new n.BufferAttribute(new Float32Array(S.geometry.attributes.position.count).fill(0), 1, true)), S.geometry.attributes._uvscale || (S.geometry.attributes._uvscale = new n.BufferAttribute(new Float32Array(S.geometry.attributes.position.count).fill(1), 1, true)), S.geometryId = x.registerGeometry(S.geometry, S.geometry.uuid), S.updateMatrix(), x.setGeometry(M, S.geometryId), S.color && x.setUniformAt(M, "color", Jc.set(S.color), 4, Float32Array, n.RGBAFormat);
        const D = S.castSSAO && S.receiveSSAO ? 1 : S.receiveSSAO ? 0.5 : 0;
        x.setUniformAt(M, "effects", $c.set(S.bloom, D, S.metalness, S.dithering), 4, Float32Array, n.RGBAFormat), x.setUniformAt(S.userData.id, "uv", ed.set(S.uv[0], S.uv[1]), 2, Float32Array, n.RGFormat);
      }
    }
  }, []), h = /* @__PURE__ */ A.useMemo(() => ({ ...c, geometriesCnt: Object.keys(c.geometries).length }), [c]);
  A.useLayoutEffect(() => {
    if (!o.current)
      return;
    const _ = o.current, x = c.count, b = Object.keys(c.geometries).length, w = c.verticesCount, P = c.indicesCount;
    _._drawStarts = [], _._drawCounts = [], _._srcOffsetAttribute = [], _._srcPosAttribute = [], _._maxInstanceCount = x, _._visibilities = [], _._inViewports = [], _._maxGeometryCount = b, _._instanceCount = x, _._maxVertexCount = w, _._maxIndexCount = P, _._currentGeometryCount = 1, _._currentVertexCount = 0, _._currentIndexCount = 0, _.batchDrawIDs = null, _.instanceMatrix = null, _.matricesTexture = null, _.matricesTextureSize = null, _.storedGeometries = /* @__PURE__ */ new Map(), _.activeGeometries = /* @__PURE__ */ new Map(), _.geometriesTexture = null, _.geometries = null, _.instances = null, _.instancePerDrawID = null, _.instancePerDrawIDTexture = null, _.batchUniforms = null, _.inViewport = true, _._starts = [], _._counts = [], _._instances = [], _.isBatchedMesh = true, _.isBatchedInstanceMesh = true, _._init();
    for (let S = 0; S < f.length; S++) {
      const M = f[S].current;
      M && M.refresh();
    }
    ae(`batch-map-${u}`, { justRemount: true }), ae(`batch-normalMap-${u}`, { justRemount: true });
  }, [o, c.count, Object.keys(c.geometries).length, c.verticesCount, c.indicesCount]), A.useMemo(() => {
    const _ = c.maps;
    for (let x = 0; x < f.length; x++) {
      const b = f[x].current;
      if (b) {
        const w = x;
        if (b.userData.id = w, !b.map || b.map === "none")
          continue;
        if (b.map)
          if (!_.has(b.map))
            _.set(b.map, [w]);
          else {
            const P = /* @__PURE__ */ _.get(b.map);
            if (P.includes(w))
              continue;
            P.push(w);
          }
      }
    }
    c.maps = _;
  }, [f, f.length]), A.useMemo(() => {
    const _ = c.normalMaps;
    for (let x = 0; x < f.length; x++) {
      const b = f[x].current;
      if (b) {
        const w = x;
        if (b.userData.id = w, !b.normalMap || b.normalMap === "none")
          continue;
        if (b.normalMap)
          if (!_.has(b.normalMap))
            _.set(b.normalMap, [w]);
          else {
            const P = /* @__PURE__ */ _.get(b.normalMap);
            if (P.includes(w))
              continue;
            P.push(w);
          }
      }
    }
    c.normalMaps = _;
  }, [f, f.length]);
  const C = /* @__PURE__ */ A.useCallback((_) => {
    o.current = _, o.current && g(f, o.current), o.current && (window.meshesBatched[u] = o.current);
  }, []);
  return A.useLayoutEffect(() => {
    o.current && g(f, o.current);
  }, [f, f.length]), A.useEffect(() => {
    o.current && o.current.geometriesComposedCb?.(o.current);
  }, [f, f.length]), window.meshesBatched || (window.meshesBatched = {}), y("metaMesh", { userData: { instances: f }, matrixAutoUpdate: false, ref: C, onUpdate: (_) => {
    p(f, _);
  }, traverse: function(x) {
    x(this);
  }, args: [null, h.count || 0, h.geometriesCnt || 0, h.verticesCount || 1024, h.indicesCount || 1024], ...i, children: typeof t == "function" ? y(l.Provider, { value: m, children: t(s) }) : H(Oe.Provider, { value: m, children: [y(zn, { mapName: "map" }), y(zn, { mapName: "normalMap" }), t] }) });
}), _a = new n.Mesh(), ad = new n.Color(), id = new n.Vector4(), nd = new n.Vector2(), Fn = new n.Matrix4(), Nn = new n.Matrix4(), xa = [], ya = /* @__PURE__ */ A.forwardRef(function({ context: t, children: a, bloom: i = 0, visible: r = true, castSSAO: l = true, receiveSSAO: s = true, dithering: o = 0, metalness: f = 0, uv: d = [1, 1], ...c }, u) {
  const m = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(u, () => m.current);
  const p = /* @__PURE__ */ A.useContext(t || Oe), g = p?.subscribe, h = p?.getParent, C = p?.uuid, _ = /* @__PURE__ */ A.useMemo(() => n.MathUtils.generateUUID(), []);
  A.useEffect(() => {
    const w = m.current.userData.id, P = c.map;
    return w !== void 0 && C && ae(`batch-map-${C}`, { id: w, map: P }), () => {
      w !== void 0 && C && ae(`batch-map-${C}`, { id: w, map: P, remove: true });
    };
  }, [c.map]), A.useEffect(() => {
    const w = m.current.userData.id, P = c.normalMap;
    return w !== void 0 && C && ae(`batch-normalMap-${C}`, { id: w, map: P }), () => {
      w !== void 0 && C && ae(`batch-normalMap-${C}`, { id: w, map: P, remove: true });
    };
  }, [c.normalMap]), A.useEffect(() => {
    const w = h().current;
    if (w) {
      const P = m.current;
      w.setUniformAt(P.userData.id, "color", ad.set(c.color), 4, Float32Array, n.RGBAFormat);
    }
  }, [c.color]), A.useEffect(() => {
    const w = h().current;
    if (w) {
      const P = m.current, S = P.castSSAO && P.receiveSSAO ? 1 : P.receiveSSAO ? 0.5 : 0;
      w.setUniformAt(P.userData.id, "effects", id.set(P.bloom, S, P.metalness, P.dithering), 4, Float32Array, n.RGBAFormat);
    }
  }, [l, s, i, o, f, h]), A.useEffect(() => {
    const w = h().current;
    if (w) {
      const P = m.current;
      w.setUniformAt(P.userData.id, "uv", nd.set(P.uv[0], P.uv[1]), 2, Float32Array, n.RGFormat);
    }
  }, [d, h]);
  const x = /* @__PURE__ */ A.useCallback(function() {
    const P = h().current;
    P && (this.matrix.compose(this.position, this.quaternion, this.scale), this.matrix.premultiply(P.matrix), P.setMatrixAt(this.userData.id, this.matrix));
  }, [h]), b = /* @__PURE__ */ A.useCallback(() => {
    const w = h().current;
    if (!w)
      return;
    const P = m.current;
    w.setVisibilityAt(P.userData.id, r);
  }, [r, h]);
  return A.useEffect(() => {
    b();
  }, [r, b, h]), A.useLayoutEffect(() => g(m), []), y("group", { instanceKey: m, ref: m, refresh: b, visible: r, updateMatrix: x, raycast: (w, P) => {
    const S = m.current, M = h().current;
    if (!(!S || !M)) {
      _a.geometry = S.geometry, Fn.copy(S.matrix), Nn.multiplyMatrices(M.matrixWorld, Fn), _a.matrixWorld = Nn, _a.material.side = M.material.side, _a.raycast(w, xa);
      for (let D = 0, T = xa.length; D < T; D++) {
        const R = xa[D];
        R.object = S, P.push(R);
      }
      xa.length = 0;
    }
  }, localUUID: _, castSSAO: l, receiveSSAO: s, dithering: o, metalness: f, uv: d, bloom: i, ...c, children: a }, _);
}), rd = function(e, t) {
  const a = [];
  return e.traverse((i) => {
    const r = /* @__PURE__ */ t(i);
    r !== void 0 && a.push(r);
  }), a.map((i) => i);
}, od = ({ scene: e }) => (V(() => {
  e.updateMatrixWorld(true, true);
}, [e]), V(() => rd(e, (a) => a.isMesh ? a.isInstancedMesh ? new Array(a.count).fill(0).map((i, r) => (a.m = new n.Matrix4(), a.getMatrixAt(r, a.m), a.i = r, a)) : a : null), []).map((a) => a && a.material ? a.m ? y(ya, { map: a.material.userData.map, normalMap: a.material.userData.map ? `${a.material.userData.map?.split(".")[0]}_normal` : null, name: `${a.name}_${a.i}`, instancedMatrix: a.m, geometry: a.geometry, castSSAO: true, receiveSSAO: true, castShadow: true, receiveShadow: true, color: a.userData.color ? `#${a.userData.color}` : a.material.color }, `${a.name}_${a.i}`) : y(ya, { scale: a.scale, position: a.position, quaternion: a.quaternion, name: a.name, castSSAO: true, receiveSSAO: true, castShadow: true, receiveShadow: true, map: a.material.userData.map, normalMap: a.material.userData.map ? `${a.material.userData.map.split(".")[0]}_normal` : null, geometry: a.geometry, color: a.userData?.color ? `#${a.userData.color}` : a.material.color }, a.uuid) : null)), ri = /* @__PURE__ */ ce.forwardRef(({ children: e, style: t, className: a }, i) => {
  const r = /* @__PURE__ */ U((d) => d.gl), [l] = /* @__PURE__ */ ce.useState(() => document.createElement("div")), s = /* @__PURE__ */ ce.useRef(null), o = r.domElement.parentNode, f = /* @__PURE__ */ ce.useRef(null);
  return ce.useEffect(() => {
    if (s.current) {
      const d = f.current = No.createRoot(l);
      return o && o.appendChild(l), () => {
        o && o.removeChild(l), d.unmount();
      };
    }
  }, [o]), ce.useEffect(() => {
    f.current?.render(y("div", { ref: i, style: t, className: a, children: e }));
  }), y("group", { ref: s });
});
ri.displayName = "HtmlMinimal";
const sd = `
  uniform float size;
  uniform float scale;
  uniform sampler2D positionsTexture;
  uniform sampler2D emojisTexture;
  in vec3 a_offset;
  in float a_age;
  in float a_life;
  #include <common>
  #include <fog_pars_vertex>
  #include <morphtarget_pars_vertex>
  #include <logdepthbuf_pars_vertex>
  #include <clipping_planes_pars_vertex>


  out float vAgeOverLife;
  out float vSize;

  out float vTexDepth;

  out vec3 vViewPosition;

    float cubicHermite(float t, float a, float b, float c, float d) {
      float t2 = t * t;
      float t3 = t2 * t;

      return a * (-2.0 * t3 + 3.0 * t2) + b * (t3 - 2.0 * t2 + t) + c * (t3 - t2) + d * (-2.0 * t3 + 3.0 * t2);
    }

    float smoothstepEaseInOut(float edge0, float edge1, float x, float easeInOutFactor) {
      float t = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);
      float a = 0.0;
      float b = easeInOutFactor;
      float c = 1.0 - easeInOutFactor;
      float d = 1.0;

      return cubicHermite(t, a, b, c, d);
    }

  void main() {
    #include <begin_vertex>

    

    
    vec3 pos = texelFetch(positionsTexture, ivec2(gl_VertexID, 0), 0).xyz;
    vTexDepth = texelFetch(emojisTexture, ivec2(gl_VertexID, 0), 0).x;
    // position 
    transformed = a_offset;
    transformed += pos;
    // offsetPlayer
    transformed.y += 1.6;

    #include <morphtarget_vertex>
    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_BATCHING
      mvPosition = batchingMatrix * mvPosition;
    #endif
    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif
    
    mvPosition = modelViewMatrix * mvPosition;
    
    gl_Position = projectionMatrix * mvPosition;

    gl_PointSize = size;
    #ifdef USE_SIZEATTENUATION
      bool isPerspective = isPerspectiveMatrix( projectionMatrix );
      if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
    #endif
    vAgeOverLife = smoothstep(0., a_life, a_age);

    float edge0 = 0.0;
    float edge1 = 0.2;
    float smoothValue = smoothstepEaseInOut(edge0, edge1, vAgeOverLife, 0.6);

    // scale over life
    gl_PointSize *= smoothValue;

    if(a_age == 999999999.){
      gl_PointSize = 0.;
    }
    vSize = gl_PointSize;
    vViewPosition = - mvPosition.xyz;
    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>
    #include <worldpos_vertex>
    #include <fog_vertex>
  }
`, ld = `
  #include <layout_pars_fragment>

  uniform vec3 diffuse;
  uniform float debug;
  uniform float opacity;

  uniform float opacityOver;

  in float vAgeOverLife;
  in float vSize;
  in float vInstanceId;
  in float vTexDepth;

  in vec3 vViewPosition;

  #include <common>
  #include <packing>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform mat3 uvTransform;

  #ifdef USE_BATCH_MAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray map;

  #endif

  #include <alphatest_pars_fragment>
  #include <logdepthbuf_pars_fragment>
  #include <clipping_planes_pars_fragment>

  void main() {
    #include <clipping_planes_fragment>
    vec3 outgoingLight = vec3( 0.0 );
    vec4 diffuseColor = vec4( vec3(1.), opacity );

    if (vAgeOverLife >= 1.0) {
      discard;
      return;
    };

    if (vAgeOverLife == 0.0) {
      discard;
      return;
    };

    #include <logdepthbuf_fragment>
	  vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, gl_PointCoord.y, 1 ) ).xy;

    #if defined(USE_MAP) && defined(USE_BATCH_MAPS)

      diffuseColor *= texture(map, vec3(uv, vTexDepth - 1.));

    #endif

    float edgeDist = 0.;
    if (debug > 0.) {
      vec2 fromCenter = abs(uv - 0.5);
      // Signed distance from the horizontal & vertical edges.
      vec2 fromEdge = fromCenter - 0.5;
      fromEdge.x /= length(vec2(dFdx(uv.x), dFdy(uv.x)));
      fromEdge.y /= length(vec2(dFdx(uv.y), dFdy(uv.y)));
      edgeDist = abs(min(max(fromEdge.x,fromEdge.y), 0.0) + length(max(fromEdge, 0.0)));
      if (edgeDist >= 1.) {
        #include <alphatest_fragment>
      }
    } else {
      #include <alphatest_fragment>
    }

   
    // alpha over lifetime
    diffuseColor.a = 1. - smoothstep(0.7, 1., vAgeOverLife);



    if (debug > 0.) {
      diffuseColor = mix(diffuseColor, vec4(1., 1., 0., 1.), saturate(1. - edgeDist));
    }

    vec4 o_color = vec4(0., 0., 0., 0.);

    // #ifdef USE_GLOW
    //     o_color.r = 1.;
    // #endif

    vec4 o_diffuse = diffuseColor;
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(0.);
    #include <layout_output_fragment>
  }
`, ba = /* @__PURE__ */ W({ debug: 0, repeat: 1, size: 4, scale: 1, diffuse: new n.Color(16777215), uvTransform: new n.Matrix3(), alphaMapTransform: new n.Matrix3(), positionsTexture: null, emojisTexture: null, map: null, alphaMap: null, closed: 0, opacity: 1, colorOver: 0, opacityOver: 0, alphaTest: 0.5, alpha: 0, distanceFade: 400, scaleOverLife: 1 }, sd, ld);
ba.key = n.MathUtils.generateUUID(), ba.type = "ParticleEmojiMaterial", N({ ParticleEmojiMaterialImpl: ba });
const On = /* @__PURE__ */ Z(({ children: e, debug: t = false, size: a = 2, scaleOverLife: i = 1, opacityOver: r = "none", useGlow: l = false, ...s }, o) => {
  const f = /* @__PURE__ */ I();
  ge(o, () => f.current);
  const d = /* @__PURE__ */ se({ useLights: false });
  return y("particleEmojiMaterialImpl", { ref: f, glslVersion: n.GLSL3, side: n.FrontSide, transparent: false, isPointsMaterial: true, scale: 1, color: 16777215, sizeAttenuation: true, size: a, debug: t, alphaTest: 0.5, scaleOverLife: i, ...d, ...s, "defines-USE_GLOW": false, attach: "material" }, ba.key);
});
On.displayName = "ParticleEmojiMaterial";
const fd = () => {
  const { args: e, uuid: t, getParent: a } = /* @__PURE__ */ A.useContext(st), [i, r] = /* @__PURE__ */ A.useState(false);
  return re(`emoji-texture-${t}`, ({ id: l, map: s, remove: o }) => {
    e.maps[s] || (e.maps[s] = [l]), Object.entries(e.maps).forEach(([f, d]) => {
      const c = /* @__PURE__ */ d.indexOf(l);
      c !== -1 && d.splice(c, 1);
    }), e.maps[s].indexOf(l) === -1 && e.maps[s].push(l), r(!i);
  }), Object.entries(e.maps).map(([l, s], o) => y(A.Fragment, { children: H(A.Suspense, { fallback: null, children: [y(dd, { url: l, depth: o }), s.map((f) => y(cd, { depth: o, id: f }, `${f}-${i}-${Object.keys(e.maps).length}`))] }) }, l));
}, cd = ({ id: e, depth: t }) => {
  const { getParent: a } = /* @__PURE__ */ A.useContext(st);
  return A.useEffect(() => {
    const i = a().current;
    i.emojisBuffer[e] = t + 1, i.material.emojisTexture.needsUpdate = true;
  }, [e, t, a]), null;
}, dd = ({ url: e, depth: t }) => {
  const { args: a, getParent: i } = /* @__PURE__ */ A.useContext(st), r = /* @__PURE__ */ Lt(e, v["/img/webp/2764-fe0f.webp"]), l = /* @__PURE__ */ Ne(r, (d) => {
    d.name = r;
  }), s = /* @__PURE__ */ A.useMemo(() => new n.Box3(), []), o = /* @__PURE__ */ A.useMemo(() => new n.Vector3(), []), f = /* @__PURE__ */ U(({ get: d }) => d);
  return A.useEffect(() => {
    const d = i().current;
    if (!d.material.map) {
      d.material.map && (d.material.map.dispose(), d.material.map = null, d.batchUniforms.map?.texture.dispose(), delete d.batchUniforms.map);
      const c = l.image.width, u = l.image.height, m = 1500, p = c * u, g = new Uint8Array(4 * p * m), h = new n.DataArrayTexture(g, c, u, m, l.format, l.type);
      h.generateMipmaps = false, d.material.mapCountCached = m, d.material.map = h, d.material.map.needsUpdate = true, d.material.needsUpdate = true, d.material.defines.USE_BATCH_MAPS = true;
    }
  }, [Object.keys(a.maps).length]), A.useEffect(() => {
    const d = i().current, c = l.image.width, u = l.image.height;
    s.max.set(c, u, 0), s.min.set(0, 0, 0), f().gl.copyTextureToTexture3D(s, o.set(0, 0, t), l, d.material.map, 0, 0);
  }, [t, Object.keys(a.maps).length]), null;
};
var ud = `precision mediump float;

/* Number of seconds (possibly fractional) that has passed since the last
  update step. */
uniform mediump sampler2D spawnsTexture;
uniform float u_delta;
uniform vec3 u_gravity;
uniform vec3 u_origin;

/* The min and max values of the (scalar!) speed assigned to a newborn
  particle.*/

in vec3 a_offset;

in float a_age;
in float a_life;
in vec3 a_velocity;

out vec3 v_offset;

out float v_age;
out float v_life;
out vec3 v_velocity;



vec3 getConeStartPos( float theta, float u_radius)
{
  float x = 0.;
  float y = 0.;
  float z = 0.;

  x = cos(theta) * u_radius;
  z = sin(theta) * u_radius;
  return vec3(x,y,z);
}

float PHI = 1.61803398874989484820459; // Golden Ratio   
float PI  = 3.14159265358979323846264; // PI
float SQ2 = 1.41421356237309504880169 * 10000.0; // Square Root of Two

float gold_noise(in vec2 coordinate, in float seed){
    return fract(tan(distance(coordinate*(seed+PHI), vec2(PHI, PI)))*SQ2);
}


void main() {

  float idVertex = float(gl_VertexID);
  
  float alive = texelFetch(spawnsTexture, ivec2(gl_VertexID, 0), 0).r;
  float age = a_age;
  float delta = 0.0;

  if (a_age >= a_life || alive < 1.0) {

    vec3 startPos = vec3(0.);

    // radius
    float adjustedRadius = .35;
    float debug_angle = adjustedRadius;
    float radAngle = debug_angle * (PI / 180.);
    // max age
    float maxDistancePossible = 5.;
    float circum = 2. * PI * maxDistancePossible * 2.;
    float arcLength = (debug_angle * circum) / 360.;

      float idVertexConstRandVel = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), 3.298085282);

    float fillRandom = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), PI);

    float coneEndRadius =
      ((2. *
        maxDistancePossible *
        sin(arcLength / (2. * maxDistancePossible))) /
        2.) * fillRandom +
      adjustedRadius;

    float coneHeight = cos(radAngle) * maxDistancePossible;

    float x2 = 0.;
    float y2 = 0.;
    float z2 = 0.;

    //cone with fill
      x2 = cos(idVertex) * coneEndRadius;
      z2 = sin(idVertex) * coneEndRadius;
    
    vec3 test = vec3(x2,y2,z2);
    vec3 topPos = vec3(test.x , coneHeight, test.z);

    vec3 startDirection = normalize(topPos - startPos) * 0.0001;
    v_velocity = startDirection * 1. * idVertexConstRandVel;
    // v_velocity = vec3(0., 1., 0.);
    v_offset = startPos;
    v_age = 0.;
  } else {
    delta = u_delta;

    float particleForce = 1.2;
    vec3 accel = normalize(a_velocity) * particleForce;
    v_velocity = a_velocity + accel * u_delta + u_gravity * u_delta;
    v_offset = a_offset + v_velocity * delta;
    v_age = age + delta;
  }

  v_life = a_life;
}
`;
const Gn = { uniforms: { spawnsTexture: { value: new n.DataTexture(new Float32Array(1), 1, 1, n.RedFormat, n.FloatType) }, u_delta: { value: 0 }, u_totalDelta: { value: 0 }, u_gravity: { value: new n.Vector3(0, 0, 0) }, u_origin: { value: new n.Vector3(0, 0, 0) } }, glslVersion: n.GLSL3, vertexShader: ud, fragmentShader: `
  void main() {
  }
  ` };
N({ WebGLTransformFeedback: Hi });
const md = 4, Hn = /* @__PURE__ */ Fa(null), vd = /* @__PURE__ */ Z(function({ children: t, graphId: a, ...i }, r) {
  const [l, s] = /* @__PURE__ */ U((b) => [b.gl, b.scene]), [o, f] = /* @__PURE__ */ ve(null), d = /* @__PURE__ */ I(), { args: c } = /* @__PURE__ */ Ke(st);
  ge(r, () => o);
  const u = /* @__PURE__ */ I(0), m = /* @__PURE__ */ V(() => ({ position: [0, 0, 0], graphId: void 0, minAge: 2, maxAge: 6, maxParticles: 200, gravity: [0, -0.1, 0], playerApi: void 0, grpRef: void 0, debug: false, ...i }), [i]), { position: p, minAge: g, maxAge: h, maxParticles: C, gravity: _ } = m, [x] = /* @__PURE__ */ V(() => {
    const b = { v_offset: "a_offset", v_velocity: "a_velocity", v_age: "a_age", v_life: "a_life" }, w = new n.RawShaderMaterial({ ...Gn, type: "ParticleTransformFeedbackMaterial", defines: {}, transformFeedbackVaryings: b });
    return w.uniforms = n.UniformsUtils.clone(Gn.uniforms), [w];
  }, []);
  return q(function(w, P) {
    const S = d.current;
    if (S) {
      S.material.uniforms.u_delta.value = P > 1 ? 0 : P, S.material.uniforms.u_origin.value.copy(o.position);
      const M = /* @__PURE__ */ Math.min(C, c.count * c.maxPerPlayer);
      o.geometry.drawRange.count = M, S.source.drawRange.count = M, S.target.drawRange.count = M, S.source && S.tick();
    }
  }, md), G(() => {
    u.current = 0;
  }, [g, h, C, x]), ie(() => {
    const b = d.current;
    b && b.material && b.material.uniforms.u_gravity.value.fromArray?.(_);
  }, [d, o, _]), y(Hn.Provider, { value: m, children: H(de, { fallback: null, children: [o ? y("webGLTransformFeedback", { ref: d, args: [x, o, l, s, C] }, `${g}-${h}-${a}`) : null, y("points", { count: 0, ref: f, position: p, materialFeedback: x, graphId: a, frustumCulled: false, isTransformFeedback: true, onUpdate: (b) => {
    b.updateMatrix();
  }, children: t }, C + g + h)] }) });
}), gd = () => {
  const { maxParticles: e, minAge: t, maxAge: a } = /* @__PURE__ */ Ke(Hn), i = 8, r = /* @__PURE__ */ V(() => {
    const l = /* @__PURE__ */ new Float32Array(e * i).fill(0);
    for (let o = 0; o < e * i; o += i)
      l[o + 4] = 1, l[o + 6] = 999999, l[o + 7] = a;
    return new n.InterleavedBuffer(l, i);
  }, [t, a, e]);
  return H(te, { children: [y("interleavedBufferAttribute", { attach: "attributes-a_offset", data: r, itemSize: 3, offset: 0, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_velocity", data: r, itemSize: 3, offset: 3, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_age", data: r, itemSize: 1, offset: 6, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_life", data: r, itemSize: 1, offset: 7, usage: n.DynamicCopyUsage })] });
}, st = /* @__PURE__ */ A.createContext(null), pd = /* @__PURE__ */ A.forwardRef(function({ children: t, debug: a = false, maxEmojis: i = 500, maxAge: r = 4, maxPerPlayer: l = 10, range: s, ...o }, f) {
  const [{ context: d, instance: c }] = /* @__PURE__ */ A.useState(() => {
    const M = /* @__PURE__ */ A.createContext(null);
    return { context: M, instance: y(Vn, { context: M }) };
  }), u = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(f, () => u.current);
  const [m, p] = /* @__PURE__ */ A.useState([]), g = /* @__PURE__ */ A.useRef(new Map(Array.from({ length: 1e3 }, (M, D) => [D, -1]))), h = /* @__PURE__ */ A.useMemo(() => n.MathUtils.generateUUID(), []), C = /* @__PURE__ */ A.useRef(0), _ = /* @__PURE__ */ A.useCallback((M) => {
    const D = new Float32Array(M * 4 * b.maxPerPlayer);
    u.current.positionsBuffer && D.set(u.current.positionsBuffer.subarray(0, M * 4 * b.maxPerPlayer), 0), u.current.positionsBuffer = D, u.current.material.positionsTexture && u.current.material.positionsTexture.dispose(), u.current.material.positionsTexture = new n.DataTexture(u.current.positionsBuffer, M * b.maxPerPlayer, 1, n.RGBAFormat, n.FloatType), u.current.material.positionsTexture.needsUpdate = true;
    const T = new Float32Array(M * b.maxPerPlayer);
    u.current.spawnsBuffer && T.set(u.current.spawnsBuffer.subarray(0, M * b.maxPerPlayer), 0), u.current.spawnsBuffer = T, u.current.materialFeedback.uniforms.spawnsTexture.value && u.current.materialFeedback.uniforms.spawnsTexture.value.dispose(), u.current.materialFeedback.uniforms.spawnsTexture.value = new n.DataTexture(T, M * b.maxPerPlayer, 1, n.RedFormat, n.FloatType), u.current.materialFeedback.uniforms.spawnsTexture.value.needsUpdate = true;
    const R = new Float32Array(M * b.maxPerPlayer);
    u.current.emojisBuffer = R, u.current.material.emojisTexture && u.current.material.emojisTexture.dispose(), u.current.material.emojisTexture = new n.DataTexture(u.current.emojisBuffer, M * b.maxPerPlayer, 1, n.RedFormat, n.FloatType), u.current.material.emojisTexture.needsUpdate = true, C.current = M;
  }, []), x = /* @__PURE__ */ A.useCallback((M) => {
    for (let D = 0; D < g.size; D++)
      g.current.set(D, -1);
    for (let D = 0; D < M.length; D++)
      M[D].current && g.current.set(D, 1);
  }, []), b = /* @__PURE__ */ A.useMemo(() => ({ maps: {}, count: 0, maxPerPlayer: l, maxAge: r, currentIndex: 0 }), [r, l]), w = /* @__PURE__ */ A.useMemo(() => ({ getParent: () => u, uuid: h, args: b, activeCount: A.createRef(0), instances: m, subscribe: (M) => {
    const D = M.current;
    b.count++, u.current && C.current <= b.count && _(Math.ceil(b.count / 10) * 10);
    for (const [T, R] of g.current.entries())
      if (R === -1) {
        g.current.set(T, 1), D.userData.id = T;
        break;
      }
    return p((T) => [...T, M]), () => {
      b.count--, u.current && b.count < C.current - 13 && _(Math.ceil(b.count / 10) * 10), g.current.set(D.userData.id, -1), p((T) => T.filter((R) => R.current && R.current !== D));
    };
  } }), []);
  b.currentIndex = 0;
  const P = /* @__PURE__ */ A.useCallback((M, D) => {
    D.updateMatrix(), D.parent && (D.parent.updateMatrix(), D.parent.matrixWorld.copy(D.parent.matrix)), D.updateMatrixWorld(true);
    for (let T = 0; T < M.length; T++) {
      const R = M[T].current;
      R && R.updateMatrix();
    }
  }, []);
  A.useMemo(() => {
    b.maps = {}, b.mapsLoaded = {};
    for (let M = 0; M < m.length; M++) {
      const D = m[M].current;
      if (D) {
        const T = M;
        D.map && (b.maps[D.map] ? b.maps[D.map].push(T) : b.maps[D.map] = [T]);
      }
    }
  }, [m, m.length]);
  const S = /* @__PURE__ */ A.useCallback((M) => {
    u.current = M, u.current && x(c);
  }, []);
  return A.useLayoutEffect(() => {
    u.current && x(m);
  }, [m, m.length]), A.useEffect(() => {
    u.current && u.current.geometriesComposedCb?.(u.current);
  }, [m, m.length]), A.useEffect(() => {
    u.current && _(Math.ceil(m.length / 10) * 10);
  }, [m]), y(st.Provider, { value: w, children: H(vd, { maxParticles: i * l, ref: S, position: [0, 0, 0], debug: a, gravity: [0, -0.2, 0], minAge: 0, maxAge: r, userData: { instances: m }, matrixAutoUpdate: false, onUpdate: (M) => {
    P(m, M);
  }, traverse: function(D) {
    D(this);
  }, ...o, children: [y("bufferGeometry", { children: y(gd, {}) }), y(On, { startColor: 16711680, useGlow: true, debug: a }), y(fd, {}), t] }) });
}), Vn = /* @__PURE__ */ A.forwardRef(function({ context: t, children: a, offsetY: i = 1.2, bloom: r = 0, ...l }, s) {
  const o = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(s, () => o.current);
  const { uuid: f, subscribe: d, getParent: c, args: u, activeCount: m } = /* @__PURE__ */ A.useContext(t || st), p = /* @__PURE__ */ A.useMemo(() => n.MathUtils.generateUUID(), []), g = /* @__PURE__ */ A.useRef(0), h = /* @__PURE__ */ A.useRef(0), C = /* @__PURE__ */ A.useCallback((_, x) => {
    const b = o.current, w = b.userData.id, P = x || b.position;
    if (g.current < u.maxPerPlayer) {
      const S = h.current % u.maxPerPlayer;
      _ && ae(`emoji-texture-${f}`, { id: w * u.maxPerPlayer + h.current % u.maxPerPlayer, map: _ });
      const M = c().current;
      M.positionsBuffer.set([P.x, P.y, P.z, 0], w * u.maxPerPlayer * 4 + S * 4), M.material.positionsTexture.needsUpdate = true, M.spawnsBuffer[w * u.maxPerPlayer + S] = 1, M.materialFeedback.uniforms.spawnsTexture.value.needsUpdate = true, g.current++, h.current++, m.current++, setTimeout(() => {
        g.current--, m.current--, M.spawnsBuffer[w * u.maxPerPlayer + S] = 0, M.materialFeedback.uniforms.spawnsTexture.value.needsUpdate = true;
      }, u.maxAge * 1e3);
    }
  }, []);
  return A.useLayoutEffect(() => d(o), []), y("group", { instanceKey: o, ref: o, spawnEmoji: C, updateMatrix: function() {
  }, localUUID: p, bloom: r, ...l, children: a }, p);
}), hd = /* @__PURE__ */ W({ surface: 0.5, epsilon: 1e-6, surfaceEpsilon: 5e-3, maxSteps: 100, cameraNear: 0.1, cameraFar: 3500, noiseSpeed: 0.5, noiseScale: new n.Vector3(1, 1, 1), sdfTex: null, normalStep: new n.Vector3(), projectionInverse: new n.Matrix4(), boundsMatrix: new n.Matrix4(), u_modelMatrix: new n.Matrix4(), cloudColor: new n.Color(14276318).convertLinearToSRGB(), shadowColor: new n.Color(10263454).convertLinearToSRGB() }, `
    out vec2 vUv;

    void main() {
      vUv = uv;
      gl_Position = vec4(position, 1);
    }
  `, `
    precision highp float;
    precision highp int;
    precision highp sampler3D;

    #include <layout_pars_fragment>
    in vec2 vUv;
    uniform float surface;
    uniform float epsilon;
    uniform float surfaceEpsilon;
    uniform int maxSteps;
    
    uniform sampler3D sdfTex;
    uniform vec3 normalStep;
    uniform mat4 projectionInverse;
    uniform mat4 u_modelMatrix;
    uniform mat4 boundsMatrix;
    uniform vec3 cloudColor;
    uniform vec3 shadowColor;
    uniform float noiseSpeed;
    uniform vec3 noiseScale;

    #include <common>
    #include <common_ubo_pars>
    #include <introanimation_pars_fragment>

    #ifndef USE_DEFERRED
    #include <deferred_lights_pars>
    #endif

    #include <packing>

    uniform float cameraNear;
    uniform float cameraFar;

    // distance to box bounds
    vec2 rayBoxDist(vec3 boundsMin, vec3 boundsMax, vec3 rayOrigin, vec3 rayDir) {
      vec3 t0 = (boundsMin - rayOrigin) / rayDir;
      vec3 t1 = (boundsMax - rayOrigin) / rayDir;
      vec3 tmin = min(t0, t1);
      vec3 tmax = max(t0, t1);
      float distA = max(max(tmin.x, tmin.y), tmin.z);
      float distB = min(tmax.x, min(tmax.y, tmax.z));
      float distToBox = max(0.0, distA);
      float distInsideBox = max(0.0, distB - distToBox);
      return vec2(distToBox, distInsideBox);
    }

    vec3 getNormal(sampler3D sdfTex, vec3 uv, vec3 normalStep) {
      float dx = texture(sdfTex, uv + vec3(normalStep.x, 0.0, 0.0)).r - texture(sdfTex, uv - vec3(normalStep.x, 0.0, 0.0)).r;
      float dy = texture(sdfTex, uv + vec3(0.0, normalStep.y, 0.0)).r - texture(sdfTex, uv - vec3(0.0, normalStep.y, 0.0)).r;
      float dz = texture(sdfTex, uv + vec3(0.0, 0.0, normalStep.z)).r - texture(sdfTex, uv - vec3(0.0, 0.0, normalStep.z)).r;
      vec3 normal = normalize(vec3(dx, dy, dz));
      return normal;
    }

    vec3 getHemisphereLighting(vec3 normal, vec3 skyColor, vec3 groundColor) {
      vec3 direction = normalize(vec3(0.0, 1.0, 0.0));
      float weight = 0.5 * dot(normal, direction) + 0.5;
      vec3 lighting = mix(groundColor, skyColor, weight);
      return lighting;
    }

    void main() {
      // get the inverse of the sdf box transform
      mat4 sdfTransform = viewMatrix * u_modelMatrix * boundsMatrix;

      mat4 sdfTransformInverse = inverse(sdfTransform);
      vec3 vWorldPosition = vec3(0.);
      vec3 vViewPosition = vec3(0.);
      vec3 normal = vec3(0.);
      // get world ray direction
      vec3 rayOrigin = vec3(0.0);
      vec3 rayDirection = normalize((projectionInverse * vec4(vUv * 2.0 - 1.0, -1.0, 1.0)).xyz);

      vec3 scale = vec3(length(u_modelMatrix[0].xyz), length(u_modelMatrix[1].xyz), length(u_modelMatrix[2].xyz));
      rayDirection = normalize(rayDirection / scale);

      // transform ray into local coordinates of sdf bounds
      vec3 sdfRayOrigin = (sdfTransformInverse * vec4(rayOrigin, 1.0)).xyz;
      vec3 sdfRayDirection = normalize((sdfTransformInverse * vec4(rayDirection, 0.0)).xyz);

      // find whether our ray hits the box bounds in the local box space
      vec2 boxIntersectionInfo = rayBoxDist(vec3(-0.5), vec3(0.5), sdfRayOrigin, sdfRayDirection);
      float distToBox = boxIntersectionInfo.x;
      float distInsideBox = boxIntersectionInfo.y;
      bool intersectsBox = distInsideBox > 0.0;

      // Set initial depth [-1, 1], > 0 blended in deferred pass
      float fragCoordZ = -1.0;

      vec4 diffuseColor = vec4(0, 0, 0, 1);

      if (intersectsBox) {
        // Find the surface point in SDF local space [-0.5, 0.5]
        vec4 point = sdfTransform * vec4(sdfRayOrigin + sdfRayDirection * (distToBox + epsilon), 1.0);

        // ray march
        for (int i = 0; i < maxSteps; i++) {
          // Transform SDF local space into local bounds space [0, 1] and check if we're inside the bounds
          vec3 uv = (sdfTransformInverse * point).xyz + vec3(0.5);
          if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0 || uv.z < 0.0 || uv.z > 1.0) break;

          // Get distance to surface from SDF lookup (negative inside)
          vWorldPosition = (inverse(viewMatrix * u_modelMatrix) * point).xyz;
          vViewPosition = -(point).xyz;

          float distanceToSurface = (texture(sdfTex, uv).r - surface);

          if (distanceToSurface < surfaceEpsilon) {
            // Set screen-space depth for deferred visibility blend
            fragCoordZ = -point.z;

            // Get world normal for lighting
            normal = getNormal(sdfTex, uv, normalStep);

            // // Hemisphere "snow" lighting
            diffuseColor.rgb += getHemisphereLighting(normal, cloudColor, shadowColor);
            break;
          }
          // step the ray
          point.xyz += rayDirection * abs(distanceToSurface);
        }
      }
     
      float toonShading = 0.5;
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_normal = vec4(normal, toonShading);
      vec4 o_position = vec4(vWorldPosition, 1.);

      o_diffuse = o_position;
      vec3 vNormal = normal;
      float shadow = 0.;
      // #include <shadows_fragment>

      #ifndef USE_DEFERRED
        #include <forward_lights_fragment>
      #endif
      gl_FragDepth = viewZToPerspectiveDepth(-fragCoordZ, cameraNear, cameraFar);

      #include <layout_output_fragment>

    }
  `, null), _d = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ RayMarchBasicMaterialImpl: hd });
const xd = /* @__PURE__ */ A.forwardRef(function(t, a) {
  const i = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(a, () => i.current), _e(i);
  const r = /* @__PURE__ */ se();
  return bt("rayMarchBasicMaterialImpl", { glslVersion: n.GLSL3, ...r, key: _d, ...t, ref: i });
}), je = /* @__PURE__ */ De((e, t) => ({ sdfFBO: null, sdfCount: 0, addSdf: () => e((a) => ({ sdfCount: a.sdfCount + 1 })), removeSdf: () => e((a) => ({ sdfCount: a.sdfCount - 1 })) })), yd = () => {
  const { width: e, height: t } = /* @__PURE__ */ U((r) => r.size), a = /* @__PURE__ */ Y((r) => r.useDeferred), i = /* @__PURE__ */ V(() => {
    const r = new n.WebGLRenderTarget(512, 512, { generateMipmaps: false, colorSpace: n.LinearSRGBColorSpace, type: n.UnsignedByteType });
    return r.depthTexture = new n.DepthTexture(512, 512), r.depthTexture.type = n.FloatType, r;
  }, [a]);
  return q(({ gl: r }, l) => {
    const s = /* @__PURE__ */ r.getRenderTarget();
    r.setRenderTarget(i), r.clear(), r.setRenderTarget(s);
  }, 990), ie(() => {
    i.setSize(e, t);
  }, [i, e, t]), G(() => (be({ tCloud: i.texture, tCloudDepth: i.depthTexture }), je.setState({ sdfFBO: i }), Pt({ useClouds: true }), () => {
    i.texture.dispose(), i.depthTexture.dispose(), i.dispose(), be({ tCloud: null, tCloudDepth: null }), je.setState({ sdfFBO: i }), Pt({ useClouds: false });
  }), [i]), null;
}, bd = () => je((t) => t.sdfCount) > 0 ? y(yd, {}) : null, Wn = new n.Vector3();
function wd({ surface: e = 0, surfaceEpsilon: t = 1e-3, epsilon: a = 1e-6, maxSteps: i = 100, resolution: r = 32, margin: l = 0.2, binary: s, boundsMatrix: o, ...f }) {
  V(() => N({ TriangleGeometry: St }), []);
  const [d, c] = /* @__PURE__ */ je((C) => [C.addSdf, C.removeSdf]);
  G(() => (d(), () => {
    c();
  }), []);
  const u = /* @__PURE__ */ I(new n.Matrix4()), m = /* @__PURE__ */ I(), p = /* @__PURE__ */ U((C) => C.gl), g = /* @__PURE__ */ U((C) => C.camera);
  q((C, _) => {
    const x = je.getState().sdfFBO;
    if (!x)
      return;
    if (m.current.material.projectionInverse.copy(g.projectionMatrixInverse), m.current.material.boundsMatrix.copy(o), f.mesh) {
      const w = f.mesh.scale.x, P = f.mesh.scale.y, S = f.mesh.scale.z, M = /* @__PURE__ */ Math.max(1, (w + P + S) / 3);
      Wn.set(M, M, M), u.current.compose(f.mesh.position, f.mesh.quaternion, Wn);
    }
    m.current.material.u_modelMatrix.copy(u.current), x.depthTexture.colorSpace = n.LinearSRGBColorSpace;
    const b = p.autoClear;
    p.setRenderTarget(x), p.autoClear = false, m.current.visible = true, p.render(m.current, g), m.current.visible = false, p.autoClear = b, p.setRenderTarget(null);
  }, 994);
  const h = s instanceof Float32Array ? s : new Float32Array(s);
  return H("mesh", { ...f, ref: m, visible: false, frustumCulled: false, children: [y("triangleGeometry", {}), y(xd, { camearNear: g.near, cameraFar: g.far, normalStep: 1 / r, surface: e, surfaceEpsilon: t, epsilon: a, maxSteps: i, shadowColor: f.shadowColor, cloudColor: f.cloudColor, noiseSpeed: f.noiseSpeed, noiseScale: f.noiseScale, side: n.FrontSide, children: y("data3DTexture", { attach: "sdfTex", args: [h, r, r, r], type: n.FloatType, minFilter: n.LinearFilter, magFilter: n.LinearFilter, format: n.RedFormat, needsUpdate: true }) })] });
}
const Ad = /* @__PURE__ */ W({ surface: -4, cameraNear: 0.1, cameraFar: 3500, noiseSpeed: 0.5, noiseScale: new n.Vector3(1, 1, 1), noiseTex: null, sdfTex: null, normalStep: new n.Vector3(), projectionInverse: new n.Matrix4(), boundsMatrix: new n.Matrix4(), u_modelMatrix: new n.Matrix4(), cloudColor: new n.Color(14276318).convertLinearToSRGB(), shadowColor: new n.Color(10263454).convertLinearToSRGB() }, `
    out vec2 vUv;

    void main() {
      vUv = uv;
      gl_Position = vec4(position, 1);
    }
  `, `
    precision highp float;
    precision highp int;
    precision highp sampler3D;

    #include <layout_pars_fragment>
    in vec2 vUv;
    uniform float surface;
    uniform sampler3D sdfTex;
    uniform sampler3D noiseTex;
    uniform vec3 normalStep;
    uniform mat4 projectionInverse;
    uniform mat4 u_modelMatrix;
    uniform mat4 boundsMatrix;
    uniform vec3 cloudColor;
    uniform vec3 shadowColor;
    uniform float noiseSpeed;
    uniform vec3 noiseScale;

    #include <common>
    #include <common_ubo_pars>
    #include <introanimation_pars_fragment>

    #ifndef USE_DEFERRED
    #include <deferred_lights_pars>
    #endif

    #include <packing>

    uniform float cameraNear;
    uniform float cameraFar;

    float PerlinWorleyNoise(vec3 position) {
      vec3 coord = position.xzy * vec3(1.0 / 32.0) * 10.0;
      return texture(noiseTex, coord).r;
    }
    
    // distance to box bounds
    vec2 rayBoxDist(vec3 boundsMin, vec3 boundsMax, vec3 rayOrigin, vec3 rayDir) {
      vec3 t0 = (boundsMin - rayOrigin) / rayDir;
      vec3 t1 = (boundsMax - rayOrigin) / rayDir;
      vec3 tmin = min(t0, t1);
      vec3 tmax = max(t0, t1);
      float distA = max(max(tmin.x, tmin.y), tmin.z);
      float distB = min(tmax.x, min(tmax.y, tmax.z));
      float distToBox = max(0.0, distA);
      float distInsideBox = max(0.0, distB - distToBox);
      return vec2(distToBox, distInsideBox);
    }

    vec3 getNormal(sampler3D sdfTex, vec3 uv, vec3 normalStep) {
      float dx = texture(sdfTex, uv + vec3(normalStep.x, 0.0, 0.0)).r - texture(sdfTex, uv - vec3(normalStep.x, 0.0, 0.0)).r;
      float dy = texture(sdfTex, uv + vec3(0.0, normalStep.y, 0.0)).r - texture(sdfTex, uv - vec3(0.0, normalStep.y, 0.0)).r;
      float dz = texture(sdfTex, uv + vec3(0.0, 0.0, normalStep.z)).r - texture(sdfTex, uv - vec3(0.0, 0.0, normalStep.z)).r;
      vec3 normal = normalize(vec3(dx, dy, dz));
      return normal;
    }

    vec3 getHemisphereLighting(vec3 normal, vec3 skyColor, vec3 groundColor) {
      vec3 direction = normalize(vec3(0.0, 1.0, 0.0));
      float weight = 0.5 * dot(normal, direction) + 0.5;
      vec3 lighting = mix(groundColor, skyColor, weight);
      return lighting;
    }

    // #include <shadows_pars_fragment>

    void main() {
      // get the inverse of the sdf box transform
      mat4 sdfTransform = viewMatrix * u_modelMatrix * boundsMatrix;

      mat4 sdfTransformInverse = inverse(sdfTransform);
      vec3 vWorldPosition = vec3(0.);
      vec3 vViewPosition = vec3(0.);
      vec3 normal = vec3(0.);
      // get world ray direction
      vec3 rayOrigin = vec3(0.0);
      vec3 rayDirection = normalize((projectionInverse * vec4(vUv * 2.0 - 1.0, -1.0, 1.0)).xyz);

      vec3 scale = vec3(length(u_modelMatrix[0].xyz), length(u_modelMatrix[1].xyz), length(u_modelMatrix[2].xyz));
      rayDirection = normalize(rayDirection / scale);

      // transform ray into local coordinates of sdf bounds
      vec3 sdfRayOrigin = (sdfTransformInverse * vec4(rayOrigin, 1.0)).xyz;
      vec3 sdfRayDirection = normalize((sdfTransformInverse * vec4(rayDirection, 0.0)).xyz);

      // find whether our ray hits the box bounds in the local box space
      vec2 boxIntersectionInfo = rayBoxDist(vec3(-0.5), vec3(0.5), sdfRayOrigin, sdfRayDirection);
      float distToBox = boxIntersectionInfo.x;
      float distInsideBox = boxIntersectionInfo.y;
      bool intersectsBox = distInsideBox > 0.0;

      // Set initial depth [-1, 1], > 0 blended in deferred pass
      float fragCoordZ = -1.0;

      vec4 diffuseColor = vec4(0, 0, 0, 1);

      if (intersectsBox) {
        // Find the surface point in SDF local space [-0.5, 0.5]
        vec4 point = sdfTransform * vec4(sdfRayOrigin + sdfRayDirection * (distToBox + EPSILON), 1.0);

        // ray march
        for (int i = 0; i < MAX_STEPS; i++) {
          // Transform SDF local space into local bounds space [0, 1] and check if we're inside the bounds
          vec3 uv = (sdfTransformInverse * point).xyz + vec3(0.5);
          if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0 || uv.z < 0.0 || uv.z > 1.0) break;

          // Get distance to surface from SDF lookup (negative inside)
          vWorldPosition = (inverse(viewMatrix * u_modelMatrix) * point).xyz;
          vViewPosition = -(point).xyz;
          // float displacement = PerlinWorleyNoise(vWorldPosition * .1 * vec3(1.,0.5,.5) + time * noiseSpeed );

          float displacement = PerlinWorleyNoise(vWorldPosition * 0.1 * noiseScale + time * noiseSpeed ) - PerlinWorleyNoise(vWorldPosition * 2. * noiseScale + time * noiseSpeed);
          // float displacement = 0.;
          // float displacement = worley(vWorldPosition * 0.1 + time * 0.5, 10.) - worley(vWorldPosition + time * 0.5, 10.);
          float distanceToSurface = (texture2D(sdfTex, uv).r - surface) + displacement;

          if (distanceToSurface < SURFACE_EPSILON) {
            // Set screen-space depth for deferred visibility blend
            fragCoordZ = -point.z;

            // Get world normal for lighting
            normal = getNormal(sdfTex, uv, normalStep);

            // // Hemisphere "snow" lighting
            diffuseColor.rgb += getHemisphereLighting(normal + displacement * .03, cloudColor, shadowColor);
            // TODO: temp hack to make the clouds look more like clouds
            diffuseColor.rgb += .2;
            
            break;
          }
          // step the ray
          point.xyz += rayDirection * abs(distanceToSurface);
        }
      }
     
      float toonShading = 0.5;
      vec4 o_diffuse = diffuseColor;
      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_normal = vec4(normal, toonShading);
      vec4 o_position = vec4(vWorldPosition, 1.);

      vec3 vNormal = normal;
      float shadow = 0.;
      // #include <shadows_fragment>

      #ifndef USE_DEFERRED
        #include <forward_lights_fragment>
      #endif
      gl_FragDepth = viewZToPerspectiveDepth(-fragCoordZ, cameraNear, cameraFar);

      #include <layout_output_fragment>

    }
  `, null), Cd = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ RayMarchSDFMaterialImpl: Ad });
const Sd = /* @__PURE__ */ A.forwardRef(function(t, a) {
  const i = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(a, () => i.current), _e(i);
  const r = /* @__PURE__ */ se();
  return bt("rayMarchSDFMaterialImpl", { glslVersion: n.GLSL3, ...r, "defines-MAX_STEPS": 100, "defines-SURFACE_EPSILON": 1.1, key: Cd, ...t, ref: i });
});
class Pd extends n.Data3DTexture {
  constructor(t) {
    const a = new n.ShaderMaterial({ uniforms: { zLevel: { value: 0 }, numCells: { value: 2 } }, type: "WorleyNoiseAtlas", vertexShader: `
        varying vec2 vUv;

        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1.0);
        }
      `, fragmentShader: `
        varying vec2 vUv;
        uniform float zLevel;
        uniform float numCells;

        float inverseLerp(float minValue, float maxValue, float v) {
          return (v - minValue) / (maxValue - minValue);
        }

        float remap(float v, float inMin, float inMax, float outMin, float outMax) {
          float t = inverseLerp(inMin, inMax, v);
          return mix(outMin, outMax, t);
        }

        vec3 hash3(vec3 p) {
          p = vec3(
            dot(p, vec3(127.1, 311.7, 74.7)),
            dot(p, vec3(269.5, 183.3, 246.1)),
            dot(p, vec3(113.5, 271.9, 124.6))
          );

          return -1.0 + 2.0 * fract(sin(p) * 43758.5453123);
        }

        vec3 hash3_New(vec3 p, float tileLength) {
          return hash3(mod(p, vec3(tileLength)));
        }

        float voronoiSlow(float maxOffset, float cellsMult, float seed) {
          vec3 coords = vec3(vUv * cellsMult, zLevel);
          vec3 seedHash = hash3(vec3(seed, seed * seed * 3.14159, seed * 1.17421));

          vec3 gridBasePosition = floor(coords);
          vec3 gridCoordOffset = fract(coords);
          float maxCellSearch = ceil(maxOffset) + 1.0;

          float closest = 1.0;
          for (float y = -maxCellSearch; y <= maxCellSearch; y += 1.0) {
            for (float x = -maxCellSearch; x <= maxCellSearch; x += 1.0) {
              for (float z = -maxCellSearch; z <= maxCellSearch; z += 1.0) {
                vec3 neighbourCellPosition = vec3(x, y, z);
                vec3 cellWorldPosition = gridBasePosition + neighbourCellPosition;
                cellWorldPosition.xy = mod(cellWorldPosition.xy, vec2(cellsMult));

                vec3 cellOffset = hash3(cellWorldPosition + seedHash);
                cellOffset *= maxOffset;

                float distToNeighbour = length(
                    neighbourCellPosition + cellOffset - gridCoordOffset);
                closest = min(closest, distToNeighbour);
              }
            }
          }

          return clamp(closest, 0.0, 1.0);
        }

        float gradientNoise(vec3 p, float tileLength) {
          vec3 i = floor(p);
          vec3 f = fract(p);
          
          vec3 u = smoothstep(vec3(0.0), vec3(1.0), f);
            
          /*
          * For 1D, the gradient of slope g at vertex u has the form h(x) = g * (x - u), where u 
          * is an integer and g is in [-1, 1]. This is the equation for a line with slope g which 
          * intersects the x-axis at u.
          * For N dimensional noise, use dot product instead of multiplication, and do 
          * component-wise interpolation (for 3D, trilinear)
          */
          return mix( mix( mix( dot( hash3_New(i + vec3(0.0,0.0,0.0), tileLength), f - vec3(0.0,0.0,0.0)), 
                                dot( hash3_New(i + vec3(1.0,0.0,0.0), tileLength), f - vec3(1.0,0.0,0.0)), u.x),
                          mix( dot( hash3_New(i + vec3(0.0,1.0,0.0), tileLength), f - vec3(0.0,1.0,0.0)), 
                                dot( hash3_New(i + vec3(1.0,1.0,0.0), tileLength), f - vec3(1.0,1.0,0.0)), u.x), u.y),
                      mix( mix( dot( hash3_New(i + vec3(0.0,0.0,1.0), tileLength), f - vec3(0.0,0.0,1.0)), 
                                dot( hash3_New(i + vec3(1.0,0.0,1.0), tileLength), f - vec3(1.0,0.0,1.0)), u.x),
                          mix( dot( hash3_New(i + vec3(0.0,1.0,1.0), tileLength), f - vec3(0.0,1.0,1.0)), 
                                dot( hash3_New(i + vec3(1.0,1.0,1.0), tileLength), f - vec3(1.0,1.0,1.0)), u.x), u.y), u.z );
        }

        // https://github.com/sebh/TileableVolumeNoise/blob/master/TileableVolumeNoise.cpp
        float tileableFBM(vec3 p, float tileLength) {
          const float persistence = 0.5;
          const float lacunarity = 2.0;
          const int octaves = 8;

          float amplitude = 0.5;
          float total = 0.0;
          float normalization = 0.0;

          for (int i = 0; i < octaves; ++i) {
            float noiseValue = gradientNoise(p, tileLength * lacunarity * 0.5) * 0.5 + 0.5;
            total += noiseValue * amplitude;
            normalization += amplitude;
            amplitude *= persistence;
            p = p * lacunarity;
          }

          total /= normalization;
          total = smoothstep(0.0, 1.0, total);

          return total;
        }

        // https://github.com/sebh/TileableVolumeNoise/blob/master/main.cpp
        vec4 PerlinWorleyDetails(float CELL_RANGE, float numCells, float mult) {
          float perlinWorley = 0.0;
          {
            float worley0 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 2.0 * mult, 1.0);
            float worley1 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 8.0 * mult, 2.0);
            float worley2 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 16.0 * mult, 3.0);
            float worleyFBM = worley0 * 0.625 + worley1 * 0.25 + worley2 * 0.125;

            float tileLength = 8.0;
            float fbm0 = tileableFBM(vec3(vUv * tileLength, zLevel) * mult, tileLength);

            perlinWorley = remap(fbm0, 0.0, 1.0, worleyFBM, 1.0);
          }

          float worley0 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 1.0 * mult, 4.0);
          float worley1 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 2.0 * mult, 5.0);
          float worley2 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 4.0 * mult, 6.0);
          float worley3 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 8.0 * mult, 7.0);
          float worley4 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 16.0 * mult, 8.0);
          float worley5 = 1.0 - voronoiSlow(CELL_RANGE, numCells * 32.0 * mult, 9.0);

          float worleyFBM0 = worley1 * 0.625 + worley2 * 0.25 + worley3 * 0.125;
          float worleyFBM1 = worley2 * 0.625 + worley3 * 0.25 + worley4 * 0.125;
          float worleyFBM2 = worley3 * 0.625 + worley4 * 0.25 + worley5 * 0.125;

          float lowFreqFBM = worleyFBM0 * 0.625 + worleyFBM1 * 0.25 + worleyFBM2 * 0.125;

          float tileLength = 8.0;
          float perlinWorleyDetail = remap(perlinWorley, lowFreqFBM, 1.0, 0.0, 1.0);

          return vec4(perlinWorleyDetail, 0.0, 0.0, 0.0);
        }

        const float CELL_RANGE = 1.0;

        void main() {
          gl_FragColor = PerlinWorleyDetails(CELL_RANGE, numCells, 1.0);
        }
      ` }), i = new n.OrthographicCamera(), r = new n.Mesh(new St(), a);
    r.frustumCulled = false;
    const l = 32, s = 64, o = 4 * l * l, f = new n.WebGLRenderTarget(l, l, { type: n.FloatType }), d = new Float32Array(s * o), c = new Float32Array(o), u = t.xr.enabled;
    t.xr.enabled = false;
    for (let m = 0; m < s; m++) {
      a.uniforms.zLevel.value = m / 4, t.setRenderTarget(f), t.render(r, i), t.readRenderTargetPixels(f, 0, 0, l, l, c), t.setRenderTarget(null);
      const p = m * o;
      d.set(c, p);
    }
    t.xr.enabled = u, super(d, l, l, s), this.minFilter = n.LinearFilter, this.magFilter = n.LinearFilter, this.wrapS = n.RepeatWrapping, this.wrapT = n.RepeatWrapping, this.wrapR = n.RepeatWrapping, this.needsUpdate = true, r.geometry.dispose(), r.material.dispose(), f.dispose(), f.texture.dispose();
  }
}
const Md = /* @__PURE__ */ W({ delta: 0, cloudColor: new n.Color(14276318).convertLinearToSRGB(), shadowColor: new n.Color(10263454).convertLinearToSRGB() }, `
    uniform float delta;
    out vec2 vUv;
    out vec3 vNormal;
    out vec3 vWorldPosition;
    out float vDisplacement;

    // 3D FBM noise https://shadertoy.com/view/lss3zr
    mat3 m = mat3(0.00, 0.80, 0.60, -0.80, 0.36, -0.48, -0.60, -0.48, 0.64);
    float hash(float n) {
      return fract(sin(n) * 43758.5453);
    }
    float noise(vec3 x) {
      vec3 p = floor(x);
      vec3 f = fract(x);
      f = f * f * (3.0 - 2.0 * f);
      float n = p.x + p.y * 57.0 + 113.0 * p.z;
      float res = mix(mix(mix(hash(n + 0.0), hash(n + 1.0), f.x),
                          mix(hash(n + 57.0), hash(n + 58.0), f.x), f.y),
                      mix(mix(hash(n + 113.0), hash(n + 114.0), f.x),
                          mix(hash(n + 170.0), hash(n + 171.0), f.x), f.y), f.z);
      return res;
    }
    float fbm(vec3 p) {
      float f = 0.0;
      f += 0.5000 * noise(p); p = m * p * 2.02;
      f += 0.2500 * noise(p); p = m * p * 2.03;
      f += 0.12500 * noise(p); p = m * p * 2.01;
      f += 0.06250 * noise(p);
      return f;
    }

    void main() {
      vUv = uv;
      vNormal = normalize(normal);
      vDisplacement = fbm(position * 0.1 + delta * 0.8) - fbm(position + delta * 0.8);
      vWorldPosition = (modelMatrix * viewMatrix * vec4(position + vDisplacement, 1)).xyz;
      gl_Position = projectionMatrix * vec4(vWorldPosition, 1.);
    }
  `, `
    precision mediump float;
    precision mediump int;
    precision mediump sampler3D;

    #include <layout_pars_fragment>

    #include <packing>
    #include <common>
    #include <common_ubo_pars>
    #include <introanimation_pars_fragment>

    #ifndef USE_DEFERRED
    #include <deferred_lights_pars>
    #endif

    in vec2 vUv;
    in vec3 vNormal;
    in vec3 vWorldPosition;
    in float vDisplacement;
    uniform vec3 cloudColor;
    uniform vec3 shadowColor;

    vec3 getHemisphereLighting(vec3 normal, vec3 skyColor, vec3 groundColor) {
      vec3 direction = normalize(vec3(0.0, 1.0, 0.0));
      float weight = 0.5 * dot(normal, direction) + 0.5;
      vec3 lighting = mix(groundColor, skyColor, weight);
      return lighting;
    }

    void main() {
      vec4 diffuseColor = vec4(0, 0, 0, 1);

      // Hemisphere "snow" lighting
      diffuseColor.rgb += getHemisphereLighting(vNormal + vDisplacement * .03, cloudColor, shadowColor);
      // diffuseColor.rgb += .2;

      vec4 o_diffuse = diffuseColor;

      float shadow = 0.;
      float toonShading = .5;

      vec4 o_color = vec4(vec3(0.), 1.);
      vec4 o_normal = vec4(vNormal, toonShading);
      vec4 o_position = vec4(vWorldPosition, shadow);

      #ifndef USE_DEFERRED
        #include <forward_lights_fragment>
      #endif
      #include <layout_output_fragment>
    }
  `, null), Dd = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ MeshSDFMaterialImpl: Md });
const Ed = /* @__PURE__ */ A.forwardRef(function(t, a) {
  const i = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(a, () => i.current), _e(i);
  const r = /* @__PURE__ */ se({ useShadows: true });
  return bt("meshSDFMaterialImpl", { ref: i, glslVersion: n.GLSL3, ...r, ...t, key: Dd });
});
class Td extends n.Data3DTexture {
  constructor(t, a, i, r) {
    const l = new n.ShaderMaterial({ type: "MeshSDFAtlas", uniforms: { boundsMatrix: { value: new n.Matrix4() }, bvh: { value: new Oo() }, zValue: { value: 0 } }, vertexShader: `
        varying vec2 vUv;

        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1.0);
        }
      `, fragmentShader: `
        precision highp isampler2D;
        precision highp usampler2D;
        ${Go}
        ${Ho}
        ${Vo}
        varying vec2 vUv;
        uniform BVH bvh;
        uniform float zValue;
        uniform mat4 boundsMatrix;
        void main() {
          // compute the point in space to check
          vec3 point = (boundsMatrix * vec4(vec3(vUv, zValue) - 0.5, 1.0)).xyz;
          // retrieve the distance and other values
          uvec4 faceIndices;
          vec3 faceNormal;
          vec3 barycoord;
          float side;
          vec3 outPoint;
          float dist = bvhClosestPointToPoint(bvh, point.xyz, faceIndices, faceNormal, barycoord, side, outPoint);
          // if the triangle side is the back then it must be on the inside and the value negative
          gl_FragColor = vec4(side * dist, 0, 0, 0);
        }
      ` }), s = new n.OrthographicCamera(), o = new n.Mesh(new St(), l);
    o.frustumCulled = false;
    const f = 1 / r, d = 0.5 * f, c = r, u = 4 * r * r, m = new n.WebGLRenderTarget(r, r, { type: n.FloatType }), p = new Float32Array(c * u), g = new Float32Array(u);
    console.log(p), l.uniforms.bvh.value.updateFrom(i), l.uniforms.boundsMatrix.value.copy(a);
    const h = t.xr.enabled;
    t.xr.enabled = false;
    for (let C = 0; C < c; C++) {
      l.uniforms.zValue.value = C * f + d, t.setRenderTarget(m), t.render(o, s), t.readRenderTargetPixels(m, 0, 0, r, r, g), t.setRenderTarget(null);
      const _ = C * u;
      p.set(g, _);
    }
    t.xr.enabled = h, super(p, r, r, c), this.type = n.FloatType, this.minFilter = n.LinearFilter, this.magFilter = n.LinearFilter, this.needsUpdate = true, o.geometry.dispose(), o.material.dispose(), m.dispose(), m.texture.dispose();
  }
}
const jn = new n.Vector3(), Id = new n.Quaternion(), Nt = new n.Vector3();
function Ud({ surface: e = 0, resolution: t = 75, margin: a = 0.2, binary: i, boundsMatrix: r, ...l }) {
  V(() => N({ TriangleGeometry: St, WorleyNoiseAtlas: Pd, MeshSDFAtlas: Td }), []);
  const s = /* @__PURE__ */ I(), o = /* @__PURE__ */ U((h) => h.gl), f = /* @__PURE__ */ U((h) => h.camera), d = /* @__PURE__ */ I(new n.Matrix4()), c = /* @__PURE__ */ I(new n.Matrix4());
  G(() => {
    l.mesh && (l.mesh.geometry.computeBoundingBox(), l.mesh.geometry.boundingBox.getCenter(jn), Nt.subVectors(l.mesh.geometry.boundingBox.max, l.mesh.geometry.boundingBox.min), Nt.addScalar(a), d.current.compose(jn, Id, Nt));
  }, [l.mesh]);
  const [u, m] = /* @__PURE__ */ je((h) => [h.addSdf, h.removeSdf]);
  G(() => (u(), () => {
    m();
  }), []), q((h, C) => {
    const _ = je.getState().sdfFBO;
    if (!_)
      return;
    if (s.current.material.projectionInverse.copy(f.projectionMatrixInverse), s.current.material.boundsMatrix.copy(d.current), l.mesh) {
      const b = l.mesh.scale.x, w = l.mesh.scale.y, P = l.mesh.scale.z, S = /* @__PURE__ */ Math.max(1, (b + w + P) / 3);
      Nt.set(S, S, S), c.current.compose(l.mesh.position, l.mesh.quaternion, Nt);
    }
    s.current.material.u_modelMatrix.copy(c.current), _.depthTexture.colorSpace = n.LinearSRGBColorSpace;
    const x = o.autoClear;
    o.setRenderTarget(_), o.autoClear = false, s.current.visible = true, o.render(s.current, f), s.current.visible = false, o.autoClear = x, o.setRenderTarget(null);
  }, 994);
  const p = /* @__PURE__ */ Se(async () => fetch(v["/bin/worley_32.bin"]).then((h) => h.arrayBuffer()), ["_/bin/worley_32.bin"]), g = i instanceof Float32Array ? i : new Float32Array(i);
  return H("mesh", { ...l, ref: s, visible: false, frustumCulled: false, children: [y("triangleGeometry", {}), H(Sd, { camearNear: f.near, cameraFar: f.far, normalStep: 1 / t, surface: e, shadowColor: l.shadowColor, cloudColor: l.cloudColor, noiseSpeed: l.noiseSpeed, noiseScale: l.noiseScale, side: n.FrontSide, children: [y("data3DTexture", { attach: "sdfTex", args: [g, t, t, t], type: n.FloatType, minFilter: n.LinearFilter, magFilter: n.LinearFilter, format: n.RedFormat, needsUpdate: true }), y("data3DTexture", { attach: "noiseTex", args: [new Float32Array(p), 32, 32, 32], type: n.FloatType, minFilter: n.LinearFilter, magFilter: n.LinearFilter, format: n.RedFormat, wrapS: n.RepeatWrapping, wrapT: n.RepeatWrapping, wrapR: n.RepeatWrapping, needsUpdate: true })] })] });
}
function Bd({ showMeshFallback: e, gltf: t, ...a }) {
  const i = /* @__PURE__ */ I();
  return q(() => {
    i.current.visible = true;
  }, 6), q(() => {
    i.current.visible = e;
  }, 8), q((r, l) => {
    i.current.material.delta && (i.current.material.delta += l);
  }, 996), y("mesh", { ...a, ref: i, children: y(Ed, {}) });
}
function kd({ mesh: e, ...t }) {
  U((i) => i.gl), Y((i) => i.quality), yn("isMobile");
  const a = At;
  return H(te, { children: [y(Bd, { showMeshFallback: a, ...t, gltf: e }), !a && y(Ud, { ...t, mesh: e })] });
}
function Rd(e) {
  return y(de, { fallback: null, children: y(kd, { ...e }) });
}
class Qn {
  constructor() {
    this.running = false, this.worker = new Worker(new URL("./assets/generateAsync.worker-dfe2013c.js", import.meta.url), { type: "module" }), this.worker.onerror = (t) => {
      throw t.message ? new Error(`GenerateMeshBVHWorker: Could not create Web Worker with error "${t.message}"`) : new Error("GenerateMeshBVHWorker: Could not create Web Worker.");
    };
  }
  generate(t, a = {}) {
    if (this.running)
      throw new Error("GenerateMeshBVHWorker: Already running job.");
    if (this.worker === null)
      throw new Error("GenerateMeshBVHWorker: Worker has been disposed.");
    const { worker: i } = this;
    return this.running = true, new Promise((r, l) => {
      i.onerror = (d) => {
        l(new Error(`GenerateMeshBVHWorker: ${d.message}`)), this.running = false;
      }, i.onmessage = (d) => {
        this.running = false;
        const { data: c } = d;
        if (c.error)
          l(new Error(c.error)), i.onmessage = null;
        else if (c.serialized) {
          const { serialized: u, position: m } = c, p = /* @__PURE__ */ Wo.deserialize(u, t, { setIndex: false }), g = { setBoundingBox: true, ...a };
          if (t.attributes.position.array = m, t.index)
            t.index.array = u.index;
          else {
            const h = new yt(u.index, 1, false);
            t.setIndex(h);
          }
          g.setBoundingBox && (t.boundingBox = p.getBoundingBox(new bo())), r(p), i.onmessage = null;
        } else
          a.onProgress && a.onProgress(c.progress);
      };
      const s = t.index ? t.index.array : null, o = t.attributes.position.array;
      if (o.isInterleavedBufferAttribute || s && s.isInterleavedBufferAttribute)
        throw new Error("GenerateMeshBVHWorker: InterleavedBufferAttribute are not supported for the geometry attributes.");
      const f = [o];
      s && f.push(s), i.postMessage({ index: s, position: o, options: { ...a, onProgress: null, includedProgressCallback: !!a.onProgress, groups: [...t.groups] } }, f.map((d) => d.buffer));
    });
  }
  dispose() {
    this.worker.terminate(), this.worker = null;
  }
  terminate() {
    console.warn('GenerateMeshBVHWorker: "terminate" is deprecated. Use "dispose" instead.'), this.dispose();
  }
}
const Yn = new n.Vector3(), Ld = new n.Quaternion(), oi = new n.Vector3();
function zd(e, t, a, i) {
  const r = i, l = new n.Data3DTexture(new Float32Array(r ** 3), r, r, r);
  l.format = n.RedFormat, l.type = n.FloatType, l.minFilter = n.LinearFilter, l.magFilter = n.LinearFilter, l.needsUpdate = true, console.log(l);
  const s = t.attributes.position, o = t.index, f = new n.Vector3(), d = new n.Vector3(), c = new n.Vector3(), u = new n.Triangle(), m = {}, p = 1 / r, g = 0.5 * p;
  for (let h = 0; h < r; h++)
    for (let C = 0; C < r; C++)
      for (let _ = 0; _ < r; _++) {
        f.set(g + h * p - 0.5, g + C * p - 0.5, g + _ * p - 0.5).applyMatrix4(a);
        const x = h + C * r + _ * r * r, b = e.closestPointToPoint(f, m).distance, w = m.faceIndex, P = /* @__PURE__ */ o.getX(w * 3 + 0), S = /* @__PURE__ */ o.getX(w * 3 + 1), M = /* @__PURE__ */ o.getX(w * 3 + 2);
        u.setFromAttributeAndIndices(s, P, S, M), u.getNormal(d), c.subVectors(m.point, f), l.image.data[x] = d.dot(c) > 0 ? -b : b;
      }
  return console.log(l.image.data), l;
}
function Fd(e, t) {
  if (e.isData3DTexture) {
    const a = e.image.data, i = new Blob([a.buffer], { type: "application/octet-stream" });
    if (t) {
      const r = /* @__PURE__ */ URL.createObjectURL(i), l = /* @__PURE__ */ document.createElement("a");
      l.href = r, l.download = "texture.bin", document.body.appendChild(l), l.click(), document.body.removeChild(l), URL.revokeObjectURL(r);
    }
    return [a, i];
  } else
    console.error("The texture is not a 3D texture!");
}
const Nd = async (e, t = 32, a = 0.02, i = true) => {
  e.traverse((m) => {
    m.isMesh && (m.visible = true);
  });
  const r = new jo(e);
  r.attributes = ["position", "normal"], r.useGroups = false;
  let l = r.generate();
  const s = new Qn(), o = await s.generate(l, { maxLeafTris: 1 });
  s.dispose();
  const f = new n.Matrix4();
  o.geometry.boundingBox.getCenter(Yn), oi.subVectors(o.geometry.boundingBox.max, o.geometry.boundingBox.min), oi.addScalar(a), f.compose(Yn, Ld, oi);
  const d = /* @__PURE__ */ zd(o, l, f, t), [c, u] = /* @__PURE__ */ Fd(d, i);
  return [c, u, f];
}, Od = ({ videoRef: e, vision: t, showVideo: a = true, ...i }) => {
  const r = /* @__PURE__ */ I(null), l = /* @__PURE__ */ I(null), s = /* @__PURE__ */ I(null);
  re("facetracking_tick", ({ results: d, resultsPose: c }) => {
    l.current = d, s.current = c, f();
  });
  const o = /* @__PURE__ */ I(), f = /* @__PURE__ */ wt(() => {
    const d = e.current, c = r.current;
    if (!c || !d)
      return;
    const u = d.videoHeight / d.videoWidth;
    c.width = parseFloat(d.getBoundingClientRect().width), c.height = parseFloat(d.getBoundingClientRect().width) * u, c.style.height = "100%", c.style.width = parseFloat(d.getBoundingClientRect().height) * (d.videoWidth / d.videoHeight) + "px", o.current || (o.current = new t.DrawingUtils(c.getContext("2d")));
    const m = o.current;
    if (m) {
      for (const p of l.current.faceLandmarks)
        if (m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_TESSELATION, { color: "#C0C0C070", lineWidth: 1 }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_LEFT_EYE, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_FACE_OVAL, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_LIPS, { color: "#E0E0E0" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_RIGHT_IRIS, { color: "#093cbe" }), m.drawConnectors(p, t.FaceLandmarker.FACE_LANDMARKS_LEFT_IRIS, { color: "#093cbe" }), s.current)
          for (const g of s.current.landmarks) {
            const h = /* @__PURE__ */ Object.assign([], t.PoseLandmarker.POSE_CONNECTIONS);
            h.splice(0, 9), m.drawConnectors(g, h);
          }
    }
  }, [o.current, e, l.current, r.current, t]);
  return y("canvas", { ref: r, style: { width: "100%", height: "100%", position: "absolute", zIndex: 1, top: 0, left: "50%", opacity: a ? 1 : 0.1, transform: "translateX(-50%)" }, ...i });
};
function Gd(e, t) {
  let a;
  return function(...r) {
    const l = this;
    a || (a = setTimeout(() => {
      e.apply(l, r), a = null;
    }, t));
  };
}
const Hd = ({ videoRef: e, stream: t, loadedData: a, show: i = false, setLoading: r }) => {
  const [l, s] = /* @__PURE__ */ Se(async () => {
    const d = "VIDEO", c = await import("@mediapipe/tasks-vision").then((h) => h.default).catch(() => (console.log("Mediapipe not loaded"), [null, null])), { FilesetResolver: u, FaceLandmarker: m } = c, p = await u.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm");
    return [await m.createFromOptions(p, { baseOptions: { modelAssetPath: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task", delegate: "GPU" }, outputFaceBlendshapes: true, outputFacialTransformationMatrixes: true, runningMode: d, selfieMode: true, numFaces: 1, modelComplexity: 1, smoothLandmarks: true, enableSegmentation: true, smoothSegmentation: true }), c];
  }, ["vision"]), o = /* @__PURE__ */ I(-1), f = /* @__PURE__ */ wt(() => {
    const d = e.current;
    if (d) {
      const c = /* @__PURE__ */ Date.now();
      if (o.current !== d.currentTime) {
        o.current = d.currentTime;
        const u = /* @__PURE__ */ l.detectForVideo(d, c);
        u.faceBlendshapes && u.faceBlendshapes.length > 0 ? u.facialTransformationMatrixes[0] && ae("facetracking", { faceLandmarks: u.faceLandmarks[0], points: u.faceBlendshapes[0].categories, video: d }) : ae("facetracking_reset"), ae("facetracking_tick", { results: u });
      }
    }
  }, [l, e]);
  return G(() => {
    const d = e.current;
    return d && t && d.addEventListener("loadeddata", f), () => {
      d?.removeEventListener("loadeddata", f);
    };
  }, [t, l, f, e]), G(() => {
    let d = Gd(() => {
      e.current && a && f();
    }, 10);
    const c = /* @__PURE__ */ za(d);
    return () => {
      d = null, c();
    };
  }, [e, t, a, f]), G(() => (r(false), () => {
    ae("unmount_facetracking");
  }), []), i ? y(Od, { videoRef: e, vision: s }) : null;
};
function Vd(e, t) {
  for (const a of t)
    delete e[a];
}
function Wd(e) {
  e.poseLandmarks && Vd(e.poseLandmarks, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 16, 17, 18, 19, 20, 21, 22]);
}
function qn(e, t) {
  const a = e.canvas;
  for (const i of t) {
    const r = i[0], l = i[1];
    if (r && l) {
      if (r.visibility && l.visibility && (r.visibility < 0.1 || l.visibility < 0.1))
        continue;
      e.beginPath(), e.moveTo(r.x * a.width, r.y * a.height), e.lineTo(l.x * a.width, l.y * a.height), e.stroke();
    }
  }
}
const jd = ({ videoRef: e, mpHolistic: t, showVideo: a = true, ...i }) => {
  const r = /* @__PURE__ */ I(null), l = /* @__PURE__ */ I(null);
  I(null);
  const [s, o] = /* @__PURE__ */ useState(null);
  useEffect(() => {
    Promise.all([import("@mediapipe/drawing_utils"), import("@mediapipe/tasks-vision")]).then(([c, u]) => {
      o({ drawingUtils: c, tasksVision: u });
    }).catch((c) => {
      console.error("Failed to load mediapipe modules", c);
    });
  }, []), re("holistictracking_tick", ({ results: c, resultsPose: u }) => {
    l.current = c, d();
  });
  const f = /* @__PURE__ */ I(), d = /* @__PURE__ */ wt(() => {
    if (!s)
      return;
    const { drawConnectors: c, drawLandmarks: u, lerp: m } = s.drawingUtils, p = e.current, g = r.current;
    if (!g || !p)
      return;
    const h = p.videoHeight / p.videoWidth;
    g.width = parseFloat(p.getBoundingClientRect().width), g.height = parseFloat(p.getBoundingClientRect().width) * h, g.style.height = "100%", g.style.width = parseFloat(p.getBoundingClientRect().height) * (p.videoWidth / p.videoHeight) + "px", f.current || (f.current = new DrawingUtils(g.getContext("2d")));
    const C = /* @__PURE__ */ g.getContext("2d");
    if (!f.current)
      return;
    const x = l.current;
    Wd(x), C.save(), C.clearRect(0, 0, g.width, g.height), C.globalCompositeOperation = "source-in", C.fillStyle = "#00FF00", C.fillRect(0, 0, g.width, g.height), C.globalCompositeOperation = "destination-atop", C.drawImage(x.image, 0, 0, g.width, g.height), C.lineWidth = 5, x.poseLandmarks && (x.rightHandLandmarks && (C.strokeStyle = "white", qn(C, [[x.poseLandmarks[t.POSE_LANDMARKS.RIGHT_ELBOW], x.rightHandLandmarks[0]]])), x.leftHandLandmarks && (C.strokeStyle = "white", qn(C, [[x.poseLandmarks[t.POSE_LANDMARKS.LEFT_ELBOW], x.leftHandLandmarks[0]]])), c(C, x.poseLandmarks, t.POSE_CONNECTIONS, { color: "white" }), u(C, Object.values(t.POSE_LANDMARKS_LEFT).map((b) => x.poseLandmarks[b]), { visibilityMin: 0.65, color: "white", fillColor: "rgb(255,138,0)" }), u(C, Object.values(t.POSE_LANDMARKS_RIGHT).map((b) => x.poseLandmarks[b]), { visibilityMin: 0.65, color: "white", fillColor: "rgb(0,217,231)" })), x.rightHandLandmarks && (c(C, x.rightHandLandmarks, t.HAND_CONNECTIONS, { color: "white" }), u(C, x.rightHandLandmarks, { color: "white", fillColor: "rgb(0,217,231)", lineWidth: 2, radius: (b) => m(b.from.z, -0.15, 0.1, 10, 1) })), x.leftHandLandmarks && (c(C, x.leftHandLandmarks, t.HAND_CONNECTIONS, { color: "white" }), u(C, x.leftHandLandmarks, { color: "white", fillColor: "rgb(255,138,0)", lineWidth: 2, radius: (b) => m(b.from.z, -0.15, 0.1, 10, 1) })), C.globalCompositeOperation = "source-over", x.faceLandmarks && (c(C, x.faceLandmarks, t.FACEMESH_TESSELATION, { color: "#C0C0C070", lineWidth: 1 }), c(C, x.faceLandmarks, t.FACEMESH_RIGHT_EYE, { color: "rgb(0,217,231)" }), c(C, x.faceLandmarks, t.FACEMESH_RIGHT_EYEBROW, { color: "rgb(0,217,231)" }), c(C, x.faceLandmarks, t.FACEMESH_LEFT_EYE, { color: "rgb(255,138,0)" }), c(C, x.faceLandmarks, t.FACEMESH_LEFT_EYEBROW, { color: "rgb(255,138,0)" }), c(C, x.faceLandmarks, t.FACEMESH_FACE_OVAL, { color: "#E0E0E0", lineWidth: 5 }), c(C, x.faceLandmarks, t.FACEMESH_LIPS, { color: "#E0E0E0", lineWidth: 5 })), C.restore();
  }, [s, f.current, e, l.current, r.current]);
  return y("canvas", { ref: r, style: { width: "100%", height: "100%", position: "absolute", zIndex: 1, top: 0, left: "50%", opacity: a ? 1 : 0.1, transform: "translateX(-50%)" }, ...i });
}, Qd = ({ videoRef: e, stream: t, show: a = false, setLoading: i }) => {
  const [r, l] = /* @__PURE__ */ Se(async () => {
    const s = "VIDEO";
    let o = null, f = null;
    f = await import("@mediapipe/holistic").then((c) => c.default).catch(() => (console.log("Mediapipe not loaded"), [null, null]));
    const d = { maxNumFaces: 1, refineLandmarks: true, selfieMode: true, modelComplexity: 1, runningMode: s, smoothLandmarks: true, enableSegmentation: false, smoothSegmentation: true, minDetectionConfidence: 0.5, minTrackingConfidence: 0.5, effect: "background", locateFile: (c) => `https://cdn.jsdelivr.net/npm/@mediapipe/holistic@${f.VERSION}/${c}` };
    return o = new f.Holistic(d), o.setOptions({ maxNumFaces: 1, refineLandmarks: true, selfieMode: true, runningMode: s, modelComplexity: 1, smoothLandmarks: true, refineFaceLandmarks: true, minDetectionConfidence: 0.5, minTrackingConfidence: 0.5 }), o.onResults((c) => {
      ae("holistictracking", c), ae("holistictracking_tick", { results: c, mpHolistic: f });
    }), [o, f];
  }, ["holistic"]);
  return G(() => {
    let s = null;
    const o = e.current;
    return !s && o && import("@mediapipe/camera_utils").then((f) => {
      s = new f.Camera(o, { onFrame: async () => {
        await r.send({ image: o });
      }, width: o.videoWidth, height: o.videoHeight }), s.start();
    }).catch((f) => {
      console.warn("@mediapipe/camera_utils is not installed");
    }), () => {
    };
  }, [t, e]), G(() => (i(false), () => {
    ae("unmount_holistictracking");
  }), []), a ? y(jd, { videoRef: e, mpHolistic: l }) : null;
}, Yd = new n.Quaternion();
new n.Quaternion(), new n.Matrix4();
const pt = new n.Euler(), qd = new n.Vector3(), si = new n.Vector3(1, 1, 1), Xd = (e, t) => {
  const a = /* @__PURE__ */ e.find((i) => i.categoryName === t);
  return a || (console.warn(`Point ${t} not found`), [0, 0, 0]);
}, Kd = (e) => {
  const t = /* @__PURE__ */ I([]);
  re("posetracking", ({ landmarks: a, worldLandmarks: i, video: r }) => {
    if (!e)
      return;
    const l = e.userData.player;
    if (!l)
      return;
    const s = l.face;
    i && i.map((f) => (f.visibility = true, f));
    const o = /* @__PURE__ */ Qo.solve(i, a, { runtime: "mediapipe", enableLegs: false });
    if (o)
      for (const [f, d] of t.current) {
        if (!s)
          continue;
        const c = /* @__PURE__ */ s.get(f);
        if (!c)
          continue;
        const u = 1;
        c.nextRotation = [o[d].x * u, o[d].y * u, o[d].z * u];
      }
  }), re("unmount_facetracking", () => {
    setTimeout(() => {
      const a = e?.userData.player;
      if (!a)
        return;
      const i = a.face;
      for (const [r, l, s] of t.current) {
        const o = /* @__PURE__ */ i.get(r);
        o && (o.nextQuat = o.nextQuat.invert());
      }
    }, 20);
  });
}, Zd = (e) => {
  const t = /* @__PURE__ */ I([["eyeBrow.right.inner", [0, 0.03, 0], "browInnerUp"], ["eyeBrow.right.outer", [0, 0.03, 0], "browOuterUpLeft"], ["eyeBrow.left.inner", [0, 0.03, 0], "browInnerUp"], ["eyeBrow.left.outer", [0, 0.03, 0], "browOuterUpRight"], ["eye.right.retina", [0, 0.01, 0], "browInnerUp"], ["eye.right.upper", [0, -0.073, -3e-3], "eyeBlinkRight"], ["eye.right.lower", [0, 0.03, 0], "eyeSquintRight"], ["eye.left.retina", [0, 0.01, 0], "browInnerUp"], ["eye.left.upper", [0, -0.073, -3e-3], "eyeBlinkLeft"], ["eye.left.lower", [0, 0.03, 0], "eyeSquintLeft"], ["mouth.right", [0, 0.04, 0], "mouthLeft"], ["mouth.left", [0, 0.04, 0], "mouthRight"], ["mouth.upper", [0, 0.04, 0], "jawOpen"], ["mouth.lower", [0, -0.04, 0], "jawOpen"]]);
  re("facetracking", ({ points: a, faceLandmarks: i }) => {
    if (!e)
      return;
    const r = e.userData.player;
    if (!r)
      return;
    const l = r.face, s = /* @__PURE__ */ Yo.solve(i, { runtime: "mediapipe", smoothBlink: true });
    for (const [o, f, d] of t.current) {
      const c = /* @__PURE__ */ l.get(o);
      if (!c)
        continue;
      let m = Xd(a, d).score;
      d === "eyeBlinkLeft" ? m = 1 - s.eye.l : d === "eyeBlinkRight" && (m = 1 - s.eye.r), o === "mouth.upper" ? (s.mouth.y = Math.min(Math.max(s.mouth.y, -4), 4), c.nextPosition = [s.mouth.x * 3e-3, s.mouth.y * 0.019, 0]) : o === "mouth.lower" ? (s.mouth.y = Math.min(Math.max(s.mouth.y, -4), 4), c.nextPosition = [s.mouth.x * 3e-3, s.mouth.y * -0.01, 0]) : d === "mouthLeft" ? (s.mouth.x = Math.min(Math.max(s.mouth.x, -4), 4), c.nextPosition = [s.mouth.x * -0.025, s.mouth.y * 1e-3, 0]) : d === "mouthRight" ? (s.mouth.x = Math.min(Math.max(s.mouth.x, -4), 4), c.nextPosition = [s.mouth.x * 0.025, s.mouth.y * 1e-3, 0]) : o === "eye.right.retina" || o === "eye.left.retina" ? (s.pupil.x = Math.min(Math.max(s.pupil.x, -4), 4), s.pupil.y = Math.min(Math.max(s.pupil.y, -4), 4), c.nextPosition = [s.pupil.x * 9e-3, s.pupil.y * 9e-3, 0]) : c.nextPosition = [m * f[0], m * f[1], m * f[2]];
    }
    if (s.head) {
      pt.set(-s.head.x, s.head.y, s.head.z), pt.x -= 0.35;
      const o = /* @__PURE__ */ r.face.get("neck");
      o.neckEuler = [pt.x, pt.y, pt.z];
    }
  }), re("unmount_facetracking", () => {
    setTimeout(() => {
      const a = e?.userData.player;
      if (!a)
        return;
      const i = a.face;
      for (const [l, s, o] of t.current) {
        const f = /* @__PURE__ */ i.get(l);
        if (!(!f || !f.nextPosition)) {
          if (f.nextPosition) {
            f.nextPosition = [-f.nextPosition[0], -f.nextPosition[1], -f.nextPosition[2]];
            const d = f.matrix.elements;
            d[12] = f.initialPosition[0] + f.nextPosition[0], d[13] = f.initialPosition[1] + f.nextPosition[1], d[14] = f.initialPosition[2] + f.nextPosition[2], f.nextScale && (si.fromArray(f.nextScale), f.matrix.scale(si)), f.matrixWorld.copy(f.matrix), f.matrixWorld.multiplyMatrices(f.parent.matrixWorld, f.matrix), f.nextPosition = null;
          }
          if (e.api) {
            const d = e.api.getParent().current;
            d && d.setBonesAt(e.userData.id, e.userData.localModel.skeleton);
          }
        }
      }
      const r = /* @__PURE__ */ a.face.get("neck");
      r && r.neckEuler && (r.neckEuler = [-r.neckEuler, -r.neckEuler, -r.neckEuler], r.matrix.compose(qd.fromArray(r.initialPosition), Yd.setFromEuler(pt.fromArray(r.neckEuler)), si.set(1, 1, 1)), r.updateMatrixWorld(true), r.neckEuler = null);
    }, 20);
  });
}, Xn = (e, t) => {
  const [a, i] = /* @__PURE__ */ ve(null), [r, l] = /* @__PURE__ */ ve(null), s = /* @__PURE__ */ wt(() => {
    a && a.getTracks().forEach((o) => o.stop());
  }, [a]);
  return G(() => {
    i(null);
  }, [t]), G(() => (a || (async () => {
    try {
      s();
      const f = await navigator.mediaDevices.getUserMedia({ video: t ? { deviceId: { exact: t || "default" } } : true });
      i(f), e && e();
    } catch {
      e && e();
    }
  })(), s), [a]), { stream: a, error: r };
}, Jd = ({ videoBackground: e = true, tracking: t = true, rigPose: a = false, loader: i, show: r = false, autAsked: l, videoDeviceId: s, ...o }) => {
  const f = /* @__PURE__ */ I(null), { stream: d } = /* @__PURE__ */ Xn(l, s), [c, u] = /* @__PURE__ */ ve(false);
  G(() => {
    const g = f.current, h = () => {
      g.readyState >= 2 && u(true);
    };
    if (g && (g.srcObject = null, u(false), d)) {
      g.srcObject = d;
      const C = g.videoHeight / g.videoWidth;
      g.style.width = "100%", g.style.height = `${parseFloat(g.getBoundingClientRect().width) * C}px`, g.addEventListener("loadeddata", h);
    }
    return () => {
      g?.removeEventListener("loadeddata", h);
    };
  }, [d, f, s]);
  const [m, p] = /* @__PURE__ */ ve(true);
  return H(te, { children: [y("video", { ref: f, id: "webcam", playsInline: true, autoPlay: true, style: { position: "absolute", height: "100%", width: "100%", top: 0, left: 0, opacity: e ? 1 : 0.4, transform: a ? "scaleX(-1)" : "" } }), d?.active && t ? a ? y(de, { fallback: null, children: y(Qd, { stream: d, loadedData: c, videoRef: f, setLoading: p, loader: i, show: r }) }) : y(de, { fallback: null, children: y(Hd, { stream: d, loadedData: c, videoRef: f, setLoading: p, loader: i, show: r }) }) : null, m ? y(te, { children: i }) : null] });
}, li = new n.Matrix4(), $d = new n.Quaternion();
new n.Vector3(), new n.Vector3();
const eu = () => {
  const [e, t] = /* @__PURE__ */ ve([]);
  re("facetracking_tick", ({ results: i }) => {
    if (i.faceBlendshapes) {
      t(i.faceBlendshapes);
      const r = a.current;
      i.facialTransformationMatrixes[0] && (li.fromArray(i.facialTransformationMatrixes[0].data), r.matrix.extractRotation(li), r.matrix.setPosition(0, 2, 0), r.matrix.setPosition(0, 2, 0), r.matrix.scale(new n.Vector3(1, 1.5, 1)), $d.setFromRotationMatrix(li), r.matrixWorld.copy(r.matrix));
    }
  });
  const a = /* @__PURE__ */ I(null);
  return H(te, { children: [H("mesh", { ref: a, "position-y": 2, onUpdate: (i) => {
    i.matrixWorld.copy(i.matrix), i.updateMatrix(), i.updateMatrixWorld();
  }, children: [y("coneGeometry", { args: [0.2, 0.4, 32], onUpdate: (i) => i.rotateX(Math.PI / 2) }), y("meshNormalMaterial", { transparent: true, opacity: 0.5 })] }), y(ri, { style: { position: "fixed", top: "0", bottom: "0", left: 0, pointerEvents: "none", width: "100%", overflow: "auto", zIndex: 100 }, children: y("ul", { children: e.length > 0 ? e[0].categories.map((i, r) => H("li", { className: "blend-shapes-item", style: { display: "flex", height: "16px", alignItems: "center", pointerEvents: "none" }, children: [y("span", { className: "blend-shapes-label", children: i.displayName || i.categoryName }), y("span", { className: "blend-shapes-value", style: { width: `calc(${+Number(i.score) * 100}% - 120px)`, backgroundColor: "#007f8b", display: "flex", height: "16px", alignItems: "center" }, children: (+Number(i.score)).toFixed(4) })] }, r)) : null }) })] });
}, tu = (e, t) => {
  for (let a = 0; a < e.length; a++)
    t.includes(e[a].name) && (n.AnimationUtils.makeClipAdditive(e[a]), e[a] = n.AnimationUtils.subclip(e[a], e[a].name, 1, 2, 30));
}, au = (e, t) => {
  const a = [];
  return e.forEach((i, r) => {
    t.forEach((l, s) => {
      if (s === i.name) {
        const o = /* @__PURE__ */ e[r].clone();
        o.name = l, a.push(o);
      }
    });
  }), a;
}, iu = ["jump", "glide", "slide", "thankyou", "turnright", "leanright", "idle", "right_walk", "right_run", "forward_right_walk", "forward_right_run", "backward_right_walk", "backward_right_run"], nu = [{ default: "inSettings" }];
function ru(e) {
  return V(() => {
    const a = [...e];
    tu(a, ["leanright", "leanFoward", "leanback"]);
    const i = /* @__PURE__ */ au(a, nu);
    a.push(...i);
    const r = /* @__PURE__ */ Sn(a, iu, "L", "R");
    return a.push(...r), a;
  }, [e]);
}
const ou = (e) => (q((t, a) => {
  const i = e.getParent().current;
  if (!i)
    return;
  const r = e.args.count;
  i.instanceMatrix && i.instanceMatrix.updateRange && (i.instanceMatrix.needsUpdate = true, i.instanceMatrix.updateRange.count = r * 16), i.skeleton && i.skeleton.boneTexture && (i.skeleton.boneTexture.needsUpdate = true);
}, z.renderPriority.updtCharacterInstance), null), su = /* @__PURE__ */ W({ mapMixer: null, animTicker: 0, skeletonTextureSize: 37, animation: new n.Vector4(0, 0, 0, 0), animationTexture: null }, `


#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <batching_pars_vertex>

uniform int skeletonTextureSize;

// TODO CREATE CHUNK
// instances
uniform sampler2D mapMixer;
uniform vec4 animation;
uniform float animTicker;

uniform sampler2DArray animationTexture;

mat4 getBoneAction(const in float i, const in int animPos, const in int animId) {
  // 21 bones
  int x = (int(i * 4.) + animPos * skeletonTextureSize * 4);
  int y = 0;


  vec4 v1 = texelFetch(animationTexture, ivec3( x, y, animId ), 0);
  vec4 v2 = texelFetch(animationTexture, ivec3( x + 1, y, animId ), 0);
  vec4 v3 = texelFetch(animationTexture, ivec3( x + 2, y, animId ), 0);
  vec4 v4 = texelFetch(animationTexture, ivec3( x + 3, y, animId ), 0);

  mat4 bone = mat4( v1, v2, v3, v4 );

  return bone;

}
#include <batching_skinning_pars_vertex>
#include <batching_pars_uniforms>

#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

// This is used for computing an equivalent of gl_FragCoord.z that is as high precision as possible.
// Some platforms compute gl_FragCoord at a lower precision which makes the manually computed value better for
// depth-based postprocessing effects. Reproduced on iPad with A10 processor / iPadOS 13.3.1.
varying vec2 vmediumprecisionZW;

void main() {

	#include <uv_vertex>

	#ifdef USE_DISPLACEMENTMAP

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <batchingbase_vertex>


    vec4 anim = vec4(0.);
    #ifdef USE_BATCHING_UNIFORM_bakedanim
      anim = getBatchUniform(batching_bakedanim_texture, 4);
    #else
      anim = animation;
    #endif

    #ifdef USE_SKINNING

      // TODO Use mat4x4
      mat4 boneMatX = mat4(1.);
      mat4 boneMatY = mat4(1.);
      mat4 boneMatZ = mat4(1.);
      mat4 boneMatW = mat4(1.);
      // use baked animation
      if (anim.w > 0.) {
        float frames = float(BAKED_ANIMATION_FRAMES);	
        float animDuration = anim.y;	
        float animTimer = anim.x;	
        float animTime	= mod( animTimer, animDuration );	// Loop Time
        float ntime	= animTime / animDuration;				// Normalize Time
        float frame	= frames * ntime;	
        int animPos	= int( floor( frame ) ); 

        int animId = int(anim.z);
      
        boneMatX = getBoneAction( skinIndex.x, animPos, animId );
        boneMatY = getBoneAction( skinIndex.y, animPos, animId );
        boneMatZ = getBoneAction( skinIndex.z, animPos, animId );
        boneMatW = getBoneAction( skinIndex.w, animPos, animId );
      } else {
        boneMatX = getBoneMatrix( skinIndex.x);
        boneMatY = getBoneMatrix( skinIndex.y);
        boneMatZ = getBoneMatrix( skinIndex.z);
        boneMatW = getBoneMatrix( skinIndex.w);
      }

    #endif

	#ifdef USE_SKINNING
        vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
        vec4 skinned = vec4( 0.0 );
        skinned += boneMatX * skinVertex * skinWeight.x;
        skinned += boneMatY * skinVertex * skinWeight.y;
        skinned += boneMatZ * skinVertex * skinWeight.z;
        skinned += boneMatW * skinVertex * skinWeight.w;
        vec3 temp = ( bindMatrixInverse * skinned ).xyz;

        transformed = ( bindMatrixInverse * skinned ).xyz;
    #endif

	#include <morphtarget_vertex>
	#include <displacementmap_vertex>

  vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;
  
  gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vmediumprecisionZW = gl_Position.zw;

}
  `, `

#include <layout_pars_fragment>

#if DEPTH_PACKING == 3200

	uniform float opacity;

#endif

#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

varying vec2 vmediumprecisionZW;

void main() {


	#include <clipping_planes_fragment>

	vec4 diffuseColor = vec4( 1.0 );

	#if DEPTH_PACKING == 3200

		diffuseColor.a = opacity;

	#endif

	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>

	#include <logdepthbuf_fragment>

	// Higher precision equivalent of gl_FragCoord.z. This assumes depthRange has been left to its default values.
	float fragCoordZ = 0.5 * vmediumprecisionZW[0] / vmediumprecisionZW[1] + 0.5;

	vec4 o_diffuse = vec4(0.);

	#if DEPTH_PACKING == 3200

		o_diffuse = vec4( vec3( 1.0 - fragCoordZ ), opacity );

	#elif DEPTH_PACKING == 3201

		o_diffuse = packDepthToRGBA( fragCoordZ );

	#endif


	vec4 o_color = vec4(vec3(0., 0., 0.), 1.);
	vec4 o_normal = vec4(0.);
	vec4 o_position = vec4(0.);
	#include <layout_output_fragment>

}
`), lu = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ MetaSkinnedDepthImpl: su });
const fi = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ A.useRef();
  return A.useImperativeHandle(a, () => i.current), y("metaSkinnedDepthImpl", { ref: a, glslVersion: n.GLSL3, "defines-BAKED_ANIMATION_FRAMES": 60, attach: "customDepthMaterial", ...t, children: e }, lu);
});
fi.displayName = "MetaSkinnedDepth";
const fu = /* @__PURE__ */ W({ map: null, mapTransform: new n.Matrix3(), mapMixer: null, mapEyes: null, opacity: 1, animTicker: 0, skeletonTextureSize: 37, animation: new n.Vector4(0, 0, 0, 0), animationTexture: null, diffuse: new n.Color(16777215) }, `
#define DEFERRED_PRIMARY

#include <common_ubo_pars>

out float vInstanceID;
#ifndef USE_UV
  out vec2 vUv;
#endif

#ifdef USE_EYES
  out float vOrdering;
#endif

out float vGLDrawID;

out vec3 vWorldPosition;


#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <batching_pars_vertex>
// #include <batching_skinning_pars_vertex>

uniform int skeletonTextureSize;

// TODO CREATE CHUNK
// instances
uniform sampler2D mapMixer;
uniform vec4 animation;
uniform float animTicker;

// uniform sampler2D animationTexture;
uniform sampler2DArray animationTexture;
// uniform sampler2D boneTexture;


mat4 getBoneAction(const in float i, const in int animPos, const in int animId) {
  // 21 bones
  int x = (int(i * 4.) + animPos * skeletonTextureSize * 4);
  int y = 0;


  vec4 v1 = texelFetch(animationTexture, ivec3( x, y, animId ), 0);
  vec4 v2 = texelFetch(animationTexture, ivec3( x + 1, y, animId ), 0);
  vec4 v3 = texelFetch(animationTexture, ivec3( x + 2, y, animId ), 0);
  vec4 v4 = texelFetch(animationTexture, ivec3( x + 3, y, animId ), 0);

  mat4 bone = mat4( v1, v2, v3, v4 );

  return bone;

}

#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

out vec3 vViewPosition;
out float vIsPerspective;
out float vDrawRawId;

void main() {


    #ifdef USE_UV
      vUv = uv;
    #endif

    #ifdef USE_MULTI_DRAW
      vGLDrawID = float(gl_DrawID);
    #endif


 
    #include <color_vertex>

    #include <morphcolor_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>

    vec4 anim = vec4(0.);
    #ifdef USE_BATCHING_UNIFORM_bakedanim
      anim = getBatchUniform(batching_bakedanim_texture, 4);
    #else
      anim = animation;
    #endif

    #ifdef USE_SKINNING

      // TODO Use mat4x4
      mat4 boneMatX = mat4(1.);
      mat4 boneMatY = mat4(1.);
      mat4 boneMatZ = mat4(1.);
      mat4 boneMatW = mat4(1.);
      // use baked animation
      if (anim.w > 0.) {
        #ifdef BAKED_ANIMATION_FRAMES
        float frames = float(BAKED_ANIMATION_FRAMES);	
        float animDuration = anim.y;	
        float animTimer = anim.x;	
        float animTime	= mod( animTimer, animDuration );	// Loop Time
        float ntime	= animTime / animDuration;				// Normalize Time
        float frame	= frames * ntime;	
        int animPos	= int( floor( frame ) ); 

        int animId = int(anim.z);
      
        boneMatX = getBoneAction( skinIndex.x, animPos, animId );
        boneMatY = getBoneAction( skinIndex.y, animPos, animId );
        boneMatZ = getBoneAction( skinIndex.z, animPos, animId );
        boneMatW = getBoneAction( skinIndex.w, animPos, animId );
        #endif
      } else {
        // #else
        boneMatX = getBoneMatrix( skinIndex.x);
        boneMatY = getBoneMatrix( skinIndex.y);
        boneMatZ = getBoneMatrix( skinIndex.z);
        boneMatW = getBoneMatrix( skinIndex.w);
      }

    #endif

    #include <skinnormal_vertex>

    #include <begin_vertex>
    #include <batchingbase_vertex>

    #ifdef USE_BATCHING_ARRAYCOLOR
	  if (gl_DrawID == 3 && length(vColor.rgb) > 0.0) {
      vBatchColor.rgb = vColor.rgb;
    }
	  #endif
  
    #include <defaultnormal_vertex>
    // normal
    #include <normal_vertex>

    #include <morphtarget_vertex>


    #ifdef USE_INSTANCING
      vec4 animation = texelFetch(mapMixer, ivec2(gl_InstanceID / 4, 0), 0);
    #endif

    #ifdef USE_EYES
     vOrdering = 0.;
    // custom depth management for eyes
    // vOrdering 2 are the body part (legs / body) and always render under the clothes
      #if defined(USE_MULTI_DRAW)
      if (gl_DrawID == 0) {
        vOrdering = 1.;
        if (vColor.r > 0. && vColor.b < 0.5) {
          transformed.z -= .01;
        }
      } else if (gl_DrawID == 1) {
        vOrdering = 2.;
      }
      #endif
    #endif

    vUv = uv;

    #ifdef USE_SKINNING
        vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
        vec4 skinned = vec4( 0.0 );
        skinned += boneMatX * skinVertex * skinWeight.x;
        skinned += boneMatY * skinVertex * skinWeight.y;
        skinned += boneMatZ * skinVertex * skinWeight.z;
        skinned += boneMatW * skinVertex * skinWeight.w;
        vec3 temp = ( bindMatrixInverse * skinned ).xyz;

        transformed = ( bindMatrixInverse * skinned ).xyz;
    #endif

    #include <displacementmap_vertex>
    

    #include <cellshading_vertex>

    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_BATCHING 

      mvPosition = batchingMatrix * mvPosition;
    
    #endif

    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif
    
    mvPosition = modelViewMatrix * mvPosition;
    
    gl_Position = projectionMatrix * mvPosition;

    // #include <worldpos_vertex>
    vec4 worldPosition = vec4( transformed, 1.0 );
    #ifdef USE_INSTANCING

      worldPosition = instanceMatrix * worldPosition;

    #endif
    #ifdef USE_BATCHING

      worldPosition = batchingMatrix * worldPosition;

    #endif

    worldPosition = modelMatrix * worldPosition;

    vWorldPosition = worldPosition.xyz;
    vViewPosition = -mvPosition.xyz;
    vNormal = normalize(transformedNormal);

   
  vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );


  
}

  `, `

uniform vec3 diffuse;
uniform float opacity;

in float vInstanceID;
in vec3 vWorldPosition;
#ifndef USE_UV
  in vec2 vUv;
#endif

  in float vGLDrawID;

#include <common_ubo_pars>

#include <layout_pars_fragment>
#include <introanimation_pars_fragment>

in vec3 vViewPosition;
in float vIsPerspective;

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

vec3 complementaryColor(vec3 color) {
  return vec3(1.0 - color.r, 1.0 - color.g, 1.0 - color.b);
}

#include <common>

#include <deferred_lights_pars>

#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
// map_pars_fragment
#ifdef USE_CUSTOM_MAP
  #ifdef USE_BATCHING_ARRAYMAP
    precision mediump sampler2DArray;
    uniform sampler2DArray map;
  #else
    uniform sampler2D map;
  #endif
#endif

#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>



float Bayer2(vec2 a) {
  a = floor(a);
  return fract(a.x / 2. + a.y * a.y * .75);
}

#define Bayer4(a)   (Bayer2 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer8(a)   (Bayer4 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer16(a)  (Bayer8 (.5 *(a)) * .25 + Bayer2(a))


#ifdef USE_EYES
  in float vOrdering;
  uniform sampler2D mapEyes;
#endif


void main() {
  float dither = 1. - smoothstep( .2, 0.4, vViewPosition.z );

  float dithered = Bayer16(gl_FragCoord.xy) * (1. + dither * 1.) - (1. - dither * 1.);

  if (dithered >= 0.0) discard;


  #ifdef USE_EYES
    gl_FragDepth = gl_FragCoord.z;


    // offset is bigger on orthographic camera
    float offset = 0.005;
    if (vIsPerspective == 0.0) {
      offset = 0.03;
    }



    if (vOrdering > 0.) {

      if (vIsPerspective == 0.0) {
        if ( !gl_FrontFacing ) discard;
      }

 
      // vOrdering 2 are the body part (legs / body) and always render under the clothes
      if (vOrdering == 2.) {
        gl_FragDepth = gl_FragCoord.z * (1. + offset * pow(gl_FragCoord.w, 2.));
      } else {
        // float timeScaled = vDrawId / 10. + time * 2.0; // adjust this value to change overall blink speed
        // float blinkDuration = 1.1; // adjust this value to change blink duration
        // float blinkPause = 5.0; // adjust this value to change pause duration
        // float blinkPhase = mod(timeScaled, blinkDuration + blinkPause);

        // float rounded;
        // if (blinkPhase < blinkDuration) {
        //   // eyes are closed during blink phase
        //   float t = blinkPhase / blinkDuration;
        //   rounded = smoothstep(0.0, 1.0, t);
        // } else {
        //   // eyes are open during pause phase
        //   rounded = 1.0;
        // }

        // vec2 spriteUV = vec2((vUv.x * 0.5 + round(rounded) / 2.), vUv.y);
        // TODO!!!: Update the 3D model and only the red part (vcolor) inherits of the color of the skin for the eye lids
        vec4 eyes = texture(mapEyes, vUv.xy);
        if (eyes.a < 0.1) {
          eyes.rgb = vColor.rgb;
        }
       
        // the white vertex color should be rendered always in back so don't change this
        if (gl_FrontFacing && vColor.r < 0.5) {
          gl_FragDepth = gl_FragCoord.z * (1. - offset * pow(gl_FragCoord.w, 2.));

        } else {
          // if vColor.rgb is white
          if (vColor.r > 0.5 && vColor.b > 0.5 && vColor.g > 0.5) {
            // very small offset for the white part of the eyes to prevent clipping with skin
            gl_FragDepth -= .0001 * pow(gl_FragCoord.w, 2.);
          }

          if (vOrdering == 1.) {
            // gl_FragDepth += .03;
          }
        }

        gColor = vec4(eyes.rgb, 1.);


        if (vColor.b > 0.5 && vColor.r < 0.5) {
          #if defined(USE_BATCHING_ARRAYCOLOR) && defined(USE_COLOR)
            gColor.rgb = vBatchColor.rgb;
            
          #endif
        } else {
          #if defined(USE_DEFERRED)
            gPosition = vec4(0.);
            gNormal = vec4(0.);
            #ifdef USE_BLOOM
              gVColor = vec4(0.);
            #endif
          #elif defined(USE_BLOOM)
            gVColor = vec4(0.);
          #endif
          return;
        }
      }
  }
  #endif

  // Handle order layer depths (each clothing part has a different depth, see perksOrder in usePerks.jsx)
  // #ifdef USE_EYES
  // if (vOrdering == 0.) {
  //   gl_FragDepth -= vGLDrawID * .0005 * pow(gl_FragCoord.w, 2.);
  // }
  // #endif

	vec4 diffuseColor = vec4( diffuse, opacity );
	vec3 totalEmissiveRadiance = vec3(0.);

  // map_fragment
  #if defined(USE_CUSTOM_MAP)
    vec4 sampledDiffuseColor = vec4(1.);
    #ifdef USE_BATCHING_ARRAYMAP
      sampledDiffuseColor *= texture( map, vec3( vUv, vTextureId ) );
    #else
      sampledDiffuseColor *= texture( map, vUv );
    #endif

    diffuseColor *= sampledDiffuseColor;
  #endif

	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>


  // albedo
  vec4 totalEmissive = vec4(totalEmissiveRadiance, saturate(length(totalEmissiveRadiance)));

// TODO DEBUG EMISSIV
#ifdef USE_BATCHING_ARRAYCOLOR
    #if defined( USE_COLOR )
      if (vColor.r < .5) {
        diffuseColor.rgb *= mix(vBatchColor, vec3(1.), smoothstep(0., 0.5, vColor.r));
      } else {
        diffuseColor.rgb *= mix(vec3(0.), complementaryColor(vBatchColor), smoothstep(0.5, 1., vColor.r));
      }
      if (vGLDrawID == 3.) {
        diffuseColor.rgb = vBatchColor.rgb;
      }
    #else
      diffuseColor.rgb *= vBatchColor;



    #endif
    
  #endif

  vec4 o_diffuse = linearToSRGB(diffuseColor);

  // o_diffuse = mix(o_diffuse -0.05, o_diffuse + 0.1, normal.g);

  vec4 o_color = vec4(vec3(0., 1., 0.), 1.);

  // vertexColor
  o_color = totalEmissive;
  // specular shiny reflection
  float toonShading = 0.5;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif

  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, 1.);



  #ifndef USE_DEFERRED
    if (vIsPerspective > 0.0) {
      #include <forward_lights_fragment>
      // o_diffuse.rgb += .2;

      // gColor.rgb += .3;
    } else {
      #ifdef USE_CELLSHADING
        if ( isBackSide ) {
          gColor = vec4(vec3(0.), 1.);
          #if defined(USE_BLOOM) || defined(USE_SSAO)
            gVColor = vec4(0.);
          #endif
          return;
        }
      #else
        #include <forward_lights_fragment>
      #endif
    }
  #endif

  #include <layout_output_fragment>
  // gColor.rgb = vBatchColor.rgb;

}
`, null), cu = /* @__PURE__ */ n.MathUtils.generateUUID(), du = (e) => {
  const t = /* @__PURE__ */ A.useRef({});
  return e.mapMixer && (t.current.mapMixer = e.mapMixer, t.current["mapMixer-colorSpace"] = n.LinearSRGBColorSpace), t.current;
};
N({ PrimaryShaderImpl: fu });
const ci = /* @__PURE__ */ A.forwardRef(({ children: e, castSSAO: t = false, receiveSSAO: a = true, collectionId: i, metaMap: r, ...l }, s) => {
  const o = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(s, () => o.current);
  const f = /* @__PURE__ */ Y((u) => u.useDeferred);
  _e(o);
  const d = /* @__PURE__ */ se();
  du(l);
  const c = /* @__PURE__ */ Ne(z.ignoreProxy ? "/img/webp/eyes.webp" : v["/img/webp/eyes.webp"], (u) => {
    u.flipY = false;
  });
  return y("primaryShaderImpl", { glslVersion: n.GLSL3, ref: o, "defines-SSAO_FACTOR": t && a ? 1 : a ? 0.5 : 0, cellShading: !f, cellShadingThickness: 1e-4, mapEyes: c, ...d, "defines-USE_EYES": i === "konpi", "defines-BAKED_ANIMATION_FRAMES": 60, "defines-USE_CUSTOM_MAP": r?.count >= 1, "defines-USE_BATCHING_ARRAYMAP": r?.count > 1, ...l, vertexColors: true, attach: "material", children: e }, l.useCPU + cu);
});
ci.displayName = "PrimaryShader";
const Kn = {}, wa = {};
async function Zn(e) {
  if (wa[e])
    return wa[e];
  async function t(a) {
    const r = await (await fetch(z.ignoreProxy ? `${z.collectionAssetsRoot}glb/characters/perks/${a}/collection.json` : v[`${z.collectionAssetsRoot}glb/characters/perks/${a}/collection.json`])).json();
    if (r.metadata.hasExtra)
      try {
        const s = await (await fetch(v[`${z.collectionAssetsRoot}glb/characters/perks/${a}/extra.json`])).json();
        Object.assign(r, s);
      } catch (l) {
        console.error(l);
      }
    return r.collectionId = a, r.metadata.defaultPerks || (r.metadata.defaultPerks = {}, r.metadata.defaultPerks.collection = a, r.metadata.useCommon && (r.metadata.defaultPerks.clothing = a)), Kn[a] = r, r;
  }
  return wa[e] = t(e), wa[e];
}
const Aa = /* @__PURE__ */ Fa(null), Jn = /* @__PURE__ */ Z(({ url: e, children: t, collectionId: a = "ancient", defaultPerks: i = { clothing: "ancient", hood: "ancient-hood", legs: "ancient", helmet: "ancient-helmet", shoulder: "ancient", collection: "ancient" }, baseModelHeight: r = 1.6, mapsCount: l = 0, count: s = 300, frustumCulled: o = true }, f) => {
  const c = U(({ get: D }) => D)().gl, u = /* @__PURE__ */ I();
  ge(f, () => u.current);
  const { animations: m, scene: p } = /* @__PURE__ */ ot(z.ignoreProxy ? `${z.collectionAssetsRoot}glb/characters/${a}.glb` : v[`${z.collectionAssetsRoot}glb/characters/${a}.glb`], void 0, void 0, void 0), g = /* @__PURE__ */ Se(() => Zn(a), [`${a}_collection_2`]), [h, C] = /* @__PURE__ */ V(() => {
    const D = /* @__PURE__ */ p.getObjectByProperty("type", "SkinnedMesh"), T = D.skeleton.bones.length;
    return [D, T];
  }, [p]), _ = /* @__PURE__ */ V(() => ({ verticesCount: g.metadata.verticesCount, indicesCount: g.metadata.indicesCount, geometriesCount: g.metadata.geometriesCount, mapsCount: l, count: 0, currentIndex: 0 }), [g.metadata]), [x, b] = /* @__PURE__ */ ve([]), w = /* @__PURE__ */ I(new Map(Array.from({ length: 1e3 }, (D, T) => [T, -1]))), P = /* @__PURE__ */ V(() => n.MathUtils.generateUUID(), []), S = /* @__PURE__ */ wt((D) => {
    for (let T = 0; T < w.size; T++)
      w.current.set(T, -1);
    for (let T = 0; T < D.length; T++) {
      const R = D[T];
      R.current && (R.current.userData.id = T, w.current.set(T, 1));
    }
  }, []), M = /* @__PURE__ */ V(() => ({ getParent: () => u, collectionId: a, collection: g, defaultPerks: i, animations: m, animationsList: Xe(), args: _, uuid: P, maps: {}, perksMap: /* @__PURE__ */ new Map(), baseModelHeight: r, scene: p, subscribe: (D) => {
    const T = D.current;
    _.count++, u.current && u.current._maxInstanceCount <= _.count && (u.current.count = u.current._maxInstanceCount);
    for (const [R, L] of w.current.entries())
      if (L === -1) {
        w.current.set(R, 1), T.userData.id = R;
        break;
      }
    return b((R) => [...R, D]), () => {
      _.count--, u.current && (u.current.setIsActive(T.userData.id, false), _.count < u.current._maxInstanceCount - 13 && (u.current.count = u.current._maxInstanceCoun), u.current.needsUpdate = true), w.current.set(T.userData.id, -1), b((R) => R.filter((L) => L.current && L.current !== T));
    };
  } }), [a, g]);
  return G(() => {
    S(x);
  }, [u.current?._maxInstanceCount]), G(() => {
    const D = u.current;
    if (D)
      return D.boundingSphere = new n.Sphere(new n.Vector3(0, 1, 0), 1), D.maps = [], () => {
      };
  }, []), ou(M), M.extendedAnimations = ru(M.animations), y("metaSkinnedMesh", { ref: u, frustumCulled: o, args: [null, s, _.geometriesCount, _.verticesCount, _.indicesCount, c, false], collectionId: a, skeleton: h.skeleton, geometry: h.geometry, onUpdate: (D) => {
    D.skeletonMount || (D.setBonesAt(0, D.skeleton), D.skeletonMount = true), D.geometry && D.geometry.computeBoundingSphere();
  }, castShadow: true, receiveShadow: false, children: H(Aa.Provider, { value: M, children: [y(fi, { vertexColors: 2, depthPacking: n.RGBADepthPacking, alphaTest: 0.5 }), y(ci, { side: n.DoubleSide, collectionId: a, skeletonTextureSize: C, metaMap: g?.metadata?.maps }), t] }) }, a);
});
Jn.displayName = "Characters";
const uu = (e) => y(de, { fallback: null, children: y(Jn, { ...e }) }), { clamp: di } = n.MathUtils, $n = new n.Vector4(), er = (e, t, a) => G(() => {
  const i = e.current;
  if (!i)
    return;
  const r = Array.isArray(t) ? t : [t];
  for (let l = 0; l < r.length; l++) {
    const s = r[l];
    a(i[s]), Object.defineProperty(i, s, { configurable: true, get() {
      return this[`_${s}`];
    }, set(o) {
      this[`_${s}`] = o, a(o);
    } });
  }
  return () => {
  };
}, [e, t]);
function mu({ playerId: e, headRef: t, bodyRef: a, group: i }) {
  const { baseModelHeight: r, getParent: l } = /* @__PURE__ */ Ke(Aa), s = /* @__PURE__ */ I(false), o = /* @__PURE__ */ I({ fly: false });
  return re(`updatePeerAttr_${e}`, (f) => {
    const d = l().current, c = i.current, u = c.userData.id;
    c && (f.fly !== void 0 && (o.current.fly = true), (f.drive !== void 0 || f.slide !== void 0) && (c.driving ? c.playerShaderState = 1 : c.slide ? c.playerShaderState = 0.5 : c.playerShaderState = 0, d.setUniformAt(u, "extra", $n.set(c.heightLerp, c.holo, c.flyLerp, c.playerShaderState || 0), 4)));
  }), er(i, "color", () => {
    const f = l().current, d = i.current, { id: c, player: u } = d.userData;
    u && f.setUniformAt(c, "color", u.color, 4, Float32Array, n.RGBAFormat);
  }), er(i, "height", () => {
    const f = i.current, { player: d } = f.userData;
    d && (d.modelHeight = In(f, r), d.eyeHeight = Un(d));
  }), q(function(d, c) {
    const u = l().current, m = i.current, { id: p, player: g } = m.userData;
    if (!g)
      return;
    let h = false;
    if (s.current && a.current) {
      h = true, g.heightLerp > g.height ? (g.heightLerp -= 0.5 * c, g.heightLerp = Math.max(g.height, g.heightLerp)) : (g.heightLerp += 0.5 * c, g.heightLerp = Math.min(g.height, g.heightLerp)), g.heightLerp === g.height && (s.current = false);
      const { heightLerp: C } = g;
      a.current.scale.set(di(C, 0, 1), C, di(C, 0, 1)), a.current.scale.multiply(i.scale);
      const _ = di(1 / C, 1, 1.6) + (g.peer.call ? g.decibelLerp : 0);
      t.current.scale.setScalar(_), t.current.updateMatrix(), t.current.matrixWorld.copy(t.current.matrix), t.current.matrixWorldNeedsUpdate = false, a.current.updateMatrix(), a.current.matrixWorld.copy(a.current.matrix), a.current.matrixWorldNeedsUpdate = false;
    }
    o.current.fly && (h = true, g.flyLerp = g.fly ? 1 : 0, g.flyLerp === g.fly && (o.current.fly = false)), u && h && u.setUniformAt(p, "extra", $n.set(g.heightLerp, 1, g.flyLerp, g.playerShaderState), 4);
  }, 7), null;
}
const ui = { 0: "bow", 1: "dance", 2: "glide", 3: "idle", 4: "jump", 5: "kneel", 6: "kneelidle", 7: "land", 8: "leanback", 9: "leanFoward", 10: "leanright", 11: "meditate", 12: "meditateyoyo", 13: "run", 14: "slide", 15: "thankyou", 16: "turnright", 17: "bow_mirror", 18: "dance_mirror", 19: "glide_mirror", 20: "idle_mirror", 21: "jump_mirror", 22: "kneel_mirror", 23: "kneelidle_mirror", 24: "land_mirror", 25: "leanback_mirror", 26: "leanFoward_mirror", 27: "leanright_mirror", 28: "meditate_mirror", 29: "meditateyoyo_mirror", 30: "run_mirror", 31: "slide_mirror", 32: "thankyou_mirror", 33: "turnright_mirror", 34: "default", 35: "default_mirror", 36: "walk", 37: "walk_mirror", 38: "inSettings", 39: "forward_run", 40: "forward_run_mirror", 41: "forward_right_walk", 42: "forward_right_walk_mirror", 43: "forward_right_run", 44: "forward_right_run_mirror", 45: "backward_walk", 46: "backward_walk_mirror", 47: "backward_run", 48: "backward_run_mirror", 49: "backward_right_walk", 50: "backward_right_walk_mirror", 51: "backward_right_run", 52: "backward_right_run_mirror" }, tr = ["leanright", "leanright_mirror", "leanFoward", "leanback", "land"], vu = ["sitting", "jump", "jump_mirror", "land", "thankyou", "thankyou_mirror", "bow", "meditate"], gu = ["idle", "idle_mirror"], pu = ["land"], hu = ["thankyou", "bow"], mi = ["meditate", "meditateyoyo", "dance", "bow", "thankyou"], vi = ["dance", "bow", "thankyou", "inSettings"], _u = ["meditateyoyo"], ar = { run: [{ frame: 11, event: "leftFoot" }, { frame: 23, event: "rightFoot" }] }, xu = {};
Object.keys(ui).forEach((e) => {
  xu[ui[e]] = parseInt(e);
});
const ir = (e, t) => {
  const a = ["neck", "head", "spine002", "spine003"], i = e._propertyBindings || [], r = e._interpolants || [];
  if (e.filteredBindings = e.filteredBindings || [], e.filteredInterpolants = e.filteredInterpolants || [], e.filteredBindings.length === 0) {
    i.forEach((o, f) => {
      const { binding: d } = o;
      d && d.targetObject && a.includes(d.node.name) || (e.filteredBindings.push(o), e.filteredInterpolants.push(r[f]));
    });
    const l = e._propertyBindings, s = e._interpolants;
    e.originalPropertyBindings = l, e.originalInterpolants = s;
  }
  t.face?.get("neck").neckEuler ? (e._propertyBindings = e.filteredBindings, e._interpolants = e.filteredInterpolants) : (e._propertyBindings = e.originalPropertyBindings || e._propertyBindings, e._interpolants = e.originalInterpolants || e._interpolants);
}, yu = (e, t, a, i) => {
  const r = /* @__PURE__ */ I({}), [l] = /* @__PURE__ */ ve(() => new wo(e)), s = function(c) {
    if (pu.includes(c.action._clip.name) && c.action.fadeOut(0.01), hu.includes(c.action._clip.name) && ae(`anim_${a}`, { name: "idle", play: true, reset: true, timeScale: 0.6 }), c.action.framesCallBacks.length > 0)
      for (let u = 0; u < c.action.framesCallBacks.length; u++)
        c.action.framesCallBacks[u].played = false;
  }, o = function(c) {
    if (c.action.framesCallBacks.length > 0)
      for (let u = 0; u < c.action.framesCallBacks.length; u++)
        c.action.framesCallBacks[u].played = false;
    gu.includes(c.action._clip.name) && ae(`anim_${a}`, { name: c.action._clip.name.replace("_mirror", "") + (Math.random() < 0.5 ? "_mirror" : ""), play: true, blendDuration: 0.4, timeScale: 1 });
  };
  G(() => (l.addEventListener("finished", s), l.addEventListener("loop", o), () => {
    l.removeEventListener("finished", s), l.removeEventListener("loop", o);
  }));
  const f = /* @__PURE__ */ V(() => {
    const c = {};
    if (t)
      return t.forEach((u) => {
        c[u.name] || Object.defineProperty(c, u.name, { enumerable: true, get() {
          if (e) {
            let m = function(g, h, C, _) {
              if (p.call(this, g, h, C, _), this.framesCallBacks.length > 0)
                for (let x = 0; x < this.framesCallBacks.length; x++) {
                  const b = this.framesCallBacks[x], w = /* @__PURE__ */ Math.floor(this.time / this._clip.duration * 100);
                  !b.played && b.eventPctMin * this.timeScale <= w * this.timeScale && (b.played = true, ae(`sound_${a}`, { name: b.event }));
                }
            };
            if (r.current[u.name] && r.current[u.name].rootUuid === e.uuid)
              return r.current[u.name];
            r.current[u.name] = l.clipAction(u, e), r.current[u.name].rootUuid = e.uuid, vu.includes(u.name) && (r.current[u.name].clampWhenFinished = true, r.current[u.name].loop = Ao), _u.includes(u.name) && (r.current[u.name].loop = Co), r.current[u.name].framesCallBacks = [], ar[u.name] && ar[u.name].forEach((g) => {
              const h = g.frame / r.current[u.name]._clip.tracks[0].times.length * 100;
              r.current[u.name].framesCallBacks.push({ eventPctMin: h, event: g.event });
            }), i.current?.userData?.player && ir(r.current[u.name], i.current?.userData?.player);
            const p = r.current[u.name]._update;
            return r.current[u.name]._update = m, r.current[u.name];
          }
          return null;
        } });
      }), { ref: e, clips: t, actions: c, names: t.map((u) => u.name), mixer: l, deltaToAdd: 0 };
  }, [e]), d = ({ name: c, play: u = true, reset: m = false, blendDuration: p = 1, weight: g = 1, timeScale: h = 1, startAt: C, syncWith: _ }) => {
    if (!e || !i.current)
      return null;
    const { player: b } = i.current.userData;
    if (!b)
      return;
    const { actions: w } = f, P = w[c], S = c ? c.replace("_mirror", "") : "idle";
    if (mi.includes(S) && (b.playingEmote = u), vi.includes(S) ? b.noHeadTracking = u : b.noHeadTracking = false, P) {
      if (ir(P, b), u) {
        if (C && (P.time = C), _ && (P.time = w[_].time), P.fadingOut && P._scheduleFading(p, P.getEffectiveWeight(), 1), P.fadingOut = false, P.setEffectiveTimeScale(h), P.setEffectiveWeight(g), m ? P.reset().fadeIn(p).play() : P.weight === 0 || !P.isRunning() ? (P.paused = false, P.enabled = true, P.fadeIn(p).play()) : P.play(), b.lastActiveAnimation = P, tr.includes(c))
          b.activAdditiveAnimations[c] = true;
        else if (Object.prototype.hasOwnProperty.call(b.activAnimations, c))
          m && (delete b.activAnimations[c], b.activAnimations[c] = true);
        else {
          for (const M in b.activAnimations) {
            const D = /* @__PURE__ */ M.replace("_mirror", "");
            mi.includes(D) && !mi.includes(S) && (b.playingEmote = false), vi.includes(D) && !vi.includes(S) && (b.noHeadTracking = false), w[M].fadingOut = true, w[M].fadeOut(0.5), delete b.activAnimations[M];
          }
          b.activAnimations[c] = true;
        }
      } else if (!u && P.fadingOut === false) {
        if (P.fadingOut = true, P._scheduleFading(p, P.getEffectiveWeight(), 0), tr.includes(c))
          delete b.activAdditiveAnimations[c];
        else
          for (const M in b.activAnimations)
            M === c && delete b.activAnimations[M];
        Object.keys(b.activAnimations).length === 0 && ae(`anim_${a}`, { name: "idle", play: true, blendDuration: 0.2, timeScale: 0.6 });
      }
    }
  };
  return re(`anim_${a}`, d), G(() => {
    const c = e;
    return e.userData.mixer = l, () => {
      r.current = {}, Object.values(f.actions).forEach((u) => {
        c && l.uncacheAction(u, c);
      });
    };
  }, []), [f];
}, ee = (e, t) => e.find((a) => a.name === t), nr = new n.Vector3(), bu = new n.Vector3(), rr = new n.Quaternion(), wu = (e, t) => {
  const a = /* @__PURE__ */ V(() => {
    if (!e)
      return;
    const i = /* @__PURE__ */ qo.clone(e).getObjectByProperty("type", "SkinnedMesh");
    i.skeleton.computeBoneTexture = function() {
      const l = this.bones.length, s = new Float32Array(l * 16);
      return s.set(this.boneMatrices), this.boneMatrices = s, this.boneTextureSize = this.bones.length, this;
    }, i.skeleton.bones[0].updateMatrixWorld(true);
    for (let r = 0; r < i.skeleton.bones.length; r++)
      i.skeleton.bones[r].matrixAutoUpdate = false;
    return i.matrixAutoUpdate = false, i;
  }, [e]);
  return V(() => {
    if (!a || !t)
      return;
    const i = /* @__PURE__ */ ee(a.skeleton.bones, "upperMouth"), r = /* @__PURE__ */ ee(a.skeleton.bones, "neck");
    if (t && i) {
      t.face = /* @__PURE__ */ new Map([["neck", r], ["mouth.upper", i], ["mouth.lower", ee(a.skeleton.bones, "lowerMouth")], ["mouth.left", ee(a.skeleton.bones, "mouth_L")], ["mouth.right", ee(a.skeleton.bones, "mouth_R")], ["eye.left.retina", ee(a.skeleton.bones, "retina_L")], ["eye.left.upper", ee(a.skeleton.bones, "upperEye_L")], ["eye.left.lower", ee(a.skeleton.bones, "lowerEye_L")], ["eye.right.retina", ee(a.skeleton.bones, "retina_R")], ["eye.right.upper", ee(a.skeleton.bones, "upperEye_R")], ["eye.right.lower", ee(a.skeleton.bones, "lowerEye_R")], ["eyeBrow.left.inner", ee(a.skeleton.bones, "eyebrow_L")], ["eyeBrow.left.outer", ee(a.skeleton.bones, "eyebrow2_L")], ["eyeBrow.right.inner", ee(a.skeleton.bones, "eyebrow_R")], ["eyeBrow.right.outer", ee(a.skeleton.bones, "eyebrow2_R")], ["arm.left.upper", ee(a.skeleton.bones, "upperarmL")], ["arm.left.forearm", ee(a.skeleton.bones, "forearmL")], ["hand.left.hand", ee(a.skeleton.bones, "handL")], ["hand.left.finger", ee(a.skeleton.bones, "fingerL")], ["arm.right.upper", ee(a.skeleton.bones, "upperarmR")], ["arm.right.forearm", ee(a.skeleton.bones, "forearmR")], ["hand.right.hand", ee(a.skeleton.bones, "handR")], ["hand.right.finger", ee(a.skeleton.bones, "fingerR")], ["spine", ee(a.skeleton.bones, "spine002")]]);
      for (const [l, s] of t.face)
        s && (s.matrix.decompose(nr, rr, bu), s.initialPosition = nr.toArray([]), s.initialQuaternion = rr.toArray([]));
    }
    return t.face;
  }, [a, t]), a;
}, Au = (e, t, a, i) => (G(() => {
  if (t === void 0)
    return;
  const r = i().current, { userData: l } = a.current, { id: s } = l;
  let o = So;
  t instanceof me ? o = Po : (t instanceof pe || t instanceof La) && (o = Mo), r.setUniformAt(s, e, parseFloat(t), 1, Float32Array, o);
}, [t]), null), Cu = (e, t) => {
  const a = [];
  if (e.userData.gltfExtensions && e.userData.gltfExtensions.KHR_materials_variants) {
    const i = e.parser, l = /* @__PURE__ */ e.userData.gltfExtensions.KHR_materials_variants.variants.findIndex((o) => o.name.includes(t)), s = async (o) => {
      if (!o.isMesh || !o.userData.gltfExtensions)
        return;
      const f = o.userData.gltfExtensions.KHR_materials_variants;
      if (!f)
        return;
      o.userData.originalMaterial || (o.userData.originalMaterial = o.material);
      const d = /* @__PURE__ */ f.mappings.find((c) => c.variants.includes(l));
      d ? (o.material = await i.getDependency("material", d.material), i.assignFinalMaterial(o)) : o.material = o.userData.originalMaterial;
    };
    e.scene.traverse((o) => {
      a.push(s(o));
    });
  }
  return a;
}, Su = async (e, t, a) => {
  const { collectionId: i, maps: r, perksMap: l, collection: s } = a, o = /* @__PURE__ */ wn();
  if (!i || !t)
    return { drawId: -4 };
  if (s.perks[e] === void 0)
    return { drawId: -4 };
  const { perkKey: f, mesh: d, variant: c } = /* @__PURE__ */ vn(e, t, s.perks);
  if (f.includes("none"))
    return { perk: { perkMesh: "none" } };
  if (d.includes("empty"))
    return { drawId: -3 };
  const u = /* @__PURE__ */ f.replace(/\.\d+/, ""), m = z.ignoreProxy ? `${z.collectionAssetsRoot}glb/characters/perks/${i}/${u}.glb` : v[`${z.collectionAssetsRoot}glb/characters/perks/${i}/${u}.glb`], p = /* @__PURE__ */ l.get(`${f}${c ? `_${c}` : ""}`);
  if (p)
    return p.promise;
  const g = { traitType: e, promise: null, perkKey: f, perkMesh: null, perkGltf: null, file: m, registered: false };
  return l.set(`${f}_${c}`, g), g.promise = (async () => {
    try {
      const h = await o.loadAsync(m, function(b) {
        return b;
      }, function() {
      }, function(x) {
        throw new Error(x);
      });
      if (await Promise.all(Cu(h, c)), g.gltf = h, g.perkMesh = h.scene.getObjectByProperty("type", "SkinnedMesh"), !g.perkMesh)
        throw new Error(`No SkinnedMesh found in ${m} for ${e} ${d}`);
      const C = g.perkMesh.material.map;
      let _ = null;
      return C && s.metadata.maps && s.metadata.maps.count > 1 && (r[`${f}_${c}`] || (_ = Object.keys(r).length, r[`${f}_${c}`] = { mapKey: _, data: C })), g.registered = true, { perk: g, texture: { key: _, data: C } };
    } catch (h) {
      throw console.error(`Couldn't load ${f}`, h), h;
    }
  })(), g.promise;
}, gi = async (e, t) => {
  const a = [];
  for (const s in t) {
    if (s === "collection" || s === "Background")
      continue;
    const o = /* @__PURE__ */ Su(s, t[s], e);
    a.push(o);
  }
  const i = await Promise.allSettled(a), r = [], l = [];
  for (let s = 0; s < i.length; s++)
    i[s].status === "fulfilled" ? (r.push(i[s].value?.perk), l.push(i[s].value?.texture)) : (console.error(`Promise ${s} failed with reason:`, i[s].reason), r.push(0), l.push(0));
  return [r, l];
}, Ot = new n.Box3(), Pu = new n.Vector3(), Mu = new n.Color();
Ot.max.set(0, 0, 0), Ot.min.set(0, 0, 0);
const Du = ["eyes", "body", "legs", "head", "face_accessory", "hands", "hair", "hair_accessory", "legs_accessory", "cloth", "shoes"], Eu = (e, t, a) => {
  const { getParent: i, collection: r } = t;
  if (!e)
    return null;
  const { metadata: l } = r, s = i().current;
  if (e && e.mipmaps[0] && s.material) {
    const o = l.maps;
    if (e.mipmaps[0] && o.width !== e.mipmaps[0].width)
      throw new Error(`texture size (${e.mipmaps[0].width}x(${e.mipmaps[0].height}) does not match metadata size (${o.width}x(${o.height})`);
    if (s.material.map && (s.material.map.format !== e.format || !s.material.map.isCompressedArrayTexture)) {
      const d = [];
      for (let c = 0; c < e.mipmaps.length; c++)
        d.push({ data: new Uint8Array(e.mipmaps[c].data.length * o.count), width: e.mipmaps[c].width, height: e.mipmaps[c].height });
      s.material.map = new n.CompressedArrayTexture(d, o.width, o.height, o.count), s.material.map.format = e.format, s.material.map.type = e.type, s.material.map.colorSpace = e.colorSpace, s.material.map.needsUpdate = true;
    }
    const f = et().gl;
    for (let d = 0; d < e.mipmaps.length; d++)
      Ot.max.set(e.mipmaps[d].width, e.mipmaps[d].height, 0), Ot.min.set(0, 0, 0), f.copyTextureToTexture3D(Ot, Pu.set(0, 0, a), e, s.material.map, d, 0);
  }
}, Tu = async (e, t, a, i, r, l) => {
  const [s, o] = await gi(t, e), f = a().current, d = i.current;
  if (!f || !d)
    return;
  const c = /* @__PURE__ */ new Array(16).fill(0);
  for (let C = 0; C < s.length; C++) {
    let _ = s[C], x;
    _?.perkMesh || (_ = { perkMesh: "none" });
    const b = o[C];
    if (b && Eu(b.data, t, b.key), _?.perkMesh === "none")
      x = -1;
    else
      try {
        x = f.registerGeometry(_.perkMesh.geometry, _.perkKey);
      } catch (w) {
        x = -1, console.warn(`iciiiiii Perk key ${_?.perkKey} error:`, w);
      }
    try {
      c[C] = { key: _.perkKey, traitType: _.traitType, perkId: x };
    } catch (w) {
      c[C] = { key: _.perkKey, traitType: _.traitType, perkId: -1 }, console.warn(`laaaaaaaaaaaa Perk key ${_?.perkKey} error:`, w);
    }
    b && (c[C].textureId = b.key + 1), c[C].colorDefault = _.perkMesh.userData?.color ? `#${_.perkMesh.userData.color}` : "#ffffff";
  }
  const { player: u, id: m } = d.userData, p = /* @__PURE__ */ new Array(16).fill(-1), g = /* @__PURE__ */ new Array(16).fill(-1), h = /* @__PURE__ */ new Array(16).fill(-1);
  if (l === "konpi")
    for (let C = 0; C < s.length; C++) {
      const { traitType: _, perkId: x, textureId: b, colorDefault: w } = c[C], P = /* @__PURE__ */ Du.indexOf(_);
      P !== -1 && (p[P] = x, g[P] = b, (r[_] || w) && (h[P] = r[_] || w));
    }
  else
    for (let C = 0; C < s.length; C++) {
      const { traitType: _, colorDefault: x, perkId: b, textureId: w } = c[C];
      p[C] = b, g[C] = w, (r[_] || x) && (h[C] = r[_] || x);
    }
  u.matrixPerks.fromArray(p), f.setGeometriesAt(m, u.matrixPerks), u.matrixTextures.fromArray(g), f.setTexturesAt(m, u.matrixTextures);
  for (let C = 0; C < h.length; C++) {
    const _ = h[C];
    _ !== -1 && f.setBatchColorsAt(m, C, Mu.set(_));
  }
}, Iu = ({ group: e, api: t, perks: a, colors: i, player: r }) => {
  const { getParent: l, collectionId: s, defaultPerks: o } = t, f = /* @__PURE__ */ Object.keys(a).map((p) => a[p].mesh || a[p]).join("-"), d = /* @__PURE__ */ Object.keys(i).map((p) => i[p]).join("-"), c = /* @__PURE__ */ I(null), u = /* @__PURE__ */ I(null), m = /* @__PURE__ */ I({});
  return G(() => {
    const p = async () => {
      c.current === f && u.current === d || (await Tu(a || o, t, l, e, i, s), !(c.current === f && u.current === d) && (c.current = f, u.current = d));
    };
    return (async () => {
      m.current[r.playerId] && await m.current[r.playerId], m.current[r.playerId] = p(), await m.current[r.playerId], delete m.current[r.playerId];
    })(), () => {
    };
  }, [f, d, t, l().current, e.current, i, r]), null;
}, pi = new n.Vector4(), Uu = new n.Vector3(), hi = new n.Vector3(), Bu = new n.Quaternion(), ku = new n.Euler(), Ru = new n.Matrix4(), or = /* @__PURE__ */ Z(({ children: e, playerId: t, perks: a, colors: i, isGpu: r, stopLoop: l, playerProps: s = {}, isAnimPaused: o, height: f, ...d }, c) => {
  const u = /* @__PURE__ */ Ke(Aa), m = /* @__PURE__ */ V(() => {
    const D = { activAnimations: {}, activAdditiveAnimations: {}, color: new n.Vector4(z.defaultSkinColor[0], z.defaultSkinColor[1], z.defaultSkinColor[2], z.defaultSkinColor[3]), dying: 0, holo: 0, invulnerability: 0, fly: 0, slide: 0, flyLerp: 0, playerShaderState: 0, noHeadTracking: false, distToPlayer: 999, height: z.defaultHeight, heightLerp: z.defaultHeight, modelHeight: 3.74, eyeHeight: 3, dirVector: new n.Vector3(0, 0, 1), upVector: new n.Vector3(0, 1, 0), eyePosition: new n.Vector3(0, 0, 0), matrixPerks: new n.Matrix4(), matrixTextures: new n.Matrix4() };
    return Object.keys(D).forEach((T) => {
      Object.prototype.hasOwnProperty.call(s, T) || (s[T] = D[T]);
    }), s;
  }, [s]), { getParent: p, extendedAnimations: g, scene: h, subscribe: C, args: _ } = u, x = /* @__PURE__ */ I();
  ge(c, () => x.current), Iu({ group: x, api: u, perks: a, colors: i, player: m }), ie(() => C(x), []);
  const b = /* @__PURE__ */ I(), w = /* @__PURE__ */ I(), P = /* @__PURE__ */ I(), S = /* @__PURE__ */ wu(h, m), [M] = /* @__PURE__ */ yu(S, g, t, x);
  return q(function(T, R) {
    const L = p().current, { userData: k } = x.current, { id: E, player: O } = k;
    if (!(!L || !S || !O || !(!L.isBatchedMesh || L._visibilities[E] && (L._inViewports[E] > 0 || L._frustumCulled[E] === 0)) && !O.leadAnim)) {
      if (P.current = true, !O.groupedAnim && (!o || O.isNpc) && (O.distToPlayer < 80 || O.leadAnim ? (M.mixer.update(R + M.deltaToAdd, r), M.deltaToAdd = 0) : M.mixer.skipNextFrame === false ? (P.current = false, M.mixer.skipNextFrame = true, M.mixer.update(R + M.deltaToAdd, r), M.deltaToAdd = 0) : (P.current = false, M.mixer.skipNextFrame = false, M.deltaToAdd = R)), r) {
        const $ = O.lastActiveAnimation;
        if (!$)
          return;
        const ne = /* @__PURE__ */ u.animationsList.current.findIndex((Ue) => Ue === $._clip.name);
        L.setUniformAt(E, "bakedanim", pi.set($.time, $._clip.duration, ne, 1), 4, Float32Array, n.RGBAFormat);
        return;
      }
      O.groupedAnim || S.skeleton.bones[0].traverse(function(ne) {
        ne.updateMatrix(), ne.matrixWorld.multiplyMatrices(ne.parent.matrixWorld, ne.matrix);
      }), O.stopLookAt && (P.current = false), P.current && ae(`postAnimRaf_${t}`, { delta: R + M.deltaToAdd });
    }
  }, z.renderPriority.characterInstanceAnim), Au("height", f, x, p), q(function(T, R) {
    const L = p().current, { userData: k } = x.current, { id: E, player: O } = k;
    if (O.groupedAnim || r || !L || !S || !O || l)
      return;
    const J = L.isBatchedMesh ? L._visibilities[E] && (L._inViewports[E] > 0 || L._frustumCulled[E] === 0) : true, $ = S.skeleton.bones, ne = S.skeleton.boneInverses;
    x.current.matrix.compose(x.current.position, x.current.quaternion, x.current.scale);
    for (let j = 0, F = $.length; j < F; j++) {
      const le = $[j], Qt = le ? le.matrixWorld : Ru;
      le._offsetMatrix || (le._offsetMatrix = new n.Matrix4()), le._offsetMatrix.multiplyMatrices(Qt, ne[j]), le._offsetMatrix.toArray(L.instanceBones, 16 * (j + E * $.length));
    }
    L.setMatrixAt(E, x.current.matrix);
    let Ue = false;
    if ((J || O.leadAnim) && O.face) {
      for (const [j, F] of O.face)
        if (F) {
          if (F && F.neckEuler)
            Ue = true, F.matrix.compose(Uu.fromArray(F.initialPosition), Bu.setFromEuler(ku.fromArray(F.neckEuler)), hi.set(1, 1, 1)), F.updateMatrixWorld(true);
          else if (F.nextPosition) {
            const le = F.matrix.elements;
            le[12] = F.initialPosition[0] + F.nextPosition[0], le[13] = F.initialPosition[1] + F.nextPosition[1], le[14] = F.initialPosition[2] + F.nextPosition[2], F.nextScale && (hi.fromArray(F.nextScale), F.matrix.scale(hi)), F.matrixWorld.copy(F.matrix), F.matrixWorld.multiplyMatrices(F.parent.matrixWorld, F.matrix);
          }
        }
      Ue && L.setBonesAt(E, S.skeleton);
    }
  }, z.renderPriority.characterInstanceBones), mu({ playerId: t, headRef: w, bodyRef: b, group: x, localModel: S }), G(() => {
    const D = p().current, T = x.current, R = T.userData.id;
    D._maxInstanceCount <= _.count && D.setMaxInstanceCount(Math.ceil(_.count / 10) * 10), D.setUniformAt(R, "bakedanim", pi.set(Math.random(), 1, n.MathUtils.randInt(0, 53), r ? 1 : 0), 4, Float32Array, n.RGBAFormat), D.setMatrixAt(R, T.matrix), D.setIsActive(R, true);
  }, []), G(() => {
    const D = p().current, R = x.current.userData.id;
    D.setUniformAt(R, "bakedanim", pi.set(Math.random(), 1, n.MathUtils.randInt(0, 53), r ? 1 : 0), 4, Float32Array, n.RGBAFormat);
  }, [r]), y("group", { ref: x, "userData-isGpu": r, "userData-player": x.current ? x.current.userData.player : m, "userData-localModel": S, ...d, api: u, onUpdate: (D) => {
    D.updateMatrix(), D.updateWorldMatrix(false, false);
    const T = /* @__PURE__ */ u.getParent();
    D.userData.id !== void 0 && T.current;
  }, children: e });
});
or.displayName = "CharacterImpl";
const sr = /* @__PURE__ */ Z(({ children: e, ...t }, a) => y(de, { fallback: null, children: y(or, { ref: a, ...t, children: e }) }));
sr.displayName = "Character";
const Lu = { mixamorigHips: "hips", mixamorigSpine: "spine", mixamorigSpine1: "chest", mixamorigSpine2: "upperChest", mixamorigNeck: "neck", mixamorigHead: "head", mixamorigLeftShoulder: "leftShoulder", mixamorigLeftArm: "leftUpperArm", mixamorigLeftForeArm: "leftLowerArm", mixamorigLeftHand: "leftHand", mixamorigLeftHandThumb1: "leftThumbMetacarpal", mixamorigLeftHandThumb2: "leftThumbProximal", mixamorigLeftHandThumb3: "leftThumbDistal", mixamorigLeftHandIndex1: "leftIndexProximal", mixamorigLeftHandIndex2: "leftIndexIntermediate", mixamorigLeftHandIndex3: "leftIndexDistal", mixamorigLeftHandMiddle1: "leftMiddleProximal", mixamorigLeftHandMiddle2: "leftMiddleIntermediate", mixamorigLeftHandMiddle3: "leftMiddleDistal", mixamorigLeftHandRing1: "leftRingProximal", mixamorigLeftHandRing2: "leftRingIntermediate", mixamorigLeftHandRing3: "leftRingDistal", mixamorigLeftHandPinky1: "leftLittleProximal", mixamorigLeftHandPinky2: "leftLittleIntermediate", mixamorigLeftHandPinky3: "leftLittleDistal", mixamorigRightShoulder: "rightShoulder", mixamorigRightArm: "rightUpperArm", mixamorigRightForeArm: "rightLowerArm", mixamorigRightHand: "rightHand", mixamorigRightHandPinky1: "rightLittleProximal", mixamorigRightHandPinky2: "rightLittleIntermediate", mixamorigRightHandPinky3: "rightLittleDistal", mixamorigRightHandRing1: "rightRingProximal", mixamorigRightHandRing2: "rightRingIntermediate", mixamorigRightHandRing3: "rightRingDistal", mixamorigRightHandMiddle1: "rightMiddleProximal", mixamorigRightHandMiddle2: "rightMiddleIntermediate", mixamorigRightHandMiddle3: "rightMiddleDistal", mixamorigRightHandIndex1: "rightIndexProximal", mixamorigRightHandIndex2: "rightIndexIntermediate", mixamorigRightHandIndex3: "rightIndexDistal", mixamorigRightHandThumb1: "rightThumbMetacarpal", mixamorigRightHandThumb2: "rightThumbProximal", mixamorigRightHandThumb3: "rightThumbDistal", mixamorigLeftUpLeg: "leftUpperLeg", mixamorigLeftLeg: "leftLowerLeg", mixamorigLeftFoot: "leftFoot", mixamorigLeftToeBase: "leftToes", mixamorigRightUpLeg: "rightUpperLeg", mixamorigRightLeg: "rightLowerLeg", mixamorigRightFoot: "rightFoot", mixamorigRightToeBase: "rightToes" };
function zu(e, t) {
  return new Xo().loadAsync(e).then((i) => {
    const r = /* @__PURE__ */ n.AnimationClip.findByName(i.animations, "mixamo.com"), l = [], s = new n.Quaternion(), o = new n.Quaternion(), f = new n.Quaternion(), d = new n.Vector3(), c = i.getObjectByName("mixamorigHips").position.y, u = t.humanoid?.getNormalizedBoneNode("hips").getWorldPosition(d).y, m = t.scene.getWorldPosition(d).y, g = Math.abs(u - m) / c;
    return r.tracks.forEach((h) => {
      const C = /* @__PURE__ */ h.name.split("."), _ = C[0], x = Lu[_], b = t.humanoid?.getNormalizedBoneNode(x)?.name, w = /* @__PURE__ */ i.getObjectByName(_);
      if (b != null) {
        const P = C[1];
        if (w.getWorldQuaternion(s).invert(), w.parent.getWorldQuaternion(o), h instanceof n.QuaternionKeyframeTrack) {
          for (let S = 0; S < h.values.length; S += 4) {
            const M = /* @__PURE__ */ h.values.slice(S, S + 4);
            f.fromArray(M), f.premultiply(o).multiply(s), f.toArray(M), M.forEach((D, T) => {
              h.values[T + S] = D;
            });
          }
          l.push(new n.QuaternionKeyframeTrack(`${b}.${P}`, h.times, h.values.map((S, M) => t.meta?.metaVersion === "0" && M % 2 === 0 ? -S : S)));
        } else if (h instanceof n.VectorKeyframeTrack) {
          const S = /* @__PURE__ */ h.values.map((M, D) => (t.meta?.metaVersion === "0" && D % 3 !== 1 ? -M : M) * g);
          l.push(new n.VectorKeyframeTrack(`${b}.${P}`, h.times, S));
        }
      }
    }), new n.AnimationClip("vrmAnimation", r.duration, l);
  });
}
const lr = /* @__PURE__ */ Z(({ children: e, model: t = "girl_konpi", animation: a = "singing", playerId: i, isGpu: r, playerProps: l = {}, isAnimPaused: s, height: o, ...f }, d) => {
  const [c, u] = /* @__PURE__ */ Se(async () => {
    const { VRMLoaderPlugin: x, VRMUtils: b } = await import("@pixiv/three-vrm").catch(() => (console.log("VRM not loaded"), [null, null]));
    return [x, b];
  }, ["pixiv"]), m = /* @__PURE__ */ V(() => {
    const x = { activAnimations: {}, activAdditiveAnimations: {}, dying: 0, holo: 0, invulnerability: 0, fly: 0, slide: 0, flyLerp: 0, playerShaderState: 0, noHeadTracking: false, distToPlayer: 999, height: z.defaultHeight, heightLerp: z.defaultHeight, modelHeight: 3.74, eyeHeight: 3, dirVector: new n.Vector3(0, 0, 1), upVector: new n.Vector3(0, 1, 0), eyePosition: new n.Vector3(0, 0, 0), matrixPerks: new n.Matrix4(), matrixTextures: new n.Matrix4() };
    return Object.keys(x).forEach((b) => {
      l.hasOwnProperty(b) || (l[b] = x[b]);
    }), l;
  }, [l]), p = /* @__PURE__ */ I();
  ge(d, () => p.current);
  const g = /* @__PURE__ */ ot(v[`${z.collectionAssetsRoot}glb/vrm/${t}.vrm`], false, false, (x) => {
    c && x.register((b) => new c(b));
  }), h = g.userData.vrm, C = /* @__PURE__ */ V(() => {
    g.scene.traverse((w) => {
      if (w.isMesh) {
        const P = Array.isArray(w.material) ? w.material : [w.material];
        if (w.isSkinnedMesh) {
          w.skeleton.bones[0].updateMatrixWorld(true);
          for (let M = 0; M < w.skeleton.bones.length; M++)
            w.skeleton.bones[M].matrixAutoUpdate = false;
          w.matrixAutoUpdate = false;
        }
        const S = [];
        P.forEach((M) => {
          const D = /* @__PURE__ */ M.clone();
          D.glslVersion = n.GLSL3, delete D.uniformsGroup, D.defines = {};
          const T = new n.MeshPhongMaterial({ map: D.map, color: D.color, alphaTest: D.alphaTest, transparent: D.transparent, opacity: D.opacity, emissive: D.emissive || 0, emissiveMap: D.emissiveMap || null, emissiveIntensity: D.emissiveIntensity, alphaMap: D.alphaMap || null, specular: D.specular || 0, side: D.side, normalMap: D.normalMap });
          S.push(T);
        }), w.material = S;
      }
    });
    const x = new n.AnimationMixer(g.scene);
    u && (u.removeUnnecessaryVertices(g.scene), u.removeUnnecessaryJoints(g.scene));
    function b(w) {
      const P = new n.Quaternion(0, 0, 0, 1), S = new n.Quaternion(0, 0, 0, 1);
      S.setFromEuler(new n.Euler(0, 0, 0.25 * Math.PI)), new n.QuaternionKeyframeTrack(w.humanoid.getNormalizedBoneNode("leftUpperArm").name + ".quaternion", [0, 0.5, 1], [...P.toArray(), ...S.toArray(), ...P.toArray()]);
      const M = new n.NumberKeyframeTrack(w.expressionManager.getExpressionTrackName("blink"), [0, 0.5, 1], [0, 1, 0]), D = new n.AnimationClip("Animation", 1, [M]);
      x.clipAction(D);
    }
    return b(h), zu(v[`/fbx/${a}.fbx`], g.userData.vrm).then((w) => {
      x.clipAction(w).play();
    }), x;
  }, [g.scene]), _ = /* @__PURE__ */ I();
  return q((x, b) => {
    h && h.update(b), C && C.update(b);
  }), q((x, b) => {
    _.current.updateMatrixWorld();
  }, 999), q((x, b) => {
    _.current.traverse((w) => {
      if (w.isSkinnedMesh) {
        w.frustumCulled = true, w.skeleton.bones[0].updateMatrixWorld(true);
        for (let P = 0; P < w.skeleton.bones.length; P++)
          w.skeleton.bones[P].updateMatrix(), w.skeleton.bones[P].matrixAutoUpdate = false;
        w.matrixAutoUpdate = false;
      }
    }), p.current.updateMatrixWorld();
  }, 998), y(te, { children: H("group", { ref: p, "userData-isGpu": r, "userData-player": p.current ? p.current.userData.player : m, ...f, onUpdate: (x) => {
    x.updateMatrix(), x.updateWorldMatrix();
  }, children: [y("primitive", { ref: _, object: g.scene }), e] }) });
});
lr.displayName = "CharacterVrmImpl";
const fr = /* @__PURE__ */ Z(({ children: e, ...t }, a) => y(de, { fallback: null, children: y(lr, { ref: a, ...t, children: e }) }));
fr.displayName = "Character";
const cr = new n.Vector4();
function Fu({ modelRef: e, players: t }) {
  return q(function(i, r) {
    const l = e.current;
    if (!l)
      return;
    const s = t.length;
    if (l.count = s, l.setInstanceCount(s), l.geometry.attributes.instanceVColor && (l.geometry.attributes.instanceVColor.updateRange.count = s * 4, l.geometry.attributes.instanceVColor.needsUpdate = true), !!l.material)
      for (let o = 0; o < t.length; o++)
        Ca.forEach((f, d) => {
          t[o].peer.energy > 0 && (cr.set(t[o].heightLerp, t[o].holo, t[o].flyLerp, t[o].slide), f.setUniformAt(o, "extra", cr, 4), f.useColor && f.setUniformAt(o, "color", t[o].color), t[o].grpRef && f.setMatrixAt(o, t[o].grpRef.matrix)), f.setVisibilityAt(o, t[o].peer.energy > 0 && !t[o].peer.dead);
        });
  }, 9), null;
}
const Nu = /* @__PURE__ */ W({}, `
#include <common>


mat4 scale(float x, float y, float z) {
  return mat4(vec4(x, 0.0, 0.0, 0.0), vec4(0.0, y, 0.0, 0.0), vec4(0.0, 0.0, z, 0.0), vec4(0.0, 0.0, 0.0, 1.0));
}
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <batching_pars_vertex>
#include <skinning_pars_vertex>
#include <batching_pars_uniforms>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
out vec2 vUv;

void main() {

	vUv = uv;
	#include <color_vertex>

	#include <morphcolor_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING ) || defined( USE_BATCHING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <batchingbase_vertex>
		#include <defaultnormal_vertex>

	#endif

       

  float holo = 1.;
  float height = 1.;

  #ifdef USE_BATCHING_UNIFORM_extra
    vec4 extraUniforms = getBatchUniform(batching_extra_texture, 4);
    holo = extraUniforms.y;
    height = extraUniforms.x;
  #endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
  #ifdef USE_BATCHING
    transformed.y *= height * .9;
    transformed.y += .1 * height;
    transformed = ( batchingMatrix * vec4( transformed, 1.0 ) ).xyz;
  #endif

  vec4 mvPosition = vec4(transformed, 1.0);
  vec4 mPosition = modelMatrix * mvPosition;

  mvPosition = viewMatrix * mPosition;
  gl_Position = projectionMatrix * mvPosition;

	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>

}`, `
  #include <layout_pars_fragment>

  #include <common>
  #include <packing>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  #include <color_pars_fragment>
  #include <batching_pars_uniforms_fragment>
  #include <batching_pars_uniforms>

  float elfld_hash( float n ) { return fract(sin(n)*3.5453123); }
  float elfld_noise( in vec3 x )
  {
      vec3 p = floor(x);
      vec3 f = fract(x);
      f = f*f*(3.0-2.0*f);

      float n = p.x + p.y*157.0 + 113.0*p.z;
      float e1 = elfld_hash(n+0.0);
      return mix(mix(mix( e1, elfld_hash(n+1.0),f.x),
                       mix( elfld_hash(n+157.0), elfld_hash(n+158.0),f.x),f.y),
                  mix(mix( elfld_hash(n+113.0), elfld_hash(n+114.0),f.x),
                       mix( elfld_hash(n+270.0), elfld_hash(n+271.0),f.x),f.y),f.z);
  }



//
// Noise functions
//
#define SCALE		   10.0		// 3.0
#define POWER			1.0		
#define OCTAVES   		2		// 7
#define SWITCH_TIME 	5.0		// seconds


vec2 hash( vec2 p )
{
    p = vec2( dot(p,vec2(127.1,311.7)), dot(p,vec2(269.5,183.3)) );
	return fract(sin(p)*43758.5453);
}

float noise( in vec2 p )
{
    vec2 i = floor( p );
    vec2 f = fract( p );
	
	vec2 u = f*f*(3.0-2.0*f);

    return mix( mix( dot( hash( i + vec2(0.0,0.0) ), f - vec2(0.0,0.0) ), 
                     dot( hash( i + vec2(1.0,0.0) ), f - vec2(1.0,0.0) ), u.x),
                mix( dot( hash( i + vec2(0.0,1.0) ), f - vec2(0.0,1.0) ), 
                     dot( hash( i + vec2(1.0,1.0) ), f - vec2(1.0,1.0) ), u.x), u.y);
}

float voronoi( in vec2 x )
{
  
    float t = 2.;
	float function 			= mod(t,4.0);
    bool  multiply_by_F1	= mod(t,8.0)  >= 4.0;
	bool  inverse			= mod(t,16.0) >= 8.0;
	float distance_type		= mod(t/16.0,4.0);
    
    vec2 n = floor( x );
    vec2 f = fract( x );

	float F1 = 8.0;
	float F2 = 8.0;
	
	
    for( int j=-1; j<=1; j++ )
    for( int i=-1; i<=1; i++ )
    {
        vec2 g = vec2(i,j);
        vec2 o = hash( n + g );

        o = 0.5 + 0.41*sin( 6.2831*o ); // animate

		vec2 r = g - f + o;

		float d = 	distance_type < 1.0 ? dot(r,r)  :				// euclidean^2
				  	distance_type < 2.0 ? sqrt(dot(r,r)) :			// euclidean
					distance_type < 3.0 ? abs(r.x) + abs(r.y) :		// manhattan
					distance_type < 4.0 ? max(abs(r.x), abs(r.y)) :	// chebyshev
					0.0;

		if( d<F1 ) 
		{ 
			F2 = F1; 
			F1 = d; 
		}
		else if( d<F2 ) 
		{
			F2 = d;
		}
    }
    
	
	float c = function < 1.0 ? F1 : 
			  function < 2.0 ? F2 : 
			  function < 3.0 ? F2-F1 :
			  function < 4.0 ? (F1+F2)/2.0 : 
			  0.0;
		
	if( multiply_by_F1 )	c *= F1;
	if( inverse )			c = 1.0 - c;
	
    return c;
}

float fbm( in vec2 p )
{
	float s = 0.0;
	float m = 0.0;
	float a = 0.5;
	
	for( int i=0; i<OCTAVES; i++ )
	{
		s += a * voronoi(p);
		m += a -.2 + abs(sin(time) * .2);
		a *= 0.5;
		p *= 2.0 + sin(time);
	}
	return s/m;
}


      in vec2 vUv;

      void main() {
       

        float holo = 1.;
        float height = 1.;

        #ifdef USE_BATCHING_UNIFORM_extra
          vec4 extraUniforms = getBatchUniform(batching_extra_texture, 4);
          holo = extraUniforms.y;
          height = extraUniforms.x;
        #endif

        vec2 uv = vUv * vec2(30., 8.);
        float outerGlow = distance(vUv, vec2(0.5, 0.)) * 2.5 - 1.8 ;


        float a = POWER*fbm( SCALE*vUv + time * 5.  );
        a += 1.*fbm( SCALE*vUv * .3 + time * .2  );
        // float a = abs(elfld_noise(vec3(uv.x-time*14.14, uv.y+time*10.,uv.x-time*14.14)));
        //(0, .5-pow(a, .2)/2., 1.-pow(a, .2), 1) //blue
        float strength = (pow(a , 1.2))*1.;
        strength = mix(strength, 1., 1. - smoothstep(0.1, .4, vUv.y));

        // strength -= outerGlow;
        // strength += step(0.3, strength);
        float alphaTest = .3;
        strength = saturate((strength - alphaTest) / max(fwidth(strength), 0.0001) + 0.5);
        if (strength >= alphaTest) discard;

        if (vUv.y >= .9) discard;

        vec3 color = mix(vec3(0.4, 0.8, 1.), vec3(1.), strength);

        vec4 o_diffuse = vec4(color, 1.);
        vec4 o_color = vec4(color, 1.);
        vec4 o_normal = vec4(0.);
        vec4 o_position = vec4(vec3(0.), 1.);

        #include <layout_output_fragment>
      }`), Ou = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ EnergyMaterialImpl: Nu });
const dr = () => y("energyMaterialImpl", { attach: "material", glslVersion: n.GLSL3, vertexColors: 2, uniformsGroups: [oe], side: n.FrontSide }, Ou), Gu = /* @__PURE__ */ W({ noise: null }, `
#include <common>

#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <batching_pars_vertex>
#include <skinning_pars_vertex>
#include <batching_pars_uniforms>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
out vec2 vUv;
out vec4 vInstanceColor;
out vec3 vViewPosition;
void main() {

	vUv = uv;
	#include <color_vertex>

	#include <morphcolor_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING ) || defined( USE_BATCHING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <batchingbase_vertex>
		#include <defaultnormal_vertex>

	#endif


  float holo = 1.;
  float height = 1.;

  #ifdef USE_BATCHING_UNIFORM_extra
    vec4 extraUniforms = getBatchUniform(batching_extra_texture, 4);
    holo = extraUniforms.y;
    height = extraUniforms.x;
  #endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
  
  #ifdef USE_BATCHING
    transformed.y *= height;
    // transformed.y += .1 * height;
    transformed = ( batchingMatrix * vec4( transformed, 1.0 ) ).xyz;
  #endif


  vec4 mvPosition = vec4(transformed, 1.0);


  // float noise = 1.0 - (snoise(vec2((time / 4. - transformed.x / 2.0) * 1. + 2., (time / 1. - transformed.y / 2.0) * 1. + 2.)));
  // if (mvPosition.y > .4) {
  //   mvPosition.x += noise / 2.5 / min(1., height) * (1. - smoothstep(-2. * height, 3.2 * height, mvPosition.y)) * smoothstep(.3, 3., mvPosition.y);
  //   mvPosition.z -= noise / 2.5 / min(1., height) * (1. - smoothstep(-2. * height, 3.2 * height, mvPosition.y)) * smoothstep(.3, 3., mvPosition.y);
  // }

  vec4 mPosition = modelMatrix * mvPosition;

  mvPosition = viewMatrix * mPosition;
  gl_Position = projectionMatrix * mvPosition;

  vViewPosition = - mvPosition.xyz;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>


  #ifdef USE_BATCHING_UNIFORM_color
    vInstanceColor = getBatchUniform(batching_color_texture, 4);
  #endif

}`, `
#include <layout_pars_fragment>

#include <common>
#include <packing>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>

uniform sampler2D noise;
in vec2 vUv;
in vec4 vInstanceColor;
in vec3 vViewPosition;

//fix for some GPU
int roundInt(float x){
  return int(round(x * 100.)/ 100.);
}
ivec4 roundVecInt(vec4 x){
  ivec4 a = ivec4(1);
  a.x = roundInt(x.x);
  a.y = roundInt(x.y);
  a.z = roundInt(x.z);
  a.w = roundInt(x.w);
  return a;
}

void main() {

  vec4 base = vec4(1.);
  ivec4 vCol = roundVecInt(vInstanceColor);
  vec3 diffuse = vec3(1.0,1.0,1.0);
  vec2 uv = vUv * 10.;
  float outerGlow = 1. - distance(vUv, vec2(0.5, 0.5)) * 1.1 - .5;
  outerGlow = pow(outerGlow, .5);
  float strength = pow(1. - texture(noise, vUv * vec2(2., .1) + vec2(0., time / 10.)).r, 15.);

  float strength2 = strength;
  strength2 -= outerGlow;
  strength2 += step(-0.2, strength2) * 0.8;
  strength2 = clamp(strength2, 0.0, 1.0);
  strength += outerGlow;
  float innerVig = 1. - distance(vUv, vec2(0.5, 0.5)) * 1.1 - .5;
  if (strength2 < .9 && innerVig <= 0.) discard;
  if (strength < .9 && innerVig <= 0.) discard;
  if (strength2 < .92 )  discard;
  if (strength < .92 ) discard;

  vec3 energy = vec3(strength);
  // strength -= smoothstep(0.5, .8, distance(vUv, vec2(0.5, 0.5)) * 2.1 - .2);
  // innerVig -= smoothstep(0.0, .8, distance(vUv, vec2(0.5, 0.5)) * 2.1 - .1) * .91;
  // color = vec3(innerVig);
  // if (strength + innerVig < .001 ) discard;

  strength = mix(strength, 0., 1. - smoothstep(0.1, .5, vUv.y));
  vec4 diffuseColor = vec4(diffuse, strength);

  vec4 o_diffuse = diffuseColor;
  vec4 o_color = vec4(diffuseColor.rgb * .5, 1.);
  vec4 o_normal = vec4(0.);
  vec4 o_position = vec4(0.);

  #include <layout_output_fragment>

}`), Hu = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ AuraMaterialImpl: Gu });
const ur = () => {
  const e = /* @__PURE__ */ A.useRef(), t = /* @__PURE__ */ Ce(ue.noise.noise_xs, (i) => {
    i.wrapS = i.wrapT = n.RepeatWrapping, i.needsUpdate = true;
  }), a = /* @__PURE__ */ se({ useLights: false });
  return y("auraMaterialImpl", { attach: "material", ref: e, noise: t, glslVersion: n.GLSL3, vertexColors: 2, uniformsGroups: a, side: n.DoubleSide, ...a }, Hu);
}, Ca = /* @__PURE__ */ new Map(), mr = 10;
N({ MetaMesh: Do });
const vr = ({ name: e, children: t, geometry: a, useColor: i }) => {
  const r = /* @__PURE__ */ I(), s = U(({ get: c }) => c)().gl, o = 1, f = 128, d = 128 * 4;
  return ie(() => {
    const c = r.current;
    if (c.useColor = i, !c)
      return;
    const u = a;
    u.computeBoundingSphere(), c.boundingSphere = u.boundingSphere, c.registerGeometry(u, 1);
    for (let m = 0; m < mr; m++)
      c.setGeometry(m, 1);
    return i && c.setUniformAt(0, "color", new n.Vector4(1, 1, 1, 1), 4, Float32Array), c.setUniformAt(0, "extra", new n.Vector4(1, 1, 1, 1), 4, Float32Array), Ca.set(e, c), () => {
      Ca.delete(e);
    };
  }, []), H(te, { children: [y("metaMesh", { ref: r, args: [null, mr, o, f, d, s], onUpdate: (c) => {
    c.geometry && c.geometry.computeBoundingSphere();
  }, frustumCulled: true, children: t }), y(Fu, { modelRef: r })] });
};
function Vu() {
  const { scene: e } = /* @__PURE__ */ ot(v["/glb/energy.glb"]);
  return y(vr, { geometry: e.children[0].geometry, name: "Energy", children: y(dr, {}) });
}
function Wu() {
  const { scene: e } = /* @__PURE__ */ ot(v["/glb/aura.glb"]);
  return y(vr, { geometry: e.children[0].geometry, name: "Aura", useColor: true, children: y(ur, {}) });
}
function ju() {
  return H(Bn, { step: 1, children: [y(de, { fallback: null, children: y(Vu, {}) }), y(de, { fallback: null, children: y(Wu, {}) })] });
}
var Qu = `precision mediump float;

/* Number of seconds (possibly fractional) that has passed since the last
  update step. */
uniform float u_delta;
uniform float u_totalDelta;
uniform float u_shape;
uniform vec3 u_gravity;
uniform vec3 u_origin;
// uniform sampler2D u_noise;

/* Theta is the angle between the vector (1, 0) and a newborn particle's
  velocity vector. By setting u_radius and u_angle, we can restrict it
  to be in a certain range to achieve a directed "cone" of particles.
  To emit particles in all directions, set these to -PI and PI. */
uniform float u_radius;
uniform float u_radiusThickness;
uniform float u_angle;

/* The min and max values of the (scalar!) speed assigned to a newborn
  particle.*/
uniform float u_minSpeed;
uniform float u_maxSpeed;
uniform float u_maxAge;
uniform float u_forceRampDuration;
uniform float u_minForce;
uniform float u_maxForce;
uniform float u_friction;
uniform vec4 u_forceBezier;
uniform float u_mode;
uniform float u_respawnMode;
uniform float u_birthRate;
uniform float u_maxParticles;
uniform float u_repeatDelay;
uniform float u_repeatCount;
uniform float u_coneMode;
uniform float u_system;
uniform vec3 u_playerPos;
uniform vec3 u_playerVelo;
uniform vec3 u_playerVeloReflect;
uniform vec3 u_parentPosition;

uniform vec3 u_playerUp;
uniform float u_hideOnTouch;
uniform float u_bounciness;

in vec3 a_offset;
#ifdef USE_MATRICE
  in vec3 a_rotation;
  in vec3 a_scale;
#endif
in float a_age;
in float a_loopCnt;
in float a_life;
in vec3 a_velocity;
in float a_overvelocity;

out vec3 v_offset;
#ifdef USE_MATRICE
  out vec3 v_rotation;
  out vec3 v_scale;

  uniform vec3 u_rotationStart;
  uniform vec3 u_forceRotation;
  uniform float u_rotationEnabled;

  uniform vec3 u_scaleStart;
  uniform vec3 u_scaleEnd;
  uniform float u_scaleEnabled;
#endif
out float v_age;
out float v_loopCnt;
out float v_life;
out vec3 v_velocity;
out float v_overvelocity;

float radiusThicknessModifier;

// decompose a mat4 into a vec3 position
vec3 getTranslation(mat4 m) {
  return m[3].xyz;
}
// decompose a mat4 into rotation in euler angles
vec3 extractRotation(mat4 m) {
  vec3 v;
  v.x = atan(m[1][2], m[2][2]);
  v.y = atan(-m[0][2], sqrt(m[1][2] * m[1][2] + m[2][2] * m[2][2]));
  v.z = atan(m[0][1], m[0][0]);
  return v;
}


float rand(float n){return fract(sin(n) * 43758.5453123);}

float cubic_bezier(vec2 A, vec2 B, vec2 C, vec2 D, float t)
{
  vec2 E = mix(A, B, t);
  vec2 F = mix(B, C, t);
  vec2 G = mix(C, D, t);

  vec2 H = mix(E, F, t);
  vec2 I = mix(F, G, t);

  vec2 P = mix(H, I, t);

  return P.y;
}


float toBezier(float delta, float i, vec4 bezier)
{
    float t = delta * i;
    float t2 = t * t;
    float one_minus_t = 1.0 - t;
    float one_minus_t2 = one_minus_t * one_minus_t;
    return (bezier.x * one_minus_t2 * one_minus_t + bezier.y * 3.0 * t * one_minus_t2 + bezier.z * 3.0 * t2 * one_minus_t + bezier.w * t2 * t);
}

float PHI = 1.61803398874989484820459; // Golden Ratio   
float PI  = 3.14159265358979323846264; // PI
float SQ2 = 1.41421356237309504880169 * 10000.0; // Square Root of Two

float gold_noise(in vec2 coordinate, in float seed){
    return fract(tan(distance(coordinate*(seed+PHI), vec2(PHI, PI)))*SQ2);
}

vec3 getSphereStartPos(float idVertex, float radius)
{
  float x = 0.;
  float y = 0.;
  float z = 0.;

  float fi = idVertex;
  // Note: Use uniform random generator instead of noise in your applications
  float theta = 2.0f * PI * gold_noise(vec2(fi * 0.3482f, fi * 2.18622f), 0.452342342);
  float phi = 2.0f * PI * gold_noise(vec2(fi * 1.9013, fi * 0.94312), 0.452342342);
  x = sin(phi) * cos(theta) * (radius);
  y = sin(phi) * sin(theta) * (radius);
  z = cos(phi) * (radius);
  
  return vec3(x,y,z);
}

vec3 getConeStartPos( float theta, float u_radius)
{
  float x = 0.;
  float y = 0.;
  float z = 0.;

  x = cos(theta) * u_radius;
  z = sin(theta) * u_radius;
  return vec3(x,y,z);
}

vec3 random3(vec3 c) {
  float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
  vec3 r;
  r.z = fract(512.0*j);
  j *= .125;
  r.x = fract(512.0*j);
  j *= .125;
  r.y = fract(512.0*j);
  return r-0.5;
}
float degToRad(float deg) {
  return deg * 0.017453292519943295;
}

const float DOT_THRESHOLD = 0.9995;

vec3 slerp (vec3 v0, vec3 v1, float t) {
  // Dot product - the cosine of the angle between 2 vectors.
              float dot = dot(v0, v1);

  // Clamp it to be in the range of Acos()
  // This may be unnecessary, but floating point
  // precision can be a fickle mistress.
  dot = clamp(dot, -1.0, 1.0);

  // Acos(dot) returns the angle between start and end,
  // And multiplying that by percent returns the angle between
  // start and the final result.
  float theta = acos(dot) * t;

  // The next few lines are a basic cross product
  vec3 RelativeVec = v1 - v0 * dot;
  RelativeVec = normalize(RelativeVec);        // Orthonormal basis
  // The final result.
  vec3 rv = ((v0 * cos(theta)) + (RelativeVec * sin(theta)));
  return rv;
}



// maybe applyMatrix4 in the shader instead of the useFrame of Particle.jsx to coonvert player pos to local
// vec3 applyMatrix4(in vec3 position, in mat4 matriceWorld)
// {
//   float w = 1. / ( matriceWorld[0][ 3 ] * position.x + matriceWorld[1][ 3 ] * position.y + matriceWorld[2][ 3 ] * position.z + matriceWorld[3][ 3 ] );

//   float x = ( matriceWorld[0][ 0 ] * position.x + matriceWorld[1][ 0 ] * position.y + matriceWorld[2][ 0 ] * position.z + matriceWorld[3][ 0 ] ) * w;
//   float y = ( matriceWorld[0][ 1 ] * position.x + matriceWorld[1][ 1 ] * position.y + matriceWorld[2][ 1 ] * position.z + matriceWorld[3][ 1 ] ) * w;
//   float z = ( matriceWorld[0][ 2 ] * position.x + matriceWorld[1][ 2 ] * position.y + matriceWorld[2][ 2 ] * position.z + matriceWorld[3][ 2 ] ) * w;

//   return vec3(x,y,z);
// }

//https://stackoverflow.com/a/64677993/6998283
vec4 closest_point_and_distance(vec3 p,vec3 a,vec3 b) {
  vec3 s = b - a;
  vec3 w = p - a;
  float ps = dot(w, s);
  if (ps <= 0.){
    return vec4(a, length(w));
  }
  float l2 = dot(s, s);
  vec3 closest = vec3(0.);
  if (ps >= l2){
    closest = b;
  }else{
    closest = a + ps / l2 * s;
  }
  return vec4(closest, distance(p,closest));
}

#pragma glslify: snoise3 = require('glsl-noise/simplex/3d') 
#pragma glslify: cnoise3 = require('glsl-noise/classic/3d') 

void main() {

  float idVertex = float(gl_VertexID);
  
  float age = a_age;
  //this should return a random number between 0 and 1 that will always be the same for a given particleId ( idVertex )
  float idVertexConstRandForce = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), 1.2988764534);
  float idVertexConstRandVel = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), 3.298085282);
  float idVertexConstRandBirthPct = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), 2.294585282);

  if (a_age >= a_life) {
    //reset position, velocity etc

    // vec2 rand = vec2(gnoise);
    // vec2 rand = texelFetch(u_noise, noise_coord, 0).rg;
    /* Decide the direction of the particle based on the first random value.
      The direction is determined by the angle theta that its vector makes
      with the vector (1, 0).*/
    float theta = idVertex;
    // CONE PROPS!!! u_radius = RADIUS

    float rr = 1.;
    float fillRandom = 1.;

    // random distribution of particles
    if (u_mode == 0.0) {
      rr += rand(u_delta * idVertex);
    }

    float x = 0.;
    float y = 0.;
    float z = 0.;



    vec3 startPos = vec3(0.);

    float randFactor = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), PI);
    radiusThicknessModifier = randFactor * u_radiusThickness ;

    float adjustedRadius = u_radius - (u_radius * radiusThicknessModifier);

    //if sphere
    if (u_shape == 1.) {
      startPos = getSphereStartPos( idVertex, adjustedRadius);
    } 
    //if cone
    if (u_shape == 0.) {
      startPos = getConeStartPos( idVertex, adjustedRadius);
    }

    vec3 startDirection;

    // SHAPE 0 === CONE!
    if (u_shape == 0.0) {
      float debug_angle = u_angle;
      float radAngle = debug_angle * (PI / 180.);
      float maxDistancePossible = u_maxSpeed * u_maxAge;
      float circum = 2. * PI * maxDistancePossible * 2.;
      float arcLength = (debug_angle * circum) / 360.;

      if (u_shape == 0.0 && u_coneMode == 1.) {
        fillRandom = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), PI);
      }

      float coneEndRadius =
        ((2. *
          maxDistancePossible *
          sin(arcLength / (2. * maxDistancePossible))) /
          2.) * fillRandom +
        adjustedRadius ;

      float coneHeight = cos(radAngle) * maxDistancePossible;

      float x2 = 0.;
      float y2 = 0.;
      float z2 = 0.;

      //cone with fill
      if (u_shape == 0.0 && u_coneMode == 1.) {
        x2 = cos(theta) * coneEndRadius;
        z2 = sin(theta) * coneEndRadius;
      }else{
        x2 = cos(theta) * coneEndRadius;
        z2 = sin(theta) * coneEndRadius;
      }

      vec3 test = vec3(x2,y2,z2) ;
      vec3 topPos = vec3(test.x , coneHeight, test.z);

      startDirection = normalize(topPos - startPos);
    } else {
      //else sphere

      vec3 fromCenter = startPos;
      float fromCenterLength = length(fromCenter);
      //normalise
      startDirection = fromCenter / fromCenterLength;
    }
    //velocity at spawn, set normalised direction length to a random velocity between min / max
    //because it's used for initial direction, minSpeed can't be == 0 so min u_minSpeed = 0.0001
    if(u_system == 0.){
      //if bezier driven
      v_velocity = startDirection * 0.0001;
    }else{
      v_velocity = startDirection * (u_minSpeed + (u_maxSpeed - u_minSpeed) * idVertexConstRandVel);
    }


    // tracking player position
    if (length(u_parentPosition) > 0.) {
      startPos += u_parentPosition;
    }

    /* Return the particle to origin. */
    v_offset = startPos;
    #ifdef USE_MATRICE
        v_rotation = a_rotation;
        v_scale = a_scale;
    #endif

    /* It's new, so age must be set accordingly.*/
    if(u_respawnMode == 1.){
      //after repeat onRepeat

      float birthDuration = (1./u_birthRate) - 1.;//start with x pct at 0 then x pct spawn per second, 1. represent the first simulated second - the total time it would have required to reach 100%
      float maxDuration = birthDuration + u_maxAge + u_repeatDelay;
      float modRepeat = mod(u_totalDelta,maxDuration );
      // float birthPerS = u_maxParticles * u_birthRate;
      // float birthAtTime = u_maxParticles * u_birthRate*modRepeat;
      float pctBirthAtTime = 1.;
      if(birthDuration > 0.){
        pctBirthAtTime = u_birthRate + modRepeat/birthDuration;
      }
      // float spawnAt = idVertexConstRandBirthPct * u_maxParticles * u_birthRate;
      float curLoop = floor(u_totalDelta/maxDuration);
      if(idVertexConstRandBirthPct < pctBirthAtTime && a_loopCnt <= curLoop && ( u_repeatCount == -1. || curLoop <= u_repeatCount ) ){
        v_age = 0.0;
        v_life = a_life;
        v_loopCnt = a_loopCnt + 1.;
      }else{
        v_age = 999999999.;
        v_life = a_life;
        v_loopCnt = a_loopCnt;
      }
    }else if(u_respawnMode == 0.){
      //after die onDie
      v_age = 0.0;
      v_life = a_life;
      v_loopCnt = a_loopCnt + 1.;
    }else{
      //no more respawn
      v_age = 999999999.;
      v_life = a_life;
      v_loopCnt = a_loopCnt;
    }
    v_overvelocity = length(u_playerVelo) * u_delta * .1;

  } else {
    v_overvelocity = a_overvelocity + length(u_playerVelo) * u_delta * .3;

    //Update particle force, velocity, age etc
    
    //todo this is a constant force per particle, this could be stored in a bufferAttribute like a_life, but maybe better to avoid too much bufferAttributes ? 
    float particleForce = u_minForce + (u_maxForce - u_minForce) * idVertexConstRandForce;

    //if bezier driven
    if(u_system == 0.){
      //for bezier, we need to recalculate the start position of the particle on each pass and then add the bezier controlled direction progress
      float randFactor = gold_noise(vec2(idVertex * 0.3482f, idVertex * 2.18622f), PI);
      radiusThicknessModifier = randFactor * u_radiusThickness ;
      float adjustedRadius = u_radius - (u_radius * radiusThicknessModifier);
      vec3 startPosition = vec3(0.);
      //if sphere
      if (u_shape == 1.) {
        startPosition = getSphereStartPos( idVertex, adjustedRadius);
      } 
      //if cone
      if (u_shape == 0.) {
        startPosition = getConeStartPos( idVertex, adjustedRadius);
      }
      vec3 direction = normalize(a_velocity);
      vec3 velModifier = direction * particleForce * cubic_bezier(vec2(0.),vec2(u_forceBezier.x,u_forceBezier.y),vec2(u_forceBezier.z,u_forceBezier.w),vec2(1.), a_age/u_forceRampDuration);

      v_velocity = a_velocity;

      if (length(u_parentPosition) > 0.) {
        startPosition += u_parentPosition;
      }

      v_offset = u_origin + startPosition + velModifier;
      
    //end if bezier driven//
    }else{
    //else physic or dynamic physic driven//

      vec3 accel = vec3(0.);
      if (u_system == 1.) {
        // Physic Driven constant force
        //the force is like the one of a rocket, it will push in the current direction the particle is going
        accel = normalize(a_velocity) * particleForce;
      }else{
        // Dynamic Physic Driven force will vary over time
        accel = normalize(a_velocity) * particleForce * cubic_bezier(vec2(0.),vec2(u_forceBezier.x,u_forceBezier.y),vec2(u_forceBezier.z,u_forceBezier.w),vec2(1.), a_age/u_maxAge);
      }
      vec3 repulseFromPlayer = vec3(0.);
      
      vec3 velocity = a_velocity;
      velocity -= velocity * u_friction * u_delta;
      vec3 offset = a_offset;

      //need check for upcoming collision
      if (length(u_playerPos) > 0. ){                

        //todo line size 
        float capsuleRadius = 2.;
        vec4 pointAndDistance = closest_point_and_distance(a_offset, vec3(u_playerPos-u_playerUp),vec3(u_playerPos+u_playerUp));
        float distanceToPlayerLine = pointAndDistance.w;
        //if detect collision 
        if ( distanceToPlayerLine < capsuleRadius) {

          if(u_hideOnTouch == 1.){
            age = 9999999.;
          }

          vec3 closestPointOnSegment = pointAndDistance.xyz;
          float depth = capsuleRadius - distanceToPlayerLine;
          vec3 collisionDirection = a_offset - closestPointOnSegment;
          collisionDirection = normalize(collisionDirection);
          
          vec3 normal = normalize(a_offset - u_playerPos.xyz);
    
          velocity = reflect(velocity, normal) + collisionDirection * depth + u_playerVeloReflect * u_delta * 20.;
          // velocity = reflect(velocity, normal) * u_bounciness + collisionDirection * depth;
          // v_velocity = vec3(0.,-100.,0.);
          // v_velocity = collisionDirection * depth;
          offset = a_offset + collisionDirection * depth;
          // v_offset = a_offset + v_velocity * u_delta ;
        }
      }

      //update velocity with external forces
      v_velocity = velocity + accel * u_delta + u_gravity * u_delta;
      v_offset = offset + v_velocity * u_delta;

      #ifdef USE_MATRICE
        vec3 rotation = a_rotation;
        if (u_rotationEnabled > 0.) {
          rotation += 360. * u_forceRotation * u_delta * rand(idVertex);
        } else {
          rotation = u_rotationStart;
        }
        v_rotation = rotation;

        vec3 scale = a_scale;
        if (u_scaleEnabled > 0. && age + u_delta < a_life) {
          scale = mix(u_scaleStart, u_scaleEnd, age / a_life);
        } else {
          scale = u_scaleStart;
        }
        v_scale = scale;
      #endif
    //end physic driven//
    }


    //increment age
    v_age = age + u_delta;
    v_life = a_life;
    v_loopCnt = a_loopCnt;
  }
}
`;
const gr = { uniforms: { u_system: { value: 0 }, u_delta: { value: 0 }, u_totalDelta: { value: 0 }, u_shape: { value: 0 }, u_forceRampDuration: { value: 0 }, u_minForce: { value: 0 }, u_maxForce: { value: 0 }, u_friction: { value: 0 }, u_forceBezier: { value: new n.Vector4(0, 0, 1, 1) }, u_mode: { value: 0 }, u_respawnMode: { value: 0 }, u_maxParticles: { value: 0 }, u_birthRate: { value: 0 }, u_repeatDelay: { value: 0 }, u_repeatCount: { value: 0 }, u_hideOnTouch: { value: 0 }, u_bounciness: { value: 0 }, u_coneMode: { value: 0 }, u_noise: { value: null }, u_gravity: { value: new n.Vector3(0, 0, 0) }, u_origin: { value: new n.Vector3(0, 0, 0) }, u_playerPos: { value: new n.Vector3(0, 0, 0) }, u_playerUp: { value: new n.Vector3(0, 0, 0) }, u_parentPosition: { value: new n.Vector3(0, 0, 0) }, u_playerVelo: { value: new n.Vector3(0, 0, 0) }, u_playerVeloReflect: { value: new n.Vector3(0, 0, 0) }, u_scaleEnabled: { value: 0 }, u_scaleStart: { value: new n.Vector3(0, 0, 0) }, u_scaleEnd: { value: new n.Vector3(0, 0, 0) }, u_rotationEnabled: { value: 0 }, u_rotationStart: { value: new n.Vector3(0, 0, 0) }, u_forceRotation: { value: new n.Vector3(1, 1, 1) }, u_radius: { value: 0 }, u_radiusThickness: { value: 0 }, u_angle: { value: 0 }, u_minSpeed: { value: 0 }, u_maxSpeed: { value: 0 }, u_maxAge: { value: 0 } }, glslVersion: n.GLSL3, vertexShader: Qu, fragmentShader: `
  void main() {
  }
  ` }, Yu = () => {
  const { shape: e, radius: t, angle: a, maxSpeed: i, maxAge: r, position: l, rotation: s, scale: o, debug: f } = /* @__PURE__ */ Ke(Gt), [d, c] = /* @__PURE__ */ ve(null), [u, m] = /* @__PURE__ */ ve(null), p = i * r;
  G(() => {
    d && (u && (u.geometry.center(), u.geometry.computeBoundingBox(), u.position.y = x + (u.geometry.boundingBox.max.y - u.geometry.boundingBox.min.y) / 2), d.traverse((b) => {
      b.updateMatrix(), b.updateWorldMatrix(true, true);
    }));
  });
  const g = /* @__PURE__ */ n.MathUtils.degToRad(a), h = 2 * Math.PI * p * 2, C = a * h / 360, _ = 2 * p * Math.sin(C / (2 * p)) / 2 + t, x = Math.cos(g) * p;
  return f ? y("group", { ref: c, position: l, scale: o, rotation: s, children: e === "cone" ? H(te, { children: [H("lineSegments", { position: [0, x, 0], children: [y("edgesGeometry", { args: [new n.CircleGeometry(_, 32)], onUpdate: (b) => b.rotateX(Math.PI / 2) }), y("lineBasicMaterial", { color: "red" })] }), H("lineSegments", { position: [0, 0, 0], children: [y("edgesGeometry", { args: [new n.CircleGeometry(t, 32)], onUpdate: (b) => b.rotateX(Math.PI / 2) }), y("lineBasicMaterial", { color: "red" })] })] }) : y(te, { children: H("lineSegments", { children: [y("edgesGeometry", { args: [new n.SphereGeometry(t, 48, 6), 29] }), y("lineBasicMaterial", { color: "red" })] }) }) }) : null;
}, pr = /* @__PURE__ */ Z(({ useGeometry: e, children: t, ...a }, i) => e ? y("mesh", { ref: i, ...a, children: t }) : y("points", { ref: i, ...a, children: t }));
pr.displayName = "ParticleBalancer", N({ WebGLTransformFeedback: Hi });
const qu = new n.Quaternion(), hr = new n.Vector3(), _r = new n.Vector3(), xr = new n.Vector3();
let _i = false;
const xi = 4, Gt = /* @__PURE__ */ Fa(null), Xu = /* @__PURE__ */ Z(function({ children: t, graphId: a, ...i }, r) {
  const [l, s] = /* @__PURE__ */ U((B) => [B.gl, B.scene]), [o, f] = /* @__PURE__ */ ve(null), d = /* @__PURE__ */ I();
  ge(r, () => d);
  const c = /* @__PURE__ */ I(0), u = /* @__PURE__ */ I(null), m = /* @__PURE__ */ I(null), p = /* @__PURE__ */ I(false), g = /* @__PURE__ */ I(false), h = /* @__PURE__ */ Ft((B) => B.currentPlayer), C = /* @__PURE__ */ V(() => ({ position: [0, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1], useGeometry: false, startOn: void 0, stopOn: void 0, system: "physicDriven", minAge: 2, maxAge: 6, delay: 0, respawnMode: "onDie", friction: 0, repeatDelay: 0, repeatCount: -1, forceRampDuration: 1, forceBezier: [0, 0, 1, 1], minForce: 0, maxForce: 0, maxParticles: 200, particleBirthRate: 0.1, bounciness: 1, minSpeed: 1, maxSpeed: 2, gravity: [0, -0.1, 0], interactive: true, tracking: false, hideOnTouch: false, shape: "cone", mode: "random", radius: 0.01, radiusThickness: 0.01, angle: 20, coneMode: "fill", rotationEnabled: false, rotationStart: [0, 0, 0], rotationForce: [0.5, 0.5, 0.5], scaleEnabled: false, scaleStart: [1, 1, 1], scaleEnd: [0, 0, 0], playerApi: void 0, grpRef: void 0, debug: false, ...i }), [i]), { position: _, rotation: x, scale: b, useGeometry: w, startOn: P, stopOn: S, system: M, minAge: D, maxAge: T, delay: R, respawnMode: L, friction: k, repeatDelay: E, repeatCount: O, forceRampDuration: J, forceBezier: $, minForce: ne, maxForce: Ue, maxParticles: j, particleBirthRate: F, bounciness: le, minSpeed: Qt, maxSpeed: Ci, gravity: Si, interactive: Pi, tracking: Mi, hideOnTouch: Di, shape: Yt, mode: qt, radius: Ei, radiusThickness: Ti, angle: Ii, coneMode: _t, rotationEnabled: Xt, rotationStart: Ea, rotationForce: Ui, scaleEnabled: Ta, scaleStart: xt, scaleEnd: Ia, playerApi: xe, grpRef: Ge } = C, [Be] = /* @__PURE__ */ V(() => {
    const B = w ? { v_offset: "a_offset", v_rotation: "a_rotation", v_scale: "a_scale", v_velocity: "a_velocity", v_age: "a_age", v_life: "a_life", v_overvelocity: "a_overvelocity", v_loopCnt: "a_loopCnt" } : { v_offset: "a_offset", v_velocity: "a_velocity", v_age: "a_age", v_life: "a_life", v_overvelocity: "a_overvelocity", v_loopCnt: "a_loopCnt" }, Qe = new n.RawShaderMaterial({ ...gr, type: "ParticleTransformFeedbackMaterial", defines: { USE_MATRICE: w, USE_PARTICLE_INSTANCE: w }, transformFeedbackVaryings: B });
    return Qe.uniforms = n.UniformsUtils.clone(gr.uniforms), [Qe];
  }, [w, F, Xt, Ta]);
  return G(() => {
    if (!Be)
      return;
    const B = Be.uniforms;
    B.u_radius.value = Ei, B.u_radiusThickness.value = Ti, B.u_angle.value = Ii, B.u_minSpeed.value = Math.max(Qt, 1e-5), B.u_maxSpeed.value = Math.max(Ci, 1e-5), B.u_maxAge.value = T, B.u_forceRampDuration.value = J, B.u_minForce.value = ne, B.u_maxForce.value = Ue, B.u_friction.value = k, w && (B.u_rotationStart.value = new n.Vector3().fromArray(Ea ? Ea || [0, 0, 0] : [0, 0, 0]), B.u_forceRotation.value = new n.Vector3().fromArray(Xt ? Ui || [0.5, 0.5, 0.5] : [0, 0, 0]), B.u_scaleEnd.value = new n.Vector3().fromArray(Ia ? Ia || [0, 0, 0] : [0, 0, 0]), B.u_scaleStart.value = new n.Vector3().fromArray(xt ? xt || [1, 1, 1] : [1, 1, 1]), B.u_rotationEnabled.value = Xt ? 1 : 0, B.u_scaleEnabled.value = Ta ? 1 : 0), B.u_forceBezier.value = new n.Vector4().fromArray($ || [0, 0, 1, 1]), B.u_shape.value = Yt === "sphere" ? 1 : 0;
    const Qe = { bezierDriven: 0, physicDriven: 1, dynamicPhysicDriven: 2 };
    B.u_system.value = M ? Qe[M] : 0, B.u_mode.value = qt === "loop" ? 1 : 0, B.u_birthRate.value = F, B.u_repeatDelay.value = E, B.u_repeatCount.value = O, p.current ? B.u_respawnMode.value = L === "onRepeat" ? 1 : 0 : B.u_respawnMode.value = -1, B.u_coneMode.value = _t === "fill" ? 1 : 0, B.u_hideOnTouch.value = Di ? 1 : 0, B.u_bounciness.value = le !== void 0 ? le : 1, B.u_maxParticles.value = j;
  }, [Ii, le, _t, $, J, k, Di, Be, T, Ue, j, Ci, ne, Qt, qt, F, Ei, Ti, O, E, L, Xt, Ui, Ea, Ta, Ia, xt, Yt, M, w]), G(() => {
    if (c.current = 0, !Be)
      return;
    const B = Be.uniforms;
    B.u_totalDelta.value = 0;
  }, [Yt, _t, qt, L, j, Be]), G(() => {
    let B;
    return P ? (B = () => {
      clearTimeout(m.current), u.current = setTimeout(() => {
        p.current = true, d.current && (d.current.material.uniforms.u_respawnMode.value = L === "onRepeat" ? 1 : 0), g.current = true;
      }, R * 1e3);
    }, Qi(P, B)) : u.current = setTimeout(() => {
      p.current = true, g.current = true, d.current && (d.current.material.uniforms.u_respawnMode.value = L === "onRepeat" ? 1 : 0);
    }, R * 1e3), () => {
      B && Yi(P, B);
    };
  }, [P, L, R]), G(() => {
    let B;
    return S && (B = () => {
      clearTimeout(u.current), p.current = false, d.current && (d.current.material.uniforms.u_respawnMode.value = -1), m.current = setTimeout(() => {
        g.current = false, ae(`resetParticle${a}`);
      }, T * 1e3);
    }, Qi(S, B)), () => {
      B && Yi(S, B);
    };
  }, [S, T, a]), q(function(Qe) {
    if (!_i && xe?.entity && Ge && Ge.position && h) {
      const ke = h.userData?.player;
      hr.copy(Ge.position).addScaledVector(ke?.upVector, ke?.modelHeight / 2), _r.copy(ke?.upVector), xr.set(xe.localVelocityx, xe.localVelocityy, xe.localVelocityz).applyMatrix4(Ge.matrixWorld), _i = true;
    }
  }, xi - 0.1), q(function(Qe, ke) {
    const fe = d.current;
    if (fe) {
      g.current ? (fe.material.uniforms.u_delta.value = ke > 1 ? 0 : ke, fe.material.uniforms.u_totalDelta.value += ke > 1 ? 0 : ke, fe.material.uniforms.u_origin.value.copy(o.position), xe?.entity && Ge && Pi ? (fe.material.uniforms.u_playerPos.value.copy(hr).applyMatrix4(o.matrixWorldInverse), fe.material.uniforms.u_playerUp.value.copy(_r).applyQuaternion(o.quaternionInverse)) : fe.material.uniforms.u_playerPos.value.set(0, 0, 0), Mi && xe?.entity && Ge && Ge.position ? (fe.material.uniforms.u_parentPosition.value.copy(Ge.position), fe.material.uniforms.u_playerVelo.value.set(xe.localVelocityx, xe.localVelocityy, xe.localVelocityz)) : fe.material.uniforms.u_parentPosition.value.set(0, 0, 0), Mi || Pi && xe ? (fe.material.uniforms.u_playerVelo.value.set(xe.localVelocityx, xe.localVelocityy, xe.localVelocityz), fe.material.uniforms.u_playerVeloReflect.value.copy(xr).applyMatrix4(o.matrixWorldInverse)) : fe.material.uniforms.u_playerVeloReflect.value.set(0, 0, 0), c.current < j && (c.current = Math.min(j, c.current + j * F * ke))) : (c.current = 0, fe.material.uniforms.u_totalDelta.value = 0);
      const Kt = /* @__PURE__ */ Math.min(j, Math.floor(c.current));
      w ? o.count = Kt : (o.geometry.drawRange.count = Kt, fe.source.drawRange.count = Kt, fe.target.drawRange.count = Kt), fe.source && fe.tick();
    }
  }, xi), q(function(Qe) {
    _i = false;
  }, xi + 0.1), G(() => {
    c.current = 0, Be.uniforms.u_totalDelta.value = 0;
  }, [w, Yt, _t, qt, D, T, j, xt, Be]), ie(() => {
    const B = d.current;
    B && B.material && B.material.uniforms.u_gravity.value.fromArray?.(Si).applyQuaternion(qu.copy(o.quaternion).invert());
  }, [d, o, Si]), H(Gt.Provider, { value: C, children: [y(Yu, {}), H(de, { fallback: null, children: [o ? y("webGLTransformFeedback", { ref: d, args: [Be, o, l, s, j] }, `${w}-${_t}-${D}-${T}-${xt}-${a}`) : null, y(pr, { count: 0, useGeometry: w, ref: f, position: _, frustumCulled: false, scale: b, rotation: x, isTransformFeedbackInstance: !!w, isTransformFeedback: !w, matrixWorldInverse: new n.Matrix4(), quaternionInverse: new n.Quaternion(), onUpdate: (B) => {
    B.updateMatrix(), B.matrixWorld.copy(B.matrix), B.matrixWorldInverse.copy(B.matrix).invert(), B.quaternionInverse.copy(B.quaternion).invert(), B.matrixWorldNeedsUpdate = false;
  }, children: t }, j + D + T + w)] })] });
}), Ku = ({ reset: e }) => {
  const { maxParticles: t = 200, scaleEnabled: a = false, scaleStart: i = [1, 1, 1], rotationEnabled: r = false, rotationStart: l = [0, 0, 0], minAge: s = 2, maxAge: o = 6, respawnMode: f = "onDie" } = /* @__PURE__ */ Ke(Gt), d = 16, c = /* @__PURE__ */ V(() => {
    const u = new Float32Array(t * d);
    for (let p = 0; p < t * d; p += d) {
      const g = /* @__PURE__ */ Number(Math.random()), h = Math.random() * Math.PI * 2, C = Math.random() * Math.PI * 2;
      u[p + 0] = g * Math.sin(h) * Math.cos(C), u[p + 1] = g * Math.sin(h) * Math.sin(C), u[p + 2] = g * Math.cos(h), u[p + 3] = l[0], u[p + 4] = l[1], u[p + 5] = l[2], u[p + 6] = i[0], u[p + 7] = i[1], u[p + 8] = i[2];
      const _ = s + Math.random() * (o - s);
      u[p + 12] = f === "onDie" ? _ : 99999;
      const x = s + Math.random() * (o - s);
      u[p + 13] = x, u[p + 14] = 0, u[p + 15] = 0;
    }
    return new n.InstancedInterleavedBuffer(u, d, 1);
  }, [s, o, t, r, l, a, i, e, f]);
  return H(te, { children: [y("interleavedBufferAttribute", { attach: "attributes-a_offset", data: c, itemSize: 3, offset: 0, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_rotation", data: c, itemSize: 3, offset: 3, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_scale", data: c, itemSize: 3, offset: 6, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_velocity", data: c, itemSize: 3, offset: 9, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_age", data: c, itemSize: 1, offset: 12, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_life", data: c, itemSize: 1, offset: 13, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_overvelocity", data: c, itemSize: 1, offset: 14, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_loopCnt", data: c, itemSize: 1, offset: 15 })] });
}, Zu = ({ reset: e }) => {
  const { maxParticles: t, minAge: a, maxAge: i, respawnMode: r } = /* @__PURE__ */ Ke(Gt), l = 10, s = /* @__PURE__ */ V(() => {
    const o = new Float32Array(t * l);
    for (let d = 0; d < t * l; d += l) {
      const c = /* @__PURE__ */ Number(Math.random()), u = Math.random() * Math.PI * 2, m = Math.random() * Math.PI * 2;
      o[d + 0] = c * Math.sin(u) * Math.cos(m), o[d + 1] = c * Math.sin(u) * Math.sin(m), o[d + 2] = c * Math.cos(u);
      const p = a + Math.random() * (i - a);
      o[d + 6] = r === "onDie" ? p : 99999;
      const g = a + Math.random() * (i - a);
      o[d + 7] = g, o[d + 8] = 0, o[d + 9] = 0;
    }
    return new n.InterleavedBuffer(o, l);
  }, [a, i, t, e, r]);
  return H(te, { children: [y("interleavedBufferAttribute", { attach: "attributes-a_offset", data: s, itemSize: 3, offset: 0, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_velocity", data: s, itemSize: 3, offset: 3, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_age", data: s, itemSize: 1, offset: 6, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_life", data: s, itemSize: 1, offset: 7, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_overvelocity", data: s, itemSize: 1, offset: 8, usage: n.DynamicCopyUsage }), y("interleavedBufferAttribute", { attach: "attributes-a_loopCnt", data: s, itemSize: 1, offset: 9, usage: n.DynamicCopyUsage })] });
}, Ju = { uniforms: { shadowMap: { value: null }, opacity: { value: 1 } }, vertexShader: `

    #include <shadows_pars_vertex>
		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

      vec4 worldPosition = vec4( position, 1.0 );

      worldPosition = modelMatrix * worldPosition;
    
      #include <shadows_vertex>
		}`, fragmentShader: `

		uniform float opacity;

		varying vec2 vUv;
    uniform highp sampler2D shadowMap;

		#include <packing>

		void main() {
      // webgl2 decode shadow
      vec4 shadowCoordinate = vec4(vUv, 1.0, 1.0);

      // float depth = textureProj(shadowMap, shadowCoordinate);
			float depth = 1.0 - unpackRGBAToDepth( texture2D( shadowMap, vUv ) );

      // if (unpackRGBAToDepth( texture2D( shadowMap, vUv ) ) > .5) discard;
      gl_FragColor = vec4(mix(vec3(depth), texture2D( shadowMap, vUv ).rgb, .0), 1.0);
		}` }, $u = ({ fboDiffuseRef: e, position: t = [10, 10], size: a = [256, 256] }) => {
  const i = /* @__PURE__ */ U((u) => u.gl), r = /* @__PURE__ */ U((u) => u.size), l = i.autoClear, s = /* @__PURE__ */ Y((u) => u.paused), o = /* @__PURE__ */ Ie((u) => u.shadowMapData), [f, d, c] = /* @__PURE__ */ V(() => {
    const u = new Vi(r.width / -2, r.width / 2, r.height / 2, r.height / -2, 1, 10);
    u.position.set(0, 0, 2);
    const m = new Jt(), p = Ju, g = /* @__PURE__ */ Wi.clone(p.uniforms), h = new Re({ uniforms: g, vertexShader: p.vertexShader, fragmentShader: p.fragmentShader, uniformsGroups: [o], defines: { USE_SHADOWS: true } }), C = new ji(a[0], a[1]), _ = new ka(C, h);
    return _.frustumCulled = false, m.add(_), [u, m, g];
  }, [a, t]);
  return q(() => {
    s || e.current && (f.left = r.width / -2, f.right = r.width / 2, f.top = r.height / 2, f.bottom = r.height / -2, f.updateMatrix(), f.updateMatrixWorld(true), f.updateProjectionMatrix(), d.children[0].position.set(-r.width / 2 + a[0] / 2 + t[0], r.height / 2 - a[1] / 2 - t[1], 0), d.children[0].updateMatrix(), d.children[0].updateMatrixWorld(true), c.shadowMap.value = e.current, i.setRenderTarget(null), i.autoClear = false, i.render(d, f), i.autoClear = l);
  }, 10001), null;
}, Ht = /* @__PURE__ */ new Map(), Vt = /* @__PURE__ */ new Map(), em = /* @__PURE__ */ W({}, `
  #include <common>
  #include <uv_pars_vertex>
  #include <displacementmap_pars_vertex>
  #include <morphtarget_pars_vertex>
  #include <batching_pars_vertex>
  #include <batching_skinning_pars_vertex>
  #include <logdepthbuf_pars_vertex>
  #include <clipping_planes_pars_vertex>

  out vec2 vHighPrecisionZW;

  void main() {

  #include <uv_vertex>

  #include <skinbase_vertex>

  #ifdef USE_DISPLACEMENTMAP

  #include <beginnormal_vertex>
  #include <morphnormal_vertex>
  #include <skinnormal_vertex>

  #endif

  #include <begin_vertex>
  #include <batchingbase_vertex>
  #include <morphtarget_vertex>

  #include <displacementmap_vertex>
  vec4 mvPosition = vec4( transformed, 1.0 );

#ifdef USE_BATCHING
mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING

mvPosition = instanceMatrix * mvPosition;

#endif

mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;


  #include <logdepthbuf_vertex>
  #include <clipping_planes_vertex>

  vHighPrecisionZW = gl_Position.zw;
}`, `

#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

in vec2 vHighPrecisionZW;

void main() {
  vec4 diffuseColor = vec4( 1.0 );

  #include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>

	// #include <logdepthbuf_fragment>

	// Higher precision equivalent of gl_FragCoord.z. This assumes depthRange has been left to its default values.
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;

	// #if DEPTH_PACKING == 3200

	// 	gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );

	// #elif DEPTH_PACKING == 3201
  gl_FragColor = packDepthToRGBA( fragCoordZ );

	// #endif

}`), yr = /* @__PURE__ */ Z(({ debug: e = false, mapSize: t = [2048, 2048], zoom: a = 1, frustumSize: i = 250, bias: r = 15e-4, shadowIntensity: l = 0.2, shadowColor: s = new n.Color("#011f3b"), ...o }, f) => {
  const [d, c] = /* @__PURE__ */ Ie((w) => [w.commonUbo, w.shadowMapData]), u = /* @__PURE__ */ Y((w) => w.paused), m = /* @__PURE__ */ I(), p = /* @__PURE__ */ I();
  ge(f, () => m.current);
  const g = /* @__PURE__ */ I(null), h = /* @__PURE__ */ V(() => new n.Scene(), []), C = /* @__PURE__ */ U((w) => w.scene), _ = /* @__PURE__ */ U((w) => w.gl), x = /* @__PURE__ */ V(() => new n.Vector3(), []), b = () => {
    if (u)
      return;
    const w = [], P = [], S = [];
    if (C.traverse((k) => {
      if (!k.castShadow || !k.visible)
        return;
      const E = k.material;
      k.isBatchedMesh && !k.isSkinnedMesh && k.userData.instances && k.userData.instances.forEach((O) => {
        const J = O.current;
        if (!J)
          return;
        const $ = J.userData.node;
        !J.castShadow && J.visible ? (k.setVisibilityAt(J.userData.id, false), Ht.has(k) ? Ht.get(k).push(J.userData.id) : Ht.set(k, [J.userData.id])) : $ && $.material && $.hiddenBirdView && $.material.visible !== false && (k.setVisibilityAt(J.userData.id, true), Vt.has(k) ? Vt.get(k).push(J.userData.id) : Vt.set(k, [J.userData.id]));
      }), E && E.side === n.FrontSide && (P.push(E), E.side = n.DoubleSide), k && (k.customDepthMaterial || (k.customDepthMaterial = new em({ alphaTest: E.alphaTest, alphaMap: E.alphaMap, opacity: E.opacity })), w.push(k));
    }), w.length === 0)
      return;
    const { lightData: M } = /* @__PURE__ */ Dt(), D = m.current, T = [d.uniforms[2].value.x < -1e3 ? 0 : d.uniforms[2].value.x, d.uniforms[2].value.y < -1e3 ? 0 : d.uniforms[2].value.y, d.uniforms[2].value.z < -1e3 ? 0 : d.uniforms[2].value.z];
    D.position.fromArray(T), x.copy(M.uniforms[3].value).setLength(100), D.position.add(x), D.lookAt(d.uniforms[2].value.x, d.uniforms[2].value.y, d.uniforms[2].value.z), g.current.position.copy(D.position), g.current.lookAt(d.uniforms[2].value.x, d.uniforms[2].value.y, d.uniforms[2].value.z);
    let R = f?.current?.zoomFactor || 3;
    R === 1 / 0 && (R = 3), g.current.updateMatrix(), g.current.updateMatrixWorld(true), D.zoom = a + R, D.updateMatrix(), D.matrixWorld.copy(D.matrix), D.updateProjectionMatrix(true), C.overrideChildren = w, _.renderShadowMapUbo([g.current], C, D, true);
    const { shadowMap: L } = /* @__PURE__ */ Dt();
    if (g.current.shadow.map && ((!L || L && L.uuid !== g.current.shadow.map.uuid) && Qa({ shadowMap: g.current.shadow.map.depthTexture }), e && g.current.shadow.map.texture.format !== n.RGBAFormat || t[0] !== g.current.shadow.map.width || t[1] !== g.current.shadow.map.height)) {
      g.current.shadow.map.dispose(), g.current.shadow.map = null;
      const k = { type: n.HalfFloatType, minFilter: n.NearestFilter, magFilter: n.NearestFilter, format: n.RGBAFormat, depthBuffer: true, depthTexture: new n.DepthTexture(1, 1) }, E = new n.WebGLRenderTarget(t[0], t[1], k);
      E.depthTexture.type = n.UnsignedShortType, E.depthTexture.minFilter = n.NearestFilter, E.depthTexture.magFilter = n.NearestFilter, E.depthTexture.compareFunction = n.LessEqualCompare, E.depthTexture.width = t[0], E.depthTexture.height = t[1], E.depthTexture.needsUpdate = true, g.current.shadow.map = E, g.current.shadow.mapSize.set(t[0], t[1]), p.current = g.current.shadow.map.texture;
    }
    P.forEach((k) => k.side = n.FrontSide);
    for (let k = 0; k < S.length; k++) {
      const E = S[k];
      E[0].setVisibilityAt(E[1], true);
    }
    Ht.forEach((k, E) => {
      E && k.forEach((O) => {
        E.setVisibilityAt(O, true);
      });
    }), Vt.forEach((k, E) => {
      E && k.forEach((O) => {
        E.setVisibilityAt(O, false);
      });
    }), Ht.clear(), Vt.clear(), C.overrideChildren = void 0, h.children.length = 0;
  };
  return G(() => {
    c.uniforms[2].value = s, c.uniforms[3].value = l, c.uniforms[4].value = r;
  }, [c, s, l, r]), q(() => {
    Dt(), b();
    const w = m.current;
    w && (c.uniforms[0].value.copy(w.projectionMatrix), c.uniforms[1].value.copy(w.matrixWorldInverse));
  }, 0), G(() => () => {
    Qa({ shadowMap: null });
  }, []), H(te, { children: [y("directionalLight", { ref: g, isDirectionalLight: false, isLight: false, "shadow-mapSize-width": t[0], "shadow-mapSize-height": t[1], children: y("orthographicCamera", { attach: "shadow-camera", args: [i / -2, i / 2, i / 2, i / -2, a, i], ...o, ref: m }) }), e ? y($u, { fboDiffuseRef: p }) : null] });
});
yr.displayName = "ShadowMap";
var tm = `#include <layout_pars_fragment>
in vec3 vWorldPosition;
uniform vec3 u_dirt;
uniform vec3 u_grass;
uniform vec3 u_grass2;
uniform sampler2D t_dirt;

uniform float opacity;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>

in float vTranslucencyFactor;
in vec3 vTranslucentColor;
in float vY;

uniform vec2 repeat;

in vec3 vViewPosition;

// snoise
vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec2 mod289(vec2 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec3 permute(vec3 x) {
  return mod289(((x * 34.0) + 1.0) * x);
}
float snoise(vec2 v) {
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i = floor(v + dot(v, C.yy));
  vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod289(i);
  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.0);
  m = m * m;
  m = m * m;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);
  vec3 g;
  g.x = a0.x * x0.x + h.x * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}


float noisyAlpha(float baseAlpha, vec2 uv, float time) {
    float noiseStrength = 2.2; // Adjust this to change the strength of the noise.
    float noise = snoise(uv * 60.0 + vec2(3.0, time * 30.0)); // Scale UV for frequency, and shift with time for animation.
    return baseAlpha + noiseStrength * noise;
}


#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>

#include <shadows_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>

void main() {

  vec3 color = vColor;
  float dirtFactor = 1. - smoothstep(0.0, 1., color.b);
  vec4 diffuseColor =  vec4(mix(u_grass, u_dirt, dirtFactor), 1.);


  vec2 dirtUv = vWorldPosition.xz / 10.;
  diffuseColor.rgb = mix(diffuseColor.rgb, diffuseColor.rgb - .3, saturate((1. - pow(texture( t_dirt, dirtUv).r, 10.))) * dirtFactor);


      // vec2 uv = vMapUv;

  // diffuseColor = vec4(1., 0., 0., 1.);
  // 
  
  #ifdef USE_COLOR
    diffuseColor.rgb = mix(diffuseColor.rgb, u_grass2, color.g);
  #endif

  // map_fragment
  #ifdef USE_MAP
  
    vec4 sampledDiffuseColor = texture2D( map, vMapUv * repeat);
    
    if (vY > .3) {
      diffuseColor.rgb = mix(diffuseColor.rgb, sampledDiffuseColor.rgb, smoothstep(0.3, 1., vY));
    }
  #endif


  // vec2 worldUv = vWorldPosition.xz / 10000.;

  vec3 factTrans = vTranslucentColor * saturate(vTranslucencyFactor) * .2 * getShadowMask();

  diffuseColor.rgb += factTrans;
  // // diffuseColor.a = 1.;
  // // alphamap_fragment


  #ifdef USE_ALPHAMAP
    vec2 uv = vMapUv;
    // #ifndef IS_FLOWER
      // uv.y = 1. - uv.y;
      // uv.y += .1;
    // #endif
    diffuseColor.a *= texture( map, vMapUv * repeat).a;
  #endif
  // // #ifndef USE_DEFERRED
  //   // diffuseColor.a = (diffuseColor.a - .5) / max(fwidth(diffuseColor.a), 0.0001) + 0.5;
    // // #endif
  float modifiedAlphaTest = alphaTest - 0.15; // Adjust this value to control the range of the melt effect


  // #ifdef IS_FLOWER
  //   float alphaGradientMagnitude = length(vec2(dFdx(diffuseColor.a), dFdy(diffuseColor.a)));
  //   float edgeFactor = smoothstep(0.0, 1.0, alphaGradientMagnitude); // Adjust 1.0 to a smaller value to limit the edge width if needed.
  //   float edgeAmplification = 20.0; // Increase or decrease this value to change the amplitude of the noise effect on the edges

  //   float noisyEdgeAlpha = diffuseColor.a + edgeFactor * edgeAmplification * noisyAlpha(modifiedAlphaTest, uv.xy, time);

  //   if (noisyEdgeAlpha < modifiedAlphaTest) {
  //       discard;
  //   }
  // #else 
    diffuseColor.a = (diffuseColor.a - alphaTest) / max(fwidth(diffuseColor.a), 0.0001) + 0.5;
    if (diffuseColor.a < .3) discard;
  // #endif
  diffuseColor = saturate(diffuseColor);
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>


  float toonShading = 0.5;
  // #if defined(USE_TOON)
  //   toonShading = 1.;
  // #endif



  // // color variation player contact
  diffuseColor.rgb += (1. - smoothstep(1., 3., distance(vWorldPosition.xz, playerPos.xz))) * saturate(vY) * .6;

  vec4 o_diffuse = diffuseColor;

  vec4 o_color = vec4(vColor, 1.);
  vec4 o_normal = vec4(normal, toonShading);

  #include <shadows_fragment>

  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif


  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif

  #include <layout_output_fragment>

}
`, am = `#define GRASS

out vec3 vWorldPosition;
#include <common>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <shadowmap_pars_vertex>

#include <common_ubo_pars>

out float vY;
out float vTranslucencyFactor;
out vec3 vTranslucentColor;
out vec3 vViewPosition;
uniform vec3 sunPosition;
mat2 rotate2d(float angle) {
    return mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
}

uniform vec4 frustumPlanes[6];  // Six planes for the frustum: [near, far, left, right, top, bottom]

const float boundingSphereRadius = 1.;  // Adjust based on your actual geometry

#include <shadows_pars_vertex>


void main() {
  #include <uv_vertex>

  mat4 vModel = modelMatrix;
  #ifdef USE_INSTANCING
    vModel = vModel * instanceMatrix;
  #endif

  vec4 viewPosition = viewMatrix * vModel * vec4(position, 1.0);

  #include <color_vertex>
  #include <morphcolor_vertex>

  #include <beginnormal_vertex>
  #include <morphnormal_vertex>
  #include <skinbase_vertex>
  #include <skinnormal_vertex>

  #include <begin_vertex>

  vec3 transformedNormal = objectNormal;

  #ifdef USE_INSTANCING

    // this is in lieu of a per-instance normal-matrix
    // shear transforms in the instance matrix are not supported

    mat3 m = mat3( instanceMatrix );

    transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );

    transformedNormal = m * transformedNormal;

  #endif

  transformedNormal = normalMatrix * transformedNormal;

  #ifdef FLIP_SIDED

    transformedNormal = - transformedNormal;

  #endif

  // normal
  #include <normal_vertex>
  float largeScaleMotion = 0.0;
  float smallScaleMotion = 0.0;

  vY = position.y;
  // billboard non spherical
  // vec3 right = vec3(viewMatrix[0][0], viewMatrix[1][0], viewMatrix[2][0]);
  // vec3 up = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);

  //Get wind data from simplex noise 
  vec4 instancePos = vec4(transformed, 1.);

  #ifdef USE_INSTANCING
    instancePos = instanceMatrix * instancePos;
  #endif

  vec3 windPos = (instancePos.xyz - instancePos.xyz * 0.5) * 2.0;
  vec3 uWind = vec3(1., 2., 0.);
  float windRotation = uWind.x;

  float scaleFactor = 1.;

  float noise = 1.;
  #ifndef IS_FLOWER
    windPos.xz = rotate2d(windRotation) * windPos.xz;

    float offsetFactor = (cos(windPos.z * 0.025) * 25.0 + windPos.x + windPos.y * 2.0 + windPos.z) * uWind.y + time * .75;

    largeScaleMotion = sin(offsetFactor);
    smallScaleMotion = sin(2.65 * (offsetFactor)) * 0.5;

    vec3 wind = vec3(0.);
    wind.z += largeScaleMotion;
    wind.z += smallScaleMotion;
    wind.x += smallScaleMotion;

    wind.xz = rotate2d(windRotation) * wind.xz;
    noise = length(wind) - 0.5;

    // #ifdef USE_COLOR
    //   scaleFactor = (1. - smoothstep(0.9, 1., vColor.b));
    // #endif

    transformed.x += noise * uv.y * scaleFactor;
    transformed.z += noise * uv.y * scaleFactor;
  #else
    transformed.xz += rotate2d(time * 3.5 + float(gl_InstanceID)) * transformed.xz / vec2(4., 3.);
  #endif
  vec4 worldPosition = modelMatrix * vec4(position, 1.0);

  #ifdef USE_INSTANCING
    worldPosition = instanceMatrix * worldPosition;
  #endif

  
  // lighting calculations
  vec3 eye = normalize(worldPosition.xyz - cameraPosition);
  vec3 light = normalize(worldPosition.xyz - sunPosition);
    
  float dp = dot(eye, light);
  float accum = 1.0;
  accum += noise * 0.35;
  transformed.xz = rotate2d(1. - smoothstep(1., 2., distance(worldPosition.xz, playerPos.xz)) * 1.2) * transformed.xz;
  transformed -= (1. - smoothstep(1., 2., distance(worldPosition.xz, playerPos.xz))) * vec3(0., .5, 1.);
  float uTranslucentPower = 4.;
  accum = pow(accum, uTranslucentPower) * 0.8;

  float shiny = 100.;
  #ifdef IS_FLOWER
    shiny = 1.0;
  #endif
  vTranslucentColor = pow(vec3(1.), vec3(2.2));
  vTranslucencyFactor = shiny * smoothstep(.73, 1.1, vY) * accum;


  #include <morphtarget_vertex>
  #include <skinning_vertex>
  #include <displacementmap_vertex>

  vec4 instancePosition;
  vec4 mvPosition = vec4( transformed, 1.0 );
  vec4 mPosition = modelMatrix * mvPosition;
  #ifdef USE_INSTANCING
    instancePosition = instanceMatrix * vec4(0, 0, 0, 1.0);
    mvPosition = instanceMatrix * mvPosition;
    mPosition = modelMatrix * instancePosition;
  #endif

  mvPosition = modelViewMatrix * mvPosition;

  vec4 billboard_center = vec4(instancePosition.x, instancePosition.y, instancePosition.z, 1.0);

  scaleFactor *= smoothstep(100., 200., -mvPosition.z);
  vec2 nowPosition = vec2(transformed.x, transformed.y * (1. - scaleFactor) - (scaleFactor) );

  vec4 billboardoffset = vec4(nowPosition, 0., 0.);
  // reduce billboard .6 factor
  vec4 billboardPosition = mix(mPosition, (modelMatrix * billboard_center + billboardoffset), 0.6);
  worldPosition = billboardPosition;
  vWorldPosition = worldPosition.xyz;

  gl_Position = projectionMatrix * mix(mvPosition, (modelMatrix * viewMatrix * billboard_center + billboardoffset), 0.6);
  vViewPosition = -mvPosition.xyz;
  vColor = color;
  #include <shadowmap_vertex>
  #include <shadows_vertex>
}
`;
const yi = new Float32Array(24);
new n.Matrix4();
const br = new n.Frustum(), im = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), opacity: 1, alphaTest: 0, map: null, frustumPlanes: yi, mapTransform: new n.Matrix3(), alphaMapTransform: new n.Matrix3(), alphaMap: null, tDiffuse: null, tFractal: null, sunPosition: new n.Vector3(100, 100, 0), grassShape: null, u_dirt: new n.Color(10014584), u_grass: new n.Color(16711680), u_grass2: new n.Color(16776960), repeat: new n.Vector2(1, 1), bladeHeight: 1 }, am, tm, null), nm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ GrassShaderImpl: im });
const Sa = /* @__PURE__ */ Z(({ color: e, color2: t, dirt: a, sunPosition: i, ...r }, l) => {
  const [s, o] = /* @__PURE__ */ Ce([ue.moss.dirt, ue.moss.grass01], (c) => {
    c[0].wrapS = c[0].wrapT = n.RepeatWrapping, c[0].colorSpace = n.LinearSRGBColorSpace, c[0].needsUpdate = true, c[1].wrapS = c[1].wrapT = n.RepeatWrapping, c[1].colorSpace = n.LinearSRGBColorSpace, c[1].needsUpdate = true;
  }), f = /* @__PURE__ */ I(null);
  ge(l, () => f.current), _e(f);
  const d = /* @__PURE__ */ se({ useShadows: true }, r.defines);
  return q(({ camera: c }) => {
    br.setFromProjectionMatrix(c.projectionMatrix);
    for (let u = 0; u < 6; u++) {
      const m = br.planes[u];
      yi.set([m.normal.x, m.normal.y, m.normal.z, m.constant], u * 4);
    }
    f.current.uniforms.frustumPlanes.value = yi;
  }, 99999), y("grassShaderImpl", { attach: "material", glslVersion: n.GLSL3, ref: f, map: o, alphaTest: 0.35, side: n.FrontSide, u_grass: e || 9747526, u_grass2: t || 9747526, u_dirt: a || 14474415, t_dirt: s, ...r, ...d, vertexColors: true, sunPosition: new n.Vector3().fromArray(i || [0, 0, 0]) }, nm);
});
Sa.displayName = "GrassShader";
const rm = /* @__PURE__ */ function() {
  const e = new Eo(), t = new pe();
  new pe();
  function a(i) {
    if (!i.isBufferGeometry || i.attributes.position.itemSize !== 3)
      throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
    i.index && (console.warn("THREE.MeshSurfaceSampler: Converting geometry to non-indexed BufferGeometry."), i = i.toNonIndexed()), this.geometry = i, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.colorAttribute = this.geometry.getAttribute("color"), this.weightAttribute = null, this.distribution = null, this.channel = "rgb";
  }
  return a.prototype = { constructor: a, setWeightAttribute(i) {
    return this.weightAttribute = i ? this.geometry.getAttribute(i) : null, this;
  }, setChannel(i) {
    return ["r", "g", "b", "rgb"].includes(i) ? this.channel = i : (console.warn("Invalid channel specified. Defaulting to 'rgb'."), this.channel = "rgb"), this;
  }, build() {
    const i = this.positionAttribute, r = this.weightAttribute, l = new Float32Array(i.count / 3);
    for (let o = 0; o < i.count; o += 3) {
      let f = 1;
      if (r)
        switch (this.channel) {
          case "r":
            f = r.getX(o);
            break;
          case "g":
            f = r.getY(o);
            break;
          case "b":
            f = r.getZ(o);
            break;
          default:
            f = (r.getX(o) + r.getY(o) + r.getZ(o)) / 3;
            break;
        }
      e.a.fromBufferAttribute(i, o), e.b.fromBufferAttribute(i, o + 1), e.c.fromBufferAttribute(i, o + 2), f *= e.getArea(), l[o / 3] = f;
    }
    this.distribution = new Float32Array(i.count / 3);
    let s = 0;
    for (let o = 0; o < l.length; o++)
      s += l[o], this.distribution[o] = s;
    return this;
  }, setRandomGenerator(i) {
    return this.randomFunction = i, this;
  }, sample(i, r, l, s) {
    const o = this.distribution[this.distribution.length - 1], f = /* @__PURE__ */ this.binarySearch(this.randomFunction() * o);
    return this.sampleFace(f, i, r, l, s);
  }, binarySearch(i) {
    const r = this.distribution;
    let l = 0, s = r.length - 1, o = -1;
    for (; l <= s; ) {
      const f = /* @__PURE__ */ Math.ceil((l + s) / 2);
      if (f === 0 || r[f - 1] <= i && r[f] > i) {
        o = f;
        break;
      } else
        i < r[f] ? s = f - 1 : l = f + 1;
    }
    return o;
  }, sampleFace(i, r, l, s, o) {
    let f = this.randomFunction(), d = this.randomFunction();
    if (f + d > 1 && (f = 1 - f, d = 1 - d), e.a.fromBufferAttribute(this.positionAttribute, i * 3), e.b.fromBufferAttribute(this.positionAttribute, i * 3 + 1), e.c.fromBufferAttribute(this.positionAttribute, i * 3 + 2), r.set(0, 0, 0).addScaledVector(e.a, f).addScaledVector(e.b, d).addScaledVector(e.c, 1 - (f + d)), l !== void 0 && e.getNormal(l), s !== void 0 && this.colorAttribute !== void 0) {
      const c = o ? this.geometry.getAttribute(o) : this.colorAttribute;
      e.a.fromBufferAttribute(c, i * 3), e.b.fromBufferAttribute(c, i * 3 + 1), e.c.fromBufferAttribute(c, i * 3 + 2), t.set(0, 0, 0).addScaledVector(e.a, f).addScaledVector(e.b, d).addScaledVector(e.c, 1 - (f + d)), s.r = t.x, s.g = t.y, s.b = t.z;
    }
    return this;
  } }, a;
}(), wr = /* @__PURE__ */ A.forwardRef(({ children: e, callback: t, weight: a, channel: i, transform: r, instances: l, geometry: s, ...o }, f) => {
  const d = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(f, () => d.current);
  const c = /* @__PURE__ */ A.useRef(null), u = /* @__PURE__ */ A.useRef(null);
  return A.useEffect(() => {
    c.current = d.current.children.find((m) => m.hasOwnProperty("instanceMatrix")), u.current = s;
  }, [e, s, l]), A.useEffect(() => {
    if (typeof u.current > "u" || typeof c.current > "u")
      return;
    if (d.current && !d.current.bake) {
      let _ = function(x, b) {
        const w = /* @__PURE__ */ document.createElement("a");
        document.body.appendChild(w), w.style.display = "none";
        const P = new Blob([x.buffer]), S = /* @__PURE__ */ window.URL.createObjectURL(P);
        w.href = S, w.download = b, w.click(), window.URL.revokeObjectURL(S);
      };
      d.current.bake = (x) => {
        _(c.current.instanceMatrix.array, `${x}.bin` || "bake.bin"), c.current.geometry.attributes.color && _(c.current.geometry.attributes.color.array, `${x}_color.bin` || "bake_color.bin");
      };
    }
    const m = new rm(u.current);
    a && m.setWeightAttribute(a), i && m.setChannel(i), m.build();
    const p = new pe(), g = new pe(), h = new Zt(), C = new To();
    for (let _ = 0; _ < c.current.count; _++)
      m.sample(p, g, h), typeof r == "function" ? r({ dummy: C, instancedMesh: c.current, position: p, normal: g, color: h }, _) : C.position.copy(p), C.updateMatrix(), c.current.setMatrixAt(_, C.matrix);
    c.current.instanceMatrix.needsUpdate = true, t && t(c.current);
  }, [e, s, l, a, r, t]), y("group", { ref: d, ...o, children: e });
});
wr.displayName = "SamplerImpl";
const Ar = /* @__PURE__ */ A.forwardRef(({ children: e, callback: t, baked: a, bakedColor: i, instances: r, ...l }, s) => {
  const o = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(s, () => o.current);
  const f = /* @__PURE__ */ A.useRef(null);
  A.useEffect(() => {
    f.current = r?.current ?? o.current.children.find((u) => u.hasOwnProperty("instanceMatrix"));
  }, [e, r]);
  const d = /* @__PURE__ */ Se(async () => fetch(a).then((u) => u.arrayBuffer()), [`position_${a}`, a]), c = i ? Se(async () => fetch(i).then((u) => u.arrayBuffer()), [`color_${i}`, i]) : null;
  return A.useEffect(() => {
    if (!(typeof f.current > "u")) {
      if (d === null) {
        console.error("An error has been encountered while loading", a);
        return;
      }
      try {
        f.current.instanceMatrix.array = new Float32Array(d), f.current.instanceMatrix.needsUpdate = true;
      } catch (u) {
        console.error(u);
      }
      if (t && t(f.current), !!i) {
        if (c === null) {
          console.error("An error has been encountered while loading", i);
          return;
        }
        f.current.geometry.attributes.color = new Io(new Float32Array(c), 3), f.current.geometry.attributes.color.needsUpdate = true;
      }
    }
  }, [e, r, d, c, a, i, t]), y("group", { ref: o, ...l, children: e });
});
Ar.displayName = "SamplerBaked";
const Cr = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => typeof t.baked > "u" ? y(wr, { ref: a, ...t, children: e }) : y(A.Suspense, { fallback: e, children: y(Ar, { ref: a, ...t, children: e }) }));
Cr.displayName = "Sampler";
function Sr(e) {
  return Math.max(Math.min(e, 1), 0);
}
const om = new n.Vector3(0, 1, 0), sm = new n.Color();
function lm({ geometry: e, path: t = "sprite3.ktx2", count: a, channel: i, nameGlb: r, isFlower: l, ...s }) {
  const o = /* @__PURE__ */ Ce(v[`/img/ktx/grass/${t}`], (u) => {
    u.wrapS = u.wrapT = n.RepeatWrapping, u.flipY = true, u.anisotropy = 4, u.colorSpace = n.LinearSRGBColorSpace, u.needsUpdate = true;
  });
  let f = a * 5;
  const d = /* @__PURE__ */ I(null), [c] = /* @__PURE__ */ ve(() => Float32Array.from(new Array(f).fill().flatMap((u, m) => sm.toArray())));
  return y(Cr, { ref: d, channel: i, weight: "color", transform: ({ position: u, normal: m, color: p, dummy: g, instancedMesh: h }, C) => {
    if (g.position.copy(u), l) {
      const _ = /* @__PURE__ */ n.MathUtils.randFloat(0.5, 2);
      g.scale.setScalar(_);
    } else
      g.scale.x = Math.random() * Sr(p.b), g.scale.y = n.MathUtils.randFloat(0.5, 1.1) * Sr(p.b), g.position.y += g.scale.y * 1;
    return g.lookAt(m.add(g.position).sub(om)), g.rotateY(Math.random() * Math.PI), p.toArray(c, C * 3), h.geometry && h.geometry.attributes.color && (h.geometry.attributes.color.needsUpdate = true), g;
  }, geometry: e, children: o ? y(de, { fallback: null, children: y(cm, { isFlowers: l, instances: f, colorArray: c, nameGlb: r, grass: o, ...s }) }) : null });
}
const fm = ({ nameGlb: e, colorArray: t, ...a }) => {
  const { scene: i } = /* @__PURE__ */ ga(v[`/glb/${e}.glb`], true, false), r = i.children[0];
  return r.material.alphaMap = r.material.map, r.material.alphaTest = 0.5, H(te, { children: [y("primitive", { object: r.geometry, ...a, children: y("instancedBufferAttribute", { attach: "attributes-color", args: [t, 3] }) }), y(Sa, { repeat: [1, 1], vertexColors: true, alphaMap: r.material.map, alphaTest: r.material.alphaTest, map: r.material.map, side: n.DoubleSide, defines: { IS_FLOWER: true }, dirt: a.dirt, color: a.color, color2: a.color2 })] });
}, cm = ({ instances: e, colorArray: t, grass: a, nameGlb: i, isFlower: r, ...l }) => y("instancedMesh", { args: [null, null, e], receiveShadow: true, castShadow: false, frustumCulled: false, children: i ? y(de, { fallback: H(te, { children: [y("planeGeometry", {}), y("rawShaderMaterial", { visible: false })] }), children: y(fm, { nameGlb: i, colorArray: t, dirt: l.dirt, color: l.color, color2: l.color2 }) }) : H(te, { children: [y("planeGeometry", { args: [3, 1], children: y("instancedBufferAttribute", { attach: "attributes-color", args: [t, 3] }) }), y(de, { fallback: y("rawShaderMaterial", { visible: false }), children: y(Sa, { repeat: [1.5, 0.98], map: a, alphaMap: a, vertexColors: true, side: n.FrontSide, defines: { IS_FLOWER: false }, dirt: l.dirt, color: l.color, color2: l.color2 }) })] }) }), dm = (e) => y(de, { fallback: null, children: y(lm, { ...e }) }), um = `

out vec3 vWorldPosition;
out vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	out vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	out vec2 vUvBatch;
#endif

in float _tint;
out float vTint;

#include <common>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>

#ifdef USE_BATCH_MAPS

  out float vTextureId;

#endif

out vec3 vViewPosition;

#ifdef USE_BATCH_NORMALMAPS

  out float vNormalTextureId;

#endif

#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float _uvscale;
  out float vUv2;

#endif


#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

#include <shadowmap_pars_vertex>



#include <shadows_pars_vertex>


void main() {

  #include <uv_vertex>

  vTint = _tint;

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>

  // normal

  #include <begin_vertex>
  #include <batchingbase_vertex>
  #include <defaultnormal_vertex>


	#include <normal_vertex>




  #ifdef USE_BATCHING_UNIFORM_color
    vColor = getBatchUniform( batching_color_texture, 4 ).rgb;
  #endif

  #ifdef USE_BATCHING_UNIFORM_effects
    vEffects = getBatchUniform( batching_effects_texture, 4 ).rgba;
  #endif

  #ifdef USE_BATCHING_UNIFORM_uv
    vUvBatch = getBatchUniform( batching_uv_texture, 2 ).rg;
  #endif

  #if defined(USE_MAP) && defined(USE_BATCH_MAPS) && defined(USE_BATCHING_UNIFORM_map) && defined(USE_MULTI_DRAW)
  	vTextureId = texelFetch(batching_map_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined(USE_NORMALMAP) && defined(USE_BATCH_NORMALMAPS) && defined(USE_BATCHING_UNIFORM_normalMap) && defined(USE_MULTI_DRAW)
  	vNormalTextureId = texelFetch(batching_normalMap_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)
    
    vUv2 = _uvscale;

  #endif

	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>

  #include <cellshading_vertex>

  vec4 mvPosition = vec4( transformed, 1.0 );
  vec4 worldNormal = vec4( vNormal, 0.0 );
  #ifdef USE_BATCHING
    worldNormal = batchingMatrix * worldNormal;
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
    worldNormal = instanceMatrix * worldNormal;
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;


  vNormal = normalize(vec3(worldNormal).xyz);

  gl_Position = projectionMatrix * mvPosition;
	#if defined( USE_NORMALMAP )

  vViewPosition = - mvPosition.xyz;

  #endif

  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif

	#ifdef USE_BATCHING

		worldPosition = batchingMatrix * worldPosition;

	#endif



	worldPosition = modelMatrix * worldPosition;

  // position
  vWorldPosition = (worldPosition).xyz;

  #include <shadows_vertex>

}

`, mm = `
#include <layout_pars_fragment>
in vec3 vWorldPosition;
in vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	in vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	in vec2 vUvBatch;
#endif

uniform vec3 diffuse;
uniform float opacity;
uniform float metalness;
uniform float brightnessThresholds;
uniform sampler2D alphaMap;

in float vTint;

#ifdef USE_MAP
  #ifdef USE_BATCH_MAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray map;

  #else
    uniform sampler2D map;
  #endif
#endif


#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float vUv2;

#endif

in vec2 vUv;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

#include <packing>
#include <color_pars_fragment>
#ifdef USE_BATCHING

	in float vDrawId;
  #ifdef USE_BATCH_MAPS
    in float vTextureId;
  #endif
  #ifdef USE_BATCH_NORMALMAPS
    in float vNormalTextureId;
  #endif
#endif

#include <batching_pars_uniforms>
#include <uv_pars_fragment>

#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>

in vec3 vViewPosition;

float noise(vec2 uv) {
  return fract(sin(dot(uv, vec2(12.9898, 78.233))) * 43758.5453);
}


// snoise
vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 mod289(vec4 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 permute(vec4 x) {
     return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r)
{
  return 1.79284291400159 - 0.85373472095314 * r;
}

float snoise(vec3 v)
  {
  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

// First corner
  vec3 i  = floor(v + dot(v, C.yyy) );
  vec3 x0 =   v - i + dot(i, C.xxx) ;

// Other corners
  vec3 g = step(x0.yzx, x0.xyz);
  vec3 l = 1.0 - g;
  vec3 i1 = min( g.xyz, l.zxy );
  vec3 i2 = max( g.xyz, l.zxy );

  //   x0 = x0 - 0.0 + 0.0 * C.xxx;
  //   x1 = x0 - i1  + 1.0 * C.xxx;
  //   x2 = x0 - i2  + 2.0 * C.xxx;
  //   x3 = x0 - 1.0 + 3.0 * C.xxx;
  vec3 x1 = x0 - i1 + C.xxx;
  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y

// Permutations
  i = mod289(i);
  vec4 p = permute( permute( permute(
             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

// Gradients: 7x7 points over a square, mapped onto an octahedron.
// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
  float n_ = 0.142857142857; // 1.0/7.0
  vec3  ns = n_ * D.wyz - D.xzx;

  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)

  vec4 x_ = floor(j * ns.z);
  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

  vec4 x = x_ *ns.x + ns.yyyy;
  vec4 y = y_ *ns.x + ns.yyyy;
  vec4 h = 1.0 - abs(x) - abs(y);

  vec4 b0 = vec4( x.xy, y.xy );
  vec4 b1 = vec4( x.zw, y.zw );

  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;
  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;
  vec4 s0 = floor(b0)*2.0 + 1.0;
  vec4 s1 = floor(b1)*2.0 + 1.0;
  vec4 sh = -step(h, vec4(0.0));

  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

  vec3 p0 = vec3(a0.xy,h.x);
  vec3 p1 = vec3(a0.zw,h.y);
  vec3 p2 = vec3(a1.xy,h.z);
  vec3 p3 = vec3(a1.zw,h.w);

//Normalise gradients
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x;
  p1 *= norm.y;
  p2 *= norm.z;
  p3 *= norm.w;

// Mix final noise value
  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
  m = m * m;
  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                dot(p2,x2), dot(p3,x3) ) );
  }


float Bayer2(vec2 a) {
  a = floor(a);
  return fract(a.x / 2. + a.y * a.y * .75);
}

#define Bayer4(a)   (Bayer2 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer8(a)   (Bayer4 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer16(a)  (Bayer8 (.5 *(a)) * .25 + Bayer2(a))

#include <shadows_pars_fragment>

void main() {

	vec4 diffuseColor = vec4( vColor, opacity );
	vec3 totalEmissiveRadiance = vec3(0.);

  float metalness = 0.;

  #ifdef USE_BATCHING_UNIFORM_effects

    // dithering
    float dither = vEffects.w;
    float dithered = Bayer16(gl_FragCoord.xy) * (1. + dither * 1.) - (1. - dither * 1.);

    if (dithered >= -0.0001) discard;

  #endif

	// #include <map_fragment>
  #if defined(USE_MAP)
  
    vec4 sampledDiffuseColor = vec4(1.);
    #ifdef USE_BATCH_MAPS
      if (vTextureId > 0.) {
        vec2 uv = vMapUv * vUv2;
        #ifdef USE_BATCHING_UNIFORM_uv
          uv *= vUvBatch;
        #endif
        sampledDiffuseColor *= texture( map, vec3( uv, vTextureId - 1.) );
      }
    #else
      sampledDiffuseColor *= texture( map, vMapUv );
    #endif

    diffuseColor *= sampledDiffuseColor;

  #endif

	#include <alphamap_fragment>
	#include <alphatest_fragment>

  vec4 o_color = vec4(vec3(0., 0., 0.), 1.);


  vec4 o_diffuse = diffuseColor;

  // #include <shadows_fragment>
  #ifdef USE_SHADOWS

    float cosTheta = dot(normalize((modelViewMatrix * vec4(Light.position.xyz, 1.)).xyz), vNormal);

    vec2 shadowMapSize = vec2(textureSize(shadowMap, 0).xy);

    float bias = max(vShadowBias * (1.0 - cosTheta), vShadowBias);

    float shadowFactor = 0.;
    vec2 texelSize = 1.0 / shadowMapSize;

    // Calculate the shadow factor using the Poisson disk
    for (int i = 0; i < 2; i++) {
      // int index = 0;
      int index = int(16.0 * noiseRandom(vec4(floor(vWorldPosition.xyz * 600.0), i))) % 16;
      float poissonShadow = 1.0 - texture(shadowMap, vec3(vShadowCoord.xy + poissonDisk[index] / shadowMapSize.x, (vShadowCoord.z - bias) / vShadowCoord.w));
      shadowFactor += 1. / 2.0 * poissonShadow;
    }


    bvec4 inFrustumVec = bvec4 ( vShadowCoord.x >= 0.0, vShadowCoord.x <= 1.0, vShadowCoord.y >= 0.0, vShadowCoord.y <= 1.0 );
    bool inFrustum = all( inFrustumVec );

    bvec2 frustumTestVec = bvec2( inFrustum, vShadowCoord.z <= 1.0 );
    bool frustumTest = all( frustumTestVec );

    if(frustumTest == false){
        shadowFactor = 0.0;
    }

    float difLight = max(0., cosTheta);

    float shadow = saturate(shadowFactor * difLight);

  #endif




  vec3 lightVector = normalize( Light.position.xyz - vWorldPosition.xyz );
  float brightness = dot( vNormal, lightVector );

  vec3 baseColor = o_diffuse.rgb;

  vec3 colorMapGenerated[4];
  colorMapGenerated[0] = baseColor * vec3(1.22, 1.12, 1.15);
  colorMapGenerated[1] = baseColor;
  colorMapGenerated[2] = baseColor * vec3(0.78, 0.88, 0.85);
  colorMapGenerated[3] = baseColor * vec3(0.55, 0.65, 0.75);
  
  float brightnessThresholdsGenerated[3];
  brightnessThresholdsGenerated[0] = brightnessThresholds;
  brightnessThresholdsGenerated[1] = brightnessThresholds * 0.5;
  brightnessThresholdsGenerated[2] = brightnessThresholds * 0.001;

  vec4 final;

  if (brightness > brightnessThresholdsGenerated[0])
    final = vec4(colorMapGenerated[0], 1);
  else if (brightness > brightnessThresholdsGenerated[1])
    final = vec4(colorMapGenerated[1], 1);
  else if (brightness > brightnessThresholdsGenerated[2])
    final = vec4(colorMapGenerated[2], 1);
  else
    final = vec4(colorMapGenerated[3], 1);


  o_diffuse = vec4(final.rgb, o_color.a);

  // specular shiny reflection
  float toonShading = 1.;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif

  vec4 o_normal = vec4(vNormal, toonShading);

  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif

  #ifndef USE_DEFERRED
    // #include <forward_lights_fragment>
  #endif
  
  #include <layout_output_fragment>
  // gColor.rgb = vNormal;

  // gColor = saturate(gColor);


}

`, vm = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), map: null, mapTransform: new n.Matrix3(), normalMap: null, alphaMap: null, opacity: 1, brightnessThresholds: 0.9, alphaTest: 0.5, metalness: 0, diffuse: new n.Color(16777215), repeat: new n.Vector2(1, 1), normalScale: new n.Vector2(1, 1), normalMapTransform: new n.Matrix3() }, um, mm, null), gm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ GhibliShaderImpl: vm });
const Pr = /* @__PURE__ */ Z(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Y((s) => s.useDeferred), r = /* @__PURE__ */ I();
  ge(a, () => r.current), _e(r);
  const l = /* @__PURE__ */ se({ useShadows: true });
  return y("ghibliShaderImpl", { attach: "material", ref: r, glslVersion: n.GLSL3, transparent: true, ...l, ...t, cellShading: t.defines?.USE_TOON ? !i : null, blending: i ? t.blending || n.NoBlending : n.NormalBlending, metalness: t.metalness, diffuse: t.color }, gm);
});
Pr.displayName = "GhibliShader";
const pm = `
  #include <common>
  out vec2 vUv;
  out vec3 vViewPosition;
  out vec3 vWorldPosition;

  #include <shadowmap_pars_vertex>
  #include <normal_pars_vertex>
  #include <color_pars_vertex>
  #include <uv_pars_vertex>

  #include <batching_pars_vertex>
  #include <batching_skinning_pars_vertex>

  void main() {
    vUv=uv;
    #include <begin_vertex>
    #include <batchingbase_vertex>

    vec4 mvPosition = vec4(transformed, 1.0);
    vec4 mPosition = modelMatrix * mvPosition;
	  #include <color_vertex>

    #ifdef USE_BATCHING

      mvPosition = batchingMatrix * mvPosition;

    #endif

    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif
    
    
   
    mvPosition = viewMatrix * mPosition;
	  gl_Position = projectionMatrix * mvPosition;

    vec4 worldPosition = vec4( transformed, 1.0 );

    #ifdef USE_INSTANCING

      worldPosition = instanceMatrix * worldPosition;

    #endif

    vViewPosition = - mvPosition.xyz;

    worldPosition = modelMatrix * worldPosition;

    #ifdef USE_BATCHING

      worldPosition = batchingMatrix * worldPosition;

    #endif
    
    vWorldPosition = (worldPosition).xyz;

    #include <beginnormal_vertex>
    #include <defaultnormal_vertex>
	  #include <normal_vertex>
    #include <shadowmap_vertex>
  }
`, hm = `
  #include <layout_pars_fragment>


  uniform float opacity;
  uniform vec3 diffuse;
  uniform sampler2D matcap;
  uniform sampler2D map;

  in float grad;
  in vec2 vUv;

  in vec3 vViewPosition;
  in vec3 vWorldPosition;

  #include <common>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  #include <uv_pars_fragment>

  #include <normal_pars_fragment>
  #include <packing>
  #include <lights_pars_begin>
  #include <shadowmap_pars_fragment>
  #include <shadowmask_pars_fragment>
  #include <color_pars_fragment>
  // #include <map_pars_fragment>

  void main() {
    #include <normal_fragment_begin>
    #include <normal_fragment_maps>
    vec3 viewDir = normalize( vViewPosition );
    vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
    vec3 y = cross( viewDir, x );
    vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
    vec4 matcapColor = texture( matcap, uv );
    vec4 diffuseColor = vec4(diffuse.rgb, opacity);

    #include <map_fragment>
    diffuseColor = texture(map, vUv);
    // diffuseColor.rgb += .6;

    diffuseColor.rgb = diffuseColor.rgb;
    float shadow = 1. - getShadowMask();

    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(normal, 0.);
    vec4 o_position = vec4(vWorldPosition, shadow);
    #include <layout_output_fragment>

  }
`, _m = /* @__PURE__ */ W({ matcap: null, map: null, mapTransform: new n.Matrix3(), playerNeonColor: new n.Color(), diffuse: new n.Color(16777215), opacity: 1 }, pm, hm), xm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ BasicMaterialImpl: _m });
const Mr = /* @__PURE__ */ Z(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Ce(ue.basic.matcapRevised);
  return y("basicMaterialImpl", { ref: a, glslVersion: n.GLSL3, side: n.FrontSide, uniformsGroups: [oe], matcap: i, vertexColors: 2, ...t, diffuse: t.color, attach: "material", children: e }, xm);
});
Mr.displayName = "BasicMaterial";
const ym = `
  #include <common>
  #include <common_ubo_pars>
  out vec2 vUv;
  out vec3 vWorldPos;

  out vec3 vPosition;
  out float vNoise;

  out vec3 vInstanceColor;
  out vec3 vViewPosition;
  in vec3 instanceVColor;

  #include <shadowmap_pars_vertex>
  	
//	Simplex 4D Noise 
//	by Ian McEwan, Ashima Arts
//
vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
float permute(float x){return floor(mod(((x*34.0)+1.0)*x, 289.0));}
vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}
float taylorInvSqrt(float r){return 1.79284291400159 - 0.85373472095314 * r;}

vec4 grad4(float j, vec4 ip){
  const vec4 ones = vec4(1.0, 1.0, 1.0, -1.0);
  vec4 p,s;

  p.xyz = floor( fract (vec3(j) * ip.xyz) * 7.0) * ip.z - 1.0;
  p.w = 1.5 - dot(abs(p.xyz), ones.xyz);
  s = vec4(lessThan(p, vec4(0.0)));
  p.xyz = p.xyz + (s.xyz*2.0 - 1.0) * s.www; 

  return p;
}

float snoise(vec4 v){
  const vec2  C = vec2( 0.138196601125010504,  // (5 - sqrt(5))/20  G4
                        0.309016994374947451); // (sqrt(5) - 1)/4   F4
// First corner
  vec4 i  = floor(v + dot(v, C.yyyy) );
  vec4 x0 = v -   i + dot(i, C.xxxx);

// Other corners

// Rank sorting originally contributed by Bill Licea-Kane, AMD (formerly ATI)
  vec4 i0;

  vec3 isX = step( x0.yzw, x0.xxx );
  vec3 isYZ = step( x0.zww, x0.yyz );
//  i0.x = dot( isX, vec3( 1.0 ) );
  i0.x = isX.x + isX.y + isX.z;
  i0.yzw = 1.0 - isX;

//  i0.y += dot( isYZ.xy, vec2( 1.0 ) );
  i0.y += isYZ.x + isYZ.y;
  i0.zw += 1.0 - isYZ.xy;

  i0.z += isYZ.z;
  i0.w += 1.0 - isYZ.z;

  // i0 now contains the unique values 0,1,2,3 in each channel
  vec4 i3 = clamp( i0, 0.0, 1.0 );
  vec4 i2 = clamp( i0-1.0, 0.0, 1.0 );
  vec4 i1 = clamp( i0-2.0, 0.0, 1.0 );

  //  x0 = x0 - 0.0 + 0.0 * C 
  vec4 x1 = x0 - i1 + 1.0 * C.xxxx;
  vec4 x2 = x0 - i2 + 2.0 * C.xxxx;
  vec4 x3 = x0 - i3 + 3.0 * C.xxxx;
  vec4 x4 = x0 - 1.0 + 4.0 * C.xxxx;

// Permutations
  i = mod(i, 289.0); 
  float j0 = permute( permute( permute( permute(i.w) + i.z) + i.y) + i.x);
  vec4 j1 = permute( permute( permute( permute (
             i.w + vec4(i1.w, i2.w, i3.w, 1.0 ))
           + i.z + vec4(i1.z, i2.z, i3.z, 1.0 ))
           + i.y + vec4(i1.y, i2.y, i3.y, 1.0 ))
           + i.x + vec4(i1.x, i2.x, i3.x, 1.0 ));
// Gradients
// ( 7*7*6 points uniformly over a cube, mapped onto a 4-octahedron.)
// 7*7*6 = 294, which is close to the ring size 17*17 = 289.

  vec4 ip = vec4(1.0/294.0, 1.0/49.0, 1.0/7.0, 0.0) ;

  vec4 p0 = grad4(j0,   ip);
  vec4 p1 = grad4(j1.x, ip);
  vec4 p2 = grad4(j1.y, ip);
  vec4 p3 = grad4(j1.z, ip);
  vec4 p4 = grad4(j1.w, ip);

// Normalise gradients
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x;
  p1 *= norm.y;
  p2 *= norm.z;
  p3 *= norm.w;
  p4 *= taylorInvSqrt(dot(p4,p4));

// Mix contributions from the five corners
  vec3 m0 = max(0.6 - vec3(dot(x0,x0), dot(x1,x1), dot(x2,x2)), 0.0);
  vec2 m1 = max(0.6 - vec2(dot(x3,x3), dot(x4,x4)            ), 0.0);
  m0 = m0 * m0;
  m1 = m1 * m1;
  return 49.0 * ( dot(m0*m0, vec3( dot( p0, x0 ), dot( p1, x1 ), dot( p2, x2 )))
               + dot(m1*m1, vec2( dot( p3, x3 ), dot( p4, x4 ) ) ) ) ;

}
	
#define NUM_OCTAVES 2
	
float fbm(vec4 x) {
	float v = 0.0;
	float a = 0.5;
	vec4 shift = vec4(100.);
	for (int i = 0; i < NUM_OCTAVES; ++i) {
		v += a * snoise(x);
		x = x * 2.0 + shift;
		a *= 0.5;
	}
	return v;
}
	
float map(float value, float min1, float max1, float min2, float max2) {
  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

  void main() {
    vUv = uv;
    vInstanceColor = instanceVColor;

    vec4 mvPosition = vec4(position, 1.0);
    vec4 mPosition = modelMatrix * mvPosition;

    vPosition = position;
    float uNoise = .025;
    float uSpeed = 1.;
    vNoise = fbm(vec4((position / uNoise) - vec3(time * 2. + 0.0,time * uSpeed,0.0),0.0));
    vNoise = map(vNoise,-1.,.6,0.,1.);

    #ifdef USE_INSTANCING
    mPosition = instanceMatrix * mPosition;
    #endif

    mvPosition = viewMatrix * mPosition;

    gl_Position = projectionMatrix * mvPosition;
    
    vViewPosition = - mvPosition.xyz;

    vec4 worldPosition = mPosition;
    vWorldPos = (mPosition).xyz;

    #include <beginnormal_vertex>
    #include <defaultnormal_vertex>
    #include <shadowmap_vertex>
  }
`, bm = `
  #include <layout_pars_fragment>
  
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform sampler2D map;
  uniform float alpha;
  uniform float distanceFade;
  uniform float repeat;
  uniform float closed;
  uniform vec3 diffuse;
  uniform vec3 playerNeonColor;
  uniform float fakeBloom;
  in vec2 vUv;
  in vec3 vWorldPos;
  in vec3 vInstanceColor;
  in vec3 vViewPosition;
  in vec3 vPosition;
  in float vNoise;
  #include <common>

  float Perlin3D( vec3 P )
  {
    //  https://github.com/BrianSharpe/Wombat/blob/master/Perlin3D.glsl
  
    // establish our grid cell and unit position
    vec3 Pi = floor(P);
    vec3 Pf = P - Pi;
    vec3 Pf_min1 = Pf - 1.0;
  
    // clamp the domain
    Pi.xyz = Pi.xyz - floor(Pi.xyz * ( 1.0 / 69.0 )) * 69.0;
    vec3 Pi_inc1 = step( Pi, vec3( 69.0 - 1.5 ) ) * ( Pi + 1.0 );
  
    // calculate the hash
    vec4 Pt = vec4( Pi.xy, Pi_inc1.xy ) + vec2( 50.0, 161.0 ).xyxy;
    Pt *= Pt;
    Pt = Pt.xzxz * Pt.yyww;
    const vec3 SOMELARGEFLOATS = vec3( 635.298681, 682.357502, 668.926525 );
    const vec3 ZINC = vec3( 48.500388, 65.294118, 63.934599 );
    vec3 lowz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi.zzz * ZINC ) );
    vec3 highz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi_inc1.zzz * ZINC ) );
    vec4 hashx0 = fract( Pt * lowz_mod.xxxx );
    vec4 hashx1 = fract( Pt * highz_mod.xxxx );
    vec4 hashy0 = fract( Pt * lowz_mod.yyyy );
    vec4 hashy1 = fract( Pt * highz_mod.yyyy );
    vec4 hashz0 = fract( Pt * lowz_mod.zzzz );
    vec4 hashz1 = fract( Pt * highz_mod.zzzz );
  
    // calculate the gradients
    vec4 grad_x0 = hashx0 - 0.49999;
    vec4 grad_y0 = hashy0 - 0.49999;
    vec4 grad_z0 = hashz0 - 0.49999;
    vec4 grad_x1 = hashx1 - 0.49999;
    vec4 grad_y1 = hashy1 - 0.49999;
    vec4 grad_z1 = hashz1 - 0.49999;
    vec4 grad_results_0 = inversesqrt( grad_x0 * grad_x0 + grad_y0 * grad_y0 + grad_z0 * grad_z0 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x0 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y0 + Pf.zzzz * grad_z0 );
    vec4 grad_results_1 = inversesqrt( grad_x1 * grad_x1 + grad_y1 * grad_y1 + grad_z1 * grad_z1 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x1 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y1 + Pf_min1.zzzz * grad_z1 );
  
    // Classic Perlin Interpolation
    vec3 blend = Pf * Pf * Pf * (Pf * (Pf * 6.0 - 15.0) + 10.0);
    vec4 res0 = mix( grad_results_0, grad_results_1, blend.z );
    vec4 blend2 = vec4( blend.xy, vec2( 1.0 - blend.xy ) );
    float final = dot( res0, blend2.zxzx * blend2.wwyy );
    return ( final * 1.1547005383792515290182975610039 );  // scale things to a strict -1.0->1.0 range  *= 1.0/sqrt(0.75)
  }
  
  
  vec2 rotate2( vec2 xy, float r ) {
    vec2 ab = xy;
    ab.x = xy.x * cos(r) - xy.y * sin(r);
    ab.y = xy.y * cos(r) + xy.x * sin(r);
    return ab;
  }
  
  float Screen(float a, float b) {
    return 1.0 - ((1.0 - a) * (1.0 - b));
  }
  
  vec2 Rotate(vec2 xy, float angle){
    return vec2(xy.x*cos(angle) - xy.y*sin(angle), xy.x*sin(angle) + xy.y*cos(angle));
  }
  
  vec2 Triangle(vec2 uv, float c){
    float r = 0.5235988;
    vec2 o = uv;
    o.x = floor(uv.x * c + 0.5);
    o.y = mix(floor(Rotate(uv * c + 0.5, r).y), floor(Rotate(uv * c + 0.5, -r).y), 0.5);
  //	o.y /= cos(0.5235988);
  //	o.y /= 0.86602539158;
    o.y *= 1.154700555; // This shifts the Y channel back into a -0.5 to +0.5 range, otherwise scrolling the pattern actually changes the output range as well
    return o / c;
  }
  
  vec2 TriangleUV(vec2 uv, float c, float r, float s){
    uv = Rotate(uv, r);
    // Fix alignment (based on the pre-rendered lines)
    // uv.x += (1.0/c)*0.25;
    // uv.y -= 0.01;
    // Larger numbers (over 10k) hit major issues with value rounding.
    // Scrolling needs to be within a much smaller range, so this is designed for a 0-1 loop.
    // The magic number scales the scrolling value to a compatible loop point.
    uv.y += s;// * 1.154700555;
    uv = Triangle(uv, c);
    // Invert the vertical scroll so the output UV values remain static, just the pattern scrolls
    uv.y -= s;// * 1.154700555;
    uv = Rotate(uv, -r);
    uv += 0.5;
  
    return uv;
  }

  vec3 rainbow(float x) {
    /*
      Target colors
      =============
      
      L  x   color
      0  0.0 vec4(1.0, 0.0, 0.0, 1.0);
      1  0.2 vec4(1.0, 0.5, 0.0, 1.0);
      2  0.4 vec4(1.0, 1.0, 0.0, 1.0);
      3  0.6 vec4(0.0, 0.5, 0.0, 1.0);
      4  0.8 vec4(0.0, 0.0, 1.0, 1.0);
      5  1.0 vec4(0.5, 0.0, 0.5, 1.0);
    */
    
    float level = x;
    float r = float(level <= 2.0) + float(level > 4.0) * 0.5;
    float g = max(1.0 - abs(level - 2.0) * 0.5, 0.0);
    float b = (1.0 - (level - 4.0) * 0.5) * float(level >= 4.0);
    return vec3(r, g, b);
  }

  vec3 smoothRainbow (float x) {
    float level1 = floor(x*6.0);
    float level2 = min(6.0, floor(x*6.0) + 1.0);
    
    vec3 a = rainbow(level1);
    vec3 b = rainbow(level2);
    
    return mix(a, b, fract(x*6.0));
  }

  #include <packing>
  #include <lights_pars_begin>
  #include <shadowmap_pars_fragment>
  #include <shadowmask_pars_fragment>

  #define CLR_BLUE vec3(0.000,0.082,0.702)
  #define CLR_PURPLE vec3(0.427,0.020,0.478)

  void main() {

    // Declare variables (these were all dynamic inputs in the Quartz composition)
    float Scroll = -0.1525;
    float Rotation = 0.0;
    float NoiseSpeed = -.2;

    vec3 color2 = texture(map, vec2(vUv.x * 1. + (cos(time * 1.) / 2. + 1.) * .2, vUv.y)).rgb * .7;
    // #if SMOOTH
      // vec3 color = smoothRainbow(vUv.x * (cos(time * 2.) / 2. + 1.));
    // #else
    // vec3 color = rainbow(floor(vUv.x*6.0));
    // #endif

    vec4 Color1 = vec4(diffuse * .7 + .2, saturate(0.3 + alpha)); // Background
    vec4 Color2 = vec4(diffuse, saturate(0.6 + alpha)); // Foreground

    float distScale = 1.;

    vec2 tx = vWorldPos.zy / 100. * 3.;
    vec2 ty = vWorldPos.xy / 100. * 3.;
    vec2 tz = vWorldPos.zx / 100. * 3.;
    vec2 uv = (tx + ty + tz) / 3.;

    // vec2 uv = vec2(vUv.x, vUv.y / 3.);
    float dist = distance(vWorldPos.xz, playerPos.xz);

    float distanceFade = smoothstep(0., 5., dist);
    // if (repeat != 1.) {
    //   uv = vUv * repeat;
    // }
  
    float n2 = Perlin3D(vec3(TriangleUV(uv/.05+vec2(1.0, -2.0) + vec2(time, -time + sin(vNoise)), 11.0, Rotation, time * Scroll)*-20., time * NoiseSpeed * Scroll));

    n2 = clamp(n2 - vNoise * .25, 0.2, 1.0);

    vec4 diffuseColor = mix(Color1, Color2, mix(0., n2, smoothstep(-5.5, 1.,vPosition.y))) * 2.;


    float alpha = 1.0;
    float gradient = mix(0.,3.,-vPosition.y + 2.);
    gradient *= (.12) + n2 *smoothstep(-5.5, 2.,vPosition.y);
    // gradient *= (.12 * distanceFade) + n2 *smoothstep(-5.5, 2.,vPosition.y);
    if(vNoise > 0.5 * gradient) {
      alpha = 0.;
      discard;
    }
  
    float mask = mix(0.,5.,vPosition.y+0.5);
    // alpha = alpha * mask;
    if (length(vInstanceColor) > 0.) {
      diffuseColor.rgb = mix(diffuseColor.rgb, vInstanceColor,saturate(-vPosition.y+1.4 - n2 * vNoise));
    } else {
      diffuseColor.rgb = mix(diffuseColor.rgb, diffuseColor.rgb * .1,saturate(-vPosition.y+1.4 - n2 * vNoise));
    }



    // diffuseColor.rgb = mix(playerNeonColor,diffuseColor.rgb, smoothstep(0., 8., dist));



    vec3 shadowColor = vec3(0, 0, 0);
    float shadowPower = 0.5;
    diffuseColor.rgb = mix(diffuseColor.rgb, shadowColor, (1.0 - getShadowMask() ) * shadowPower);

    
    diffuseColor.rgb = diffuseColor.rgb * (1.0 + gradient * vNoise);

    if (fakeBloom > 0.) {
      diffuseColor.rgb *= 1.7;
    }


    diffuseColor.a = saturate(alpha) * 1. * smoothstep(-8.5, 2.4,vPosition.y);

    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(vec3(vWorldPos), 1.);

    #include <layout_output_fragment>

  }
`, wm = /* @__PURE__ */ W({ fakeBloom: 0, repeat: 1, map: null, mapTransform: new n.Matrix3(), playerNeonColor: new n.Color(), color: new n.Color(16777215), closed: 0, alpha: 0, distanceFade: 400 }, ym, bm), Am = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ FlameImpl: wm });
const Dr = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Y((l) => l.quality), r = /* @__PURE__ */ se({ useLights: false });
  return y("flameImpl", { ref: a, glslVersion: n.GLSL3, side: n.DoubleSide, ...r, ...t, fakeBloom: i > 1 ? 0 : 1, depthWrite: true, attach: "material" }, Am);
});
Dr.displayName = "Flame";
const Cm = `
  #include <common>
  out vec2 vUv;
  out vec3 vWorldPos;
  void main() {
    vUv = uv;
    #include <begin_vertex>

    vec4 vWorldPosition = modelMatrix * vec4(transformed, 1.0);
    #ifdef USE_INSTANCING
      vWorldPosition = instanceMatrix * vWorldPosition;
    #endif
    vWorldPos = vWorldPosition.xyz;
    gl_Position = projectionMatrix * viewMatrix * vWorldPosition;
  }
`, Sm = `
  #include <layout_pars_fragment>


  uniform float alpha;
  uniform float distanceFade;
  uniform float repeat;
  uniform float forceOpacity;
  uniform float closed;
  uniform vec3 u_color;
  in vec2 vUv;
  in vec3 vWorldPos;
  #include <common>
  #include <packing>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  float Perlin3D( vec3 P )
  {
    //  https://github.com/BrianSharpe/Wombat/blob/master/Perlin3D.glsl
  
    // establish our grid cell and unit position
    vec3 Pi = floor(P);
    vec3 Pf = P - Pi;
    vec3 Pf_min1 = Pf - 1.0;
  
    // clamp the domain
    Pi.xyz = Pi.xyz - floor(Pi.xyz * ( 1.0 / 69.0 )) * 69.0;
    vec3 Pi_inc1 = step( Pi, vec3( 69.0 - 1.5 ) ) * ( Pi + 1.0 );
  
    // calculate the hash
    vec4 Pt = vec4( Pi.xy, Pi_inc1.xy ) + vec2( 50.0, 161.0 ).xyxy;
    Pt *= Pt;
    Pt = Pt.xzxz * Pt.yyww;
    const vec3 SOMELARGEFLOATS = vec3( 635.298681, 682.357502, 668.926525 );
    const vec3 ZINC = vec3( 48.500388, 65.294118, 63.934599 );
    vec3 lowz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi.zzz * ZINC ) );
    vec3 highz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi_inc1.zzz * ZINC ) );
    vec4 hashx0 = fract( Pt * lowz_mod.xxxx );
    vec4 hashx1 = fract( Pt * highz_mod.xxxx );
    vec4 hashy0 = fract( Pt * lowz_mod.yyyy );
    vec4 hashy1 = fract( Pt * highz_mod.yyyy );
    vec4 hashz0 = fract( Pt * lowz_mod.zzzz );
    vec4 hashz1 = fract( Pt * highz_mod.zzzz );
  
    // calculate the gradients
    vec4 grad_x0 = hashx0 - 0.49999;
    vec4 grad_y0 = hashy0 - 0.49999;
    vec4 grad_z0 = hashz0 - 0.49999;
    vec4 grad_x1 = hashx1 - 0.49999;
    vec4 grad_y1 = hashy1 - 0.49999;
    vec4 grad_z1 = hashz1 - 0.49999;
    vec4 grad_results_0 = inversesqrt( grad_x0 * grad_x0 + grad_y0 * grad_y0 + grad_z0 * grad_z0 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x0 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y0 + Pf.zzzz * grad_z0 );
    vec4 grad_results_1 = inversesqrt( grad_x1 * grad_x1 + grad_y1 * grad_y1 + grad_z1 * grad_z1 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x1 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y1 + Pf_min1.zzzz * grad_z1 );
  
    // Classic Perlin Interpolation
    vec3 blend = Pf * Pf * Pf * (Pf * (Pf * 6.0 - 15.0) + 10.0);
    vec4 res0 = mix( grad_results_0, grad_results_1, blend.z );
    vec4 blend2 = vec4( blend.xy, vec2( 1.0 - blend.xy ) );
    float final = dot( res0, blend2.zxzx * blend2.wwyy );
    return ( final * 1.1547005383792515290182975610039 );  // scale things to a strict -1.0->1.0 range  *= 1.0/sqrt(0.75)
  }
  
  
  vec2 rotate2( vec2 xy, float r ) {
    vec2 ab = xy;
    ab.x = xy.x * cos(r) - xy.y * sin(r);
    ab.y = xy.y * cos(r) + xy.x * sin(r);
    return ab;
  }
  
  float Screen(float a, float b) {
    return 1.0 - ((1.0 - a) * (1.0 - b));
  }
  
  vec2 Rotate(vec2 xy, float angle){
    return vec2(xy.x*cos(angle) - xy.y*sin(angle), xy.x*sin(angle) + xy.y*cos(angle));
  }
  
  vec2 Triangle(vec2 uv, float c){
    float r = 0.5235988;
    vec2 o = uv;
    o.x = floor(uv.x * c + 0.5);
    o.y = mix(floor(Rotate(uv * c + 0.5, r).y), floor(Rotate(uv * c + 0.5, -r).y), 0.5);
  //	o.y /= cos(0.5235988);
  //	o.y /= 0.86602539158;
    o.y *= 1.154700555; // This shifts the Y channel back into a -0.5 to +0.5 range, otherwise scrolling the pattern actually changes the output range as well
    return o / c;
  }
  
  vec2 TriangleUV(vec2 uv, float c, float r, float s){
    uv = Rotate(uv, r);
    // Fix alignment (based on the pre-rendered lines)
    // uv.x += (1.0/c)*0.25;
    // uv.y -= 0.01;
    // Larger numbers (over 10k) hit major issues with value rounding.
    // Scrolling needs to be within a much smaller range, so this is designed for a 0-1 loop.
    // The magic number scales the scrolling value to a compatible loop point.
    uv.y += s;// * 1.154700555;
    uv = Triangle(uv, c);
    // Invert the vertical scroll so the output UV values remain static, just the pattern scrolls
    uv.y -= s;// * 1.154700555;
    uv = Rotate(uv, -r);
    uv += 0.5;
  
    return uv;
  }

  
  void main() {

    // Declare variables (these were all dynamic inputs in the Quartz composition)
    float Scroll = 0.0325;
    float Rotation = -0.0;
    float NoiseSpeed = 1.0;
    float dist = distance(vWorldPos, playerPos.xyz);
    vec4 Color1 = vec4(u_color * .7 + .2, saturate(0.05 + alpha)); // Background
    vec4 Color2 = vec4(u_color, 0.); // Foreground

    float distScale = 1.;

    vec2 tx = vWorldPos.zy / 100. * repeat;
    vec2 ty = vWorldPos.xy / 100. * repeat;
    vec2 tz = vWorldPos.zx / 100. * repeat;
    vec2 uv = (tx + ty + tz) / 3.;

    if (repeat != 1.) {
      uv = uv * repeat;
    }

    uv *= 10.;
    float n2 = Perlin3D(vec3(TriangleUV(uv/.05+vec2(2.0, 2.0), 11.0, Rotation, -time * Scroll)*20., time * NoiseSpeed * Scroll));
    float n3 = Perlin3D(vec3(TriangleUV(uv/.4+vec2(1.0, 1.0) * 1.2, 11.0, Rotation, -time * Scroll)*20., time * NoiseSpeed * Scroll));
    n2 = clamp((n2+n3), 0.0, 1.0);

    vec4 diffuseColor = mix(Color1, Color2, n2);
    if (repeat != 0.15 && n2 > 0.3) discard;
    // if forcefield is open fade out when the player get closer

    vec4 o_color =  vec4(0.);


    // if (forceOpacity > 0.) {
    //   diffuseColor.a = forceOpacity;

    //   #ifdef USE_CONTACT_SHADER
    //     float distanceFade = 1. - smoothstep(0., 4.2, dist);
    //     diffuseColor.a *= 1. - distanceFade;
    //     diffuseColor.a = saturate(diffuseColor.a - pow(distanceFade, .8));
    //     float distanceBloom = (-smoothstep(2.5, 3.51, dist) + smoothstep(2., 2.5, dist));
    //     diffuseColor += distanceBloom * .5;
    //     o_color += distanceBloom * .5;
    //   #endif
    // }

    vec4 o_diffuse = diffuseColor;
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(vWorldPos, 0.);

    #include <layout_output_fragment>

  }
`, Pm = /* @__PURE__ */ W({ repeat: 1, u_color: new n.Color(1502187), closed: 0, forceOpacity: 0, alpha: 0, distanceFade: 400 }, Cm, Sm), Mm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ ForceFieldImpl: Pm });
const Er = /* @__PURE__ */ Z(({ children: e, ...t }, a) => y("forceFieldImpl", { ref: a, glslVersion: n.GLSL3, side: n.DoubleSide, uniformsGroups: [oe], ...t, attach: "material" }, Mm));
Er.displayName = "ForceField";
const Dm = `
  out vec3 vWorldPosition;
  out vec3 vNormal;
  out vec2 vUv;
  out float yPos;
  uniform float repeat;

  #include <morphtarget_pars_vertex>
  #include <skinning_pars_vertex>
  #include <color_pars_vertex>

  void main() {

    #include <begin_vertex>
    vUv = uv;
    #include <morphcolor_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>
    #include <skinbase_vertex>
    #include <skinnormal_vertex>
    #include <defaultnormal_vertex>
		#include <color_vertex>

    #include <morphtarget_vertex>
    #include <skinning_vertex>

    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_BATCHING
      mvPosition = batchingMatrix * mvPosition;
    #endif
    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif
    
    mvPosition = modelViewMatrix * mvPosition;
    
    gl_Position = projectionMatrix * mvPosition;
    mat4 mvPos = modelMatrix;
    #ifdef USE_INSTANCING
      mvPos = instanceMatrix * mvPos;
    #endif
   
    vWorldPosition = (mvPos * vec4(transformed.xyz, 1.)).xyz;
    vNormal = normalize(normal.xyz);


  }
`, Em = `
  #include <layout_pars_fragment>


  
  uniform vec3 diffuse;
  #include <map_pars_fragment>

  in vec3 vWorldPosition;
  in vec3 vNormal;
  in vec2 vUv;
  in float yPos;
  #include <packing>
  #include <common>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  #include <fog_pars_fragment>
  #include <color_pars_fragment>

  void main() {
    vec4 diffuseColor = vec4(diffuse, 1.);
    #include <map_fragment>

    #if defined(USE_MAP)
    #else
      #ifdef USE_COLOR
        diffuseColor.rgb *= vColor.rgb;
      #endif
    #endif
    vec3 norm = vNormal;

    #include <fog_fragment>
    diffuseColor.a = length(vNormal.g) * 1.2;

    vec4 o_diffuse = diffuseColor;
    vec4 o_color = diffuseColor;
    vec4 o_normal = vec4(vNormal, 1.);
    vec4 o_position = vec4(vWorldPosition, 1.);

    #include <layout_output_fragment>

  }
`, Tm = /* @__PURE__ */ W({ map: null, mapTransform: new n.Matrix3(), repeat: 1, diffuse: new n.Color(16777215) }, Dm, Em), Im = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ FresnelMaterialImpl: Tm });
const Tr = /* @__PURE__ */ Z((e, t) => y("fresnelMaterialImpl", { ref: t, glslVersion: n.GLSL3, side: n.FrontSide, blending: n.NormalBlending, uniformsGroups: [oe], transparent: true, ...e, attach: "material" }, Im));
Tr.displayName = "FresnelMaterial";
const Um = `
    #include <common>
    #include <shadowmap_pars_vertex>


    out vec3 vWorldPosition;
    out vec3 vNorm;
    out vec3 vColor;
    out vec2 vUv;
    out vec3 vScale;


    void main() {
        vUv = uv;
        #include <begin_vertex>
        vec4 mvPosition = vec4( transformed, 1.0 );
        #ifdef USE_INSTANCING
          mvPosition = instanceMatrix * mvPosition;
        #endif

        vec4 worldPosition = (modelMatrix * mvPosition);
        
        mat4 cm = modelMatrix;
        float scaleX = sqrt(cm[0][0]*cm[0][0] + cm[0][1]*cm[0][1] + cm[0][2]*cm[0][2]);
        float scaleY = sqrt(cm[1][0]*cm[1][0] + cm[1][1]*cm[1][1] + cm[1][2]*cm[1][2]);
        float scaleZ = sqrt(cm[2][0]*cm[2][0] + cm[2][1]*cm[2][1] + cm[2][2]*cm[2][2]);
        vScale = vec3(scaleX, scaleY, scaleZ);

        vWorldPosition =(mvPosition).xyz;
        vNorm = normal;
        #ifdef USE_COLOR
          vColor = color.rgb;
        #endif



        #include <beginnormal_vertex>
        #include <defaultnormal_vertex>

        mvPosition = modelViewMatrix * mvPosition;
	      gl_Position = projectionMatrix * mvPosition;

        worldPosition = modelMatrix * worldPosition;
        #include <shadowmap_vertex>
    }
`, Bm = `
  #include <layout_pars_fragment>

  in vec3 vWorldPosition;
  in vec3 vNorm;
  in vec3 vColor;
  in vec2 vUv;
  in vec3 vScale;

  uniform float uSize1;
  uniform sampler2D patternMap;
  uniform vec3 u_color;
  #include <common>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  #include <packing>
  uniform bool receiveShadow;

  #if NUM_DIR_LIGHTS > 0

    struct DirectionalLight {
      vec3 direction;
      vec3 color;
    };

    uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

    void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {

      light.color = directionalLight.color;
      light.direction = directionalLight.direction;
      light.visible = true;

    }

  #endif

  #include <shadowmap_pars_fragment>
  #include <shadowmask_pars_fragment>

  vec3 triplanar_grid_mapping(float size) {

    vec3 bf = normalize(abs(vNorm));
    bf /= dot(bf, vec3(1.0));

    vec3 tx = texture(patternMap, vWorldPosition.zy / size * vScale.zy).rgb;
    vec3 ty = texture(patternMap, vWorldPosition.xz / size * vScale.xz).rgb;
    vec3 tz = texture(patternMap, vWorldPosition.xy / size * vScale.xy).rgb;

    return tx * bf.x + ty * bf.y + tz * bf.z;

  }


  float triplanar_grid(float size) {
    float scale = 2.0;
    vec3 coord = vWorldPosition / scale * vScale;

    vec3 grid = abs(fract(coord - 1.5) - 0.5)  / fwidth(coord);
    float line = min(min(grid.x, grid.y), grid.z);

    // vec3 grid2 = abs(fract(coord - 0.0) - 0.5) / fwidth(coord);
    // float line2 = min(min(grid2.x, grid2.y), grid2.z);

    return 1.0 - min(line, 1.0);
  }

  void main() {
    float d = 1.0 - min(distance(cameraPosition.xz, vWorldPosition.xz) / 1000., 1.0);
    
    vec3 col = 1. - u_color.rgb;

    vec4 diffuseColor = vec4(mix(u_color.rgb, vec3(0.), saturate(vNorm.g) * .05), 1.);
    diffuseColor.rgb = triplanar_grid_mapping(uSize1);
    diffuseColor.rgb += u_color.rgb / 2.;

    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(vWorldPosition, (1. - getShadowMask()));

    #include <layout_output_fragment>
  }
`, km = /* @__PURE__ */ W({ uSize1: 20, patternMap: null, u_color: new n.Color("black") }, Um, Bm), Rm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ GridImpl: km });
const Ir = /* @__PURE__ */ Z(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Ne(ue.grid.pattern, (r) => {
    r.wrapS = r.wrapT = n.RepeatWrapping, r.flipY = true, r.needsUpdate = true;
  });
  return y("gridImpl", { ref: a, glslVersion: n.GLSL3, side: n.DoubleSide, ...t, patternMap: i, uniformsGroups: [oe], depthWrite: true, attach: "material" }, Rm);
});
Ir.displayName = "Grid";
const Lm = `
  #include <common>
  out vec2 vUv;
  out vec3 vWorldPos;
  #include <shadowmap_pars_vertex>

  void main() {
    vUv = uv;
    #include <begin_vertex>

    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_INSTANCING
        mvPosition = instanceMatrix * mvPosition;
    #endif
    vec4 mPosition = modelMatrix * mvPosition;
    vWorldPos = mPosition.xyz;
    mvPosition = modelViewMatrix * mvPosition;
    vec4 worldPosition = mvPosition;
    
    gl_Position = projectionMatrix * mvPosition;
    #include <beginnormal_vertex>
    #include <defaultnormal_vertex>
    #include <shadowmap_vertex>
  }
`, zm = `
  #include <layout_pars_fragment>

  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform sampler2D map;
  uniform float alpha;
  uniform float distanceFade;
  uniform float repeat;
  uniform float closed;

  uniform vec3 playerNeonColor;
  uniform vec3 diffuse;
  uniform float fakeBloom;
  in vec2 vUv;
  in vec3 vWorldPos;

  #include <common>

  float Perlin3D( vec3 P )
  {
    //  https://github.com/BrianSharpe/Wombat/blob/master/Perlin3D.glsl
  
    // establish our grid cell and unit position
    vec3 Pi = floor(P);
    vec3 Pf = P - Pi;
    vec3 Pf_min1 = Pf - 1.0;
  
    // clamp the domain
    Pi.xyz = Pi.xyz - floor(Pi.xyz * ( 1.0 / 69.0 )) * 69.0;
    vec3 Pi_inc1 = step( Pi, vec3( 69.0 - 1.5 ) ) * ( Pi + 1.0 );
  
    // calculate the hash
    vec4 Pt = vec4( Pi.xy, Pi_inc1.xy ) + vec2( 50.0, 161.0 ).xyxy;
    Pt *= Pt;
    Pt = Pt.xzxz * Pt.yyww;
    const vec3 SOMELARGEFLOATS = vec3( 635.298681, 682.357502, 668.926525 );
    const vec3 ZINC = vec3( 48.500388, 65.294118, 63.934599 );
    vec3 lowz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi.zzz * ZINC ) );
    vec3 highz_mod = vec3( 1.0 / ( SOMELARGEFLOATS + Pi_inc1.zzz * ZINC ) );
    vec4 hashx0 = fract( Pt * lowz_mod.xxxx );
    vec4 hashx1 = fract( Pt * highz_mod.xxxx );
    vec4 hashy0 = fract( Pt * lowz_mod.yyyy );
    vec4 hashy1 = fract( Pt * highz_mod.yyyy );
    vec4 hashz0 = fract( Pt * lowz_mod.zzzz );
    vec4 hashz1 = fract( Pt * highz_mod.zzzz );
  
    // calculate the gradients
    vec4 grad_x0 = hashx0 - 0.49999;
    vec4 grad_y0 = hashy0 - 0.49999;
    vec4 grad_z0 = hashz0 - 0.49999;
    vec4 grad_x1 = hashx1 - 0.49999;
    vec4 grad_y1 = hashy1 - 0.49999;
    vec4 grad_z1 = hashz1 - 0.49999;
    vec4 grad_results_0 = inversesqrt( grad_x0 * grad_x0 + grad_y0 * grad_y0 + grad_z0 * grad_z0 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x0 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y0 + Pf.zzzz * grad_z0 );
    vec4 grad_results_1 = inversesqrt( grad_x1 * grad_x1 + grad_y1 * grad_y1 + grad_z1 * grad_z1 ) * ( vec2( Pf.x, Pf_min1.x ).xyxy * grad_x1 + vec2( Pf.y, Pf_min1.y ).xxyy * grad_y1 + Pf_min1.zzzz * grad_z1 );
  
    // Classic Perlin Interpolation
    vec3 blend = Pf * Pf * Pf * (Pf * (Pf * 6.0 - 15.0) + 10.0);
    vec4 res0 = mix( grad_results_0, grad_results_1, blend.z );
    vec4 blend2 = vec4( blend.xy, vec2( 1.0 - blend.xy ) );
    float final = dot( res0, blend2.zxzx * blend2.wwyy );
    return ( final * 1.1547005383792515290182975610039 );  // scale things to a strict -1.0->1.0 range  *= 1.0/sqrt(0.75)
  }
  
  
  vec2 rotate2( vec2 xy, float r ) {
    vec2 ab = xy;
    ab.x = xy.x * cos(r) - xy.y * sin(r);
    ab.y = xy.y * cos(r) + xy.x * sin(r);
    return ab;
  }
  
  float Screen(float a, float b) {
    return 1.0 - ((1.0 - a) * (1.0 - b));
  }
  
  vec2 Rotate(vec2 xy, float angle){
    return vec2(xy.x*cos(angle) - xy.y*sin(angle), xy.x*sin(angle) + xy.y*cos(angle));
  }
  
  vec2 Triangle(vec2 uv, float c){
    float r = 0.5235988;
    vec2 o = uv;
    o.x = floor(uv.x * c + 0.5);
    o.y = mix(floor(Rotate(uv * c + 0.5, r).y), floor(Rotate(uv * c + 0.5, -r).y), 0.5);
  //	o.y /= cos(0.5235988);
  //	o.y /= 0.86602539158;
    o.y *= 1.154700555; // This shifts the Y channel back into a -0.5 to +0.5 range, otherwise scrolling the pattern actually changes the output range as well
    return o / c;
  }
  
  vec2 TriangleUV(vec2 uv, float c, float r, float s){
    uv = Rotate(uv, r);
    // Fix alignment (based on the pre-rendered lines)
    // uv.x += (1.0/c)*0.25;
    // uv.y -= 0.01;
    // Larger numbers (over 10k) hit major issues with value rounding.
    // Scrolling needs to be within a much smaller range, so this is designed for a 0-1 loop.
    // The magic number scales the scrolling value to a compatible loop point.
    uv.y += s;// * 1.154700555;
    uv = Triangle(uv, c);
    // Invert the vertical scroll so the output UV values remain static, just the pattern scrolls
    uv.y -= s;// * 1.154700555;
    uv = Rotate(uv, -r);
    uv += 0.5;
  
    return uv;
  }

  vec3 rainbow(float x) {
    /*
      Target colors
      =============
      
      L  x   color
      0  0.0 vec4(1.0, 0.0, 0.0, 1.0);
      1  0.2 vec4(1.0, 0.5, 0.0, 1.0);
      2  0.4 vec4(1.0, 1.0, 0.0, 1.0);
      3  0.6 vec4(0.0, 0.5, 0.0, 1.0);
      4  0.8 vec4(0.0, 0.0, 1.0, 1.0);
      5  1.0 vec4(0.5, 0.0, 0.5, 1.0);
    */
    
    float level = x;
    float r = float(level <= 2.0) + float(level > 4.0) * 0.5;
    float g = max(1.0 - abs(level - 2.0) * 0.5, 0.0);
    float b = (1.0 - (level - 4.0) * 0.5) * float(level >= 4.0);
    return vec3(r, g, b);
  }

  vec3 smoothRainbow (float x) {
    float level1 = floor(x*6.0);
    float level2 = min(6.0, floor(x*6.0) + 1.0);
    
    vec3 a = rainbow(level1);
    vec3 b = rainbow(level2);
    
    return mix(a, b, fract(x*6.0));
  }

  #include <packing>
  #include <lights_pars_begin>
  #include <shadowmap_pars_fragment>
  #include <shadowmask_pars_fragment>

  void main() {

    // Declare variables (these were all dynamic inputs in the Quartz composition)
    float Scroll = 0.0625;
    float Rotation = 0.0;
    float NoiseSpeed = 1.0;

    vec3 color = texture(map, vec2(vUv.x * 1. + (cos(time * 2.) / 2. + 1.) * .2, vUv.y)).rgb * .7;
    // #if SMOOTH
      // vec3 color = smoothRainbow(vUv.x * (cos(time * 2.) / 2. + 1.));
    // #else
    // vec3 color = rainbow(floor(vUv.x*6.0));
    // #endif

    vec4 Color1 = vec4(color, saturate(0.3 + alpha)); // Background
    vec4 Color2 = vec4(vec3(1.), saturate(0.6 + alpha)); // Foreground

    float distScale = 1.;

    vec2 tx = vWorldPos.zy / 100. * repeat;
    vec2 ty = vWorldPos.xy / 100. * repeat;
    vec2 tz = vWorldPos.zx / 100. * repeat;
    vec2 uv = (tx + ty + tz) / 3.;

    if (repeat != 1.) {
      uv = vUv * repeat;
    }
  
    float n2 = Perlin3D(vec3(TriangleUV(uv/.05+vec2(1.0, 2.0), 11.0, Rotation, time * Scroll)*20., time * NoiseSpeed * Scroll));
    float n3 = Perlin3D(vec3(TriangleUV(uv/.4+vec2(1.0, 1.0) * 1.2, 11.0, Rotation, time * Scroll)*20., time * NoiseSpeed * Scroll));
    n2 = clamp((n2+n3), 0.2, 1.0);

    vec4 diffuseColor = mix(Color1, Color2, n2);
    diffuseColor.a = 1.;
    float dist = distance(vWorldPos.xz, playerPos.xz);

    // diffuseColor.rgb = mix(playerNeonColor,diffuseColor.rgb, smoothstep(0., .8, dist));

    if (fakeBloom > 0.) {
      diffuseColor.rgb *= 1.7;
    }


    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(diffuseColor.rgb * .6, 1.);
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(vec3(0.), 1.0 - getShadowMask());

    #include <layout_output_fragment>

  }
`, Fm = /* @__PURE__ */ W({ fakeBloom: 0, repeat: 1, map: null, mapTransform: new n.Matrix3(), playerNeonColor: new n.Color(), diffuse: new n.Color(1502187), closed: 0, alpha: 0, distanceFade: 400 }, Lm, zm), Nm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ RainbowImpl: Fm });
const Ur = /* @__PURE__ */ Z(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Y((l) => l.quality), r = /* @__PURE__ */ Ce(ue.rainbow.rainbow, (l) => {
    l.wrapS = l.wrapT = n.RepeatWrapping, l.needsUpdate = true;
  });
  return y("rainbowImpl", { ref: a, glslVersion: n.GLSL3, side: n.DoubleSide, uniformsGroups: [oe], ...t, map: r, diffuse: t.color, fakeBloom: i > 1 ? 0 : 1, attach: "material" }, Nm);
});
Ur.displayName = "Rainbow";
const Om = `
  out vec3 vWorldPosition;
  out vec3 vNormal;
  out float yPos;
  uniform float repeat;

  void main() {

    #include <begin_vertex>

    #ifdef USE_FOG
      vFogDepth = - mvPosition.z;
    #endif
    yPos = length(position.xyz) * repeat;

    mat4 mvPos = modelMatrix;
    #ifdef USE_INSTANCING
      mvPos = instanceMatrix * mvPos;
    #endif

    vWorldPosition = (mvPos * vec4(transformed.xyz, 1.)).xyz;
    vNormal = normalize(normal.xyz);

    gl_Position = projectionMatrix * viewMatrix * (mvPos * vec4(transformed.xyz, 1.));

  }
`, Gm = `
  #include <layout_pars_fragment>
  #include <packing>

  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform vec3 u_color;
  uniform float strength;

  in vec3 vWorldPosition;
  in vec3 vNormal;
  in float yPos;
  #include <common>
  #include <fog_pars_fragment>

  void main() {

    float holoOpacity = 0.;
    float fraclines = fract((yPos * .05) + time * 1.);//small lines 
    float scanlines = step(fraclines, 0.1);// cut off based on 0.5
    // big scanline up
    float bigfracline = fract((yPos * .5) + time * 2.);// big gradient line
    float bigfracline2 = fract((yPos * 1.) - time * 4.);// big gradient line
    vec4 diffuseColor = vec4(0.);
    diffuseColor.rgb = diffuseColor.rgb + (bigfracline * 0.8 * vec3(1., 1., 0.));// end result color 
    diffuseColor.rgb = diffuseColor.rgb + (bigfracline2 * 0.1 * vec3(0.,1.,1.));// end result color 
    diffuseColor.rgb = diffuseColor.rgb + (scanlines * 0.4 * vec3(1., 1., 0.));// end result color 

    holoOpacity = (scanlines + bigfracline * .5);// alpha based on scanlines and rim

    vec3 norm = vNormal;
    if (vWorldPosition.x < 0.) norm = -norm;
    vec3 gCol = u_color;

    diffuseColor.rgb = mix(u_color, vec3(1.), norm.r);
    // diffuseColor.rgb = mix(saturate(1. / norm), vec3(1.), norm.rgb);

    if (holoOpacity < 0.4) {
      discard;
    }

    #include <fog_fragment>
    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(vNormal, 0.);
    vec4 o_position = vec4(vWorldPosition, 0.);

    #include <layout_output_fragment>
  }
`, Hm = /* @__PURE__ */ W({ repeat: 1, strength: 1, u_color: new n.Color(1502187) }, Om, Gm), Vm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ ScanLineMaterialImpl: Hm });
const Br = /* @__PURE__ */ Z((e, t) => y("scanLineMaterialImpl", { ref: t, glslVersion: n.GLSL3, side: n.FrontSide, uniformsGroups: [oe], ...e, attach: "material" }, Vm));
Br.displayName = "ScanLineMaterial";
class Wm extends n.ShaderMaterial {
  constructor() {
    super({ type: "SpriteArrayMaterial", uniforms: { alphaTest: { value: 0.5 }, time: { value: 0 }, opacity: { value: 0.5 }, depth: { value: 0 }, bloom: { value: 0 }, cursor: { value: new n.Vector2() }, map: { value: null } }, vertexShader: `
     
	uniform vec2 size;
	out vec2 vUv;
  out float vFogDepth;
  out vec3 vWorldPosition;
  out vec3 vNormal;

	void main() {

    #include <begin_vertex>
    #include <morphtarget_vertex>
    #include <skinning_vertex>
    
    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_INSTANCING

      mvPosition = instanceMatrix * mvPosition;

    #endif
    vWorldPosition = (modelMatrix * mvPosition).xyz;
    vNormal = normal.xyz;

    mvPosition = modelViewMatrix * mvPosition;

    gl_Position = projectionMatrix * mvPosition;


		// Convert position.xy to 1.0-0.0
		vUv.xy = uv;
		vUv.y = 1.0 - vUv.y; // original data is upside down

	}`, fragmentShader: `
precision mediump float;
precision mediump int;
precision mediump sampler2DArray;

#include <layout_pars_fragment>
#include <common_ubo_pars>
#include <packing>
#include <introanimation_pars_fragment>

uniform sampler2DArray map;
uniform int depth;
uniform float opacity;
uniform float alphaTest;
uniform float bloom;
uniform vec2 cursor;
in vec3 vWorldPosition;
in vec3 vNormal;
in vec2 vUv;

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

void main() {

  vec4 diffuseColor = texture(map, vec3( vUv, depth ), 0.);
  diffuseColor = linearToSRGB(diffuseColor);
  
  #include <alphatest_fragment>

  vec4 o_diffuse = diffuseColor;
  vec4 o_color = vec4(diffuseColor.rgb * .6, opacity);
  vec4 o_normal = vec4(vNormal, 0.);
  vec4 o_position = vec4(vWorldPosition, 0.);

  o_color = vec4(bloom, 1., 1., 1.);
  #include <layout_output_fragment>

}` });
  }
  set alphaTest(t) {
    this.uniforms.alphaTest.value = t;
  }
  get alphaTest() {
    return this.uniforms.alphaTest.value;
  }
  set time(t) {
    this.uniforms.time.value = t;
  }
  get time() {
    return this.uniforms.time.value;
  }
  set depth(t) {
    this.uniforms.depth.value = t;
  }
  get depth() {
    return this.uniforms.depth.value;
  }
  set cursor(t) {
    this.uniforms.cursor.value = t;
  }
  get cursor() {
    return this.uniforms.cursor.value;
  }
  set bloom(t) {
    this.uniforms.bloom.value = t;
  }
  get bloom() {
    return this.uniforms.bloom.value;
  }
  set map(t) {
    this.uniforms.map.value = t;
  }
  get map() {
    return this.uniforms.map.value;
  }
}
const jm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ SpriteArrayMaterialImpl: Wm });
const Qm = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ A.useRef(null), r = /* @__PURE__ */ A.useRef(0);
  return A.useImperativeHandle(a, () => i.current), q((l, s) => {
    r.current += s * 10 * t.speed, i.current.depth = Math.round(r.current % t.depth);
  }), y("spriteArrayMaterialImpl", { ref: i, glslVersion: n.GLSL3, ...t, attach: "material", children: e }, jm);
}), kr = /* @__PURE__ */ A.forwardRef(({ defines: e, textureId: t, bloom: a = 1, repeat: i = [1, 1], offset: r = [0, 0], wrapS: l = n.ClampToEdgeWrapping, wrapT: s = n.ClampToEdgeWrapping, ...o }, f) => {
  const d = /* @__PURE__ */ A.useRef(), c = /* @__PURE__ */ Ce(t ? z.externalEndpoint + t : `${z.assetsRoot}img/ktx/404.ktx`, (m) => {
    m.wrapS = l, m.wrapT = s, m.repeat.set(i[0], i[1]), m.offset.set(r[0], r[1]), m.needsUpdate = true;
  }), u = /* @__PURE__ */ A.useMemo(() => [oe], []);
  return y(Qm, { side: o?.side, ref: d, bloom: a, alphaTest: 0.5, depth: o?.depth, opacity: o?.opacity, speed: o?.speed || 1, map: c, defines: e, uniformsGroups: u });
});
kr.displayName = "SpriteArrayMaterial";
const Ym = `
  out vec3 vWorldPosition;
  out vec3 vNormal;
  out vec2 vUv;

  void main() {

    #include <begin_vertex>

    #ifdef USE_FOG
      vFogDepth = - mvPosition.z;
    #endif
    vUv = uv;

    mat4 mvPos = modelMatrix;
    #ifdef USE_INSTANCING
      mvPos = instanceMatrix * mvPos;
    #endif

    vWorldPosition = (mvPos * vec4(transformed.xyz, 1.)).xyz;
    vNormal = normalize(normal.xyz);

    gl_Position = projectionMatrix * viewMatrix * (mvPos * vec4(transformed.xyz, 1.));

  }
`, qm = `
  #include <layout_pars_fragment>

  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform sampler2D map;
  uniform float speed;
  uniform float alphaTest;
  uniform float strength;

  in vec3 vWorldPosition;
  in vec3 vNormal;
  in vec2 vUv;
  #include <packing>
  #include <common>
  #include <fog_pars_fragment>

  void main() {

    
    vec4 diffuseColor = texture(map, vUv + vec2(time * speed, 0.));

    #include <alphatest_fragment>


    #include <fog_fragment>

    vec4 o_diffuse = diffuseColor;
    vec4 o_color = vec4(diffuseColor.rgb, strength);
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(0.);

    #include <layout_output_fragment>
  }
`, Xm = /* @__PURE__ */ W({ speed: 1, strength: 1, alphaTest: 0.45, map: null, mapTransform: new n.Matrix3() }, Ym, qm), Km = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ TextureLoopMaterialImpl: Xm });
const Rr = /* @__PURE__ */ Z((e, t) => y("textureLoopMaterialImpl", { ref: t, glslVersion: n.GLSL3, side: n.FrontSide, uniformsGroups: [oe], ...e, attach: "material" }, Km));
Rr.displayName = "TextureLoopMaterial";
const Lr = /* @__PURE__ */ W({ uSize1: 1, uColor: new n.Color("black") }, `
    #include <common>

    out vec3 vWorldPosition;
    out float vDepth;
    out vec3 vNorm;
    out vec3 vWorldNorm;
    out vec3 vScale;

    out vec3 vColor;


    void main() {
        #include <begin_vertex>
        vec4 mvPosition = vec4( transformed, 1.0 );
        #ifdef USE_INSTANCING
          mvPosition = instanceMatrix * mvPosition;
        #endif

        vec4 worldPosition = (modelMatrix * mvPosition);
        
        mat4 cm = modelMatrix;
        float scaleX = sqrt(cm[0][0]*cm[0][0] + cm[0][1]*cm[0][1] + cm[0][2]*cm[0][2]);
        float scaleY = sqrt(cm[1][0]*cm[1][0] + cm[1][1]*cm[1][1] + cm[1][2]*cm[1][2]);
        float scaleZ = sqrt(cm[2][0]*cm[2][0] + cm[2][1]*cm[2][1] + cm[2][2]*cm[2][2]);
        vScale = vec3(scaleX, scaleY, scaleZ);

        mat4 modelInstance = modelMatrix;
        #ifdef USE_INSTANCING
          modelInstance *= instanceMatrix;
        #endif
        vWorldNorm = normalize( mat3( modelInstance[0].xyz, modelInstance[1].xyz, modelInstance[2].xyz ) * normal );
        
        vWorldPosition = (worldPosition).xyz;
        vDepth = -(viewMatrix * worldPosition).z;

        vNorm = normal;
        #ifdef USE_COLOR
          vColor = color.rgb;
        #endif



        #include <beginnormal_vertex>
        #include <defaultnormal_vertex>

        mvPosition = modelViewMatrix * mvPosition;
	      gl_Position = projectionMatrix * mvPosition;
    }
`, `
  #include <layout_pars_fragment>
  in vec3 vWorldPosition;
  in vec3 vNorm;
  in vec3 vWorldNorm;
  in vec3 vColor;
  in vec3 vScale;
  in float vDepth;

  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  uniform float uSize1;
  uniform vec3 uColor;
  #include <common>
  #include <packing>

  float grid_tri_mapping(float size) {

    float scale = 10.0;
    vec3 coord = vWorldPosition / scale * vScale;
		vec3 fw = fwidth( coord );
    vec3 grid = abs(fract(coord - 0.5) - 0.5) / fw;
    float line = min(min(grid.x, grid.y), grid.z);

    return  min(line, 1.0);

  }

vec3 sphAO;
float sphAR;
vec3 sphBO;
float sphBR;
float ground;

float random (in vec2 _st) { 						
    return fract(sin(dot(_st.xy,
                         vec2(12.9898,78.233)))* 
        43758.5453123+time*.1);
}

vec2 truchetPattern(in vec2 st, in float index, float aa){
    
    // float fw = fwidth(st);
    // float index = fwidth(dd);



    // st = mix(st, vec2(1.) - st, smoothstep(0.75 - fw, 0.75 + fw, index));
    // st = mix(st, vec2(1.0-st.x,st.y), smoothstep(0.5 - fw, 0.5 + fw, index));
    // st = mix(st, 1.0-vec2(1.0-st.x,st.y), smoothstep(0.25 - fw, 0.25 + fw, index));

    if (index > 0.75) {
        st = vec2(1.) - st;
    } else if (index > 0.5) {
        st = vec2(1.0-st.x,st.y);
    } else if (index > 0.25) {
        st = 1.0-vec2(1.0-st.x,st.y);
    }
    if (aa > 0.) {
      vec2 fw = fwidth(st) * .5;
      st += smoothstep(0. -fw, 0.02 + fw, st);
    }
    return st;
}


  vec3 groundColor(in vec3 pos){


    vec3 triUV = vWorldPosition.xyz;

    vec3 weights = abs(normalize(vWorldNorm.xyz));
    weights /= dot(weights, vec3(1.0));
    float size = 1.;
    vec2 coords;
    float maxWeight = max(weights.x, max(weights.y, weights.z));
    if (maxWeight == weights.z) {
      coords = triUV.xy / size;
    } else if (maxWeight == weights.y) {
      coords = triUV.xz / size;
    } else {
      coords = triUV.yz / size;
    }


    vec3 col= vec3(0.);
      float scale = .2;
    	vec2 ipos = floor(coords*scale);  // integer
    	vec2 fpos = fract(coords*scale);  // fraction
		  vec2 tile = truchetPattern(fpos, random( ipos ), 1.);		// generate Maze
      vec2 tileHead = truchetPattern(fpos, random( ipos ), 0.);		// generate Maze
      vec2 tileXL = truchetPattern(fract(coords*scale), random( floor(coords*scale) ), 1.);		// used for impact effect
      
      col.gb += vec2(.2, .4)*(smoothstep(tile.x-0.02,tile.x,tile.y)-smoothstep(tile.x,tile.x+0.02,tile.y));



      col.gb += vec2(.3, .5)*(1.-smoothstep(.03,.04,length(tileHead-fract(time*.4))));	// Head on top of Truchet pattern
    
      
      col += (1.-smoothstep(0.,.02,abs(pos.x)));				// thin white line (main line)
      col.rgb += .3*max(0.,1.-atan(abs(pos.x))*2./PI-.1);		// White line glow
      col.r += (1.-smoothstep(0.,.02,abs(pos.z)));			    // thin red line (crossing signal)
      
      col.r += max(0.,(1.-smoothstep(0., .6, fract(time*.1+pos.x*0.00025)))*((1.-smoothstep(0.,.02,abs(pos.z))) + max(0.,1.-atan(abs(pos.z))*2./PI-.1)));	//crossing pulse
      col.b += max(0.,(1.-smoothstep(0., .4, fract(time*3.+pos.z*0.01)))*((1.-smoothstep(0.,.02,abs(pos.x))) + max(0.,1.-atan(abs(pos.x))*2./PI-.1)));	//rapid pulse
              
      col.r += 1.*min(.9, smoothstep(0.,1.,(1.-fract(time*.1))
              *( smoothstep(tile.x-0.05,tile.x,tile.y) - smoothstep(tile.x,tile.x+0.05,tile.y)+1.*(1.-smoothstep(.0,.1,length(tileXL-fract(time*2.)))) )
              *(1.-smoothstep(0.,300000.*fract(time*.1), pos.x*pos.x+ pos.z*pos.z))*smoothstep(0.,200000.*(fract(time*.1)), pos.x*pos.x+ pos.z*pos.z)  ));  //impact
                       
              
      col.rgb = mix(col.rgb * 10., col.rgb, smoothstep(0., 10., distance(playerPos.xz, vWorldPosition.xz)));
      col.rgb *= 1. - smoothstep(0., 300., distance(playerPos.xz, vWorldPosition.xz)) * .8;

      col.rgb *= 3.;
    return saturate(col);
}



  void main() {
  
        float d = 1.0 - min(distance(cameraPosition.xz, vWorldPosition.xz) / 200., 1.0);
        float g1 = grid_tri_mapping(uSize1);
        
        
        vec3 col = uColor.rgb;
        vec4 diffuseColor = vec4(1.);

        // diffuseColor = vec4(mix(diffuse, col, g1 * pow(d, 3.0)), 1.);
        diffuseColor.rgb = mix(diffuseColor.rgb, col, g1);

        diffuseColor.rgb = mix(diffuseColor.rgb, vec3(0.), saturate(vNorm.g) * .05);
        diffuseColor.a = 1.;

        vec3 triUV = vWorldPosition.xyz;

        vec3 weights = abs(normalize(vWorldNorm.xyz));
        weights /= dot(weights, vec3(1.0));
        float scl = 10. - smoothstep(500., 1000., vDepth) * 9.;

        diffuseColor = vec4(groundColor(vWorldPosition.xyz),1.0);
        // diffuseColor.rgb *= scl;

        vec4 o_diffuse = diffuseColor;
        vec4 o_color = vec4(diffuseColor.rgb * .5, 1.);
        vec4 o_normal = vec4(0.);
        vec4 o_position = vec4(0.);

        #include <layout_output_fragment>
  }
`), Zm = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ TronImpl: Lr });
const zr = /* @__PURE__ */ Z(({ children: e, ...t }, a) => y("tronImpl", { ref: a, glslVersion: n.GLSL3, uniformsGroups: [oe], ...t, attach: "material" }, Zm));
zr.displayName = "Tron";
const Jm = /* @__PURE__ */ W({ map: null, mapTransform: new n.Matrix3(), repeat: new n.Vector2(10, 10), diffuse: new n.Color("#5bafdd") }, `

#include <common>
#include <shadowmap_pars_vertex>

out vec2 vUv;
out vec3 vWorldPosition;
out vec3 vNormal;

#include <common_ubo_pars>

uniform vec2 repeat;

float calculateSurface(float x, float z) {
    float y = 0.0;
    y += (sin(x * 1.0 / repeat.x + time * 1.0) + sin(x * 2.3 / repeat.x + time * 1.5) + sin(x * 3.3 / repeat.x + time * 0.4)) / 3.0;
    y += (sin(z * 0.2 / repeat.y + time * 1.8) + sin(z * 1.8 / repeat.y + time * 1.8) + sin(z * 2.8 / repeat.y + time * 0.8)) / 3.0;
    return y;
}

void main() {
    vUv = uv;
    #include <begin_vertex>

  	#include <beginnormal_vertex>
    #include <defaultnormal_vertex>
    vec3 pos = transformed;
    
    float strength = 1.0;
    // pos.y += strength * calculateSurface(pos.x, pos.z);
    // pos.y -= strength * calculateSurface(0.0, 0.0);
    vec4 mvPosition = vec4(pos, 1.0);
    #ifdef USE_INSTANCING
      mvPosition = instanceMatrix * mvPosition;
    #endif
    vWorldPosition = (modelMatrix * mvPosition).xyz;
    vNormal = normal.xyz;
    gl_Position = projectionMatrix * modelViewMatrix * mvPosition;

    vec4 worldPosition = vec4( transformed, 1.0 );

    #ifdef USE_INSTANCING

      worldPosition = instanceMatrix * worldPosition;

    #endif
    worldPosition = modelMatrix * worldPosition;

    #include <shadowmap_vertex>
}`, `
#include <layout_pars_fragment>


in vec2 vUv;

#include <common_ubo_pars>
#include <introanimation_pars_fragment>

uniform sampler2D map;
uniform vec2 repeat;
uniform vec3 diffuse;
in vec3 vWorldPosition;
in vec3 vNormal;


#include <common>
#include <packing>
uniform bool receiveShadow;

#if NUM_DIR_LIGHTS > 0

	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};

	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {

		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;

	}

#endif
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>


void main() {
    vec2 uv = vUv * repeat + vec2(time * -0.05);

    uv.y += 0.01 * (sin(uv.x * 3.5 + time * 0.35) + sin(uv.x * 4.8 + time * 1.05) + sin(uv.x * 7.3 + time * 0.45)) / 3.0;
    uv.x += 0.12 * (sin(uv.y * 4.0 + time * 0.5) + sin(uv.y * 6.8 + time * 0.75) + sin(uv.y * 11.3 + time * 0.2)) / 3.0;
    uv.y += 0.12 * (sin(uv.x * 4.2 + time * 0.64) + sin(uv.x * 6.3 + time * 1.65) + sin(uv.x * 8.2 + time * 0.45)) / 3.0;

    vec4 tex1 = texture(map, uv * 1.0);
    vec4 tex2 = texture(map, uv * 1.0 + vec2(0.2));
    vec3 blue = diffuse;

    vec4 diffuseColor = vec4(blue + vec3(tex1.a * 0.9 - tex2.a * 0.02), 1.0);

    vec4 o_diffuse = diffuseColor;

    float toonShading = .5;

    vec4 o_color = vec4(vec3(0.), 1.);
    vec4 o_normal = vec4(vNormal, toonShading);
    vec4 o_position = vec4(vWorldPosition, 0.);

    #include <layout_output_fragment>
}
`), $m = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ WaterImpl: Jm });
const Fr = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ Ce(ue.water.water_windwalker, (r) => {
    r.wrapS = r.wrapT = n.RepeatWrapping, r.needsUpdate = true;
  });
  return bt("waterImpl", { ref: a, glslVersion: n.GLSL3, map: i, ...t, uniformsGroups: [oe], diffuse: t.color, name: "WaterShader", key: $m, attach: "material" }, e);
});
Fr.displayName = "Water";
const e0 = `
  uniform float size;
  uniform float scale;
  uniform float scaleOverLife;
  in vec3 a_offset;
  in float a_age;
  in float a_life;
  in float a_overvelocity;
  #include <common>
  #include <color_pars_vertex>
  #include <fog_pars_vertex>
  #include <morphtarget_pars_vertex>
  #include <logdepthbuf_pars_vertex>
  #include <clipping_planes_pars_vertex>

  out float vAgeOverLife;
  out float vSize;
  out float vOverVelocity;
  out vec3 vViewPosition;

  void main() {
    #include <color_vertex>
    #include <morphcolor_vertex>
    #include <begin_vertex>

    transformed = a_offset;

    #include <morphtarget_vertex>
    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_BATCHING
      mvPosition = batchingMatrix * mvPosition;
    #endif
    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif
    
    mvPosition = modelViewMatrix * mvPosition;
    
    gl_Position = projectionMatrix * mvPosition;
    gl_PointSize = size;
    #ifdef USE_SIZEATTENUATION
      bool isPerspective = isPerspectiveMatrix( projectionMatrix );
      if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
    #endif
    vAgeOverLife = smoothstep(0., a_life, a_age);
    vOverVelocity = a_overvelocity;
    if(scaleOverLife > 0.){
      gl_PointSize *= vAgeOverLife;
    }else if(scaleOverLife < 0.){
      gl_PointSize = size - size * vAgeOverLife;
    }
    if(a_age == 999999999.){
      gl_PointSize = 0.;
    }
    vSize = gl_PointSize;
    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>
    #include <worldpos_vertex>
    #include <fog_vertex>

    vViewPosition = - mvPosition.xyz;
  }
`, t0 = `
  #include <layout_pars_fragment>

  uniform vec3 diffuse;
  uniform float debug;
  uniform float opacity;

  uniform float colorOver;
  uniform float opacityOver;

  in float vAgeOverLife;
  in float vSize;
  in float vOverVelocity;
  in vec3 vViewPosition;
  uniform vec3 colorEnd;

  #include <common>
  #include <packing>
  #include <common_ubo_pars>
  #include <introanimation_pars_fragment>

  #include <color_pars_fragment>
  uniform mat3 uvTransform;

  #ifdef USE_MAP

    uniform sampler2D map;

  #endif

  #ifdef USE_ALPHAMAP

    uniform sampler2D alphaMap;

  #endif
  #include <alphatest_pars_fragment>
  #include <fog_pars_fragment>
  #include <logdepthbuf_pars_fragment>
  #include <clipping_planes_pars_fragment>
  void main() {
    #include <clipping_planes_fragment>
    vec3 outgoingLight = vec3( 0.0 );
    vec4 diffuseColor = vec4( diffuse, opacity );

    if (vAgeOverLife >= 1.0) {
      discard;
      return;
    };

    if (vAgeOverLife == 0.0) {
      discard;
      return;
    };
    // color over lifetime
    if (colorOver == 1.) {
      diffuseColor.rgb = mix(diffuseColor.rgb, colorEnd, vAgeOverLife);
    } else if (colorOver == 2.) {
      diffuseColor.rgb = mix(diffuseColor.rgb, colorEnd, saturate(vOverVelocity));
    }
  
    #include <logdepthbuf_fragment>
	  vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;

    #ifdef USE_MAP

      diffuseColor *= texture2D( map, uv );

    #endif

    #ifdef USE_ALPHAMAP

    float alphaValue = texture2D( alphaMap, uv ).g;
       // Calculate the antialiasing width using fwidth
      float aaWidth = fwidth(alphaValue) * 0.5;
      // Apply smoothstep to perform antialiasing
      float antialiasedAlpha = smoothstep(0.5 - aaWidth, 0.5 + aaWidth, alphaValue);

      diffuseColor.a *= antialiasedAlpha;
    #endif

    #include <color_fragment>

    float edgeDist = 0.;
    if (debug > 0.) {
      vec2 fromCenter = abs(uv - 0.5);
      // Signed distance from the horizontal & vertical edges.
      vec2 fromEdge = fromCenter - 0.5;
      fromEdge.x /= length(vec2(dFdx(uv.x), dFdy(uv.x)));
      fromEdge.y /= length(vec2(dFdx(uv.y), dFdy(uv.y)));
      edgeDist = abs(min(max(fromEdge.x,fromEdge.y), 0.0) + length(max(fromEdge, 0.0)));
      if (edgeDist >= 1.) {
        #include <alphatest_fragment>
      }
    } else {
      #include <alphatest_fragment>
    }

   
   
    // alpha over lifetime
    if (opacityOver == 1.) {
      diffuseColor.a *= 1. - vAgeOverLife;
    } else if (opacityOver == 2.) {
      diffuseColor.a *= saturate(vOverVelocity);
    }

    outgoingLight = diffuseColor.rgb;
    diffuseColor = vec4( outgoingLight, diffuseColor.a );

    if (debug > 0.) {
      diffuseColor = mix(diffuseColor, vec4(1., 1., 0., 1.), saturate(1. - edgeDist));
    }

    vec4 o_color = vec4(1., 0., 0., 0.);

    vec4 glow = vec4(0.);
    #ifdef USE_GLOW
        o_color.r = 1.;
    #endif

    vec4 o_diffuse = diffuseColor;
    vec4 o_normal = vec4(0.);
    vec4 o_position = vec4(0.);
    #include <layout_output_fragment>
  }
`, Pa = /* @__PURE__ */ W({ debug: 0, repeat: 1, size: 4, scale: 1, uvTransform: new n.Matrix3(), alphaMapTransform: new n.Matrix3(), map: null, mapTransform: new n.Matrix3(), alphaMap: null, diffuse: new n.Color(16777215), color: new n.Color(16777215), colorEnd: new n.Color("lightblue"), closed: 0, opacity: 1, colorOver: 0, opacityOver: 0, alphaTest: 0.5, alpha: 0, distanceFade: 400, scaleOverLife: 1 }, e0, t0);
Pa.key = n.MathUtils.generateUUID(), Pa.type = "ParticleMaterial", N({ ParticleMaterialImpl: Pa });
const Nr = /* @__PURE__ */ Z(({ children: e, debug: t = false, size: a = 2, scaleOverLife: i = 1, colorOver: r = "none", opacityOver: l = "none", useGlow: s = false, startColor: o = "#ffffff", endColor: f = "#8affff", blending: d = "normal", textureId: c, alphaTextureId: u, ...m }, p) => {
  const g = /* @__PURE__ */ I();
  ge(p, () => g.current), Y((w) => w.useDeferred);
  const h = /* @__PURE__ */ Lt(c ? z.externalEndpoint + c : null, ue.particle.disc), C = /* @__PURE__ */ Lt(u ? z.externalEndpoint + u : null, ue.particle.disc), _ = /* @__PURE__ */ Ne(h, (w) => {
    w.needsUpdate = true, g.current.needsUpdate = true;
  }), x = /* @__PURE__ */ Ne(C, (w) => {
    w.needsUpdate = true, g.current.needsUpdate = true;
  }), b = /* @__PURE__ */ se({ useLights: false });
  return y("particleMaterialImpl", { ref: g, glslVersion: n.GLSL3, side: n.DoubleSide, transparent: false, isPointsMaterial: true, color: o || 16777215, diffuse: o || 16777215, colorEnd: f || 16777215, colorOver: r === "life" ? 1 : r === "velocity" ? 2 : 0, opacityOver: l === "life" ? 1 : l === "velocity" ? 2 : 0, scale: 1, sizeAttenuation: true, size: a, map: _ instanceof n.Texture ? _ : null, debug: t, alphaMap: x instanceof n.Texture ? x : null, alphaTest: 0.5, blending: d === "additive" ? n.AdditiveBlending : n.NormalBlending, scaleOverLife: i, ...b, ...m, "defines-USE_GLOW": s, attach: "material" }, Pa.key);
});
Nr.displayName = "ParticleMaterial";
const a0 = async (e, t) => {
  await gi(e, t);
}, Or = /* @__PURE__ */ A.forwardRef(({ makeDefault: e, camera: t, regress: a, domElement: i, enableDamping: r = true, keyEvents: l = false, onChange: s, onStart: o, onEnd: f, ...d }, c) => {
  const u = /* @__PURE__ */ U((S) => S.invalidate), m = /* @__PURE__ */ U((S) => S.camera), p = /* @__PURE__ */ U((S) => S.gl), g = /* @__PURE__ */ U((S) => S.events), h = /* @__PURE__ */ U((S) => S.setEvents), C = /* @__PURE__ */ U((S) => S.set), _ = /* @__PURE__ */ U((S) => S.get), x = /* @__PURE__ */ U((S) => S.performance), b = t || m, w = i || g.connected || p.domElement, P = /* @__PURE__ */ A.useMemo(() => new Ko(b, w), [b, w]);
  return q(() => {
    P.enabled && P.update();
  }, -1), A.useEffect(() => (l && P.connect(l === true ? w : l), P.connect(w), () => void P.dispose()), [l, w, a, P, u]), A.useEffect(() => {
    const S = (T) => {
      u(), a && x.regress(), s && s(T);
    }, M = (T) => {
      o && o(T);
    }, D = (T) => {
      f && f(T);
    };
    return P.addEventListener("change", S), P.addEventListener("start", M), P.addEventListener("end", D), () => {
      P.removeEventListener("start", M), P.removeEventListener("end", D), P.removeEventListener("change", S);
    };
  }, [s, o, f, P, u, h]), A.useEffect(() => {
    if (e) {
      const S = _().controls;
      return C({ controls: P }), () => C({ controls: S });
    }
  }, [e, P]), y("primitive", { ref: c, object: P, enableDamping: r, ...d });
});
Or.displayName = "OrbitControls";
const Gr = /* @__PURE__ */ A.forwardRef(({ makeDefault: e, children: t, ...a }, i) => {
  const r = /* @__PURE__ */ U(({ set: f }) => f), l = /* @__PURE__ */ U(({ camera: f }) => f), s = /* @__PURE__ */ U(({ size: f }) => f), o = /* @__PURE__ */ A.useRef(null);
  return A.useLayoutEffect(() => {
    a.manual || (o.current.aspect = s.width / s.height);
  }, [s, a]), A.useLayoutEffect(() => {
    o.current.updateProjectionMatrix();
  }), A.useLayoutEffect(() => {
    if (e) {
      const f = l;
      return r(() => ({ camera: o.current })), () => r(() => ({ camera: f }));
    }
  }, [o, e, r]), A.useImperativeHandle(i, () => o.current), y(te, { children: y("perspectiveCamera", { ref: o, ...a, children: t }) });
});
Gr.displayName = "PerspectiveCamera";
const Hr = /* @__PURE__ */ A.forwardRef(({ children: e, makeDefault: t, ...a }, i) => {
  const r = /* @__PURE__ */ U(({ set: f }) => f), l = /* @__PURE__ */ U(({ camera: f }) => f), s = /* @__PURE__ */ U(({ size: f }) => f), o = /* @__PURE__ */ A.useRef(null);
  return A.useLayoutEffect(() => {
    a.manual || o.current.updateProjectionMatrix();
  }, [s, a]), A.useLayoutEffect(() => {
    o.current.updateProjectionMatrix();
  }), A.useLayoutEffect(() => {
    if (t) {
      const f = l;
      return r(() => ({ camera: o.current })), () => r(() => ({ camera: f }));
    }
  }, [o, t, r]), A.useImperativeHandle(i, () => o.current), y(te, { children: y("orthographicCamera", { left: s.width / -2, right: s.width / 2, top: s.height / 2, bottom: s.height / -2, ref: o, ...a, children: e }) });
});
Hr.displayName = "OrthographicCamera";
const Vr = ["enabled", "axis", "mode", "translationSnap", "rotationSnap", "scaleSnap", "space", "size", "showX", "showY", "showZ"], Wr = /* @__PURE__ */ ce.forwardRef(({ children: e, domElement: t, onChange: a, onMouseDown: i, onMouseUp: r, onObjectChange: l, object: s, makeDefault: o, ...f }, d) => {
  const { camera: c, ...u } = f, m = /* @__PURE__ */ Object.keys(u).filter((E) => Vr.includes(E)).reduce((E, O) => (E[O] = u[O], E), {}), p = /* @__PURE__ */ Object.keys(u).filter((E) => !Vr.includes(E)).reduce((E, O) => (E[O] = u[O], E), {}), g = /* @__PURE__ */ U((E) => E.controls), h = /* @__PURE__ */ U((E) => E.gl), C = /* @__PURE__ */ U((E) => E.events), _ = /* @__PURE__ */ U((E) => E.camera), x = /* @__PURE__ */ U((E) => E.invalidate), b = /* @__PURE__ */ U((E) => E.get), w = /* @__PURE__ */ U((E) => E.set), P = c || _, S = t || C.connected || h.domElement, M = /* @__PURE__ */ V(() => new Zo(P, S), [P, S]), D = /* @__PURE__ */ I();
  ie(() => (s ? M.attach(s instanceof n.Object3D ? s : s.current) : D.current instanceof n.Object3D && M.attach(D.current), () => M.detach()), [s, e, M]), G(() => {
    if (g) {
      const E = (O) => g.enabled = !O.value;
      return M.addEventListener("dragging-changed", E), () => M.removeEventListener("dragging-changed", E);
    }
  }, [M, g]);
  const T = /* @__PURE__ */ I(), R = /* @__PURE__ */ I(), L = /* @__PURE__ */ I(), k = /* @__PURE__ */ I();
  return ie(() => {
    T.current = a;
  }, [a]), ie(() => {
    R.current = i;
  }, [i]), ie(() => {
    L.current = r;
  }, [r]), ie(() => {
    k.current = l;
  }, [l]), G(() => {
    const E = (ne) => {
      x(), T.current?.(ne);
    }, O = (ne) => R.current?.(ne), J = (ne) => L.current?.(ne), $ = (ne) => k.current?.(ne);
    return M.addEventListener("change", E), M.addEventListener("mouseDown", O), M.addEventListener("mouseUp", J), M.addEventListener("objectChange", $), () => {
      M.removeEventListener("change", E), M.removeEventListener("mouseDown", O), M.removeEventListener("mouseUp", J), M.removeEventListener("objectChange", $);
    };
  }, [x, M]), G(() => {
    if (o) {
      const E = b().controls;
      return w({ controls: M }), () => w({ controls: E });
    }
  }, [o, M]), M ? H(te, { children: [y("primitive", { ref: d, object: M, ...m }), y("group", { ref: D, ...p, children: e })] }) : null;
});
Wr.displayName = "TransformControls";
var i0 = `#include <layout_pars_fragment>
in vec3 vWorldPosition;
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float bloom;
uniform float opacity;
uniform float metalness;
uniform sampler2D alphaMap;

in vec3 vViewPosition;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>

#if NUM_DIR_LIGHTS > 0

	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};

	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {

		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;

	}

#endif

#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>

#include <envmap_common_pars_fragment>

#include <shadows_pars_fragment>

void main() {


	vec4 diffuseColor = vec4( diffuse, opacity );
	vec3 totalEmissiveRadiance = vec3(0.);

	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>


  // albedo
  vec4 totalEmissive = vec4(totalEmissiveRadiance, saturate(length(totalEmissiveRadiance)));

// TODO DEBUG EMISSIV
  #if defined( USE_COLOR )
    
      if (vColor.r > 0.) {
        diffuseColor.rgb += vColor.r;
        diffuseColor.rgb = saturate(diffuseColor.rgb);
      }

    // bloom is green vertex color
    #if defined( USE_MAP )

      totalEmissive.a += vColor.g;

      if (vColor.g > 0.) {
        totalEmissive.rgb += sampledDiffuseColor.rgb * vColor.g;
        totalEmissive *= diffuseColor.a;
      } else {
        totalEmissive.rgb += vColor.rgb;
      }

    #else

      #if defined ( USE_UNLIT )
      #else
        // then it's just flat vertex color mesh
        diffuseColor.rgb *= vColor.rgb;

      #endif

    #endif
  #endif


  #ifdef USE_ENVMAP


  vec3 cameraToFrag;

  if ( isOrthographic ) {

    cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );

  } else {

    cameraToFrag = normalize( vWorldPosition - cameraPosition );

  }

  // Transforming Normal Vectors with the Inverse Transformation
  vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
  vec3 reflectVec = reflect( cameraToFrag, worldNormal );

  vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );

  #ifdef DEBUG_ENVMAP
    gColor = vec4(envColor.rgb, 1.);
    gVColor = vec4(0.);
    return;
  #endif

  diffuseColor.rgb = mix( diffuseColor.rgb, mix(diffuseColor.rgb, envColor.xyz, 0.5), saturate(metalness) );

#endif


  vec4 o_diffuse = diffuseColor;

  #include <shadows_fragment>

  vec4 o_color = vec4(vec3(bloom, 0., 0.), 1.);

  #if defined(SSAO_FACTOR)
    o_color.g = float(SSAO_FACTOR);
  #endif
  // more vertex color info for the main phong shader
  if (metalness > 0.) {
    totalEmissive.b = metalness;
  }
  
  // vertexColor
  // o_color = totalEmissive;
  // specular shiny reflection
  float toonShading = 0.5;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif

  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  #include <layout_output_fragment>

}
`, n0 = `
#define DEFERRED_PHONG

out vec3 vWorldPosition;

#include <common>
#include <common_ubo_pars>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadows_pars_vertex>

out vec3 vViewPosition;

#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

void main() {

  #include <uv_vertex>

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>


  vec3 transformedNormal = objectNormal;

  #ifdef USE_INSTANCING

    // this is in lieu of a per-instance normal-matrix
    // shear transforms in the instance matrix are not supported

    mat3 m = mat3( instanceMatrix );

    transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );

    transformedNormal = m * transformedNormal;

  #endif

  transformedNormal = normalMatrix * transformedNormal;

  #ifdef FLIP_SIDED

    transformedNormal = - transformedNormal;

  #endif

  #ifdef USE_TANGENT

    vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;

    #ifdef FLIP_SIDED

      transformedTangent = - transformedTangent;

    #endif

  #endif

	// #include <defaultnormal_vertex>

  // normal
	#include <normal_vertex>

	#include <begin_vertex>
  #include <batchingbase_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>

  #include <cellshading_vertex>

  vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;
  
  gl_Position = projectionMatrix * mvPosition;
  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif




  vViewPosition = - mvPosition.xyz;

	worldPosition = modelMatrix * worldPosition;

	#ifdef USE_BATCHING

		worldPosition = batchingMatrix * worldPosition;

	#endif

  // position
  vWorldPosition = (worldPosition).xyz;

  #include <shadows_vertex>

}
`;
const jr = /* @__PURE__ */ W({ shadowMap: null, envMap: null, flipEnvMap: 0, map: null, mapTransform: new n.Matrix3(), normalMap: null, alphaMap: null, bloom: 0, opacity: 1, alphaTest: 0.5, metalness: 0, diffuse: new n.Color(16777215), repeat: new n.Vector2(1, 1), normalScale: new n.Vector2(1, 1), uPaintMap: null, uNoise: null }, n0, i0, null), r0 = /* @__PURE__ */ n.MathUtils.generateUUID(), o0 = (e) => {
  const t = /* @__PURE__ */ I({});
  return e.map && (t.current.map = e.map, t.current["map-colorSpace"] = n.LinearSRGBColorSpace), e.normalMap && (t.current.normalMap = e.normalMap, t.current["normalMap-colorSpace"] = n.LinearSRGBColorSpace), t.current;
};
N({ PhongShaderImpl: jr });
const Qr = /* @__PURE__ */ Z(({ bloom: e = 0, castSSAO: t = false, receiveSSAO: a = false, ...i }, r) => {
  const l = /* @__PURE__ */ Y((c) => c.useDeferred), s = /* @__PURE__ */ I(null);
  ge(r, () => s.current), _e(s);
  const o = /* @__PURE__ */ se({ useShadows: true }), f = /* @__PURE__ */ o0(i), d = /* @__PURE__ */ zt(["px.webp", "nx.webp", "py.webp", "ny.webp", "pz.webp", "nz.webp"], { path: v["/img/cube/sumi/"] });
  return y("phongShaderImpl", { attach: "material", ref: s, isMeshGouraudMaterial: true, glslVersion: n.GLSL3, "defines-SSAO_FACTOR": t && a ? 1 : a ? 0.5 : 0, bloom: e, normalMapType: n.TangentSpaceNormalMap, envMap: d, ...o, ...i, ...f, transmission: 0, cellShading: i.defines?.USE_TOON ? !l : null, blending: l ? i.blending || n.NoBlending : n.NormalBlending, metalness: i.metalness, diffuse: i.color }, r0 + i.defines?.USE_UNLIT + i.defines?.USE_TOON + i.defines?.USE_GLOW);
});
Qr.displayName = "PhongShader";
var s0 = `#include <layout_pars_fragment>

in vec3 vWorldPosition;
in vec3 vWorldNorm;
in vec3 vColor;
in vec2 vUv;

uniform vec3 diffuse;

uniform float opacity;
uniform float repeat;

in vec3 vViewPosition;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>

#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <alphatest_pars_fragment>
#include <normal_pars_fragment>
#include <normalmap_pars_fragment>

#include <shadows_pars_fragment>

#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>

uniform sampler2D u_alphaMap;

void main() {

	vec4 diffuseColor = vec4( vColor, opacity );
  vec3 normal = vWorldNorm;
	// #include <map_fragment>


  diffuseColor.a *= texture2D( u_alphaMap, vUv * repeat).g;
  float normalAdd = .8;
  // diffuseColor.rgb += -.1 + (normal.g + normalAdd) * .2;
  
  if (diffuseColor.a < alphaTest) discard;

  vec3 highlights = vec3(1.);
  float fresnelFactor = .5;
  float fresnelInt = .85;
  float fresnelPow = .4;
  float fresnelBias = .3;

  vec3 viewDirection = normalize(cameraPosition - vWorldPosition);
  float fresnelTerm = pow(1.0 - max(dot(viewDirection, normal), 0.0), fresnelPow);
  float f_fresnel = fresnelBias + fresnelInt * fresnelTerm;
  f_fresnel = saturate(f_fresnel);
  // diffuseColor.rgb += mix(vec3(0.), highlights, 1. - f_fresnel) * .6;

  diffuseColor.rgb = saturate(diffuseColor.rgb);


  vec4 o_diffuse = diffuseColor;

  #include <shadows_fragment>
  float toonShading = 1.;
  vec4 o_color = vec4(vec3(0.), 1.);
  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, 1.);

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  #include <layout_output_fragment>
}
`, l0 = `#define CANOPY

out vec3 vWorldPosition;
out vec3 vWorldNorm;
out vec3 vColor;
out vec2 vUv;

vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 mod289(vec4 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 permute(vec4 x) {
     return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r)
{
  return 1.79284291400159 - 0.85373472095314 * r;
}

float snoise(vec3 v)
  {
  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

// First corner
  vec3 i  = floor(v + dot(v, C.yyy) );
  vec3 x0 =   v - i + dot(i, C.xxx) ;

// Other corners
  vec3 g = step(x0.yzx, x0.xyz);
  vec3 l = 1.0 - g;
  vec3 i1 = min( g.xyz, l.zxy );
  vec3 i2 = max( g.xyz, l.zxy );

  //   x0 = x0 - 0.0 + 0.0 * C.xxx;
  //   x1 = x0 - i1  + 1.0 * C.xxx;
  //   x2 = x0 - i2  + 2.0 * C.xxx;
  //   x3 = x0 - 1.0 + 3.0 * C.xxx;
  vec3 x1 = x0 - i1 + C.xxx;
  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y

// Permutations
  i = mod289(i);
  vec4 p = permute( permute( permute(
             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

// Gradients: 7x7 points over a square, mapped onto an octahedron.
// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
  float n_ = 0.142857142857; // 1.0/7.0
  vec3  ns = n_ * D.wyz - D.xzx;

  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)

  vec4 x_ = floor(j * ns.z);
  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

  vec4 x = x_ *ns.x + ns.yyyy;
  vec4 y = y_ *ns.x + ns.yyyy;
  vec4 h = 1.0 - abs(x) - abs(y);

  vec4 b0 = vec4( x.xy, y.xy );
  vec4 b1 = vec4( x.zw, y.zw );

  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;
  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;
  vec4 s0 = floor(b0)*2.0 + 1.0;
  vec4 s1 = floor(b1)*2.0 + 1.0;
  vec4 sh = -step(h, vec4(0.0));

  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

  vec3 p0 = vec3(a0.xy,h.x);
  vec3 p1 = vec3(a0.zw,h.y);
  vec3 p2 = vec3(a1.xy,h.z);
  vec3 p3 = vec3(a1.zw,h.w);

//Normalise gradients
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x;
  p1 *= norm.y;
  p2 *= norm.z;
  p3 *= norm.w;

// Mix final noise value
  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
  m = m * m;
  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                dot(p2,x2), dot(p3,x3) ) );
  }

#include <common>
#include <common_ubo_pars>

#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>

#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

uniform float u_effectBlend;
uniform float u_inflate;
uniform float u_scale;
uniform float u_windSpeed;

float inverseLerp(float v, float minValue, float maxValue) {
  return (v - minValue) / (maxValue - minValue);
}

float remap(float v, float inMin, float inMax, float outMin, float outMax) {
  float t = inverseLerp(v, inMin, inMax);
  return mix(outMin, outMax, t);
}

mat4 rotateZ(float radians) {
  float c = cos(radians);
  float s = sin(radians);

	return mat4(
    c, -s, 0, 0,
    s, c, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1
  );
}

vec2 calcInitialOffsetFromUVs() {
  vec2 offset = vec2(
    remap(uv.x, 0.0, 1.0, -1.0, 1.0),
    remap(uv.y, 0.0, 1.0, -1.0, 1.0)
  );

  // Invert the vertex offset so it's positioned towards the camera.
  offset = normalize(offset) * u_scale;
  offset *= vec2(-1.0, 1.0);

  return offset;
}

vec3 inflateOffset(vec3 offset) {
  return offset + normal.xyz * u_inflate;
}


out vec3 vViewPosition;

#include <shadows_pars_vertex>


void main() {
  vec2 vertexOffset = calcInitialOffsetFromUVs();

  vec3 inflatedVertexOffset = inflateOffset(vec3(vertexOffset, 0.0));

  vUv = uv;

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>

	#include <begin_vertex>

	#include <batchingbase_vertex>

	#include <defaultnormal_vertex>
  // normal
	#include <normal_vertex>


  #ifdef USE_BATCHING_UNIFORM_color
    vColor = getBatchUniform( batching_color_texture, 4 ).rgb;
  #endif


	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>


  vec4 mvPosition = modelMatrix * vec4(transformed, 1.0);


  #ifdef USE_BATCHING
    mvPosition = ( batchingMatrix * mvPosition );
  #endif

  #ifdef USE_INSTANCING
  
    mvPosition = ( instanceMatrix * mvPosition );
  
  #endif


  float windEffect = snoise(vec3(mvPosition.xyz * 10. + time / 5.)) * 0.5 + 0.5;

  float power = u_windSpeed * windEffect;


  vec4 worldPosition = vec4( vWorldPosition, 1.0 );
  mvPosition = viewMatrix * mvPosition;
  mvPosition.xyz += power;

  mvPosition += vec4(mix(vec3(0.0), inflatedVertexOffset, u_effectBlend), 0.0);

  worldPosition += vec4(mix(vec3(0.0), inflatedVertexOffset, u_effectBlend), 0.0);
  vWorldPosition = mvPosition.xyz;

  vViewPosition = -mvPosition.xyz;
  gl_Position = projectionMatrix * mvPosition;

  vWorldNorm = normalize( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * normal );

  #include <shadowmap_vertex>


  #include <shadows_vertex>

}
`;
const f0 = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), u_effectBlend: 1, u_inflate: 0, u_scale: 1, u_windSpeed: 1, u_windTime: 0, u_alphaMap: null, opacity: 1, alphaTest: 0.5, repeat: 1, ditherDistance: 10 }, l0, s0, null), c0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ CanopyShaderImpl: f0 });
const Yr = /* @__PURE__ */ A.forwardRef(({ ...e }, t) => {
  const a = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(t, () => a.current), _e(a);
  const i = /* @__PURE__ */ se({ useShadows: true });
  return y("canopyShaderImpl", { attach: "material", ref: t, glslVersion: n.GLSL3, side: n.DoubleSide, ...i, ...e }, c0);
});
Yr.displayName = "CanopyShader";
const d0 = /* @__PURE__ */ W({ u_effectBlend: 1, u_inflate: 0, u_scale: 5, u_windSpeed: 1, u_windTime: 0, u_alphaMap: null, alphaTest: 0.5, repeat: 1 }, `
  #define CANOPY

  out vec2 vUv;
  out vec2 vmediumprecisionZW;
  uniform float noiseScale;
  
  #include <common>
  #include <common_ubo_pars>
  
  #include <uv_pars_vertex>
  #include <displacementmap_pars_vertex>
  #include <color_pars_vertex>
  #include <normal_pars_vertex>
  #include <morphtarget_pars_vertex>
  #include <skinning_pars_vertex>
  #include <shadowmap_pars_vertex>
  
  #include <batching_pars_vertex>
  #include <batching_skinning_pars_vertex>
  
  #include <batching_pars_uniforms>
  
  
  uniform float u_effectBlend;
  uniform float u_inflate;
  uniform float u_scale;
  uniform float u_windSpeed;
  


vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 mod289(vec4 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 permute(vec4 x) {
     return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r)
{
  return 1.79284291400159 - 0.85373472095314 * r;
}

float snoise(vec3 v)
  {
  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

// First corner
  vec3 i  = floor(v + dot(v, C.yyy) );
  vec3 x0 =   v - i + dot(i, C.xxx) ;

// Other corners
  vec3 g = step(x0.yzx, x0.xyz);
  vec3 l = 1.0 - g;
  vec3 i1 = min( g.xyz, l.zxy );
  vec3 i2 = max( g.xyz, l.zxy );

  //   x0 = x0 - 0.0 + 0.0 * C.xxx;
  //   x1 = x0 - i1  + 1.0 * C.xxx;
  //   x2 = x0 - i2  + 2.0 * C.xxx;
  //   x3 = x0 - 1.0 + 3.0 * C.xxx;
  vec3 x1 = x0 - i1 + C.xxx;
  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y

// Permutations
  i = mod289(i);
  vec4 p = permute( permute( permute(
             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

// Gradients: 7x7 points over a square, mapped onto an octahedron.
// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
  float n_ = 0.142857142857; // 1.0/7.0
  vec3  ns = n_ * D.wyz - D.xzx;

  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)

  vec4 x_ = floor(j * ns.z);
  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

  vec4 x = x_ *ns.x + ns.yyyy;
  vec4 y = y_ *ns.x + ns.yyyy;
  vec4 h = 1.0 - abs(x) - abs(y);

  vec4 b0 = vec4( x.xy, y.xy );
  vec4 b1 = vec4( x.zw, y.zw );

  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;
  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;
  vec4 s0 = floor(b0)*2.0 + 1.0;
  vec4 s1 = floor(b1)*2.0 + 1.0;
  vec4 sh = -step(h, vec4(0.0));

  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

  vec3 p0 = vec3(a0.xy,h.x);
  vec3 p1 = vec3(a0.zw,h.y);
  vec3 p2 = vec3(a1.xy,h.z);
  vec3 p3 = vec3(a1.zw,h.w);

//Normalise gradients
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x;
  p1 *= norm.y;
  p2 *= norm.z;
  p3 *= norm.w;

// Mix final noise value
  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
  m = m * m;
  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                dot(p2,x2), dot(p3,x3) ) );
  }


  float inverseLerp(float v, float minValue, float maxValue) {
    return (v - minValue) / (maxValue - minValue);
  }
  
  float remap(float v, float inMin, float inMax, float outMin, float outMax) {
    float t = inverseLerp(v, inMin, inMax);
    return mix(outMin, outMax, t);
  }
  
  mat4 rotateZ(float radians) {
    float c = cos(radians);
    float s = sin(radians);
  
      return mat4(
      c, -s, 0, 0,
      s, c, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1
    );
  }

  vec2 calcInitialOffsetFromUVs() {
    vec2 offset = vec2(
      remap(uv.x, 0.0, 1.0, -1.0, 1.0),
      remap(uv.y, 0.0, 1.0, -1.0, 1.0)
    );
  
    // Invert the vertex offset so it's positioned towards the camera.
    offset *= vec2(-1.0, 1.0);
    offset = normalize(offset) * u_scale;
  
    return offset;
  }
  
  vec3 inflateOffset(vec3 offset) {
    return offset + normal.xyz * u_inflate;
  }
  
  void main() {
    vec2 vertexOffset = calcInitialOffsetFromUVs();
  
    vec3 inflatedVertexOffset = inflateOffset(vec3(vertexOffset, 0.0));
  
    vUv = uv;
  
    #include <color_vertex>

    #include <morphcolor_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>
    #include <skinbase_vertex>
    #include <skinnormal_vertex>


  
    #include <begin_vertex>
    #include <batchingbase_vertex>
  
      #include <morphtarget_vertex>
      #include <skinning_vertex>
      #include <displacementmap_vertex>
  

    vec4 mvPosition = modelMatrix * vec4(position, 1.0);


    #ifdef USE_BATCHING
      mvPosition = batchingMatrix * mvPosition;
    #endif

    #ifdef USE_INSTANCING
    
      mvPosition = instanceMatrix * mvPosition;
    
    #endif



    float windEffect = snoise(vec3(mvPosition.xyz * 10. + time / 5.)) * 0.5 + 0.5;

    float power = u_windSpeed * 5. * windEffect;
    mvPosition.xyz += power;

    mvPosition = viewMatrix * mvPosition;
    mvPosition += vec4(mix(vec3(0.0), inflatedVertexOffset, u_effectBlend), 0.0);

    gl_Position = projectionMatrix * mvPosition;
  
    vmediumprecisionZW = gl_Position.zw;

  
    #include <shadowmap_vertex>
  
  }
  
  `, `

#include <layout_pars_fragment>

// uniform float opacity;
#include <common>
#include <packing>
#include <map_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

in vec2 vmediumprecisionZW;
in vec2 vUv;

uniform float repeat;
uniform sampler2D u_alphaMap;

void main() {


	#include <clipping_planes_fragment>

	vec4 diffuseColor = vec4( 1.0 );


	// diffuseColor.a = opacity;
  diffuseColor.a *= texture2D( u_alphaMap, vUv * repeat ).g;

	if ( diffuseColor.a < alphaTest ) discard;

	#include <logdepthbuf_fragment>

	// Higher precision equivalent of gl_FragCoord.z. This assumes depthRange has been left to its default values.
	float fragCoordZ = 0.5 * vmediumprecisionZW[0] / vmediumprecisionZW[1] + 0.5;

  gl_FragColor = packDepthToRGBA( fragCoordZ );
}
`), u0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ CanopyDepthImpl: d0 });
const qr = /* @__PURE__ */ A.forwardRef(({ children: e, ...t }, a) => {
  const i = /* @__PURE__ */ A.useRef();
  A.useImperativeHandle(a, () => i.current), _e(i);
  const r = /* @__PURE__ */ se({ useLights: false });
  return y("canopyDepthImpl", { ref: a, uniformsGroups: r, glslVersion: n.GLSL3, attach: "customDepthMaterial", ...r, ...t, children: e }, u0);
});
qr.displayName = "CanopyDepth";
var m0 = `#include <layout_pars_fragment>
#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <packing>

uniform float gradientPosition;
uniform vec3 diffuse;
uniform vec3 colorMiddle;
uniform vec3 colorEnd;
uniform float showSun;

uniform float mieDirectionalG;
uniform sampler2D noise;

in vec2 vUv;
in vec3 vWorldPosition;
in vec3 vSunDirection;
in vec3 vBetaR;
in vec3 vBetaM;
in float vSunE;

float dist(vec2 p0, vec2 pf){return sqrt((pf.x-p0.x)*(pf.x-p0.x)+(pf.y-p0.y)*(pf.y-p0.y));}

const vec3 cameraPos = vec3( 0.0, 0.0, 0.0 );

// constants for atmospheric scattering
const float pi = 3.141592653589793238462643383279502884197169;

const float n = 1.0003; // refractive index of air
const float N = 2.545E25; // number of molecules per unit volume for air at 288.15K and 1013mb (sea level -45 celsius)

// optical length at zenith for molecules
const float rayleighZenithLength = 8.4E3;
const float mieZenithLength = 1.25E3;
// 66 arc seconds -> degrees, and the cosine of that
const float sunAngularDiameterCos = 0.999956676946448443553574619906976478926848692873900859324;

// 3.0 / ( 16.0 * pi )
const float THREE_OVER_SIXTEENPI = 0.05968310365946075;
// 1.0 / ( 4.0 * pi )
const float ONE_OVER_FOURPI = 0.07957747154594767;

float rayleighPhase( float cosTheta ) {
  return THREE_OVER_SIXTEENPI * ( 1.0 + pow( cosTheta, 2.0 ) );
}

float hgPhase( float cosTheta, float g ) {
  float g2 = pow( g, 2.0 );
  float inverse = 1.0 / pow( 1.0 - 2.0 * g * cosTheta + g2, 1.5 );
  return ONE_OVER_FOURPI * ( ( 1.0 - g2 ) * inverse );
}


void main() {
  vec2 uv = vUv;
  uv += texture(noise, vUv * 60.).r * .1;


  float h = gradientPosition; // adjust position of colorMiddle
  vec3 result = mix(mix(diffuse, colorMiddle, uv.y/h), mix(colorMiddle, colorEnd, (uv.y - h)/(1.0 - h)), step(h, uv.y));
  
  if (showSun > 0.0) {
    vec3 direction = normalize( vWorldPosition - cameraPos );
    // optical length
    // cutoff angle at 90 to avoid singularity in next formula.
    float zenithAngle = acos( max( 0.0, dot( vec3(0., 1., 0.), direction ) ) );
    float inverse = 1.0 / ( cos( zenithAngle ) + 0.15 * pow( 93.885 - ( ( zenithAngle * 180.0 ) / pi ), -1.253 ) );
    float sR = rayleighZenithLength * inverse;
    float sM = mieZenithLength * inverse;

    // combined extinction factor
    vec3 Fex = exp( -( vBetaR * sR + vBetaM * sM ) );
    // in scattering
    vec3 pos = vSunDirection;
    float cosTheta = dot( direction, pos );


    float sundisk = smoothstep( sunAngularDiameterCos, sunAngularDiameterCos + 1300., cosTheta * 1.2 );
    float sundiskCenter = smoothstep( sunAngularDiameterCos, sunAngularDiameterCos + 1., cosTheta * 1.001 );
    // sun circle
    result += ( vSunE * 19000.0 * Fex ) * sundisk;
    result += ( vSunE * 19000.0 * Fex ) * sundiskCenter;
  }

  vec4 o_diffuse = vec4(result, 1.);
  vec4 o_color = vec4(vec3(0.), 1.);
  vec4 o_normal = vec4(0.);
  vec4 o_position = vec4(0.);

  #include <layout_output_fragment>
}
`, v0 = `out vec2 vUv;
out vec3 vWorldPosition;
out vec3 vSunDirection;
out vec3 vBetaR;
out vec3 vBetaM;
out float vSunE;

uniform vec3 sunPosition;
uniform float rayleigh;
uniform float turbidity;
uniform float mieCoefficient;



// constants for atmospheric scattering
const float e = 2.71828182845904523536028747135266249775724709369995957;
const float pi = 3.141592653589793238462643383279502884197169;

// wavelength of used primaries, according to preetham
const vec3 lambda = vec3( 680E-9, 550E-9, 450E-9 );
// this pre-calcuation replaces older TotalRayleigh(vec3 lambda) function:
// (8.0 * pow(pi, 3.0) * pow(pow(n, 2.0) - 1.0, 2.0) * (6.0 + 3.0 * pn)) / (3.0 * N * pow(lambda, vec3(4.0)) * (6.0 - 7.0 * pn))
const vec3 totalRayleigh = vec3( 5.804542996261093E-6, 1.3562911419845635E-5, 3.0265902468824876E-5 );

// mie stuff
// K coefficient for the primaries
const float v = 4.0;
const vec3 K = vec3( 0.686, 0.678, 0.666 );
// MieConst = pi * pow( ( 2.0 * pi ) / lambda, vec3( v - 2.0 ) ) * K
const vec3 MieConst = vec3( 1.8399918514433978E14, 2.7798023919660528E14, 4.0790479543861094E14 );

// earth shadow hack
// cutoffAngle = pi / 1.95;
const float cutoffAngle = 1.6110731556870734;
const float steepness = 1.5;
const float EE = 1000.0;

float sunIntensity( float zenithAngleCos ) {
  zenithAngleCos = clamp( zenithAngleCos, -1.0, 1.0 );
  return EE * max( 0.0, 1.0 - pow( e, -( ( cutoffAngle - acos( zenithAngleCos ) ) / steepness ) ) );
}

vec3 totalMie( float T ) {
  float c = ( 0.2 * T ) * 10E-18;
  return 0.434 * c * MieConst;
}

void main() {
  vUv = uv;
  vUv.y = 1. - vUv.y;
  #include <begin_vertex>

  vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;
  
  gl_Position = projectionMatrix * mvPosition;
  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif
  vWorldPosition = worldPosition.xyz;

  // gl_Position.z = gl_Position.w; // set z to camera.far

  vSunDirection = normalize( sunPosition );

  vSunE = sunIntensity( dot( vSunDirection, vec3(0., 1., 0.) ) );

  float vSunfade = 1.0 - clamp( 1.0 - exp( ( sunPosition.y / 450000.0 ) ), 0.0, 1.0 );

  float rayleighCoefficient = rayleigh - ( 1.0 * ( 1.0 - vSunfade ) );

  // extinction (absorbtion + out scattering)
  // rayleigh coefficients
  vBetaR = totalRayleigh * rayleighCoefficient;

  // mie coefficients
  vBetaM = totalMie( turbidity ) * mieCoefficient;

}
`;
const g0 = /* @__PURE__ */ W({ diffuse: new n.Color("blue"), colorMiddle: new n.Color("grey"), colorEnd: new n.Color("white"), showSun: 0, noise: null, gradientPosition: 0.5, turbidity: 2, rayleigh: 1, mieCoefficient: 5e-3, mieDirectionalG: 0.8, sunPosition: new n.Vector3(300, 1e3, 1200) }, v0, m0), p0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ GradientShaderImpl: g0 });
const h0 = /* @__PURE__ */ Z(function({ discardSSAO: t = true, sunPosition: a, ...i }, r) {
  const l = /* @__PURE__ */ Ce(ue.gradient.blue_noise, (s) => {
    s.wrapS = s.wrapT = n.RepeatWrapping, s.needsUpdate = true;
  });
  return y("gradientShaderImpl", { ref: r, attach: "material", glslVersion: n.GLSL3, "defines-DISCARD_SSAO": t, side: n.BackSide, noise: l, uniformsGroups: [oe], ...i, sunPosition: new n.Vector3().fromArray(a || [0, 1e3, 100]) }, p0);
}), _0 = { primary: ["#ffffff", "#e82324", "#ffa063", "#35d493", "#1ad5d5", "#11B3ED", "#3A5470", "#9d4ad4", "#E32B9A", "#242424"], secondary: ["#f4f4f4", "#fd0000", "#13a6ff", "#6ea47c", "#005220", "#ff5e00", "#f5e07e", "#cfcfcf", "#b3b3b3", "#121212"], third: ["#ffffff", "#fd0000", "#ffff19", "#01ff18", "#1be9e9", "#0154ff", "#ff008e", "#ff6dff", "#606060", "#c5c5c5"] };
function x0(e) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(e) ? `vec3(${new n.Color(e).toArray().map((i) => {
    let r = Math.round(i * 1e3) / 1e3;
    return r.toString().indexOf(".") === -1 && (r += "."), r;
  })})` : "";
}
const bi = (e, t, a) => {
  const i = _0[t];
  let r = "";
  return i.forEach((l, s) => {
    const o = s < i.length - 1 ? `,
` : `
`;
    r += `${x0(a || l)}${o}`;
  }), r;
}, y0 = `

const vec3 paletteNpcPrimary[7] = vec3[7](
  vec3(0.812,0.341,0.098),
  vec3(0.,0.,0.),
  vec3(0.8614,0.7163,0.2357),
  vec3(0.996,0.004,0.173),
  vec3(0.18,0.671,0.129),
  vec3(0.396,0.173,0.725),
  vec3(0.71,0.306,0.678)
);

const vec3 paletteNpcSecondary[7] = vec3[7](
  vec3(0.,0.,0.),
  vec3(0.812,0.341,0.098),
  vec3(0.8614,0.7163,0.2357),
  vec3(0.008,0.22,0.51),
  vec3(0.129,0.204,0.353),
  vec3(0.122,0.153,0.188),
  vec3(0.996,0.957,0.333)
);

const vec3 paletteNpcEmissive[7] = vec3[7](
  vec3(0.973,1.,0.),
  vec3(0.812,0.341,0.098),
  vec3(0.9614,0.8163,0.3357),
  vec3(0.894,0.894,0.894),
  vec3(0.894,0.894,0.894),
  vec3(0.988,0.992,0.443),
  vec3(0.996,0.957,0.333)
);

vec3 getPrimary(int num) {
  return num > 9 ? paletteNpcPrimary[num-10] : palettePrimary[num];
}

vec3 getSecondary(int num) {
  return num > 9 ? paletteNpcSecondary[num-10] : paletteSecondary[num];
}

vec3 getEmissive(int num) {
  return num > 9 ? paletteNpcEmissive[num-10] : paletteEmissive[num];
}
`;
var b0 = `
#define DEFERRED_PHONG

#include <common_ubo_pars>

out float yPos;
out float vHolo;
out float vHeight;
out float vFly;
out float vState;
out float vInstanceID;
#ifndef USE_UV
  out vec2 vUv;
#endif
out vec3 mPos;
out vec4 vInstanceColor;
out vec3 vWorldPosition;


// snoise
vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec2 mod289(vec2 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec3 permute(vec3 x) {
  return mod289(((x * 34.0) + 1.0) * x);
}
float snoise(vec2 v) {
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i = floor(v + dot(v, C.yy));
  vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod289(i);
  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.0);
  m = m * m;
  m = m * m;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);
  vec3 g;
  g.x = a0.x * x0.x + h.x * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}


mat4 scale(float x, float y, float z) {
  return mat4(vec4(x, 0.0, 0.0, 0.0), vec4(0.0, y, 0.0, 0.0), vec4(0.0, 0.0, z, 0.0), vec4(0.0, 0.0, 0.0, 1.0));
}



#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>
#include <batching_pars_uniforms>

#include <shadows_pars_vertex>

#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

  out vec3 vViewPosition;

#endif

void main() {

	#ifdef USE_UV

	  vUv = uv;

  #endif

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>

	#include <begin_vertex>

	#include <batchingbase_vertex>
// #endif

	#include <defaultnormal_vertex>
  // normal
	#include <normal_vertex>

	#include <morphtarget_vertex>
	
  

  // skinning
  float holo = 0.;
  float height = 1.;
  float fly = 0.;
  float slide = 0.;
  vec4 extraUniforms = vec4(0.);
  #ifdef USE_BATCHING_UNIFORM_color
  vInstanceColor = getBatchUniform(batching_color_texture, 4);
  #endif

  #ifdef USE_BATCHING_UNIFORM_extra
  extraUniforms = getBatchUniform(batching_extra_texture, 4);
  height = extraUniforms.x;
  fly = extraUniforms.z;
  slide = extraUniforms.w;
  //holo = extraUniforms.y;
  #endif

  vUv = uv;
  vFly = fly;

  vState = slide;
  float windFactor = vState * 2.;
  
  vHeight = height;
  #ifdef USE_SKINNING
    vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
    vec4 skinned = vec4( 0.0 );
    skinned += boneMatX * skinVertex * skinWeight.x;
    skinned += boneMatY * skinVertex * skinWeight.y;
    skinned += boneMatZ * skinVertex * skinWeight.z;
    skinned += boneMatW * skinVertex * skinWeight.w;
    vec3 temp = ( bindMatrixInverse * skinned ).xyz;

    float flyFactor =  1. + windFactor * 6.;
    float noiseX = (time * flyFactor / 4. - transformed.x / 2.0) * 1. + 2. * holo + flyFactor;
    float noiseY = (time * flyFactor - transformed.y / 2.0) * 1. + 2. * holo + flyFactor;
    float noise = 1.0 - snoise(vec2(noiseX, noiseY));
    if (transformed.y > .0) {
      skinned.x += noise * (1. - smoothstep(-2. * 1., 2.2 * 1., transformed.y)) * smoothstep(.3, 3., transformed.y) * (1. - windFactor * 3.);
      skinned.z -= noise * (1. - smoothstep(-2. * 1., 2.2 * 1., transformed.y)) * smoothstep(.3, 3., transformed.y) * (1. - windFactor * 3.);
    }
    skinned.y +=  2. * holo;
    transformed = ( bindMatrixInverse * skinned ).xyz;
  #endif

  #ifdef USE_BATCHING
    transformed = ( batchingMatrix * vec4( transformed, 1.0 ) ).xyz;
  #endif

  if (vState > 0.5) {
    transformed.y += 1. / height * .1;
  }

	#include <displacementmap_vertex>
  // project vertex  
  float holoSmooth = smoothstep(0.5, 1., holo);

  #ifdef USE_BATCHING_UNIFORM_extra
    vHolo = extraUniforms.y;
  #endif

  #include <cellshading_vertex>

  vec4 mvPosition = vec4(transformed, 1.0);

  #ifdef USE_SKINNING

  #else
  float noise = 0.0;
  noise = 1.0 - (snoise(vec2((time / 4. - transformed.x / 2.0) * 1. + 2. * holo, (time / 1. - transformed.y / 2.0) * 1. + 2. * holo)));
  if (mvPosition.y > .4) {
    mvPosition.x += noise / 2.5 / min(1., height) * (1. - smoothstep(-2. * height, 3.2 * height, mvPosition.y)) * smoothstep(.3, 3., mvPosition.y);
    mvPosition.z -= noise / 2.5 / min(1., height) * (1. - smoothstep(-2. * height, 3.2 * height, mvPosition.y)) * smoothstep(.3, 3., mvPosition.y);
  }

  #endif

  vec4 mPosition = modelMatrix * mvPosition;

  yPos = position.y;



  mPosition.y += holoSmooth * .2;

  // mPosition = scale(1. - holoSmooth * 1., 1. + holoSmooth * .5, 1. - holoSmooth * 1.) * mPosition;
  mPosition = scale(1., 1. + holoSmooth * (mPosition.y < 0. ? -.5 : .5), 1.) * mPosition;
  mPos = position.xyz;
  mvPosition = viewMatrix * mPosition;

  vWorldPosition = mPosition.xyz;
  vNormal = normalMatrix * normal;
  gl_Position = projectionMatrix * mvPosition;

	vec4 worldPosition = mPosition;

  #include <shadows_vertex>

}
`;
const w0 = /* @__PURE__ */ W({ map: null, mapTransform: new n.Matrix3(), emissiveEnable: 1 }, b0, `

in float yPos;
in float vHolo;
in float vHeight;
in float vFly;
in float vInstanceID;
in float vState;
in vec3 vWorldPosition;
#ifndef USE_UV
  in vec2 vUv;
#endif
in vec3 mPos;

in vec4 vInstanceColor;


#include <common_ubo_pars>
uniform float emissiveEnable;

#include <layout_pars_fragment>
#include <introanimation_pars_fragment>

const vec3 palettePrimary[10] = vec3[10](
  ${bi("ancient", "primary")}
);

const vec3 paletteSecondary[10] = vec3[10](
  ${bi("ancient", "secondary")}
);

const vec3 paletteEmissive[10] = vec3[10](
  ${bi("ancient", "third")}
);

${y0}
  
  float circ(float d, float x, float y){
    return d + sqrt( x*x*x*x*x*x + y*y*y*y*y*y );
  }
  vec3 mod289(vec3 x) {return x - floor(x * (1.0 / 289.0)) * 289.0;} vec2 mod289(vec2 x) {return x - floor(x * (1.0 / 289.0)) * 289.0;} vec3 permute(vec3 x) {return mod289(((x*34.0)+1.0)*x);} float snoise(vec2 v){const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439); vec2 i  = floor(v + dot(v, C.yy) ); vec2 x0 = v -   i + dot(i, C.xx); vec2 i1; i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0); vec4 x12 = x0.xyxy + C.xxzz; x12.xy -= i1; i = mod289(i); vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 )) + i.x + vec3(0.0, i1.x, 1.0 )); vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0); m = m*m ; m = m*m ; vec3 x = 2.0 * fract(p * C.www) - 1.0; vec3 h = abs(x) - 0.5; vec3 ox = floor(x + 0.5); vec3 a0 = x - ox; m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h ); vec3 g; g.x  = a0.x  * x0.x  + h.x  * x0.y; g.yz = a0.yz * x12.xz + h.yz * x12.yw; return 130.0 * dot(m, g);}
  
  vec4 roundVec(vec4 x){
    vec4 a = vec4(1.);
    a.x = round(x.x * 100.)/ 100.;
    a.y = round(x.y * 100.)/ 100.;
    a.z = round(x.z * 100.)/ 100.;
    a.w = round(x.w * 100.)/ 100.;
    return a;
  }

  vec3 roundVec(vec3 x){
    vec3 a = vec3(1.);
    a.x = round(x.x * 100.)/ 100.;
    a.y = round(x.y * 100.)/ 100.;
    a.z = round(x.z * 100.)/ 100.;
    return a;
  }

  //fix for some GPU
  int roundInt(float x){
    return int(round(x * 100.)/ 100.);
  }
  ivec4 roundVecInt(vec4 x){
    ivec4 a = ivec4(1);
    a.x = roundInt(x.x);
    a.y = roundInt(x.y);
    a.z = roundInt(x.z);
    a.w = roundInt(x.w);
    return a;
  }


#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

  in vec3 vViewPosition;

#endif


#include <common>

#include <deferred_lights_pars>

float Bayer2(vec2 a) {
  a = floor(a);
  return fract(a.x / 2. + a.y * a.y * .75);
}

#define Bayer4(a)   (Bayer2 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer8(a)   (Bayer4 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer16(a)  (Bayer8 (.5 *(a)) * .25 + Bayer2(a))




#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
// map_pars_fragment
#ifdef USE_CUSTOM_MAP
  #ifdef USE_BATCHING_ARRAYMAP
    precision mediump sampler2DArray;
    uniform sampler2DArray map;
  #else
    uniform sampler2D map;
  #endif
#endif

#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

#include <shadows_pars_fragment>

void main() {
  if (vState > 0.5) {
    if (yPos < 1.5) {
      discard;
      return;
    }
  }
  float bwNFTs = 0.;

	vec4 diffuseColor = vec4(1.);


float glowAlpha = 0.;

vec3 diffuseBloom = vec3(0.);
vec4 base = vec4(1.);

base *= vec4(roundVec(vColor), 1.);

#ifndef USE_CUSTOM_MAP
  diffuseColor *= base;
#endif

ivec4 vCol = roundVecInt(vInstanceColor);

if (vCol[3] == 9) {
  bwNFTs = 0.;
}


bool r = base.r > 0.01;
bool g = base.g > 0.01;
bool b = base.b > 0.01;
vec3 emissiveVColor = vec3(1.);

#ifndef USE_CUSTOM_MAP
  emissiveVColor *= getEmissive(vCol[2]);
  // TODO Diffuse map custom here
  // primary
  if (base.rgb == vec3(1.)) {
    // TODO DISABLE SPECULAR ICI

    diffuseColor.rgb = getPrimary(vCol[0]);

    // NFT RENDER
    // float nft = getNFT(vCol[3], vUv, mPos, time);
    vec3 mid = getEmissive(vCol[2]);
    // diffuseColor.rgb = mix(diffuseColor.rgb, mid, nft);// end result color 
  }

  // secondary
  if (base.rgb == vec3(1.,0.0,0.)) {
    diffuseColor.rgb = getSecondary(vCol[1]);
  }

  // helmet
  if (base.rgb == vec3(0.)) {
    diffuseColor.rgb = vec3(0.,0.,0.);
  }

#endif

  #ifdef USE_BATCHING_UNIFORM_neon
    // if (base.g == 1. && base.b == 0. && base.r == 0.) {
      vec4 neonColor = getBatchUniform(batching_neon_texture, 4);
      emissiveVColor *= neonColor.rgb;
    // }
  #endif

  #ifdef USE_VERTEXCOLORONLY
    diffuseColor.rgb = vColor.rgb;
  #endif
  // if blue darker

  // TEMP ALSO ADD GREEN TO BLOOM 
    if (!r && g && !b) {
    diffuseColor.rgb = emissiveVColor.rgb;
    diffuseBloom.rgb = diffuseColor.rgb;
  }

  vec4 diffuseSkin = diffuseColor;
  diffuseSkin.rgb = mix(diffuseColor.rgb, diffuseColor.rgb, smoothstep(1., 2.0, diffuseColor.r + diffuseColor.g + diffuseColor.b));


  vec3 holoOutLight = vec3(1.);
  float holoOpacity = 0.;
  // small scanlines down
  if (vHolo > 0.0) {
    float fraclines = fract((yPos * 10.) + time * 4.);//small lines 
    float scanlines = step(fraclines, 0.2);// cut off based on 0.5
    // big scanline up
    float bigfracline = fract((yPos * 2.) + time * 3.);// big gradient line
    float bigfracline2 = fract((yPos * 1.) - time * 3.);// big gradient line

    holoOutLight = diffuseSkin.rgb + (bigfracline * 0.8 * vec3(1., 1., 0.));// end result color 
    holoOutLight = holoOutLight + (bigfracline2 * 0.8 * vec3(0.,1.,1.));// end result color 
    holoOutLight = holoOutLight + (scanlines * 0.4 * vec3(1., 1., 0.));// end result color 

    holoOpacity = vHolo * 1. * (scanlines + bigfracline * .5);// alpha based on scanlines and rim
  }

  diffuseColor = vec4( mix(diffuseSkin.rgb, holoOutLight, vHolo), diffuseColor.a - holoOpacity * 1. - vHolo);
  #ifdef USE_BATCHING
  if (vDrawId > 0. || vCol[3] == 9) {
    diffuseColor.rgb = mix(diffuseColor.rgb, vec3(.8), bwNFTs);
    diffuseColor.rgb += bwNFTs * .4;
  }
  #endif


  // map_fragment
  #if defined(USE_CUSTOM_MAP)
    vec4 sampledDiffuseColor = vec4(1.);
    #ifdef USE_BATCHING_ARRAYMAP
      sampledDiffuseColor *= texture( map, vec3( vUv, vTextureId ) );
    #else
      sampledDiffuseColor *= texture( map, vUv );
    #endif

    diffuseColor *= sampledDiffuseColor;

  #endif

	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>

  vec3 col = vec3(1.);

  // inner glow (esper)
  float glowOffset = 0.;
  glowOffset += vInstanceID * 100.;
  vec2 s = vUv * 2. - 1.;
  s += snoise(s + glowOffset + time * .75) * .15;
  vec2 d = 1. - abs(1.-vUv) * .2 * 1.;
  vec3 c = getEmissive(vCol[2]);
  vec3 color = vec3(circ(c.x, s.x, s.y), circ(c.y, s.x, s.y),  circ(c.z, s.x, s.y) ); // color circles			

    diffuseColor = mix(diffuseColor, vec4(color * .8, d), vFly);
    diffuseBloom.rgb += diffuseColor.rgb * vFly;
  if (vFly > 0.) {
    glowAlpha = 1.;
  }

  vec2 stateUniforms = vec2(0.);
  #ifdef USE_BATCHING_UNIFORM_state
    stateUniforms = getBatchUniform(batching_state_texture, 2).rg;
  #endif

  float death = saturate(stateUniforms.x + vHolo);
  float invulnerability = stateUniforms.y;

  // DEATH SHADER
  if ( death > 0.0 ) {
    float characterSize = 4.;
    float facDith = smoothstep(characterSize * death + 3. * pow(death, .2), characterSize * death, mPos.y);
    float facDith2 = smoothstep(characterSize * death + 5. * pow(death, .2), characterSize * death, mPos.y);
    float dithDeath = Bayer8(gl_FragCoord.xy * 2.) * (2. + facDith2 * 1.) - (2. - facDith2);

    if (dithDeath > 0.0) discard;
    diffuseColor.rgb = mix(diffuseColor.rgb, vec3(1.), facDith);
    diffuseColor.a = 1.;
    if (mPos.y < characterSize * death) discard;
  }



  vec4 o_color = vec4(vec3(0.), glowAlpha);

  if (vColor.rgb == vec3(1., 1., 0.)) {
    o_color.rgb = vec3(0., 0., 1.);
    glowAlpha = 0.;
  }
  if (!r && g && !b) {
    if (emissiveEnable > 0.) {
      diffuseColor.rgb = emissiveVColor.rgb;
      o_color.r = 1.;
    }
  }

  vec4 o_diffuse = diffuseColor;

  #include <shadows_fragment>
  float toonShading = 1.;

  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, shadow);

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  // #include <layout_output_fragment>


  #if defined(USE_DEFERRED)
    float shininess = 0.;
    // if (length(o_color.rg) < .1) {
    //   shininess = o_color.b;
    //   o_color.rgb = vec3(0.);
    // }
  #endif

  // if (length(o_color.gb) < .1) {
  //   o_color.rgb = vec3(0.);
  //   o_diffuse.rgb += o_color.r;
  // }

  #ifndef USE_BLOOM
    if (o_color.r > 0.) {
    o_diffuse.rgb *= 1. + 0.3 * o_color.r;
    }
  #endif

  gColor = linearToSRGB(o_diffuse);


  #ifndef USE_DEFERRED
    #ifdef USE_COMMON_UBO
      if (vInstanceID > 0.) {
        float playerAnimDist = distance(playerPos.xyz, o_position.xyz);
        gColor.rgb = introAnimation(1. - animProgress, playerAnimDist, 1000., gColor.rgb, o_normal, o_position.xyz, playerPos.xyz);
      }
    #endif
  #endif

  #if defined(USE_DEFERRED)
    gPosition = o_position;

    if (length(o_normal.rgb) > 0.) {
      o_normal.rgb = normalize( o_normal.rgb ) * 0.5 + 0.5;
    }
    gNormal = o_normal;
    #ifdef USE_BLOOM
      gVColor = o_color;
    #endif
  #elif defined(USE_BLOOM)
    gVColor = o_color;
  #endif

}
`, null), A0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ MetaSkinnedShaderImpl: w0 });
const Xr = /* @__PURE__ */ A.forwardRef(({ children: e, speed: t = 1, metaMap: a, collectionId: i, ...r }, l) => {
  const s = /* @__PURE__ */ Y((c) => c.useDeferred), o = /* @__PURE__ */ A.useRef(null);
  A.useImperativeHandle(l, () => o.current), _e(o);
  const f = /* @__PURE__ */ A.useMemo(() => a ? new n.Texture() : null, [a]), d = /* @__PURE__ */ se({ useShadows: true });
  return y("metaSkinnedShaderImpl", { glslVersion: n.GLSL3, ref: o, vertexColors: 2, cellShading: !s, "defines-USE_CUSTOM_MAP": a?.count >= 1, "defines-USE_BATCHING_ARRAYMAP": a?.count > 1, map: f, ...d, ...r, attach: "material", children: e }, i + A0);
});
Xr.displayName = "MetaSkinnedShader";
var C0 = `#include <common>

precision mediump float;
in vec3 normX;
in vec3 normY;
in vec3 normZ;
in float pAlpha;
float diffuse = 0.9;
float specular = 0.8;
float rstop = 0.1;
// pos orign r.ab
float ellipse(vec2 p, vec2 o, vec2 r) { 
    vec2 lp = (p - o) / r;
    return length(lp) - 1.0;
}
void main() {
	vec3 p = vec3(gl_PointCoord - vec2(0.5, 0.5), 0.0) * 2.0;
	vec3 d = vec3(0.0, 0.0, -1.0);
	float nd = normZ.z; //dot(-normZ, d);
	if(abs(nd) < 0.0001) discard;
	float np = dot(normZ, p);
    vec3 tp = p + d * np / nd;//dot(-normZ, d) / dot(-normZ, p);
	// Back 2D 
 	vec2 coord = vec2(dot(normX, tp), dot(normY, tp));
	// angle = 15 degree
	const float flwrsn = 0.258819045102521;
	const float flwrcs = 0.965925826289068;
	mat2 flwrm = mat2(flwrcs, -flwrsn, flwrsn, flwrcs);
	// abs => double [0,1]
	vec2 flwrp = vec2(abs(coord.x), coord.y) * flwrm;
	float r;
	if(flwrp.x < 0.0) {
	// middle part(double)
		r = ellipse(flwrp, vec2(0.065, 0.024) * 0.5, vec2(0.36, 0.96) * 0.5);
	} else {
		// out part(double)
		r = ellipse(flwrp, vec2(0.065, 0.024) * 0.5, vec2(0.58, 0.96) * 0.5);
	}
	if(r > rstop) discard;
    vec3 col = vec3(1.);
    
	float grady = mix(0.0, 1.0, pow(coord.y * 0.5 + 0.5, 0.35));
  	col *= vec3(1.0, grady, grady);
	col *= mix(0.8, 1.0, pow(abs(coord.x), 0.3));
  	col = col * diffuse + specular;
    
	float alphaS = (0.5 - r / (rstop * 1.0));
	alphaS = smoothstep(0.0, 1.0, alphaS) * pAlpha;
  float distCenter = distance(gl_PointCoord.xy, vec2(0.));

  float finalAlpha = 1.0; 
  
  if (finalAlpha <= 0.0) {
    discard;
  };


  pc_fragColor.a = finalAlpha;

  #include <tonemapping_fragment>
  #include <colorspace_fragment>
}
`, S0 = `in vec3 a_offset;
in vec3 a_euler;
out float pAlpha;
out vec3 normX;
out vec3 normY;
out vec3 normZ;
uniform float size;

void main() {
  #include <begin_vertex>

  transformed = a_offset;

  #include <project_vertex>
	pAlpha = (modelMatrix * vec4( a_offset, 1.0 )).y;
	gl_PointSize = (size) * (10. / -mvPosition.z);
    
	float pdist = length(mvPosition.xyz);
	// Caculate Normal
	vec3 elrsn = sin(a_euler);
 	vec3 elrcs = cos(a_euler);
 	mat3 rotx = mat3(
		1.0, 0.0, 0.0,
      0.0, elrcs.x, elrsn.x,
      0.0, -elrsn.x, elrcs.x
 	);
	mat3 roty = mat3(
      elrcs.y, 0.0, -elrsn.y,
      0.0, 1.0, 0.0,
      elrsn.y, 0.0, elrcs.y
	);
	mat3 rotz = mat3(
      elrcs.z, elrsn.z, 0.0, 
      -elrsn.z, elrcs.z, 0.0,
      0.0, 0.0, 1.0
	);
	mat3 rotmat = rotx * roty * rotz;
	mat3 trrotm = mat3(
      rotmat[0][0], rotmat[1][0], rotmat[2][0],
      rotmat[0][1], rotmat[1][1], rotmat[2][1],
      rotmat[0][2], rotmat[1][2], rotmat[2][2]
 	);
 	normX = trrotm[0];
 	normY = trrotm[1];
 	normZ = trrotm[2];
}
`;
const Kr = /* @__PURE__ */ W({ size: 0 }, S0, C0), P0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ PetalesShaderImpl: Kr });
const Zr = ({ speed: e = 1, ...t }) => (U((a) => a.viewport), y("petalesShaderImpl", { ...t, side: n.DoubleSide, attach: "material", size: Math.max(window.innerHeight * 130 / 1e3, 8) }, P0));
Zr.displayName = "PetalesShader";
var M0 = `#include <layout_pars_fragment>
uniform vec3 diffuse;
uniform float opacity;
uniform float factor;


in vec3 vWorldPosition;

in float vAngle;
in vec3 vV;
in vec3 vGlow;
in vec3 vViewDir;


#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

  in vec3 vViewPosition;

#endif


#include <common>

#include <common_ubo_pars>
#include <introanimation_pars_fragment>

uniform bool receiveShadow;

#if NUM_DIR_LIGHTS > 0

	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};

	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];

	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {

		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;

	}

#endif

#include <packing>
#include <color_pars_fragment>
#include <batching_pars_uniforms_fragment>
#include <batching_pars_uniforms>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <normalmap_pars_fragment>

#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>




float remap(float x, float a, float b, float c, float d) {
    return (((x - a) / (b - a)) * (d - c)) + c;
}
// Hash functions by Dave_Hoskins
float hash12(vec2 p) {
  uvec2 q = uvec2(ivec2(p)) * uvec2(1597334673U, 3812015801U);
  uint n = (q.x ^ q.y) * 1597334673U;
  return float(n) * (1.0 / float(0xffffffffU));
}

vec2 hash22(vec2 p) {
  uvec2 q = uvec2(ivec2(p))*uvec2(1597334673U, 3812015801U);
  q = (q.x ^ q.y) * uvec2(1597334673U, 3812015801U);
  return vec2(q) * (1.0 / float(0xffffffffU));
}

float perlin (vec2 uv) {
    vec2 id = floor(uv);
    vec2 gv = fract(uv);

    // Four corners in 2D of a tile
    float a = hash12(id);
    float b = hash12(id + vec2(1.0, 0.0));
    float c = hash12(id + vec2(0.0, 1.0));
    float d = hash12(id + vec2(1.0, 1.0));

    vec2 u = gv * gv * (3.0 - 2.0 * gv);

    return mix(a, b, u.x) +
            (c - a)* u.y * (1.0 - u.x) +
            (d - b) * u.x * u.y;
}

vec2 curl (vec2 uv)
{
    vec2 eps = vec2(0., 1.);
    
    float n1, n2, a, b;
    n1 = perlin(uv+eps);
    n2 = perlin(uv-eps);
    a = (n1-n2)/(2.*eps.y); // ∂x1/∂y
    
    n1 = perlin(uv+eps.yx);
    n2 = perlin(uv-eps.yx);
    b = (n1-n2)/(2.*eps.y); // ∂y1/∂x
    
    return vec2(a, -b);
}

float worley(vec2 uv, float freq, float t)
{
    uv *= freq;
    uv += t;
    
    vec2 id = floor(uv);
    vec2 gv = fract(uv);
    
    float minDist = 100.;
    for (float y = -1.; y <= 1.; ++y)
    {
        for(float x = -1.; x <= 1.; ++x)
        {
            vec2 offset = vec2(x, y);
            vec2 h = hash22(id + offset) * .8 + .1; // .1 - .9
        h += offset;
            vec2 d = gv - h;
            minDist = min(minDist, dot(d, d));
        }
    }
    
    return minDist + .4;
}
vec2 Rotate(vec2 xy, float angle){
  return vec2(xy.x*cos(angle) - xy.y*sin(angle), xy.x*sin(angle) + xy.y*cos(angle));
}

vec2 Triangle(vec2 uv, float c){
  float r = 0.5235988;
  vec2 o = uv;
  o.x = floor(uv.x * c + 0.5);
  o.y = mix(floor(Rotate(uv * c + 0.5, r).y), floor(Rotate(uv * c + 0.5, -r).y), 0.5);
  o.y *= 1.154700555; // This shifts the Y channel back into a -0.5 to +0.5 range, otherwise scrolling the pattern actually changes the output range as well
  return o / c;
}
vec2 TriangleUV(vec2 uv, float c, float r, float s){
  uv = Rotate(uv, r);
  // Fix alignment (based on the pre-rendered lines)
  // uv.x += (1.0/c)*0.25;
  // uv.y -= 0.01;
  // Larger numbers (over 10k) hit major issues with value rounding.
  // Scrolling needs to be within a much smaller range, so this is designed for a 0-1 loop.
  // The magic number scales the scrolling value to a compatible loop point.
  uv.y += s;// * 1.154700555;
  uv = Triangle(uv, c);
  // Invert the vertical scroll so the output UV values remain static, just the pattern scrolls
  uv.y -= s;// * 1.154700555;
  uv = Rotate(uv, -r);
  uv += 0.5;

  return uv;
}

// Worley noise fbm using uvs offset by curl noise
vec3 fbmCurlWorley(vec2 uv, float freq, float t)
{
    float worley1 = 1. - worley(uv, freq * 2., t * 2.);
    float worley2 = 1. - worley(uv, freq * 4., t * 4.);
    float worley3 = 1. - worley(uv, freq * 8., t * 8.);
    float worley4 = 1. - worley(uv, freq * 16., t * 16.);
    
    float fbm1 = worley1 * .625 + worley2 * .25 + worley3 * .125;
    float fbm2 = worley2 * .625 + worley3 * .25 + worley4 * .125;
    float fbm3 = worley3 * .75 + worley4 * .25;
    return vec3(fbm1, fbm2, fbm3);
}

float getFresnel(vec3 vNorm, vec3 vDir) {
    float dp = dot(normalize(vNorm), normalize(vDir));
    return 1.0 - abs(dp);
}


void main() {

	vec4 diffuseColor = vec4( diffuse, opacity );
  // map_fragment
  #ifdef USE_MAP
    vec3 uFresnel = vec3(-.1, -1.82, 1.5);
    float fresnel = getFresnel(vNormal, vViewDir);

    vec2 uv = vMapUv;
    uv = TriangleUV(uv, 30., 1., 1.);
    float t = time * .3;

    uv.x += curl(uv * 10. + t).x; // offset uvs for advection

    vec3 curlWorleyFbm = fbmCurlWorley(uv, 1., t);
    float curlWorley = curlWorleyFbm.r * .9 + curlWorleyFbm.g * .325 + 
        curlWorleyFbm.b * .125;

    vec3 col = vec3(0.);
    col += remap(curlWorley, 0., 1., .25, 1.);

    vec2 uv2 = vMapUv;
    uv2 *= .7;
    // uv2.x *= -1.;

    uv2 -= 0.5;
    uv2.y += 0.2;
    uv2.x -= vAngle * 0.1;

    uv2.x += 0.5;
    uv2.y += 0.5;

    vec4 sampledDiffuseColor = texture2D( map, uv2 + col.xy / 20. );

    sampledDiffuseColor += pow(col.y * 1.1, 10.);

    fresnel = smoothstep(uFresnel.x, -uFresnel.y, fresnel);
    float fresnelfade = saturate(fresnel * 2.);

    sampledDiffuseColor.rgb = sampledDiffuseColor.rgb + fresnelfade;
    sampledDiffuseColor.a = 1.;
    #ifdef DECODE_VIDEO_TEXTURE
      sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
    #endif
  diffuseColor *= sampledDiffuseColor;
  #endif
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>

  // albedo
  diffuseColor = mix(diffuseColor, vec4(1.), fresnelfade);

  vec4 o_diffuse = diffuseColor;

  float shadow = 1. - getShadowMask();
  float toonShading = .5;

  vec4 o_color = vec4(fresnelfade);
  vec4 o_normal = vec4(normal, toonShading);
  vec4 o_position = vec4(vWorldPosition, shadow);

  #include <layout_output_fragment>
}
`, D0 = `
#define DEFERRED_PHONG

uniform vec2 repeat;
uniform float factor;


out vec3 vWorldPosition;

out vec3 vGlow;
out vec3 vV;
out vec3 vViewDir;
out float vAngle;


#include <common>

#include <common_ubo_pars>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>

#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

  out vec3 vViewPosition;

#endif



// snoise
vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec2 mod289(vec2 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec3 permute(vec3 x) {
  return mod289(((x * 34.0) + 1.0) * x);
}
float snoise(vec2 v) {
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i = floor(v + dot(v, C.yy));
  vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod289(i);
  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.0);
  m = m * m;
  m = m * m;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);
  vec3 g;
  g.x = a0.x * x0.x + h.x * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

//https://www.geeks3d.com/20141201/how-to-rotate-a-vertex-by-a-quaternion-in-glsl/
vec3 rotateVectorByQuaternion(vec3 v, vec4 q) {
  return 2.0 * cross(q.xyz, v * q.w + cross(q.xyz, v)) + v;
}

void main() {

	#include <color_vertex>
  #include <uv_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>


  vec3 transformedNormal = objectNormal;

  #ifdef USE_INSTANCING

    // this is in lieu of a per-instance normal-matrix
    // shear transforms in the instance matrix are not supported

    mat3 m = mat3( instanceMatrix );

    transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );

    transformedNormal = m * transformedNormal;

  #endif

  transformedNormal = normalMatrix * transformedNormal;

  #ifdef FLIP_SIDED

    transformedNormal = - transformedNormal;

  #endif

  #ifdef USE_TANGENT

    vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;

    #ifdef FLIP_SIDED

      transformedTangent = - transformedTangent;

    #endif

  #endif

	// #include <defaultnormal_vertex>

  // normal
	#include <normal_vertex>

  // begin_vertex
	float noise = 1.0 - (snoise(vec2((time * 1. - position.x / 10000.0), (time * .2 - position.z / 10000.0)))); 
  //Apply wind
  float halfAngle = noise * 0.5 * factor;

  vec3 transformed = rotateVectorByQuaternion(position, normalize(vec4(sin(halfAngle), 0.0, -sin(halfAngle), cos(halfAngle))));
  transformed.x += sin(noise) * 40. * factor;
  transformed.z -= cos(noise) * 40. * factor;

	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>

  vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;
  
  gl_Position = projectionMatrix * mvPosition;
  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif




	#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

	  vViewPosition = - mvPosition.xyz;

  #endif

	worldPosition = modelMatrix * worldPosition;

  // portal shader
  vViewDir = -vec3(modelViewMatrix * vec4(position, 1.0));
  vV = (viewMatrix * vec4(cameraPosition,1.)).xyz;
  vec3 n = mat3(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz) * vec3(0.0, 0.0, 1.0);
  vAngle = dot(cross(n, vec3(0.0, 1.0, 0.0)), normalize(-vV));

  // position
  vWorldPosition = (worldPosition).xyz;

  #include <shadowmap_vertex>

}
`;
const E0 = /* @__PURE__ */ W({ cameraPosition: new n.Vector3(), diffuse: new n.Color(16777215), map: null, mapTransform: new n.Matrix3(), opacity: 1, noiseScale: 1, factor: 0 }, D0, M0), T0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ PortalShaderImpl: E0 });
const Jr = /* @__PURE__ */ A.forwardRef((e, t) => {
  const a = /* @__PURE__ */ Ie((i) => i.commonUbo);
  return y("portalShaderImpl", { ref: t, glslVersion: n.GLSL3, side: n.FrontSide, uniformsGroups: [a], vertexColors: 2, ...e, attach: "material" }, T0);
});
Jr.displayName = "PortalShader";
var I0 = `#include <layout_pars_fragment>
in vec3 vWorldPosition;
in vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	in vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	in vec2 vUvBatch;
#endif

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
uniform float metalness;
uniform sampler2D alphaMap;

in float vTint;

#ifdef USE_MAP
  #ifdef USE_BATCH_MAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray map;

  #else
    uniform sampler2D map;
  #endif
#endif


#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float vUv2;

#endif

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>



uniform mat4 modelViewMatrix;
struct PointLight {
  vec4 position; // position.w is the distance
  vec4 color; // color w is the intensity
};

uniform LightingData {
  // ambient
  vec4 ambient;
  // rgb = ambient color
  // w = ambient intensity;

  // diffuse
  vec4 diffuse;
  // rgb = diffuse color
  // w = diffuse intensity;

  // specular
  vec4 specular;
  // rgb = specular color
  // w = float shininess;

  vec4 position;
} Light;

float fresnelSchlick(float cosTheta, float f0) {
  return f0 + (1.0 - f0) * pow(1.0 - cosTheta, 5.0);
}

#ifdef USE_LIGHTS_POINT
uniform PointLightData {
  PointLight pointLight[LIGHTS_POINT_MAX];
};
#endif

vec3 getGradientIrradiance(float dotNL) {
  vec2 coord = vec2(dotNL * 0.5 + 0.5, 0.0);

  vec2 fw = fwidth(coord) * 0.5;
  vec3 backColor = mix(vec3(0.65), vec3(0.7), smoothstep(0.65, 0.7, coord.x));

  vec3 res = coord.x < 0.7 ? backColor : vec3(1.0);

  return res;
}

float getDistanceAttenuation(
  float lightDistance,
  float cutoffDistance,
  float decayExponent
) {
  float distanceFalloff = 1.0 / max(pow(lightDistance, decayExponent), 0.01);

  if (cutoffDistance > 0.0) {
    distanceFalloff *= pow2(
      saturate(1.0 - pow4(lightDistance / cutoffDistance))
    );
  }

  return distanceFalloff;
}
vec3 getPointLighting(
  PointLight pointLight,
  vec3 position,
  vec3 normal,
  float toonShadingFactor,
  float shininess
) {
  vec3 offset = pointLight.position.xyz - position.xyz;
  vec3 lightDir = normalize(offset);
  float distance = length(offset);

  // energy-conserving-wrapped diffuse implemenatation
  float w = 0.45;
  float dotNL = saturate((dot(normal, lightDir) + w) / ((1.0 + w) * (1.0 + w)));
  // float dotNL = max(0.0, dot(normal, lightDir));
  float attenuation = 1.0 / (distance * distance);
  float distanceFalloff = getDistanceAttenuation(
    distance,
    pointLight.position.w,
    0.0
  );

  vec3 irradiance = pointLight.color.xyz;

  // if (toonShadingFactor == 1.0) {
  //   irradiance *= getGradientIrradiance(dotNL);
  // }

  vec3 viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( cameraPosition - position );

  vec3 reflectDir = reflect(-lightDir, normal);

  float spec = pow(max(dot(viewDir, reflectDir), 0.0), 13.0);

  float cosTheta = max(dot(viewDir, reflectDir), 0.0);
  float fresnel = 1.; // 0.04 is the default value for F0 (dielectric materials)
  // float fresnel = fresnelSchlick(cosTheta, 0.14); // 0.04 is the default value for F0 (dielectric materials)

  float fresnelRim = fresnelSchlick(cosTheta, 0.04);

  float specularStrength = shininess;
  vec3 specular = specularStrength * spec * pointLight.color.xyz;

  vec3 lightWeighting =
    (irradiance + specular) * pointLight.color.w * distanceFalloff;



  float rim = max(dot(viewDir, normal), 0.0);
  float rimPower = 2.0; // You can adjust this value to control the rim lighting tightness
  rim = pow(rim, rimPower);
  float rimIntensity = 0.1; // Adjust this value to control the intensity of the rim lighting
  rim *= rimIntensity;

  vec3 lighting = lightWeighting * (1.0 + dotNL * 2.0) + rim;

  return saturate(lighting);
}

vec3 getDirectLighting(
  vec3 position,
  vec3 normal,
  float toonShadingFactor,
  float shininess,
  float bloom
) {
  vec3 mvpDirLight = (modelViewMatrix * vec4(Light.position.xyz, .1)).xyz;
  // diffuse
  vec3 lightDir = normalize(mvpDirLight - position.xyz);

  // energy-conserving-wrapped diffuse implemenatation
  float w = 0.45;
  float dotNL = saturate((dot(normal, lightDir) + w) / ((1.0 + w) * (1.0 + w)));
  // float dotNL = max(dot(normal.rgb, lightDir), 0.0);

  vec3 irradiance = Light.diffuse.rgb;
  // toon shading if normal.a = 1
  // if (toonShadingFactor == 1.0) {
  //   irradiance *= getGradientIrradiance(dotNL);
  // }

  // no ortho camera condition needed
  vec3 viewDir = normalize(cameraPosition - mvpDirLight);
  vec3 reflectDir = reflect(-lightDir, normal.xyz);

  float cosTheta = max(dot(viewDir, reflectDir), 0.0);
  float fresnel = 1.; // 0.04 is the default value for F0 (dielectric materials)
  // float fresnel = fresnelSchlick(cosTheta, 0.14); // 0.04 is the default value for F0 (dielectric materials)

  float spec = pow(max(dot(viewDir, reflectDir), 0.0), 32.0);
  float specularStrength = shininess;
  vec3 specular = specularStrength * spec * Light.diffuse.rgb * fresnel;

  float fresnelRim = fresnelSchlick(cosTheta, 0.04);

  float rim = max(dot(viewDir, normal), 0.0);
  float rimPower = 2.0; // You can adjust this value to control the rim lighting tightness
  rim = pow(rim, rimPower);
  float rimIntensity = 0.1; // Adjust this value to control the intensity of the rim lighting
  rim *= rimIntensity;

  vec3 diffuse = dotNL * (irradiance + specular) * max(0.0, Light.diffuse.w + min(1., bloom / 8.)) + rim;

  return dotNL * (irradiance + specular);
}


// #include <deferred_lights_pars>

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

#include <packing>
#include <color_pars_fragment>
#ifdef USE_BATCHING

	in float vDrawId;
  #ifdef USE_BATCH_MAPS
    in float vTextureId;
  #endif
  #ifdef USE_BATCH_NORMALMAPS
    in float vNormalTextureId;
  #endif
#endif

#include <batching_pars_uniforms>
#include <uv_pars_fragment>

#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <emissivemap_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>

in vec3 vViewPosition;

#ifdef USE_NORMALMAP

  #ifdef USE_BATCH_NORMALMAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray normalMap;

  #else
    uniform sampler2D normalMap;
  #endif

	// Normal Mapping Without Precomputed Tangents
	// http://www.thetenthplanet.de/archives/1180

	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {

		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );

		vec3 N = surf_norm; // normalized

		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );

		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;

		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );

		return mat3( T * scale, B * scale, N );

	}


#endif

// #include <nearbyplayers_ubo_pars>

float Bayer2(vec2 a) {
  a = floor(a);
  return fract(a.x / 2. + a.y * a.y * .75);
}

#define Bayer4(a)   (Bayer2 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer8(a)   (Bayer4 (.5 *(a)) * .25 + Bayer2(a))
#define Bayer16(a)  (Bayer8 (.5 *(a)) * .25 + Bayer2(a))


#include <envmap_common_pars_fragment>

#include <shadows_pars_fragment>
uniform float isPainting;

void main() {

	vec4 diffuseColor = vec4( vColor, opacity );
	vec3 totalEmissiveRadiance = vec3(0.);

  float metalness = 0.;

  #ifdef USE_BATCHING_UNIFORM_effects

    // dithering
    float dither = vEffects.w;
    float dithered = Bayer16(gl_FragCoord.xy) * (1. + dither * 1.) - (1. - dither * 1.);

    if (dithered >= -0.0001) discard;

  #endif

	// #include <map_fragment>
  vec4 sampledDiffuseColor = vec4(1.);

  #if defined(USE_MAP)
  
    #ifdef USE_BATCH_MAPS
      if (vTextureId > 0.) {
        vec2 uv = vMapUv * vUv2;
        #ifdef USE_BATCHING_UNIFORM_uv
          uv *= vUvBatch;
        #endif
        sampledDiffuseColor *= texture( map, vec3( uv, vTextureId - 1.) );
      }
    #else
      sampledDiffuseColor *= texture( map, vMapUv );
    #endif

    diffuseColor *= sampledDiffuseColor;

  #endif

	#include <alphamap_fragment>
	#include <alphatest_fragment>


	#include <normal_fragment_begin>

  #if defined( USE_NORMALMAP ) || defined( USE_ANISOTROPY )

    #ifdef USE_TANGENT

      mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );

    #else

      mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );

    #endif

    #if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )

      tbn[0] *= faceDirection;
      tbn[1] *= faceDirection;

    #endif

  #endif


	// #include <normalmap_fragment>
  #if defined(USE_NORMALMAP)
    vec2 uvNormal = vNormalMapUv.xy;
    vec3 mapN;
    #ifdef USE_BATCH_NORMALMAPS
      if (vNormalTextureId > 0.) {
        uvNormal = uvNormal;
        #ifdef USE_BATCHING_UNIFORM_uv
          uvNormal *= vUvBatch;
        #endif
        vec4 mapNormal = texture( normalMap, vec3( uvNormal, vNormalTextureId - 1.) );

        mapN.xy = mapNormal.ga;              // Load in [0,1]
        mapN.xy = mapN.xy * 2.0 - 1.0;           // Unpack to [-1,1]
        mapN.z = sqrt(1. - dot(mapN.xy, mapN.xy)); // Compute Z


        // mapN.xy *= 2.;
      }
    #else
      mapN = texture( normalMap, uvNormal ).xyz * 2.0 - 1.0;
    #endif

    // TODO support batch normal scale?
    // mapN.xy *= normalScale;
    mapN.xy *= 2.;
    #ifdef USE_BATCH_NORMALMAPS
      if (vNormalTextureId > 0.) {
      	normal = normalize( tbn * mapN );
      }
    #else 
      normal = normalize( tbn * mapN );
    #endif

  #endif

	#include <emissivemap_fragment>

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>


  // albedo
  vec4 totalEmissive = vec4(totalEmissiveRadiance, saturate(length(totalEmissiveRadiance)));

  // tint
  diffuseColor.rgb *= (1. - vTint);
  diffuseColor.rgb = saturate(diffuseColor.rgb);


  vec4 outgoingLight = diffuseColor;

  // #include <envmap_fragment>




  vec4 o_color = vec4(vec3(0., 0., 0.), 1.);

  #ifdef USE_BATCHING_UNIFORM_effects
    // bloom
    o_color.r = vEffects.x;
    // ssao
    o_color.g = vEffects.y;
    
    // metalness (* 10 for exageration)
    metalness = vEffects.z;
    o_color.b = metalness * 10.;
    
  #endif



  #ifdef USE_ENVMAP


  vec3 cameraToFrag;

  if ( isOrthographic ) {

    cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );

  } else {

    cameraToFrag = normalize( vWorldPosition - cameraPosition );

  }

  // Transforming Normal Vectors with the Inverse Transformation
  vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
  vec3 reflectVec = reflect( cameraToFrag, worldNormal );

  vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );

  #ifdef DEBUG_ENVMAP
    gColor = vec4(envColor.rgb, 1.);
    gVColor = vec4(0.);
    return;
  #endif

  outgoingLight.rgb = mix( outgoingLight.rgb, mix(outgoingLight.rgb, envColor.xyz, 0.5), saturate(metalness) );
  // outgoingLight.rgb = envColor.xyz;

#endif


  vec4 o_diffuse = linearToSRGB(outgoingLight);

  #include <shadows_fragment>
  // specular shiny reflection
  float toonShading = 0.5;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif

  vec4 o_normal = vec4(normal, toonShading);

  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  #include <layout_output_fragment>

  // #include <nearbyplayers_fragment>

#pragma optimize(off)

// circle system for office:
// #ifdef USE_NEARBYPLAYERS
// float circleRadius = 1.5;

// float callFactor = smoothstep(0.5, .75, playerPos.w);
// float focusFactor = smoothstep(0.75, 1., playerPos.w);


// float sdf = circleSDF(playerPos.xyz, circleRadius, .4);

// sdf = smoothUnion(sdf, circleSDF(nearbyPlayer1.xyz, circleRadius, .4), 1.);
// sdf = smoothUnion(sdf, circleSDF(nearbyPlayer2.xyz, circleRadius, .4), 1.);
// sdf = smoothUnion(sdf, circleSDF(nearbyPlayer3.xyz, circleRadius, .4), 1.);
// sdf = smoothUnion(sdf, circleSDF(nearbyPlayer4.xyz, circleRadius, .4), 1.);
// sdf = smoothUnion(sdf, circleSDF(nearbyPlayer5.xyz, circleRadius, .4), 1.);

// float isAvailable = 1.0;
// if (playerPos.w == 0.25) {
//   isAvailable = 0.0;
// }


// vec3 circleColorUnavailable = vec3(0.953, 0.192, 0.51);
// vec3 circleColorAvailable = vec3(1.);

// if (focusFactor > 0.) {
//   // gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b), focusFactor * .5);
//   float currentPlayerCirclePrivate = circleSDFSimple(playerPos.xyz, circleRadius + focusFactor * 200.);
//   gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b), focusFactor);

//   if (smoothstep(0.0, 0.02, currentPlayerCirclePrivate) < 1.0) {
//     gColor.rgb = mix(gColor.rgb, vec3(0.21 * gColor.r + 0.71 * gColor.g + 0.3 * gColor.b) - o_normal.g * .3, .6 * focusFactor);
//   }
// }

// if (smoothstep(0.0, 0.02, sdf) < 1.0) {
//   gColor.rgb = mix(gColor.rgb, circleColorAvailable, (1. - smoothstep(0.0, 0.02, sdf)) * .3);
// }


// if (isAvailable == 0.0) {
//   float currentPlayerCircle = circleSDF(playerPos.xyz, circleRadius, .4);
//   if (smoothstep(0.0, 0.02, currentPlayerCircle) < 1.0) {
//     gColor.rgb = mix(gColor.rgb, circleColorUnavailable, (1. - smoothstep(0.0, 0.02, currentPlayerCircle)) * .3);
//   }
// }



// Nearest intensity
// vec4 playerPositions[5];
// playerPositions[0] = nearbyPlayer1;
// playerPositions[1] = nearbyPlayer2;
// playerPositions[2] = nearbyPlayer3;
// playerPositions[3] = nearbyPlayer4;
// playerPositions[4] = nearbyPlayer5;

// for (int i = 0; i < 5; i++) {
//     float dist = distance(playerPos.xyz, playerPositions[i].xyz);

//     if (playerPositions[i].w == 0.25) {
//       float innerBusy = circleSDF(playerPositions[i].xyz, circleRadius, .4);
//       if (smoothstep(0.0, 0.02, innerBusy) < 1.0) {
//         gColor.rgb = mix(gColor.rgb, circleColorUnavailable, (1. - smoothstep(0.0, 0.02, circleSDF(playerPositions[i].xyz, circleRadius, .4))) * .3);
//       }
//       continue;
//     }
    
//     if (dist <= 4.) {
      
//         float pulseDistance = smoothstep(4.0, 3., dist);


//         if (playerPositions[i].w == 0.25 || playerPos.w == 0.25) {
//           focusFactor = 0.0;
//           circleRadius = 0.;
//         }

//         float a = 1. - (.1 * (((sin(time * 3.5)) + 1.) / 2.)) * (1. - callFactor);
//         a -= callFactor * .3;

//         float sdfInner = circleSDF(playerPos.xyz, circleRadius * a * pulseDistance, .4);
//         float sdfInnerOut = circleSDF(playerPositions[i].xyz, circleRadius * a * pulseDistance, .4);

//         sdfInner = smoothUnion(sdfInner, sdfInnerOut, pulseDistance + callFactor);

//         float contactFactor = 1. - smoothstep(0. + 0.98 * (1. - pulseDistance), 0.02 + 0.98 * (1. - pulseDistance), sdfInner);

//         if (playerPositions[i].w == 0.25 || playerPos.w == 0.25) {
//           contactFactor = 0.;
//         }

//         gColor.rgb = mix(gColor.rgb, mix(vec3(0.035,0.235,0.745), vec3(0.953,0.192,0.51), focusFactor), contactFactor * (.5 * pulseDistance) );
//     }
// }

// gColor.rgb += circleColor;
// #endif
// end circle system for office
  gColor = saturate(gColor);

}
`, U0 = `
#define DEFERRED_PHONG

out vec3 vWorldPosition;
out vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	out vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	out vec2 vUvBatch;
#endif

in float _tint;
out float vTint;

#include <common>
#include <common_ubo_pars>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>

#ifdef USE_BATCH_MAPS

  out float vTextureId;

#endif

out vec3 vViewPosition;

#ifdef USE_BATCH_NORMALMAPS

  out float vNormalTextureId;

#endif

#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float _uvscale;
  out float vUv2;

#endif


#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

#include <shadowmap_pars_vertex>

#include <shadows_pars_vertex>

void main() {

  #include <uv_vertex>

  vTint = _tint;

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>

  #include <batchingbase_vertex>

  // normal




  #ifdef USE_BATCHING_UNIFORM_color
    vColor = getBatchUniform( batching_color_texture, 4 ).rgb;
  #endif

  #ifdef USE_BATCHING_UNIFORM_effects
    vEffects = getBatchUniform( batching_effects_texture, 4 ).rgba;
  #endif

  #ifdef USE_BATCHING_UNIFORM_uv
    vUvBatch = getBatchUniform( batching_uv_texture, 2 ).rg;
  #endif

  #if defined(USE_MAP) && defined(USE_BATCH_MAPS) && defined(USE_BATCHING_UNIFORM_map) && defined(USE_MULTI_DRAW)
  	vTextureId = texelFetch(batching_map_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined(USE_NORMALMAP) && defined(USE_BATCH_NORMALMAPS) && defined(USE_BATCHING_UNIFORM_normalMap) && defined(USE_MULTI_DRAW)
  	vNormalTextureId = texelFetch(batching_normalMap_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)
    
    vUv2 = _uvscale;

  #endif



  #include <begin_vertex>

  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif

	#ifdef USE_BATCHING

		worldPosition = batchingMatrix * worldPosition;

	#endif
	worldPosition = modelMatrix * worldPosition;

  // position
  vWorldPosition = (worldPosition).xyz;


  #include <defaultnormal_vertex>


	#include <normal_vertex>


	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>

  #include <cellshading_vertex>


	 vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  

  mvPosition = modelMatrix * mvPosition;
  // mvPosition = mix(mvPosition, vec4(vec3( vUvPaint * 2. - 1. ,0.), 1.), sin(time * .2) * .5 + .5);
  mvPosition = viewMatrix * mvPosition;

  gl_Position = projectionMatrix * mvPosition;

  vViewPosition = - mvPosition.xyz;

  #include <shadows_vertex>

}
`;
const B0 = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), map: null, mapTransform: new n.Matrix3(), normalMap: null, alphaMap: null, opacity: 1, alphaTest: 0.5, metalness: 0, envMap: null, flipEnvMap: 0, diffuse: new n.Color(16777215), repeat: new n.Vector2(1, 1), normalScale: new n.Vector2(1, 1), normalMapTransform: new n.Matrix3(), uPaintMap: null, uNoise: null }, U0, I0, null), k0 = /* @__PURE__ */ n.MathUtils.generateUUID(), R0 = (e) => {
  const t = /* @__PURE__ */ I({});
  return e.map && (t.current.map = e.map, t.current["map-colorSpace"] = n.LinearSRGBColorSpace), e.normalMap && (t.current.normalMap = e.normalMap, t.current["normalMap-colorSpace"] = n.LinearSRGBColorSpace), t.current;
};
N({ KonpiShaderImpl: B0 });
const $r = /* @__PURE__ */ Z(({ useShadows: e = true, ...t }, a) => {
  const i = /* @__PURE__ */ Y((f) => f.useDeferred), r = /* @__PURE__ */ I();
  ge(a, () => r.current), _e(r);
  const l = /* @__PURE__ */ se({ useShadows: e }), s = /* @__PURE__ */ R0(t), o = /* @__PURE__ */ zt(["px.webp", "nx.webp", "py.webp", "ny.webp", "pz.webp", "nz.webp"], { path: v["/img/cube/sumi/"] });
  return y("konpiShaderImpl", { attach: "material", ref: r, isMeshGouraudMaterial: true, glslVersion: n.GLSL3, envMap: o, ...l, ...t, ...s, transmission: 0, cellShading: t.defines?.USE_TOON ? !i : null, blending: i ? t.blending || n.NoBlending : n.NormalBlending, side: t.side || n.FrontSide, metalness: t.metalness, diffuse: t.color }, k0);
});
$r.displayName = "KonpiShader";
const L0 = `

out vec3 vWorldPosition;
out vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	out vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	out vec2 vUvBatch;
#endif

in float _tint;
out float vTint;

#include <common>

#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>

#ifdef USE_BATCH_MAPS

  out float vTextureId;

#endif

#ifdef USE_NORMALMAP 
	out vec3 vViewPosition;
#endif

#ifdef USE_BATCH_NORMALMAPS

  out float vNormalTextureId;

#endif

#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float _uvscale;
  out float vUv2;

#endif


#include <batching_pars_vertex>
#include <batching_skinning_pars_vertex>

#include <batching_pars_uniforms>

#include <shadowmap_pars_vertex>

#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_BUMPMAP )

  out vec3 vViewPosition;

#endif


#include <shadows_pars_vertex>


void main() {

  #include <uv_vertex>

  vTint = _tint;

	#include <color_vertex>

	#include <morphcolor_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>

  // normal

  #include <begin_vertex>
  #include <batchingbase_vertex>
  #include <defaultnormal_vertex>


	#include <normal_vertex>


  #ifdef USE_BATCHING_UNIFORM_color
    vColor = getBatchUniform( batching_color_texture, 4 ).rgb;
  #endif

  #ifdef USE_BATCHING_UNIFORM_effects
    vEffects = getBatchUniform( batching_effects_texture, 4 ).rgba;
  #endif

  #ifdef USE_BATCHING_UNIFORM_uv
    vUvBatch = getBatchUniform( batching_uv_texture, 2 ).rg;
  #endif

  #if defined(USE_MAP) && defined(USE_BATCH_MAPS) && defined(USE_BATCHING_UNIFORM_map) && defined(USE_MULTI_DRAW)
  	vTextureId = texelFetch(batching_map_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined(USE_NORMALMAP) && defined(USE_BATCH_NORMALMAPS) && defined(USE_BATCHING_UNIFORM_normalMap) && defined(USE_MULTI_DRAW)
  	vNormalTextureId = texelFetch(batching_normalMap_texture, ivec3(0, 0, vDrawId), 0).r;
  #endif

  #if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)
    
    vUv2 = _uvscale;

  #endif

	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>

  #include <cellshading_vertex>

	 vec4 mvPosition = vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPosition = batchingMatrix * mvPosition;
  #endif
  #ifdef USE_INSTANCING
  
    mvPosition = instanceMatrix * mvPosition;
  
  #endif
  
  mvPosition = modelViewMatrix * mvPosition;
  
  gl_Position = projectionMatrix * mvPosition;
	#if defined( USE_NORMALMAP )

  vViewPosition = - mvPosition.xyz;

  #endif

  vec4 worldPosition = vec4( transformed, 1.0 );

	#ifdef USE_INSTANCING

		worldPosition = instanceMatrix * worldPosition;

	#endif

	#ifdef USE_BATCHING

		worldPosition = batchingMatrix * worldPosition;

	#endif



	worldPosition = modelMatrix * worldPosition;

  // position
  vWorldPosition = (worldPosition).xyz;

  #include <shadows_vertex>

}

`, z0 = `
#include <layout_pars_fragment>
in vec3 vWorldPosition;
in vec3 vColor;

#ifdef USE_BATCHING_UNIFORM_effects
	in vec4 vEffects;
#endif

#ifdef USE_BATCHING_UNIFORM_uv
	in vec2 vUvBatch;
#endif

uniform vec3 diffuse;
uniform float opacity;
uniform float metalness;
uniform sampler2D alphaMap;

in float vTint;

#ifdef USE_MAP
  #ifdef USE_BATCH_MAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray map;

  #else
    uniform sampler2D map;
  #endif
#endif


#if defined (USE_BATCH_MAPS) || defined(USE_BATCH_NORMALMAPS)

  in float vUv2;

#endif

in vec2 vUv;

#include <common>
#include <common_ubo_pars>
#include <introanimation_pars_fragment>

#include <deferred_lights_pars>

vec4 linearToSRGB(vec4 color) {
  return mix(pow(color, vec4(1.0 / 2.4)), color * 12.92, lessThan(color, vec4(0.0031308)));
}

#include <packing>
#include <color_pars_fragment>
#ifdef USE_BATCHING

	in float vDrawId;
  #ifdef USE_BATCH_MAPS
    in float vTextureId;
  #endif
  #ifdef USE_BATCH_NORMALMAPS
    in float vNormalTextureId;
  #endif
#endif

#include <batching_pars_uniforms>
#include <uv_pars_fragment>

#include <alphamap_pars_fragment>
// #include <alphatest_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>

#ifdef USE_NORMALMAP

	in vec3 vViewPosition;

  #ifdef USE_BATCH_NORMALMAPS
    precision mediump sampler2DArray;
    uniform sampler2DArray normalMap;

  #else
    uniform sampler2D normalMap;
  #endif

	// Normal Mapping Without Precomputed Tangents
	// http://www.thetenthplanet.de/archives/1180

	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {

		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );

		vec3 N = surf_norm; // normalized

		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );

		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;

		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );

		return mat3( T * scale, B * scale, N );

	}


#endif

float noise(vec2 uv) {
  return fract(sin(dot(uv, vec2(12.9898, 78.233))) * 43758.5453);
}


// snoise
vec3 mod289(vec3 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 mod289(vec4 x) {
  return x - floor(x * (1.0 / 289.0)) * 289.0;
}

vec4 permute(vec4 x) {
     return mod289(((x*34.0)+1.0)*x);
}

vec4 taylorInvSqrt(vec4 r)
{
  return 1.79284291400159 - 0.85373472095314 * r;
}

float snoise(vec3 v)
  {
  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

// First corner
  vec3 i  = floor(v + dot(v, C.yyy) );
  vec3 x0 =   v - i + dot(i, C.xxx) ;

// Other corners
  vec3 g = step(x0.yzx, x0.xyz);
  vec3 l = 1.0 - g;
  vec3 i1 = min( g.xyz, l.zxy );
  vec3 i2 = max( g.xyz, l.zxy );

  //   x0 = x0 - 0.0 + 0.0 * C.xxx;
  //   x1 = x0 - i1  + 1.0 * C.xxx;
  //   x2 = x0 - i2  + 2.0 * C.xxx;
  //   x3 = x0 - 1.0 + 3.0 * C.xxx;
  vec3 x1 = x0 - i1 + C.xxx;
  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y
  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y

// Permutations
  i = mod289(i);
  vec4 p = permute( permute( permute(
             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

// Gradients: 7x7 points over a square, mapped onto an octahedron.
// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)
  float n_ = 0.142857142857; // 1.0/7.0
  vec3  ns = n_ * D.wyz - D.xzx;

  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)

  vec4 x_ = floor(j * ns.z);
  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

  vec4 x = x_ *ns.x + ns.yyyy;
  vec4 y = y_ *ns.x + ns.yyyy;
  vec4 h = 1.0 - abs(x) - abs(y);

  vec4 b0 = vec4( x.xy, y.xy );
  vec4 b1 = vec4( x.zw, y.zw );

  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;
  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;
  vec4 s0 = floor(b0)*2.0 + 1.0;
  vec4 s1 = floor(b1)*2.0 + 1.0;
  vec4 sh = -step(h, vec4(0.0));

  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

  vec3 p0 = vec3(a0.xy,h.x);
  vec3 p1 = vec3(a0.zw,h.y);
  vec3 p2 = vec3(a1.xy,h.z);
  vec3 p3 = vec3(a1.zw,h.w);

//Normalise gradients
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x;
  p1 *= norm.y;
  p2 *= norm.z;
  p3 *= norm.w;

// Mix final noise value
  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
  m = m * m;
  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                dot(p2,x2), dot(p3,x3) ) );
  }

#include <envmap_common_pars_fragment>

#include <shadows_pars_fragment>

void main() {


  float metalness = 0.;


	#include <alphamap_fragment>
	// #include <alphatest_fragment>


	#include <normal_fragment_begin>

  #if defined( USE_NORMALMAP ) || defined( USE_ANISOTROPY )

    #ifdef USE_TANGENT

      mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );

    #else

      mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );

    #endif

    #if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )

      tbn[0] *= faceDirection;
      tbn[1] *= faceDirection;

    #endif

  #endif


	// #include <normalmap_fragment>
  #if defined(USE_NORMALMAP)
    vec2 uvNormal = vNormalMapUv.xy;
    vec3 mapN;
    #ifdef USE_BATCH_NORMALMAPS
      if (vNormalTextureId > 0.) {
        uvNormal = uvNormal;
        #ifdef USE_BATCHING_UNIFORM_uv
          uvNormal *= vUvBatch;
        #endif
        vec4 mapNormal = texture( normalMap, vec3( uvNormal, vNormalTextureId - 1.) );

        mapN.xy = mapNormal.ga;              // Load in [0,1]
        mapN.xy = mapN.xy * 2.0 - 1.0;           // Unpack to [-1,1]
        mapN.z = sqrt(1. - dot(mapN.xy, mapN.xy)); // Compute Z


        // mapN.xy *= 2.;
      }
    #else
      mapN = texture( normalMap, uvNormal ).xyz * 2.0 - 1.0;
    #endif

    // TODO support batch normal scale?
    // mapN.xy *= normalScale;
    mapN.xy *= 2.;
    #ifdef USE_BATCH_NORMALMAPS
      if (vNormalTextureId > 0.) {
      	normal = normalize( tbn * mapN );
      }
      #else 
      	normal = normalize( tbn * mapN );
      #endif

  #endif

	// modulation
	// #include <aomap_fragment>
	#include <premultiplied_alpha_fragment>


  vec3 viewDirection = normalize(cameraPosition - vWorldPosition);

  float noiseValue = snoise(vWorldPosition.xyz * .02 + time * .3);

  float fresnel = dot(viewDirection, vNormal);
  // float fresnel = dot(viewDirection, vNormal + vec3(noiseValue * 0.1));

  // float distortedFresnel = dot(viewDirection, vNormal);
  fresnel = clamp((1.0 - fresnel) * 2.0, 0.0, 1.0);


  // fresnel = clamp((1.0 - fresnel) * 2.0, 0.0, 1.0);
  // fresnel *= 1.0 + (noise(vWorldPosition.xz * 5.0) - 0.5) * 0.2; 

  // Thin-film interference simulation
  float interference = (cos(2.0 * 3.14159 * fresnel) + 1.0) * 0.5;

  vec3 iridescence = vec3(
      sin(2.0 * 3.14159 * (fresnel + 0.00)) * 0.5 + 0.5,
      sin(2.0 * 3.14159 * (fresnel + 0.33)) * 0.5 + 0.5,
      sin(2.0 * 3.14159 * (fresnel + 0.67)) * 0.5 + 0.5
  );



  vec4 o_color = vec4(vec3(0., 0., 0.), 1.);


  vec3 finalColor = iridescence;

  #ifdef USE_ENVMAP

    vec3 cameraToFrag;

    if ( isOrthographic ) {

      cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );

    } else {

      cameraToFrag = normalize( vWorldPosition - cameraPosition );

    }

    // Transforming Normal Vectors with the Inverse Transformation
    vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
    vec3 reflectVec = reflect( cameraToFrag, worldNormal );

    vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );

    // Composite the iridescence over the reflection
    finalColor = mix(envColor.rgb, iridescence, interference);
  
  #else

    finalColor = iridescence * interference;
  #endif


  float alpha = pow(fresnel, 2.0);
  vec4 outgoingLight = vec4(finalColor, alpha);

  vec4 o_diffuse = linearToSRGB(outgoingLight);

  // #include <shadows_fragment>
  #ifdef USE_SHADOWS

    float cosTheta = dot(normalize((modelViewMatrix * vec4(Light.position.xyz, 1.)).xyz), vNormal);

    vec2 shadowMapSize = vec2(textureSize(shadowMap, 0).xy);

    float bias = max(vShadowBias * (1.0 - cosTheta), vShadowBias);

    float shadowFactor = 0.;
    vec2 texelSize = 1.0 / shadowMapSize;

    // Calculate the shadow factor using the Poisson disk
    for (int i = 0; i < 2; i++) {
      // int index = 0;
      int index = int(16.0 * noiseRandom(vec4(floor(vWorldPosition.xyz * 600.0), i))) % 16;
      float poissonShadow = 1.0 - texture(shadowMap, vec3(vShadowCoord.xy + poissonDisk[index] / shadowMapSize.x, (vShadowCoord.z - bias) / vShadowCoord.w));
      shadowFactor += 1. / 2.0 * poissonShadow;
    }


    bvec4 inFrustumVec = bvec4 ( vShadowCoord.x >= 0.0, vShadowCoord.x <= 1.0, vShadowCoord.y >= 0.0, vShadowCoord.y <= 1.0 );
    bool inFrustum = all( inFrustumVec );

    bvec2 frustumTestVec = bvec2( inFrustum, vShadowCoord.z <= 1.0 );
    bool frustumTest = all( frustumTestVec );

    if(frustumTest == false){
        shadowFactor = 0.0;
    }

    float difLight = max(0., cosTheta);

    float shadow = saturate(shadowFactor * difLight);

  #endif
  // specular shiny reflection
  float toonShading = 0.5;
  #if defined(USE_TOON)
    toonShading = 1.;
  #endif

  vec4 o_normal = vec4(normal, toonShading);

  vec4 o_position = vec4(vWorldPosition, 1.);
  #ifdef USE_SHADOWS
    o_position.w = shadow;
  #endif

  #ifndef USE_DEFERRED
    #include <forward_lights_fragment>
  #endif
  #include <layout_output_fragment>
  // gColor = saturate(gColor);


}

`, F0 = /* @__PURE__ */ W({ shadowMap: new n.Texture({ compareFunction: n.LessEqualDepth, type: n.UnsignedShortType, format: n.DepthFormat, generateMipmaps: false }), map: null, mapTransform: new n.Matrix3(), normalMap: null, alphaMap: null, opacity: 1, alphaTest: 0.5, metalness: 0, envMap: null, flipEnvMap: 0, diffuse: new n.Color(16777215), repeat: new n.Vector2(1, 1), normalScale: new n.Vector2(1, 1), normalMapTransform: new n.Matrix3() }, L0, z0, null), N0 = /* @__PURE__ */ n.MathUtils.generateUUID();
N({ BubbleSoapMaterialImpl: F0 });
const eo = /* @__PURE__ */ Z(({ useShadows: e = true, children: t, ...a }, i) => {
  const r = /* @__PURE__ */ Y((f) => f.useDeferred), l = /* @__PURE__ */ I();
  ge(i, () => l.current), _e(l);
  const s = /* @__PURE__ */ se({ useShadows: e }), o = /* @__PURE__ */ zt(["px.png", "nx.png", "py.png", "ny.png", "pz.png", "nz.png"], { path: v["/img/cube/irid/"] });
  return y("bubbleSoapMaterialImpl", { attach: "material", ref: l, isMeshGouraudMaterial: true, glslVersion: n.GLSL3, envMap: o, transparent: true, ...s, ...a, cellShading: a.defines?.USE_TOON ? !r : null, blending: r ? a.blending || n.NoBlending : n.NormalBlending, metalness: a.metalness, diffuse: a.color }, N0);
});
eo.displayName = "BubbleSoapMaterial";
const to = ({ borderShape: e, backShape: t, borderColor: a, backgroundColor: i = 16777215, side: r, graphId: l, backgroundOpacity: s = 1, borderOpacity: o = 1, ...f }) => {
  const d = /* @__PURE__ */ I();
  return G(() => {
    if (d.current && l && t) {
      const { geometriesCached: c } = /* @__PURE__ */ Dn();
      c[l] = d.current.geometry, En({ geometriesCached: c });
    }
  }, [d, l, t]), H("mesh", { ...f, ref: d, renderOrder: -1, position: [0, 0, -0.1], onUpdate: (c) => {
    c.updateMatrix();
  }, children: [y("shapeGeometry", { args: [t] }), y("meshBasicMaterial", { color: i, side: r, opacity: s, transparent: s < 1, depthWrite: true })] });
};
function wi(e, t, a, i, r, l, s = true, o = [0.15, 0.15, 0.15, 0.15], f = 0.75, d = 0.6, c = 0.1) {
  return o = Array.isArray(o) ? o.map((u) => u * l) : new Array(4).fill(o * l), f *= l, d *= l, c *= l, i += f, r += d, t -= i / 2, a -= r / 2, e.moveTo(t, a + o[0]), e.lineTo(t, a + r - o[2]), e.quadraticCurveTo(t, a + r, t + o[2], a + r), e.lineTo(t + i - o[1], a + r), e.quadraticCurveTo(t + i, a + r, t + i, a + r - o[3]), e.lineTo(t + i, a + o[3]), e.quadraticCurveTo(t + i, a, t + i - o[3], a), s && (e.lineTo(t + i / 2 + c, a), e.lineTo(t + i / 2, a - c * 2), e.lineTo(t + i / 2 - c, a)), e.lineTo(t + o[0], a), e.quadraticCurveTo(t, a, t, a + o[0]), e;
}
function O0(e, t, a, i, r, l, s = 0.75, o = 0.6, f = 0.15) {
  return s *= l, o *= l, f *= l, i += s, r += o, t -= i / 2, a -= r / 2, e.moveTo(t + i, a + f), e.lineTo(t + i, a), e.lineTo(t + i - f, a), e.lineTo(t + i, a + f), e;
}
const G0 = [{ n: ["grinning", "grinning_face"], u: "1f600", a: "1.0", id: 0 }, { n: ["smiley", "smiling_face_with_open_mouth"], u: "1f603", a: "0.6", id: 1 }, { n: ["smile", "smiling_face_with_open_mouth_and_smiling_eyes"], u: "1f604", a: "0.6", id: 2 }, { n: ["grin", "grinning_face_with_smiling_eyes"], u: "1f601", a: "0.6", id: 3 }, { n: ["laughing", "satisfied", "smiling_face_with_open_mouth_and_tightly_closed_eyes"], u: "1f606", a: "0.6", id: 4 }, { n: ["sweat_smile", "smiling_face_with_open_mouth_and_cold_sweat"], u: "1f605", a: "0.6", id: 5 }, { n: ["rolling_on_the_floor_laughing"], u: "1f923", a: "3.0", id: 6 }, { n: ["joy", "face_with_tears_of_joy"], u: "1f602", a: "0.6", id: 7 }, { n: ["slightly_smiling_face"], u: "1f642", a: "1.0", id: 8 }, { n: ["upside_down_face", "upside_down_face"], u: "1f643", a: "1.0", id: 9 }, { n: ["melting_face"], u: "1fae0", a: "14.0", id: 10 }, { n: ["wink", "winking_face"], u: "1f609", a: "0.6", id: 11 }, { n: ["blush", "smiling_face_with_smiling_eyes"], u: "1f60a", a: "0.6", id: 12 }, { n: ["innocent", "smiling_face_with_halo"], u: "1f607", a: "1.0", id: 13 }, { n: ["smiling_face_with_3_hearts", "smiling_face_with_smiling_eyes_and_three_hearts"], u: "1f970", a: "11.0", id: 14 }, { n: ["heart_eyes", "smiling_face_with_heart_shaped_eyes"], u: "1f60d", a: "0.6", id: 15 }, { n: ["star_struck", "grinning_face_with_star_eyes"], u: "1f929", a: "5.0", id: 16 }, { n: ["kissing_heart", "face_throwing_a_kiss"], u: "1f618", a: "0.6", id: 17 }, { n: ["kissing", "kissing_face"], u: "1f617", a: "1.0", id: 18 }, { n: ["relaxed", "white_smiling_face"], u: "263a-fe0f", a: "0.6", id: 19 }, { n: ["kissing_closed_eyes", "kissing_face_with_closed_eyes"], u: "1f61a", a: "0.6", id: 20 }, { n: ["kissing_smiling_eyes", "kissing_face_with_smiling_eyes"], u: "1f619", a: "1.0", id: 21 }, { n: ["smiling_face_with_tear"], u: "1f972", a: "13.0", id: 22 }, { n: ["yum", "face_savouring_delicious_food"], u: "1f60b", a: "0.6", id: 23 }, { n: ["stuck_out_tongue", "face_with_stuck_out_tongue"], u: "1f61b", a: "1.0", id: 24 }, { n: ["stuck_out_tongue_winking_eye", "face_with_stuck_out_tongue_and_winking_eye"], u: "1f61c", a: "0.6", id: 25 }, { n: ["zany_face", "grinning_face_with_one_large_and_one_small_eye"], u: "1f92a", a: "5.0", id: 26 }, { n: ["stuck_out_tongue_closed_eyes", "face_with_stuck_out_tongue_and_tightly_closed_eyes"], u: "1f61d", a: "0.6", id: 27 }, { n: ["money_mouth_face", "money_mouth_face"], u: "1f911", a: "1.0", id: 28 }, { n: ["hugging_face"], u: "1f917", a: "1.0", id: 29 }, { n: ["face_with_hand_over_mouth", "smiling_face_with_smiling_eyes_and_hand_covering_mouth"], u: "1f92d", a: "5.0", id: 30 }, { n: ["face_with_open_eyes_and_hand_over_mouth"], u: "1fae2", a: "14.0", id: 31 }, { n: ["face_with_peeking_eye"], u: "1fae3", a: "14.0", id: 32 }, { n: ["shushing_face", "face_with_finger_covering_closed_lips"], u: "1f92b", a: "5.0", id: 33 }, { n: ["thinking_face"], u: "1f914", a: "1.0", id: 34 }, { n: ["saluting_face"], u: "1fae1", a: "14.0", id: 35 }, { n: ["zipper_mouth_face", "zipper_mouth_face"], u: "1f910", a: "1.0", id: 36 }, { n: ["face_with_raised_eyebrow", "face_with_one_eyebrow_raised"], u: "1f928", a: "5.0", id: 37 }, { n: ["neutral_face"], u: "1f610", a: "0.7", id: 38 }, { n: ["expressionless", "expressionless_face"], u: "1f611", a: "1.0", id: 39 }, { n: ["no_mouth", "face_without_mouth"], u: "1f636", a: "1.0", id: 40 }, { n: ["dotted_line_face"], u: "1fae5", a: "14.0", id: 41 }, { n: ["face_in_clouds"], u: "1f636-200d-1f32b-fe0f", a: "13.1", id: 42 }, { n: ["smirk", "smirking_face"], u: "1f60f", a: "0.6", id: 43 }, { n: ["unamused", "unamused_face"], u: "1f612", a: "0.6", id: 44 }, { n: ["face_with_rolling_eyes"], u: "1f644", a: "1.0", id: 45 }, { n: ["grimacing", "grimacing_face"], u: "1f62c", a: "1.0", id: 46 }, { n: ["face_exhaling"], u: "1f62e-200d-1f4a8", a: "13.1", id: 47 }, { n: ["lying_face"], u: "1f925", a: "3.0", id: 48 }, { n: ["relieved", "relieved_face"], u: "1f60c", a: "0.6", id: 49 }, { n: ["pensive", "pensive_face"], u: "1f614", a: "0.6", id: 50 }, { n: ["sleepy", "sleepy_face"], u: "1f62a", a: "0.6", id: 51 }, { n: ["drooling_face"], u: "1f924", a: "3.0", id: 52 }, { n: ["sleeping", "sleeping_face"], u: "1f634", a: "1.0", id: 53 }, { n: ["mask", "face_with_medical_mask"], u: "1f637", a: "0.6", id: 54 }, { n: ["face_with_thermometer"], u: "1f912", a: "1.0", id: 55 }, { n: ["face_with_head_bandage", "face_with_head_bandage"], u: "1f915", a: "1.0", id: 56 }, { n: ["nauseated_face"], u: "1f922", a: "3.0", id: 57 }, { n: ["face_vomiting", "face_with_open_mouth_vomiting"], u: "1f92e", a: "5.0", id: 58 }, { n: ["sneezing_face"], u: "1f927", a: "3.0", id: 59 }, { n: ["hot_face", "overheated_face"], u: "1f975", a: "11.0", id: 60 }, { n: ["cold_face", "freezing_face"], u: "1f976", a: "11.0", id: 61 }, { n: ["woozy_face", "face_with_uneven_eyes_and_wavy_mouth"], u: "1f974", a: "11.0", id: 62 }, { n: ["dizzy_face"], u: "1f635", a: "0.6", id: 63 }, { n: ["face_with_spiral_eyes"], u: "1f635-200d-1f4ab", a: "13.1", id: 64 }, { n: ["exploding_head", "shocked_face_with_exploding_head"], u: "1f92f", a: "5.0", id: 65 }, { n: ["face_with_cowboy_hat"], u: "1f920", a: "3.0", id: 66 }, { n: ["partying_face", "face_with_party_horn_and_party_hat"], u: "1f973", a: "11.0", id: 67 }, { n: ["disguised_face"], u: "1f978", a: "13.0", id: 68 }, { n: ["sunglasses", "smiling_face_with_sunglasses"], u: "1f60e", a: "1.0", id: 69 }, { n: ["nerd_face"], u: "1f913", a: "1.0", id: 70 }, { n: ["face_with_monocle"], u: "1f9d0", a: "5.0", id: 71 }, { n: ["confused", "confused_face"], u: "1f615", a: "1.0", id: 72 }, { n: ["face_with_diagonal_mouth"], u: "1fae4", a: "14.0", id: 73 }, { n: ["worried", "worried_face"], u: "1f61f", a: "1.0", id: 74 }, { n: ["slightly_frowning_face"], u: "1f641", a: "1.0", id: 75 }, { n: ["frowning_face", "white_frowning_face"], u: "2639-fe0f", a: "0.7", id: 76 }, { n: ["open_mouth", "face_with_open_mouth"], u: "1f62e", a: "1.0", id: 77 }, { n: ["hushed", "hushed_face"], u: "1f62f", a: "1.0", id: 78 }, { n: ["astonished", "astonished_face"], u: "1f632", a: "0.6", id: 79 }, { n: ["flushed", "flushed_face"], u: "1f633", a: "0.6", id: 80 }, { n: ["pleading_face", "face_with_pleading_eyes"], u: "1f97a", a: "11.0", id: 81 }, { n: ["face_holding_back_tears"], u: "1f979", a: "14.0", id: 82 }, { n: ["frowning", "frowning_face_with_open_mouth"], u: "1f626", a: "1.0", id: 83 }, { n: ["anguished", "anguished_face"], u: "1f627", a: "1.0", id: 84 }, { n: ["fearful", "fearful_face"], u: "1f628", a: "0.6", id: 85 }, { n: ["cold_sweat", "face_with_open_mouth_and_cold_sweat"], u: "1f630", a: "0.6", id: 86 }, { n: ["disappointed_relieved", "disappointed_but_relieved_face"], u: "1f625", a: "0.6", id: 87 }, { n: ["cry", "crying_face"], u: "1f622", a: "0.6", id: 88 }, { n: ["sob", "loudly_crying_face"], u: "1f62d", a: "0.6", id: 89 }, { n: ["scream", "face_screaming_in_fear"], u: "1f631", a: "0.6", id: 90 }, { n: ["confounded", "confounded_face"], u: "1f616", a: "0.6", id: 91 }, { n: ["persevere", "persevering_face"], u: "1f623", a: "0.6", id: 92 }, { n: ["disappointed", "disappointed_face"], u: "1f61e", a: "0.6", id: 93 }, { n: ["sweat", "face_with_cold_sweat"], u: "1f613", a: "0.6", id: 94 }, { n: ["weary", "weary_face"], u: "1f629", a: "0.6", id: 95 }, { n: ["tired_face"], u: "1f62b", a: "0.6", id: 96 }, { n: ["yawning_face"], u: "1f971", a: "12.0", id: 97 }, { n: ["triumph", "face_with_look_of_triumph"], u: "1f624", a: "0.6", id: 98 }, { n: ["rage", "pouting_face"], u: "1f621", a: "0.6", id: 99 }, { n: ["angry", "angry_face"], u: "1f620", a: "0.6", id: 100 }, { n: ["face_with_symbols_on_mouth", "serious_face_with_symbols_covering_mouth"], u: "1f92c", a: "5.0", id: 101 }, { n: ["smiling_imp", "smiling_face_with_horns"], u: "1f608", a: "1.0", id: 102 }, { n: ["imp"], u: "1f47f", a: "0.6", id: 103 }, { n: ["skull"], u: "1f480", a: "0.6", id: 104 }, { n: ["skull_and_crossbones"], u: "2620-fe0f", a: "1.0", id: 105 }, { n: ["poop", "shit", "hankey", "pile_of_poo"], u: "1f4a9", a: "0.6", id: 106 }, { n: ["clown_face"], u: "1f921", a: "3.0", id: 107 }, { n: ["japanese_ogre"], u: "1f479", a: "0.6", id: 108 }, { n: ["japanese_goblin"], u: "1f47a", a: "0.6", id: 109 }, { n: ["ghost"], u: "1f47b", a: "0.6", id: 110 }, { n: ["alien", "extraterrestrial_alien"], u: "1f47d", a: "0.6", id: 111 }, { n: ["alien_monster", "space_invader"], u: "1f47e", a: "0.6", id: 112 }, { n: ["robot_face"], u: "1f916", a: "1.0", id: 113 }, { n: ["smiley_cat", "smiling_cat_face_with_open_mouth"], u: "1f63a", a: "0.6", id: 114 }, { n: ["smile_cat", "grinning_cat_face_with_smiling_eyes"], u: "1f638", a: "0.6", id: 115 }, { n: ["joy_cat", "cat_face_with_tears_of_joy"], u: "1f639", a: "0.6", id: 116 }, { n: ["heart_eyes_cat", "smiling_cat_face_with_heart_shaped_eyes"], u: "1f63b", a: "0.6", id: 117 }, { n: ["smirk_cat", "cat_face_with_wry_smile"], u: "1f63c", a: "0.6", id: 118 }, { n: ["kissing_cat", "kissing_cat_face_with_closed_eyes"], u: "1f63d", a: "0.6", id: 119 }, { n: ["scream_cat", "weary_cat_face"], u: "1f640", a: "0.6", id: 120 }, { n: ["crying_cat_face"], u: "1f63f", a: "0.6", id: 121 }, { n: ["pouting_cat", "pouting_cat_face"], u: "1f63e", a: "0.6", id: 122 }, { n: ["see_no_evil", "see_no_evil_monkey"], u: "1f648", a: "0.6", id: 123 }, { n: ["hear_no_evil", "hear_no_evil_monkey"], u: "1f649", a: "0.6", id: 124 }, { n: ["speak_no_evil", "speak_no_evil_monkey"], u: "1f64a", a: "0.6", id: 125 }, { n: ["kiss", "kiss_mark"], u: "1f48b", a: "0.6", id: 126 }, { n: ["love_letter"], u: "1f48c", a: "0.6", id: 127 }, { n: ["cupid", "heart_with_arrow"], u: "1f498", a: "0.6", id: 128 }, { n: ["gift_heart", "heart_with_ribbon"], u: "1f49d", a: "0.6", id: 129 }, { n: ["sparkling_heart"], u: "1f496", a: "0.6", id: 130 }, { n: ["heartpulse", "growing_heart"], u: "1f497", a: "0.6", id: 131 }, { n: ["heartbeat", "beating_heart"], u: "1f493", a: "0.6", id: 132 }, { n: ["revolving_hearts"], u: "1f49e", a: "0.6", id: 133 }, { n: ["two_hearts"], u: "1f495", a: "0.6", id: 134 }, { n: ["heart_decoration"], u: "1f49f", a: "0.6", id: 135 }, { n: ["heart_exclamation", "heavy_heart_exclamation_mark_ornament"], u: "2763-fe0f", a: "1.0", id: 136 }, { n: ["broken_heart"], u: "1f494", a: "0.6", id: 137 }, { n: ["heart_on_fire"], u: "2764-fe0f-200d-1f525", a: "13.1", id: 138 }, { n: ["mending_heart"], u: "2764-fe0f-200d-1fa79", a: "13.1", id: 139 }, { n: ["heart", "heavy_black_heart"], u: "2764-fe0f", a: "0.6", id: 140 }, { n: ["orange_heart"], u: "1f9e1", a: "5.0", id: 141 }, { n: ["yellow_heart"], u: "1f49b", a: "0.6", id: 142 }, { n: ["green_heart"], u: "1f49a", a: "0.6", id: 143 }, { n: ["blue_heart"], u: "1f499", a: "0.6", id: 144 }, { n: ["purple_heart"], u: "1f49c", a: "0.6", id: 145 }, { n: ["brown_heart"], u: "1f90e", a: "12.0", id: 146 }, { n: ["black_heart"], u: "1f5a4", a: "3.0", id: 147 }, { n: ["white_heart"], u: "1f90d", a: "12.0", id: 148 }, { n: ["100", "hundred_points_symbol"], u: "1f4af", a: "0.6", id: 149 }, { n: ["anger", "anger_symbol"], u: "1f4a2", a: "0.6", id: 150 }, { n: ["boom", "collision", "collision_symbol"], u: "1f4a5", a: "0.6", id: 151 }, { n: ["dizzy", "dizzy_symbol"], u: "1f4ab", a: "0.6", id: 152 }, { n: ["sweat_drops", "splashing_sweat_symbol"], u: "1f4a6", a: "0.6", id: 153 }, { n: ["dash", "dash_symbol"], u: "1f4a8", a: "0.6", id: 154 }, { n: ["hole"], u: "1f573-fe0f", a: "0.7", id: 155 }, { n: ["bomb"], u: "1f4a3", a: "0.6", id: 156 }, { n: ["speech_balloon"], u: "1f4ac", a: "0.6", id: 157 }, { n: ["eye_in_speech_bubble", "eye_in_speech_bubble"], u: "1f441-fe0f-200d-1f5e8-fe0f", a: "2.0", id: 158 }, { n: ["left_speech_bubble"], u: "1f5e8-fe0f", a: "2.0", id: 159 }, { n: ["right_anger_bubble"], u: "1f5ef-fe0f", a: "0.7", id: 160 }, { n: ["zzz", "sleeping"], u: "1f4a4", id: 1529 }, { n: ["wave", "waving_hand_sign"], u: "1f44b", id: 1530 }, { n: ["hand", "raised_hand"], u: "1f91a", id: 1531 }, { n: ["hand"], u: "1f590-fe0f", id: 1532 }, { n: ["hand", "raised_hand"], u: "270b", id: 1533 }, { n: ["spock-hand", "hand"], u: "1f596", id: 1534 }, { n: ["hand"], u: "1faf1", id: 1535 }, { n: ["hand"], u: "1faf2", id: 1536 }, { n: ["hand"], u: "1faf3", id: 1537 }, { n: ["hand"], u: "1faf4", id: 1538 }, { n: ["ok", "hand"], u: "1f44c", id: 1539 }, { n: ["pinched_fingers"], u: "1f90c", v: ["1f90c-1f3fb", "1f90c-1f3fc", "1f90c-1f3fd", "1f90c-1f3fe", "1f90c-1f3ff"], id: 1540 }, { n: ["pinching_hand"], u: "1f90f", v: ["1f90f-1f3fb", "1f90f-1f3fc", "1f90f-1f3fd", "1f90f-1f3fe", "1f90f-1f3ff"], id: 1541 }, { n: ["v", "victory"], u: "270c-fe0f", v: ["270c-1f3fb", "270c-1f3fc", "270c-1f3fd", "270c-1f3fe", "270c-1f3ff"], id: 1542 }, { n: ["crossed_fingers"], u: "1f91e", v: ["1f91e-1f3fb", "1f91e-1f3fc", "1f91e-1f3fd", "1f91e-1f3fe", "1f91e-1f3ff"], id: 1543 }, { n: ["hand"], u: "1faf0", v: ["1faf0-1f3fb", "1faf0-1f3fc", "1faf0-1f3fd", "1faf0-1f3fe", "1faf0-1f3ff"], id: 1544 }, { n: ["love", "hand"], u: "1f91f", v: ["1f91f-1f3fb", "1f91f-1f3fc", "1f91f-1f3fd", "1f91f-1f3fe", "1f91f-1f3ff"], id: 1545 }, { n: ["horns", "hand"], u: "1f918", v: ["1f918-1f3fb", "1f918-1f3fc", "1f918-1f3fd", "1f918-1f3fe", "1f918-1f3ff"], id: 1546 }, { n: ["call", "hand"], u: "1f919", v: ["1f919-1f3fb", "1f919-1f3fc", "1f919-1f3fd", "1f919-1f3fe", "1f919-1f3ff"], id: 1547 }, { n: ["left", "hand"], u: "1f448", v: ["1f448-1f3fb", "1f448-1f3fc", "1f448-1f3fd", "1f448-1f3fe", "1f448-1f3ff"], id: 1548 }, { n: ["right", "hand"], u: "1f449", v: ["1f449-1f3fb", "1f449-1f3fc", "1f449-1f3fd", "1f449-1f3fe", "1f449-1f3ff"], id: 1549 }, { n: ["up", "hand"], u: "1f446", v: ["1f446-1f3fb", "1f446-1f3fc", "1f446-1f3fd", "1f446-1f3fe", "1f446-1f3ff"], id: 1550 }, { n: ["down", "hand"], u: "1f447", v: ["1f447-1f3fb", "1f447-1f3fc", "1f447-1f3fd", "1f447-1f3fe", "1f447-1f3ff"], id: 1551 }, { n: ["up", "hand"], u: "261d-fe0f", v: ["261d-1f3fb", "261d-1f3fc", "261d-1f3fd", "261d-1f3fe", "261d-1f3ff"], id: 1552 }, { n: ["hand"], u: "1faf5", v: ["1faf5-1f3fb", "1faf5-1f3fc", "1faf5-1f3fd", "1faf5-1f3fe", "1faf5-1f3ff"], id: 1553 }, { n: ["+1", "thumbsup", "hand"], u: "1f44d", v: ["1f44d-1f3fb", "1f44d-1f3fc", "1f44d-1f3fd", "1f44d-1f3fe", "1f44d-1f3ff"], id: 1554 }, { n: ["-1", "thumbsdown", "hand"], u: "1f44e", v: ["1f44e-1f3fb", "1f44e-1f3fc", "1f44e-1f3fd", "1f44e-1f3fe", "1f44e-1f3ff"], id: 1555 }, { n: ["fist", "hand"], u: "270a", v: ["270a-1f3fb", "270a-1f3fc", "270a-1f3fd", "270a-1f3fe", "270a-1f3ff"], id: 1556 }, { n: ["punch", "hand"], u: "1f44a", v: ["1f44a-1f3fb", "1f44a-1f3fc", "1f44a-1f3fd", "1f44a-1f3fe", "1f44a-1f3ff"], id: 1557 }, { n: ["left", "fist", "hand"], u: "1f91b", v: ["1f91b-1f3fb", "1f91b-1f3fc", "1f91b-1f3fd", "1f91b-1f3fe", "1f91b-1f3ff"], id: 1558 }, { n: ["right", "fist", "hand"], u: "1f91c", v: ["1f91c-1f3fb", "1f91c-1f3fc", "1f91c-1f3fd", "1f91c-1f3fe", "1f91c-1f3ff"], id: 1559 }, { n: ["clap", "hand"], u: "1f44f", v: ["1f44f-1f3fb", "1f44f-1f3fc", "1f44f-1f3fd", "1f44f-1f3fe", "1f44f-1f3ff"], id: 1560 }, { n: ["raised", "hand", "celebration"], u: "1f64c", v: ["1f64c-1f3fb", "1f64c-1f3fc", "1f64c-1f3fd", "1f64c-1f3fe", "1f64c-1f3ff"], id: 1561 }, { n: ["heart", "hand"], u: "1faf6", v: ["1faf6-1f3fb", "1faf6-1f3fc", "1faf6-1f3fd", "1faf6-1f3fe", "1faf6-1f3ff"], id: 1562 }, { n: ["open", "hand"], u: "1f450", v: ["1f450-1f3fb", "1f450-1f3fc", "1f450-1f3fd", "1f450-1f3fe", "1f450-1f3ff"], id: 1563 }, { n: ["palms_up", "hand"], u: "1f932", v: ["1f932-1f3fb", "1f932-1f3fc", "1f932-1f3fd", "1f932-1f3fe", "1f932-1f3ff"], id: 1564 }, { n: ["handshake", "hand"], u: "1f91d", id: 1565 }, { n: ["pray", "hand"], u: "1f64f", v: ["1f64f-1f3fb", "1f64f-1f3fc", "1f64f-1f3fd", "1f64f-1f3fe", "1f64f-1f3ff"], id: 1566 }, { n: ["writing", "hand"], u: "270d-fe0f", v: ["270d-1f3fb", "270d-1f3fc", "270d-1f3fd", "270d-1f3fe", "270d-1f3ff"], id: 1567 }, { n: ["nail", "hand"], u: "1f485", v: ["1f485-1f3fb", "1f485-1f3fc", "1f485-1f3fd", "1f485-1f3fe", "1f485-1f3ff"], id: 1568 }, { n: ["selfie"], u: "1f933", v: ["1f933-1f3fb", "1f933-1f3fc", "1f933-1f3fd", "1f933-1f3fe", "1f933-1f3ff"], id: 1569 }, { n: ["muscle"], u: "1f4aa", v: ["1f4aa-1f3fb", "1f4aa-1f3fc", "1f4aa-1f3fd", "1f4aa-1f3fe", "1f4aa-1f3ff"], id: 1570 }, { n: ["mechanical_arm"], u: "1f9be", id: 1571 }, { n: ["mechanical_leg"], u: "1f9bf", id: 1572 }, { n: ["leg"], u: "1f9b5", v: ["1f9b5-1f3fb", "1f9b5-1f3fc", "1f9b5-1f3fd", "1f9b5-1f3fe", "1f9b5-1f3ff"], id: 1573 }, { n: ["foot"], u: "1f9b6", v: ["1f9b6-1f3fb", "1f9b6-1f3fc", "1f9b6-1f3fd", "1f9b6-1f3fe", "1f9b6-1f3ff"], id: 1574 }, { n: ["ear"], u: "1f442", v: ["1f442-1f3fb", "1f442-1f3fc", "1f442-1f3fd", "1f442-1f3fe", "1f442-1f3ff"], id: 1575 }, { n: ["ear"], u: "1f9bb", v: ["1f9bb-1f3fb", "1f9bb-1f3fc", "1f9bb-1f3fd", "1f9bb-1f3fe", "1f9bb-1f3ff"], id: 1576 }, { n: ["nose"], u: "1f443", v: ["1f443-1f3fb", "1f443-1f3fc", "1f443-1f3fd", "1f443-1f3fe", "1f443-1f3ff"], id: 1577 }, { n: ["brain"], u: "1f9e0", id: 1578 }, { n: ["heart"], u: "1fac0", id: 1579 }, { n: ["lungs"], u: "1fac1", id: 1580 }, { n: ["tooth"], u: "1f9b7", id: 1581 }, { n: ["bone"], u: "1f9b4", id: 1582 }, { n: ["eyes"], u: "1f440", id: 1583 }, { n: ["eye"], u: "1f441-fe0f", id: 1584 }, { n: ["tongue"], u: "1f445", id: 1585 }, { n: ["lips", "mouth"], u: "1f444", id: 1586 }, { n: ["lips"], u: "1fae6", id: 1587 }, { n: ["baby"], u: "1f476", v: ["1f476-1f3fb", "1f476-1f3fc", "1f476-1f3fd", "1f476-1f3fe", "1f476-1f3ff"], id: 1588 }, { n: ["child"], u: "1f9d2", v: ["1f9d2-1f3fb", "1f9d2-1f3fc", "1f9d2-1f3fd", "1f9d2-1f3fe", "1f9d2-1f3ff"], id: 1589 }, { n: ["boy"], u: "1f466", v: ["1f466-1f3fb", "1f466-1f3fc", "1f466-1f3fd", "1f466-1f3fe", "1f466-1f3ff"], id: 1590 }, { n: ["girl"], u: "1f467", v: ["1f467-1f3fb", "1f467-1f3fc", "1f467-1f3fd", "1f467-1f3fe", "1f467-1f3ff"], id: 1591 }, { n: ["adult"], u: "1f9d1", v: ["1f9d1-1f3fb", "1f9d1-1f3fc", "1f9d1-1f3fd", "1f9d1-1f3fe", "1f9d1-1f3ff"], id: 1592 }, { n: ["person"], u: "1f471", v: ["1f471-1f3fb", "1f471-1f3fc", "1f471-1f3fd", "1f471-1f3fe", "1f471-1f3ff"], id: 1593 }, { n: ["man"], u: "1f468", v: ["1f468-1f3fb", "1f468-1f3fc", "1f468-1f3fd", "1f468-1f3fe", "1f468-1f3ff"], id: 1594 }, { n: ["person"], u: "1f9d4", v: ["1f9d4-1f3fb", "1f9d4-1f3fc", "1f9d4-1f3fd", "1f9d4-1f3fe", "1f9d4-1f3ff"], id: 1595 }, { n: ["man"], u: "1f9d4-200d-2642-fe0f", v: ["1f9d4-1f3fb-200d-2642-fe0f", "1f9d4-1f3fc-200d-2642-fe0f", "1f9d4-1f3fd-200d-2642-fe0f", "1f9d4-1f3fe-200d-2642-fe0f", "1f9d4-1f3ff-200d-2642-fe0f"], id: 1596 }, { n: ["woman"], u: "1f9d4-200d-2640-fe0f", v: ["1f9d4-1f3fb-200d-2640-fe0f", "1f9d4-1f3fc-200d-2640-fe0f", "1f9d4-1f3fd-200d-2640-fe0f", "1f9d4-1f3fe-200d-2640-fe0f", "1f9d4-1f3ff-200d-2640-fe0f"], id: 1597 }, { n: ["man"], u: "1f468-200d-1f9b0", v: ["1f468-1f3fb-200d-1f9b0", "1f468-1f3fc-200d-1f9b0", "1f468-1f3fd-200d-1f9b0", "1f468-1f3fe-200d-1f9b0", "1f468-1f3ff-200d-1f9b0"], id: 1598 }, { n: ["man"], u: "1f468-200d-1f9b1", v: ["1f468-1f3fb-200d-1f9b1", "1f468-1f3fc-200d-1f9b1", "1f468-1f3fd-200d-1f9b1", "1f468-1f3fe-200d-1f9b1", "1f468-1f3ff-200d-1f9b1"], id: 1599 }, { n: ["man"], u: "1f468-200d-1f9b3", v: ["1f468-1f3fb-200d-1f9b3", "1f468-1f3fc-200d-1f9b3", "1f468-1f3fd-200d-1f9b3", "1f468-1f3fe-200d-1f9b3", "1f468-1f3ff-200d-1f9b3"], id: 1600 }, { n: ["man"], u: "1f468-200d-1f9b2", v: ["1f468-1f3fb-200d-1f9b2", "1f468-1f3fc-200d-1f9b2", "1f468-1f3fd-200d-1f9b2", "1f468-1f3fe-200d-1f9b2", "1f468-1f3ff-200d-1f9b2"], id: 1601 }, { n: ["woman"], u: "1f469", v: ["1f469-1f3fb", "1f469-1f3fc", "1f469-1f3fd", "1f469-1f3fe", "1f469-1f3ff"], id: 1602 }, { n: ["woman"], u: "1f469-200d-1f9b0", v: ["1f469-1f3fb-200d-1f9b0", "1f469-1f3fc-200d-1f9b0", "1f469-1f3fd-200d-1f9b0", "1f469-1f3fe-200d-1f9b0", "1f469-1f3ff-200d-1f9b0"], id: 1603 }, { n: ["person"], u: "1f9d1-200d-1f9b0", v: ["1f9d1-1f3fb-200d-1f9b0", "1f9d1-1f3fc-200d-1f9b0", "1f9d1-1f3fd-200d-1f9b0", "1f9d1-1f3fe-200d-1f9b0", "1f9d1-1f3ff-200d-1f9b0"], id: 1604 }, { n: ["woman"], u: "1f469-200d-1f9b1", v: ["1f469-1f3fb-200d-1f9b1", "1f469-1f3fc-200d-1f9b1", "1f469-1f3fd-200d-1f9b1", "1f469-1f3fe-200d-1f9b1", "1f469-1f3ff-200d-1f9b1"], id: 1605 }, { n: ["person"], u: "1f9d1-200d-1f9b1", v: ["1f9d1-1f3fb-200d-1f9b1", "1f9d1-1f3fc-200d-1f9b1", "1f9d1-1f3fd-200d-1f9b1", "1f9d1-1f3fe-200d-1f9b1", "1f9d1-1f3ff-200d-1f9b1"], id: 1606 }, { n: ["woman"], u: "1f469-200d-1f9b3", v: ["1f469-1f3fb-200d-1f9b3", "1f469-1f3fc-200d-1f9b3", "1f469-1f3fd-200d-1f9b3", "1f469-1f3fe-200d-1f9b3", "1f469-1f3ff-200d-1f9b3"], id: 1607 }, { n: ["person"], u: "1f9d1-200d-1f9b3", v: ["1f9d1-1f3fb-200d-1f9b3", "1f9d1-1f3fc-200d-1f9b3", "1f9d1-1f3fd-200d-1f9b3", "1f9d1-1f3fe-200d-1f9b3", "1f9d1-1f3ff-200d-1f9b3"], id: 1608 }, { n: ["woman"], u: "1f469-200d-1f9b2", v: ["1f469-1f3fb-200d-1f9b2", "1f469-1f3fc-200d-1f9b2", "1f469-1f3fd-200d-1f9b2", "1f469-1f3fe-200d-1f9b2", "1f469-1f3ff-200d-1f9b2"], id: 1609 }, { n: ["person"], u: "1f9d1-200d-1f9b2", v: ["1f9d1-1f3fb-200d-1f9b2", "1f9d1-1f3fc-200d-1f9b2", "1f9d1-1f3fd-200d-1f9b2", "1f9d1-1f3fe-200d-1f9b2", "1f9d1-1f3ff-200d-1f9b2"], id: 1610 }, { n: ["woman"], u: "1f471-200d-2640-fe0f", v: ["1f471-1f3fb-200d-2640-fe0f", "1f471-1f3fc-200d-2640-fe0f", "1f471-1f3fd-200d-2640-fe0f", "1f471-1f3fe-200d-2640-fe0f", "1f471-1f3ff-200d-2640-fe0f"], id: 1611 }, { n: ["man"], u: "1f471-200d-2642-fe0f", v: ["1f471-1f3fb-200d-2642-fe0f", "1f471-1f3fc-200d-2642-fe0f", "1f471-1f3fd-200d-2642-fe0f", "1f471-1f3fe-200d-2642-fe0f", "1f471-1f3ff-200d-2642-fe0f"], id: 1612 }, { n: ["older", "adult"], u: "1f9d3", v: ["1f9d3-1f3fb", "1f9d3-1f3fc", "1f9d3-1f3fd", "1f9d3-1f3fe", "1f9d3-1f3ff"], id: 1613 }, { n: ["older", "man"], u: "1f474", v: ["1f474-1f3fb", "1f474-1f3fc", "1f474-1f3fd", "1f474-1f3fe", "1f474-1f3ff"], id: 1614 }, { n: ["older", "woman"], u: "1f475", v: ["1f475-1f3fb", "1f475-1f3fc", "1f475-1f3fd", "1f475-1f3fe", "1f475-1f3ff"], id: 1615 }, { n: ["person", "frowning"], u: "1f64d", v: ["1f64d-1f3fb", "1f64d-1f3fc", "1f64d-1f3fd", "1f64d-1f3fe", "1f64d-1f3ff"], id: 1616 }, { n: ["man", "frowning"], u: "1f64d-200d-2642-fe0f", v: ["1f64d-1f3fb-200d-2642-fe0f", "1f64d-1f3fc-200d-2642-fe0f", "1f64d-1f3fd-200d-2642-fe0f", "1f64d-1f3fe-200d-2642-fe0f", "1f64d-1f3ff-200d-2642-fe0f"], id: 1617 }, { n: ["woman", "frowning"], u: "1f64d-200d-2640-fe0f", v: ["1f64d-1f3fb-200d-2640-fe0f", "1f64d-1f3fc-200d-2640-fe0f", "1f64d-1f3fd-200d-2640-fe0f", "1f64d-1f3fe-200d-2640-fe0f", "1f64d-1f3ff-200d-2640-fe0f"], id: 1618 }, { n: ["person", "pouting"], u: "1f64e", v: ["1f64e-1f3fb", "1f64e-1f3fc", "1f64e-1f3fd", "1f64e-1f3fe", "1f64e-1f3ff"], id: 1619 }, { n: ["man", "pouting"], u: "1f64e-200d-2642-fe0f", v: ["1f64e-1f3fb-200d-2642-fe0f", "1f64e-1f3fc-200d-2642-fe0f", "1f64e-1f3fd-200d-2642-fe0f", "1f64e-1f3fe-200d-2642-fe0f", "1f64e-1f3ff-200d-2642-fe0f"], id: 1620 }, { n: ["woman", "pouting"], u: "1f64e-200d-2640-fe0f", v: ["1f64e-1f3fb-200d-2640-fe0f", "1f64e-1f3fc-200d-2640-fe0f", "1f64e-1f3fd-200d-2640-fe0f", "1f64e-1f3fe-200d-2640-fe0f", "1f64e-1f3ff-200d-2640-fe0f"], id: 1621 }, { n: ["no-good", "face"], u: "1f645", v: ["1f645-1f3fb", "1f645-1f3fc", "1f645-1f3fd", "1f645-1f3fe", "1f645-1f3ff"], id: 1622 }, { n: ["man", "no", "wrong"], u: "1f645-200d-2642-fe0f", v: ["1f645-1f3fb-200d-2642-fe0f", "1f645-1f3fc-200d-2642-fe0f", "1f645-1f3fd-200d-2642-fe0f", "1f645-1f3fe-200d-2642-fe0f", "1f645-1f3ff-200d-2642-fe0f"], id: 1623 }, { n: ["woman", "no", "wrong"], u: "1f645-200d-2640-fe0f", v: ["1f645-1f3fb-200d-2640-fe0f", "1f645-1f3fc-200d-2640-fe0f", "1f645-1f3fd-200d-2640-fe0f", "1f645-1f3fe-200d-2640-fe0f", "1f645-1f3ff-200d-2640-fe0f"], id: 1624 }, { n: ["ok", "woman"], u: "1f646", v: ["1f646-1f3fb", "1f646-1f3fc", "1f646-1f3fd", "1f646-1f3fe", "1f646-1f3ff"], id: 1625 }, { n: ["man", "ok"], u: "1f646-200d-2642-fe0f", v: ["1f646-1f3fb-200d-2642-fe0f", "1f646-1f3fc-200d-2642-fe0f", "1f646-1f3fd-200d-2642-fe0f", "1f646-1f3fe-200d-2642-fe0f", "1f646-1f3ff-200d-2642-fe0f"], id: 1626 }, { n: ["woman", "ok"], u: "1f646-200d-2640-fe0f", v: ["1f646-1f3fb-200d-2640-fe0f", "1f646-1f3fc-200d-2640-fe0f", "1f646-1f3fd-200d-2640-fe0f", "1f646-1f3fe-200d-2640-fe0f", "1f646-1f3ff-200d-2640-fe0f"], id: 1627 }, { n: ["information", "person"], u: "1f481", v: ["1f481-1f3fb", "1f481-1f3fc", "1f481-1f3fd", "1f481-1f3fe", "1f481-1f3ff"], id: 1628 }, { n: ["man", "tipping", "hand"], u: "1f481-200d-2642-fe0f", v: ["1f481-1f3fb-200d-2642-fe0f", "1f481-1f3fc-200d-2642-fe0f", "1f481-1f3fd-200d-2642-fe0f", "1f481-1f3fe-200d-2642-fe0f", "1f481-1f3ff-200d-2642-fe0f"], id: 1629 }, { n: ["woman", "tipping", "hand"], u: "1f481-200d-2640-fe0f", v: ["1f481-1f3fb-200d-2640-fe0f", "1f481-1f3fc-200d-2640-fe0f", "1f481-1f3fd-200d-2640-fe0f", "1f481-1f3fe-200d-2640-fe0f", "1f481-1f3ff-200d-2640-fe0f"], id: 1630 }, { n: ["raised_hand", "hand"], u: "1f64b", v: ["1f64b-1f3fb", "1f64b-1f3fc", "1f64b-1f3fd", "1f64b-1f3fe", "1f64b-1f3ff"], id: 1631 }, { n: ["man", "raised_hand", "hand"], u: "1f64b-200d-2642-fe0f", v: ["1f64b-1f3fb-200d-2642-fe0f", "1f64b-1f3fc-200d-2642-fe0f", "1f64b-1f3fd-200d-2642-fe0f", "1f64b-1f3fe-200d-2642-fe0f", "1f64b-1f3ff-200d-2642-fe0f"], id: 1632 }, { n: ["woman", "raised_hand", "hand"], u: "1f64b-200d-2640-fe0f", v: ["1f64b-1f3fb-200d-2640-fe0f", "1f64b-1f3fc-200d-2640-fe0f", "1f64b-1f3fd-200d-2640-fe0f", "1f64b-1f3fe-200d-2640-fe0f", "1f64b-1f3ff-200d-2640-fe0f"], id: 1633 }, { n: ["deaf", "person"], u: "1f9cf", v: ["1f9cf-1f3fb", "1f9cf-1f3fc", "1f9cf-1f3fd", "1f9cf-1f3fe", "1f9cf-1f3ff"], id: 1634 }, { n: ["deaf", "man"], u: "1f9cf-200d-2642-fe0f", id: 1635 }, { n: ["deaf", "woman"], u: "1f9cf-200d-2640-fe0f", id: 1636 }, { n: ["bowing", "person"], u: "1f647", id: 1637 }, { n: ["man", "bowing"], u: "1f647-200d-2642-fe0f", id: 1638 }, { n: ["woman", "bowing"], u: "1f647-200d-2640-fe0f", id: 1639 }, { n: ["face_palm"], u: "1f926", v: ["1f926-1f3fb", "1f926-1f3fc", "1f926-1f3fd", "1f926-1f3fe", "1f926-1f3ff"], id: 1640 }, { n: ["man", "face_palm"], u: "1f926-200d-2642-fe0f", id: 1641 }, { n: ["woman", "face_palm"], u: "1f926-200d-2640-fe0f", id: 1642 }, { n: ["shrug"], u: "1f937", id: 1643 }, { n: ["man", "shrug"], u: "1f937-200d-2642-fe0f", id: 1644 }, { n: ["woman", "shrug"], u: "1f937-200d-2640-fe0f", id: 1645 }, { n: ["doctor"], u: "1f9d1-200d-2695-fe0f", id: 1646 }, { n: ["student"], u: "1f9d1-200d-1f393", id: 1647 }, { n: ["teacher"], u: "1f9d1-200d-1f3eb", id: 1648 }, { n: ["man", "teacher"], u: "1f468-200d-1f3eb", v: ["1f468-1f3fb-200d-1f3eb", "1f468-1f3fc-200d-1f3eb", "1f468-1f3fd-200d-1f3eb", "1f468-1f3fe-200d-1f3eb", "1f468-1f3ff-200d-1f3eb"], id: 1649 }, { n: ["woman", "teacher"], u: "1f469-200d-1f3eb", v: ["1f469-1f3fb-200d-1f3eb", "1f469-1f3fc-200d-1f3eb", "1f469-1f3fd-200d-1f3eb", "1f469-1f3fe-200d-1f3eb", "1f469-1f3ff-200d-1f3eb"], id: 1650 }, { n: ["judge"], u: "1f9d1-200d-2696-fe0f", v: ["1f9d1-1f3fb-200d-2696-fe0f", "1f9d1-1f3fc-200d-2696-fe0f", "1f9d1-1f3fd-200d-2696-fe0f", "1f9d1-1f3fe-200d-2696-fe0f", "1f9d1-1f3ff-200d-2696-fe0f"], id: 1651 }, { n: ["farmer"], u: "1f9d1-200d-1f33e", v: ["1f9d1-1f3fb-200d-1f33e", "1f9d1-1f3fc-200d-1f33e", "1f9d1-1f3fd-200d-1f33e", "1f9d1-1f3fe-200d-1f33e", "1f9d1-1f3ff-200d-1f33e"], id: 1652 }, { n: ["cook"], u: "1f9d1-200d-1f373", v: ["1f9d1-1f3fb-200d-1f373", "1f9d1-1f3fc-200d-1f373", "1f9d1-1f3fd-200d-1f373", "1f9d1-1f3fe-200d-1f373", "1f9d1-1f3ff-200d-1f373"], id: 1653 }, { n: ["man", "cook"], u: "1f468-200d-1f373", v: ["1f468-1f3fb-200d-1f373", "1f468-1f3fc-200d-1f373", "1f468-1f3fd-200d-1f373", "1f468-1f3fe-200d-1f373", "1f468-1f3ff-200d-1f373"], id: 1654 }, { n: ["woman", "cook"], u: "1f469-200d-1f373", v: ["1f469-1f3fb-200d-1f373", "1f469-1f3fc-200d-1f373", "1f469-1f3fd-200d-1f373", "1f469-1f3fe-200d-1f373", "1f469-1f3ff-200d-1f373"], id: 1655 }, { n: ["mechanic"], u: "1f9d1-200d-1f527", v: ["1f9d1-1f3fb-200d-1f527", "1f9d1-1f3fc-200d-1f527", "1f9d1-1f3fd-200d-1f527", "1f9d1-1f3fe-200d-1f527", "1f9d1-1f3ff-200d-1f527"], id: 1656 }, { n: ["factory"], u: "1f9d1-200d-1f3ed", v: ["1f9d1-1f3fb-200d-1f3ed", "1f9d1-1f3fc-200d-1f3ed", "1f9d1-1f3fd-200d-1f3ed", "1f9d1-1f3fe-200d-1f3ed", "1f9d1-1f3ff-200d-1f3ed"], id: 1657 }, { n: ["people", "office_worker"], u: "1f9d1-200d-1f4bc", v: ["1f9d1-1f3fb-200d-1f4bc", "1f9d1-1f3fc-200d-1f4bc", "1f9d1-1f3fd-200d-1f4bc", "1f9d1-1f3fe-200d-1f4bc", "1f9d1-1f3ff-200d-1f4bc"], id: 1658 }, { n: ["man", "office_worker"], u: "1f468-200d-1f4bc", v: ["1f468-1f3fb-200d-1f4bc", "1f468-1f3fc-200d-1f4bc", "1f468-1f3fd-200d-1f4bc", "1f468-1f3fe-200d-1f4bc", "1f468-1f3ff-200d-1f4bc"], id: 1659 }, { n: ["woman", "office_worker"], u: "1f469-200d-1f4bc", v: ["1f469-1f3fb-200d-1f4bc", "1f469-1f3fc-200d-1f4bc", "1f469-1f3fd-200d-1f4bc", "1f469-1f3fe-200d-1f4bc", "1f469-1f3ff-200d-1f4bc"], id: 1660 }, { n: ["scientist"], u: "1f9d1-200d-1f52c", v: ["1f9d1-1f3fb-200d-1f52c", "1f9d1-1f3fc-200d-1f52c", "1f9d1-1f3fd-200d-1f52c", "1f9d1-1f3fe-200d-1f52c", "1f9d1-1f3ff-200d-1f52c"], id: 1661 }, { n: ["man", "scientist"], u: "1f468-200d-1f52c", v: ["1f468-1f3fb-200d-1f52c", "1f468-1f3fc-200d-1f52c", "1f468-1f3fd-200d-1f52c", "1f468-1f3fe-200d-1f52c", "1f468-1f3ff-200d-1f52c"], id: 1662 }, { n: ["woman", "scientist"], u: "1f469-200d-1f52c", id: 1663 }, { n: ["technologist"], u: "1f9d1-200d-1f4bb", id: 1664 }, { n: ["man", "technologist"], u: "1f468-200d-1f4bb", id: 1665 }, { n: ["woman", "technologist"], u: "1f469-200d-1f4bb", id: 1666 }, { n: ["singer"], u: "1f9d1-200d-1f3a4", id: 1667 }, { n: ["man", "singer"], u: "1f468-200d-1f3a4", id: 1668 }, { n: ["woman", "singer"], u: "1f469-200d-1f3a4", id: 1669 }, { n: ["artist"], u: "1f9d1-200d-1f3a8", id: 1670 }, { n: ["man", "artist"], u: "1f468-200d-1f3a8", id: 1671 }, { n: ["woman", "artist"], u: "1f469-200d-1f3a8", id: 1672 }, { n: ["pilot"], u: "1f9d1-200d-2708-fe0f", id: 1673 }, { n: ["astronaut"], u: "1f9d1-200d-1f680", id: 1674 }, { n: ["firefighter"], u: "1f9d1-200d-1f692", id: 1675 }, { n: ["cop", "police_officer"], u: "1f46e", v: ["1f46e-1f3fb", "1f46e-1f3fc", "1f46e-1f3fd", "1f46e-1f3fe", "1f46e-1f3ff"], id: 1676 }, { n: ["detective", "spy"], u: "1f575-fe0f", v: ["1f575-1f3fb", "1f575-1f3fc", "1f575-1f3fd", "1f575-1f3fe", "1f575-1f3ff"], id: 1677 }, { n: ["guard"], u: "1f482", v: ["1f482-1f3fb", "1f482-1f3fc", "1f482-1f3fd", "1f482-1f3fe", "1f482-1f3ff"], id: 1678 }, { n: ["ninja"], u: "1f977", v: ["1f977-1f3fb", "1f977-1f3fc", "1f977-1f3fd", "1f977-1f3fe", "1f977-1f3ff"], id: 1679 }, { n: ["construction_worker"], u: "1f477", v: ["1f477-1f3fb", "1f477-1f3fc", "1f477-1f3fd", "1f477-1f3fe", "1f477-1f3ff"], id: 1680 }, { n: ["person", "crown"], u: "1fac5", v: ["1fac5-1f3fb", "1fac5-1f3fc", "1fac5-1f3fd", "1fac5-1f3fe", "1fac5-1f3ff"], id: 1681 }, { n: ["prince", "crown"], u: "1f934", v: ["1f934-1f3fb", "1f934-1f3fc", "1f934-1f3fd", "1f934-1f3fe", "1f934-1f3ff"], id: 1682 }, { n: ["princess", "crown"], u: "1f478", v: ["1f478-1f3fb", "1f478-1f3fc", "1f478-1f3fd", "1f478-1f3fe", "1f478-1f3ff"], id: 1683 }, { n: ["turban"], u: "1f473", v: ["1f473-1f3fb", "1f473-1f3fc", "1f473-1f3fd", "1f473-1f3fe", "1f473-1f3ff"], id: 1684 }, { n: ["man", "gua_pi_mao"], u: "1f472", v: ["1f472-1f3fb", "1f472-1f3fc", "1f472-1f3fd", "1f472-1f3fe", "1f472-1f3ff"], id: 1685 }, { n: ["person", "headscarf"], u: "1f9d5", v: ["1f9d5-1f3fb", "1f9d5-1f3fc", "1f9d5-1f3fd", "1f9d5-1f3fe", "1f9d5-1f3ff"], id: 1686 }, { n: ["man", "tuxedo"], u: "1f935", v: ["1f935-1f3fb", "1f935-1f3fc", "1f935-1f3fd", "1f935-1f3fe", "1f935-1f3ff"], id: 1687 }, { n: ["man", "tuxedo"], u: "1f935-200d-2642-fe0f", v: ["1f935-1f3fb-200d-2642-fe0f", "1f935-1f3fc-200d-2642-fe0f", "1f935-1f3fd-200d-2642-fe0f", "1f935-1f3fe-200d-2642-fe0f", "1f935-1f3ff-200d-2642-fe0f"], id: 1688 }, { n: ["woman", "tuxedo"], u: "1f935-200d-2640-fe0f", v: ["1f935-1f3fb-200d-2640-fe0f", "1f935-1f3fc-200d-2640-fe0f", "1f935-1f3fd-200d-2640-fe0f", "1f935-1f3fe-200d-2640-fe0f", "1f935-1f3ff-200d-2640-fe0f"], id: 1689 }, { n: ["bride"], u: "1f470", v: ["1f470-1f3fb", "1f470-1f3fc", "1f470-1f3fd", "1f470-1f3fe", "1f470-1f3ff"], id: 1690 }, { n: ["pregnant"], u: "1fac4", v: ["1fac4-1f3fb", "1fac4-1f3fc", "1fac4-1f3fd", "1fac4-1f3fe", "1fac4-1f3ff"], id: 1691 }, { n: ["angel", "baby"], u: "1f47c", v: ["1f47c-1f3fb", "1f47c-1f3fc", "1f47c-1f3fd", "1f47c-1f3fe", "1f47c-1f3ff"], id: 1692 }, { n: ["santa", "christmas"], u: "1f385", v: ["1f385-1f3fb", "1f385-1f3fc", "1f385-1f3fd", "1f385-1f3fe", "1f385-1f3ff"], id: 1693 }, { n: ["santa", "christmas"], u: "1f936", v: ["1f936-1f3fb", "1f936-1f3fc", "1f936-1f3fd", "1f936-1f3fe", "1f936-1f3ff"], id: 1694 }, { n: ["santa", "christmas"], u: "1f9d1-200d-1f384", v: ["1f9d1-1f3fb-200d-1f384", "1f9d1-1f3fc-200d-1f384", "1f9d1-1f3fd-200d-1f384", "1f9d1-1f3fe-200d-1f384", "1f9d1-1f3ff-200d-1f384"], id: 1695 }, { n: ["superhero"], u: "1f9b8", v: ["1f9b8-1f3fb", "1f9b8-1f3fc", "1f9b8-1f3fd", "1f9b8-1f3fe", "1f9b8-1f3ff"], id: 1696 }, { n: ["man", "superhero"], u: "1f9b8-200d-2642-fe0f", v: ["1f9b8-1f3fb-200d-2642-fe0f", "1f9b8-1f3fc-200d-2642-fe0f", "1f9b8-1f3fd-200d-2642-fe0f", "1f9b8-1f3fe-200d-2642-fe0f", "1f9b8-1f3ff-200d-2642-fe0f"], id: 1697 }, { n: ["woman", "superhero"], u: "1f9b8-200d-2640-fe0f", v: ["1f9b8-1f3fb-200d-2640-fe0f", "1f9b8-1f3fc-200d-2640-fe0f", "1f9b8-1f3fd-200d-2640-fe0f", "1f9b8-1f3fe-200d-2640-fe0f", "1f9b8-1f3ff-200d-2640-fe0f"], id: 1698 }, { n: ["supervillain"], u: "1f9b9", v: ["1f9b9-1f3fb", "1f9b9-1f3fc", "1f9b9-1f3fd", "1f9b9-1f3fe", "1f9b9-1f3ff"], id: 1699 }, { n: ["man", "supervillain"], u: "1f9b9-200d-2642-fe0f", id: 1700 }, { n: ["woman", "supervillain"], u: "1f9b9-200d-2640-fe0f", id: 1701 }, { n: ["mage"], u: "1f9d9", id: 1702 }, { n: ["man", "mage"], u: "1f9d9-200d-2642-fe0f", id: 1703 }, { n: ["woman", "mage"], u: "1f9d9-200d-2640-fe0f", id: 1704 }, { n: ["fairy"], u: "1f9da", id: 1705 }, { n: ["vampire"], u: "1f9db", id: 1706 }, { n: ["mermaid"], u: "1f9dc-200d-2640-fe0f", id: 1707 }, { n: ["genie"], u: "1f9de", id: 1708 }, { n: ["zombie"], u: "1f9df", id: 1709 }, { n: ["troll"], u: "1f9cc", id: 1710 }, { n: ["massage"], u: "1f486", id: 1711 }, { n: ["haircut"], u: "1f487", id: 1712 }, { n: ["wheelchair"], u: "1f9d1-200d-1f9bc", id: 1713 }, { n: ["wheelchair"], u: "1f9d1-200d-1f9bd", id: 1714 }, { n: ["runner", "person"], u: "1f3c3", id: 1715 }, { n: ["man", "runner"], u: "1f3c3-200d-2642-fe0f", id: 1716 }, { n: ["woman", "running"], u: "1f3c3-200d-2640-fe0f", id: 1717 }, { n: ["dancer"], u: "1f483", id: 1718 }, { n: ["dancer"], u: "1f57a", id: 1719 }, { n: ["dancer", "bunny"], u: "1f46f", id: 1720 }, { n: ["dancer", "bunny"], u: "1f46f-200d-2642-fe0f", id: 1721 }, { n: ["dancer", "bunny"], u: "1f46f-200d-2640-fe0f", id: 1722 }, { n: ["person", "climbing"], u: "1f9d7", id: 1723 }, { n: ["fencer"], u: "1f93a", id: 1726 }, { n: ["horse"], u: "1f3c7", id: 1727 }, { n: ["skier"], u: "26f7-fe0f", id: 1728 }, { n: ["snowboarder"], u: "1f3c2", id: 1729 }, { n: ["golfer", "person"], u: "1f3cc-fe0f", id: 1730 }, { n: ["surfer"], u: "1f3c4", id: 1731 }, { n: ["rowboat"], u: "1f6a3", id: 1732 }, { n: ["swimmer"], u: "1f3ca", id: 1733 }, { n: ["basketball"], u: "26f9-fe0f", id: 1734 }, { n: ["weight_lifter"], u: "1f3cb-fe0f", id: 1735 }, { n: ["bicyclist"], u: "1f6b4", id: 1736 }, { n: ["bicyclist", "mountain_bicyclist"], u: "1f6b5", id: 1737 }, { n: ["cartwheel"], u: "1f938", id: 1738 }, { n: ["wrestlers"], u: "1f93c", id: 1739 }, { n: ["water_polo"], u: "1f93d", id: 1740 }, { n: ["handball"], u: "1f93e", id: 1741 }, { n: ["juggling"], u: "1f939", id: 1742 }, { n: ["lotus_position"], u: "1f9d8", id: 1743 }, { n: ["bath"], u: "1f6c0", id: 1744 }, { n: ["sleeping"], u: "1f6cc", id: 1745 }, { n: ["t_d1_1f3ff_200d_1f91d_200d_1f9d1_1f3fb", "1f9d1_1f3ff_200d_1f91d_200d_1f9d1_1f3fc", "1f9d1_1f3ff_200d_1f91d_200d_1f9d1_1f3fd", "1f9d1_1f3ff_200d_1f91d_200d_1f9d1_1f3fe", "1f9d1_1f3ff_200d_1f91d_200d_1f9d1_1f3ff"], a: "12.0", id: 161 }, { n: ["women_holding_hands", "two_women_holding_hands"], u: "1f46d", a: "1.0", id: 162 }, { n: ["couple", "man_and_woman_holding_hands", "woman_and_man_holding_hands"], u: "1f46b", a: "0.6", id: 163 }, { n: ["men_holding_hands", "two_men_holding_hands"], u: "1f46c", a: "1.0", id: 164 }, { n: ["kiss", "couplekiss"], u: "1f48f", a: "0.6", id: 165 }, { n: ["woman_kiss_man", "kiss_woman_man"], u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468", a: "2.0", id: 166 }, { n: ["man_kiss_man", "kiss_man_man"], u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468", a: "2.0", id: 167 }, { n: ["woman_kiss_woman", "kiss_woman_woman"], u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469", a: "2.0", id: 168 }, { n: ["couple_with_heart"], u: "1f491", a: "0.6", id: 169 }, { n: ["woman_heart_man", "couple_with_heart_woman_man"], u: "1f469-200d-2764-fe0f-200d-1f468", a: "2.0", id: 170 }, { n: ["man_heart_man", "couple_with_heart_man_man"], u: "1f468-200d-2764-fe0f-200d-1f468", a: "2.0", id: 171 }, { n: ["woman_heart_woman", "couple_with_heart_woman_woman"], u: "1f469-200d-2764-fe0f-200d-1f469", a: "2.0", id: 172 }, { n: ["speaking_head", "speaking_head_in_silhouette"], u: "1f5e3-fe0f", a: "0.7", id: 199 }, { n: ["bust_in_silhouette"], u: "1f464", a: "0.6", id: 200 }, { n: ["busts_in_silhouette"], u: "1f465", a: "1.0", id: 201 }, { n: ["people_hugging"], u: "1fac2", a: "13.0", id: 202 }, { n: ["footprints"], u: "1f463", a: "0.6", id: 203 }], H0 = [{ n: ["monkey_face"], u: "1f435", a: "0.6", id: 204 }, { n: ["monkey"], u: "1f412", a: "0.6", id: 205 }, { n: ["gorilla"], u: "1f98d", a: "3.0", id: 206 }, { n: ["orangutan"], u: "1f9a7", a: "12.0", id: 207 }, { n: ["dog", "dog_face"], u: "1f436", a: "0.6", id: 208 }, { n: ["dog", "dog2"], u: "1f415", a: "0.7", id: 209 }, { n: ["guide_dog"], u: "1f9ae", a: "12.0", id: 210 }, { n: ["service_dog"], u: "1f415-200d-1f9ba", a: "12.0", id: 211 }, { n: ["poodle"], u: "1f429", a: "0.6", id: 212 }, { n: ["wolf", "wolf_face"], u: "1f43a", a: "0.6", id: 213 }, { n: ["fox_face"], u: "1f98a", a: "3.0", id: 214 }, { n: ["raccoon"], u: "1f99d", a: "11.0", id: 215 }, { n: ["cat", "cat_face"], u: "1f431", a: "0.6", id: 216 }, { n: ["cat", "cat2"], u: "1f408", a: "0.7", id: 217 }, { n: ["black_cat"], u: "1f408-200d-2b1b", a: "13.0", id: 218 }, { n: ["lion_face"], u: "1f981", a: "1.0", id: 219 }, { n: ["tiger", "tiger_face"], u: "1f42f", a: "0.6", id: 220 }, { n: ["tiger", "tiger2"], u: "1f405", a: "1.0", id: 221 }, { n: ["leopard"], u: "1f406", a: "1.0", id: 222 }, { n: ["horse", "horse_face"], u: "1f434", a: "0.6", id: 223 }, { n: ["horse", "racehorse"], u: "1f40e", a: "0.6", id: 224 }, { n: ["unicorn_face"], u: "1f984", a: "1.0", id: 225 }, { n: ["zebra_face"], u: "1f993", a: "5.0", id: 226 }, { n: ["deer"], u: "1f98c", a: "3.0", id: 227 }, { n: ["bison"], u: "1f9ac", a: "13.0", id: 228 }, { n: ["cow", "cow_face"], u: "1f42e", a: "0.6", id: 229 }, { n: ["ox"], u: "1f402", a: "1.0", id: 230 }, { n: ["water_buffalo"], u: "1f403", a: "1.0", id: 231 }, { n: ["cow", "cow2"], u: "1f404", a: "1.0", id: 232 }, { n: ["pig", "pig_face"], u: "1f437", a: "0.6", id: 233 }, { n: ["pig", "pig2"], u: "1f416", a: "1.0", id: 234 }, { n: ["boar"], u: "1f417", a: "0.6", id: 235 }, { n: ["pig_nose"], u: "1f43d", a: "0.6", id: 236 }, { n: ["ram"], u: "1f40f", a: "1.0", id: 237 }, { n: ["sheep"], u: "1f411", a: "0.6", id: 238 }, { n: ["goat"], u: "1f410", a: "1.0", id: 239 }, { n: ["dromedary_camel"], u: "1f42a", a: "1.0", id: 240 }, { n: ["camel", "bactrian_camel"], u: "1f42b", a: "0.6", id: 241 }, { n: ["llama"], u: "1f999", a: "11.0", id: 242 }, { n: ["giraffe_face"], u: "1f992", a: "5.0", id: 243 }, { n: ["elephant"], u: "1f418", a: "0.6", id: 244 }, { n: ["mammoth"], u: "1f9a3", a: "13.0", id: 245 }, { n: ["rhinoceros"], u: "1f98f", a: "3.0", id: 246 }, { n: ["hippopotamus"], u: "1f99b", a: "11.0", id: 247 }, { n: ["mouse", "mouse_face"], u: "1f42d", a: "0.6", id: 248 }, { n: ["mouse", "mouse2"], u: "1f401", a: "1.0", id: 249 }, { n: ["rat"], u: "1f400", a: "1.0", id: 250 }, { n: ["hamster", "hamster_face"], u: "1f439", a: "0.6", id: 251 }, { n: ["rabbit", "rabbit_face"], u: "1f430", a: "0.6", id: 252 }, { n: ["rabbit", "rabbit2"], u: "1f407", a: "1.0", id: 253 }, { n: ["chipmunk"], u: "1f43f-fe0f", a: "0.7", id: 254 }, { n: ["beaver"], u: "1f9ab", a: "13.0", id: 255 }, { n: ["hedgehog"], u: "1f994", a: "5.0", id: 256 }, { n: ["bat"], u: "1f987", a: "3.0", id: 257 }, { n: ["bear", "bear_face"], u: "1f43b", a: "0.6", id: 258 }, { n: ["polar_bear"], u: "1f43b-200d-2744-fe0f", a: "13.0", id: 259 }, { n: ["koala"], u: "1f428", a: "0.6", id: 260 }, { n: ["panda_face"], u: "1f43c", a: "0.6", id: 261 }, { n: ["sloth"], u: "1f9a5", a: "12.0", id: 262 }, { n: ["otter"], u: "1f9a6", a: "12.0", id: 263 }, { n: ["skunk"], u: "1f9a8", a: "12.0", id: 264 }, { n: ["kangaroo"], u: "1f998", a: "11.0", id: 265 }, { n: ["badger"], u: "1f9a1", a: "11.0", id: 266 }, { n: ["feet", "paw_prints"], u: "1f43e", a: "0.6", id: 267 }, { n: ["turkey"], u: "1f983", a: "1.0", id: 268 }, { n: ["chicken"], u: "1f414", a: "0.6", id: 269 }, { n: ["rooster"], u: "1f413", a: "1.0", id: 270 }, { n: ["hatching_chick"], u: "1f423", a: "0.6", id: 271 }, { n: ["baby_chick"], u: "1f424", a: "0.6", id: 272 }, { n: ["hatched_chick", "front_facing_baby_chick"], u: "1f425", a: "0.6", id: 273 }, { n: ["bird"], u: "1f426", a: "0.6", id: 274 }, { n: ["penguin"], u: "1f427", a: "0.6", id: 275 }, { n: ["dove", "dove_of_peace"], u: "1f54a-fe0f", a: "0.7", id: 276 }, { n: ["eagle"], u: "1f985", a: "3.0", id: 277 }, { n: ["duck"], u: "1f986", a: "3.0", id: 278 }, { n: ["swan"], u: "1f9a2", a: "11.0", id: 279 }, { n: ["owl"], u: "1f989", a: "3.0", id: 280 }, { n: ["dodo"], u: "1f9a4", a: "13.0", id: 281 }, { n: ["feather"], u: "1fab6", a: "13.0", id: 282 }, { n: ["flamingo"], u: "1f9a9", a: "12.0", id: 283 }, { n: ["peacock"], u: "1f99a", a: "11.0", id: 284 }, { n: ["parrot"], u: "1f99c", a: "11.0", id: 285 }, { n: ["frog", "frog_face"], u: "1f438", a: "0.6", id: 286 }, { n: ["crocodile"], u: "1f40a", a: "1.0", id: 287 }, { n: ["turtle"], u: "1f422", a: "0.6", id: 288 }, { n: ["lizard"], u: "1f98e", a: "3.0", id: 289 }, { n: ["snake"], u: "1f40d", a: "0.6", id: 290 }, { n: ["dragon_face"], u: "1f432", a: "0.6", id: 291 }, { n: ["dragon"], u: "1f409", a: "1.0", id: 292 }, { n: ["sauropod"], u: "1f995", a: "5.0", id: 293 }, { n: ["t_rex"], u: "1f996", a: "5.0", id: 294 }, { n: ["whale", "spouting_whale"], u: "1f433", a: "0.6", id: 295 }, { n: ["whale", "whale2"], u: "1f40b", a: "1.0", id: 296 }, { n: ["dolphin", "flipper"], u: "1f42c", a: "0.6", id: 297 }, { n: ["seal"], u: "1f9ad", a: "13.0", id: 298 }, { n: ["fish"], u: "1f41f", a: "0.6", id: 299 }, { n: ["tropical_fish"], u: "1f420", a: "0.6", id: 300 }, { n: ["blowfish"], u: "1f421", a: "0.6", id: 301 }, { n: ["shark"], u: "1f988", a: "3.0", id: 302 }, { n: ["octopus"], u: "1f419", a: "0.6", id: 303 }, { n: ["shell", "spiral_shell"], u: "1f41a", a: "0.6", id: 304 }, { n: ["coral"], u: "1fab8", a: "14.0", id: 305 }, { n: ["snail"], u: "1f40c", a: "0.6", id: 306 }, { n: ["butterfly"], u: "1f98b", a: "3.0", id: 307 }, { n: ["bug"], u: "1f41b", a: "0.6", id: 308 }, { n: ["ant"], u: "1f41c", a: "0.6", id: 309 }, { n: ["bee", "honeybee"], u: "1f41d", a: "0.6", id: 310 }, { n: ["beetle"], u: "1fab2", a: "13.0", id: 311 }, { n: ["ladybug", "lady_beetle"], u: "1f41e", a: "0.6", id: 312 }, { n: ["cricket"], u: "1f997", a: "5.0", id: 313 }, { n: ["cockroach"], u: "1fab3", a: "13.0", id: 314 }, { n: ["spider"], u: "1f577-fe0f", a: "0.7", id: 315 }, { n: ["spider_web"], u: "1f578-fe0f", a: "0.7", id: 316 }, { n: ["scorpion"], u: "1f982", a: "1.0", id: 317 }, { n: ["mosquito"], u: "1f99f", a: "11.0", id: 318 }, { n: ["fly"], u: "1fab0", a: "13.0", id: 319 }, { n: ["worm"], u: "1fab1", a: "13.0", id: 320 }, { n: ["microbe"], u: "1f9a0", a: "11.0", id: 321 }, { n: ["bouquet"], u: "1f490", a: "0.6", id: 322 }, { n: ["cherry_blossom"], u: "1f338", a: "0.6", id: 323 }, { n: ["white_flower"], u: "1f4ae", a: "0.6", id: 324 }, { n: ["lotus"], u: "1fab7", a: "14.0", id: 325 }, { n: ["rosette"], u: "1f3f5-fe0f", a: "0.7", id: 326 }, { n: ["rose"], u: "1f339", a: "0.6", id: 327 }, { n: ["wilted_flower"], u: "1f940", a: "3.0", id: 328 }, { n: ["hibiscus"], u: "1f33a", a: "0.6", id: 329 }, { n: ["sunflower"], u: "1f33b", a: "0.6", id: 330 }, { n: ["blossom"], u: "1f33c", a: "0.6", id: 331 }, { n: ["tulip"], u: "1f337", a: "0.6", id: 332 }, { n: ["seedling"], u: "1f331", a: "0.6", id: 333 }, { n: ["potted_plant"], u: "1fab4", a: "13.0", id: 334 }, { n: ["evergreen_tree"], u: "1f332", a: "1.0", id: 335 }, { n: ["deciduous_tree"], u: "1f333", a: "1.0", id: 336 }, { n: ["palm_tree"], u: "1f334", a: "0.6", id: 337 }, { n: ["cactus"], u: "1f335", a: "0.6", id: 338 }, { n: ["ear_of_rice"], u: "1f33e", a: "0.6", id: 339 }, { n: ["herb"], u: "1f33f", a: "0.6", id: 340 }, { n: ["shamrock"], u: "2618-fe0f", a: "1.0", id: 341 }, { n: ["four_leaf_clover"], u: "1f340", a: "0.6", id: 342 }, { n: ["maple_leaf"], u: "1f341", a: "0.6", id: 343 }, { n: ["fallen_leaf"], u: "1f342", a: "0.6", id: 344 }, { n: ["leaves", "leaf_fluttering_in_wind"], u: "1f343", a: "0.6", id: 345 }, { n: ["empty_nest"], u: "1fab9", a: "14.0", id: 346 }, { n: ["nest_with_eggs"], u: "1faba", a: "14.0", id: 347 }], V0 = [{ n: ["grapes"], u: "1f347", a: "0.6", id: 348 }, { n: ["melon"], u: "1f348", a: "0.6", id: 349 }, { n: ["watermelon"], u: "1f349", a: "0.6", id: 350 }, { n: ["tangerine"], u: "1f34a", a: "0.6", id: 351 }, { n: ["lemon"], u: "1f34b", a: "1.0", id: 352 }, { n: ["banana"], u: "1f34c", a: "0.6", id: 353 }, { n: ["pineapple"], u: "1f34d", a: "0.6", id: 354 }, { n: ["mango"], u: "1f96d", a: "11.0", id: 355 }, { n: ["apple", "red_apple"], u: "1f34e", a: "0.6", id: 356 }, { n: ["green_apple"], u: "1f34f", a: "0.6", id: 357 }, { n: ["pear"], u: "1f350", a: "1.0", id: 358 }, { n: ["peach"], u: "1f351", a: "0.6", id: 359 }, { n: ["cherries"], u: "1f352", a: "0.6", id: 360 }, { n: ["strawberry"], u: "1f353", a: "0.6", id: 361 }, { n: ["blueberries"], u: "1fad0", a: "13.0", id: 362 }, { n: ["kiwifruit"], u: "1f95d", a: "3.0", id: 363 }, { n: ["tomato"], u: "1f345", a: "0.6", id: 364 }, { n: ["olive"], u: "1fad2", a: "13.0", id: 365 }, { n: ["coconut"], u: "1f965", a: "5.0", id: 366 }, { n: ["avocado"], u: "1f951", a: "3.0", id: 367 }, { n: ["eggplant", "aubergine"], u: "1f346", a: "0.6", id: 368 }, { n: ["potato"], u: "1f954", a: "3.0", id: 369 }, { n: ["carrot"], u: "1f955", a: "3.0", id: 370 }, { n: ["corn", "ear_of_maize"], u: "1f33d", a: "0.6", id: 371 }, { n: ["hot_pepper"], u: "1f336-fe0f", a: "0.7", id: 372 }, { n: ["bell_pepper"], u: "1fad1", a: "13.0", id: 373 }, { n: ["cucumber"], u: "1f952", a: "3.0", id: 374 }, { n: ["leafy_green"], u: "1f96c", a: "11.0", id: 375 }, { n: ["broccoli"], u: "1f966", a: "5.0", id: 376 }, { n: ["garlic"], u: "1f9c4", a: "12.0", id: 377 }, { n: ["onion"], u: "1f9c5", a: "12.0", id: 378 }, { n: ["mushroom"], u: "1f344", a: "0.6", id: 379 }, { n: ["peanuts"], u: "1f95c", a: "3.0", id: 380 }, { n: ["beans"], u: "1fad8", a: "14.0", id: 381 }, { n: ["chestnut"], u: "1f330", a: "0.6", id: 382 }, { n: ["bread"], u: "1f35e", a: "0.6", id: 383 }, { n: ["croissant"], u: "1f950", a: "3.0", id: 384 }, { n: ["baguette_bread"], u: "1f956", a: "3.0", id: 385 }, { n: ["flatbread"], u: "1fad3", a: "13.0", id: 386 }, { n: ["pretzel"], u: "1f968", a: "5.0", id: 387 }, { n: ["bagel"], u: "1f96f", a: "11.0", id: 388 }, { n: ["pancakes"], u: "1f95e", a: "3.0", id: 389 }, { n: ["waffle"], u: "1f9c7", a: "12.0", id: 390 }, { n: ["cheese_wedge"], u: "1f9c0", a: "1.0", id: 391 }, { n: ["meat_on_bone"], u: "1f356", a: "0.6", id: 392 }, { n: ["poultry_leg"], u: "1f357", a: "0.6", id: 393 }, { n: ["cut_of_meat"], u: "1f969", a: "5.0", id: 394 }, { n: ["bacon"], u: "1f953", a: "3.0", id: 395 }, { n: ["hamburger"], u: "1f354", a: "0.6", id: 396 }, { n: ["fries", "french_fries"], u: "1f35f", a: "0.6", id: 397 }, { n: ["pizza", "slice_of_pizza"], u: "1f355", a: "0.6", id: 398 }, { n: ["hotdog", "hot_dog"], u: "1f32d", a: "1.0", id: 399 }, { n: ["sandwich"], u: "1f96a", a: "5.0", id: 400 }, { n: ["taco"], u: "1f32e", a: "1.0", id: 401 }, { n: ["burrito"], u: "1f32f", a: "1.0", id: 402 }, { n: ["tamale"], u: "1fad4", a: "13.0", id: 403 }, { n: ["stuffed_flatbread"], u: "1f959", a: "3.0", id: 404 }, { n: ["falafel"], u: "1f9c6", a: "12.0", id: 405 }, { n: ["egg"], u: "1f95a", a: "3.0", id: 406 }, { n: ["cooking", "fried_egg"], u: "1f373", a: "0.6", id: 407 }, { n: ["shallow_pan_of_food"], u: "1f958", a: "3.0", id: 408 }, { n: ["stew", "pot_of_food"], u: "1f372", a: "0.6", id: 409 }, { n: ["fondue"], u: "1fad5", a: "13.0", id: 410 }, { n: ["bowl_with_spoon"], u: "1f963", a: "5.0", id: 411 }, { n: ["green_salad"], u: "1f957", a: "3.0", id: 412 }, { n: ["popcorn"], u: "1f37f", a: "1.0", id: 413 }, { n: ["butter"], u: "1f9c8", a: "12.0", id: 414 }, { n: ["salt", "salt_shaker"], u: "1f9c2", a: "11.0", id: 415 }, { n: ["canned_food"], u: "1f96b", a: "5.0", id: 416 }, { n: ["bento", "bento_box"], u: "1f371", a: "0.6", id: 417 }, { n: ["rice_cracker"], u: "1f358", a: "0.6", id: 418 }, { n: ["rice_ball"], u: "1f359", a: "0.6", id: 419 }, { n: ["rice", "cooked_rice"], u: "1f35a", a: "0.6", id: 420 }, { n: ["curry", "curry_and_rice"], u: "1f35b", a: "0.6", id: 421 }, { n: ["ramen", "steaming_bowl"], u: "1f35c", a: "0.6", id: 422 }, { n: ["spaghetti"], u: "1f35d", a: "0.6", id: 423 }, { n: ["sweet_potato", "roasted_sweet_potato"], u: "1f360", a: "0.6", id: 424 }, { n: ["oden"], u: "1f362", a: "0.6", id: 425 }, { n: ["sushi"], u: "1f363", a: "0.6", id: 426 }, { n: ["fried_shrimp"], u: "1f364", a: "0.6", id: 427 }, { n: ["fish_cake", "fish_cake_with_swirl_design"], u: "1f365", a: "0.6", id: 428 }, { n: ["moon_cake"], u: "1f96e", a: "11.0", id: 429 }, { n: ["dango"], u: "1f361", a: "0.6", id: 430 }, { n: ["dumpling"], u: "1f95f", a: "5.0", id: 431 }, { n: ["fortune_cookie"], u: "1f960", a: "5.0", id: 432 }, { n: ["takeout_box"], u: "1f961", a: "5.0", id: 433 }, { n: ["crab"], u: "1f980", a: "1.0", id: 434 }, { n: ["lobster"], u: "1f99e", a: "11.0", id: 435 }, { n: ["shrimp"], u: "1f990", a: "3.0", id: 436 }, { n: ["squid"], u: "1f991", a: "3.0", id: 437 }, { n: ["oyster"], u: "1f9aa", a: "12.0", id: 438 }, { n: ["icecream", "soft_ice_cream"], u: "1f366", a: "0.6", id: 439 }, { n: ["shaved_ice"], u: "1f367", a: "0.6", id: 440 }, { n: ["ice_cream"], u: "1f368", a: "0.6", id: 441 }, { n: ["doughnut"], u: "1f369", a: "0.6", id: 442 }, { n: ["cookie"], u: "1f36a", a: "0.6", id: 443 }, { n: ["birthday", "birthday_cake"], u: "1f382", a: "0.6", id: 444 }, { n: ["cake", "shortcake"], u: "1f370", a: "0.6", id: 445 }, { n: ["cupcake"], u: "1f9c1", a: "11.0", id: 446 }, { n: ["pie"], u: "1f967", a: "5.0", id: 447 }, { n: ["chocolate_bar"], u: "1f36b", a: "0.6", id: 448 }, { n: ["candy"], u: "1f36c", a: "0.6", id: 449 }, { n: ["lollipop"], u: "1f36d", a: "0.6", id: 450 }, { n: ["custard"], u: "1f36e", a: "0.6", id: 451 }, { n: ["honey_pot"], u: "1f36f", a: "0.6", id: 452 }, { n: ["baby_bottle"], u: "1f37c", a: "1.0", id: 453 }, { n: ["glass_of_milk"], u: "1f95b", a: "3.0", id: 454 }, { n: ["coffee", "hot_beverage"], u: "2615", a: "0.6", id: 455 }, { n: ["teapot"], u: "1fad6", a: "13.0", id: 456 }, { n: ["tea", "teacup_without_handle"], u: "1f375", a: "0.6", id: 457 }, { n: ["sake", "sake_bottle_and_cup"], u: "1f376", a: "0.6", id: 458 }, { n: ["champagne", "bottle_with_popping_cork"], u: "1f37e", a: "1.0", id: 459 }, { n: ["wine_glass"], u: "1f377", a: "0.6", id: 460 }, { n: ["cocktail", "cocktail_glass"], u: "1f378", a: "0.6", id: 461 }, { n: ["tropical_drink"], u: "1f379", a: "0.6", id: 462 }, { n: ["beer", "beer_mug"], u: "1f37a", a: "0.6", id: 463 }, { n: ["beers", "clinking_beer_mugs"], u: "1f37b", a: "0.6", id: 464 }, { n: ["clinking_glasses"], u: "1f942", a: "3.0", id: 465 }, { n: ["tumbler_glass"], u: "1f943", a: "3.0", id: 466 }, { n: ["pouring_liquid"], u: "1fad7", a: "14.0", id: 467 }, { n: ["cup_with_straw"], u: "1f964", a: "5.0", id: 468 }, { n: ["bubble_tea"], u: "1f9cb", a: "13.0", id: 469 }, { n: ["beverage_box"], u: "1f9c3", a: "12.0", id: 470 }, { n: ["mate_drink"], u: "1f9c9", a: "12.0", id: 471 }, { n: ["ice_cube"], u: "1f9ca", a: "12.0", id: 472 }, { n: ["chopsticks"], u: "1f962", a: "5.0", id: 473 }, { n: ["knife_fork_plate", "fork_and_knife_with_plate"], u: "1f37d-fe0f", a: "0.7", id: 474 }, { n: ["fork_and_knife"], u: "1f374", a: "0.6", id: 475 }, { n: ["spoon"], u: "1f944", a: "3.0", id: 476 }, { n: ["hocho", "knife"], u: "1f52a", a: "0.6", id: 477 }, { n: ["jar"], u: "1fad9", a: "14.0", id: 478 }, { n: ["amphora"], u: "1f3fa", a: "1.0", id: 479 }], W0 = [{ n: ["earth_africa", "earth_globe_europe_africa"], u: "1f30d", a: "0.7", id: 480 }, { n: ["earth_americas", "earth_globe_americas"], u: "1f30e", a: "0.7", id: 481 }, { n: ["earth_asia", "earth_globe_asia_australia"], u: "1f30f", a: "0.6", id: 482 }, { n: ["globe_with_meridians"], u: "1f310", a: "1.0", id: 483 }, { n: ["world_map"], u: "1f5fa-fe0f", a: "0.7", id: 484 }, { n: ["japan", "silhouette_of_japan"], u: "1f5fe", a: "0.6", id: 485 }, { n: ["compass"], u: "1f9ed", a: "11.0", id: 486 }, { n: ["snow_capped_mountain", "snow_capped_mountain"], u: "1f3d4-fe0f", a: "0.7", id: 487 }, { n: ["mountain"], u: "26f0-fe0f", a: "0.7", id: 488 }, { n: ["volcano"], u: "1f30b", a: "0.6", id: 489 }, { n: ["mount_fuji"], u: "1f5fb", a: "0.6", id: 490 }, { n: ["camping"], u: "1f3d5-fe0f", a: "0.7", id: 491 }, { n: ["beach_with_umbrella"], u: "1f3d6-fe0f", a: "0.7", id: 492 }, { n: ["desert"], u: "1f3dc-fe0f", a: "0.7", id: 493 }, { n: ["desert_island"], u: "1f3dd-fe0f", a: "0.7", id: 494 }, { n: ["national_park"], u: "1f3de-fe0f", a: "0.7", id: 495 }, { n: ["stadium"], u: "1f3df-fe0f", a: "0.7", id: 496 }, { n: ["classical_building"], u: "1f3db-fe0f", a: "0.7", id: 497 }, { n: ["building_construction"], u: "1f3d7-fe0f", a: "0.7", id: 498 }, { n: ["brick", "bricks"], u: "1f9f1", a: "11.0", id: 499 }, { n: ["rock"], u: "1faa8", a: "13.0", id: 500 }, { n: ["wood"], u: "1fab5", a: "13.0", id: 501 }, { n: ["hut"], u: "1f6d6", a: "13.0", id: 502 }, { n: ["houses", "house_buildings"], u: "1f3d8-fe0f", a: "0.7", id: 503 }, { n: ["derelict_house", "derelict_house_building"], u: "1f3da-fe0f", a: "0.7", id: 504 }, { n: ["house", "house_building"], u: "1f3e0", a: "0.6", id: 505 }, { n: ["house_with_garden"], u: "1f3e1", a: "0.6", id: 506 }, { n: ["office", "office_building"], u: "1f3e2", a: "0.6", id: 507 }, { n: ["post_office", "japanese_post_office"], u: "1f3e3", a: "0.6", id: 508 }, { n: ["european_post_office"], u: "1f3e4", a: "1.0", id: 509 }, { n: ["hospital"], u: "1f3e5", a: "0.6", id: 510 }, { n: ["bank"], u: "1f3e6", a: "0.6", id: 511 }, { n: ["hotel"], u: "1f3e8", a: "0.6", id: 512 }, { n: ["love_hotel"], u: "1f3e9", a: "0.6", id: 513 }, { n: ["convenience_store"], u: "1f3ea", a: "0.6", id: 514 }, { n: ["school"], u: "1f3eb", a: "0.6", id: 515 }, { n: ["department_store"], u: "1f3ec", a: "0.6", id: 516 }, { n: ["factory"], u: "1f3ed", a: "0.6", id: 517 }, { n: ["japanese_castle"], u: "1f3ef", a: "0.6", id: 518 }, { n: ["european_castle"], u: "1f3f0", a: "0.6", id: 519 }, { n: ["wedding"], u: "1f492", a: "0.6", id: 520 }, { n: ["tokyo_tower"], u: "1f5fc", a: "0.6", id: 521 }, { n: ["statue_of_liberty"], u: "1f5fd", a: "0.6", id: 522 }, { n: ["church"], u: "26ea", a: "0.6", id: 523 }, { n: ["mosque"], u: "1f54c", a: "1.0", id: 524 }, { n: ["hindu_temple"], u: "1f6d5", a: "12.0", id: 525 }, { n: ["synagogue"], u: "1f54d", a: "1.0", id: 526 }, { n: ["shinto_shrine"], u: "26e9-fe0f", a: "0.7", id: 527 }, { n: ["kaaba"], u: "1f54b", a: "1.0", id: 528 }, { n: ["fountain"], u: "26f2", a: "0.6", id: 529 }, { n: ["tent"], u: "26fa", a: "0.6", id: 530 }, { n: ["foggy"], u: "1f301", a: "0.6", id: 531 }, { n: ["night_with_stars"], u: "1f303", a: "0.6", id: 532 }, { n: ["cityscape"], u: "1f3d9-fe0f", a: "0.7", id: 533 }, { n: ["sunrise_over_mountains"], u: "1f304", a: "0.6", id: 534 }, { n: ["sunrise"], u: "1f305", a: "0.6", id: 535 }, { n: ["city_sunset", "cityscape_at_dusk"], u: "1f306", a: "0.6", id: 536 }, { n: ["city_sunrise", "sunset_over_buildings"], u: "1f307", a: "0.6", id: 537 }, { n: ["bridge_at_night"], u: "1f309", a: "0.6", id: 538 }, { n: ["hotsprings", "hot_springs"], u: "2668-fe0f", a: "0.6", id: 539 }, { n: ["carousel_horse"], u: "1f3a0", a: "0.6", id: 540 }, { n: ["playground_slide"], u: "1f6dd", a: "14.0", id: 541 }, { n: ["ferris_wheel"], u: "1f3a1", a: "0.6", id: 542 }, { n: ["roller_coaster"], u: "1f3a2", a: "0.6", id: 543 }, { n: ["barber", "barber_pole"], u: "1f488", a: "0.6", id: 544 }, { n: ["circus_tent"], u: "1f3aa", a: "0.6", id: 545 }, { n: ["steam_locomotive"], u: "1f682", a: "1.0", id: 546 }, { n: ["railway_car"], u: "1f683", a: "0.6", id: 547 }, { n: ["high_speed_train", "bullettrain_side"], u: "1f684", a: "0.6", id: 548 }, { n: ["bullettrain_front", "high_speed_train_with_bullet_nose"], u: "1f685", a: "0.6", id: 549 }, { n: ["train", "train2"], u: "1f686", a: "1.0", id: 550 }, { n: ["metro"], u: "1f687", a: "0.6", id: 551 }, { n: ["light_rail"], u: "1f688", a: "1.0", id: 552 }, { n: ["station"], u: "1f689", a: "0.6", id: 553 }, { n: ["tram"], u: "1f68a", a: "1.0", id: 554 }, { n: ["monorail"], u: "1f69d", a: "1.0", id: 555 }, { n: ["mountain_railway"], u: "1f69e", a: "1.0", id: 556 }, { n: ["train", "tram_car"], u: "1f68b", a: "1.0", id: 557 }, { n: ["bus"], u: "1f68c", a: "0.6", id: 558 }, { n: ["oncoming_bus"], u: "1f68d", a: "0.7", id: 559 }, { n: ["trolleybus"], u: "1f68e", a: "1.0", id: 560 }, { n: ["minibus"], u: "1f690", a: "1.0", id: 561 }, { n: ["ambulance"], u: "1f691", a: "0.6", id: 562 }, { n: ["fire_engine"], u: "1f692", a: "0.6", id: 563 }, { n: ["police_car"], u: "1f693", a: "0.6", id: 564 }, { n: ["oncoming_police_car"], u: "1f694", a: "0.7", id: 565 }, { n: ["taxi"], u: "1f695", a: "0.6", id: 566 }, { n: ["oncoming_taxi"], u: "1f696", a: "1.0", id: 567 }, { n: ["car", "red_car", "automobile"], u: "1f697", a: "0.6", id: 568 }, { n: ["oncoming_automobile"], u: "1f698", a: "0.7", id: 569 }, { n: ["blue_car", "recreational_vehicle"], u: "1f699", a: "0.6", id: 570 }, { n: ["pickup_truck"], u: "1f6fb", a: "13.0", id: 571 }, { n: ["truck", "delivery_truck"], u: "1f69a", a: "0.6", id: 572 }, { n: ["articulated_lorry"], u: "1f69b", a: "1.0", id: 573 }, { n: ["tractor"], u: "1f69c", a: "1.0", id: 574 }, { n: ["racing_car"], u: "1f3ce-fe0f", a: "0.7", id: 575 }, { n: ["motorcycle", "racing_motorcycle"], u: "1f3cd-fe0f", a: "0.7", id: 576 }, { n: ["motor_scooter"], u: "1f6f5", a: "3.0", id: 577 }, { n: ["manual_wheelchair"], u: "1f9bd", a: "12.0", id: 578 }, { n: ["motorized_wheelchair"], u: "1f9bc", a: "12.0", id: 579 }, { n: ["auto_rickshaw"], u: "1f6fa", a: "12.0", id: 580 }, { n: ["bike", "bicycle"], u: "1f6b2", a: "0.6", id: 581 }, { n: ["scooter"], u: "1f6f4", a: "3.0", id: 582 }, { n: ["skateboard"], u: "1f6f9", a: "11.0", id: 583 }, { n: ["roller_skate"], u: "1f6fc", a: "13.0", id: 584 }, { n: ["busstop", "bus_stop"], u: "1f68f", a: "0.6", id: 585 }, { n: ["motorway"], u: "1f6e3-fe0f", a: "0.7", id: 586 }, { n: ["railway_track"], u: "1f6e4-fe0f", a: "0.7", id: 587 }, { n: ["oil_drum"], u: "1f6e2-fe0f", a: "0.7", id: 588 }, { n: ["fuelpump", "fuel_pump"], u: "26fd", a: "0.6", id: 589 }, { n: ["wheel"], u: "1f6de", a: "14.0", id: 590 }, { n: ["rotating_light", "police_cars_revolving_light"], u: "1f6a8", a: "0.6", id: 591 }, { n: ["traffic_light", "horizontal_traffic_light"], u: "1f6a5", a: "0.6", id: 592 }, { n: ["vertical_traffic_light"], u: "1f6a6", a: "1.0", id: 593 }, { n: ["octagonal_sign"], u: "1f6d1", a: "3.0", id: 594 }, { n: ["construction", "construction_sign"], u: "1f6a7", a: "0.6", id: 595 }, { n: ["anchor"], u: "2693", a: "0.6", id: 596 }, { n: ["ring_buoy"], u: "1f6df", a: "14.0", id: 597 }, { n: ["boat", "sailboat"], u: "26f5", a: "0.6", id: 598 }, { n: ["canoe"], u: "1f6f6", a: "3.0", id: 599 }, { n: ["speedboat"], u: "1f6a4", a: "0.6", id: 600 }, { n: ["passenger_ship"], u: "1f6f3-fe0f", a: "0.7", id: 601 }, { n: ["ferry"], u: "26f4-fe0f", a: "0.7", id: 602 }, { n: ["motor_boat"], u: "1f6e5-fe0f", a: "0.7", id: 603 }, { n: ["ship"], u: "1f6a2", a: "0.6", id: 604 }, { n: ["airplane"], u: "2708-fe0f", a: "0.6", id: 605 }, { n: ["small_airplane"], u: "1f6e9-fe0f", a: "0.7", id: 606 }, { n: ["airplane_departure"], u: "1f6eb", a: "1.0", id: 607 }, { n: ["airplane_arriving"], u: "1f6ec", a: "1.0", id: 608 }, { n: ["parachute"], u: "1fa82", a: "12.0", id: 609 }, { n: ["seat"], u: "1f4ba", a: "0.6", id: 610 }, { n: ["helicopter"], u: "1f681", a: "1.0", id: 611 }, { n: ["suspension_railway"], u: "1f69f", a: "1.0", id: 612 }, { n: ["mountain_cableway"], u: "1f6a0", a: "1.0", id: 613 }, { n: ["aerial_tramway"], u: "1f6a1", a: "1.0", id: 614 }, { n: ["satellite"], u: "1f6f0-fe0f", a: "0.7", id: 615 }, { n: ["rocket"], u: "1f680", a: "0.6", id: 616 }, { n: ["flying_saucer"], u: "1f6f8", a: "5.0", id: 617 }, { n: ["bellhop_bell"], u: "1f6ce-fe0f", a: "0.7", id: 618 }, { n: ["luggage"], u: "1f9f3", a: "11.0", id: 619 }, { n: ["hourglass"], u: "231b", a: "0.6", id: 620 }, { n: ["hourglass_flowing_sand", "hourglass_with_flowing_sand"], u: "23f3", a: "0.6", id: 621 }, { n: ["watch"], u: "231a", a: "0.6", id: 622 }, { n: ["alarm_clock"], u: "23f0", a: "0.6", id: 623 }, { n: ["stopwatch"], u: "23f1-fe0f", a: "1.0", id: 624 }, { n: ["timer_clock"], u: "23f2-fe0f", a: "1.0", id: 625 }, { n: ["mantelpiece_clock"], u: "1f570-fe0f", a: "0.7", id: 626 }, { n: ["clock12", "clock_face_twelve_oclock"], u: "1f55b", a: "0.6", id: 627 }, { n: ["clock1230", "clock_face_twelve_thirty"], u: "1f567", a: "0.7", id: 628 }, { n: ["clock1", "clock_face_one_oclock"], u: "1f550", a: "0.6", id: 629 }, { n: ["clock130", "clock_face_one_thirty"], u: "1f55c", a: "0.7", id: 630 }, { n: ["clock2", "clock_face_two_oclock"], u: "1f551", a: "0.6", id: 631 }, { n: ["clock230", "clock_face_two_thirty"], u: "1f55d", a: "0.7", id: 632 }, { n: ["clock3", "clock_face_three_oclock"], u: "1f552", a: "0.6", id: 633 }, { n: ["clock330", "clock_face_three_thirty"], u: "1f55e", a: "0.7", id: 634 }, { n: ["clock4", "clock_face_four_oclock"], u: "1f553", a: "0.6", id: 635 }, { n: ["clock430", "clock_face_four_thirty"], u: "1f55f", a: "0.7", id: 636 }, { n: ["clock5", "clock_face_five_oclock"], u: "1f554", a: "0.6", id: 637 }, { n: ["clock530", "clock_face_five_thirty"], u: "1f560", a: "0.7", id: 638 }, { n: ["clock6", "clock_face_six_oclock"], u: "1f555", a: "0.6", id: 639 }, { n: ["clock630", "clock_face_six_thirty"], u: "1f561", a: "0.7", id: 640 }, { n: ["clock7", "clock_face_seven_oclock"], u: "1f556", a: "0.6", id: 641 }, { n: ["clock730", "clock_face_seven_thirty"], u: "1f562", a: "0.7", id: 642 }, { n: ["clock8", "clock_face_eight_oclock"], u: "1f557", a: "0.6", id: 643 }, { n: ["clock830", "clock_face_eight_thirty"], u: "1f563", a: "0.7", id: 644 }, { n: ["clock9", "clock_face_nine_oclock"], u: "1f558", a: "0.6", id: 645 }, { n: ["clock930", "clock_face_nine_thirty"], u: "1f564", a: "0.7", id: 646 }, { n: ["clock10", "clock_face_ten_oclock"], u: "1f559", a: "0.6", id: 647 }, { n: ["clock1030", "clock_face_ten_thirty"], u: "1f565", a: "0.7", id: 648 }, { n: ["clock11", "clock_face_eleven_oclock"], u: "1f55a", a: "0.6", id: 649 }, { n: ["clock1130", "clock_face_eleven_thirty"], u: "1f566", a: "0.7", id: 650 }, { n: ["new_moon", "new_moon_symbol"], u: "1f311", a: "0.6", id: 651 }, { n: ["waxing_crescent_moon", "waxing_crescent_moon_symbol"], u: "1f312", a: "1.0", id: 652 }, { n: ["first_quarter_moon", "first_quarter_moon_symbol"], u: "1f313", a: "0.6", id: 653 }, { n: ["moon", "waxing_gibbous_moon", "waxing_gibbous_moon_symbol"], u: "1f314", a: "0.6", id: 654 }, { n: ["full_moon", "full_moon_symbol"], u: "1f315", a: "0.6", id: 655 }, { n: ["waning_gibbous_moon", "waning_gibbous_moon_symbol"], u: "1f316", a: "1.0", id: 656 }, { n: ["last_quarter_moon", "last_quarter_moon_symbol"], u: "1f317", a: "1.0", id: 657 }, { n: ["waning_crescent_moon", "waning_crescent_moon_symbol"], u: "1f318", a: "1.0", id: 658 }, { n: ["crescent_moon"], u: "1f319", a: "0.6", id: 659 }, { n: ["new_moon_with_face"], u: "1f31a", a: "1.0", id: 660 }, { n: ["first_quarter_moon_with_face"], u: "1f31b", a: "0.6", id: 661 }, { n: ["last_quarter_moon_with_face"], u: "1f31c", a: "0.7", id: 662 }, { n: ["thermometer"], u: "1f321-fe0f", a: "0.7", id: 663 }, { n: ["sunny", "black_sun_with_rays"], u: "2600-fe0f", a: "0.6", id: 664 }, { n: ["full_moon_with_face"], u: "1f31d", a: "1.0", id: 665 }, { n: ["sun_with_face"], u: "1f31e", a: "1.0", id: 666 }, { n: ["ringed_planet"], u: "1fa90", a: "12.0", id: 667 }, { n: ["star", "white_medium_star"], u: "2b50", a: "0.6", id: 668 }, { n: ["star2", "glowing_star"], u: "1f31f", a: "0.6", id: 669 }, { n: ["stars", "shooting_star"], u: "1f320", a: "0.6", id: 670 }, { n: ["milky_way"], u: "1f30c", a: "0.6", id: 671 }, { n: ["cloud"], u: "2601-fe0f", a: "0.6", id: 672 }, { n: ["partly_sunny", "sun_behind_cloud"], u: "26c5", a: "0.6", id: 673 }, { n: ["thunder_cloud_and_rain", "cloud_with_lightning_and_rain"], u: "26c8-fe0f", a: "0.7", id: 674 }, { n: ["mostly_sunny", "sun_small_cloud", "sun_behind_small_cloud"], u: "1f324-fe0f", a: "0.7", id: 675 }, { n: ["barely_sunny", "sun_behind_cloud", "sun_behind_large_cloud"], u: "1f325-fe0f", a: "0.7", id: 676 }, { n: ["partly_sunny_rain", "sun_behind_rain_cloud"], u: "1f326-fe0f", a: "0.7", id: 677 }, { n: ["rain_cloud", "cloud_with_rain"], u: "1f327-fe0f", a: "0.7", id: 678 }, { n: ["snow_cloud", "cloud_with_snow"], u: "1f328-fe0f", a: "0.7", id: 679 }, { n: ["lightning", "lightning_cloud", "cloud_with_lightning"], u: "1f329-fe0f", a: "0.7", id: 680 }, { n: ["tornado", "tornado_cloud"], u: "1f32a-fe0f", a: "0.7", id: 681 }, { n: ["fog"], u: "1f32b-fe0f", a: "0.7", id: 682 }, { n: ["wind_face", "wind_blowing_face"], u: "1f32c-fe0f", a: "0.7", id: 683 }, { n: ["cyclone"], u: "1f300", a: "0.6", id: 684 }, { n: ["rainbow"], u: "1f308", a: "0.6", id: 685 }, { n: ["closed_umbrella"], u: "1f302", a: "0.6", id: 686 }, { n: ["umbrella"], u: "2602-fe0f", a: "0.7", id: 687 }, { n: ["umbrella_with_rain_drops"], u: "2614", a: "0.6", id: 688 }, { n: ["umbrella_on_ground"], u: "26f1-fe0f", a: "0.7", id: 689 }, { n: ["zap", "high_voltage_sign"], u: "26a1", a: "0.6", id: 690 }, { n: ["snowflake"], u: "2744-fe0f", a: "0.6", id: 691 }, { n: ["snowman"], u: "2603-fe0f", a: "0.7", id: 692 }, { n: ["snowman_without_snow"], u: "26c4", a: "0.6", id: 693 }, { n: ["comet"], u: "2604-fe0f", a: "1.0", id: 694 }, { n: ["fire"], u: "1f525", a: "0.6", id: 695 }, { n: ["droplet"], u: "1f4a7", a: "0.6", id: 696 }, { n: ["ocean", "water_wave"], u: "1f30a", a: "0.6", id: 697 }], j0 = [{ n: ["jack_o_lantern", "jack_o_lantern"], u: "1f383", a: "0.6", id: 698 }, { n: ["christmas_tree"], u: "1f384", a: "0.6", id: 699 }, { n: ["fireworks"], u: "1f386", a: "0.6", id: 700 }, { n: ["sparkler", "firework_sparkler"], u: "1f387", a: "0.6", id: 701 }, { n: ["firecracker"], u: "1f9e8", a: "11.0", id: 702 }, { n: ["sparkles"], u: "2728", a: "0.6", id: 703 }, { n: ["balloon"], u: "1f388", a: "0.6", id: 704 }, { n: ["tada", "party_popper"], u: "1f389", a: "0.6", id: 705 }, { n: ["confetti_ball"], u: "1f38a", a: "0.6", id: 706 }, { n: ["tanabata_tree"], u: "1f38b", a: "0.6", id: 707 }, { n: ["bamboo", "pine_decoration"], u: "1f38d", a: "0.6", id: 708 }, { n: ["dolls", "japanese_dolls"], u: "1f38e", a: "0.6", id: 709 }, { n: ["flags", "carp_streamer"], u: "1f38f", a: "0.6", id: 710 }, { n: ["wind_chime"], u: "1f390", a: "0.6", id: 711 }, { n: ["rice_scene", "moon_viewing_ceremony"], u: "1f391", a: "0.6", id: 712 }, { n: ["red_envelope", "red_gift_envelope"], u: "1f9e7", a: "11.0", id: 713 }, { n: ["ribbon"], u: "1f380", a: "0.6", id: 714 }, { n: ["gift", "wrapped_present"], u: "1f381", a: "0.6", id: 715 }, { n: ["reminder_ribbon"], u: "1f397-fe0f", a: "0.7", id: 716 }, { n: ["admission_tickets"], u: "1f39f-fe0f", a: "0.7", id: 717 }, { n: ["ticket"], u: "1f3ab", a: "0.6", id: 718 }, { n: ["medal", "military_medal"], u: "1f396-fe0f", a: "0.7", id: 719 }, { n: ["trophy"], u: "1f3c6", a: "0.6", id: 720 }, { n: ["sports_medal"], u: "1f3c5", a: "1.0", id: 721 }, { n: ["first_place_medal"], u: "1f947", a: "3.0", id: 722 }, { n: ["second_place_medal"], u: "1f948", a: "3.0", id: 723 }, { n: ["third_place_medal"], u: "1f949", a: "3.0", id: 724 }, { n: ["soccer", "soccer_ball"], u: "26bd", a: "0.6", id: 725 }, { n: ["baseball"], u: "26be", a: "0.6", id: 726 }, { n: ["softball"], u: "1f94e", a: "11.0", id: 727 }, { n: ["basketball", "basketball_and_hoop"], u: "1f3c0", a: "0.6", id: 728 }, { n: ["volleyball"], u: "1f3d0", a: "1.0", id: 729 }, { n: ["football", "american_football"], u: "1f3c8", a: "0.6", id: 730 }, { n: ["rugby_football"], u: "1f3c9", a: "1.0", id: 731 }, { n: ["tennis", "tennis_racquet_and_ball"], u: "1f3be", a: "0.6", id: 732 }, { n: ["flying_disc"], u: "1f94f", a: "11.0", id: 733 }, { n: ["bowling"], u: "1f3b3", a: "0.6", id: 734 }, { n: ["cricket_bat_and_ball"], u: "1f3cf", a: "1.0", id: 735 }, { n: ["field_hockey_stick_and_ball"], u: "1f3d1", a: "1.0", id: 736 }, { n: ["ice_hockey_stick_and_puck"], u: "1f3d2", a: "1.0", id: 737 }, { n: ["lacrosse", "lacrosse_stick_and_ball"], u: "1f94d", a: "11.0", id: 738 }, { n: ["table_tennis_paddle_and_ball"], u: "1f3d3", a: "1.0", id: 739 }, { n: ["badminton_racquet_and_shuttlecock"], u: "1f3f8", a: "1.0", id: 740 }, { n: ["boxing_glove"], u: "1f94a", a: "3.0", id: 741 }, { n: ["martial_arts_uniform"], u: "1f94b", a: "3.0", id: 742 }, { n: ["goal_net"], u: "1f945", a: "3.0", id: 743 }, { n: ["golf", "flag_in_hole"], u: "26f3", a: "0.6", id: 744 }, { n: ["ice_skate"], u: "26f8-fe0f", a: "0.7", id: 745 }, { n: ["fishing_pole_and_fish"], u: "1f3a3", a: "0.6", id: 746 }, { n: ["diving_mask"], u: "1f93f", a: "12.0", id: 747 }, { n: ["running_shirt_with_sash"], u: "1f3bd", a: "0.6", id: 748 }, { n: ["ski", "ski_and_ski_boot"], u: "1f3bf", a: "0.6", id: 749 }, { n: ["sled"], u: "1f6f7", a: "5.0", id: 750 }, { n: ["curling_stone"], u: "1f94c", a: "5.0", id: 751 }, { n: ["dart", "direct_hit"], u: "1f3af", a: "0.6", id: 752 }, { n: ["yo_yo"], u: "1fa80", a: "12.0", id: 753 }, { n: ["kite"], u: "1fa81", a: "12.0", id: 754 }, { n: ["8ball", "billiards"], u: "1f3b1", a: "0.6", id: 755 }, { n: ["crystal_ball"], u: "1f52e", a: "0.6", id: 756 }, { n: ["magic_wand"], u: "1fa84", a: "13.0", id: 757 }, { n: ["nazar_amulet"], u: "1f9ff", a: "11.0", id: 758 }, { n: ["hamsa"], u: "1faac", a: "14.0", id: 759 }, { n: ["video_game"], u: "1f3ae", a: "0.6", id: 760 }, { n: ["joystick"], u: "1f579-fe0f", a: "0.7", id: 761 }, { n: ["slot_machine"], u: "1f3b0", a: "0.6", id: 762 }, { n: ["game_die"], u: "1f3b2", a: "0.6", id: 763 }, { n: ["jigsaw", "jigsaw_puzzle_piece"], u: "1f9e9", a: "11.0", id: 764 }, { n: ["teddy_bear"], u: "1f9f8", a: "11.0", id: 765 }, { n: ["pinata"], u: "1fa85", a: "13.0", id: 766 }, { n: ["mirror_ball"], u: "1faa9", a: "14.0", id: 767 }, { n: ["nesting_dolls"], u: "1fa86", a: "13.0", id: 768 }, { n: ["spades", "black_spade_suit"], u: "2660-fe0f", a: "0.6", id: 769 }, { n: ["hearts", "black_heart_suit"], u: "2665-fe0f", a: "0.6", id: 770 }, { n: ["diamonds", "black_diamond_suit"], u: "2666-fe0f", a: "0.6", id: 771 }, { n: ["clubs", "black_club_suit"], u: "2663-fe0f", a: "0.6", id: 772 }, { n: ["chess_pawn"], u: "265f-fe0f", a: "11.0", id: 773 }, { n: ["black_joker", "playing_card_black_joker"], u: "1f0cf", a: "0.6", id: 774 }, { n: ["mahjong", "mahjong_tile_red_dragon"], u: "1f004", a: "0.6", id: 775 }, { n: ["flower_playing_cards"], u: "1f3b4", a: "0.6", id: 776 }, { n: ["performing_arts"], u: "1f3ad", a: "0.6", id: 777 }, { n: ["framed_picture", "frame_with_picture"], u: "1f5bc-fe0f", a: "0.7", id: 778 }, { n: ["art", "artist_palette"], u: "1f3a8", a: "0.6", id: 779 }, { n: ["thread", "spool_of_thread"], u: "1f9f5", a: "11.0", id: 780 }, { n: ["sewing_needle"], u: "1faa1", a: "13.0", id: 781 }, { n: ["yarn", "ball_of_yarn"], u: "1f9f6", a: "11.0", id: 782 }, { n: ["knot"], u: "1faa2", a: "13.0", id: 783 }], Q0 = [{ n: ["eyeglasses"], u: "1f453", a: "0.6", id: 784 }, { n: ["sunglasses", "dark_sunglasses"], u: "1f576-fe0f", a: "0.7", id: 785 }, { n: ["goggles"], u: "1f97d", a: "11.0", id: 786 }, { n: ["lab_coat"], u: "1f97c", a: "11.0", id: 787 }, { n: ["safety_vest"], u: "1f9ba", a: "12.0", id: 788 }, { n: ["necktie"], u: "1f454", a: "0.6", id: 789 }, { n: ["shirt", "tshirt", "t_shirt"], u: "1f455", a: "0.6", id: 790 }, { n: ["jeans"], u: "1f456", a: "0.6", id: 791 }, { n: ["scarf"], u: "1f9e3", a: "5.0", id: 792 }, { n: ["gloves"], u: "1f9e4", a: "5.0", id: 793 }, { n: ["coat"], u: "1f9e5", a: "5.0", id: 794 }, { n: ["socks"], u: "1f9e6", a: "5.0", id: 795 }, { n: ["dress"], u: "1f457", a: "0.6", id: 796 }, { n: ["kimono"], u: "1f458", a: "0.6", id: 797 }, { n: ["sari"], u: "1f97b", a: "12.0", id: 798 }, { n: ["one_piece_swimsuit"], u: "1fa71", a: "12.0", id: 799 }, { n: ["briefs"], u: "1fa72", a: "12.0", id: 800 }, { n: ["shorts"], u: "1fa73", a: "12.0", id: 801 }, { n: ["bikini"], u: "1f459", a: "0.6", id: 802 }, { n: ["womans_clothes"], u: "1f45a", a: "0.6", id: 803 }, { n: ["purse"], u: "1f45b", a: "0.6", id: 804 }, { n: ["handbag"], u: "1f45c", a: "0.6", id: 805 }, { n: ["pouch"], u: "1f45d", a: "0.6", id: 806 }, { n: ["shopping_bags"], u: "1f6cd-fe0f", a: "0.7", id: 807 }, { n: ["school_satchel"], u: "1f392", a: "0.6", id: 808 }, { n: ["thong_sandal"], u: "1fa74", a: "13.0", id: 809 }, { n: ["shoe", "mans_shoe"], u: "1f45e", a: "0.6", id: 810 }, { n: ["athletic_shoe"], u: "1f45f", a: "0.6", id: 811 }, { n: ["hiking_boot"], u: "1f97e", a: "11.0", id: 812 }, { n: ["flat_shoe", "womans_flat_shoe"], u: "1f97f", a: "11.0", id: 813 }, { n: ["high_heel", "high_heeled_shoe"], u: "1f460", a: "0.6", id: 814 }, { n: ["sandal", "womans_sandal"], u: "1f461", a: "0.6", id: 815 }, { n: ["ballet_shoes"], u: "1fa70", a: "12.0", id: 816 }, { n: ["boot", "womans_boots"], u: "1f462", a: "0.6", id: 817 }, { n: ["crown"], u: "1f451", a: "0.6", id: 818 }, { n: ["womans_hat"], u: "1f452", a: "0.6", id: 819 }, { n: ["tophat", "top_hat"], u: "1f3a9", a: "0.6", id: 820 }, { n: ["mortar_board", "graduation_cap"], u: "1f393", a: "0.6", id: 821 }, { n: ["billed_cap"], u: "1f9e2", a: "5.0", id: 822 }, { n: ["military_helmet"], u: "1fa96", a: "13.0", id: 823 }, { n: ["rescue_worker_s_helmet", "helmet_with_white_cross"], u: "26d1-fe0f", a: "0.7", id: 824 }, { n: ["prayer_beads"], u: "1f4ff", a: "1.0", id: 825 }, { n: ["lipstick"], u: "1f484", a: "0.6", id: 826 }, { n: ["ring"], u: "1f48d", a: "0.6", id: 827 }, { n: ["gem", "gem_stone"], u: "1f48e", a: "0.6", id: 828 }, { n: ["mute", "speaker_with_cancellation_stroke"], u: "1f507", a: "1.0", id: 829 }, { n: ["speaker"], u: "1f508", a: "0.7", id: 830 }, { n: ["sound", "speaker_with_one_sound_wave"], u: "1f509", a: "1.0", id: 831 }, { n: ["loud_sound", "speaker_with_three_sound_waves"], u: "1f50a", a: "0.6", id: 832 }, { n: ["loudspeaker", "public_address_loudspeaker"], u: "1f4e2", a: "0.6", id: 833 }, { n: ["mega", "cheering_megaphone"], u: "1f4e3", a: "0.6", id: 834 }, { n: ["postal_horn"], u: "1f4ef", a: "1.0", id: 835 }, { n: ["bell"], u: "1f514", a: "0.6", id: 836 }, { n: ["no_bell", "bell_with_cancellation_stroke"], u: "1f515", a: "1.0", id: 837 }, { n: ["musical_score"], u: "1f3bc", a: "0.6", id: 838 }, { n: ["musical_note"], u: "1f3b5", a: "0.6", id: 839 }, { n: ["notes", "multiple_musical_notes"], u: "1f3b6", a: "0.6", id: 840 }, { n: ["studio_microphone"], u: "1f399-fe0f", a: "0.7", id: 841 }, { n: ["level_slider"], u: "1f39a-fe0f", a: "0.7", id: 842 }, { n: ["control_knobs"], u: "1f39b-fe0f", a: "0.7", id: 843 }, { n: ["microphone"], u: "1f3a4", a: "0.6", id: 844 }, { n: ["headphone", "headphones"], u: "1f3a7", a: "0.6", id: 845 }, { n: ["radio"], u: "1f4fb", a: "0.6", id: 846 }, { n: ["saxophone"], u: "1f3b7", a: "0.6", id: 847 }, { n: ["accordion"], u: "1fa97", a: "13.0", id: 848 }, { n: ["guitar"], u: "1f3b8", a: "0.6", id: 849 }, { n: ["musical_keyboard"], u: "1f3b9", a: "0.6", id: 850 }, { n: ["trumpet"], u: "1f3ba", a: "0.6", id: 851 }, { n: ["violin"], u: "1f3bb", a: "0.6", id: 852 }, { n: ["banjo"], u: "1fa95", a: "12.0", id: 853 }, { n: ["drum_with_drumsticks"], u: "1f941", a: "3.0", id: 854 }, { n: ["long_drum"], u: "1fa98", a: "13.0", id: 855 }, { n: ["iphone", "mobile_phone"], u: "1f4f1", a: "0.6", id: 856 }, { n: ["calling", "mobile_phone_with_rightwards_arrow_at_left"], u: "1f4f2", a: "0.6", id: 857 }, { n: ["phone", "telephone", "black_telephone"], u: "260e-fe0f", a: "0.6", id: 858 }, { n: ["telephone_receiver"], u: "1f4de", a: "0.6", id: 859 }, { n: ["pager"], u: "1f4df", a: "0.6", id: 860 }, { n: ["fax", "fax_machine"], u: "1f4e0", a: "0.6", id: 861 }, { n: ["battery"], u: "1f50b", a: "0.6", id: 862 }, { n: ["low_battery"], u: "1faab", a: "14.0", id: 863 }, { n: ["electric_plug"], u: "1f50c", a: "0.6", id: 864 }, { n: ["computer", "personal_computer"], u: "1f4bb", a: "0.6", id: 865 }, { n: ["desktop_computer"], u: "1f5a5-fe0f", a: "0.7", id: 866 }, { n: ["printer"], u: "1f5a8-fe0f", a: "0.7", id: 867 }, { n: ["keyboard"], u: "2328-fe0f", a: "1.0", id: 868 }, { n: ["computer_mouse", "three_button_mouse"], u: "1f5b1-fe0f", a: "0.7", id: 869 }, { n: ["trackball"], u: "1f5b2-fe0f", a: "0.7", id: 870 }, { n: ["minidisc"], u: "1f4bd", a: "0.6", id: 871 }, { n: ["floppy_disk"], u: "1f4be", a: "0.6", id: 872 }, { n: ["cd", "optical_disc"], u: "1f4bf", a: "0.6", id: 873 }, { n: ["dvd"], u: "1f4c0", a: "0.6", id: 874 }, { n: ["abacus"], u: "1f9ee", a: "11.0", id: 875 }, { n: ["movie_camera"], u: "1f3a5", a: "0.6", id: 876 }, { n: ["film_frames"], u: "1f39e-fe0f", a: "0.7", id: 877 }, { n: ["film_projector"], u: "1f4fd-fe0f", a: "0.7", id: 878 }, { n: ["clapper", "clapper_board"], u: "1f3ac", a: "0.6", id: 879 }, { n: ["tv", "television"], u: "1f4fa", a: "0.6", id: 880 }, { n: ["camera"], u: "1f4f7", a: "0.6", id: 881 }, { n: ["camera_with_flash"], u: "1f4f8", a: "1.0", id: 882 }, { n: ["video_camera"], u: "1f4f9", a: "0.6", id: 883 }, { n: ["vhs", "videocassette"], u: "1f4fc", a: "0.6", id: 884 }, { n: ["mag", "left_pointing_magnifying_glass"], u: "1f50d", a: "0.6", id: 885 }, { n: ["mag_right", "right_pointing_magnifying_glass"], u: "1f50e", a: "0.6", id: 886 }, { n: ["candle"], u: "1f56f-fe0f", a: "0.7", id: 887 }, { n: ["bulb", "electric_light_bulb"], u: "1f4a1", a: "0.6", id: 888 }, { n: ["flashlight", "electric_torch"], u: "1f526", a: "0.6", id: 889 }, { n: ["lantern", "izakaya_lantern"], u: "1f3ee", a: "0.6", id: 890 }, { n: ["diya_lamp"], u: "1fa94", a: "12.0", id: 891 }, { n: ["notebook_with_decorative_cover"], u: "1f4d4", a: "0.6", id: 892 }, { n: ["closed_book"], u: "1f4d5", a: "0.6", id: 893 }, { n: ["book", "open_book"], u: "1f4d6", a: "0.6", id: 894 }, { n: ["green_book"], u: "1f4d7", a: "0.6", id: 895 }, { n: ["blue_book"], u: "1f4d8", a: "0.6", id: 896 }, { n: ["orange_book"], u: "1f4d9", a: "0.6", id: 897 }, { n: ["books"], u: "1f4da", a: "0.6", id: 898 }, { n: ["notebook"], u: "1f4d3", a: "0.6", id: 899 }, { n: ["ledger"], u: "1f4d2", a: "0.6", id: 900 }, { n: ["page_with_curl"], u: "1f4c3", a: "0.6", id: 901 }, { n: ["scroll"], u: "1f4dc", a: "0.6", id: 902 }, { n: ["page_facing_up"], u: "1f4c4", a: "0.6", id: 903 }, { n: ["newspaper"], u: "1f4f0", a: "0.6", id: 904 }, { n: ["rolled_up_newspaper", "rolled_up_newspaper"], u: "1f5de-fe0f", a: "0.7", id: 905 }, { n: ["bookmark_tabs"], u: "1f4d1", a: "0.6", id: 906 }, { n: ["bookmark"], u: "1f516", a: "0.6", id: 907 }, { n: ["label"], u: "1f3f7-fe0f", a: "0.7", id: 908 }, { n: ["moneybag", "money_bag"], u: "1f4b0", a: "0.6", id: 909 }, { n: ["coin"], u: "1fa99", a: "13.0", id: 910 }, { n: ["yen", "banknote_with_yen_sign"], u: "1f4b4", a: "0.6", id: 911 }, { n: ["dollar", "banknote_with_dollar_sign"], u: "1f4b5", a: "0.6", id: 912 }, { n: ["euro", "banknote_with_euro_sign"], u: "1f4b6", a: "1.0", id: 913 }, { n: ["pound", "banknote_with_pound_sign"], u: "1f4b7", a: "1.0", id: 914 }, { n: ["money_with_wings"], u: "1f4b8", a: "0.6", id: 915 }, { n: ["credit_card"], u: "1f4b3", a: "0.6", id: 916 }, { n: ["receipt"], u: "1f9fe", a: "11.0", id: 917 }, { n: ["chart", "chart_with_upwards_trend_and_yen_sign"], u: "1f4b9", a: "0.6", id: 918 }, { n: ["email", "envelope"], u: "2709-fe0f", a: "0.6", id: 919 }, { n: ["e_mail", "e_mail_symbol"], u: "1f4e7", a: "0.6", id: 920 }, { n: ["incoming_envelope"], u: "1f4e8", a: "0.6", id: 921 }, { n: ["envelope_with_arrow", "envelope_with_downwards_arrow_above"], u: "1f4e9", a: "0.6", id: 922 }, { n: ["outbox_tray"], u: "1f4e4", a: "0.6", id: 923 }, { n: ["inbox_tray"], u: "1f4e5", a: "0.6", id: 924 }, { n: ["package"], u: "1f4e6", a: "0.6", id: 925 }, { n: ["mailbox", "closed_mailbox_with_raised_flag"], u: "1f4eb", a: "0.6", id: 926 }, { n: ["mailbox_closed", "closed_mailbox_with_lowered_flag"], u: "1f4ea", a: "0.6", id: 927 }, { n: ["mailbox_with_mail", "open_mailbox_with_raised_flag"], u: "1f4ec", a: "0.7", id: 928 }, { n: ["mailbox_with_no_mail", "open_mailbox_with_lowered_flag"], u: "1f4ed", a: "0.7", id: 929 }, { n: ["postbox"], u: "1f4ee", a: "0.6", id: 930 }, { n: ["ballot_box_with_ballot"], u: "1f5f3-fe0f", a: "0.7", id: 931 }, { n: ["pencil", "pencil2"], u: "270f-fe0f", a: "0.6", id: 932 }, { n: ["black_nib"], u: "2712-fe0f", a: "0.6", id: 933 }, { n: ["fountain_pen", "lower_left_fountain_pen"], u: "1f58b-fe0f", a: "0.7", id: 934 }, { n: ["pen", "lower_left_ballpoint_pen"], u: "1f58a-fe0f", a: "0.7", id: 935 }, { n: ["paintbrush", "lower_left_paintbrush"], u: "1f58c-fe0f", a: "0.7", id: 936 }, { n: ["crayon", "lower_left_crayon"], u: "1f58d-fe0f", a: "0.7", id: 937 }, { n: ["memo", "pencil"], u: "1f4dd", a: "0.6", id: 938 }, { n: ["briefcase"], u: "1f4bc", a: "0.6", id: 939 }, { n: ["file_folder"], u: "1f4c1", a: "0.6", id: 940 }, { n: ["open_file_folder"], u: "1f4c2", a: "0.6", id: 941 }, { n: ["card_index_dividers"], u: "1f5c2-fe0f", a: "0.7", id: 942 }, { n: ["date", "calendar"], u: "1f4c5", a: "0.6", id: 943 }, { n: ["calendar", "tear_off_calendar"], u: "1f4c6", a: "0.6", id: 944 }, { n: ["spiral_notepad", "spiral_note_pad"], u: "1f5d2-fe0f", a: "0.7", id: 945 }, { n: ["spiral_calendar", "spiral_calendar_pad"], u: "1f5d3-fe0f", a: "0.7", id: 946 }, { n: ["card_index"], u: "1f4c7", a: "0.6", id: 947 }, { n: ["chart_with_upwards_trend"], u: "1f4c8", a: "0.6", id: 948 }, { n: ["chart_with_downwards_trend"], u: "1f4c9", a: "0.6", id: 949 }, { n: ["bar_chart"], u: "1f4ca", a: "0.6", id: 950 }, { n: ["clipboard"], u: "1f4cb", a: "0.6", id: 951 }, { n: ["pushpin"], u: "1f4cc", a: "0.6", id: 952 }, { n: ["round_pushpin"], u: "1f4cd", a: "0.6", id: 953 }, { n: ["paperclip"], u: "1f4ce", a: "0.6", id: 954 }, { n: ["linked_paperclips"], u: "1f587-fe0f", a: "0.7", id: 955 }, { n: ["straight_ruler"], u: "1f4cf", a: "0.6", id: 956 }, { n: ["triangular_ruler"], u: "1f4d0", a: "0.6", id: 957 }, { n: ["scissors", "black_scissors"], u: "2702-fe0f", a: "0.6", id: 958 }, { n: ["card_file_box"], u: "1f5c3-fe0f", a: "0.7", id: 959 }, { n: ["file_cabinet"], u: "1f5c4-fe0f", a: "0.7", id: 960 }, { n: ["wastebasket"], u: "1f5d1-fe0f", a: "0.7", id: 961 }, { n: ["lock"], u: "1f512", a: "0.6", id: 962 }, { n: ["unlock", "open_lock"], u: "1f513", a: "0.6", id: 963 }, { n: ["lock_with_ink_pen"], u: "1f50f", a: "0.6", id: 964 }, { n: ["closed_lock_with_key"], u: "1f510", a: "0.6", id: 965 }, { n: ["key"], u: "1f511", a: "0.6", id: 966 }, { n: ["old_key"], u: "1f5dd-fe0f", a: "0.7", id: 967 }, { n: ["hammer"], u: "1f528", a: "0.6", id: 968 }, { n: ["axe"], u: "1fa93", a: "12.0", id: 969 }, { n: ["pick"], u: "26cf-fe0f", a: "0.7", id: 970 }, { n: ["hammer_and_pick"], u: "2692-fe0f", a: "1.0", id: 971 }, { n: ["hammer_and_wrench"], u: "1f6e0-fe0f", a: "0.7", id: 972 }, { n: ["dagger", "dagger_knife"], u: "1f5e1-fe0f", a: "0.7", id: 973 }, { n: ["crossed_swords"], u: "2694-fe0f", a: "1.0", id: 974 }, { n: ["gun", "pistol"], u: "1f52b", a: "0.6", id: 975 }, { n: ["boomerang"], u: "1fa83", a: "13.0", id: 976 }, { n: ["bow_and_arrow"], u: "1f3f9", a: "1.0", id: 977 }, { n: ["shield"], u: "1f6e1-fe0f", a: "0.7", id: 978 }, { n: ["carpentry_saw"], u: "1fa9a", a: "13.0", id: 979 }, { n: ["wrench"], u: "1f527", a: "0.6", id: 980 }, { n: ["screwdriver"], u: "1fa9b", a: "13.0", id: 981 }, { n: ["nut_and_bolt"], u: "1f529", a: "0.6", id: 982 }, { n: ["gear"], u: "2699-fe0f", a: "1.0", id: 983 }, { n: ["clamp", "compression"], u: "1f5dc-fe0f", a: "0.7", id: 984 }, { n: ["scales", "balance_scale"], u: "2696-fe0f", a: "1.0", id: 985 }, { n: ["probing_cane"], u: "1f9af", a: "12.0", id: 986 }, { n: ["link", "link_symbol"], u: "1f517", a: "0.6", id: 987 }, { n: ["chains"], u: "26d3-fe0f", a: "0.7", id: 988 }, { n: ["hook"], u: "1fa9d", a: "13.0", id: 989 }, { n: ["toolbox"], u: "1f9f0", a: "11.0", id: 990 }, { n: ["magnet"], u: "1f9f2", a: "11.0", id: 991 }, { n: ["ladder"], u: "1fa9c", a: "13.0", id: 992 }, { n: ["alembic"], u: "2697-fe0f", a: "1.0", id: 993 }, { n: ["test_tube"], u: "1f9ea", a: "11.0", id: 994 }, { n: ["petri_dish"], u: "1f9eb", a: "11.0", id: 995 }, { n: ["dna", "dna_double_helix"], u: "1f9ec", a: "11.0", id: 996 }, { n: ["microscope"], u: "1f52c", a: "1.0", id: 997 }, { n: ["telescope"], u: "1f52d", a: "1.0", id: 998 }, { n: ["satellite_antenna"], u: "1f4e1", a: "0.6", id: 999 }, { n: ["syringe"], u: "1f489", a: "0.6", id: 1e3 }, { n: ["drop_of_blood"], u: "1fa78", a: "12.0", id: 1001 }, { n: ["pill"], u: "1f48a", a: "0.6", id: 1002 }, { n: ["adhesive_bandage"], u: "1fa79", a: "12.0", id: 1003 }, { n: ["crutch"], u: "1fa7c", a: "14.0", id: 1004 }, { n: ["stethoscope"], u: "1fa7a", a: "12.0", id: 1005 }, { n: ["x_ray"], u: "1fa7b", a: "14.0", id: 1006 }, { n: ["door"], u: "1f6aa", a: "0.6", id: 1007 }, { n: ["elevator"], u: "1f6d7", a: "13.0", id: 1008 }, { n: ["mirror"], u: "1fa9e", a: "13.0", id: 1009 }, { n: ["window"], u: "1fa9f", a: "13.0", id: 1010 }, { n: ["bed"], u: "1f6cf-fe0f", a: "0.7", id: 1011 }, { n: ["couch_and_lamp"], u: "1f6cb-fe0f", a: "0.7", id: 1012 }, { n: ["chair"], u: "1fa91", a: "12.0", id: 1013 }, { n: ["toilet"], u: "1f6bd", a: "0.6", id: 1014 }, { n: ["plunger"], u: "1faa0", a: "13.0", id: 1015 }, { n: ["shower"], u: "1f6bf", a: "1.0", id: 1016 }, { n: ["bathtub"], u: "1f6c1", a: "1.0", id: 1017 }, { n: ["mouse_trap"], u: "1faa4", a: "13.0", id: 1018 }, { n: ["razor"], u: "1fa92", a: "12.0", id: 1019 }, { n: ["lotion_bottle"], u: "1f9f4", a: "11.0", id: 1020 }, { n: ["safety_pin"], u: "1f9f7", a: "11.0", id: 1021 }, { n: ["broom"], u: "1f9f9", a: "11.0", id: 1022 }, { n: ["basket"], u: "1f9fa", a: "11.0", id: 1023 }, { n: ["roll_of_paper"], u: "1f9fb", a: "11.0", id: 1024 }, { n: ["bucket"], u: "1faa3", a: "13.0", id: 1025 }, { n: ["soap", "bar_of_soap"], u: "1f9fc", a: "11.0", id: 1026 }, { n: ["bubbles"], u: "1fae7", a: "14.0", id: 1027 }, { n: ["toothbrush"], u: "1faa5", a: "13.0", id: 1028 }, { n: ["sponge"], u: "1f9fd", a: "11.0", id: 1029 }, { n: ["fire_extinguisher"], u: "1f9ef", a: "11.0", id: 1030 }, { n: ["shopping_trolley"], u: "1f6d2", a: "3.0", id: 1031 }, { n: ["smoking", "smoking_symbol"], u: "1f6ac", a: "0.6", id: 1032 }, { n: ["coffin"], u: "26b0-fe0f", a: "1.0", id: 1033 }, { n: ["headstone"], u: "1faa6", a: "13.0", id: 1034 }, { n: ["funeral_urn"], u: "26b1-fe0f", a: "1.0", id: 1035 }, { n: ["moyai"], u: "1f5ff", a: "0.6", id: 1036 }, { n: ["placard"], u: "1faa7", a: "13.0", id: 1037 }, { n: ["identification_card"], u: "1faaa", a: "14.0", id: 1038 }], Y0 = [{ n: ["atm", "automated_teller_machine"], u: "1f3e7", a: "0.6", id: 1039 }, { n: ["put_litter_in_its_place", "put_litter_in_its_place_symbol"], u: "1f6ae", a: "1.0", id: 1040 }, { n: ["potable_water", "potable_water_symbol"], u: "1f6b0", a: "1.0", id: 1041 }, { n: ["wheelchair", "wheelchair_symbol"], u: "267f", a: "0.6", id: 1042 }, { n: ["mens", "mens_symbol"], u: "1f6b9", a: "0.6", id: 1043 }, { n: ["womens", "womens_symbol"], u: "1f6ba", a: "0.6", id: 1044 }, { n: ["restroom"], u: "1f6bb", a: "0.6", id: 1045 }, { n: ["baby_symbol"], u: "1f6bc", a: "0.6", id: 1046 }, { n: ["wc", "water_closet"], u: "1f6be", a: "0.6", id: 1047 }, { n: ["passport_control"], u: "1f6c2", a: "1.0", id: 1048 }, { n: ["customs"], u: "1f6c3", a: "1.0", id: 1049 }, { n: ["baggage_claim"], u: "1f6c4", a: "1.0", id: 1050 }, { n: ["left_luggage"], u: "1f6c5", a: "1.0", id: 1051 }, { n: ["warning", "warning_sign"], u: "26a0-fe0f", a: "0.6", id: 1052 }, { n: ["children_crossing"], u: "1f6b8", a: "1.0", id: 1053 }, { n: ["no_entry"], u: "26d4", a: "0.6", id: 1054 }, { n: ["no_entry_sign"], u: "1f6ab", a: "0.6", id: 1055 }, { n: ["no_bicycles"], u: "1f6b3", a: "1.0", id: 1056 }, { n: ["no_smoking", "no_smoking_symbol"], u: "1f6ad", a: "0.6", id: 1057 }, { n: ["do_not_litter", "do_not_litter_symbol"], u: "1f6af", a: "1.0", id: 1058 }, { n: ["non_potable_water", "non_potable_water_symbol"], u: "1f6b1", a: "1.0", id: 1059 }, { n: ["no_pedestrians"], u: "1f6b7", a: "1.0", id: 1060 }, { n: ["no_mobile_phones"], u: "1f4f5", a: "1.0", id: 1061 }, { n: ["underage", "no_one_under_eighteen_symbol"], u: "1f51e", a: "0.6", id: 1062 }, { n: ["radioactive", "radioactive_sign"], u: "2622-fe0f", a: "1.0", id: 1063 }, { n: ["biohazard", "biohazard_sign"], u: "2623-fe0f", a: "1.0", id: 1064 }, { n: ["arrow_up", "upwards_black_arrow"], u: "2b06-fe0f", a: "0.6", id: 1065 }, { n: ["north_east_arrow", "arrow_upper_right"], u: "2197-fe0f", a: "0.6", id: 1066 }, { n: ["arrow_right", "black_rightwards_arrow"], u: "27a1-fe0f", a: "0.6", id: 1067 }, { n: ["south_east_arrow", "arrow_lower_right"], u: "2198-fe0f", a: "0.6", id: 1068 }, { n: ["arrow_down", "downwards_black_arrow"], u: "2b07-fe0f", a: "0.6", id: 1069 }, { n: ["south_west_arrow", "arrow_lower_left"], u: "2199-fe0f", a: "0.6", id: 1070 }, { n: ["arrow_left", "leftwards_black_arrow"], u: "2b05-fe0f", a: "0.6", id: 1071 }, { n: ["north_west_arrow", "arrow_upper_left"], u: "2196-fe0f", a: "0.6", id: 1072 }, { n: ["up_down_arrow", "arrow_up_down"], u: "2195-fe0f", a: "0.6", id: 1073 }, { n: ["left_right_arrow"], u: "2194-fe0f", a: "0.6", id: 1074 }, { n: ["leftwards_arrow_with_hook"], u: "21a9-fe0f", a: "0.6", id: 1075 }, { n: ["arrow_right_hook", "rightwards_arrow_with_hook"], u: "21aa-fe0f", a: "0.6", id: 1076 }, { n: ["arrow_heading_up", "arrow_pointing_rightwards_then_curving_upwards"], u: "2934-fe0f", a: "0.6", id: 1077 }, { n: ["arrow_heading_down", "arrow_pointing_rightwards_then_curving_downwards"], u: "2935-fe0f", a: "0.6", id: 1078 }, { n: ["arrows_clockwise", "clockwise_downwards_and_upwards_open_circle_arrows"], u: "1f503", a: "0.6", id: 1079 }, { n: ["arrows_counterclockwise", "anticlockwise_downup"], u: "1f504", a: "1.0", id: 1080 }, { n: ["back", "back_with_leftwards_arrow_above"], u: "1f519", a: "0.6", id: 1081 }, { n: ["end", "end_with_leftwards_arrow_above"], u: "1f51a", a: "0.6", id: 1082 }, { n: ["on", "on_with_exclamation_mark_with_left_right_arrow_above"], u: "1f51b", a: "0.6", id: 1083 }, { n: ["soon", "soon_with_rightwards_arrow_above"], u: "1f51c", a: "0.6", id: 1084 }, { n: ["top", "top_with_upwards_arrow_above"], u: "1f51d", a: "0.6", id: 1085 }, { n: ["place_of_worship"], u: "1f6d0", a: "1.0", id: 1086 }, { n: ["atom_symbol"], u: "269b-fe0f", a: "1.0", id: 1087 }, { n: ["om", "om_symbol"], u: "1f549-fe0f", a: "0.7", id: 1088 }, { n: ["star_of_david"], u: "2721-fe0f", a: "0.7", id: 1089 }, { n: ["wheel_of_dharma"], u: "2638-fe0f", a: "0.7", id: 1090 }, { n: ["yin_yang"], u: "262f-fe0f", a: "0.7", id: 1091 }, { n: ["latin_cross"], u: "271d-fe0f", a: "0.7", id: 1092 }, { n: ["orthodox_cross"], u: "2626-fe0f", a: "1.0", id: 1093 }, { n: ["star_and_crescent"], u: "262a-fe0f", a: "0.7", id: 1094 }, { n: ["peace_symbol"], u: "262e-fe0f", a: "1.0", id: 1095 }, { n: ["menorah_with_nine_branches"], u: "1f54e", a: "1.0", id: 1096 }, { n: ["six_pointed_star", "six_pointed_star_with_middle_dot"], u: "1f52f", a: "0.6", id: 1097 }, { n: ["aries"], u: "2648", a: "0.6", id: 1098 }, { n: ["taurus"], u: "2649", a: "0.6", id: 1099 }, { n: ["gemini"], u: "264a", a: "0.6", id: 1100 }, { n: ["cancer"], u: "264b", a: "0.6", id: 1101 }, { n: ["leo"], u: "264c", a: "0.6", id: 1102 }, { n: ["virgo"], u: "264d", a: "0.6", id: 1103 }, { n: ["libra"], u: "264e", a: "0.6", id: 1104 }, { n: ["scorpius"], u: "264f", a: "0.6", id: 1105 }, { n: ["sagittarius"], u: "2650", a: "0.6", id: 1106 }, { n: ["capricorn"], u: "2651", a: "0.6", id: 1107 }, { n: ["aquarius"], u: "2652", a: "0.6", id: 1108 }, { n: ["pisces"], u: "2653", a: "0.6", id: 1109 }, { n: ["ophiuchus"], u: "26ce", a: "0.6", id: 1110 }, { n: ["twisted_rightwards_arrows"], u: "1f500", a: "1.0", id: 1111 }, { n: ["repeat", "clockwise_rightwards_and_leftwards_open_circle_arrows"], u: "1f501", a: "1.0", id: 1112 }, { n: ["repeat_one", "crlocker"], u: "1f502", a: "1.0", id: 1113 }, { n: ["arrow_forward", "black_right_pointing_triangle"], u: "25b6-fe0f", a: "0.6", id: 1114 }, { n: ["fast_forward", "black_right_pointing_double_triangle"], u: "23e9", a: "0.6", id: 1115 }, { n: ["next_track_button", "black_right_pointing_double_triangle_with_vertical_bar"], u: "23ed-fe0f", a: "0.7", id: 1116 }, { n: ["play_or_pause_button", "brptroll"], u: "23ef-fe0f", a: "1.0", id: 1117 }, { n: ["arrow_backward", "black_left_pointing_triangle"], u: "25c0-fe0f", a: "0.6", id: 1118 }, { n: ["rewind", "black_left_pointing_double_triangle"], u: "23ea", a: "0.6", id: 1119 }, { n: ["last_track_button", "black_left_pointing_double_triangle_with_vertical_bar"], u: "23ee-fe0f", a: "0.7", id: 1120 }, { n: ["arrow_up_small", "up_pointing_small_red_triangle"], u: "1f53c", a: "0.6", id: 1121 }, { n: ["arrow_double_up", "black_up_pointing_double_triangle"], u: "23eb", a: "0.6", id: 1122 }, { n: ["arrow_down_small", "down_pointing_small_red_triangle"], u: "1f53d", a: "0.6", id: 1123 }, { n: ["arrow_double_down", "black_down_pointing_double_triangle"], u: "23ec", a: "0.6", id: 1124 }, { n: ["pause_button", "double_vertical_bar"], u: "23f8-fe0f", a: "0.7", id: 1125 }, { n: ["stop_button", "black_square_for_stop"], u: "23f9-fe0f", a: "0.7", id: 1126 }, { n: ["record_button", "black_circle_for_record"], u: "23fa-fe0f", a: "0.7", id: 1127 }, { n: ["eject", "eject_button"], u: "23cf-fe0f", a: "1.0", id: 1128 }, { n: ["cinema"], u: "1f3a6", a: "0.6", id: 1129 }, { n: ["low_brightness", "low_brightness_symbol"], u: "1f505", a: "1.0", id: 1130 }, { n: ["high_brightness", "high_brightness_symbol"], u: "1f506", a: "1.0", id: 1131 }, { n: ["signal_strength", "antenna_with_bars"], u: "1f4f6", a: "0.6", id: 1132 }, { n: ["vibration_mode"], u: "1f4f3", a: "0.6", id: 1133 }, { n: ["mobile_phone_off"], u: "1f4f4", a: "0.6", id: 1134 }, { n: ["female_sign"], u: "2640-fe0f", a: "4.0", id: 1135 }, { n: ["male_sign"], u: "2642-fe0f", a: "4.0", id: 1136 }, { n: ["transgender_symbol"], u: "26a7-fe0f", a: "13.0", id: 1137 }, { n: ["heavy_multiplication_x"], u: "2716-fe0f", a: "0.6", id: 1138 }, { n: ["heavy_plus_sign"], u: "2795", a: "0.6", id: 1139 }, { n: ["heavy_minus_sign"], u: "2796", a: "0.6", id: 1140 }, { n: ["heavy_division_sign"], u: "2797", a: "0.6", id: 1141 }, { n: ["heavy_equals_sign"], u: "1f7f0", a: "14.0", id: 1142 }, { n: ["infinity"], u: "267e-fe0f", a: "11.0", id: 1143 }, { n: ["bangbang", "double_exclamation_mark"], u: "203c-fe0f", a: "0.6", id: 1144 }, { n: ["interrobang", "exclamation_question_mark"], u: "2049-fe0f", a: "0.6", id: 1145 }, { n: ["question", "black_question_mark_ornament"], u: "2753", a: "0.6", id: 1146 }, { n: ["grey_question", "white_question_mark_ornament"], u: "2754", a: "0.6", id: 1147 }, { n: ["grey_exclamation", "white_exclamation_mark_ornament"], u: "2755", a: "0.6", id: 1148 }, { n: ["exclamation", "heavy_exclamation_mark", "heavy_exclamation_mark_symbol"], u: "2757", a: "0.6", id: 1149 }, { n: ["wavy_dash"], u: "3030-fe0f", a: "0.6", id: 1150 }, { n: ["currency_exchange"], u: "1f4b1", a: "0.6", id: 1151 }, { n: ["heavy_dollar_sign"], u: "1f4b2", a: "0.6", id: 1152 }, { n: ["medical_symbol", "staff_of_aesculapius"], u: "2695-fe0f", a: "4.0", id: 1153 }, { n: ["recycle", "black_universal_recycling_symbol"], u: "267b-fe0f", a: "0.6", id: 1154 }, { n: ["fleur_de_lis", "fleur_de_lis"], u: "269c-fe0f", a: "1.0", id: 1155 }, { n: ["trident", "trident_emblem"], u: "1f531", a: "0.6", id: 1156 }, { n: ["name_badge"], u: "1f4db", a: "0.6", id: 1157 }, { n: ["beginner", "japanese_symbol_for_beginner"], u: "1f530", a: "0.6", id: 1158 }, { n: ["o", "heavy_large_circle"], u: "2b55", a: "0.6", id: 1159 }, { n: ["white_check_mark", "white_heavy_check_mark"], u: "2705", a: "0.6", id: 1160 }, { n: ["ballot_box_with_check"], u: "2611-fe0f", a: "0.6", id: 1161 }, { n: ["heavy_check_mark"], u: "2714-fe0f", a: "0.6", id: 1162 }, { n: ["x", "cross_mark"], u: "274c", a: "0.6", id: 1163 }, { n: ["negative_squared_cross_mark"], u: "274e", a: "0.6", id: 1164 }, { n: ["curly_loop"], u: "27b0", a: "0.6", id: 1165 }, { n: ["loop", "double_curly_loop"], u: "27bf", a: "1.0", id: 1166 }, { n: ["part_alternation_mark"], u: "303d-fe0f", a: "0.6", id: 1167 }, { n: ["eight_spoked_asterisk"], u: "2733-fe0f", a: "0.6", id: 1168 }, { n: ["eight_pointed_black_star"], u: "2734-fe0f", a: "0.6", id: 1169 }, { n: ["sparkle"], u: "2747-fe0f", a: "0.6", id: 1170 }, { n: ["copyright", "copyright_sign"], u: "00a9-fe0f", a: "0.6", id: 1171 }, { n: ["registered", "registered_sign"], u: "00ae-fe0f", a: "0.6", id: 1172 }, { n: ["tm", "trade_mark_sign"], u: "2122-fe0f", a: "0.6", id: 1173 }, { n: ["hash", "hash_key"], u: "0023-fe0f-20e3", a: "0.6", id: 1174 }, { n: ["keycap", "keycap_star"], u: "002a-fe0f-20e3", a: "2.0", id: 1175 }, { n: ["zero", "keycap_0"], u: "0030-fe0f-20e3", a: "0.6", id: 1176 }, { n: ["one", "keycap_1"], u: "0031-fe0f-20e3", a: "0.6", id: 1177 }, { n: ["two", "keycap_2"], u: "0032-fe0f-20e3", a: "0.6", id: 1178 }, { n: ["three", "keycap_3"], u: "0033-fe0f-20e3", a: "0.6", id: 1179 }, { n: ["four", "keycap_4"], u: "0034-fe0f-20e3", a: "0.6", id: 1180 }, { n: ["five", "keycap_5"], u: "0035-fe0f-20e3", a: "0.6", id: 1181 }, { n: ["six", "keycap_6"], u: "0036-fe0f-20e3", a: "0.6", id: 1182 }, { n: ["seven", "keycap_7"], u: "0037-fe0f-20e3", a: "0.6", id: 1183 }, { n: ["eight", "keycap_8"], u: "0038-fe0f-20e3", a: "0.6", id: 1184 }, { n: ["nine", "keycap_9"], u: "0039-fe0f-20e3", a: "0.6", id: 1185 }, { n: ["keycap_ten"], u: "1f51f", a: "0.6", id: 1186 }, { n: ["capital_abcd", "input_symbol_for_latin_capital_letters"], u: "1f520", a: "0.6", id: 1187 }, { n: ["abcd", "input_symbol_for_latin_small_letters"], u: "1f521", a: "0.6", id: 1188 }, { n: ["1234", "input_symbol_for_numbers"], u: "1f522", a: "0.6", id: 1189 }, { n: ["symbols", "input_symbol_for_symbols"], u: "1f523", a: "0.6", id: 1190 }, { n: ["abc", "input_symbol_for_latin_letters"], u: "1f524", a: "0.6", id: 1191 }, { n: ["a", "negative_squared_latin_capital_letter_a"], u: "1f170-fe0f", a: "0.6", id: 1192 }, { n: ["ab", "negative_squared_ab"], u: "1f18e", a: "0.6", id: 1193 }, { n: ["b", "negative_squared_latin_capital_letter_b"], u: "1f171-fe0f", a: "0.6", id: 1194 }, { n: ["cl", "squared_cl"], u: "1f191", a: "0.6", id: 1195 }, { n: ["cool", "squared_cool"], u: "1f192", a: "0.6", id: 1196 }, { n: ["free", "squared_free"], u: "1f193", a: "0.6", id: 1197 }, { n: ["information_source"], u: "2139-fe0f", a: "0.6", id: 1198 }, { n: ["id", "squared_id"], u: "1f194", a: "0.6", id: 1199 }, { n: ["m", "circled_latin_capital_letter_m"], u: "24c2-fe0f", a: "0.6", id: 1200 }, { n: ["new", "squared_new"], u: "1f195", a: "0.6", id: 1201 }, { n: ["ng", "squared_ng"], u: "1f196", a: "0.6", id: 1202 }, { n: ["o2", "negative_squared_latin_capital_letter_o"], u: "1f17e-fe0f", a: "0.6", id: 1203 }, { n: ["ok", "squared_ok"], u: "1f197", a: "0.6", id: 1204 }, { n: ["parking", "negative_squared_latin_capital_letter_p"], u: "1f17f-fe0f", a: "0.6", id: 1205 }, { n: ["sos", "squared_sos"], u: "1f198", a: "0.6", id: 1206 }, { n: ["up", "squared_up_with_exclamation_mark"], u: "1f199", a: "0.6", id: 1207 }, { n: ["vs", "squared_vs"], u: "1f19a", a: "0.6", id: 1208 }, { n: ["koko", "squared_katakana_koko"], u: "1f201", a: "0.6", id: 1209 }, { n: ["sa", "squared_katakana_sa"], u: "1f202-fe0f", a: "0.6", id: 1210 }, { n: ["u6708", "squared_cjk_unified_ideograph_6708"], u: "1f237-fe0f", a: "0.6", id: 1211 }, { n: ["u6709", "squared_cjk_unified_ideograph_6709"], u: "1f236", a: "0.6", id: 1212 }, { n: ["u6307", "squared_cjk_unified_ideograph_6307"], u: "1f22f", a: "0.6", id: 1213 }, { n: ["ideograph_advantage", "circled_ideograph_advantage"], u: "1f250", a: "0.6", id: 1214 }, { n: ["u5272", "squared_cjk_unified_ideograph_5272"], u: "1f239", a: "0.6", id: 1215 }, { n: ["u7121", "squared_cjk_unified_ideograph_7121"], u: "1f21a", a: "0.6", id: 1216 }, { n: ["u7981", "squared_cjk_unified_ideograph_7981"], u: "1f232", a: "0.6", id: 1217 }, { n: ["accept", "circled_ideograph_accept"], u: "1f251", a: "0.6", id: 1218 }, { n: ["u7533", "squared_cjk_unified_ideograph_7533"], u: "1f238", a: "0.6", id: 1219 }, { n: ["u5408", "squared_cjk_unified_ideograph_5408"], u: "1f234", a: "0.6", id: 1220 }, { n: ["u7a7a", "squared_cjk_unified_ideograph_7a7a"], u: "1f233", a: "0.6", id: 1221 }, { n: ["congratulations", "circled_ideograph_congratulation"], u: "3297-fe0f", a: "0.6", id: 1222 }, { n: ["secret", "circled_ideograph_secret"], u: "3299-fe0f", a: "0.6", id: 1223 }, { n: ["u55b6", "squared_cjk_unified_ideograph_55b6"], u: "1f23a", a: "0.6", id: 1224 }, { n: ["u6e80", "squared_cjk_unified_ideograph_6e80"], u: "1f235", a: "0.6", id: 1225 }, { n: ["red_circle", "large_red_circle"], u: "1f534", a: "0.6", id: 1226 }, { n: ["large_orange_circle"], u: "1f7e0", a: "12.0", id: 1227 }, { n: ["large_yellow_circle"], u: "1f7e1", a: "12.0", id: 1228 }, { n: ["large_green_circle"], u: "1f7e2", a: "12.0", id: 1229 }, { n: ["large_blue_circle"], u: "1f535", a: "0.6", id: 1230 }, { n: ["large_purple_circle"], u: "1f7e3", a: "12.0", id: 1231 }, { n: ["large_brown_circle"], u: "1f7e4", a: "12.0", id: 1232 }, { n: ["black_circle", "medium_black_circle"], u: "26ab", a: "0.6", id: 1233 }, { n: ["white_circle", "medium_white_circle"], u: "26aa", a: "0.6", id: 1234 }, { n: ["large_red_square"], u: "1f7e5", a: "12.0", id: 1235 }, { n: ["large_orange_square"], u: "1f7e7", a: "12.0", id: 1236 }, { n: ["large_yellow_square"], u: "1f7e8", a: "12.0", id: 1237 }, { n: ["large_green_square"], u: "1f7e9", a: "12.0", id: 1238 }, { n: ["large_blue_square"], u: "1f7e6", a: "12.0", id: 1239 }, { n: ["large_purple_square"], u: "1f7ea", a: "12.0", id: 1240 }, { n: ["large_brown_square"], u: "1f7eb", a: "12.0", id: 1241 }, { n: ["black_large_square"], u: "2b1b", a: "0.6", id: 1242 }, { n: ["white_large_square"], u: "2b1c", a: "0.6", id: 1243 }, { n: ["black_medium_square"], u: "25fc-fe0f", a: "0.6", id: 1244 }, { n: ["white_medium_square"], u: "25fb-fe0f", a: "0.6", id: 1245 }, { n: ["black_medium_small_square"], u: "25fe", a: "0.6", id: 1246 }, { n: ["white_medium_small_square"], u: "25fd", a: "0.6", id: 1247 }, { n: ["black_small_square"], u: "25aa-fe0f", a: "0.6", id: 1248 }, { n: ["white_small_square"], u: "25ab-fe0f", a: "0.6", id: 1249 }, { n: ["large_orange_diamond"], u: "1f536", a: "0.6", id: 1250 }, { n: ["large_blue_diamond"], u: "1f537", a: "0.6", id: 1251 }, { n: ["small_orange_diamond"], u: "1f538", a: "0.6", id: 1252 }, { n: ["small_blue_diamond"], u: "1f539", a: "0.6", id: 1253 }, { n: ["small_red_triangle", "up_pointing_red_triangle"], u: "1f53a", a: "0.6", id: 1254 }, { n: ["small_red_triangle_down", "down_pointing_red_triangle"], u: "1f53b", a: "0.6", id: 1255 }, { n: ["diamond_shape_with_a_dot_inside"], u: "1f4a0", a: "0.6", id: 1256 }, { n: ["radio_button"], u: "1f518", a: "0.6", id: 1257 }, { n: ["white_square_button"], u: "1f533", a: "0.6", id: 1258 }, { n: ["black_square_button"], u: "1f532", a: "0.6", id: 1259 }], q0 = [{ n: ["chequered_flag", "checkered_flag"], u: "1f3c1", a: "0.6", id: 1260 }, { n: ["triangular_flag_on_post"], u: "1f6a9", a: "0.6", id: 1261 }, { n: ["crossed_flags"], u: "1f38c", a: "0.6", id: 1262 }, { n: ["waving_black_flag"], u: "1f3f4", a: "1.0", id: 1263 }, { n: ["white_flag", "waving_white_flag"], u: "1f3f3-fe0f", a: "0.7", id: 1264 }, { n: ["rainbow_flag", "rainbow_flag"], u: "1f3f3-fe0f-200d-1f308", a: "4.0", id: 1265 }, { n: ["transgender_flag"], u: "1f3f3-fe0f-200d-26a7-fe0f", a: "13.0", id: 1266 }, { n: ["pirate_flag"], u: "1f3f4-200d-2620-fe0f", a: "11.0", id: 1267 }, { n: ["flag_ac", "ascension_island_flag"], u: "1f1e6-1f1e8", a: "2.0", id: 1268 }, { n: ["flag_ad", "andorra_flag"], u: "1f1e6-1f1e9", a: "2.0", id: 1269 }, { n: ["flag_ae", "united_arab_emirates_flag"], u: "1f1e6-1f1ea", a: "2.0", id: 1270 }, { n: ["flag_af", "afghanistan_flag"], u: "1f1e6-1f1eb", a: "2.0", id: 1271 }, { n: ["flag_ag", "antigua_barbuda_flag"], u: "1f1e6-1f1ec", a: "2.0", id: 1272 }, { n: ["flag_ai", "anguilla_flag"], u: "1f1e6-1f1ee", a: "2.0", id: 1273 }, { n: ["flag_al", "albania_flag"], u: "1f1e6-1f1f1", a: "2.0", id: 1274 }, { n: ["flag_am", "armenia_flag"], u: "1f1e6-1f1f2", a: "2.0", id: 1275 }, { n: ["flag_ao", "angola_flag"], u: "1f1e6-1f1f4", a: "2.0", id: 1276 }, { n: ["flag_aq", "antarctica_flag"], u: "1f1e6-1f1f6", a: "2.0", id: 1277 }, { n: ["flag_ar", "argentina_flag"], u: "1f1e6-1f1f7", a: "2.0", id: 1278 }, { n: ["flag_as", "american_samoa_flag"], u: "1f1e6-1f1f8", a: "2.0", id: 1279 }, { n: ["flag_at", "austria_flag"], u: "1f1e6-1f1f9", a: "2.0", id: 1280 }, { n: ["flag_au", "australia_flag"], u: "1f1e6-1f1fa", a: "2.0", id: 1281 }, { n: ["flag_aw", "aruba_flag"], u: "1f1e6-1f1fc", a: "2.0", id: 1282 }, { n: ["flag_ax", "land_islands_flag"], u: "1f1e6-1f1fd", a: "2.0", id: 1283 }, { n: ["flag_az", "azerbaijan_flag"], u: "1f1e6-1f1ff", a: "2.0", id: 1284 }, { n: ["flag_ba", "bosnia_herzegovina_flag"], u: "1f1e7-1f1e6", a: "2.0", id: 1285 }, { n: ["flag_bb", "barbados_flag"], u: "1f1e7-1f1e7", a: "2.0", id: 1286 }, { n: ["flag_bd", "bangladesh_flag"], u: "1f1e7-1f1e9", a: "2.0", id: 1287 }, { n: ["flag_be", "belgium_flag"], u: "1f1e7-1f1ea", a: "2.0", id: 1288 }, { n: ["flag_bf", "burkina_faso_flag"], u: "1f1e7-1f1eb", a: "2.0", id: 1289 }, { n: ["flag_bg", "bulgaria_flag"], u: "1f1e7-1f1ec", a: "2.0", id: 1290 }, { n: ["flag_bh", "bahrain_flag"], u: "1f1e7-1f1ed", a: "2.0", id: 1291 }, { n: ["flag_bi", "burundi_flag"], u: "1f1e7-1f1ee", a: "2.0", id: 1292 }, { n: ["flag_bj", "benin_flag"], u: "1f1e7-1f1ef", a: "2.0", id: 1293 }, { n: ["flag_bl", "st_barth_lemy_flag"], u: "1f1e7-1f1f1", a: "2.0", id: 1294 }, { n: ["flag_bm", "bermuda_flag"], u: "1f1e7-1f1f2", a: "2.0", id: 1295 }, { n: ["flag_bn", "brunei_flag"], u: "1f1e7-1f1f3", a: "2.0", id: 1296 }, { n: ["flag_bo", "bolivia_flag"], u: "1f1e7-1f1f4", a: "2.0", id: 1297 }, { n: ["flag_bq", "caribbean_netherlands_flag"], u: "1f1e7-1f1f6", a: "2.0", id: 1298 }, { n: ["flag_br", "brazil_flag"], u: "1f1e7-1f1f7", a: "2.0", id: 1299 }, { n: ["flag_bs", "bahamas_flag"], u: "1f1e7-1f1f8", a: "2.0", id: 1300 }, { n: ["flag_bt", "bhutan_flag"], u: "1f1e7-1f1f9", a: "2.0", id: 1301 }, { n: ["flag_bv", "bouvet_island_flag"], u: "1f1e7-1f1fb", a: "2.0", id: 1302 }, { n: ["flag_bw", "botswana_flag"], u: "1f1e7-1f1fc", a: "2.0", id: 1303 }, { n: ["flag_by", "belarus_flag"], u: "1f1e7-1f1fe", a: "2.0", id: 1304 }, { n: ["flag_bz", "belize_flag"], u: "1f1e7-1f1ff", a: "2.0", id: 1305 }, { n: ["flag_ca", "canada_flag"], u: "1f1e8-1f1e6", a: "2.0", id: 1306 }, { n: ["flag_cc", "cocos_keeling_islands_flag"], u: "1f1e8-1f1e8", a: "2.0", id: 1307 }, { n: ["flag_cd", "congo_kinshasa_flag"], u: "1f1e8-1f1e9", a: "2.0", id: 1308 }, { n: ["flag_cf", "central_african_republic_flag"], u: "1f1e8-1f1eb", a: "2.0", id: 1309 }, { n: ["flag_cg", "congo_brazzaville_flag"], u: "1f1e8-1f1ec", a: "2.0", id: 1310 }, { n: ["flag_ch", "switzerland_flag"], u: "1f1e8-1f1ed", a: "2.0", id: 1311 }, { n: ["flag_ci", "c_te_d_ivoire_flag"], u: "1f1e8-1f1ee", a: "2.0", id: 1312 }, { n: ["flag_ck", "cook_islands_flag"], u: "1f1e8-1f1f0", a: "2.0", id: 1313 }, { n: ["flag_cl", "chile_flag"], u: "1f1e8-1f1f1", a: "2.0", id: 1314 }, { n: ["flag_cm", "cameroon_flag"], u: "1f1e8-1f1f2", a: "2.0", id: 1315 }, { n: ["cn", "flag_cn", "china_flag"], u: "1f1e8-1f1f3", a: "0.6", id: 1316 }, { n: ["flag_co", "colombia_flag"], u: "1f1e8-1f1f4", a: "2.0", id: 1317 }, { n: ["flag_cp", "clipperton_island_flag"], u: "1f1e8-1f1f5", a: "2.0", id: 1318 }, { n: ["flag_cr", "costa_rica_flag"], u: "1f1e8-1f1f7", a: "2.0", id: 1319 }, { n: ["flag_cu", "cuba_flag"], u: "1f1e8-1f1fa", a: "2.0", id: 1320 }, { n: ["flag_cv", "cape_verde_flag"], u: "1f1e8-1f1fb", a: "2.0", id: 1321 }, { n: ["flag_cw", "cura_ao_flag"], u: "1f1e8-1f1fc", a: "2.0", id: 1322 }, { n: ["flag_cx", "christmas_island_flag"], u: "1f1e8-1f1fd", a: "2.0", id: 1323 }, { n: ["flag_cy", "cyprus_flag"], u: "1f1e8-1f1fe", a: "2.0", id: 1324 }, { n: ["flag_cz", "czechia_flag"], u: "1f1e8-1f1ff", a: "2.0", id: 1325 }, { n: ["de", "flag_de", "germany_flag"], u: "1f1e9-1f1ea", a: "0.6", id: 1326 }, { n: ["flag_dg", "diego_garcia_flag"], u: "1f1e9-1f1ec", a: "2.0", id: 1327 }, { n: ["flag_dj", "djibouti_flag"], u: "1f1e9-1f1ef", a: "2.0", id: 1328 }, { n: ["flag_dk", "denmark_flag"], u: "1f1e9-1f1f0", a: "2.0", id: 1329 }, { n: ["flag_dm", "dominica_flag"], u: "1f1e9-1f1f2", a: "2.0", id: 1330 }, { n: ["flag_do", "dominican_republic_flag"], u: "1f1e9-1f1f4", a: "2.0", id: 1331 }, { n: ["flag_dz", "algeria_flag"], u: "1f1e9-1f1ff", a: "2.0", id: 1332 }, { n: ["flag_ea", "ceuta_melilla_flag"], u: "1f1ea-1f1e6", a: "2.0", id: 1333 }, { n: ["flag_ec", "ecuador_flag"], u: "1f1ea-1f1e8", a: "2.0", id: 1334 }, { n: ["flag_ee", "estonia_flag"], u: "1f1ea-1f1ea", a: "2.0", id: 1335 }, { n: ["flag_eg", "egypt_flag"], u: "1f1ea-1f1ec", a: "2.0", id: 1336 }, { n: ["flag_eh", "western_sahara_flag"], u: "1f1ea-1f1ed", a: "2.0", id: 1337 }, { n: ["flag_er", "eritrea_flag"], u: "1f1ea-1f1f7", a: "2.0", id: 1338 }, { n: ["es", "flag_es", "spain_flag"], u: "1f1ea-1f1f8", a: "0.6", id: 1339 }, { n: ["flag_et", "ethiopia_flag"], u: "1f1ea-1f1f9", a: "2.0", id: 1340 }, { n: ["flag_eu", "european_union_flag"], u: "1f1ea-1f1fa", a: "2.0", id: 1341 }, { n: ["flag_fi", "finland_flag"], u: "1f1eb-1f1ee", a: "2.0", id: 1342 }, { n: ["flag_fj", "fiji_flag"], u: "1f1eb-1f1ef", a: "2.0", id: 1343 }, { n: ["flag_fk", "falkland_islands_flag"], u: "1f1eb-1f1f0", a: "2.0", id: 1344 }, { n: ["flag_fm", "micronesia_flag"], u: "1f1eb-1f1f2", a: "2.0", id: 1345 }, { n: ["flag_fo", "faroe_islands_flag"], u: "1f1eb-1f1f4", a: "2.0", id: 1346 }, { n: ["fr", "flag_fr", "france_flag"], u: "1f1eb-1f1f7", a: "0.6", id: 1347 }, { n: ["flag_ga", "gabon_flag"], u: "1f1ec-1f1e6", a: "2.0", id: 1348 }, { n: ["gb", "uk", "flag_gb", "united_kingdom_flag"], u: "1f1ec-1f1e7", a: "0.6", id: 1349 }, { n: ["flag_gd", "grenada_flag"], u: "1f1ec-1f1e9", a: "2.0", id: 1350 }, { n: ["flag_ge", "georgia_flag"], u: "1f1ec-1f1ea", a: "2.0", id: 1351 }, { n: ["flag_gf", "french_guiana_flag"], u: "1f1ec-1f1eb", a: "2.0", id: 1352 }, { n: ["flag_gg", "guernsey_flag"], u: "1f1ec-1f1ec", a: "2.0", id: 1353 }, { n: ["flag_gh", "ghana_flag"], u: "1f1ec-1f1ed", a: "2.0", id: 1354 }, { n: ["flag_gi", "gibraltar_flag"], u: "1f1ec-1f1ee", a: "2.0", id: 1355 }, { n: ["flag_gl", "greenland_flag"], u: "1f1ec-1f1f1", a: "2.0", id: 1356 }, { n: ["flag_gm", "gambia_flag"], u: "1f1ec-1f1f2", a: "2.0", id: 1357 }, { n: ["flag_gn", "guinea_flag"], u: "1f1ec-1f1f3", a: "2.0", id: 1358 }, { n: ["flag_gp", "guadeloupe_flag"], u: "1f1ec-1f1f5", a: "2.0", id: 1359 }, { n: ["flag_gq", "equatorial_guinea_flag"], u: "1f1ec-1f1f6", a: "2.0", id: 1360 }, { n: ["flag_gr", "greece_flag"], u: "1f1ec-1f1f7", a: "2.0", id: 1361 }, { n: ["flag_gs", "south_georgia_south_sandwich_islands_flag"], u: "1f1ec-1f1f8", a: "2.0", id: 1362 }, { n: ["flag_gt", "guatemala_flag"], u: "1f1ec-1f1f9", a: "2.0", id: 1363 }, { n: ["flag_gu", "guam_flag"], u: "1f1ec-1f1fa", a: "2.0", id: 1364 }, { n: ["flag_gw", "guinea_bissau_flag"], u: "1f1ec-1f1fc", a: "2.0", id: 1365 }, { n: ["flag_gy", "guyana_flag"], u: "1f1ec-1f1fe", a: "2.0", id: 1366 }, { n: ["flag_hk", "hong_kong_sar_china_flag"], u: "1f1ed-1f1f0", a: "2.0", id: 1367 }, { n: ["flag_hm", "heard_mcdonald_islands_flag"], u: "1f1ed-1f1f2", a: "2.0", id: 1368 }, { n: ["flag_hn", "honduras_flag"], u: "1f1ed-1f1f3", a: "2.0", id: 1369 }, { n: ["flag_hr", "croatia_flag"], u: "1f1ed-1f1f7", a: "2.0", id: 1370 }, { n: ["flag_ht", "haiti_flag"], u: "1f1ed-1f1f9", a: "2.0", id: 1371 }, { n: ["flag_hu", "hungary_flag"], u: "1f1ed-1f1fa", a: "2.0", id: 1372 }, { n: ["flag_ic", "canary_islands_flag"], u: "1f1ee-1f1e8", a: "2.0", id: 1373 }, { n: ["flag_id", "indonesia_flag"], u: "1f1ee-1f1e9", a: "2.0", id: 1374 }, { n: ["flag_ie", "ireland_flag"], u: "1f1ee-1f1ea", a: "2.0", id: 1375 }, { n: ["flag_il", "israel_flag"], u: "1f1ee-1f1f1", a: "2.0", id: 1376 }, { n: ["flag_im", "isle_of_man_flag"], u: "1f1ee-1f1f2", a: "2.0", id: 1377 }, { n: ["flag_in", "india_flag"], u: "1f1ee-1f1f3", a: "2.0", id: 1378 }, { n: ["flag_io", "british_indian_ocean_territory_flag"], u: "1f1ee-1f1f4", a: "2.0", id: 1379 }, { n: ["flag_iq", "iraq_flag"], u: "1f1ee-1f1f6", a: "2.0", id: 1380 }, { n: ["flag_ir", "iran_flag"], u: "1f1ee-1f1f7", a: "2.0", id: 1381 }, { n: ["flag_is", "iceland_flag"], u: "1f1ee-1f1f8", a: "2.0", id: 1382 }, { n: ["it", "flag_it", "italy_flag"], u: "1f1ee-1f1f9", a: "0.6", id: 1383 }, { n: ["flag_je", "jersey_flag"], u: "1f1ef-1f1ea", a: "2.0", id: 1384 }, { n: ["flag_jm", "jamaica_flag"], u: "1f1ef-1f1f2", a: "2.0", id: 1385 }, { n: ["flag_jo", "jordan_flag"], u: "1f1ef-1f1f4", a: "2.0", id: 1386 }, { n: ["jp", "flag_jp", "japan_flag"], u: "1f1ef-1f1f5", a: "0.6", id: 1387 }, { n: ["flag_ke", "kenya_flag"], u: "1f1f0-1f1ea", a: "2.0", id: 1388 }, { n: ["flag_kg", "kyrgyzstan_flag"], u: "1f1f0-1f1ec", a: "2.0", id: 1389 }, { n: ["flag_kh", "cambodia_flag"], u: "1f1f0-1f1ed", a: "2.0", id: 1390 }, { n: ["flag_ki", "kiribati_flag"], u: "1f1f0-1f1ee", a: "2.0", id: 1391 }, { n: ["flag_km", "comoros_flag"], u: "1f1f0-1f1f2", a: "2.0", id: 1392 }, { n: ["flag_kn", "st_kitts_nevis_flag"], u: "1f1f0-1f1f3", a: "2.0", id: 1393 }, { n: ["flag_kp", "north_korea_flag"], u: "1f1f0-1f1f5", a: "2.0", id: 1394 }, { n: ["kr", "flag_kr", "south_korea_flag"], u: "1f1f0-1f1f7", a: "0.6", id: 1395 }, { n: ["flag_kw", "kuwait_flag"], u: "1f1f0-1f1fc", a: "2.0", id: 1396 }, { n: ["flag_ky", "cayman_islands_flag"], u: "1f1f0-1f1fe", a: "2.0", id: 1397 }, { n: ["flag_kz", "kazakhstan_flag"], u: "1f1f0-1f1ff", a: "2.0", id: 1398 }, { n: ["flag_la", "laos_flag"], u: "1f1f1-1f1e6", a: "2.0", id: 1399 }, { n: ["flag_lb", "lebanon_flag"], u: "1f1f1-1f1e7", a: "2.0", id: 1400 }, { n: ["flag_lc", "st_lucia_flag"], u: "1f1f1-1f1e8", a: "2.0", id: 1401 }, { n: ["flag_li", "liechtenstein_flag"], u: "1f1f1-1f1ee", a: "2.0", id: 1402 }, { n: ["flag_lk", "sri_lanka_flag"], u: "1f1f1-1f1f0", a: "2.0", id: 1403 }, { n: ["flag_lr", "liberia_flag"], u: "1f1f1-1f1f7", a: "2.0", id: 1404 }, { n: ["flag_ls", "lesotho_flag"], u: "1f1f1-1f1f8", a: "2.0", id: 1405 }, { n: ["flag_lt", "lithuania_flag"], u: "1f1f1-1f1f9", a: "2.0", id: 1406 }, { n: ["flag_lu", "luxembourg_flag"], u: "1f1f1-1f1fa", a: "2.0", id: 1407 }, { n: ["flag_lv", "latvia_flag"], u: "1f1f1-1f1fb", a: "2.0", id: 1408 }, { n: ["flag_ly", "libya_flag"], u: "1f1f1-1f1fe", a: "2.0", id: 1409 }, { n: ["flag_ma", "morocco_flag"], u: "1f1f2-1f1e6", a: "2.0", id: 1410 }, { n: ["flag_mc", "monaco_flag"], u: "1f1f2-1f1e8", a: "2.0", id: 1411 }, { n: ["flag_md", "moldova_flag"], u: "1f1f2-1f1e9", a: "2.0", id: 1412 }, { n: ["flag_me", "montenegro_flag"], u: "1f1f2-1f1ea", a: "2.0", id: 1413 }, { n: ["flag_mf", "st_martin_flag"], u: "1f1f2-1f1eb", a: "2.0", id: 1414 }, { n: ["flag_mg", "madagascar_flag"], u: "1f1f2-1f1ec", a: "2.0", id: 1415 }, { n: ["flag_mh", "marshall_islands_flag"], u: "1f1f2-1f1ed", a: "2.0", id: 1416 }, { n: ["flag_mk", "north_macedonia_flag"], u: "1f1f2-1f1f0", a: "2.0", id: 1417 }, { n: ["flag_ml", "mali_flag"], u: "1f1f2-1f1f1", a: "2.0", id: 1418 }, { n: ["flag_mm", "myanmar_burma_flag"], u: "1f1f2-1f1f2", a: "2.0", id: 1419 }, { n: ["flag_mn", "mongolia_flag"], u: "1f1f2-1f1f3", a: "2.0", id: 1420 }, { n: ["flag_mo", "macao_sar_china_flag"], u: "1f1f2-1f1f4", a: "2.0", id: 1421 }, { n: ["flag_mp", "northern_mariana_islands_flag"], u: "1f1f2-1f1f5", a: "2.0", id: 1422 }, { n: ["flag_mq", "martinique_flag"], u: "1f1f2-1f1f6", a: "2.0", id: 1423 }, { n: ["flag_mr", "mauritania_flag"], u: "1f1f2-1f1f7", a: "2.0", id: 1424 }, { n: ["flag_ms", "montserrat_flag"], u: "1f1f2-1f1f8", a: "2.0", id: 1425 }, { n: ["flag_mt", "malta_flag"], u: "1f1f2-1f1f9", a: "2.0", id: 1426 }, { n: ["flag_mu", "mauritius_flag"], u: "1f1f2-1f1fa", a: "2.0", id: 1427 }, { n: ["flag_mv", "maldives_flag"], u: "1f1f2-1f1fb", a: "2.0", id: 1428 }, { n: ["flag_mw", "malawi_flag"], u: "1f1f2-1f1fc", a: "2.0", id: 1429 }, { n: ["flag_mx", "mexico_flag"], u: "1f1f2-1f1fd", a: "2.0", id: 1430 }, { n: ["flag_my", "malaysia_flag"], u: "1f1f2-1f1fe", a: "2.0", id: 1431 }, { n: ["flag_mz", "mozambique_flag"], u: "1f1f2-1f1ff", a: "2.0", id: 1432 }, { n: ["flag_na", "namibia_flag"], u: "1f1f3-1f1e6", a: "2.0", id: 1433 }, { n: ["flag_nc", "new_caledonia_flag"], u: "1f1f3-1f1e8", a: "2.0", id: 1434 }, { n: ["flag_ne", "niger_flag"], u: "1f1f3-1f1ea", a: "2.0", id: 1435 }, { n: ["flag_nf", "norfolk_island_flag"], u: "1f1f3-1f1eb", a: "2.0", id: 1436 }, { n: ["flag_ng", "nigeria_flag"], u: "1f1f3-1f1ec", a: "2.0", id: 1437 }, { n: ["flag_ni", "nicaragua_flag"], u: "1f1f3-1f1ee", a: "2.0", id: 1438 }, { n: ["flag_nl", "netherlands_flag"], u: "1f1f3-1f1f1", a: "2.0", id: 1439 }, { n: ["flag_no", "norway_flag"], u: "1f1f3-1f1f4", a: "2.0", id: 1440 }, { n: ["flag_np", "nepal_flag"], u: "1f1f3-1f1f5", a: "2.0", id: 1441 }, { n: ["flag_nr", "nauru_flag"], u: "1f1f3-1f1f7", a: "2.0", id: 1442 }, { n: ["flag_nu", "niue_flag"], u: "1f1f3-1f1fa", a: "2.0", id: 1443 }, { n: ["flag_nz", "new_zealand_flag"], u: "1f1f3-1f1ff", a: "2.0", id: 1444 }, { n: ["flag_om", "oman_flag"], u: "1f1f4-1f1f2", a: "2.0", id: 1445 }, { n: ["flag_pa", "panama_flag"], u: "1f1f5-1f1e6", a: "2.0", id: 1446 }, { n: ["flag_pe", "peru_flag"], u: "1f1f5-1f1ea", a: "2.0", id: 1447 }, { n: ["flag_pf", "french_polynesia_flag"], u: "1f1f5-1f1eb", a: "2.0", id: 1448 }, { n: ["flag_pg", "papua_new_guinea_flag"], u: "1f1f5-1f1ec", a: "2.0", id: 1449 }, { n: ["flag_ph", "philippines_flag"], u: "1f1f5-1f1ed", a: "2.0", id: 1450 }, { n: ["flag_pk", "pakistan_flag"], u: "1f1f5-1f1f0", a: "2.0", id: 1451 }, { n: ["flag_pl", "poland_flag"], u: "1f1f5-1f1f1", a: "2.0", id: 1452 }, { n: ["flag_pm", "st_pierre_miquelon_flag"], u: "1f1f5-1f1f2", a: "2.0", id: 1453 }, { n: ["flag_pn", "pitcairn_islands_flag"], u: "1f1f5-1f1f3", a: "2.0", id: 1454 }, { n: ["flag_pr", "puerto_rico_flag"], u: "1f1f5-1f1f7", a: "2.0", id: 1455 }, { n: ["flag_ps", "palestinian_territories_flag"], u: "1f1f5-1f1f8", a: "2.0", id: 1456 }, { n: ["flag_pt", "portugal_flag"], u: "1f1f5-1f1f9", a: "2.0", id: 1457 }, { n: ["flag_pw", "palau_flag"], u: "1f1f5-1f1fc", a: "2.0", id: 1458 }, { n: ["flag_py", "paraguay_flag"], u: "1f1f5-1f1fe", a: "2.0", id: 1459 }, { n: ["flag_qa", "qatar_flag"], u: "1f1f6-1f1e6", a: "2.0", id: 1460 }, { n: ["flag_re", "r_union_flag"], u: "1f1f7-1f1ea", a: "2.0", id: 1461 }, { n: ["flag_ro", "romania_flag"], u: "1f1f7-1f1f4", a: "2.0", id: 1462 }, { n: ["flag_rs", "serbia_flag"], u: "1f1f7-1f1f8", a: "2.0", id: 1463 }, { n: ["ru", "flag_ru", "russia_flag"], u: "1f1f7-1f1fa", a: "0.6", id: 1464 }, { n: ["flag_rw", "rwanda_flag"], u: "1f1f7-1f1fc", a: "2.0", id: 1465 }, { n: ["flag_sa", "saudi_arabia_flag"], u: "1f1f8-1f1e6", a: "2.0", id: 1466 }, { n: ["flag_sb", "solomon_islands_flag"], u: "1f1f8-1f1e7", a: "2.0", id: 1467 }, { n: ["flag_sc", "seychelles_flag"], u: "1f1f8-1f1e8", a: "2.0", id: 1468 }, { n: ["flag_sd", "sudan_flag"], u: "1f1f8-1f1e9", a: "2.0", id: 1469 }, { n: ["flag_se", "sweden_flag"], u: "1f1f8-1f1ea", a: "2.0", id: 1470 }, { n: ["flag_sg", "singapore_flag"], u: "1f1f8-1f1ec", a: "2.0", id: 1471 }, { n: ["flag_sh", "st_helena_flag"], u: "1f1f8-1f1ed", a: "2.0", id: 1472 }, { n: ["flag_si", "slovenia_flag"], u: "1f1f8-1f1ee", a: "2.0", id: 1473 }, { n: ["flag_sj", "svalbard_jan_mayen_flag"], u: "1f1f8-1f1ef", a: "2.0", id: 1474 }, { n: ["flag_sk", "slovakia_flag"], u: "1f1f8-1f1f0", a: "2.0", id: 1475 }, { n: ["flag_sl", "sierra_leone_flag"], u: "1f1f8-1f1f1", a: "2.0", id: 1476 }, { n: ["flag_sm", "san_marino_flag"], u: "1f1f8-1f1f2", a: "2.0", id: 1477 }, { n: ["flag_sn", "senegal_flag"], u: "1f1f8-1f1f3", a: "2.0", id: 1478 }, { n: ["flag_so", "somalia_flag"], u: "1f1f8-1f1f4", a: "2.0", id: 1479 }, { n: ["flag_sr", "suriname_flag"], u: "1f1f8-1f1f7", a: "2.0", id: 1480 }, { n: ["flag_ss", "south_sudan_flag"], u: "1f1f8-1f1f8", a: "2.0", id: 1481 }, { n: ["flag_st", "s_o_tom_pr_ncipe_flag"], u: "1f1f8-1f1f9", a: "2.0", id: 1482 }, { n: ["flag_sv", "el_salvador_flag"], u: "1f1f8-1f1fb", a: "2.0", id: 1483 }, { n: ["flag_sx", "sint_maarten_flag"], u: "1f1f8-1f1fd", a: "2.0", id: 1484 }, { n: ["flag_sy", "syria_flag"], u: "1f1f8-1f1fe", a: "2.0", id: 1485 }, { n: ["flag_sz", "eswatini_flag"], u: "1f1f8-1f1ff", a: "2.0", id: 1486 }, { n: ["flag_ta", "tristan_da_cunha_flag"], u: "1f1f9-1f1e6", a: "2.0", id: 1487 }, { n: ["flag_tc", "turks_caicos_islands_flag"], u: "1f1f9-1f1e8", a: "2.0", id: 1488 }, { n: ["flag_td", "chad_flag"], u: "1f1f9-1f1e9", a: "2.0", id: 1489 }, { n: ["flag_tf", "french_southern_territories_flag"], u: "1f1f9-1f1eb", a: "2.0", id: 1490 }, { n: ["flag_tg", "togo_flag"], u: "1f1f9-1f1ec", a: "2.0", id: 1491 }, { n: ["flag_th", "thailand_flag"], u: "1f1f9-1f1ed", a: "2.0", id: 1492 }, { n: ["flag_tj", "tajikistan_flag"], u: "1f1f9-1f1ef", a: "2.0", id: 1493 }, { n: ["flag_tk", "tokelau_flag"], u: "1f1f9-1f1f0", a: "2.0", id: 1494 }, { n: ["flag_tl", "timor_leste_flag"], u: "1f1f9-1f1f1", a: "2.0", id: 1495 }, { n: ["flag_tm", "turkmenistan_flag"], u: "1f1f9-1f1f2", a: "2.0", id: 1496 }, { n: ["flag_tn", "tunisia_flag"], u: "1f1f9-1f1f3", a: "2.0", id: 1497 }, { n: ["flag_to", "tonga_flag"], u: "1f1f9-1f1f4", a: "2.0", id: 1498 }, { n: ["flag_tr", "turkey_flag"], u: "1f1f9-1f1f7", a: "2.0", id: 1499 }, { n: ["flag_tt", "trinidad_tobago_flag"], u: "1f1f9-1f1f9", a: "2.0", id: 1500 }, { n: ["flag_tv", "tuvalu_flag"], u: "1f1f9-1f1fb", a: "2.0", id: 1501 }, { n: ["flag_tw", "taiwan_flag"], u: "1f1f9-1f1fc", a: "2.0", id: 1502 }, { n: ["flag_tz", "tanzania_flag"], u: "1f1f9-1f1ff", a: "2.0", id: 1503 }, { n: ["flag_ua", "ukraine_flag"], u: "1f1fa-1f1e6", a: "2.0", id: 1504 }, { n: ["flag_ug", "uganda_flag"], u: "1f1fa-1f1ec", a: "2.0", id: 1505 }, { n: ["flag_um", "u_s_outlying_islands_flag"], u: "1f1fa-1f1f2", a: "2.0", id: 1506 }, { n: ["flag_un", "united_nations_flag"], u: "1f1fa-1f1f3", a: "4.0", id: 1507 }, { n: ["us", "flag_us", "united_states_flag"], u: "1f1fa-1f1f8", a: "0.6", id: 1508 }, { n: ["flag_uy", "uruguay_flag"], u: "1f1fa-1f1fe", a: "2.0", id: 1509 }, { n: ["flag_uz", "uzbekistan_flag"], u: "1f1fa-1f1ff", a: "2.0", id: 1510 }, { n: ["flag_va", "vatican_city_flag"], u: "1f1fb-1f1e6", a: "2.0", id: 1511 }, { n: ["flag_vc", "st_vincent_grenadines_flag"], u: "1f1fb-1f1e8", a: "2.0", id: 1512 }, { n: ["flag_ve", "venezuela_flag"], u: "1f1fb-1f1ea", a: "2.0", id: 1513 }, { n: ["flag_vg", "british_virgin_islands_flag"], u: "1f1fb-1f1ec", a: "2.0", id: 1514 }, { n: ["flag_vi", "u_s_virgin_islands_flag"], u: "1f1fb-1f1ee", a: "2.0", id: 1515 }, { n: ["flag_vn", "vietnam_flag"], u: "1f1fb-1f1f3", a: "2.0", id: 1516 }, { n: ["flag_vu", "vanuatu_flag"], u: "1f1fb-1f1fa", a: "2.0", id: 1517 }, { n: ["flag_wf", "wallis_futuna_flag"], u: "1f1fc-1f1eb", a: "2.0", id: 1518 }, { n: ["flag_ws", "samoa_flag"], u: "1f1fc-1f1f8", a: "2.0", id: 1519 }, { n: ["flag_xk", "kosovo_flag"], u: "1f1fd-1f1f0", a: "2.0", id: 1520 }, { n: ["flag_ye", "yemen_flag"], u: "1f1fe-1f1ea", a: "2.0", id: 1521 }, { n: ["flag_yt", "mayotte_flag"], u: "1f1fe-1f1f9", a: "2.0", id: 1522 }, { n: ["flag_za", "south_africa_flag"], u: "1f1ff-1f1e6", a: "2.0", id: 1523 }, { n: ["flag_zm", "zambia_flag"], u: "1f1ff-1f1f2", a: "2.0", id: 1524 }, { n: ["flag_zw", "zimbabwe_flag"], u: "1f1ff-1f1fc", a: "2.0", id: 1525 }, { n: ["england_flag", "flag_england"], u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f", a: "5.0", id: 1526 }, { n: ["scotland_flag", "flag_scotland"], u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f", a: "5.0", id: 1527 }, { n: ["wales_flag", "flag_wales"], u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f", a: "5.0", id: 1528 }], ao = { smileys_people: G0, animals_nature: H0, food_drink: V0, travel_places: W0, activities: j0, objects: Q0, symbols: Y0, flags: q0 };
class X0 {
  constructor() {
    this.emojiSize = 64, this.emojis = /* @__PURE__ */ new Map(), this.version = 0, this.initCanvas();
  }
  initCanvas() {
    this.canvas = null, typeof OffscreenCanvas < "u" ? this.canvas = new OffscreenCanvas(0, 0) : typeof document < "u" ? this.canvas = document.createElement("canvas") : this.canvas = null, this.canvas && (this.ctx = this.canvas.getContext("2d"), this.texture = new n.CanvasTexture(this.canvas, n.UVMapping, n.ClampToEdgeWrapping, n.ClampToEdgeWrapping, n.LinearFilter, n.LinearFilter, n.RGBAFormat, n.UnsignedByteType, 16), this.needsUpdate = true);
  }
  indexOf(t) {
    return this.emojis.get(t)?._index ?? -1;
  }
  async load(t) {
    if (!this.emojis.has(t))
      return new Promise((a) => {
        const i = new Image();
        i.crossOrigin = "anonymous", i.onload = () => {
          this.emojis.set(t, i), i._index = this.emojis.size - 1, this.needsUpdate = true, a();
        }, i.src = t;
      });
  }
  update() {
    if (this.canvas || this.initCanvas(), !this.needsUpdate || !this.texture)
      return;
    const t = this.emojiSize * Math.max(this.emojis.size, 1);
    t > this.canvas.width && this.texture.dispose(), this.canvas.width = t, this.canvas.height = this.emojiSize;
    let a = 0;
    for (const [, i] of this.emojis)
      this.ctx ?? (this.ctx = this.canvas.data.getContext("2d")), this.ctx.drawImage(i, this.emojiSize * a++, 0, this.emojiSize, this.emojiSize);
    this.needsUpdate = false, this.texture.needsUpdate = true;
  }
}
const io = "�", Wt = 1e20;
function Ma(e, t, a, i, r, l, s) {
  l[0] = 0, s[0] = -Wt, s[1] = Wt, r[0] = e[t];
  for (let o = 1, f = 0, d = 0; o < i; o++) {
    r[o] = e[t + o * a];
    do {
      const c = l[f];
      d = (r[o] - r[c] + o ** 2 - c ** 2) / (o - c) / 2;
    } while (d <= s[f] && --f > -1);
    f++, l[f] = o, s[f] = d, s[f + 1] = Wt;
  }
  for (let o = 0, f = 0; o < i; o++) {
    for (; s[f + 1] < o; )
      f++;
    const d = l[f];
    e[t + o * a] = r[d] + (o - d) ** 2;
  }
}
class no {
  constructor() {
    this.fontFamily = "Rubik, Open Sans, Helvetica, Arial, Hiragino Kaku Gothic ProN, ヒラギノ角ゴ ProN W3, Hiragin Kaku Gothic Pro, ヒラギノ角ゴ Pro W3, Noto Sans JP, Meiryo, メイリオ, sans-serif", this.fontWeight = "600", this.fontStyle = "normal", this.fontSize = 48, this.width = 1024, this.height = 1024, this.glyphs = /* @__PURE__ */ new Map(), this.texture = new n.DataTexture(new Uint8ClampedArray(this.width * this.height * 4), this.width, this.height, n.RGBAFormat, n.UnsignedByteType, n.UVMapping, n.ClampToEdgeWrapping, n.ClampToEdgeWrapping, n.LinearFilter, n.LinearFilter), this.version = 0, this.initCanvas();
  }
  getGlyphInfo(t) {
    if (!this.ctx)
      return null;
    const a = /* @__PURE__ */ this.ctx.measureText(t), i = /* @__PURE__ */ Math.ceil(a.actualBoundingBoxAscent), r = 0, l = /* @__PURE__ */ Math.max(0, Math.min(this.glyphSize - this.margin, Math.ceil(a.actualBoundingBoxRight - a.actualBoundingBoxLeft))), s = /* @__PURE__ */ Math.min(this.glyphSize - this.margin, i + Math.ceil(a.actualBoundingBoxDescent)), o = l + 2 * this.margin, f = s + 2 * this.margin, d = new Uint8ClampedArray(o * f), c = { char: t, data: d, width: o, height: f, glyphWidth: l, glyphHeight: s, glyphTop: i, glyphLeft: r, glyphAdvance: Math.max(a.width, o - this.margin) };
    if (l === 0 || s === 0)
      return c;
    this.ctx.clearRect(this.margin, this.margin, l, s), this.ctx.fillText(t, this.margin, this.margin + i);
    const u = /* @__PURE__ */ this.ctx.getImageData(this.margin, this.margin, l, s);
    this._gridOuter ?? (this._gridOuter = new Float64Array(this.glyphSize ** 2)), this._gridInner ?? (this._gridInner = new Float64Array(this.glyphSize ** 2)), this._gridOuter.fill(Wt, 0, o * f), this._gridInner.fill(0, 0, o * f), this._f ?? (this._f = new Float64Array(this.glyphSize)), this._z ?? (this._z = new Float64Array(this.glyphSize + 1)), this._v ?? (this._v = new Uint16Array(this.glyphSize));
    for (let g = 0; g < s; g++)
      for (let h = 0; h < l; h++) {
        const C = u.data[4 * (g * l + h) + 3] / 255;
        if (C === 0)
          continue;
        const _ = (g + this.margin) * o + h + this.margin;
        if (C === 1)
          this._gridOuter[_] = 0, this._gridInner[_] = Wt;
        else {
          const x = 0.5 - C;
          this._gridOuter[_] = x > 0 ? x ** 2 : 0, this._gridInner[_] = x < 0 ? x ** 2 : 0;
        }
      }
    for (let g = 0; g < o; g++)
      Ma(this._gridOuter, g, o, f, this._f, this._v, this._z), Ma(this._gridInner, g, o, f, this._f, this._v, this._z);
    for (let g = 0; g < f; g++)
      Ma(this._gridOuter, g * o, 1, o, this._f, this._v, this._z), Ma(this._gridInner, g * o, 1, o, this._f, this._v, this._z);
    const m = /* @__PURE__ */ Math.max(...this._gridInner), p = 0.5;
    for (let g = 0; g < o * f; g++) {
      const h = Math.sqrt(this._gridOuter[g]) - Math.sqrt(this._gridInner[g]);
      d[g] = Math.round(255 - 255 * (h / m + p));
    }
    return c;
  }
  initCanvas() {
    if (this.canvas = null, typeof OffscreenCanvas < "u" ? this.canvas = new OffscreenCanvas(0, 0) : typeof document < "u" ? this.canvas = document.createElement("canvas") : this.canvas = null, this.canvas) {
      this._alphabet = "", this.lineHeight = 0, this.maxAscent = 0, this.margin = Math.ceil(this.fontSize / 16), this.glyphSize = this.fontSize + this.margin * 4, this.canvas.width = this.canvas.height = this.glyphSize, this.ctx = this.canvas.getContext("2d", { willReadFrequently: true }), this.ctx.font = `${this.fontStyle} ${this.fontWeight} ${this.fontSize}px ${this.fontFamily}`, this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left", this.ctx.fillStyle = "black", this.needsUpdate = true;
      const t = /* @__PURE__ */ " ".charCodeAt(0), a = /* @__PURE__ */ "~".charCodeAt(0);
      let i = io + `
`;
      for (let r = t; r <= a; r++)
        i += String.fromCodePoint(r);
      this.update(i);
    }
  }
  update(t) {
    this.canvas || this.initCanvas();
    for (const l of t)
      this._alphabet.includes(l) || (this._alphabet += l, this.needsUpdate = true);
    if (!this.needsUpdate)
      return;
    let a = 0, i = 0, r = 0;
    this.lineHeight = 0, this.maxAscent = 0;
    for (const l of this._alphabet) {
      const s = /* @__PURE__ */ this.getGlyphInfo(l);
      a + s.width >= this.width && (a = 0, i += r, r = 0);
      for (let o = 0; o < s.height; o++) {
        const f = s.width * o, d = s.width * (o + 1), c = this.width * (i + o) + a;
        for (let u = f; u < d; u++) {
          let m = c + u - f;
          this.texture.image.data[m * 4 + 3] = s.data[u];
        }
      }
      this.glyphs.set(l, { ...s, atlasX: a, atlasY: i }), a += s.width, r = Math.max(r, s.height), this.lineHeight = Math.max(this.lineHeight, r), this.maxAscent = Math.max(this.maxAscent, s.glyphTop);
    }
    this.texture.needsUpdate = true, this.needsUpdate = false;
  }
  getLayoutInfo(t = "") {
    const a = [];
    let i = 0, r = 0, l = 0, s = 0;
    for (const o of t)
      if (o === `
`)
        i = 0, r += this.lineHeight;
      else {
        const f = this.glyphs.get(o) ? this.glyphs.get(o) : this.glyphs.get(io);
        a.push({ ...f, left: i, top: r - f.glyphTop + this.maxAscent, boxTop: r, boxHeight: this.lineHeight }), l = Math.max(l, i += f.glyphAdvance), s = Math.max(s, r + this.lineHeight);
      }
    return { glyphs: a, width: l, height: s };
  }
}
const K0 = typeof process < "u" && process.env.NODE_ENV === "development", Z0 = K0 ? "/emojis/" : "https://cdn.utsubo.io/ui/emojis/", Da = {};
for (const e in ao)
  for (const { u: t } of ao[e])
    try {
      const a = /* @__PURE__ */ String.fromCodePoint(`0x${t}`);
      Da[a] = `${Z0}${t}.webp`;
    } catch {
    }
const J0 = new RegExp(`${Object.keys(Da).join("|")}`, "g");
class ro extends n.InstancedMesh {
  constructor() {
    super(Me().geometry, Me().material, 0), this.frustumCulled = false, this.fontSize = 1, this.color = new n.Color(), this.opacity = 1, this.isTextMesh = true, this.material.uniforms.uFontAtlas.value = Me().fontManager?.texture, this.material.uniforms.uEmojiAtlas.value = Me().emojiManager?.texture, this.geometry.setDrawRange(0, 6);
  }
  get font() {
    return Me().fontManager?.fontFamily;
  }
  set font(t) {
    const { fontManager: a } = /* @__PURE__ */ Me();
    a && (a.fontFamily = t, a.needsUpdate = true);
  }
  update() {
    if (this.visible = true, this.traverseAncestors((c) => {
      c.isTextMesh && (this.visible = false);
    }), !this.visible)
      return;
    let t = "";
    const a = [], i = [];
    this.traverse((c) => {
      if (c.isTextMesh && c.text) {
        t += c.text = c.text.replace(/\\n/g, `
`), a.push(c);
        const u = /* @__PURE__ */ c.text.match(J0);
        u && i.push(...u);
      }
    });
    let { fontManager: r, emojiManager: l } = Me();
    r || (ii({ fontManager: new no() }), r = Me().fontManager, this.material.uniforms.uFontAtlas.value = Me().fontManager?.texture), l || (ii({ emojiManager: new X0() }), l = Me().emojiManager, this.material.uniforms.uEmojiAtlas.value = Me().emojiManager?.texture), r.update(t), Promise.all(i.map((c) => l.load(Da[c]))), l.update();
    let s = 0;
    for (const c of a) {
      c._text !== c.text && (c._text = c.text, c._layout = r.getLayoutInfo(c.text));
      const u = c._layout;
      s += u.glyphs.length;
    }
    this.count = s;
    const o = this.count * 18;
    (!this._instanceData || this._instanceData.length < o) && (this._instanceData = new Float32Array(o), this._instanceBuffer = new n.InstancedInterleavedBuffer(this._instanceData, 18, 1), this._instanceEmojiIndex = new n.InterleavedBufferAttribute(this._instanceBuffer, 1, 0), this._instanceLineHeight = new n.InterleavedBufferAttribute(this._instanceBuffer, 1, 1), this._instanceLayout = new n.InterleavedBufferAttribute(this._instanceBuffer, 4, 2), this._instancePosition = new n.InterleavedBufferAttribute(this._instanceBuffer, 4, 6), this._instanceSize = new n.InterleavedBufferAttribute(this._instanceBuffer, 4, 10), this._instanceColor = new n.InterleavedBufferAttribute(this._instanceBuffer, 4, 14), this.geometry.setAttribute("instanceEmojiIndex", this._instanceEmojiIndex), this.geometry.setAttribute("instanceLineHeight", this._instanceLineHeight), this.geometry.setAttribute("instanceLayout", this._instanceLayout), this.geometry.setAttribute("instancePosition", this._instancePosition), this.geometry.setAttribute("instanceSize", this._instanceSize), this.geometry.setAttribute("instanceColor", this._instanceColor), this.instanceMatrix = new n.InstancedBufferAttribute(new Float32Array(this.count * 16), 16)), this.instanceMatrix.count = this.count, this._instanceBuffer.count = this.count;
    let f = 0, d = 0;
    for (const c of a) {
      const u = c._layout;
      for (const m of u.glyphs)
        this._instanceData[f++] = l.indexOf(Da[m.char]), this._instanceData[f++] = c.fontSize / r.lineHeight, this._instanceData[f++] = m.atlasX, this._instanceData[f++] = m.atlasY, this._instanceData[f++] = u.width, this._instanceData[f++] = u.height, this._instanceData[f++] = m.left, this._instanceData[f++] = u.height - m.boxTop - m.boxHeight, this._instanceData[f++] = m.left, this._instanceData[f++] = u.height - m.boxTop - m.boxHeight + m.top - m.boxTop, this._instanceData[f++] = m.glyphAdvance, this._instanceData[f++] = m.boxHeight, this._instanceData[f++] = m.width, this._instanceData[f++] = m.height, this._instanceData[f++] = c.color.r, this._instanceData[f++] = c.color.g, this._instanceData[f++] = c.color.b, this._instanceData[f++] = c.opacity, this.setMatrixAt(d++, c.matrixWorld);
    }
    this._instanceBuffer.needsUpdate = true, this.instanceMatrix.needsUpdate = true;
  }
  dispose() {
    super.dispose(), this.geometry.dispose(), this.material.dispose();
  }
}
const lt = /* @__PURE__ */ Z(function(t, a) {
  N({ TextMesh: ro });
  const i = /* @__PURE__ */ I();
  return ge(a, () => i.current), q(() => i.current.update(), z.renderPriority.updateAllPositions + 1), y("textMesh", { ...t, ref: i }, t.font);
});
lt.displayName = "Text";
const oo = new n.Vector3(), $0 = ({ fontSize: e = 0.4, text: t, borderColor: a, backgroundColor: i = "#757575", showBackground: r = true, color: l = 16777215, withTriangle: s = false, borderRadius: o = [0.4, 0.4, 0.4, 0.4], paddingX: f = 0.6, paddingY: d = 0.5, side: c = n.DoubleSide, graphId: u, backgroundOpacity: m = 0.6, borderOpacity: p = 1, lookAtCamera: g = false, ...h }) => {
  const C = /* @__PURE__ */ I(null), _ = /* @__PURE__ */ I(null), x = /* @__PURE__ */ Ft((S) => S.font), [b, w] = /* @__PURE__ */ ve(() => ({ backShape: new n.Shape() })), P = /* @__PURE__ */ ha((S) => S.fontManager);
  return ie(() => {
    if (!P)
      return;
    P.update(_.current.text);
    const S = /* @__PURE__ */ P.getLayoutInfo(_.current.text);
    S.width *= 1 / 64 * e, S.height *= 1 / 64 * e;
    const { width: M, height: D } = S;
    if (_.current.position.x = -(M - S.width) / 2, _.current.position.y = -(D - S.height) / 2, _.current.matrix.copy(C.current.matrix), _.current.updateWorldMatrix(false, false), r) {
      const T = new n.Shape();
      wi(T, 0, 0, M, D, 1, s, o, f, d), w({ backShape: T });
    }
  }, [P, x, t, e, r, s, ...Array.isArray(o) ? o : [o, o, o, o], f, d]), q(({ camera: S }) => {
    g && (oo.setFromMatrixPosition(S.matrixWorld), C.current.lookAt(oo));
  }, z.renderPriority.updateAllPositions + 0.1), H("group", { ref: C, ...h, children: [r ? y(to, { onUpdate: (S) => {
    S.matrix.copy(S.parent.matrix), S.matrixWorld.copy(S.matrix), S.matrixWorldNeedsUpdate = false;
  }, paddingX: f, paddingY: d, borderColor: a, borderRadius: o, backShape: b.backShape, backgroundColor: i, side: c, graphId: u, backgroundOpacity: m, borderOpacity: p, withTriangle: s }) : null, y(lt, { font: x, children: y(lt, { color: l, ref: _, text: t, fontSize: e }) })] });
}, e1 = (e) => {
  const t = /* @__PURE__ */ /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? { r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16) } : null;
}, t1 = (e) => {
  const t = /* @__PURE__ */ e1(e);
  return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
}, so = new n.Vector3(), a1 = ({ fontSize: e = 0.4, text: t, borderColor: a, pseudo: i = "Anonymous", pseudoColor: r, backgroundColor: l = "#757575", showBackground: s = true, color: o = 16777215, withTriangle: f = false, borderRadius: d = [0.5, 0.5, 0.5, 0.5], paddingX: c = 0.1, paddingY: u = 0.35, textAlign: m = "left", side: p = n.DoubleSide, graphId: g, backgroundOpacity: h = 0.6, borderOpacity: C = 1, lookAtCamera: _ = false, maxWidth: x = 2.4, ...b }) => {
  const w = /* @__PURE__ */ I(null), P = /* @__PURE__ */ I(null), S = /* @__PURE__ */ I(null), [M, D] = /* @__PURE__ */ ve(() => ({ backShape: new n.Shape() })), T = /* @__PURE__ */ ha((L) => L.fontManager), R = /* @__PURE__ */ Ft((L) => L.font);
  return ie(() => {
    if (!T)
      return;
    const L = /* @__PURE__ */ T.getLayoutInfo(P.current.text), k = /* @__PURE__ */ T.getLayoutInfo(S.current.text), E = 1 / 64 * e;
    L.width *= E, L.height *= E, k.width *= E, k.height *= E;
    const O = /* @__PURE__ */ Math.max(L.width, k.width), J = L.height + k.height;
    if (P.current.position.x = -(O - L.width) / 2, P.current.position.y = -(J - L.height) / 2, P.current.updateMatrix(), P.current.updateWorldMatrix(false, false), S.current.position.x = -(O - k.width) / 2, S.current.position.y = (J - k.height) / 2, S.current.updateMatrix(), S.current.updateWorldMatrix(false, false), s) {
      const $ = new n.Shape();
      wi($, 0, 0, O, J, 0.45, f, d, c, u), D({ backShape: $ });
    }
  }, [T, R, t, i, e, s, f, ...Array.isArray(d) ? d : [d, d, d, d], c, u]), q(({ camera: L }) => {
    _ && (so.setFromMatrixPosition(L.matrixWorld), w.current.lookAt(so));
  }, z.renderPriority.updateAllPositions + 0.1), H("group", { ref: w, ...b, children: [s ? y(to, { paddingX: c, paddingY: u, borderColor: a, borderRadius: d, backShape: M.backShape, backgroundColor: l, side: p, graphId: g, backgroundOpacity: h, borderOpacity: C, withTriangle: f }) : null, H(lt, { font: R, children: [y(lt, { color: o, ref: P, text: t, fontSize: e }), y(lt, { ref: S, color: r && t1(r) < 200 ? r : "#ffffff", text: i, fontSize: e * 0.8, opacity: 1 })] })] });
};
class i1 {
  constructor(t, a) {
    this.renderer = a, this.texture = t, this.initScene();
    const i = { format: n.RGBAFormat, type: n.UnsignedByteType, depthBuffer: false, stencilBuffer: false, colorSpace: n.LinearSRGBColorSpace };
    this.renderTarget = this.createFBO(i), this.offRenderTarget = this.createFBO(i);
  }
  initScene() {
    this.camera = new n.OrthographicCamera(-1, 1, 1, -1, 0, 1), this.uvScene = new n.Scene();
  }
  createFBO(t) {
    const { image: a } = this.texture, [i, r] = a ? [a.width, a.height] : [this.texture[0], this.texture[1]], l = new n.WebGLRenderTarget(i, r, { ...this.renderTargetOptions, ...t });
    return l.texture.userData.renderTargetId = l.texture.uuid, l;
  }
  renderMeshToFbo(t, a) {
    this.renderer.setRenderTarget(t);
    const i = this.renderer.autoClearColor;
    this.renderer.autoClearColor = false;
    const r = a.material;
    a.material = a.materialFeedback;
    const l = a.frustumCulled, s = a.onBeforeRender;
    a.frustumCulled = false, this.uvScene.children = [a], this.renderer.render(this.uvScene, this.camera), a.frustumCulled = l, a.material = r, a.onBeforeRender = s, this.renderer.autoClearColor = i, this.renderer.setRenderTarget(null);
  }
}
const n1 = { uniforms: { map: { value: null }, mapFeedback: { value: null } }, vertexShader: `
          out vec2 vUv;
          void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  
          }`, fragmentShader: `
      out vec4 gColor;
      in vec2 vUv;
      uniform sampler2D map;
      uniform sampler2D mapFeedback;
      #include <packing>

      void main() {
          gColor = vec4(vec3(1.), 1.);
          gColor *= texture( map, vUv );
          // if (gColor.a < 0.1) gColor.rgb = vec3(0., 1., 0.);
          vec4 paint = texture(mapFeedback, vUv);
          gColor.rgb = mix(gColor.rgb, paint.rgb, paint.a);
          gColor.a = 1.;
      }
    ` }, r1 = ({ actualRef: e, texTransformer: t, keysOffset: a, position: i = [10, 10], resolution: r = [256, 256] }) => {
  const l = /* @__PURE__ */ U((u) => u.gl), s = l.autoClear, o = /* @__PURE__ */ U((u) => u.get), [f, d, c] = /* @__PURE__ */ V(() => {
    const u = new Vi(o().size.width / -2, o().size.width / 2, o().size.height / 2, o().size.height / -2, 1, 10);
    u.position.set(0, 0, 2);
    const m = new Jt(), p = n1, g = /* @__PURE__ */ Wi.clone(p.uniforms), h = new Re({ uniforms: g, vertexShader: p.vertexShader, fragmentShader: p.fragmentShader });
    h.glslVersion = Oi;
    const C = new ji(r[0], r[1]), _ = new ka(C, h);
    return _.frustumCulled = false, m.add(_), [u, m, g];
  }, [r, i]);
  return q(({ size: u }) => {
    const m = e.current, p = t.current;
    if (!m)
      return;
    if (m && p) {
      const h = m.material.map;
      h && !h.isDataArrayTexture && !h.isCompressedArrayTexture && (c.map.value = h), c.mapFeedback.value = p.offRenderTarget.texture;
    }
    const g = /* @__PURE__ */ a.findIndex((h) => h === m.uuid);
    c.mapFeedback.value && (f.left = u.width / -2, f.right = u.width / 2, f.top = u.height / 2, f.bottom = u.height / -2, f.updateMatrix(), f.updateMatrixWorld(true), f.updateProjectionMatrix(), d.children[0].position.set(-u.width / 2 + r[0] / 2 + i[0] + r[0] * g, u.height / 2 - r[1] / 2 + -u.height + r[1] + i[1], 0), d.children[0].updateMatrix(), d.children[0].updateMatrixWorld(true), l.setRenderTarget(null), l.autoClear = false, l.render(d, f), l.autoClear = s);
  }, 10001), null;
}, Ai = 100;
new n.Color();
const o1 = /* @__PURE__ */ W({ uPaintMap: null, boneTexture: null, boneTextureSize: 0, brushCount: 1 }, `
  #include <common>
  #include <common_ubo_pars>
  #include <uv_pars_vertex>
  #include <displacementmap_pars_vertex>
  #include <morphtarget_pars_vertex>
  #include <batching_pars_vertex>
  #include <batching_skinning_pars_vertex>
  #include <logdepthbuf_pars_vertex>
  #include <clipping_planes_pars_vertex>

  out vec3 vWorldPosition;
  out vec2 vUvPaint;
  #ifndef USE_UV1
    in vec2 uv1;
  #endif
  uniform vec3 uBrushPoint;

  void main() {

  #include <uv_vertex>

  #include <skinbase_vertex>

  #ifdef USE_DISPLACEMENTMAP

  #include <beginnormal_vertex>
  #include <morphnormal_vertex>
  #include <skinnormal_vertex>

  #endif
  #include <begin_vertex>
  #include <batchingbase_vertex>

  vec4 mvPositionWorld = modelMatrix * vec4( transformed, 1.0 );

  #ifdef USE_BATCHING
    mvPositionWorld = batchingMatrix * mvPositionWorld;
  #endif
  #ifdef USE_INSTANCING
    mvPositionWorld = instanceMatrix * mvPositionWorld;
  #endif

  vUvPaint = uv1;
  #ifdef FLIP_UV
    vUvPaint.y = 1.0 - vUvPaint.y; // To flip the UVs along the V axis
  #endif
  vWorldPosition = mvPositionWorld.xyz;
  transformed = vec3( vUvPaint * 2. - 1. ,0.);


  // transformed = mix(position, vec3( uv * 2. - 1. ,0.), sin(time * .2) * .5 + .5);

  #include <morphtarget_vertex>

  #include <displacementmap_vertex>

  gl_Position = projectionMatrix * viewMatrix * vec4(transformed, 1.);

  #include <logdepthbuf_vertex>
  #include <clipping_planes_vertex>
}`, `
layout(location = 0) out highp vec4 pc_fragColor;

uniform BrushDataBlock {
  vec4 uBrushPoints[${Ai}];  // Array to hold brush point position and size
  vec4 uBrushColors[${Ai}];   // Array to hold brush point colors
  vec4 uBrushDirections[${Ai}];   // Array to hold brush point directions
};

#include <common>
#include <common_ubo_pars>

#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

in vec2 vUvPaint;
in vec3 vWorldPosition;
uniform sampler2D uPaintMap;
uniform int brushCount;

void main() {
  vec4 diffuseColor = texture(uPaintMap, vUvPaint);


  //  for loop brushCount from higher to lower

  for (int i = brushCount - 1; i >= 0; i--) {
    if (uBrushPoints[i].w == 0.) continue;
    vec3 brushDelta = (vWorldPosition - uBrushPoints[i].xyz) / 1.0;
    float dist = length(brushDelta) / uBrushPoints[i].w; // Here we use the brush size in the influence calculation
    float brushInfluence = min(1., max(0., 1. - pow(dist, 1000.)));
    
    vec4 brushColor = vec4(uBrushColors[i].rgb, brushInfluence);
    
    if (uBrushColors[i].a > 0. && brushInfluence > 0.) {
      // discard if r === 0.;
      diffuseColor = vec4(vec3(0.), brushInfluence);
    } else {
      // blend the brush color with the existing color
      diffuseColor.rgb = mix(diffuseColor.rgb, brushColor.rgb, brushColor.a);

      // prevent non-lazer to disapeear
      diffuseColor.r = max(diffuseColor.r, 0.01);
  
      diffuseColor.a = max(diffuseColor.a, brushColor.a);  // Update alpha to the maximum brush influence encountered so far
    }
  }


  // for (int i = brushCount - 1; i >= 0; i--) {
  //   if (uBrushPoints[i].w == 0.) continue;
  
  //   vec3 brushDelta = (vWorldPosition - uBrushPoints[i].xyz) / 1.0;
  
  //   // Get the brush direction for the current brush
  //   vec3 brushDirection = normalize(uBrushDirections[i].xyz);
  
  //   float dist = length(brushDelta) / uBrushPoints[i].w;
  
  //   // Modulate the radius based on direction influence
  //   float directionInfluence = dot(normalize(brushDelta), brushDirection);
  //   float modulatedRadius = uBrushPoints[i].w * (1.0 + 5. * directionInfluence * directionInfluence * 0.5); // Using the square of directionInfluence
  
  //   dist = length(brushDelta) / modulatedRadius; // Recalculate distance with the modulated radius
  //   float brushInfluence = min(1., max(0., 1. - pow(dist, 1000.)));
    
  //   vec4 brushColor = vec4(uBrushColors[i].rgb, brushInfluence);
  
  //   // blend the brush color with the existing color
  //   diffuseColor.rgb = mix(diffuseColor.rgb, brushColor.rgb, brushColor.a);
  //   diffuseColor.a = max(diffuseColor.a, brushColor.a);  // Update alpha to the maximum brush influence encountered so far
  // }

  // float brushInfluence = 0.;
  // float dist = min(1.,length(vDelta));
  // brushInfluence = min(1., max(0.,1. - pow(dist, .1 + (1. * 3. ) ) ));

  // diffuseColor = vec4(vUvPaint, 0., 1.);
  
  // blender add replace color with paint
  // diffuseColor.rgb = mix(diffuseColor.rgb, vec3(1.,0.,0.), brushInfluence);
  
  pc_fragColor = diffuseColor;
}`, (e) => {
  e.glslVersion = n.GLSL3, e.needsUpdate = true;
}), ht = [], jt = {}, s1 = ({ root: e, resolution: t = 1024, debug: a = false }) => {
  const i = U((m) => m.get()).gl, r = /* @__PURE__ */ Ie((m) => m.paintData), l = /* @__PURE__ */ I(null), s = /* @__PURE__ */ I(), o = /* @__PURE__ */ ce.useMemo(() => e ? e.isObject3D ? { current: e } : e : s, [e]), f = /* @__PURE__ */ Ie((m) => m.playerBrushReferences), d = /* @__PURE__ */ Ce(v["/img/patterns/uastc/terrain_1_normal.ktx2"], (m) => {
    m.wrapS = m.wrapT = n.RepeatWrapping, m.needsUpdate = true;
  });
  G(() => {
    const m = o.current;
    if (m && m.isMesh && m.material && (!jt[m.uuid] || jt[m.uuid].resolution !== t)) {
      if (!m.material.uPaintMap) {
        const p = t, g = t, h = new Uint8Array(p * g * 4);
        m.material.uPaintMap = new n.DataTexture(h, p, g), m.material.uPaintMap.flipY = true;
      }
      jt[m.uuid] = t, m.material.defines || (m.material.defines = {}), m.material.defines.FLIP_UV = m.geometry.type === "BufferGeometry", m.material.defines.USE_PAINT = true, m.materialFeedback = new o1(), m.materialFeedback.uniformsGroups = [oe, r], m.materialFeedback.transparent = true, m.materialFeedback.blending = n.NormalBlending, m.materialFeedback.depthWrite = false, m.materialFeedback.defines.FLIP_UV = m.geometry.type === "BufferGeometry", m.materialFeedback.uniforms.uPaintMap = { value: m.material.uPaintMap }, m.material.uNoise = d, l.current = new i1([t, t], i), ht.push(m.uuid);
    }
  }, [o.current, i, t]), G(() => () => {
    o.current && (o.current.material && (o.current.material.defines.USE_PAINT = false), ht.splice(ht.indexOf(o.current.uuid), 1), delete jt[o.current.uuid]);
    const m = /* @__PURE__ */ Object.keys(f.current);
    for (let p = 0; p < m.length; p++) {
      const g = m[p], h = f.current[g];
      if (!h)
        continue;
      const { brushesToDraw: C } = h;
      !C || C.length === 0 || (C.length = 0);
    }
  }, [o]), G(() => () => {
    o.current && (delete jt[o.current.uuid], ht.splice(ht.indexOf(o.current.uuid), 1));
  }, []);
  const c = 0.4;
  re("brush_position", ({ id: m, playerId: p, position: g }) => {
    if (!o.current)
      return;
    f.current[p] || (f.current[p] = { size: c });
    const h = f.current[p], { size: C, color: _, colorArr: x, lazer: b } = h;
    h.brushesToDraw = h.brushesToDraw || [], h.brushesToDraw.push({ id: m, point: [g[0], g[1], g[2], C || c], color: _ || "#ffffff", colorArr: x || [1, 1, 1], lazer: b || 0 });
  }), re("brush_size", ({ playerId: m, size: p }) => {
    f.current[m] || (f.current[m] = {}), f.current[m].size = p || c;
  }), re("brush_color", ({ playerId: m, color: p, colorArr: g, lazer: h }) => {
    f.current[m] || (f.current[m] = {}), f.current[m].color = p, f.current[m].colorArr = g, f.current[m].lazer = h || 0;
  }), re("player_joined", ({ playerId: m }) => {
    f.current[m] = {};
  }), re("player_leave", ({ playerId: m }) => {
    delete f.current[m];
  });
  const u = /* @__PURE__ */ ce.useCallback(() => {
    const m = o.current;
    if (!m || !m?.material || !l.current)
      return;
    const p = /* @__PURE__ */ Object.keys(f.current);
    for (let h = 0; h < p.length; h++) {
      const C = p[h], _ = f.current[C];
      if (!_)
        continue;
      const { brushesToDraw: x, lastPoint: b } = _;
      if (!x || x.length === 0)
        continue;
      const { id: w, color: P, colorArr: S, lazer: M, point: D } = /* @__PURE__ */ x.shift();
      if (!r.uniforms[0].value[w] || !P || !D)
        continue;
      const T = [S[0], S[1], S[2], M || 0];
      if (x.length === 0 && D[0] !== -9999 && x.push({ id: w, point: [-9999, -9999, -9999, 0], color: P, colorArr: S, lazer: M }), r.uniforms[0].value[w].fromArray(D), r.uniforms[1].value[w].fromArray(T), b) {
        const R = [b[0], b[1], b[2]];
        r.uniforms[2].value[w].fromArray(R);
      }
      _.lastPoint = D;
    }
    const g = l.current;
    m.material.uPaintMap = g.renderTarget.texture, l.current.renderMeshToFbo(g.offRenderTarget, m), m.materialFeedback.uniforms.brushCount.value = Object.keys(f.current).length, m.material.uNoise || (m.material.uNoise = d), m.material.uPaintMap = g.offRenderTarget.texture;
  }, [o.current, a, d]);
  return G(() => {
    ae("paint_init");
  }, []), q(() => {
    const m = o.current;
    m && (!m?.material || !l.current || u(m));
  }, 0), a ? y(r1, { actualRef: o, texTransformer: l, keysOffset: ht, position: [10, 10], resolution: [96, 96] }) : null;
};
export {
  ur as AuraMaterial,
  Mr as BasicMaterial,
  ya as BatchInstance,
  td as BatchInstances,
  eo as BubbleSoapMaterial,
  a1 as BubbleWithBorder,
  qr as CanopyDepth,
  Yr as CanopyShader,
  sr as Character,
  ju as CharacterEnergy,
  fr as CharacterVrm,
  uu as Characters,
  Rd as Clouds,
  Bn as DelayedLoading,
  Vn as EmojisInstance,
  pd as EmojisInstances,
  dr as EnergyMaterial,
  Jd as FaceTracking,
  eu as FaceTrackingDebug,
  Dr as Flame,
  no as FontManager,
  Er as ForceField,
  Tr as FresnelMaterial,
  Qn as GenerateMeshBVHWorker,
  Pr as GhibliShader,
  h0 as GradientShader,
  dm as Grass,
  Sa as GrassShader,
  Ir as Grid,
  ri as HtmlMinimal,
  $r as KonpiShader,
  wd as MeshSDF,
  $0 as MessageWithBorder,
  fi as MetaSkinnedDepth,
  Xr as MetaSkinnedShader,
  Ln as Mirror,
  Rn as MirrorShader,
  Hc as Moss,
  kn as MossShader,
  Or as OrbitControls,
  Hr as OrthographicCamera,
  s1 as Paint,
  Xu as Particle,
  Zu as ParticleAttribute,
  Ku as ParticleInstanceAttribute,
  Nr as ParticleMaterial,
  Gr as PerspectiveCamera,
  Zr as PetalesShader,
  Kr as PetalesShaderImpl,
  Qr as PhongShader,
  jr as PhongShaderImpl,
  Jr as PortalShader,
  wc as PreloadAsync,
  ci as PrimaryShader,
  Ur as Rainbow,
  Df as Renderer,
  bd as SDFWrapper,
  Br as ScanLineMaterial,
  od as SceneToBatches,
  yr as ShadowMap,
  cn as SougenInstance,
  Tf as SougenInstances,
  ln as SougenPosition,
  kr as SpriteArrayMaterial,
  rn as StatsGl,
  lt as Text,
  ro as TextMesh,
  Uf as TextureBakedAnimations,
  Pn as TextureInstanceShader,
  Rr as TextureLoopMaterial,
  Wr as TransformControls,
  zr as Tron,
  Lr as TronImpl,
  Fr as Water,
  It as alreadyLoadedItems,
  ui as animList,
  v as assets,
  vt as attachLoadingManager,
  qf as backToLocalPos,
  Oe as batchGlobalContext,
  Aa as charactersGlobalContext,
  Nd as cloudsToSDFBlob,
  Rc as commonLoadConfig,
  oe as commonUbo,
  Wf as convertToDegrees,
  jf as convertToRad,
  bn as detectDevice,
  vc as deviceCombinationToCheck,
  st as emojiGlobalContext,
  Ca as extraMeshes,
  qa as firstProgressList,
  Za as getDeviceKey,
  gc as getDeviceKeyForDevice,
  Un as getEyeHeight,
  wn as getGltfLoader,
  kc as getHeightAnimOffset,
  Tc as getInteractiveStore,
  et as getLoader,
  Ya as getMatrix,
  gi as getMatrixPerksIds,
  $f as getMatrixWorld,
  vn as getPerkIds,
  In as getPlayerModelHeight,
  cc as getProgress,
  mn as getSafeExternalImgUrl,
  na as getStateComposer,
  Dt as getStateUbo,
  xn as getStoreDetectDevice,
  Va as getStoreRenderer,
  Dn as getStoreScene,
  Me as getStoreText,
  Dc as getVideo,
  Vf as getWorldQuaternionLight,
  Jf as getWorldRotation,
  Hf as getWorldScaleLight,
  Tn as glideYModifier,
  hn as itemsToIgnore,
  kt as kTX2Loader,
  ni as konpiPatternTextures,
  we as lightConfig,
  it as lightData,
  ic as linearlerp,
  Nf as linstep,
  Lc as listMaterialsPath,
  Zn as loadCollection,
  Kn as loadedCollections,
  Kf as localPosToWorld,
  ue as materialsTextures,
  kf as mergeGeometries,
  Sn as mirrorAnimations,
  nc as mix,
  Gt as particleContext,
  oa as pointsLightData,
  bc as rawShader,
  zf as regexDetectJapanese,
  Lf as regexFilterLatinJapanese,
  wi as roundedRect,
  Ff as saturate,
  Rf as setDefaultBlending,
  Ic as setInteractiveStore,
  Ve as setLoader,
  a0 as setMatrixPerks,
  dc as setProgress,
  be as setStateComposer,
  Qa as setStateUbo,
  mc as setStoreDetectDevice,
  Pt as setStoreRenderer,
  En as setStoreScene,
  ii as setStoreText,
  Ec as setVideo,
  W as shaderMaterial,
  z as shared,
  O0 as triangle,
  We as useAnisotropy,
  zt as useCubeTexture,
  yn as useDetectDevice,
  ot as useGLTF,
  ga as useGLTFSafe,
  Mc as useHelper,
  Mn as useInteractiveStore,
  Ce as useKTX2,
  Pc as useLoadAnimationsList,
  ra as useLoader,
  Sc as useMinimAnimations,
  _e as useNeedCompile,
  _n as useProgress,
  je as useSDFStore,
  Lt as useSafeExternalImgUrl,
  $e as useStoreComposer,
  Ka as useStoreDetectDevice,
  Y as useStoreRenderer,
  Ft as useStoreScene,
  ha as useStoreText,
  Ie as useStoreUbo,
  Zd as useSyncFaceTrackingPlayer,
  Kd as useSyncPoseTrackingPlayer,
  Ne as useTexture,
  se as useUbos,
  Ja as useVideoStore,
  Xn as useWebcam,
  Zf as worldPosToLocal,
  Yf as worldQuaternionToLocal,
  Qf as worldRotationToLocal
};
